
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("dT5kE", function(module, exports) {

$parcel$export(module.exports, "usePricingContentContext", function () { return $bd5fad949d3794ef$export$5c4a541176bccda; });
$parcel$export(module.exports, "PricingContentContextProvider", function () { return $bd5fad949d3794ef$export$72e02a396b6ef938; });
$parcel$export(module.exports, "PricingContentContextProviderRelay", function () { return $bd5fad949d3794ef$export$4e54691009c7ed4c; });
$parcel$export(module.exports, "usePricingPlanComparison", function () { return $bd5fad949d3794ef$export$6ef9aee1b558c2a5; });
$parcel$export(module.exports, "useGetComparePlanCta", function () { return $bd5fad949d3794ef$export$8c0343b0c8323d5e; });
$parcel$export(module.exports, "useDatacenterPlans", function () { return $bd5fad949d3794ef$export$317f41c6296bda84; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $hOqV7 = parcelRequire("hOqV7");

var $8rqVU = parcelRequire("8rqVU");

var $g9kzu = parcelRequire("g9kzu");

var $4ktyF = parcelRequire("4ktyF");

var $3FBn4 = parcelRequire("3FBn4");

var $chUDa = parcelRequire("chUDa");
const $bd5fad949d3794ef$var$PricingContentContext = /*#__PURE__*/ (0, $iSvIT.createContext)(undefined);
const $bd5fad949d3794ef$export$5c4a541176bccda = ()=>{
    return (0, $iSvIT.useContext)($bd5fad949d3794ef$var$PricingContentContext);
};
const $bd5fad949d3794ef$var$stripPTags = (htmlString)=>{
    return htmlString.replace(/<\/?p>/g, "");
};
const $bd5fad949d3794ef$export$72e02a396b6ef938 = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4ktyF.default), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)($bd5fad949d3794ef$var$PricingContentContextProviderInternal, (0, $7Knp0._)({}, props))
    });
};
const $bd5fad949d3794ef$var$PricingContentContextProviderInternal = (props)=>{
    const { productId: productId, pricingContent: initialPricingContent, pricingTitleInternal: pricingTitleInternal } = props;
    const locale = (0, $3FBn4.useLocale)();
    const [pricingContent, setPricingContent] = (0, $iSvIT.useState)(initialPricingContent);
    const [loading, setLoading] = (0, $iSvIT.useState)(true);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    (0, $iSvIT.useEffect)(()=>{
        async function fetchPricingContent() {
            try {
                const fetchedContent = await (0, $chUDa.getPricingContent)(productId, {
                    locale: locale,
                    pricingTitleInternal: pricingTitleInternal
                });
                setPricingContent(fetchedContent);
            } catch (error) {
                createAnalyticsEvent({
                    eventType: "track",
                    action: "failed",
                    actionSubject: "getPricingContent",
                    attributes: {
                        productId: productId,
                        locale: locale,
                        pricingTitleInternal: pricingTitleInternal,
                        // @ts-ignore
                        error: error.message
                    },
                    source: window.location.pathname
                }).fire();
                setPricingContent({
                    hasError: true
                });
            } finally{
                setLoading(false);
            }
        }
        if (!initialPricingContent) fetchPricingContent();
        else setLoading(false);
    }, [
        initialPricingContent,
        productId,
        locale
    ]);
    const cleanedValue = pricingContent ? (0, $6iHNw._)((0, $7Knp0._)({}, pricingContent), {
        headline: (pricingContent === null || pricingContent === void 0 ? void 0 : pricingContent.headline) ? $bd5fad949d3794ef$var$stripPTags(pricingContent.headline) : ""
    }) : undefined;
    if (loading) return null;
    return /*#__PURE__*/ (0, $loA2J.jsx)($bd5fad949d3794ef$var$PricingContentContext.Provider, {
        value: cleanedValue,
        children: props.children
    });
};
const $bd5fad949d3794ef$export$4e54691009c7ed4c = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4ktyF.default), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)($bd5fad949d3794ef$var$PricingContentContextProviderInternalRelay, (0, $7Knp0._)({}, props))
    });
};
const $bd5fad949d3794ef$var$PricingContentContextProviderInternalRelay = (props)=>{
    let { pricingContent: pricingContent } = props;
    const [loading, setLoading] = (0, $iSvIT.useState)(true);
    const data = (0, $hOqV7.usePreloadedQuery)((0, $8rqVU.PricingPageRelayQuery), props.queryRef || null);
    if (!pricingContent) {
        var _shapedResponse_pricings_edges_, _shapedResponse_pricings_edges, _shapedResponse_pricings;
        const shapedResponse = (0, $8rqVU.shapePricingContentfulResponse)(data);
        pricingContent = shapedResponse === null || shapedResponse === void 0 ? void 0 : (_shapedResponse_pricings = shapedResponse.pricings) === null || _shapedResponse_pricings === void 0 ? void 0 : (_shapedResponse_pricings_edges = _shapedResponse_pricings.edges) === null || _shapedResponse_pricings_edges === void 0 ? void 0 : (_shapedResponse_pricings_edges_ = _shapedResponse_pricings_edges[0]) === null || _shapedResponse_pricings_edges_ === void 0 ? void 0 : _shapedResponse_pricings_edges_.node;
    }
    (0, $iSvIT.useEffect)(()=>{
        if (!!pricingContent) setLoading(false);
    }, [
        pricingContent
    ]);
    const cleanedValue = pricingContent ? (0, $6iHNw._)((0, $7Knp0._)({}, pricingContent), {
        headline: (pricingContent === null || pricingContent === void 0 ? void 0 : pricingContent.headline) ? $bd5fad949d3794ef$var$stripPTags(pricingContent.headline) : ""
    }) : undefined;
    if (loading) return null;
    return /*#__PURE__*/ (0, $loA2J.jsx)($bd5fad949d3794ef$var$PricingContentContext.Provider, {
        value: cleanedValue,
        children: props.children
    });
};
function $bd5fad949d3794ef$export$6ef9aee1b558c2a5(title) {
    var _context_comparePlans;
    const context = $bd5fad949d3794ef$export$5c4a541176bccda();
    return context === null || context === void 0 ? void 0 : (_context_comparePlans = context.comparePlans) === null || _context_comparePlans === void 0 ? void 0 : _context_comparePlans.find((p)=>p.planTitleExternal === title);
}
function $bd5fad949d3794ef$export$8c0343b0c8323d5e() {
    const context = $bd5fad949d3794ef$export$5c4a541176bccda();
    return function getComparePlanCta(params) {
        var _context_comparePlans_params_comparePlanIdx_microCta, _context_comparePlans_params_comparePlanIdx, _context_comparePlans;
        var _params_microCtaIdx;
        return context === null || context === void 0 ? void 0 : (_context_comparePlans = context.comparePlans) === null || _context_comparePlans === void 0 ? void 0 : (_context_comparePlans_params_comparePlanIdx = _context_comparePlans[params.comparePlanIdx]) === null || _context_comparePlans_params_comparePlanIdx === void 0 ? void 0 : (_context_comparePlans_params_comparePlanIdx_microCta = _context_comparePlans_params_comparePlanIdx.microCta) === null || _context_comparePlans_params_comparePlanIdx_microCta === void 0 ? void 0 : _context_comparePlans_params_comparePlanIdx_microCta[(_params_microCtaIdx = params.microCtaIdx) !== null && _params_microCtaIdx !== void 0 ? _params_microCtaIdx : 0];
    };
}
function $bd5fad949d3794ef$export$e5b23f1c4d669bad() {
    const context = $bd5fad949d3794ef$export$5c4a541176bccda();
    return function getPricingPlanCta(params) {
        var _context_comparePlans_find_microCta, _context_comparePlans_find, _context_comparePlans;
        return context === null || context === void 0 ? void 0 : (_context_comparePlans = context.comparePlans) === null || _context_comparePlans === void 0 ? void 0 : (_context_comparePlans_find = _context_comparePlans.find((p)=>p.planTitleExternal === params.planName)) === null || _context_comparePlans_find === void 0 ? void 0 : (_context_comparePlans_find_microCta = _context_comparePlans_find.microCta) === null || _context_comparePlans_find_microCta === void 0 ? void 0 : _context_comparePlans_find_microCta[0];
    };
}
function $bd5fad949d3794ef$export$317f41c6296bda84(btnText, linkText) {
    var _context_datacenterPlans, _datacenterContent_microCta, _datacenterContent_microCta1;
    const context = $bd5fad949d3794ef$export$5c4a541176bccda();
    const datacenterContent = context === null || context === void 0 ? void 0 : (_context_datacenterPlans = context.datacenterPlans) === null || _context_datacenterPlans === void 0 ? void 0 : _context_datacenterPlans[0];
    const btnCtaObject = datacenterContent === null || datacenterContent === void 0 ? void 0 : (_datacenterContent_microCta = datacenterContent.microCta) === null || _datacenterContent_microCta === void 0 ? void 0 : _datacenterContent_microCta.find((btnCta)=>"ctaButtonText" in btnCta && btnText === btnCta.ctaButtonText);
    const linkCtaObject = datacenterContent === null || datacenterContent === void 0 ? void 0 : (_datacenterContent_microCta1 = datacenterContent.microCta) === null || _datacenterContent_microCta1 === void 0 ? void 0 : _datacenterContent_microCta1.find((linkCta)=>"ctaButtonText" in linkCta && linkText === linkCta.ctaButtonText);
    var _datacenterContent_planTitleExternal, _datacenterContent_planOneLiner;
    return {
        title: (_datacenterContent_planTitleExternal = datacenterContent === null || datacenterContent === void 0 ? void 0 : datacenterContent.planTitleExternal) !== null && _datacenterContent_planTitleExternal !== void 0 ? _datacenterContent_planTitleExternal : "",
        description: (_datacenterContent_planOneLiner = datacenterContent === null || datacenterContent === void 0 ? void 0 : datacenterContent.planOneLiner) !== null && _datacenterContent_planOneLiner !== void 0 ? _datacenterContent_planOneLiner : "",
        buttonCta: btnCtaObject && "ctaUrl" in btnCtaObject ? {
            label: btnCtaObject.ctaButtonText || undefined,
            href: btnCtaObject.ctaUrl || undefined
        } : undefined,
        linkCta: linkCtaObject && "ctaUrl" in linkCtaObject ? {
            label: linkCtaObject.ctaButtonText || undefined,
            href: linkCtaObject.ctaUrl || undefined
        } : undefined
    };
}

});
parcelRegister("chUDa", function(module, exports) {

$parcel$export(module.exports, "getPricingContent", function () { return $f94bc41939c8d05c$export$331f740a8830d0ce; });

var $hOqV7 = parcelRequire("hOqV7");

var $4PJsz = parcelRequire("4PJsz");

var $gAJUc = parcelRequire("gAJUc");

var $an8Ry = parcelRequire("an8Ry");

var $cCupH = parcelRequire("cCupH");

var $1FkY0 = parcelRequire("1FkY0");

var $5rrol = parcelRequire("5rrol");
const $f94bc41939c8d05c$var$getPricingContentDeprecated = async (productId, opts = {})=>{
    var _data_pricings, _edges_;
    const { locale: locale = "en", pricingTitleInternal: pricingTitleInternal } = opts;
    const aggClient = new (0, $an8Ry.AGGClientV2)({
        gatewayUrl: "https://www.atlassian.com/gateway/api/graphql"
    });
    const cpapiLocale = (0, $1FkY0.WAC_TO_CPAPI_LOCALE_MAP)[locale] || "en-US";
    const { data: data, error: error } = await aggClient.query((0, $5rrol.GET_PRICING_CONTENT), {
        search: {
            queries: [
                {
                    withLocales: [
                        cpapiLocale
                    ],
                    where: {
                        fieldNamed: "relatedProduct.productNameId",
                        havingValues: [
                            productId
                        ]
                    }
                }
            ]
        }
    });
    if (error) {
        const errors = error.message.split("\n");
        errors.forEach((errorMessage)=>{
            if (errorMessage !== "[GraphQL] String cannot represent value: {}") throw new Error(error.message);
        });
    }
    const edges = data === null || data === void 0 ? void 0 : (_data_pricings = data.pricings) === null || _data_pricings === void 0 ? void 0 : _data_pricings.edges;
    if (pricingTitleInternal) {
        const result = edges === null || edges === void 0 ? void 0 : edges.find((edge)=>edge.node.pricingTitleInternal === pricingTitleInternal);
        if (result === null || result === void 0 ? void 0 : result.node) return result.node;
    }
    return edges === null || edges === void 0 ? void 0 : (_edges_ = edges[0]) === null || _edges_ === void 0 ? void 0 : _edges_.node;
};
const $f94bc41939c8d05c$export$331f740a8830d0ce = async (productId, opts = {})=>{
    if (!(0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).wacCpapiDeprecation)) return $f94bc41939c8d05c$var$getPricingContentDeprecated(productId, opts);
    else {
        var _pricingDataRelay_pricings_edges_, _pricingDataRelay_pricings_edges, _pricingDataRelay_pricings;
        const fetchGraphQL = async (request, variables)=>{
            const resp = await fetch("https://graphql.contentful.com/content/v1/spaces/xjcz23wx147q/environments/master", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer fTu2YoVb3vqTOyvfOZveEriN4V4vgNk9aVYcJuLRfc8"
                },
                body: JSON.stringify({
                    query: request.text,
                    variables: variables
                })
            });
            if (!resp.ok) throw new Error("Response failed.");
            return await resp.json();
        };
        const environment = new (0, $4PJsz.Environment)({
            store: new (0, $4PJsz.Store)(new (0, $4PJsz.RecordSource)({})),
            network: (0, $4PJsz.Network).create(fetchGraphQL)
        });
        const pricingDataRaw = await (0, $hOqV7.fetchQuery)(environment, (0, $cCupH.PricingPageRelayQuery), (0, $cCupH.getPricingPageRelayQueryVars)(productId, window.location)).toPromise().then((data)=>data).catch((error)=>{
            console.log(error);
        });
        const pricingDataRelay = (0, $cCupH.shapePricingContentfulResponse)(pricingDataRaw);
        return pricingDataRelay === null || pricingDataRelay === void 0 ? void 0 : (_pricingDataRelay_pricings = pricingDataRelay.pricings) === null || _pricingDataRelay_pricings === void 0 ? void 0 : (_pricingDataRelay_pricings_edges = _pricingDataRelay_pricings.edges) === null || _pricingDataRelay_pricings_edges === void 0 ? void 0 : (_pricingDataRelay_pricings_edges_ = _pricingDataRelay_pricings_edges[0]) === null || _pricingDataRelay_pricings_edges_ === void 0 ? void 0 : _pricingDataRelay_pricings_edges_.node;
    }
};

});
parcelRegister("5rrol", function(module, exports) {

$parcel$export(module.exports, "GET_PRICING_CONTENT", function () { return $f6dbffa856edd6d4$export$22246238e69ee736; });

var $gX72x = parcelRequire("gX72x");
parcelRequire("d8vZZ");
var $5fX9V = parcelRequire("5fX9V");

var $aoS05 = parcelRequire("aoS05");
const $f6dbffa856edd6d4$export$22246238e69ee736 = (0, $aoS05.graphql)((0, $gX72x.print)((0, $5fX9V.Pricings)));

});
parcelRegister("d8vZZ", function(module, exports) {
$parcel$export(module.exports, "Pricings", function () { return (parcelRequire("5fX9V")).Pricings; });
parcelRequire("5fX9V");

});
parcelRegister("5fX9V", function(module, exports) {

$parcel$export(module.exports, "Pricings", function () { return $2f512219da033f72$export$5d6aae0a726eb71f; });

var $e9EE7 = parcelRequire("e9EE7");
let $2f512219da033f72$var$_ = (t)=>t, $2f512219da033f72$var$t, $2f512219da033f72$var$t1, $2f512219da033f72$var$t2, $2f512219da033f72$var$t3, $2f512219da033f72$var$t4, $2f512219da033f72$var$t5, $2f512219da033f72$var$t6, $2f512219da033f72$var$t7, $2f512219da033f72$var$t8, $2f512219da033f72$var$t9, $2f512219da033f72$var$t10, $2f512219da033f72$var$t11;
var $2f512219da033f72$export$1798210ae1009578;
(function(AcceptableResponse) {
    AcceptableResponse["False"] = "FALSE";
    AcceptableResponse["NotApplicable"] = "NOT_APPLICABLE";
    AcceptableResponse["True"] = "TRUE";
})($2f512219da033f72$export$1798210ae1009578 || ($2f512219da033f72$export$1798210ae1009578 = {}));
var $2f512219da033f72$export$9d38595f26d62a61;
(function(AccessStatus) {
    AccessStatus["AnonymousAccess"] = "ANONYMOUS_ACCESS";
    AccessStatus["ExternalCollaboratorAccess"] = "EXTERNAL_COLLABORATOR_ACCESS";
    AccessStatus["ExternalShareAccess"] = "EXTERNAL_SHARE_ACCESS";
    AccessStatus["LicensedAdminAccess"] = "LICENSED_ADMIN_ACCESS";
    AccessStatus["LicensedUseAccess"] = "LICENSED_USE_ACCESS";
    AccessStatus["NotPermitted"] = "NOT_PERMITTED";
    AccessStatus["UnlicensedAuthenticatedAccess"] = "UNLICENSED_AUTHENTICATED_ACCESS";
})($2f512219da033f72$export$9d38595f26d62a61 || ($2f512219da033f72$export$9d38595f26d62a61 = {}));
var $2f512219da033f72$export$64ed4f32859160d1;
(function(AccessType) {
    AccessType["Edit"] = "EDIT";
    AccessType["View"] = "VIEW";
})($2f512219da033f72$export$64ed4f32859160d1 || ($2f512219da033f72$export$64ed4f32859160d1 = {}));
var $2f512219da033f72$export$3693f74db10d5f88;
(function(AccountStatus) {
    /** The account is an active account */ AccountStatus["Active"] = "active";
    /** The account has been closed */ AccountStatus["Closed"] = "closed";
    /** The account is no longer an active account */ AccountStatus["Inactive"] = "inactive";
})($2f512219da033f72$export$3693f74db10d5f88 || ($2f512219da033f72$export$3693f74db10d5f88 = {}));
var $2f512219da033f72$export$b8ca5fa4899cbfc7;
(function(AccountType) {
    AccountType["App"] = "APP";
    AccountType["Atlassian"] = "ATLASSIAN";
    AccountType["Customer"] = "CUSTOMER";
    AccountType["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$b8ca5fa4899cbfc7 || ($2f512219da033f72$export$b8ca5fa4899cbfc7 = {}));
var $2f512219da033f72$export$db8ac507a39ab8b4;
(function(ActionsAuthType) {
    /** actions that support THREE_LEGGED authentication can be executed with a user in context */ ActionsAuthType["ThreeLegged"] = "THREE_LEGGED";
    /** actions that support TWO_LEGGED authentication can be executed without user in context */ ActionsAuthType["TwoLegged"] = "TWO_LEGGED";
})($2f512219da033f72$export$db8ac507a39ab8b4 || ($2f512219da033f72$export$db8ac507a39ab8b4 = {}));
var $2f512219da033f72$export$3acc52b983618180;
(function(ActionsCapabilityType) {
    /** Actions Enabled for Automation */ ActionsCapabilityType["Automation"] = "AUTOMATION";
})($2f512219da033f72$export$3acc52b983618180 || ($2f512219da033f72$export$3acc52b983618180 = {}));
var $2f512219da033f72$export$8cf09b5eff7c9333;
(function(ActionsConfigurationLayout) {
    ActionsConfigurationLayout["VerticalLayout"] = "VerticalLayout";
})($2f512219da033f72$export$8cf09b5eff7c9333 || ($2f512219da033f72$export$8cf09b5eff7c9333 = {}));
var $2f512219da033f72$export$d36a88022706d185;
(function(ActivitiesContainerType) {
    ActivitiesContainerType["Project"] = "PROJECT";
    ActivitiesContainerType["Site"] = "SITE";
    ActivitiesContainerType["Space"] = "SPACE";
    ActivitiesContainerType["Workspace"] = "WORKSPACE";
})($2f512219da033f72$export$d36a88022706d185 || ($2f512219da033f72$export$d36a88022706d185 = {}));
var $2f512219da033f72$export$c1fb1f213efc1d1a;
(function(ActivitiesFilterType) {
    ActivitiesFilterType["And"] = "AND";
    ActivitiesFilterType["Or"] = "OR";
})($2f512219da033f72$export$c1fb1f213efc1d1a || ($2f512219da033f72$export$c1fb1f213efc1d1a = {}));
var $2f512219da033f72$export$4edf00fad4b97379;
(function(ActivitiesObjectType) {
    ActivitiesObjectType["Blogpost"] = "BLOGPOST";
    ActivitiesObjectType["Database"] = "DATABASE";
    ActivitiesObjectType["Embed"] = "EMBED";
    ActivitiesObjectType["Goal"] = "GOAL";
    ActivitiesObjectType["Issue"] = "ISSUE";
    ActivitiesObjectType["Page"] = "PAGE";
    /** Refers to a townsquare project (not to be confused with a jira project) */ ActivitiesObjectType["Project"] = "PROJECT";
    ActivitiesObjectType["Whiteboard"] = "WHITEBOARD";
})($2f512219da033f72$export$4edf00fad4b97379 || ($2f512219da033f72$export$4edf00fad4b97379 = {}));
var $2f512219da033f72$export$132f858337fea016;
(function(ActivityEventType) {
    ActivityEventType["Assigned"] = "ASSIGNED";
    ActivityEventType["Commented"] = "COMMENTED";
    ActivityEventType["Created"] = "CREATED";
    ActivityEventType["Edited"] = "EDITED";
    ActivityEventType["Liked"] = "LIKED";
    ActivityEventType["Published"] = "PUBLISHED";
    ActivityEventType["Transitioned"] = "TRANSITIONED";
    ActivityEventType["Unassigned"] = "UNASSIGNED";
    ActivityEventType["Updated"] = "UPDATED";
    ActivityEventType["Viewed"] = "VIEWED";
})($2f512219da033f72$export$132f858337fea016 || ($2f512219da033f72$export$132f858337fea016 = {}));
var $2f512219da033f72$export$d02a56686be43f69;
(function(ActivityObjectType) {
    ActivityObjectType["Blogpost"] = "BLOGPOST";
    ActivityObjectType["Comment"] = "COMMENT";
    ActivityObjectType["Database"] = "DATABASE";
    ActivityObjectType["Embed"] = "EMBED";
    ActivityObjectType["Goal"] = "GOAL";
    ActivityObjectType["Issue"] = "ISSUE";
    ActivityObjectType["Page"] = "PAGE";
    ActivityObjectType["Project"] = "PROJECT";
    ActivityObjectType["Site"] = "SITE";
    ActivityObjectType["Space"] = "SPACE";
    ActivityObjectType["Task"] = "TASK";
    ActivityObjectType["Whiteboard"] = "WHITEBOARD";
})($2f512219da033f72$export$d02a56686be43f69 || ($2f512219da033f72$export$d02a56686be43f69 = {}));
var $2f512219da033f72$export$3ca4051c67b8ec7b;
(function(ActivityProduct) {
    ActivityProduct["Confluence"] = "CONFLUENCE";
    ActivityProduct["Jira"] = "JIRA";
    ActivityProduct["JiraBusiness"] = "JIRA_BUSINESS";
    ActivityProduct["JiraOps"] = "JIRA_OPS";
    ActivityProduct["JiraServiceDesk"] = "JIRA_SERVICE_DESK";
    ActivityProduct["JiraSoftware"] = "JIRA_SOFTWARE";
    ActivityProduct["Townsquare"] = "TOWNSQUARE";
})($2f512219da033f72$export$3ca4051c67b8ec7b || ($2f512219da033f72$export$3ca4051c67b8ec7b = {}));
var $2f512219da033f72$export$d473388190f44564;
(function(AdminAnnouncementBannerSettingsByCriteriaOrder) {
    AdminAnnouncementBannerSettingsByCriteriaOrder["Default"] = "DEFAULT";
    AdminAnnouncementBannerSettingsByCriteriaOrder["ScheduledEndDate"] = "SCHEDULED_END_DATE";
    AdminAnnouncementBannerSettingsByCriteriaOrder["ScheduledStartDate"] = "SCHEDULED_START_DATE";
    AdminAnnouncementBannerSettingsByCriteriaOrder["Visibility"] = "VISIBILITY";
})($2f512219da033f72$export$d473388190f44564 || ($2f512219da033f72$export$d473388190f44564 = {}));
var $2f512219da033f72$export$77091207d2ef65cb;
(function(AgentStudioAgentType) {
    /** Rovo agent type */ AgentStudioAgentType["Assistant"] = "ASSISTANT";
})($2f512219da033f72$export$77091207d2ef65cb || ($2f512219da033f72$export$77091207d2ef65cb = {}));
var $2f512219da033f72$export$276a961098f2db01;
(function(AlertEventStatus) {
    AlertEventStatus["Acknowledged"] = "ACKNOWLEDGED";
    AlertEventStatus["Closed"] = "CLOSED";
    AlertEventStatus["Opened"] = "OPENED";
    AlertEventStatus["Snoozed"] = "SNOOZED";
})($2f512219da033f72$export$276a961098f2db01 || ($2f512219da033f72$export$276a961098f2db01 = {}));
var $2f512219da033f72$export$232eaa1effb46fa2;
(function(AlertPriority) {
    AlertPriority["P1"] = "P1";
    AlertPriority["P2"] = "P2";
    AlertPriority["P3"] = "P3";
    AlertPriority["P4"] = "P4";
    AlertPriority["P5"] = "P5";
})($2f512219da033f72$export$232eaa1effb46fa2 || ($2f512219da033f72$export$232eaa1effb46fa2 = {}));
var $2f512219da033f72$export$4a0ef2063823d595;
(function(AllUpdatesFeedEventType) {
    AllUpdatesFeedEventType["Comment"] = "COMMENT";
    AllUpdatesFeedEventType["Create"] = "CREATE";
    AllUpdatesFeedEventType["Edit"] = "EDIT";
})($2f512219da033f72$export$4a0ef2063823d595 || ($2f512219da033f72$export$4a0ef2063823d595 = {}));
var $2f512219da033f72$export$308e2943abbbaaa3;
(function(AnalyticsClickEventName) {
    AnalyticsClickEventName["CompanyHubLinkClicked"] = "companyHubLink_clicked";
})($2f512219da033f72$export$308e2943abbbaaa3 || ($2f512219da033f72$export$308e2943abbbaaa3 = {}));
var $2f512219da033f72$export$9180cd5128ccbcb3;
(function(AnalyticsCommentType) {
    AnalyticsCommentType["Inline"] = "inline";
    AnalyticsCommentType["Page"] = "page";
})($2f512219da033f72$export$9180cd5128ccbcb3 || ($2f512219da033f72$export$9180cd5128ccbcb3 = {}));
var $2f512219da033f72$export$cded1cb35d1d0b78;
(function(AnalyticsContentType) {
    AnalyticsContentType["Blogpost"] = "blogpost";
    AnalyticsContentType["Page"] = "page";
})($2f512219da033f72$export$cded1cb35d1d0b78 || ($2f512219da033f72$export$cded1cb35d1d0b78 = {}));
var $2f512219da033f72$export$9b64ffeee4e546e5;
(function(AnalyticsDiscoverEventName) {
    AnalyticsDiscoverEventName["CompanyHubLinkViewed"] = "companyHubLink_viewed";
})($2f512219da033f72$export$9b64ffeee4e546e5 || ($2f512219da033f72$export$9b64ffeee4e546e5 = {}));
var $2f512219da033f72$export$b24d7126f46e9c0f;
(function(AnalyticsEventName) {
    AnalyticsEventName["AnalyticsPageModalViewed"] = "analyticsPageModal_viewed";
    AnalyticsEventName["AutomationRuleTrackCreated"] = "automationRuleTrack_created";
    AnalyticsEventName["CalendarCreated"] = "calendar_created";
    AnalyticsEventName["CommentCreated"] = "comment_created";
    AnalyticsEventName["CompanyHubLinkClicked"] = "companyHubLink_clicked";
    AnalyticsEventName["CompanyHubLinkViewed"] = "companyHubLink_viewed";
    AnalyticsEventName["DatabaseCreated"] = "database_created";
    AnalyticsEventName["DatabaseViewed"] = "database_viewed";
    AnalyticsEventName["InspectPermissionsDialogViewed"] = "inspectPermissionsDialog_viewed";
    AnalyticsEventName["InstanceAnalyticsViewed"] = "instanceAnalytics_viewed";
    AnalyticsEventName["PageAnalyticsViewed"] = "pageAnalytics_viewed";
    AnalyticsEventName["PageCreated"] = "page_created";
    AnalyticsEventName["PageUpdated"] = "page_updated";
    AnalyticsEventName["PageViewed"] = "page_viewed";
    AnalyticsEventName["PubliclinkPageViewed"] = "publiclink_page_viewed";
    AnalyticsEventName["SpaceAnalyticsViewed"] = "spaceAnalytics_viewed";
    AnalyticsEventName["TeamCalendarsViewed"] = "teamCalendars_viewed";
    AnalyticsEventName["WhiteboardCreated"] = "whiteboard_created";
    AnalyticsEventName["WhiteboardViewed"] = "whiteboard_viewed";
})($2f512219da033f72$export$b24d7126f46e9c0f || ($2f512219da033f72$export$b24d7126f46e9c0f = {}));
var $2f512219da033f72$export$fa94a16c12eb7142;
(function(AnalyticsMeasuresEventName) {
    AnalyticsMeasuresEventName["CurrentBlogpostCountSpacestateMeasured"] = "currentBlogpostCount_spacestate_measured";
    AnalyticsMeasuresEventName["CurrentDatabaseCountSpacestateMeasured"] = "currentDatabaseCount_spacestate_measured";
    AnalyticsMeasuresEventName["CurrentLivedocsCountSpacestateMeasured"] = "currentLivedocsCount_spacestate_measured";
    AnalyticsMeasuresEventName["CurrentPageCountSpacestateMeasured"] = "currentPageCount_spacestate_measured";
    AnalyticsMeasuresEventName["CurrentWhiteboardCountSpacestateMeasured"] = "currentWhiteboardCount_spacestate_measured";
    AnalyticsMeasuresEventName["InactivePageCountSitestateMeasured"] = "inactivePageCount_sitestate_measured";
    AnalyticsMeasuresEventName["InactivePageCountSpacestateMeasured"] = "inactivePageCount_spacestate_measured";
    AnalyticsMeasuresEventName["TotalActiveCommunalSpacesSitestateMeasured"] = "totalActiveCommunalSpaces_sitestate_measured";
    AnalyticsMeasuresEventName["TotalActivePersonalSpacesSitestateMeasured"] = "totalActivePersonalSpaces_sitestate_measured";
    AnalyticsMeasuresEventName["TotalActivePublicLinksSitestateMeasured"] = "totalActivePublicLinks_sitestate_measured";
    AnalyticsMeasuresEventName["TotalActivePublicLinksSpacestateMeasured"] = "totalActivePublicLinks_spacestate_measured";
    AnalyticsMeasuresEventName["TotalActiveSpacesSitestateMeasured"] = "totalActiveSpaces_sitestate_measured";
    AnalyticsMeasuresEventName["TotalCurrentBlogpostCountSitestateMeasured"] = "totalCurrentBlogpostCount_sitestate_measured";
    AnalyticsMeasuresEventName["TotalCurrentDatabaseCountSitestateMeasured"] = "totalCurrentDatabaseCount_sitestate_measured";
    AnalyticsMeasuresEventName["TotalCurrentLivedocsCountSitestateMeasured"] = "totalCurrentLivedocsCount_sitestate_measured";
    AnalyticsMeasuresEventName["TotalCurrentPageCountSitestateMeasured"] = "totalCurrentPageCount_sitestate_measured";
    AnalyticsMeasuresEventName["TotalCurrentWhiteboardCountSitestateMeasured"] = "totalCurrentWhiteboardCount_sitestate_measured";
    AnalyticsMeasuresEventName["TotalPagesDeactivatedOwnerSitestateMeasured"] = "totalPagesDeactivatedOwner_sitestate_measured";
    AnalyticsMeasuresEventName["TotalPagesDeactivatedOwnerSpacestateMeasured"] = "totalPagesDeactivatedOwner_spacestate_measured";
})($2f512219da033f72$export$fa94a16c12eb7142 || ($2f512219da033f72$export$fa94a16c12eb7142 = {}));
var $2f512219da033f72$export$45880df433ee9403;
(function(AnalyticsMeasuresSpaceEventName) {
    AnalyticsMeasuresSpaceEventName["CurrentBlogpostCountSpacestateMeasured"] = "currentBlogpostCount_spacestate_measured";
    AnalyticsMeasuresSpaceEventName["CurrentDatabaseCountSpacestateMeasured"] = "currentDatabaseCount_spacestate_measured";
    AnalyticsMeasuresSpaceEventName["CurrentLivedocsCountSpacestateMeasured"] = "currentLivedocsCount_spacestate_measured";
    AnalyticsMeasuresSpaceEventName["CurrentPageCountSpacestateMeasured"] = "currentPageCount_spacestate_measured";
    AnalyticsMeasuresSpaceEventName["CurrentWhiteboardCountSpacestateMeasured"] = "currentWhiteboardCount_spacestate_measured";
    AnalyticsMeasuresSpaceEventName["InactivePageCountSpacestateMeasured"] = "inactivePageCount_spacestate_measured";
    AnalyticsMeasuresSpaceEventName["TotalActivePublicLinksSpacestateMeasured"] = "totalActivePublicLinks_spacestate_measured";
    AnalyticsMeasuresSpaceEventName["TotalPagesDeactivatedOwnerSpacestateMeasured"] = "totalPagesDeactivatedOwner_spacestate_measured";
})($2f512219da033f72$export$45880df433ee9403 || ($2f512219da033f72$export$45880df433ee9403 = {}));
var $2f512219da033f72$export$e9062d11934e8ae;
(function(AnalyticsSearchEventName) {
    AnalyticsSearchEventName["AdvancedSearchResultLinkClicked"] = "advancedSearchResultLink_clicked";
    AnalyticsSearchEventName["AdvancedSearchResultsShown"] = "advancedSearchResults_shown";
    AnalyticsSearchEventName["QuickSearchRequestCompleted"] = "quickSearchRequest_completed";
    AnalyticsSearchEventName["QuickSearchResultSelected"] = "quickSearchResult_selected";
})($2f512219da033f72$export$e9062d11934e8ae || ($2f512219da033f72$export$e9062d11934e8ae = {}));
var $2f512219da033f72$export$a874c5d67969faf2;
(function(AnalyticsTimeseriesGranularity) {
    AnalyticsTimeseriesGranularity["Day"] = "DAY";
    AnalyticsTimeseriesGranularity["Hour"] = "HOUR";
    AnalyticsTimeseriesGranularity["Month"] = "MONTH";
    AnalyticsTimeseriesGranularity["Week"] = "WEEK";
})($2f512219da033f72$export$a874c5d67969faf2 || ($2f512219da033f72$export$a874c5d67969faf2 = {}));
var $2f512219da033f72$export$f6d52655da4aa77d;
(function(ApiContext) {
    ApiContext["Devops"] = "DEVOPS";
})($2f512219da033f72$export$f6d52655da4aa77d || ($2f512219da033f72$export$f6d52655da4aa77d = {}));
var $2f512219da033f72$export$8145658f3946b657;
(function(ApiGroup) {
    ApiGroup["Actions"] = "ACTIONS";
    ApiGroup["AgentStudio"] = "AGENT_STUDIO";
    ApiGroup["AppRecommendations"] = "APP_RECOMMENDATIONS";
    ApiGroup["AtlassianStudio"] = "ATLASSIAN_STUDIO";
    ApiGroup["Caas"] = "CAAS";
    ApiGroup["CloudAdmin"] = "CLOUD_ADMIN";
    ApiGroup["CollaborationGraph"] = "COLLABORATION_GRAPH";
    ApiGroup["CommerceCcp"] = "COMMERCE_CCP";
    ApiGroup["CommerceHams"] = "COMMERCE_HAMS";
    ApiGroup["CommerceSharedApi"] = "COMMERCE_SHARED_API";
    ApiGroup["Compass"] = "COMPASS";
    ApiGroup["Confluence"] = "CONFLUENCE";
    ApiGroup["ConfluenceAnalytics"] = "CONFLUENCE_ANALYTICS";
    ApiGroup["ConfluenceLegacy"] = "CONFLUENCE_LEGACY";
    ApiGroup["ConfluenceMutations"] = "CONFLUENCE_MUTATIONS";
    ApiGroup["ConfluencePages"] = "CONFLUENCE_PAGES";
    ApiGroup["ConfluencePageTree"] = "CONFLUENCE_PAGE_TREE";
    ApiGroup["ConfluenceSmarts"] = "CONFLUENCE_SMARTS";
    ApiGroup["ConfluenceTenant"] = "CONFLUENCE_TENANT";
    ApiGroup["ConfluenceUser"] = "CONFLUENCE_USER";
    ApiGroup["ConfluenceV2"] = "CONFLUENCE_V2";
    ApiGroup["ContentPlatformApi"] = "CONTENT_PLATFORM_API";
    ApiGroup["CustomerService"] = "CUSTOMER_SERVICE";
    ApiGroup["DevopsAriGraph"] = "DEVOPS_ARI_GRAPH";
    ApiGroup["DevopsContainerRelationship"] = "DEVOPS_CONTAINER_RELATIONSHIP";
    ApiGroup["DevopsService"] = "DEVOPS_SERVICE";
    ApiGroup["DevopsThirdParty"] = "DEVOPS_THIRD_PARTY";
    ApiGroup["DevopsToolchain"] = "DEVOPS_TOOLCHAIN";
    ApiGroup["FeatureReleaseQuery"] = "FEATURE_RELEASE_QUERY";
    ApiGroup["Forge"] = "FORGE";
    ApiGroup["Help"] = "HELP";
    ApiGroup["Identity"] = "IDENTITY";
    ApiGroup["InsightsXperienceService"] = "INSIGHTS_XPERIENCE_SERVICE";
    ApiGroup["Jira"] = "JIRA";
    ApiGroup["Papi"] = "PAPI";
    ApiGroup["Polaris"] = "POLARIS";
    ApiGroup["ServiceHubAgentConfiguration"] = "SERVICE_HUB_AGENT_CONFIGURATION";
    ApiGroup["SurfacePlatform"] = "SURFACE_PLATFORM";
    ApiGroup["Teams"] = "TEAMS";
    ApiGroup["VirtualAgent"] = "VIRTUAL_AGENT";
    ApiGroup["WebTriggers"] = "WEB_TRIGGERS";
    ApiGroup["XenInvocationService"] = "XEN_INVOCATION_SERVICE";
    ApiGroup["XenLogsApi"] = "XEN_LOGS_API";
})($2f512219da033f72$export$8145658f3946b657 || ($2f512219da033f72$export$8145658f3946b657 = {}));
var $2f512219da033f72$export$50693beeb92df79c;
(function(AppContributorRole) {
    AppContributorRole["Admin"] = "ADMIN";
    AppContributorRole["Deployer"] = "DEPLOYER";
    AppContributorRole["Developer"] = "DEVELOPER";
    AppContributorRole["Viewer"] = "VIEWER";
    AppContributorRole["ViewerAdvanced"] = "VIEWER_ADVANCED";
})($2f512219da033f72$export$50693beeb92df79c || ($2f512219da033f72$export$50693beeb92df79c = {}));
var $2f512219da033f72$export$2f94efde4452c4e8;
(function(AppDeploymentEventLogLevel) {
    AppDeploymentEventLogLevel["Error"] = "ERROR";
    AppDeploymentEventLogLevel["Info"] = "INFO";
    AppDeploymentEventLogLevel["Warning"] = "WARNING";
})($2f512219da033f72$export$2f94efde4452c4e8 || ($2f512219da033f72$export$2f94efde4452c4e8 = {}));
var $2f512219da033f72$export$df989df2cca988a2;
(function(AppDeploymentStatus) {
    AppDeploymentStatus["Done"] = "DONE";
    AppDeploymentStatus["Failed"] = "FAILED";
    AppDeploymentStatus["InProgress"] = "IN_PROGRESS";
})($2f512219da033f72$export$df989df2cca988a2 || ($2f512219da033f72$export$df989df2cca988a2 = {}));
var $2f512219da033f72$export$aa4fe8ce66c067b1;
(function(AppDeploymentStepStatus) {
    AppDeploymentStepStatus["Done"] = "DONE";
    AppDeploymentStepStatus["Failed"] = "FAILED";
    AppDeploymentStepStatus["Started"] = "STARTED";
})($2f512219da033f72$export$aa4fe8ce66c067b1 || ($2f512219da033f72$export$aa4fe8ce66c067b1 = {}));
var $2f512219da033f72$export$bbec072c9916131d;
(function(AppEnvironmentType) {
    AppEnvironmentType["Development"] = "DEVELOPMENT";
    AppEnvironmentType["Production"] = "PRODUCTION";
    AppEnvironmentType["Staging"] = "STAGING";
})($2f512219da033f72$export$bbec072c9916131d || ($2f512219da033f72$export$bbec072c9916131d = {}));
var $2f512219da033f72$export$fbf2cbb62789ffaf;
(function(AppNetworkEgressCategory) {
    AppNetworkEgressCategory["Analytics"] = "ANALYTICS";
})($2f512219da033f72$export$fbf2cbb62789ffaf || ($2f512219da033f72$export$fbf2cbb62789ffaf = {}));
var $2f512219da033f72$export$2ffac81b887afa1d;
(function(AppNetworkEgressCategoryExtension) {
    AppNetworkEgressCategoryExtension["Analytics"] = "ANALYTICS";
})($2f512219da033f72$export$2ffac81b887afa1d || ($2f512219da033f72$export$2ffac81b887afa1d = {}));
var $2f512219da033f72$export$cb9e000131989fd;
(function(AppNetworkPermissionType) {
    AppNetworkPermissionType["FetchBackendSide"] = "FETCH_BACKEND_SIDE";
    AppNetworkPermissionType["FetchClientSide"] = "FETCH_CLIENT_SIDE";
    AppNetworkPermissionType["Fonts"] = "FONTS";
    AppNetworkPermissionType["Frames"] = "FRAMES";
    AppNetworkPermissionType["Images"] = "IMAGES";
    AppNetworkPermissionType["Media"] = "MEDIA";
    AppNetworkPermissionType["Navigation"] = "NAVIGATION";
    AppNetworkPermissionType["Scripts"] = "SCRIPTS";
    AppNetworkPermissionType["Styles"] = "STYLES";
})($2f512219da033f72$export$cb9e000131989fd || ($2f512219da033f72$export$cb9e000131989fd = {}));
var $2f512219da033f72$export$46aa181a404c6a14;
(function(AppNetworkPermissionTypeExtension) {
    AppNetworkPermissionTypeExtension["FetchBackendSide"] = "FETCH_BACKEND_SIDE";
    AppNetworkPermissionTypeExtension["FetchClientSide"] = "FETCH_CLIENT_SIDE";
    AppNetworkPermissionTypeExtension["Fonts"] = "FONTS";
    AppNetworkPermissionTypeExtension["Frames"] = "FRAMES";
    AppNetworkPermissionTypeExtension["Images"] = "IMAGES";
    AppNetworkPermissionTypeExtension["Media"] = "MEDIA";
    AppNetworkPermissionTypeExtension["Navigation"] = "NAVIGATION";
    AppNetworkPermissionTypeExtension["Scripts"] = "SCRIPTS";
    AppNetworkPermissionTypeExtension["Styles"] = "STYLES";
})($2f512219da033f72$export$46aa181a404c6a14 || ($2f512219da033f72$export$46aa181a404c6a14 = {}));
var $2f512219da033f72$export$1618aa24ce40e8c9;
(function(AppSecurityPoliciesPermissionType) {
    AppSecurityPoliciesPermissionType["Scripts"] = "SCRIPTS";
    AppSecurityPoliciesPermissionType["Styles"] = "STYLES";
})($2f512219da033f72$export$1618aa24ce40e8c9 || ($2f512219da033f72$export$1618aa24ce40e8c9 = {}));
var $2f512219da033f72$export$3397fdc734564301;
(function(AppSecurityPoliciesPermissionTypeExtension) {
    AppSecurityPoliciesPermissionTypeExtension["Scripts"] = "SCRIPTS";
    AppSecurityPoliciesPermissionTypeExtension["Styles"] = "STYLES";
})($2f512219da033f72$export$3397fdc734564301 || ($2f512219da033f72$export$3397fdc734564301 = {}));
var $2f512219da033f72$export$abe79a166182d5dd;
(function(AppStoredCustomEntityFilterCondition) {
    AppStoredCustomEntityFilterCondition["BeginsWith"] = "BEGINS_WITH";
    AppStoredCustomEntityFilterCondition["Between"] = "BETWEEN";
    AppStoredCustomEntityFilterCondition["Contains"] = "CONTAINS";
    AppStoredCustomEntityFilterCondition["EqualTo"] = "EQUAL_TO";
    AppStoredCustomEntityFilterCondition["Exists"] = "EXISTS";
    AppStoredCustomEntityFilterCondition["GreaterThan"] = "GREATER_THAN";
    AppStoredCustomEntityFilterCondition["GreaterThanEqualTo"] = "GREATER_THAN_EQUAL_TO";
    AppStoredCustomEntityFilterCondition["LessThan"] = "LESS_THAN";
    AppStoredCustomEntityFilterCondition["LessThanEqualTo"] = "LESS_THAN_EQUAL_TO";
    AppStoredCustomEntityFilterCondition["NotContains"] = "NOT_CONTAINS";
    AppStoredCustomEntityFilterCondition["NotEqualTo"] = "NOT_EQUAL_TO";
    AppStoredCustomEntityFilterCondition["NotExists"] = "NOT_EXISTS";
})($2f512219da033f72$export$abe79a166182d5dd || ($2f512219da033f72$export$abe79a166182d5dd = {}));
var $2f512219da033f72$export$8c6210489e377c93;
(function(AppStoredCustomEntityRangeCondition) {
    AppStoredCustomEntityRangeCondition["BeginsWith"] = "BEGINS_WITH";
    AppStoredCustomEntityRangeCondition["Between"] = "BETWEEN";
    AppStoredCustomEntityRangeCondition["EqualTo"] = "EQUAL_TO";
    AppStoredCustomEntityRangeCondition["GreaterThan"] = "GREATER_THAN";
    AppStoredCustomEntityRangeCondition["GreaterThanEqualTo"] = "GREATER_THAN_EQUAL_TO";
    AppStoredCustomEntityRangeCondition["LessThan"] = "LESS_THAN";
    AppStoredCustomEntityRangeCondition["LessThanEqualTo"] = "LESS_THAN_EQUAL_TO";
})($2f512219da033f72$export$8c6210489e377c93 || ($2f512219da033f72$export$8c6210489e377c93 = {}));
var $2f512219da033f72$export$6c1157c4fc1b51c4;
(function(AppStoredEntityCondition) {
    AppStoredEntityCondition["In"] = "IN";
    AppStoredEntityCondition["NotEqualTo"] = "NOT_EQUAL_TO";
    AppStoredEntityCondition["StartsWith"] = "STARTS_WITH";
})($2f512219da033f72$export$6c1157c4fc1b51c4 || ($2f512219da033f72$export$6c1157c4fc1b51c4 = {}));
var $2f512219da033f72$export$63fbd5015391964b;
(function(AppTaskState) {
    AppTaskState["Complete"] = "COMPLETE";
    AppTaskState["Failed"] = "FAILED";
    AppTaskState["Pending"] = "PENDING";
    AppTaskState["Running"] = "RUNNING";
})($2f512219da033f72$export$63fbd5015391964b || ($2f512219da033f72$export$63fbd5015391964b = {}));
var $2f512219da033f72$export$5b9c3b8406b5cf1a;
(function(AppTrustInformationState) {
    AppTrustInformationState["Draft"] = "DRAFT";
    AppTrustInformationState["Live"] = "LIVE";
})($2f512219da033f72$export$5b9c3b8406b5cf1a || ($2f512219da033f72$export$5b9c3b8406b5cf1a = {}));
var $2f512219da033f72$export$c8ae3a8e8f57359f;
(function(ArchivedMode) {
    ArchivedMode["ActiveOnly"] = "ACTIVE_ONLY";
    ArchivedMode["All"] = "ALL";
    ArchivedMode["ArchivedOnly"] = "ARCHIVED_ONLY";
})($2f512219da033f72$export$c8ae3a8e8f57359f || ($2f512219da033f72$export$c8ae3a8e8f57359f = {}));
var $2f512219da033f72$export$207a81844461bdb0;
(function(AriGraphRelationshipsSortDirection) {
    /** Sort in ascending order */ AriGraphRelationshipsSortDirection["Asc"] = "ASC";
    /** Sort in descending order */ AriGraphRelationshipsSortDirection["Desc"] = "DESC";
})($2f512219da033f72$export$207a81844461bdb0 || ($2f512219da033f72$export$207a81844461bdb0 = {}));
var $2f512219da033f72$export$38d407d6909984c2;
(function(AtlassianProductHostingType) {
    AtlassianProductHostingType["Cloud"] = "CLOUD";
    AtlassianProductHostingType["DataCenter"] = "DATA_CENTER";
    AtlassianProductHostingType["Server"] = "SERVER";
})($2f512219da033f72$export$38d407d6909984c2 || ($2f512219da033f72$export$38d407d6909984c2 = {}));
var $2f512219da033f72$export$f607415a4f76ed4a;
(function(AuthClientType) {
    AuthClientType["AtlassianMobile"] = "ATLASSIAN_MOBILE";
    AuthClientType["ThirdParty"] = "THIRD_PARTY";
    AuthClientType["ThirdPartyNative"] = "THIRD_PARTY_NATIVE";
})($2f512219da033f72$export$f607415a4f76ed4a || ($2f512219da033f72$export$f607415a4f76ed4a = {}));
var $2f512219da033f72$export$9a15ec84cbf7e668;
(function(BackendExperiment) {
    BackendExperiment["Einstein"] = "EINSTEIN";
})($2f512219da033f72$export$9a15ec84cbf7e668 || ($2f512219da033f72$export$9a15ec84cbf7e668 = {}));
var $2f512219da033f72$export$2c393978d59015b8;
(function(BillingSourceSystem) {
    BillingSourceSystem["Ccp"] = "CCP";
    BillingSourceSystem["Hams"] = "HAMS";
})($2f512219da033f72$export$2c393978d59015b8 || ($2f512219da033f72$export$2c393978d59015b8 = {}));
var $2f512219da033f72$export$a3fe6fe047d6ad5c;
(function(BitbucketPermission) {
    /** Bitbucket admin permission */ BitbucketPermission["Admin"] = "ADMIN";
})($2f512219da033f72$export$a3fe6fe047d6ad5c || ($2f512219da033f72$export$a3fe6fe047d6ad5c = {}));
var $2f512219da033f72$export$43eb1e191ddb78c0;
(function(BlockedAccessSubjectType) {
    BlockedAccessSubjectType["Group"] = "GROUP";
    BlockedAccessSubjectType["User"] = "USER";
})($2f512219da033f72$export$43eb1e191ddb78c0 || ($2f512219da033f72$export$43eb1e191ddb78c0 = {}));
var $2f512219da033f72$export$dd75b3db211b43be;
(function(BoardFeatureStatus) {
    BoardFeatureStatus["ComingSoon"] = "COMING_SOON";
    BoardFeatureStatus["Disabled"] = "DISABLED";
    BoardFeatureStatus["Enabled"] = "ENABLED";
})($2f512219da033f72$export$dd75b3db211b43be || ($2f512219da033f72$export$dd75b3db211b43be = {}));
var $2f512219da033f72$export$c0a71a6782116cff;
(function(BoardFeatureToggleStatus) {
    BoardFeatureToggleStatus["Disabled"] = "DISABLED";
    BoardFeatureToggleStatus["Enabled"] = "ENABLED";
})($2f512219da033f72$export$c0a71a6782116cff || ($2f512219da033f72$export$c0a71a6782116cff = {}));
var $2f512219da033f72$export$19baf80f4562d4e3;
(function(BoardSwimlaneStrategy) {
    BoardSwimlaneStrategy["AssigneeUnassignedFirst"] = "ASSIGNEE_UNASSIGNED_FIRST";
    BoardSwimlaneStrategy["AssigneeUnassignedLast"] = "ASSIGNEE_UNASSIGNED_LAST";
    BoardSwimlaneStrategy["Custom"] = "CUSTOM";
    BoardSwimlaneStrategy["Epic"] = "EPIC";
    BoardSwimlaneStrategy["IssueChildren"] = "ISSUE_CHILDREN";
    BoardSwimlaneStrategy["IssueParent"] = "ISSUE_PARENT";
    BoardSwimlaneStrategy["None"] = "NONE";
    BoardSwimlaneStrategy["ParentChild"] = "PARENT_CHILD";
    BoardSwimlaneStrategy["Project"] = "PROJECT";
    BoardSwimlaneStrategy["RequestType"] = "REQUEST_TYPE";
})($2f512219da033f72$export$19baf80f4562d4e3 || ($2f512219da033f72$export$19baf80f4562d4e3 = {}));
var $2f512219da033f72$export$6aa34929962e7b8e;
(function(BodyFormatType) {
    BodyFormatType["AnonymousExportView"] = "ANONYMOUS_EXPORT_VIEW";
    BodyFormatType["AtlasDocFormat"] = "ATLAS_DOC_FORMAT";
    BodyFormatType["Editor"] = "EDITOR";
    BodyFormatType["Editor2"] = "EDITOR2";
    BodyFormatType["ExportView"] = "EXPORT_VIEW";
    BodyFormatType["Storage"] = "STORAGE";
    BodyFormatType["StyledView"] = "STYLED_VIEW";
    BodyFormatType["View"] = "VIEW";
})($2f512219da033f72$export$6aa34929962e7b8e || ($2f512219da033f72$export$6aa34929962e7b8e = {}));
var $2f512219da033f72$export$cb959494221894c8;
(function(BooleanUserInputType) {
    BooleanUserInputType["Boolean"] = "BOOLEAN";
})($2f512219da033f72$export$cb959494221894c8 || ($2f512219da033f72$export$cb959494221894c8 = {}));
var $2f512219da033f72$export$52d25977f4eeeb6;
(function(BuiltinPolarisIdeaField) {
    /** Jira Product Discovery fields */ BuiltinPolarisIdeaField["Archived"] = "ARCHIVED";
    BuiltinPolarisIdeaField["ArchivedBy"] = "ARCHIVED_BY";
    BuiltinPolarisIdeaField["ArchivedOn"] = "ARCHIVED_ON";
    /** Jira fields */ BuiltinPolarisIdeaField["Assignee"] = "ASSIGNEE";
    BuiltinPolarisIdeaField["AtlasGoal"] = "ATLAS_GOAL";
    BuiltinPolarisIdeaField["AtlasProject"] = "ATLAS_PROJECT";
    BuiltinPolarisIdeaField["AtlasProjectStatus"] = "ATLAS_PROJECT_STATUS";
    BuiltinPolarisIdeaField["AtlasProjectTarget"] = "ATLAS_PROJECT_TARGET";
    BuiltinPolarisIdeaField["Created"] = "CREATED";
    BuiltinPolarisIdeaField["Creator"] = "CREATOR";
    BuiltinPolarisIdeaField["DeliveryProgress"] = "DELIVERY_PROGRESS";
    BuiltinPolarisIdeaField["DeliveryStatus"] = "DELIVERY_STATUS";
    BuiltinPolarisIdeaField["Description"] = "DESCRIPTION";
    BuiltinPolarisIdeaField["IssueComments"] = "ISSUE_COMMENTS";
    BuiltinPolarisIdeaField["IssueId"] = "ISSUE_ID";
    BuiltinPolarisIdeaField["IssueType"] = "ISSUE_TYPE";
    BuiltinPolarisIdeaField["Key"] = "KEY";
    BuiltinPolarisIdeaField["Labels"] = "LABELS";
    BuiltinPolarisIdeaField["LinkedIssues"] = "LINKED_ISSUES";
    BuiltinPolarisIdeaField["NumDataPoints"] = "NUM_DATA_POINTS";
    BuiltinPolarisIdeaField["Reporter"] = "REPORTER";
    BuiltinPolarisIdeaField["Status"] = "STATUS";
    BuiltinPolarisIdeaField["Summary"] = "SUMMARY";
    BuiltinPolarisIdeaField["Updated"] = "UPDATED";
    BuiltinPolarisIdeaField["Votes"] = "VOTES";
})($2f512219da033f72$export$52d25977f4eeeb6 || ($2f512219da033f72$export$52d25977f4eeeb6 = {}));
var $2f512219da033f72$export$dc2a111abcc46324;
(function(BulkRoleAssignmentSpaceType) {
    BulkRoleAssignmentSpaceType["Collaboration"] = "COLLABORATION";
    BulkRoleAssignmentSpaceType["Global"] = "GLOBAL";
    BulkRoleAssignmentSpaceType["KnowledgeBase"] = "KNOWLEDGE_BASE";
    BulkRoleAssignmentSpaceType["Personal"] = "PERSONAL";
})($2f512219da033f72$export$dc2a111abcc46324 || ($2f512219da033f72$export$dc2a111abcc46324 = {}));
var $2f512219da033f72$export$e57870671ec2468e;
(function(BulkSetSpacePermissionSpaceType) {
    BulkSetSpacePermissionSpaceType["Collaboration"] = "COLLABORATION";
    BulkSetSpacePermissionSpaceType["Global"] = "GLOBAL";
    BulkSetSpacePermissionSpaceType["KnowledgeBase"] = "KNOWLEDGE_BASE";
    BulkSetSpacePermissionSpaceType["Personal"] = "PERSONAL";
})($2f512219da033f72$export$e57870671ec2468e || ($2f512219da033f72$export$e57870671ec2468e = {}));
var $2f512219da033f72$export$8b2051573ac4b3d5;
(function(BulkSetSpacePermissionSubjectType) {
    BulkSetSpacePermissionSubjectType["Group"] = "GROUP";
    BulkSetSpacePermissionSubjectType["User"] = "USER";
})($2f512219da033f72$export$8b2051573ac4b3d5 || ($2f512219da033f72$export$8b2051573ac4b3d5 = {}));
var $2f512219da033f72$export$184db778f5e78171;
(function(CapabilitySet) {
    CapabilitySet["CapabilityAdvanced"] = "capabilityAdvanced";
    CapabilitySet["CapabilityStandard"] = "capabilityStandard";
})($2f512219da033f72$export$184db778f5e78171 || ($2f512219da033f72$export$184db778f5e78171 = {}));
var $2f512219da033f72$export$805b6160e3efc186;
(function(CardHierarchyLevelEnumType) {
    CardHierarchyLevelEnumType["Base"] = "BASE";
    CardHierarchyLevelEnumType["Child"] = "CHILD";
    CardHierarchyLevelEnumType["Parent"] = "PARENT";
})($2f512219da033f72$export$805b6160e3efc186 || ($2f512219da033f72$export$805b6160e3efc186 = {}));
var $2f512219da033f72$export$fe6033382a69eea9;
(function(CatchupContentType) {
    CatchupContentType["Blogpost"] = "BLOGPOST";
    CatchupContentType["Page"] = "PAGE";
})($2f512219da033f72$export$fe6033382a69eea9 || ($2f512219da033f72$export$fe6033382a69eea9 = {}));
var $2f512219da033f72$export$e836133c611d8abd;
(function(CatchupOverviewUpdateType) {
    CatchupOverviewUpdateType["SinceLastViewed"] = "SINCE_LAST_VIEWED";
    CatchupOverviewUpdateType["SinceLastViewedMarkdown"] = "SINCE_LAST_VIEWED_MARKDOWN";
})($2f512219da033f72$export$e836133c611d8abd || ($2f512219da033f72$export$e836133c611d8abd = {}));
var $2f512219da033f72$export$ee2a5f4674ed5b8d;
(function(CcpActivationReason) {
    CcpActivationReason["AdvantagePricing"] = "ADVANTAGE_PRICING";
    CcpActivationReason["DefaultPricing"] = "DEFAULT_PRICING";
    CcpActivationReason["ExperimentalPricing"] = "EXPERIMENTAL_PRICING";
})($2f512219da033f72$export$ee2a5f4674ed5b8d || ($2f512219da033f72$export$ee2a5f4674ed5b8d = {}));
var $2f512219da033f72$export$b67456ef3eee80c9;
(function(CcpBehaviourAtEndOfTrial) {
    /** Cancels the entitlement after trial ends */ CcpBehaviourAtEndOfTrial["Cancel"] = "CANCEL";
    /** Converts the trial to paid after trial ends */ CcpBehaviourAtEndOfTrial["ConvertToPaid"] = "CONVERT_TO_PAID";
    /** Reverts to previous offering after trial ends */ CcpBehaviourAtEndOfTrial["RevertTrial"] = "REVERT_TRIAL";
})($2f512219da033f72$export$b67456ef3eee80c9 || ($2f512219da033f72$export$b67456ef3eee80c9 = {}));
var $2f512219da033f72$export$dd06bd5976bfc6e3;
(function(CcpBillingInterval) {
    CcpBillingInterval["Day"] = "DAY";
    CcpBillingInterval["Month"] = "MONTH";
    CcpBillingInterval["Week"] = "WEEK";
    CcpBillingInterval["Year"] = "YEAR";
})($2f512219da033f72$export$dd06bd5976bfc6e3 || ($2f512219da033f72$export$dd06bd5976bfc6e3 = {}));
var $2f512219da033f72$export$8f092ffe50fe78ad;
(function(CcpCancelEntitlementExperienceCapabilityReasonCode) {
    CcpCancelEntitlementExperienceCapabilityReasonCode["EntitlementIsCollectionInstance"] = "ENTITLEMENT_IS_COLLECTION_INSTANCE";
})($2f512219da033f72$export$8f092ffe50fe78ad || ($2f512219da033f72$export$8f092ffe50fe78ad = {}));
var $2f512219da033f72$export$f1663167a1dfb133;
(function(CcpChargeType) {
    CcpChargeType["AutoScaling"] = "AUTO_SCALING";
    CcpChargeType["Licensed"] = "LICENSED";
    CcpChargeType["Metered"] = "METERED";
})($2f512219da033f72$export$f1663167a1dfb133 || ($2f512219da033f72$export$f1663167a1dfb133 = {}));
var $2f512219da033f72$export$2b7ed271c0780e01;
(function(CcpCreateEntitlementExperienceCapabilityErrorReasonCode) {
    CcpCreateEntitlementExperienceCapabilityErrorReasonCode["MultipleTransactionAccount"] = "MULTIPLE_TRANSACTION_ACCOUNT";
    CcpCreateEntitlementExperienceCapabilityErrorReasonCode["UsecaseNotImplemented"] = "USECASE_NOT_IMPLEMENTED";
})($2f512219da033f72$export$2b7ed271c0780e01 || ($2f512219da033f72$export$2b7ed271c0780e01 = {}));
var $2f512219da033f72$export$d921db77026b0ff1;
(function(CcpCreateEntitlementExperienceOptionsConfirmationScreen) {
    /** Show comparison screen for confirmation screen */ CcpCreateEntitlementExperienceOptionsConfirmationScreen["Comparison"] = "COMPARISON";
    /** Show default screen for confirmation screen */ CcpCreateEntitlementExperienceOptionsConfirmationScreen["Default"] = "DEFAULT";
})($2f512219da033f72$export$d921db77026b0ff1 || ($2f512219da033f72$export$d921db77026b0ff1 = {}));
var $2f512219da033f72$export$c0b393797b8a5dd1;
(function(CcpCurrency) {
    CcpCurrency["Jpy"] = "JPY";
    CcpCurrency["Usd"] = "USD";
})($2f512219da033f72$export$c0b393797b8a5dd1 || ($2f512219da033f72$export$c0b393797b8a5dd1 = {}));
var $2f512219da033f72$export$5f9edcd77bf8a9b9;
(function(CcpDuration) {
    CcpDuration["Forever"] = "FOREVER";
    CcpDuration["Once"] = "ONCE";
    CcpDuration["Repeating"] = "REPEATING";
})($2f512219da033f72$export$5f9edcd77bf8a9b9 || ($2f512219da033f72$export$5f9edcd77bf8a9b9 = {}));
var $2f512219da033f72$export$57f8dd5442590d31;
(function(CcpEntitlementPreDunningStatus) {
    CcpEntitlementPreDunningStatus["InPreDunning"] = "IN_PRE_DUNNING";
    CcpEntitlementPreDunningStatus["NotInPreDunning"] = "NOT_IN_PRE_DUNNING";
})($2f512219da033f72$export$57f8dd5442590d31 || ($2f512219da033f72$export$57f8dd5442590d31 = {}));
var $2f512219da033f72$export$21652ca36153879b;
(function(CcpEntitlementStatus) {
    CcpEntitlementStatus["Active"] = "ACTIVE";
    CcpEntitlementStatus["Inactive"] = "INACTIVE";
})($2f512219da033f72$export$21652ca36153879b || ($2f512219da033f72$export$21652ca36153879b = {}));
var $2f512219da033f72$export$e9dd9659ef9f0fb5;
(function(CcpOfferingHostingType) {
    CcpOfferingHostingType["Cloud"] = "CLOUD";
})($2f512219da033f72$export$e9dd9659ef9f0fb5 || ($2f512219da033f72$export$e9dd9659ef9f0fb5 = {}));
var $2f512219da033f72$export$a6e9989b075a8458;
(function(CcpOfferingStatus) {
    CcpOfferingStatus["Active"] = "ACTIVE";
    CcpOfferingStatus["AtNotice"] = "AT_NOTICE";
    CcpOfferingStatus["Draft"] = "DRAFT";
    CcpOfferingStatus["Expired"] = "EXPIRED";
})($2f512219da033f72$export$a6e9989b075a8458 || ($2f512219da033f72$export$a6e9989b075a8458 = {}));
var $2f512219da033f72$export$2ec95e801b135b6a;
(function(CcpOfferingType) {
    CcpOfferingType["Child"] = "CHILD";
    CcpOfferingType["Parent"] = "PARENT";
})($2f512219da033f72$export$2ec95e801b135b6a || ($2f512219da033f72$export$2ec95e801b135b6a = {}));
var $2f512219da033f72$export$60c062217a56cebb;
(function(CcpOfferingUncollectibleActionType) {
    CcpOfferingUncollectibleActionType["Cancel"] = "CANCEL";
    CcpOfferingUncollectibleActionType["Downgrade"] = "DOWNGRADE";
    CcpOfferingUncollectibleActionType["NoAction"] = "NO_ACTION";
})($2f512219da033f72$export$60c062217a56cebb || ($2f512219da033f72$export$60c062217a56cebb = {}));
var $2f512219da033f72$export$b1c315941e36715;
(function(CcpPricingPlanStatus) {
    CcpPricingPlanStatus["Active"] = "ACTIVE";
    CcpPricingPlanStatus["AtNotice"] = "AT_NOTICE";
    CcpPricingPlanStatus["Draft"] = "DRAFT";
    CcpPricingPlanStatus["Expired"] = "EXPIRED";
})($2f512219da033f72$export$b1c315941e36715 || ($2f512219da033f72$export$b1c315941e36715 = {}));
var $2f512219da033f72$export$c9b826d15992706b;
(function(CcpPricingType) {
    CcpPricingType["External"] = "EXTERNAL";
    CcpPricingType["Free"] = "FREE";
    CcpPricingType["LimitedFree"] = "LIMITED_FREE";
    CcpPricingType["Paid"] = "PAID";
})($2f512219da033f72$export$c9b826d15992706b || ($2f512219da033f72$export$c9b826d15992706b = {}));
var $2f512219da033f72$export$f654d8be32cce431;
(function(CcpProductStatus) {
    CcpProductStatus["Active"] = "ACTIVE";
    CcpProductStatus["AtNotice"] = "AT_NOTICE";
    CcpProductStatus["Draft"] = "DRAFT";
    CcpProductStatus["Expired"] = "EXPIRED";
})($2f512219da033f72$export$f654d8be32cce431 || ($2f512219da033f72$export$f654d8be32cce431 = {}));
var $2f512219da033f72$export$2b3bbef813bc7ddb;
(function(CcpProrateOnUsageChange) {
    CcpProrateOnUsageChange["AlwaysInvoice"] = "ALWAYS_INVOICE";
    CcpProrateOnUsageChange["CreateProrations"] = "CREATE_PRORATIONS";
    CcpProrateOnUsageChange["None"] = "NONE";
})($2f512219da033f72$export$2b3bbef813bc7ddb || ($2f512219da033f72$export$2b3bbef813bc7ddb = {}));
var $2f512219da033f72$export$bec7023af534df98;
(function(CcpRelationshipPricingType) {
    CcpRelationshipPricingType["AdvantagePricing"] = "ADVANTAGE_PRICING";
    CcpRelationshipPricingType["CurrencyGenerated"] = "CURRENCY_GENERATED";
    CcpRelationshipPricingType["NextPricing"] = "NEXT_PRICING";
    CcpRelationshipPricingType["SyntheticGenerated"] = "SYNTHETIC_GENERATED";
})($2f512219da033f72$export$bec7023af534df98 || ($2f512219da033f72$export$bec7023af534df98 = {}));
var $2f512219da033f72$export$d615304fed69e4cc;
(function(CcpRelationshipStatus) {
    CcpRelationshipStatus["Active"] = "ACTIVE";
    CcpRelationshipStatus["Deprecated"] = "DEPRECATED";
})($2f512219da033f72$export$d615304fed69e4cc || ($2f512219da033f72$export$d615304fed69e4cc = {}));
var $2f512219da033f72$export$946a9fb0cc42074a;
(function(CcpRelationshipType) {
    CcpRelationshipType["AddonDependence"] = "ADDON_DEPENDENCE";
    CcpRelationshipType["AppCompatibility"] = "APP_COMPATIBILITY";
    CcpRelationshipType["Collection"] = "COLLECTION";
    CcpRelationshipType["CollectionTrial"] = "COLLECTION_TRIAL";
    CcpRelationshipType["Enterprise"] = "ENTERPRISE";
    CcpRelationshipType["EnterpriseSandboxGrant"] = "ENTERPRISE_SANDBOX_GRANT";
    CcpRelationshipType["FamilyContainer"] = "FAMILY_CONTAINER";
    CcpRelationshipType["MultiInstance"] = "MULTI_INSTANCE";
    CcpRelationshipType["SandboxDependence"] = "SANDBOX_DEPENDENCE";
    CcpRelationshipType["SandboxGrant"] = "SANDBOX_GRANT";
})($2f512219da033f72$export$946a9fb0cc42074a || ($2f512219da033f72$export$946a9fb0cc42074a = {}));
var $2f512219da033f72$export$1597d868ca01d69;
(function(CcpSubscriptionScheduleAction) {
    CcpSubscriptionScheduleAction["Cancel"] = "CANCEL";
    CcpSubscriptionScheduleAction["Update"] = "UPDATE";
})($2f512219da033f72$export$1597d868ca01d69 || ($2f512219da033f72$export$1597d868ca01d69 = {}));
var $2f512219da033f72$export$dcee3eda38daaeab;
(function(CcpSubscriptionStatus) {
    CcpSubscriptionStatus["Active"] = "ACTIVE";
    CcpSubscriptionStatus["Cancelled"] = "CANCELLED";
    CcpSubscriptionStatus["Processing"] = "PROCESSING";
})($2f512219da033f72$export$dcee3eda38daaeab || ($2f512219da033f72$export$dcee3eda38daaeab = {}));
var $2f512219da033f72$export$30c9d4dfd26087be;
(function(CcpSupportedBillingSystems) {
    CcpSupportedBillingSystems["BackOffice"] = "BACK_OFFICE";
    CcpSupportedBillingSystems["Ccp"] = "CCP";
    CcpSupportedBillingSystems["Hams"] = "HAMS";
    CcpSupportedBillingSystems["Opsgenie"] = "OPSGENIE";
})($2f512219da033f72$export$30c9d4dfd26087be || ($2f512219da033f72$export$30c9d4dfd26087be = {}));
var $2f512219da033f72$export$55c02debb712e2db;
(function(CcpTiersMode) {
    CcpTiersMode["Graduated"] = "GRADUATED";
    CcpTiersMode["Volume"] = "VOLUME";
})($2f512219da033f72$export$55c02debb712e2db || ($2f512219da033f72$export$55c02debb712e2db = {}));
var $2f512219da033f72$export$cec1fe9fa75edecd;
(function(Classification) {
    Classification["Other"] = "other";
    Classification["Pii"] = "pii";
    Classification["Ugc"] = "ugc";
})($2f512219da033f72$export$cec1fe9fa75edecd || ($2f512219da033f72$export$cec1fe9fa75edecd = {}));
var $2f512219da033f72$export$ada0032275d8af60;
(function(ClassificationLevelSource) {
    ClassificationLevelSource["Content"] = "CONTENT";
    ClassificationLevelSource["Organization"] = "ORGANIZATION";
    ClassificationLevelSource["Space"] = "SPACE";
})($2f512219da033f72$export$ada0032275d8af60 || ($2f512219da033f72$export$ada0032275d8af60 = {}));
var $2f512219da033f72$export$e0a3d3232b4dfb12;
(function(CollabFormat) {
    CollabFormat["Adf"] = "ADF";
    CollabFormat["Pm"] = "PM";
})($2f512219da033f72$export$e0a3d3232b4dfb12 || ($2f512219da033f72$export$e0a3d3232b4dfb12 = {}));
var $2f512219da033f72$export$cdccd0683766be81;
(function(CommentCreationLocation) {
    CommentCreationLocation["Database"] = "DATABASE";
    CommentCreationLocation["Editor"] = "EDITOR";
    CommentCreationLocation["Live"] = "LIVE";
    CommentCreationLocation["Renderer"] = "RENDERER";
    CommentCreationLocation["Whiteboard"] = "WHITEBOARD";
})($2f512219da033f72$export$cdccd0683766be81 || ($2f512219da033f72$export$cdccd0683766be81 = {}));
var $2f512219da033f72$export$26bc7a3bb70e176c;
(function(CommentDeletionLocation) {
    CommentDeletionLocation["Editor"] = "EDITOR";
    CommentDeletionLocation["Live"] = "LIVE";
})($2f512219da033f72$export$26bc7a3bb70e176c || ($2f512219da033f72$export$26bc7a3bb70e176c = {}));
var $2f512219da033f72$export$faa6868f5a841c36;
(function(CommentReplyType) {
    CommentReplyType["Emoji"] = "EMOJI";
    CommentReplyType["Prompt"] = "PROMPT";
    CommentReplyType["QuickReply"] = "QUICK_REPLY";
})($2f512219da033f72$export$faa6868f5a841c36 || ($2f512219da033f72$export$faa6868f5a841c36 = {}));
var $2f512219da033f72$export$ffa1150e6a48f9cd;
(function(CommentType) {
    CommentType["Footer"] = "FOOTER";
    CommentType["Inline"] = "INLINE";
    CommentType["Resolved"] = "RESOLVED";
    CommentType["Unresolved"] = "UNRESOLVED";
})($2f512219da033f72$export$ffa1150e6a48f9cd || ($2f512219da033f72$export$ffa1150e6a48f9cd = {}));
var $2f512219da033f72$export$46ebd93a1a0d445e;
(function(CommentsDigestResponseType) {
    CommentsDigestResponseType["Json"] = "JSON";
    CommentsDigestResponseType["PlainText"] = "PLAIN_TEXT";
})($2f512219da033f72$export$46ebd93a1a0d445e || ($2f512219da033f72$export$46ebd93a1a0d445e = {}));
var $2f512219da033f72$export$e9466e0faeadf399;
(function(CommentsType) {
    CommentsType["Footer"] = "FOOTER";
    CommentsType["Inline"] = "INLINE";
})($2f512219da033f72$export$e9466e0faeadf399 || ($2f512219da033f72$export$e9466e0faeadf399 = {}));
var $2f512219da033f72$export$998d732c1030d8c;
(function(CompassBuildEventState) {
    CompassBuildEventState["Cancelled"] = "CANCELLED";
    CompassBuildEventState["Error"] = "ERROR";
    CompassBuildEventState["Failed"] = "FAILED";
    CompassBuildEventState["InProgress"] = "IN_PROGRESS";
    CompassBuildEventState["Successful"] = "SUCCESSFUL";
    CompassBuildEventState["TimedOut"] = "TIMED_OUT";
    CompassBuildEventState["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$998d732c1030d8c || ($2f512219da033f72$export$998d732c1030d8c = {}));
var $2f512219da033f72$export$b18beaf85a2196b5;
(function(CompassCampaignQuerySortOrder) {
    CompassCampaignQuerySortOrder["Asc"] = "ASC";
    CompassCampaignQuerySortOrder["Desc"] = "DESC";
})($2f512219da033f72$export$b18beaf85a2196b5 || ($2f512219da033f72$export$b18beaf85a2196b5 = {}));
var $2f512219da033f72$export$903f60c2a3adb98a;
(function(CompassComponentCreationTimeFilterType) {
    CompassComponentCreationTimeFilterType["After"] = "AFTER";
    CompassComponentCreationTimeFilterType["Before"] = "BEFORE";
})($2f512219da033f72$export$903f60c2a3adb98a || ($2f512219da033f72$export$903f60c2a3adb98a = {}));
var $2f512219da033f72$export$dbf96ee31a2e1415;
(function(CompassComponentType) {
    /** A standalone software artifact that is directly consumable by an end-user. */ CompassComponentType["Application"] = "APPLICATION";
    /** A standalone software artifact that provides some functionality for other software via embedding. */ CompassComponentType["Library"] = "LIBRARY";
    /** A software artifact that does not fit into the pre-defined categories. */ CompassComponentType["Other"] = "OTHER";
    /** A software artifact that provides some functionality for other software over the network. */ CompassComponentType["Service"] = "SERVICE";
})($2f512219da033f72$export$dbf96ee31a2e1415 || ($2f512219da033f72$export$dbf96ee31a2e1415 = {}));
var $2f512219da033f72$export$ad2a5e42be992de9;
(function(CompassCreatePullRequestStatus) {
    CompassCreatePullRequestStatus["Created"] = "CREATED";
    CompassCreatePullRequestStatus["InReview"] = "IN_REVIEW";
    CompassCreatePullRequestStatus["Merged"] = "MERGED";
    CompassCreatePullRequestStatus["Rejected"] = "REJECTED";
})($2f512219da033f72$export$ad2a5e42be992de9 || ($2f512219da033f72$export$ad2a5e42be992de9 = {}));
var $2f512219da033f72$export$ec0d5c1fa3218a83;
(function(CompassCriteriaBooleanComparatorOptions) {
    CompassCriteriaBooleanComparatorOptions["Equals"] = "EQUALS";
})($2f512219da033f72$export$ec0d5c1fa3218a83 || ($2f512219da033f72$export$ec0d5c1fa3218a83 = {}));
var $2f512219da033f72$export$e387eb9a14a2773b;
(function(CompassCriteriaCollectionComparatorOptions) {
    CompassCriteriaCollectionComparatorOptions["AllOf"] = "ALL_OF";
    CompassCriteriaCollectionComparatorOptions["AnyOf"] = "ANY_OF";
    CompassCriteriaCollectionComparatorOptions["NoneOf"] = "NONE_OF";
})($2f512219da033f72$export$e387eb9a14a2773b || ($2f512219da033f72$export$e387eb9a14a2773b = {}));
var $2f512219da033f72$export$9597031f08feb1bc;
(function(CompassCriteriaMembershipComparatorOptions) {
    CompassCriteriaMembershipComparatorOptions["In"] = "IN";
    CompassCriteriaMembershipComparatorOptions["NotIn"] = "NOT_IN";
})($2f512219da033f72$export$9597031f08feb1bc || ($2f512219da033f72$export$9597031f08feb1bc = {}));
var $2f512219da033f72$export$8a8b436a51cf3b62;
(function(CompassCriteriaNumberComparatorOptions) {
    CompassCriteriaNumberComparatorOptions["Equals"] = "EQUALS";
    CompassCriteriaNumberComparatorOptions["GreaterThan"] = "GREATER_THAN";
    CompassCriteriaNumberComparatorOptions["GreaterThanOrEqualTo"] = "GREATER_THAN_OR_EQUAL_TO";
    CompassCriteriaNumberComparatorOptions["LessThan"] = "LESS_THAN";
    CompassCriteriaNumberComparatorOptions["LessThanOrEqualTo"] = "LESS_THAN_OR_EQUAL_TO";
})($2f512219da033f72$export$8a8b436a51cf3b62 || ($2f512219da033f72$export$8a8b436a51cf3b62 = {}));
var $2f512219da033f72$export$b7f3ac0d38937afa;
(function(CompassCriteriaTextComparatorOptions) {
    CompassCriteriaTextComparatorOptions["IsPresent"] = "IS_PRESENT";
    CompassCriteriaTextComparatorOptions["MatchesRegex"] = "MATCHES_REGEX";
})($2f512219da033f72$export$b7f3ac0d38937afa || ($2f512219da033f72$export$b7f3ac0d38937afa = {}));
var $2f512219da033f72$export$ce4ce86422cc81d0;
(function(CompassCustomEventIcon) {
    CompassCustomEventIcon["Checkpoint"] = "CHECKPOINT";
    CompassCustomEventIcon["Info"] = "INFO";
    CompassCustomEventIcon["Warning"] = "WARNING";
})($2f512219da033f72$export$ce4ce86422cc81d0 || ($2f512219da033f72$export$ce4ce86422cc81d0 = {}));
var $2f512219da033f72$export$43cacf9c2c9c2a10;
(function(CompassCustomPermissionPreset) {
    /** Restrictive option which only permits product admins and owners to create/edit/delete, which vary depending on entity, i.e. component */ CompassCustomPermissionPreset["AdminsAndOwners"] = "ADMINS_AND_OWNERS";
    /** Default option which permits the owner team, as well as all teams and roles. */ CompassCustomPermissionPreset["Default"] = "DEFAULT";
})($2f512219da033f72$export$43cacf9c2c9c2a10 || ($2f512219da033f72$export$43cacf9c2c9c2a10 = {}));
var $2f512219da033f72$export$15c39df7a190a18a;
(function(CompassDeploymentEventEnvironmentCategory) {
    CompassDeploymentEventEnvironmentCategory["Development"] = "DEVELOPMENT";
    CompassDeploymentEventEnvironmentCategory["Production"] = "PRODUCTION";
    CompassDeploymentEventEnvironmentCategory["Staging"] = "STAGING";
    CompassDeploymentEventEnvironmentCategory["Testing"] = "TESTING";
    CompassDeploymentEventEnvironmentCategory["Unmapped"] = "UNMAPPED";
})($2f512219da033f72$export$15c39df7a190a18a || ($2f512219da033f72$export$15c39df7a190a18a = {}));
var $2f512219da033f72$export$43d1deedebbbaa4e;
(function(CompassDeploymentEventState) {
    CompassDeploymentEventState["Cancelled"] = "CANCELLED";
    CompassDeploymentEventState["Failed"] = "FAILED";
    CompassDeploymentEventState["InProgress"] = "IN_PROGRESS";
    CompassDeploymentEventState["Pending"] = "PENDING";
    CompassDeploymentEventState["RolledBack"] = "ROLLED_BACK";
    CompassDeploymentEventState["Successful"] = "SUCCESSFUL";
    CompassDeploymentEventState["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$43d1deedebbbaa4e || ($2f512219da033f72$export$43d1deedebbbaa4e = {}));
var $2f512219da033f72$export$155351532e5d1b9f;
(function(CompassEventType) {
    CompassEventType["Alert"] = "ALERT";
    CompassEventType["Build"] = "BUILD";
    CompassEventType["Custom"] = "CUSTOM";
    CompassEventType["Deployment"] = "DEPLOYMENT";
    CompassEventType["Flag"] = "FLAG";
    CompassEventType["Incident"] = "INCIDENT";
    CompassEventType["Lifecycle"] = "LIFECYCLE";
    CompassEventType["PullRequest"] = "PULL_REQUEST";
    CompassEventType["Push"] = "PUSH";
    CompassEventType["Vulnerability"] = "VULNERABILITY";
})($2f512219da033f72$export$155351532e5d1b9f || ($2f512219da033f72$export$155351532e5d1b9f = {}));
var $2f512219da033f72$export$5ba534b6379276b;
(function(CompassFieldType) {
    CompassFieldType["Boolean"] = "BOOLEAN";
    CompassFieldType["Date"] = "DATE";
    CompassFieldType["Enum"] = "ENUM";
    CompassFieldType["Number"] = "NUMBER";
    CompassFieldType["Text"] = "TEXT";
})($2f512219da033f72$export$5ba534b6379276b || ($2f512219da033f72$export$5ba534b6379276b = {}));
var $2f512219da033f72$export$9a02db1f2decc63;
(function(CompassIncidentEventSeverityLevel) {
    CompassIncidentEventSeverityLevel["Five"] = "FIVE";
    CompassIncidentEventSeverityLevel["Four"] = "FOUR";
    CompassIncidentEventSeverityLevel["One"] = "ONE";
    CompassIncidentEventSeverityLevel["Three"] = "THREE";
    CompassIncidentEventSeverityLevel["Two"] = "TWO";
})($2f512219da033f72$export$9a02db1f2decc63 || ($2f512219da033f72$export$9a02db1f2decc63 = {}));
var $2f512219da033f72$export$f8b82012c65b70c9;
(function(CompassIncidentEventState) {
    CompassIncidentEventState["Deleted"] = "DELETED";
    CompassIncidentEventState["Open"] = "OPEN";
    CompassIncidentEventState["Resolved"] = "RESOLVED";
})($2f512219da033f72$export$f8b82012c65b70c9 || ($2f512219da033f72$export$f8b82012c65b70c9 = {}));
var $2f512219da033f72$export$4366f17562f80ce7;
(function(CompassLifecycleEventStage) {
    CompassLifecycleEventStage["Deprecation"] = "DEPRECATION";
    CompassLifecycleEventStage["EndOfLife"] = "END_OF_LIFE";
    CompassLifecycleEventStage["PreRelease"] = "PRE_RELEASE";
    CompassLifecycleEventStage["Production"] = "PRODUCTION";
})($2f512219da033f72$export$4366f17562f80ce7 || ($2f512219da033f72$export$4366f17562f80ce7 = {}));
var $2f512219da033f72$export$e01fe70cc554ac5d;
(function(CompassLifecycleFilterOperator) {
    CompassLifecycleFilterOperator["Nor"] = "NOR";
    CompassLifecycleFilterOperator["Or"] = "OR";
})($2f512219da033f72$export$e01fe70cc554ac5d || ($2f512219da033f72$export$e01fe70cc554ac5d = {}));
var $2f512219da033f72$export$56307b64f049eb43;
(function(CompassLinkType) {
    /** Chat Channels for contacting the owners/support of the component */ CompassLinkType["ChatChannel"] = "CHAT_CHANNEL";
    /** A link to the dashboard of the component. */ CompassLinkType["Dashboard"] = "DASHBOARD";
    /**
   * A link to the documentation of the component.
   * @deprecated Documents should be created with the documentation API
   */ CompassLinkType["Document"] = "DOCUMENT";
    /** A link to the on-call schedule of the component. */ CompassLinkType["OnCall"] = "ON_CALL";
    /** Other link for a Component. */ CompassLinkType["OtherLink"] = "OTHER_LINK";
    /** A link to the Jira or third-party project of the component. */ CompassLinkType["Project"] = "PROJECT";
    /** A link to the source code repository of the component. */ CompassLinkType["Repository"] = "REPOSITORY";
})($2f512219da033f72$export$56307b64f049eb43 || ($2f512219da033f72$export$56307b64f049eb43 = {}));
var $2f512219da033f72$export$270abbff10f02537;
(function(CompassMetricDefinitionType) {
    /** Predefined metrics built in to Compass */ CompassMetricDefinitionType["BuiltIn"] = "BUILT_IN";
    /** Metrics defined by the individual user */ CompassMetricDefinitionType["Custom"] = "CUSTOM";
})($2f512219da033f72$export$270abbff10f02537 || ($2f512219da033f72$export$270abbff10f02537 = {}));
var $2f512219da033f72$export$7a6755e08e21a7bd;
(function(CompassPullRequestQuerySortName) {
    /** The time between a PR's created and merged or rejected state. */ CompassPullRequestQuerySortName["CycleTime"] = "CYCLE_TIME";
    CompassPullRequestQuerySortName["OpenToFirstReview"] = "OPEN_TO_FIRST_REVIEW";
    CompassPullRequestQuerySortName["PrClosedTime"] = "PR_CLOSED_TIME";
    CompassPullRequestQuerySortName["PrCreatedTime"] = "PR_CREATED_TIME";
    /** The time between a PR's first reviewed and last reviewed timestamps. */ CompassPullRequestQuerySortName["ReviewTime"] = "REVIEW_TIME";
})($2f512219da033f72$export$7a6755e08e21a7bd || ($2f512219da033f72$export$7a6755e08e21a7bd = {}));
var $2f512219da033f72$export$d5ddc46f2d03ff56;
(function(CompassPullRequestStatus) {
    CompassPullRequestStatus["Created"] = "CREATED";
    CompassPullRequestStatus["FirstReviewed"] = "FIRST_REVIEWED";
    CompassPullRequestStatus["Merged"] = "MERGED";
    CompassPullRequestStatus["Overdue"] = "OVERDUE";
    CompassPullRequestStatus["Rejected"] = "REJECTED";
})($2f512219da033f72$export$d5ddc46f2d03ff56 || ($2f512219da033f72$export$d5ddc46f2d03ff56 = {}));
var $2f512219da033f72$export$6a1e195288b23c05;
(function(CompassPullRequestStatusForStatusInTimeRangeFilter) {
    CompassPullRequestStatusForStatusInTimeRangeFilter["Created"] = "CREATED";
    CompassPullRequestStatusForStatusInTimeRangeFilter["FirstReviewed"] = "FIRST_REVIEWED";
    CompassPullRequestStatusForStatusInTimeRangeFilter["Merged"] = "MERGED";
    CompassPullRequestStatusForStatusInTimeRangeFilter["Rejected"] = "REJECTED";
})($2f512219da033f72$export$6a1e195288b23c05 || ($2f512219da033f72$export$6a1e195288b23c05 = {}));
var $2f512219da033f72$export$94d43384cf172d05;
(function(CompassQuerySortOrder) {
    CompassQuerySortOrder["Asc"] = "ASC";
    CompassQuerySortOrder["Desc"] = "DESC";
})($2f512219da033f72$export$94d43384cf172d05 || ($2f512219da033f72$export$94d43384cf172d05 = {}));
var $2f512219da033f72$export$c8e6de4296189e26;
(function(CompassRelationshipDirection) {
    /** Going from the other component to this component. */ CompassRelationshipDirection["Inward"] = "INWARD";
    /** Going from this component to the other component. */ CompassRelationshipDirection["Outward"] = "OUTWARD";
})($2f512219da033f72$export$c8e6de4296189e26 || ($2f512219da033f72$export$c8e6de4296189e26 = {}));
var $2f512219da033f72$export$2a274d082ac90bb0;
(function(CompassRelationshipType) {
    CompassRelationshipType["DependsOn"] = "DEPENDS_ON";
})($2f512219da033f72$export$2a274d082ac90bb0 || ($2f512219da033f72$export$2a274d082ac90bb0 = {}));
var $2f512219da033f72$export$854cc3c30987ee51;
(function(CompassScorecardCriteriaScoreHistoryPeriodicity) {
    CompassScorecardCriteriaScoreHistoryPeriodicity["Daily"] = "DAILY";
    CompassScorecardCriteriaScoreHistoryPeriodicity["Weekly"] = "WEEKLY";
})($2f512219da033f72$export$854cc3c30987ee51 || ($2f512219da033f72$export$854cc3c30987ee51 = {}));
var $2f512219da033f72$export$742385f55bd1cd4c;
(function(CompassScorecardCriteriaScoringStrategyRuleAction) {
    CompassScorecardCriteriaScoringStrategyRuleAction["MarkAsError"] = "MARK_AS_ERROR";
    CompassScorecardCriteriaScoringStrategyRuleAction["MarkAsFailed"] = "MARK_AS_FAILED";
    CompassScorecardCriteriaScoringStrategyRuleAction["MarkAsPassed"] = "MARK_AS_PASSED";
    CompassScorecardCriteriaScoringStrategyRuleAction["MarkAsSkipped"] = "MARK_AS_SKIPPED";
})($2f512219da033f72$export$742385f55bd1cd4c || ($2f512219da033f72$export$742385f55bd1cd4c = {}));
var $2f512219da033f72$export$bf3ba69a1c03451c;
(function(CompassScorecardCriterionExpressionBooleanComparatorOptions) {
    CompassScorecardCriterionExpressionBooleanComparatorOptions["EqualTo"] = "EQUAL_TO";
    CompassScorecardCriterionExpressionBooleanComparatorOptions["NotEqualTo"] = "NOT_EQUAL_TO";
})($2f512219da033f72$export$bf3ba69a1c03451c || ($2f512219da033f72$export$bf3ba69a1c03451c = {}));
var $2f512219da033f72$export$e062d8c6934091a0;
(function(CompassScorecardCriterionExpressionCollectionComparatorOptions) {
    CompassScorecardCriterionExpressionCollectionComparatorOptions["AllOf"] = "ALL_OF";
    CompassScorecardCriterionExpressionCollectionComparatorOptions["AnyOf"] = "ANY_OF";
    CompassScorecardCriterionExpressionCollectionComparatorOptions["NoneOf"] = "NONE_OF";
})($2f512219da033f72$export$e062d8c6934091a0 || ($2f512219da033f72$export$e062d8c6934091a0 = {}));
var $2f512219da033f72$export$585900ca87936e49;
(function(CompassScorecardCriterionExpressionEvaluationRuleAction) {
    CompassScorecardCriterionExpressionEvaluationRuleAction["Continue"] = "CONTINUE";
    CompassScorecardCriterionExpressionEvaluationRuleAction["ReturnError"] = "RETURN_ERROR";
    CompassScorecardCriterionExpressionEvaluationRuleAction["ReturnFailed"] = "RETURN_FAILED";
    CompassScorecardCriterionExpressionEvaluationRuleAction["ReturnPassed"] = "RETURN_PASSED";
    CompassScorecardCriterionExpressionEvaluationRuleAction["ReturnSkipped"] = "RETURN_SKIPPED";
})($2f512219da033f72$export$585900ca87936e49 || ($2f512219da033f72$export$585900ca87936e49 = {}));
var $2f512219da033f72$export$4f85753d37a00b44;
(function(CompassScorecardCriterionExpressionMembershipComparatorOptions) {
    CompassScorecardCriterionExpressionMembershipComparatorOptions["In"] = "IN";
    CompassScorecardCriterionExpressionMembershipComparatorOptions["NotIn"] = "NOT_IN";
})($2f512219da033f72$export$4f85753d37a00b44 || ($2f512219da033f72$export$4f85753d37a00b44 = {}));
var $2f512219da033f72$export$b161fd9f9f7ba9ea;
(function(CompassScorecardCriterionExpressionNumberComparatorOptions) {
    CompassScorecardCriterionExpressionNumberComparatorOptions["EqualTo"] = "EQUAL_TO";
    CompassScorecardCriterionExpressionNumberComparatorOptions["GreaterThan"] = "GREATER_THAN";
    CompassScorecardCriterionExpressionNumberComparatorOptions["GreaterThanOrEqualTo"] = "GREATER_THAN_OR_EQUAL_TO";
    CompassScorecardCriterionExpressionNumberComparatorOptions["LessThan"] = "LESS_THAN";
    CompassScorecardCriterionExpressionNumberComparatorOptions["LessThanOrEqualTo"] = "LESS_THAN_OR_EQUAL_TO";
    CompassScorecardCriterionExpressionNumberComparatorOptions["NotEqualTo"] = "NOT_EQUAL_TO";
})($2f512219da033f72$export$b161fd9f9f7ba9ea || ($2f512219da033f72$export$b161fd9f9f7ba9ea = {}));
var $2f512219da033f72$export$e0536272da42a911;
(function(CompassScorecardCriterionExpressionTextComparatorOptions) {
    CompassScorecardCriterionExpressionTextComparatorOptions["EqualTo"] = "EQUAL_TO";
    CompassScorecardCriterionExpressionTextComparatorOptions["NotEqualTo"] = "NOT_EQUAL_TO";
    CompassScorecardCriterionExpressionTextComparatorOptions["Regex"] = "REGEX";
})($2f512219da033f72$export$e0536272da42a911 || ($2f512219da033f72$export$e0536272da42a911 = {}));
var $2f512219da033f72$export$8f487531178b2612;
(function(CompassScorecardImportance) {
    /** Recommended to the component's owner when they select a scorecard to apply to their component. */ CompassScorecardImportance["Recommended"] = "RECOMMENDED";
    /** Automatically applied to all components of the specified type or types and cannot be removed. */ CompassScorecardImportance["Required"] = "REQUIRED";
    /** Custom scorecard, focused on specific use cases within teams or departments. */ CompassScorecardImportance["UserDefined"] = "USER_DEFINED";
})($2f512219da033f72$export$8f487531178b2612 || ($2f512219da033f72$export$8f487531178b2612 = {}));
var $2f512219da033f72$export$edfe0f1e34848d09;
(function(CompassScorecardQuerySortOrder) {
    CompassScorecardQuerySortOrder["Asc"] = "ASC";
    CompassScorecardQuerySortOrder["Desc"] = "DESC";
})($2f512219da033f72$export$edfe0f1e34848d09 || ($2f512219da033f72$export$edfe0f1e34848d09 = {}));
var $2f512219da033f72$export$ac226c775361dae9;
(function(CompassScorecardScoreHistoryPeriodicity) {
    CompassScorecardScoreHistoryPeriodicity["Daily"] = "DAILY";
    CompassScorecardScoreHistoryPeriodicity["Weekly"] = "WEEKLY";
})($2f512219da033f72$export$ac226c775361dae9 || ($2f512219da033f72$export$ac226c775361dae9 = {}));
var $2f512219da033f72$export$f073cd3745c42272;
(function(CompassScorecardScoringStrategyType) {
    CompassScorecardScoringStrategyType["PercentageBased"] = "PERCENTAGE_BASED";
    CompassScorecardScoringStrategyType["PointBased"] = "POINT_BASED";
    CompassScorecardScoringStrategyType["WeightBased"] = "WEIGHT_BASED";
})($2f512219da033f72$export$f073cd3745c42272 || ($2f512219da033f72$export$f073cd3745c42272 = {}));
var $2f512219da033f72$export$68f18a6f081a15ae;
(function(CompassVulnerabilityEventSeverityLevel) {
    CompassVulnerabilityEventSeverityLevel["Critical"] = "CRITICAL";
    CompassVulnerabilityEventSeverityLevel["High"] = "HIGH";
    CompassVulnerabilityEventSeverityLevel["Low"] = "LOW";
    CompassVulnerabilityEventSeverityLevel["Medium"] = "MEDIUM";
})($2f512219da033f72$export$68f18a6f081a15ae || ($2f512219da033f72$export$68f18a6f081a15ae = {}));
var $2f512219da033f72$export$a9a10726b2721d81;
(function(CompassVulnerabilityEventState) {
    CompassVulnerabilityEventState["Declined"] = "DECLINED";
    CompassVulnerabilityEventState["Open"] = "OPEN";
    CompassVulnerabilityEventState["Remediated"] = "REMEDIATED";
})($2f512219da033f72$export$a9a10726b2721d81 || ($2f512219da033f72$export$a9a10726b2721d81 = {}));
var $2f512219da033f72$export$f1221e641dc6f3ef;
(function(ComponentSyncEventStatus) {
    /** A Compass internal server issue prevented the sync from occurring. */ ComponentSyncEventStatus["ServerError"] = "SERVER_ERROR";
    /** The component updates were successfully synced to Compass. */ ComponentSyncEventStatus["Success"] = "SUCCESS";
    /** An issue with the calling app or user input prevented the component from syncing to Compass. */ ComponentSyncEventStatus["UserError"] = "USER_ERROR";
})($2f512219da033f72$export$f1221e641dc6f3ef || ($2f512219da033f72$export$f1221e641dc6f3ef = {}));
var $2f512219da033f72$export$87e61d6b6781860f;
(function(ConfluenceAdminAnnouncementBannerStatusType) {
    ConfluenceAdminAnnouncementBannerStatusType["Published"] = "PUBLISHED";
    ConfluenceAdminAnnouncementBannerStatusType["Saved"] = "SAVED";
    ConfluenceAdminAnnouncementBannerStatusType["Scheduled"] = "SCHEDULED";
})($2f512219da033f72$export$87e61d6b6781860f || ($2f512219da033f72$export$87e61d6b6781860f = {}));
var $2f512219da033f72$export$d7bd60e8119936bb;
(function(ConfluenceAdminAnnouncementBannerVisibilityType) {
    ConfluenceAdminAnnouncementBannerVisibilityType["All"] = "ALL";
    ConfluenceAdminAnnouncementBannerVisibilityType["Authorized"] = "AUTHORIZED";
})($2f512219da033f72$export$d7bd60e8119936bb || ($2f512219da033f72$export$d7bd60e8119936bb = {}));
var $2f512219da033f72$export$f2d20e136929adb;
(function(ConfluenceBlogPostStatus) {
    ConfluenceBlogPostStatus["Archived"] = "ARCHIVED";
    ConfluenceBlogPostStatus["Current"] = "CURRENT";
    ConfluenceBlogPostStatus["Deleted"] = "DELETED";
    ConfluenceBlogPostStatus["Draft"] = "DRAFT";
    ConfluenceBlogPostStatus["Historical"] = "HISTORICAL";
    ConfluenceBlogPostStatus["Trashed"] = "TRASHED";
})($2f512219da033f72$export$f2d20e136929adb || ($2f512219da033f72$export$f2d20e136929adb = {}));
var $2f512219da033f72$export$92fbeeae7bfc11f8;
(function(ConfluenceBodyRepresentation) {
    ConfluenceBodyRepresentation["AnonymousExportView"] = "ANONYMOUS_EXPORT_VIEW";
    ConfluenceBodyRepresentation["AtlasDocFormat"] = "ATLAS_DOC_FORMAT";
    ConfluenceBodyRepresentation["Dynamic"] = "DYNAMIC";
    ConfluenceBodyRepresentation["Editor"] = "EDITOR";
    ConfluenceBodyRepresentation["Editor2"] = "EDITOR2";
    ConfluenceBodyRepresentation["ExportView"] = "EXPORT_VIEW";
    ConfluenceBodyRepresentation["Storage"] = "STORAGE";
    ConfluenceBodyRepresentation["StyledView"] = "STYLED_VIEW";
    ConfluenceBodyRepresentation["View"] = "VIEW";
    ConfluenceBodyRepresentation["WhiteboardDocFormat"] = "WHITEBOARD_DOC_FORMAT";
})($2f512219da033f72$export$92fbeeae7bfc11f8 || ($2f512219da033f72$export$92fbeeae7bfc11f8 = {}));
var $2f512219da033f72$export$c0eb639b68d4388a;
(function(ConfluenceCollaborativeEditingService) {
    ConfluenceCollaborativeEditingService["Ncs"] = "NCS";
    ConfluenceCollaborativeEditingService["Synchrony"] = "SYNCHRONY";
})($2f512219da033f72$export$c0eb639b68d4388a || ($2f512219da033f72$export$c0eb639b68d4388a = {}));
var $2f512219da033f72$export$40c6e21853446237;
(function(ConfluenceCommentState) {
    ConfluenceCommentState["Resolved"] = "RESOLVED";
    ConfluenceCommentState["Unresolved"] = "UNRESOLVED";
})($2f512219da033f72$export$40c6e21853446237 || ($2f512219da033f72$export$40c6e21853446237 = {}));
var $2f512219da033f72$export$33f6fe4ae00b4df5;
(function(ConfluenceCommentStatus) {
    ConfluenceCommentStatus["Current"] = "CURRENT";
    ConfluenceCommentStatus["Draft"] = "DRAFT";
})($2f512219da033f72$export$33f6fe4ae00b4df5 || ($2f512219da033f72$export$33f6fe4ae00b4df5 = {}));
var $2f512219da033f72$export$6fc7e2bddad2dec7;
(function(ConfluenceCommentType) {
    ConfluenceCommentType["Footer"] = "FOOTER";
    ConfluenceCommentType["Inline"] = "INLINE";
})($2f512219da033f72$export$6fc7e2bddad2dec7 || ($2f512219da033f72$export$6fc7e2bddad2dec7 = {}));
var $2f512219da033f72$export$7ba61dc1e5005a2;
(function(ConfluenceContentRepresentation) {
    ConfluenceContentRepresentation["AtlasDocFormat"] = "ATLAS_DOC_FORMAT";
    ConfluenceContentRepresentation["Editor"] = "EDITOR";
    ConfluenceContentRepresentation["Editor2"] = "EDITOR2";
    ConfluenceContentRepresentation["ExportView"] = "EXPORT_VIEW";
    ConfluenceContentRepresentation["Plain"] = "PLAIN";
    ConfluenceContentRepresentation["Raw"] = "RAW";
    ConfluenceContentRepresentation["Storage"] = "STORAGE";
    ConfluenceContentRepresentation["StyledView"] = "STYLED_VIEW";
    ConfluenceContentRepresentation["View"] = "VIEW";
    ConfluenceContentRepresentation["Wiki"] = "WIKI";
})($2f512219da033f72$export$7ba61dc1e5005a2 || ($2f512219da033f72$export$7ba61dc1e5005a2 = {}));
var $2f512219da033f72$export$98ac9eece9e68319;
(function(ConfluenceContentType) {
    ConfluenceContentType["Attachment"] = "ATTACHMENT";
    ConfluenceContentType["BlogPost"] = "BLOG_POST";
    ConfluenceContentType["Comment"] = "COMMENT";
    ConfluenceContentType["Page"] = "PAGE";
    ConfluenceContentType["Whiteboard"] = "WHITEBOARD";
})($2f512219da033f72$export$98ac9eece9e68319 || ($2f512219da033f72$export$98ac9eece9e68319 = {}));
var $2f512219da033f72$export$353a51d90d6c94b7;
(function(ConfluenceContributionStatus) {
    ConfluenceContributionStatus["Current"] = "CURRENT";
    ConfluenceContributionStatus["Draft"] = "DRAFT";
    ConfluenceContributionStatus["Unknown"] = "UNKNOWN";
    ConfluenceContributionStatus["Unpublished"] = "UNPUBLISHED";
})($2f512219da033f72$export$353a51d90d6c94b7 || ($2f512219da033f72$export$353a51d90d6c94b7 = {}));
var $2f512219da033f72$export$68577d543b14ae02;
(function(ConfluenceEdition) {
    ConfluenceEdition["Free"] = "FREE";
    ConfluenceEdition["Premium"] = "PREMIUM";
    ConfluenceEdition["Standard"] = "STANDARD";
})($2f512219da033f72$export$68577d543b14ae02 || ($2f512219da033f72$export$68577d543b14ae02 = {}));
var $2f512219da033f72$export$d9c59fb36f888de3;
(function(ConfluenceInlineCommentResolutionStatus) {
    ConfluenceInlineCommentResolutionStatus["Resolved"] = "RESOLVED";
    ConfluenceInlineCommentResolutionStatus["Unresolved"] = "UNRESOLVED";
})($2f512219da033f72$export$d9c59fb36f888de3 || ($2f512219da033f72$export$d9c59fb36f888de3 = {}));
var $2f512219da033f72$export$d6dc66c7e58b1f27;
(function(ConfluenceInlineTaskStatus) {
    ConfluenceInlineTaskStatus["Complete"] = "COMPLETE";
    ConfluenceInlineTaskStatus["Incomplete"] = "INCOMPLETE";
})($2f512219da033f72$export$d6dc66c7e58b1f27 || ($2f512219da033f72$export$d6dc66c7e58b1f27 = {}));
var $2f512219da033f72$export$55cdc784c43406a6;
(function(ConfluenceLegacyAccessStatus) {
    ConfluenceLegacyAccessStatus["AnonymousAccess"] = "ANONYMOUS_ACCESS";
    ConfluenceLegacyAccessStatus["ExternalCollaboratorAccess"] = "EXTERNAL_COLLABORATOR_ACCESS";
    ConfluenceLegacyAccessStatus["ExternalShareAccess"] = "EXTERNAL_SHARE_ACCESS";
    ConfluenceLegacyAccessStatus["LicensedAdminAccess"] = "LICENSED_ADMIN_ACCESS";
    ConfluenceLegacyAccessStatus["LicensedUseAccess"] = "LICENSED_USE_ACCESS";
    ConfluenceLegacyAccessStatus["NotPermitted"] = "NOT_PERMITTED";
    ConfluenceLegacyAccessStatus["UnlicensedAuthenticatedAccess"] = "UNLICENSED_AUTHENTICATED_ACCESS";
})($2f512219da033f72$export$55cdc784c43406a6 || ($2f512219da033f72$export$55cdc784c43406a6 = {}));
var $2f512219da033f72$export$6fb100d84dc744ee;
(function(ConfluenceLegacyAccessType) {
    ConfluenceLegacyAccessType["Edit"] = "EDIT";
    ConfluenceLegacyAccessType["View"] = "VIEW";
})($2f512219da033f72$export$6fb100d84dc744ee || ($2f512219da033f72$export$6fb100d84dc744ee = {}));
var $2f512219da033f72$export$f94f4d758ab56d24;
(function(ConfluenceLegacyAccountType) {
    ConfluenceLegacyAccountType["App"] = "APP";
    ConfluenceLegacyAccountType["Atlassian"] = "ATLASSIAN";
    ConfluenceLegacyAccountType["Customer"] = "CUSTOMER";
    ConfluenceLegacyAccountType["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$f94f4d758ab56d24 || ($2f512219da033f72$export$f94f4d758ab56d24 = {}));
var $2f512219da033f72$export$67a1e2571d1b8f49;
(function(ConfluenceLegacyAdminAnnouncementBannerSettingsByCriteriaOrder) {
    ConfluenceLegacyAdminAnnouncementBannerSettingsByCriteriaOrder["Default"] = "DEFAULT";
    ConfluenceLegacyAdminAnnouncementBannerSettingsByCriteriaOrder["ScheduledEndDate"] = "SCHEDULED_END_DATE";
    ConfluenceLegacyAdminAnnouncementBannerSettingsByCriteriaOrder["ScheduledStartDate"] = "SCHEDULED_START_DATE";
    ConfluenceLegacyAdminAnnouncementBannerSettingsByCriteriaOrder["Visibility"] = "VISIBILITY";
})($2f512219da033f72$export$67a1e2571d1b8f49 || ($2f512219da033f72$export$67a1e2571d1b8f49 = {}));
var $2f512219da033f72$export$abe83d18892e131e;
(function(ConfluenceLegacyAdminAnnouncementBannerStatusType) {
    ConfluenceLegacyAdminAnnouncementBannerStatusType["Published"] = "PUBLISHED";
    ConfluenceLegacyAdminAnnouncementBannerStatusType["Saved"] = "SAVED";
    ConfluenceLegacyAdminAnnouncementBannerStatusType["Scheduled"] = "SCHEDULED";
})($2f512219da033f72$export$abe83d18892e131e || ($2f512219da033f72$export$abe83d18892e131e = {}));
var $2f512219da033f72$export$6ea4d7ff878e1fa7;
(function(ConfluenceLegacyAdminAnnouncementBannerVisibilityType) {
    ConfluenceLegacyAdminAnnouncementBannerVisibilityType["All"] = "ALL";
    ConfluenceLegacyAdminAnnouncementBannerVisibilityType["Authorized"] = "AUTHORIZED";
})($2f512219da033f72$export$6ea4d7ff878e1fa7 || ($2f512219da033f72$export$6ea4d7ff878e1fa7 = {}));
var $2f512219da033f72$export$592845e9ae5bd115;
(function(ConfluenceLegacyAllUpdatesFeedEventType) {
    ConfluenceLegacyAllUpdatesFeedEventType["Comment"] = "COMMENT";
    ConfluenceLegacyAllUpdatesFeedEventType["Create"] = "CREATE";
    ConfluenceLegacyAllUpdatesFeedEventType["Edit"] = "EDIT";
})($2f512219da033f72$export$592845e9ae5bd115 || ($2f512219da033f72$export$592845e9ae5bd115 = {}));
var $2f512219da033f72$export$4f7b2d728c929a44;
(function(ConfluenceLegacyAnalyticsCommentType) {
    ConfluenceLegacyAnalyticsCommentType["Inline"] = "inline";
    ConfluenceLegacyAnalyticsCommentType["Page"] = "page";
})($2f512219da033f72$export$4f7b2d728c929a44 || ($2f512219da033f72$export$4f7b2d728c929a44 = {}));
var $2f512219da033f72$export$e30f067708a78859;
(function(ConfluenceLegacyAnalyticsContentType) {
    ConfluenceLegacyAnalyticsContentType["Blogpost"] = "blogpost";
    ConfluenceLegacyAnalyticsContentType["Page"] = "page";
})($2f512219da033f72$export$e30f067708a78859 || ($2f512219da033f72$export$e30f067708a78859 = {}));
var $2f512219da033f72$export$974cb55686fb4ebc;
(function(ConfluenceLegacyAnalyticsEventName) {
    ConfluenceLegacyAnalyticsEventName["AnalyticsPageModalViewed"] = "analyticsPageModal_viewed";
    ConfluenceLegacyAnalyticsEventName["AutomationRuleTrackCreated"] = "automationRuleTrack_created";
    ConfluenceLegacyAnalyticsEventName["CalendarCreated"] = "calendar_created";
    ConfluenceLegacyAnalyticsEventName["CommentCreated"] = "comment_created";
    ConfluenceLegacyAnalyticsEventName["DatabaseCreated"] = "database_created";
    ConfluenceLegacyAnalyticsEventName["DatabaseViewed"] = "database_viewed";
    ConfluenceLegacyAnalyticsEventName["InspectPermissionsDialogViewed"] = "inspectPermissionsDialog_viewed";
    ConfluenceLegacyAnalyticsEventName["InstanceAnalyticsViewed"] = "instanceAnalytics_viewed";
    ConfluenceLegacyAnalyticsEventName["PageAnalyticsViewed"] = "pageAnalytics_viewed";
    ConfluenceLegacyAnalyticsEventName["PageCreated"] = "page_created";
    ConfluenceLegacyAnalyticsEventName["PageUpdated"] = "page_updated";
    ConfluenceLegacyAnalyticsEventName["PageViewed"] = "page_viewed";
    ConfluenceLegacyAnalyticsEventName["PubliclinkPageViewed"] = "publiclink_page_viewed";
    ConfluenceLegacyAnalyticsEventName["SpaceAnalyticsViewed"] = "spaceAnalytics_viewed";
    ConfluenceLegacyAnalyticsEventName["TeamCalendarsViewed"] = "teamCalendars_viewed";
    ConfluenceLegacyAnalyticsEventName["WhiteboardCreated"] = "whiteboard_created";
    ConfluenceLegacyAnalyticsEventName["WhiteboardViewed"] = "whiteboard_viewed";
})($2f512219da033f72$export$974cb55686fb4ebc || ($2f512219da033f72$export$974cb55686fb4ebc = {}));
var $2f512219da033f72$export$9dc60e43906fc093;
(function(ConfluenceLegacyAnalyticsMeasuresEventName) {
    ConfluenceLegacyAnalyticsMeasuresEventName["CurrentBlogpostCountSitestateMeasured"] = "currentBlogpostCount_sitestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["CurrentBlogpostCountSpacestateMeasured"] = "currentBlogpostCount_spacestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["CurrentDatabaseCountSitestateMeasured"] = "currentDatabaseCount_sitestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["CurrentDatabaseCountSpacestateMeasured"] = "currentDatabaseCount_spacestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["CurrentPageCountSitestateMeasured"] = "currentPageCount_sitestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["CurrentPageCountSpacestateMeasured"] = "currentPageCount_spacestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["CurrentWhiteboardCountSitestateMeasured"] = "currentWhiteboardCount_sitestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["CurrentWhiteboardCountSpacestateMeasured"] = "currentWhiteboardCount_spacestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["InactivePageCountSitestateMeasured"] = "inactivePageCount_sitestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["InactivePageCountSpacestateMeasured"] = "inactivePageCount_spacestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["TotalActiveCommunalSpacesSitestateMeasured"] = "totalActiveCommunalSpaces_sitestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["TotalActivePersonalSpacesSitestateMeasured"] = "totalActivePersonalSpaces_sitestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["TotalActivePublicLinksSitestateMeasured"] = "totalActivePublicLinks_sitestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["TotalActivePublicLinksSpacestateMeasured"] = "totalActivePublicLinks_spacestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["TotalActiveSpacesSitestateMeasured"] = "totalActiveSpaces_sitestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["TotalCurrentBlogpostCountSitestateMeasured"] = "totalCurrentBlogpostCount_sitestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["TotalCurrentDatabaseCountSitestateMeasured"] = "totalCurrentDatabaseCount_sitestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["TotalCurrentPageCountSitestateMeasured"] = "totalCurrentPageCount_sitestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["TotalCurrentWhiteboardCountSitestateMeasured"] = "totalCurrentWhiteboardCount_sitestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["TotalPagesDeactivatedOwnerSitestateMeasured"] = "totalPagesDeactivatedOwner_sitestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["TotalPagesDeactivatedOwnerSpacestateMeasured"] = "totalPagesDeactivatedOwner_spacestate_measured";
})($2f512219da033f72$export$9dc60e43906fc093 || ($2f512219da033f72$export$9dc60e43906fc093 = {}));
var $2f512219da033f72$export$529a0a3fc89fb460;
(function(ConfluenceLegacyAnalyticsMeasuresSpaceEventName) {
    ConfluenceLegacyAnalyticsMeasuresSpaceEventName["CurrentBlogpostCountSpacestateMeasured"] = "currentBlogpostCount_spacestate_measured";
    ConfluenceLegacyAnalyticsMeasuresSpaceEventName["CurrentDatabaseCountSpacestateMeasured"] = "currentDatabaseCount_spacestate_measured";
    ConfluenceLegacyAnalyticsMeasuresSpaceEventName["CurrentPageCountSpacestateMeasured"] = "currentPageCount_spacestate_measured";
    ConfluenceLegacyAnalyticsMeasuresSpaceEventName["CurrentWhiteboardCountSpacestateMeasured"] = "currentWhiteboardCount_spacestate_measured";
    ConfluenceLegacyAnalyticsMeasuresSpaceEventName["InactivePageCountSpacestateMeasured"] = "inactivePageCount_spacestate_measured";
    ConfluenceLegacyAnalyticsMeasuresSpaceEventName["TotalActivePublicLinksSpacestateMeasured"] = "totalActivePublicLinks_spacestate_measured";
    ConfluenceLegacyAnalyticsMeasuresSpaceEventName["TotalPagesDeactivatedOwnerSpacestateMeasured"] = "totalPagesDeactivatedOwner_spacestate_measured";
})($2f512219da033f72$export$529a0a3fc89fb460 || ($2f512219da033f72$export$529a0a3fc89fb460 = {}));
var $2f512219da033f72$export$5a62729781e5150;
(function(ConfluenceLegacyAnalyticsSearchEventName) {
    ConfluenceLegacyAnalyticsSearchEventName["AdvancedSearchResultLinkClicked"] = "advancedSearchResultLink_clicked";
    ConfluenceLegacyAnalyticsSearchEventName["AdvancedSearchResultsShown"] = "advancedSearchResults_shown";
    ConfluenceLegacyAnalyticsSearchEventName["QuickSearchRequestCompleted"] = "quickSearchRequest_completed";
    ConfluenceLegacyAnalyticsSearchEventName["QuickSearchResultSelected"] = "quickSearchResult_selected";
})($2f512219da033f72$export$5a62729781e5150 || ($2f512219da033f72$export$5a62729781e5150 = {}));
var $2f512219da033f72$export$cd1f6d32ed31f38f;
(function(ConfluenceLegacyAnalyticsTimeseriesGranularity) {
    ConfluenceLegacyAnalyticsTimeseriesGranularity["Day"] = "DAY";
    ConfluenceLegacyAnalyticsTimeseriesGranularity["Hour"] = "HOUR";
    ConfluenceLegacyAnalyticsTimeseriesGranularity["Month"] = "MONTH";
    ConfluenceLegacyAnalyticsTimeseriesGranularity["Week"] = "WEEK";
})($2f512219da033f72$export$cd1f6d32ed31f38f || ($2f512219da033f72$export$cd1f6d32ed31f38f = {}));
var $2f512219da033f72$export$84cc0985ee5132c3;
(function(ConfluenceLegacyBackendExperiment) {
    ConfluenceLegacyBackendExperiment["Einstein"] = "EINSTEIN";
})($2f512219da033f72$export$84cc0985ee5132c3 || ($2f512219da033f72$export$84cc0985ee5132c3 = {}));
var $2f512219da033f72$export$72d2271493719cd9;
(function(ConfluenceLegacyBillingSourceSystem) {
    ConfluenceLegacyBillingSourceSystem["Ccp"] = "CCP";
    ConfluenceLegacyBillingSourceSystem["Hams"] = "HAMS";
})($2f512219da033f72$export$72d2271493719cd9 || ($2f512219da033f72$export$72d2271493719cd9 = {}));
var $2f512219da033f72$export$1d6c7c01499dab;
(function(ConfluenceLegacyBodyFormatType) {
    ConfluenceLegacyBodyFormatType["AnonymousExportView"] = "ANONYMOUS_EXPORT_VIEW";
    ConfluenceLegacyBodyFormatType["AtlasDocFormat"] = "ATLAS_DOC_FORMAT";
    ConfluenceLegacyBodyFormatType["Editor"] = "EDITOR";
    ConfluenceLegacyBodyFormatType["Editor2"] = "EDITOR2";
    ConfluenceLegacyBodyFormatType["ExportView"] = "EXPORT_VIEW";
    ConfluenceLegacyBodyFormatType["Storage"] = "STORAGE";
    ConfluenceLegacyBodyFormatType["StyledView"] = "STYLED_VIEW";
    ConfluenceLegacyBodyFormatType["View"] = "VIEW";
})($2f512219da033f72$export$1d6c7c01499dab || ($2f512219da033f72$export$1d6c7c01499dab = {}));
var $2f512219da033f72$export$808cc4b811411528;
(function(ConfluenceLegacyBulkSetSpacePermissionSpaceType) {
    ConfluenceLegacyBulkSetSpacePermissionSpaceType["Collaboration"] = "COLLABORATION";
    ConfluenceLegacyBulkSetSpacePermissionSpaceType["Global"] = "GLOBAL";
    ConfluenceLegacyBulkSetSpacePermissionSpaceType["KnowledgeBase"] = "KNOWLEDGE_BASE";
    ConfluenceLegacyBulkSetSpacePermissionSpaceType["Personal"] = "PERSONAL";
})($2f512219da033f72$export$808cc4b811411528 || ($2f512219da033f72$export$808cc4b811411528 = {}));
var $2f512219da033f72$export$7537b52b3e1ca17f;
(function(ConfluenceLegacyBulkSetSpacePermissionSubjectType) {
    ConfluenceLegacyBulkSetSpacePermissionSubjectType["Group"] = "GROUP";
    ConfluenceLegacyBulkSetSpacePermissionSubjectType["User"] = "USER";
})($2f512219da033f72$export$7537b52b3e1ca17f || ($2f512219da033f72$export$7537b52b3e1ca17f = {}));
var $2f512219da033f72$export$c274657b6ae8c08b;
(function(ConfluenceLegacyCatchupContentType) {
    ConfluenceLegacyCatchupContentType["Blogpost"] = "BLOGPOST";
    ConfluenceLegacyCatchupContentType["Page"] = "PAGE";
})($2f512219da033f72$export$c274657b6ae8c08b || ($2f512219da033f72$export$c274657b6ae8c08b = {}));
var $2f512219da033f72$export$d3260cc27acb2273;
(function(ConfluenceLegacyCatchupUpdateType) {
    ConfluenceLegacyCatchupUpdateType["TopN"] = "TOP_N";
})($2f512219da033f72$export$d3260cc27acb2273 || ($2f512219da033f72$export$d3260cc27acb2273 = {}));
var $2f512219da033f72$export$fbf27f279c195cfd;
(function(ConfluenceLegacyCommentCreationLocation) {
    ConfluenceLegacyCommentCreationLocation["Editor"] = "EDITOR";
    ConfluenceLegacyCommentCreationLocation["Live"] = "LIVE";
    ConfluenceLegacyCommentCreationLocation["Renderer"] = "RENDERER";
    ConfluenceLegacyCommentCreationLocation["Whiteboard"] = "WHITEBOARD";
})($2f512219da033f72$export$fbf27f279c195cfd || ($2f512219da033f72$export$fbf27f279c195cfd = {}));
var $2f512219da033f72$export$68d0cd998b71f75b;
(function(ConfluenceLegacyCommentDeletionLocation) {
    ConfluenceLegacyCommentDeletionLocation["Live"] = "LIVE";
})($2f512219da033f72$export$68d0cd998b71f75b || ($2f512219da033f72$export$68d0cd998b71f75b = {}));
var $2f512219da033f72$export$e2f309d5fad312d0;
(function(ConfluenceLegacyCommentReplyType) {
    ConfluenceLegacyCommentReplyType["Emoji"] = "EMOJI";
    ConfluenceLegacyCommentReplyType["Prompt"] = "PROMPT";
    ConfluenceLegacyCommentReplyType["QuickReply"] = "QUICK_REPLY";
})($2f512219da033f72$export$e2f309d5fad312d0 || ($2f512219da033f72$export$e2f309d5fad312d0 = {}));
var $2f512219da033f72$export$2dfdca1bacc36231;
(function(ConfluenceLegacyCommentType) {
    ConfluenceLegacyCommentType["Footer"] = "FOOTER";
    ConfluenceLegacyCommentType["Inline"] = "INLINE";
    ConfluenceLegacyCommentType["Resolved"] = "RESOLVED";
    ConfluenceLegacyCommentType["Unresolved"] = "UNRESOLVED";
})($2f512219da033f72$export$2dfdca1bacc36231 || ($2f512219da033f72$export$2dfdca1bacc36231 = {}));
var $2f512219da033f72$export$b6d21fe6703a2599;
(function(ConfluenceLegacyCommentsType) {
    ConfluenceLegacyCommentsType["Footer"] = "FOOTER";
    ConfluenceLegacyCommentsType["Inline"] = "INLINE";
})($2f512219da033f72$export$b6d21fe6703a2599 || ($2f512219da033f72$export$b6d21fe6703a2599 = {}));
var $2f512219da033f72$export$83d2156f88d87d3c;
(function(ConfluenceLegacyContactAdminPageDisabledReason) {
    ConfluenceLegacyContactAdminPageDisabledReason["ConfigOff"] = "CONFIG_OFF";
    ConfluenceLegacyContactAdminPageDisabledReason["NoAdminEmails"] = "NO_ADMIN_EMAILS";
    ConfluenceLegacyContactAdminPageDisabledReason["NoMailServer"] = "NO_MAIL_SERVER";
    ConfluenceLegacyContactAdminPageDisabledReason["NoRecaptcha"] = "NO_RECAPTCHA";
})($2f512219da033f72$export$83d2156f88d87d3c || ($2f512219da033f72$export$83d2156f88d87d3c = {}));
var $2f512219da033f72$export$dc0b3486b6d302da;
(function(ConfluenceLegacyContainerType) {
    ConfluenceLegacyContainerType["Blogpost"] = "BLOGPOST";
    ConfluenceLegacyContainerType["Page"] = "PAGE";
    ConfluenceLegacyContainerType["Space"] = "SPACE";
    ConfluenceLegacyContainerType["Whiteboard"] = "WHITEBOARD";
})($2f512219da033f72$export$dc0b3486b6d302da || ($2f512219da033f72$export$dc0b3486b6d302da = {}));
var $2f512219da033f72$export$14a0d7c84f79aebf;
(function(ConfluenceLegacyContentAccessInputType) {
    ConfluenceLegacyContentAccessInputType["EveryoneCanEdit"] = "EVERYONE_CAN_EDIT";
    ConfluenceLegacyContentAccessInputType["EveryoneCanView"] = "EVERYONE_CAN_VIEW";
    ConfluenceLegacyContentAccessInputType["EveryoneNoAccess"] = "EVERYONE_NO_ACCESS";
    ConfluenceLegacyContentAccessInputType["Private"] = "PRIVATE";
})($2f512219da033f72$export$14a0d7c84f79aebf || ($2f512219da033f72$export$14a0d7c84f79aebf = {}));
var $2f512219da033f72$export$cf8f2171d823bde;
(function(ConfluenceLegacyContentAccessType) {
    ConfluenceLegacyContentAccessType["EveryoneCanEdit"] = "EVERYONE_CAN_EDIT";
    ConfluenceLegacyContentAccessType["EveryoneCanView"] = "EVERYONE_CAN_VIEW";
    ConfluenceLegacyContentAccessType["EveryoneNoAccess"] = "EVERYONE_NO_ACCESS";
})($2f512219da033f72$export$cf8f2171d823bde || ($2f512219da033f72$export$cf8f2171d823bde = {}));
var $2f512219da033f72$export$1c8c23d711ae773e;
(function(ConfluenceLegacyContentAction) {
    ConfluenceLegacyContentAction["Created"] = "created";
    ConfluenceLegacyContentAction["Updated"] = "updated";
    ConfluenceLegacyContentAction["Viewed"] = "viewed";
})($2f512219da033f72$export$1c8c23d711ae773e || ($2f512219da033f72$export$1c8c23d711ae773e = {}));
var $2f512219da033f72$export$a78e2be628bf0936;
(function(ConfluenceLegacyContentDataClassificationMutationContentStatus) {
    ConfluenceLegacyContentDataClassificationMutationContentStatus["Current"] = "CURRENT";
    ConfluenceLegacyContentDataClassificationMutationContentStatus["Draft"] = "DRAFT";
})($2f512219da033f72$export$a78e2be628bf0936 || ($2f512219da033f72$export$a78e2be628bf0936 = {}));
var $2f512219da033f72$export$8294e4a5584cdafb;
(function(ConfluenceLegacyContentDataClassificationQueryContentStatus) {
    ConfluenceLegacyContentDataClassificationQueryContentStatus["Archived"] = "ARCHIVED";
    ConfluenceLegacyContentDataClassificationQueryContentStatus["Current"] = "CURRENT";
    ConfluenceLegacyContentDataClassificationQueryContentStatus["Draft"] = "DRAFT";
})($2f512219da033f72$export$8294e4a5584cdafb || ($2f512219da033f72$export$8294e4a5584cdafb = {}));
var $2f512219da033f72$export$11a7365bbd55a2c3;
(function(ConfluenceLegacyContentDeleteActionType) {
    ConfluenceLegacyContentDeleteActionType["DeleteDraft"] = "DELETE_DRAFT";
    ConfluenceLegacyContentDeleteActionType["DeleteDraftIfBlank"] = "DELETE_DRAFT_IF_BLANK";
    ConfluenceLegacyContentDeleteActionType["MoveToTrash"] = "MOVE_TO_TRASH";
    ConfluenceLegacyContentDeleteActionType["PurgeFromTrash"] = "PURGE_FROM_TRASH";
})($2f512219da033f72$export$11a7365bbd55a2c3 || ($2f512219da033f72$export$11a7365bbd55a2c3 = {}));
var $2f512219da033f72$export$e4765167602a01a4;
(function(ConfluenceLegacyContentPermissionType) {
    ConfluenceLegacyContentPermissionType["Edit"] = "EDIT";
    ConfluenceLegacyContentPermissionType["View"] = "VIEW";
})($2f512219da033f72$export$e4765167602a01a4 || ($2f512219da033f72$export$e4765167602a01a4 = {}));
var $2f512219da033f72$export$52bfd28e9d78a168;
(function(ConfluenceLegacyContentRendererMode) {
    ConfluenceLegacyContentRendererMode["Editor"] = "EDITOR";
    ConfluenceLegacyContentRendererMode["Pdf"] = "PDF";
    ConfluenceLegacyContentRendererMode["Renderer"] = "RENDERER";
})($2f512219da033f72$export$52bfd28e9d78a168 || ($2f512219da033f72$export$52bfd28e9d78a168 = {}));
var $2f512219da033f72$export$9f48a780e64ab98d;
(function(ConfluenceLegacyContentRepresentation) {
    ConfluenceLegacyContentRepresentation["AtlasDocFormat"] = "ATLAS_DOC_FORMAT";
    ConfluenceLegacyContentRepresentation["Editor"] = "EDITOR";
    ConfluenceLegacyContentRepresentation["Editor2"] = "EDITOR2";
    ConfluenceLegacyContentRepresentation["ExportView"] = "EXPORT_VIEW";
    ConfluenceLegacyContentRepresentation["Plain"] = "PLAIN";
    ConfluenceLegacyContentRepresentation["Raw"] = "RAW";
    ConfluenceLegacyContentRepresentation["Storage"] = "STORAGE";
    ConfluenceLegacyContentRepresentation["StyledView"] = "STYLED_VIEW";
    ConfluenceLegacyContentRepresentation["View"] = "VIEW";
    ConfluenceLegacyContentRepresentation["Wiki"] = "WIKI";
})($2f512219da033f72$export$9f48a780e64ab98d || ($2f512219da033f72$export$9f48a780e64ab98d = {}));
var $2f512219da033f72$export$22638a777276bf91;
(function(ConfluenceLegacyContentRole) {
    ConfluenceLegacyContentRole["Default"] = "DEFAULT";
    ConfluenceLegacyContentRole["Editor"] = "EDITOR";
    ConfluenceLegacyContentRole["Viewer"] = "VIEWER";
})($2f512219da033f72$export$22638a777276bf91 || ($2f512219da033f72$export$22638a777276bf91 = {}));
var $2f512219da033f72$export$962cbd35615f4fff;
(function(ConfluenceLegacyContentStateRestrictionLevel) {
    ConfluenceLegacyContentStateRestrictionLevel["None"] = "NONE";
    ConfluenceLegacyContentStateRestrictionLevel["PageOwner"] = "PAGE_OWNER";
})($2f512219da033f72$export$962cbd35615f4fff || ($2f512219da033f72$export$962cbd35615f4fff = {}));
var $2f512219da033f72$export$c24d6a3d72599268;
(function(ConfluenceLegacyContentStatus) {
    ConfluenceLegacyContentStatus["Archived"] = "ARCHIVED";
    ConfluenceLegacyContentStatus["Current"] = "CURRENT";
    ConfluenceLegacyContentStatus["Deleted"] = "DELETED";
    ConfluenceLegacyContentStatus["Draft"] = "DRAFT";
})($2f512219da033f72$export$c24d6a3d72599268 || ($2f512219da033f72$export$c24d6a3d72599268 = {}));
var $2f512219da033f72$export$492d1092720944e9;
(function(ConfluenceLegacyContentTemplateType) {
    ConfluenceLegacyContentTemplateType["Blueprint"] = "BLUEPRINT";
    ConfluenceLegacyContentTemplateType["Page"] = "PAGE";
})($2f512219da033f72$export$492d1092720944e9 || ($2f512219da033f72$export$492d1092720944e9 = {}));
var $2f512219da033f72$export$1ead28a8886cdf4e;
(function(ConfluenceLegacyDataSecurityPolicyAction) {
    ConfluenceLegacyDataSecurityPolicyAction["AppAccess"] = "APP_ACCESS";
    ConfluenceLegacyDataSecurityPolicyAction["PageExport"] = "PAGE_EXPORT";
    ConfluenceLegacyDataSecurityPolicyAction["PublicLinks"] = "PUBLIC_LINKS";
})($2f512219da033f72$export$1ead28a8886cdf4e || ($2f512219da033f72$export$1ead28a8886cdf4e = {}));
var $2f512219da033f72$export$d97f1f6b89a9dab8;
(function(ConfluenceLegacyDataSecurityPolicyCoverageType) {
    ConfluenceLegacyDataSecurityPolicyCoverageType["ClassificationLevel"] = "CLASSIFICATION_LEVEL";
    ConfluenceLegacyDataSecurityPolicyCoverageType["Container"] = "CONTAINER";
    ConfluenceLegacyDataSecurityPolicyCoverageType["None"] = "NONE";
    ConfluenceLegacyDataSecurityPolicyCoverageType["Workspace"] = "WORKSPACE";
})($2f512219da033f72$export$d97f1f6b89a9dab8 || ($2f512219da033f72$export$d97f1f6b89a9dab8 = {}));
var $2f512219da033f72$export$b8ebe8bcbe0edcc9;
(function(ConfluenceLegacyDataSecurityPolicyDecidableContentStatus) {
    ConfluenceLegacyDataSecurityPolicyDecidableContentStatus["Archived"] = "ARCHIVED";
    ConfluenceLegacyDataSecurityPolicyDecidableContentStatus["Current"] = "CURRENT";
    ConfluenceLegacyDataSecurityPolicyDecidableContentStatus["Draft"] = "DRAFT";
})($2f512219da033f72$export$b8ebe8bcbe0edcc9 || ($2f512219da033f72$export$b8ebe8bcbe0edcc9 = {}));
var $2f512219da033f72$export$8f82f21f1f98a966;
(function(ConfluenceLegacyDateFormat) {
    ConfluenceLegacyDateFormat["Global"] = "GLOBAL";
    ConfluenceLegacyDateFormat["Millis"] = "MILLIS";
    ConfluenceLegacyDateFormat["User"] = "USER";
    ConfluenceLegacyDateFormat["UserFriendly"] = "USER_FRIENDLY";
})($2f512219da033f72$export$8f82f21f1f98a966 || ($2f512219da033f72$export$8f82f21f1f98a966 = {}));
var $2f512219da033f72$export$1c761a9499909678;
(function(ConfluenceLegacyDeactivatedPageOwnerUserType) {
    ConfluenceLegacyDeactivatedPageOwnerUserType["FormerUsers"] = "FORMER_USERS";
    ConfluenceLegacyDeactivatedPageOwnerUserType["NonFormerUsers"] = "NON_FORMER_USERS";
})($2f512219da033f72$export$1c761a9499909678 || ($2f512219da033f72$export$1c761a9499909678 = {}));
var $2f512219da033f72$export$477e85946b13cfd1;
(function(ConfluenceLegacyDepth) {
    ConfluenceLegacyDepth["All"] = "ALL";
    ConfluenceLegacyDepth["Root"] = "ROOT";
})($2f512219da033f72$export$477e85946b13cfd1 || ($2f512219da033f72$export$477e85946b13cfd1 = {}));
var $2f512219da033f72$export$8ca8fdccfce3b6b2;
(function(ConfluenceLegacyDescendantsNoteApplicationOption) {
    ConfluenceLegacyDescendantsNoteApplicationOption["All"] = "ALL";
    ConfluenceLegacyDescendantsNoteApplicationOption["None"] = "NONE";
    ConfluenceLegacyDescendantsNoteApplicationOption["Roots"] = "ROOTS";
})($2f512219da033f72$export$8ca8fdccfce3b6b2 || ($2f512219da033f72$export$8ca8fdccfce3b6b2 = {}));
var $2f512219da033f72$export$9e676a15531fad10;
(function(ConfluenceLegacyDocumentRepresentation) {
    ConfluenceLegacyDocumentRepresentation["AtlasDocFormat"] = "ATLAS_DOC_FORMAT";
    ConfluenceLegacyDocumentRepresentation["Html"] = "HTML";
    ConfluenceLegacyDocumentRepresentation["Storage"] = "STORAGE";
    ConfluenceLegacyDocumentRepresentation["View"] = "VIEW";
})($2f512219da033f72$export$9e676a15531fad10 || ($2f512219da033f72$export$9e676a15531fad10 = {}));
var $2f512219da033f72$export$c54c52e1dab26d52;
(function(ConfluenceLegacyEdition) {
    ConfluenceLegacyEdition["Free"] = "FREE";
    ConfluenceLegacyEdition["Premium"] = "PREMIUM";
    ConfluenceLegacyEdition["Standard"] = "STANDARD";
})($2f512219da033f72$export$c54c52e1dab26d52 || ($2f512219da033f72$export$c54c52e1dab26d52 = {}));
var $2f512219da033f72$export$42d27343a8b84fc8;
(function(ConfluenceLegacyEditorConversionSetting) {
    ConfluenceLegacyEditorConversionSetting["None"] = "NONE";
    ConfluenceLegacyEditorConversionSetting["Supported"] = "SUPPORTED";
})($2f512219da033f72$export$42d27343a8b84fc8 || ($2f512219da033f72$export$42d27343a8b84fc8 = {}));
var $2f512219da033f72$export$fb03d9af47277a3d;
(function(ConfluenceLegacyEnvironment) {
    ConfluenceLegacyEnvironment["Development"] = "DEVELOPMENT";
    ConfluenceLegacyEnvironment["Production"] = "PRODUCTION";
    ConfluenceLegacyEnvironment["Staging"] = "STAGING";
})($2f512219da033f72$export$fb03d9af47277a3d || ($2f512219da033f72$export$fb03d9af47277a3d = {}));
var $2f512219da033f72$export$4e6002c4c65764d4;
(function(ConfluenceLegacyExternalCollaboratorsSortField) {
    ConfluenceLegacyExternalCollaboratorsSortField["Name"] = "NAME";
})($2f512219da033f72$export$4e6002c4c65764d4 || ($2f512219da033f72$export$4e6002c4c65764d4 = {}));
var $2f512219da033f72$export$a828ec9b508a2266;
(function(ConfluenceLegacyFeedEventType) {
    ConfluenceLegacyFeedEventType["Comment"] = "COMMENT";
    ConfluenceLegacyFeedEventType["Create"] = "CREATE";
    ConfluenceLegacyFeedEventType["Edit"] = "EDIT";
})($2f512219da033f72$export$a828ec9b508a2266 || ($2f512219da033f72$export$a828ec9b508a2266 = {}));
var $2f512219da033f72$export$13866e2e9da2ea4b;
(function(ConfluenceLegacyFeedItemSourceType) {
    ConfluenceLegacyFeedItemSourceType["Person"] = "PERSON";
    ConfluenceLegacyFeedItemSourceType["Space"] = "SPACE";
})($2f512219da033f72$export$13866e2e9da2ea4b || ($2f512219da033f72$export$13866e2e9da2ea4b = {}));
var $2f512219da033f72$export$2e72a60396e89995;
(function(ConfluenceLegacyFeedType) {
    ConfluenceLegacyFeedType["Direct"] = "DIRECT";
    ConfluenceLegacyFeedType["Following"] = "FOLLOWING";
    ConfluenceLegacyFeedType["Popular"] = "POPULAR";
})($2f512219da033f72$export$2e72a60396e89995 || ($2f512219da033f72$export$2e72a60396e89995 = {}));
var $2f512219da033f72$export$25f79122cd5df609;
(function(ConfluenceLegacyFrontCoverState) {
    ConfluenceLegacyFrontCoverState["Hidden"] = "HIDDEN";
    ConfluenceLegacyFrontCoverState["Shown"] = "SHOWN";
    ConfluenceLegacyFrontCoverState["Transition"] = "TRANSITION";
    ConfluenceLegacyFrontCoverState["Unset"] = "UNSET";
})($2f512219da033f72$export$25f79122cd5df609 || ($2f512219da033f72$export$25f79122cd5df609 = {}));
var $2f512219da033f72$export$a19da40648493053;
(function(ConfluenceLegacyHomeWidgetState) {
    ConfluenceLegacyHomeWidgetState["Collapsed"] = "COLLAPSED";
    ConfluenceLegacyHomeWidgetState["Expanded"] = "EXPANDED";
})($2f512219da033f72$export$a19da40648493053 || ($2f512219da033f72$export$a19da40648493053 = {}));
var $2f512219da033f72$export$5f0193f955ef0cb1;
(function(ConfluenceLegacyInitialPermissionOptions) {
    ConfluenceLegacyInitialPermissionOptions["CopyFromSpace"] = "COPY_FROM_SPACE";
    ConfluenceLegacyInitialPermissionOptions["Default"] = "DEFAULT";
    ConfluenceLegacyInitialPermissionOptions["Private"] = "PRIVATE";
})($2f512219da033f72$export$5f0193f955ef0cb1 || ($2f512219da033f72$export$5f0193f955ef0cb1 = {}));
var $2f512219da033f72$export$df2ab38c891954c2;
(function(ConfluenceLegacyInlineTasksQuerySortColumn) {
    ConfluenceLegacyInlineTasksQuerySortColumn["Assignee"] = "ASSIGNEE";
    ConfluenceLegacyInlineTasksQuerySortColumn["DueDate"] = "DUE_DATE";
    ConfluenceLegacyInlineTasksQuerySortColumn["PageTitle"] = "PAGE_TITLE";
})($2f512219da033f72$export$df2ab38c891954c2 || ($2f512219da033f72$export$df2ab38c891954c2 = {}));
var $2f512219da033f72$export$cba96ef83f91f0df;
(function(ConfluenceLegacyInlineTasksQuerySortOrder) {
    ConfluenceLegacyInlineTasksQuerySortOrder["Ascending"] = "ASCENDING";
    ConfluenceLegacyInlineTasksQuerySortOrder["Descending"] = "DESCENDING";
})($2f512219da033f72$export$cba96ef83f91f0df || ($2f512219da033f72$export$cba96ef83f91f0df = {}));
var $2f512219da033f72$export$b2bba2f5e2a7ff3e;
(function(ConfluenceLegacyInspectPermissions) {
    ConfluenceLegacyInspectPermissions["Comment"] = "COMMENT";
    ConfluenceLegacyInspectPermissions["Edit"] = "EDIT";
    ConfluenceLegacyInspectPermissions["View"] = "VIEW";
})($2f512219da033f72$export$b2bba2f5e2a7ff3e || ($2f512219da033f72$export$b2bba2f5e2a7ff3e = {}));
var $2f512219da033f72$export$56cd0576b91fa37a;
(function(ConfluenceLegacyLabelSortDirection) {
    ConfluenceLegacyLabelSortDirection["Ascending"] = "ASCENDING";
    ConfluenceLegacyLabelSortDirection["Descending"] = "DESCENDING";
})($2f512219da033f72$export$56cd0576b91fa37a || ($2f512219da033f72$export$56cd0576b91fa37a = {}));
var $2f512219da033f72$export$c05dc088e940cc05;
(function(ConfluenceLegacyLabelSortField) {
    ConfluenceLegacyLabelSortField["LabellingCreationdate"] = "LABELLING_CREATIONDATE";
    ConfluenceLegacyLabelSortField["LabellingId"] = "LABELLING_ID";
})($2f512219da033f72$export$c05dc088e940cc05 || ($2f512219da033f72$export$c05dc088e940cc05 = {}));
var $2f512219da033f72$export$33f17291ac91a786;
(function(ConfluenceLegacyLicenseStatus) {
    ConfluenceLegacyLicenseStatus["Active"] = "ACTIVE";
    ConfluenceLegacyLicenseStatus["Suspended"] = "SUSPENDED";
    ConfluenceLegacyLicenseStatus["Unlicensed"] = "UNLICENSED";
})($2f512219da033f72$export$33f17291ac91a786 || ($2f512219da033f72$export$33f17291ac91a786 = {}));
var $2f512219da033f72$export$662bb1896031bf06;
(function(ConfluenceLegacyLoomUserStatus) {
    ConfluenceLegacyLoomUserStatus["Linked"] = "LINKED";
    ConfluenceLegacyLoomUserStatus["Mastered"] = "MASTERED";
    ConfluenceLegacyLoomUserStatus["NotFound"] = "NOT_FOUND";
})($2f512219da033f72$export$662bb1896031bf06 || ($2f512219da033f72$export$662bb1896031bf06 = {}));
var $2f512219da033f72$export$fd5adc8aad00cb78;
(function(ConfluenceLegacyMobilePlatform) {
    ConfluenceLegacyMobilePlatform["Android"] = "ANDROID";
    ConfluenceLegacyMobilePlatform["Ios"] = "IOS";
})($2f512219da033f72$export$fd5adc8aad00cb78 || ($2f512219da033f72$export$fd5adc8aad00cb78 = {}));
var $2f512219da033f72$export$728d574e7c9f150a;
(function(ConfluenceLegacyOperation) {
    ConfluenceLegacyOperation["Assigned"] = "ASSIGNED";
    ConfluenceLegacyOperation["Complete"] = "COMPLETE";
    ConfluenceLegacyOperation["Deleted"] = "DELETED";
    ConfluenceLegacyOperation["InComplete"] = "IN_COMPLETE";
    ConfluenceLegacyOperation["Reworded"] = "REWORDED";
    ConfluenceLegacyOperation["Unassigned"] = "UNASSIGNED";
})($2f512219da033f72$export$728d574e7c9f150a || ($2f512219da033f72$export$728d574e7c9f150a = {}));
var $2f512219da033f72$export$42875c45c64c8240;
(function(ConfluenceLegacyOutputDeviceType) {
    ConfluenceLegacyOutputDeviceType["Desktop"] = "DESKTOP";
    ConfluenceLegacyOutputDeviceType["Email"] = "EMAIL";
    ConfluenceLegacyOutputDeviceType["Mobile"] = "MOBILE";
})($2f512219da033f72$export$42875c45c64c8240 || ($2f512219da033f72$export$42875c45c64c8240 = {}));
var $2f512219da033f72$export$938d9fc91bf189e3;
(function(ConfluenceLegacyPtGraphQlPageStatus) {
    ConfluenceLegacyPtGraphQlPageStatus["Current"] = "CURRENT";
    ConfluenceLegacyPtGraphQlPageStatus["Draft"] = "DRAFT";
    ConfluenceLegacyPtGraphQlPageStatus["Historical"] = "HISTORICAL";
    ConfluenceLegacyPtGraphQlPageStatus["Trashed"] = "TRASHED";
})($2f512219da033f72$export$938d9fc91bf189e3 || ($2f512219da033f72$export$938d9fc91bf189e3 = {}));
var $2f512219da033f72$export$32601201a16f0b5d;
(function(ConfluenceLegacyPageActivityAction) {
    ConfluenceLegacyPageActivityAction["Created"] = "created";
    ConfluenceLegacyPageActivityAction["Updated"] = "updated";
})($2f512219da033f72$export$32601201a16f0b5d || ($2f512219da033f72$export$32601201a16f0b5d = {}));
var $2f512219da033f72$export$768747d8a19c91ab;
(function(ConfluenceLegacyPageActivityActionSubject) {
    ConfluenceLegacyPageActivityActionSubject["Comment"] = "comment";
    ConfluenceLegacyPageActivityActionSubject["Page"] = "page";
})($2f512219da033f72$export$768747d8a19c91ab || ($2f512219da033f72$export$768747d8a19c91ab = {}));
var $2f512219da033f72$export$47389b8ef7f23bf3;
(function(ConfluenceLegacyPageAnalyticsCountType) {
    ConfluenceLegacyPageAnalyticsCountType["All"] = "ALL";
    ConfluenceLegacyPageAnalyticsCountType["User"] = "USER";
})($2f512219da033f72$export$47389b8ef7f23bf3 || ($2f512219da033f72$export$47389b8ef7f23bf3 = {}));
var $2f512219da033f72$export$1a9b6173c3040cc0;
(function(ConfluenceLegacyPageAnalyticsTimeseriesCountType) {
    ConfluenceLegacyPageAnalyticsTimeseriesCountType["All"] = "ALL";
})($2f512219da033f72$export$1a9b6173c3040cc0 || ($2f512219da033f72$export$1a9b6173c3040cc0 = {}));
var $2f512219da033f72$export$aa202cd8cef6b1c2;
(function(ConfluenceLegacyPageCardInPageTreeHoverPreference) {
    ConfluenceLegacyPageCardInPageTreeHoverPreference["NoOptionSelected"] = "NO_OPTION_SELECTED";
    ConfluenceLegacyPageCardInPageTreeHoverPreference["NoShowPagecard"] = "NO_SHOW_PAGECARD";
    ConfluenceLegacyPageCardInPageTreeHoverPreference["ShowPagecard"] = "SHOW_PAGECARD";
})($2f512219da033f72$export$aa202cd8cef6b1c2 || ($2f512219da033f72$export$aa202cd8cef6b1c2 = {}));
var $2f512219da033f72$export$865c06c6ecba3931;
(function(ConfluenceLegacyPageCopyRestrictionValidationStatus) {
    ConfluenceLegacyPageCopyRestrictionValidationStatus["InvalidMultiple"] = "INVALID_MULTIPLE";
    ConfluenceLegacyPageCopyRestrictionValidationStatus["InvalidSingle"] = "INVALID_SINGLE";
    ConfluenceLegacyPageCopyRestrictionValidationStatus["Valid"] = "VALID";
})($2f512219da033f72$export$865c06c6ecba3931 || ($2f512219da033f72$export$865c06c6ecba3931 = {}));
var $2f512219da033f72$export$29a013f0158561e;
(function(ConfluenceLegacyPageStatus) {
    ConfluenceLegacyPageStatus["Current"] = "CURRENT";
    ConfluenceLegacyPageStatus["Draft"] = "DRAFT";
    ConfluenceLegacyPageStatus["Historical"] = "HISTORICAL";
    ConfluenceLegacyPageStatus["Trashed"] = "TRASHED";
})($2f512219da033f72$export$29a013f0158561e || ($2f512219da033f72$export$29a013f0158561e = {}));
var $2f512219da033f72$export$cb32a82a68eac3ea;
(function(ConfluenceLegacyPageStatusInput) {
    ConfluenceLegacyPageStatusInput["Current"] = "CURRENT";
    ConfluenceLegacyPageStatusInput["Draft"] = "DRAFT";
})($2f512219da033f72$export$cb32a82a68eac3ea || ($2f512219da033f72$export$cb32a82a68eac3ea = {}));
var $2f512219da033f72$export$88e74ffbe5a7ddc7;
(function(ConfluenceLegacyPageUpdateTrigger) {
    ConfluenceLegacyPageUpdateTrigger["CreatePage"] = "CREATE_PAGE";
    ConfluenceLegacyPageUpdateTrigger["DiscardChanges"] = "DISCARD_CHANGES";
    ConfluenceLegacyPageUpdateTrigger["EditPage"] = "EDIT_PAGE";
    ConfluenceLegacyPageUpdateTrigger["LinkRefactoring"] = "LINK_REFACTORING";
    ConfluenceLegacyPageUpdateTrigger["MigratePageCollab"] = "MIGRATE_PAGE_COLLAB";
    ConfluenceLegacyPageUpdateTrigger["OwnerChange"] = "OWNER_CHANGE";
    ConfluenceLegacyPageUpdateTrigger["PageRename"] = "PAGE_RENAME";
    ConfluenceLegacyPageUpdateTrigger["PersonalTasklist"] = "PERSONAL_TASKLIST";
    ConfluenceLegacyPageUpdateTrigger["Revert"] = "REVERT";
    ConfluenceLegacyPageUpdateTrigger["SpaceCreate"] = "SPACE_CREATE";
    ConfluenceLegacyPageUpdateTrigger["Unknown"] = "UNKNOWN";
    ConfluenceLegacyPageUpdateTrigger["ViewPage"] = "VIEW_PAGE";
})($2f512219da033f72$export$88e74ffbe5a7ddc7 || ($2f512219da033f72$export$88e74ffbe5a7ddc7 = {}));
var $2f512219da033f72$export$e9c8dbdf7b225312;
(function(ConfluenceLegacyPagesDisplayPersistenceOption) {
    ConfluenceLegacyPagesDisplayPersistenceOption["Cards"] = "CARDS";
    ConfluenceLegacyPagesDisplayPersistenceOption["CompactList"] = "COMPACT_LIST";
    ConfluenceLegacyPagesDisplayPersistenceOption["List"] = "LIST";
})($2f512219da033f72$export$e9c8dbdf7b225312 || ($2f512219da033f72$export$e9c8dbdf7b225312 = {}));
var $2f512219da033f72$export$aaf6c229cce2f3b3;
(function(ConfluenceLegacyPagesSortField) {
    ConfluenceLegacyPagesSortField["LastModifiedDate"] = "LAST_MODIFIED_DATE";
    ConfluenceLegacyPagesSortField["Relevant"] = "RELEVANT";
    ConfluenceLegacyPagesSortField["Title"] = "TITLE";
})($2f512219da033f72$export$aaf6c229cce2f3b3 || ($2f512219da033f72$export$aaf6c229cce2f3b3 = {}));
var $2f512219da033f72$export$318b7a7639914e93;
(function(ConfluenceLegacyPagesSortOrder) {
    ConfluenceLegacyPagesSortOrder["Asc"] = "ASC";
    ConfluenceLegacyPagesSortOrder["Desc"] = "DESC";
})($2f512219da033f72$export$318b7a7639914e93 || ($2f512219da033f72$export$318b7a7639914e93 = {}));
var $2f512219da033f72$export$c7738cb0d3dab26f;
(function(ConfluenceLegacyPathType) {
    ConfluenceLegacyPathType["Absolute"] = "ABSOLUTE";
    ConfluenceLegacyPathType["Relative"] = "RELATIVE";
    ConfluenceLegacyPathType["RelativeNoContext"] = "RELATIVE_NO_CONTEXT";
})($2f512219da033f72$export$c7738cb0d3dab26f || ($2f512219da033f72$export$c7738cb0d3dab26f = {}));
var $2f512219da033f72$export$45c5982866ef3f86;
(function(ConfluenceLegacyPaywallStatus) {
    ConfluenceLegacyPaywallStatus["Active"] = "ACTIVE";
    ConfluenceLegacyPaywallStatus["Deactivated"] = "DEACTIVATED";
    ConfluenceLegacyPaywallStatus["Unset"] = "UNSET";
})($2f512219da033f72$export$45c5982866ef3f86 || ($2f512219da033f72$export$45c5982866ef3f86 = {}));
var $2f512219da033f72$export$bdd86c404514bf5e;
(function(ConfluenceLegacyPermissionDisplayType) {
    ConfluenceLegacyPermissionDisplayType["Anonymous"] = "ANONYMOUS";
    ConfluenceLegacyPermissionDisplayType["Group"] = "GROUP";
    ConfluenceLegacyPermissionDisplayType["GuestUser"] = "GUEST_USER";
    ConfluenceLegacyPermissionDisplayType["LicensedUser"] = "LICENSED_USER";
})($2f512219da033f72$export$bdd86c404514bf5e || ($2f512219da033f72$export$bdd86c404514bf5e = {}));
var $2f512219da033f72$export$5e661380a2aa4206;
(function(ConfluenceLegacyPlatform) {
    ConfluenceLegacyPlatform["Android"] = "ANDROID";
    ConfluenceLegacyPlatform["Ios"] = "IOS";
    ConfluenceLegacyPlatform["Web"] = "WEB";
})($2f512219da033f72$export$5e661380a2aa4206 || ($2f512219da033f72$export$5e661380a2aa4206 = {}));
var $2f512219da033f72$export$b8313f5a464cf0ed;
(function(ConfluenceLegacyPremiumToolsDropdownStatus) {
    ConfluenceLegacyPremiumToolsDropdownStatus["Collapsed"] = "COLLAPSED";
    ConfluenceLegacyPremiumToolsDropdownStatus["Expanded"] = "EXPANDED";
    ConfluenceLegacyPremiumToolsDropdownStatus["Unset"] = "UNSET";
})($2f512219da033f72$export$b8313f5a464cf0ed || ($2f512219da033f72$export$b8313f5a464cf0ed = {}));
var $2f512219da033f72$export$44790dd8acc73dd6;
(function(ConfluenceLegacyPrincipalType) {
    ConfluenceLegacyPrincipalType["Group"] = "GROUP";
    ConfluenceLegacyPrincipalType["User"] = "USER";
})($2f512219da033f72$export$44790dd8acc73dd6 || ($2f512219da033f72$export$44790dd8acc73dd6 = {}));
var $2f512219da033f72$export$132f1b98364f7846;
(function(ConfluenceLegacyProduct) {
    ConfluenceLegacyProduct["Confluence"] = "CONFLUENCE";
})($2f512219da033f72$export$132f1b98364f7846 || ($2f512219da033f72$export$132f1b98364f7846 = {}));
var $2f512219da033f72$export$baf22e4384c384d6;
(function(ConfluenceLegacyPublicLinkAdminAction) {
    ConfluenceLegacyPublicLinkAdminAction["Block"] = "BLOCK";
    ConfluenceLegacyPublicLinkAdminAction["Off"] = "OFF";
    ConfluenceLegacyPublicLinkAdminAction["On"] = "ON";
    ConfluenceLegacyPublicLinkAdminAction["Unblock"] = "UNBLOCK";
})($2f512219da033f72$export$baf22e4384c384d6 || ($2f512219da033f72$export$baf22e4384c384d6 = {}));
var $2f512219da033f72$export$6c27a44327a1685c;
(function(ConfluenceLegacyPublicLinkDefaultSpaceStatus) {
    ConfluenceLegacyPublicLinkDefaultSpaceStatus["Off"] = "OFF";
    ConfluenceLegacyPublicLinkDefaultSpaceStatus["On"] = "ON";
})($2f512219da033f72$export$6c27a44327a1685c || ($2f512219da033f72$export$6c27a44327a1685c = {}));
var $2f512219da033f72$export$882b105854002ad0;
(function(ConfluenceLegacyPublicLinkPageStatus) {
    ConfluenceLegacyPublicLinkPageStatus["BlockedByClassificationLevel"] = "BLOCKED_BY_CLASSIFICATION_LEVEL";
    ConfluenceLegacyPublicLinkPageStatus["BlockedByOrg"] = "BLOCKED_BY_ORG";
    ConfluenceLegacyPublicLinkPageStatus["BlockedByProduct"] = "BLOCKED_BY_PRODUCT";
    ConfluenceLegacyPublicLinkPageStatus["BlockedBySpace"] = "BLOCKED_BY_SPACE";
    ConfluenceLegacyPublicLinkPageStatus["Off"] = "OFF";
    ConfluenceLegacyPublicLinkPageStatus["On"] = "ON";
    ConfluenceLegacyPublicLinkPageStatus["SiteBlocked"] = "SITE_BLOCKED";
    ConfluenceLegacyPublicLinkPageStatus["SiteDisabled"] = "SITE_DISABLED";
    ConfluenceLegacyPublicLinkPageStatus["SpaceBlocked"] = "SPACE_BLOCKED";
    ConfluenceLegacyPublicLinkPageStatus["SpaceDisabled"] = "SPACE_DISABLED";
})($2f512219da033f72$export$882b105854002ad0 || ($2f512219da033f72$export$882b105854002ad0 = {}));
var $2f512219da033f72$export$e1e4b830a0825f2b;
(function(ConfluenceLegacyPublicLinkPageStatusFilter) {
    ConfluenceLegacyPublicLinkPageStatusFilter["BlockedByProduct"] = "BLOCKED_BY_PRODUCT";
    ConfluenceLegacyPublicLinkPageStatusFilter["BlockedBySpace"] = "BLOCKED_BY_SPACE";
    ConfluenceLegacyPublicLinkPageStatusFilter["Off"] = "OFF";
    ConfluenceLegacyPublicLinkPageStatusFilter["On"] = "ON";
})($2f512219da033f72$export$e1e4b830a0825f2b || ($2f512219da033f72$export$e1e4b830a0825f2b = {}));
var $2f512219da033f72$export$9acef11a8ce6e3c6;
(function(ConfluenceLegacyPublicLinkPagesByCriteriaOrder) {
    ConfluenceLegacyPublicLinkPagesByCriteriaOrder["DateEnabled"] = "DATE_ENABLED";
    ConfluenceLegacyPublicLinkPagesByCriteriaOrder["Status"] = "STATUS";
    ConfluenceLegacyPublicLinkPagesByCriteriaOrder["Title"] = "TITLE";
})($2f512219da033f72$export$9acef11a8ce6e3c6 || ($2f512219da033f72$export$9acef11a8ce6e3c6 = {}));
var $2f512219da033f72$export$892bc471a65769c0;
(function(ConfluenceLegacyPublicLinkPermissionsObjectType) {
    ConfluenceLegacyPublicLinkPermissionsObjectType["Content"] = "CONTENT";
})($2f512219da033f72$export$892bc471a65769c0 || ($2f512219da033f72$export$892bc471a65769c0 = {}));
var $2f512219da033f72$export$353b2d93c5c6cf5c;
(function(ConfluenceLegacyPublicLinkPermissionsType) {
    ConfluenceLegacyPublicLinkPermissionsType["Edit"] = "EDIT";
})($2f512219da033f72$export$353b2d93c5c6cf5c || ($2f512219da033f72$export$353b2d93c5c6cf5c = {}));
var $2f512219da033f72$export$1363899e44b2229b;
(function(ConfluenceLegacyPublicLinkSiteStatus) {
    ConfluenceLegacyPublicLinkSiteStatus["BlockedByOrg"] = "BLOCKED_BY_ORG";
    ConfluenceLegacyPublicLinkSiteStatus["Off"] = "OFF";
    ConfluenceLegacyPublicLinkSiteStatus["On"] = "ON";
})($2f512219da033f72$export$1363899e44b2229b || ($2f512219da033f72$export$1363899e44b2229b = {}));
var $2f512219da033f72$export$6344a7355e3086d1;
(function(ConfluenceLegacyPublicLinkSpaceStatus) {
    ConfluenceLegacyPublicLinkSpaceStatus["BlockedByOrg"] = "BLOCKED_BY_ORG";
    ConfluenceLegacyPublicLinkSpaceStatus["BlockedByProduct"] = "BLOCKED_BY_PRODUCT";
    ConfluenceLegacyPublicLinkSpaceStatus["Off"] = "OFF";
    ConfluenceLegacyPublicLinkSpaceStatus["On"] = "ON";
})($2f512219da033f72$export$6344a7355e3086d1 || ($2f512219da033f72$export$6344a7355e3086d1 = {}));
var $2f512219da033f72$export$24ea1c3cc5ac9e7d;
(function(ConfluenceLegacyPublicLinkSpacesByCriteriaOrder) {
    ConfluenceLegacyPublicLinkSpacesByCriteriaOrder["ActiveLinks"] = "ACTIVE_LINKS";
    ConfluenceLegacyPublicLinkSpacesByCriteriaOrder["Name"] = "NAME";
    ConfluenceLegacyPublicLinkSpacesByCriteriaOrder["Status"] = "STATUS";
})($2f512219da033f72$export$24ea1c3cc5ac9e7d || ($2f512219da033f72$export$24ea1c3cc5ac9e7d = {}));
var $2f512219da033f72$export$fde6c5e19eaa1054;
(function(ConfluenceLegacyPublicLinkStatus) {
    ConfluenceLegacyPublicLinkStatus["BlockedByClassificationLevel"] = "BLOCKED_BY_CLASSIFICATION_LEVEL";
    ConfluenceLegacyPublicLinkStatus["BlockedByOrg"] = "BLOCKED_BY_ORG";
    ConfluenceLegacyPublicLinkStatus["BlockedByProduct"] = "BLOCKED_BY_PRODUCT";
    ConfluenceLegacyPublicLinkStatus["BlockedBySpace"] = "BLOCKED_BY_SPACE";
    ConfluenceLegacyPublicLinkStatus["Off"] = "OFF";
    ConfluenceLegacyPublicLinkStatus["On"] = "ON";
    ConfluenceLegacyPublicLinkStatus["SiteBlocked"] = "SITE_BLOCKED";
    ConfluenceLegacyPublicLinkStatus["SiteDisabled"] = "SITE_DISABLED";
    ConfluenceLegacyPublicLinkStatus["SpaceBlocked"] = "SPACE_BLOCKED";
    ConfluenceLegacyPublicLinkStatus["SpaceDisabled"] = "SPACE_DISABLED";
})($2f512219da033f72$export$fde6c5e19eaa1054 || ($2f512219da033f72$export$fde6c5e19eaa1054 = {}));
var $2f512219da033f72$export$9b956743b565355b;
(function(ConfluenceLegacyPublicLinksByCriteriaOrder) {
    ConfluenceLegacyPublicLinksByCriteriaOrder["DateEnabled"] = "DATE_ENABLED";
    ConfluenceLegacyPublicLinksByCriteriaOrder["Status"] = "STATUS";
    ConfluenceLegacyPublicLinksByCriteriaOrder["Title"] = "TITLE";
})($2f512219da033f72$export$9b956743b565355b || ($2f512219da033f72$export$9b956743b565355b = {}));
var $2f512219da033f72$export$9e74ac381de41243;
(function(ConfluenceLegacyPushNotificationGroupInputType) {
    ConfluenceLegacyPushNotificationGroupInputType["None"] = "NONE";
    ConfluenceLegacyPushNotificationGroupInputType["Quiet"] = "QUIET";
    ConfluenceLegacyPushNotificationGroupInputType["Standard"] = "STANDARD";
})($2f512219da033f72$export$9e74ac381de41243 || ($2f512219da033f72$export$9e74ac381de41243 = {}));
var $2f512219da033f72$export$4b9d765e6088e3c4;
(function(ConfluenceLegacyPushNotificationSettingGroup) {
    ConfluenceLegacyPushNotificationSettingGroup["Custom"] = "CUSTOM";
    ConfluenceLegacyPushNotificationSettingGroup["None"] = "NONE";
    ConfluenceLegacyPushNotificationSettingGroup["Quiet"] = "QUIET";
    ConfluenceLegacyPushNotificationSettingGroup["Standard"] = "STANDARD";
})($2f512219da033f72$export$4b9d765e6088e3c4 || ($2f512219da033f72$export$4b9d765e6088e3c4 = {}));
var $2f512219da033f72$export$4490245889e26dee;
(function(ConfluenceLegacyReactionContentType) {
    ConfluenceLegacyReactionContentType["Blogpost"] = "BLOGPOST";
    ConfluenceLegacyReactionContentType["Comment"] = "COMMENT";
    ConfluenceLegacyReactionContentType["Page"] = "PAGE";
})($2f512219da033f72$export$4490245889e26dee || ($2f512219da033f72$export$4490245889e26dee = {}));
var $2f512219da033f72$export$74f0035aff7ea1c0;
(function(ConfluenceLegacyRecentFilter) {
    ConfluenceLegacyRecentFilter["All"] = "ALL";
    ConfluenceLegacyRecentFilter["Created"] = "CREATED";
    ConfluenceLegacyRecentFilter["WorkedOn"] = "WORKED_ON";
})($2f512219da033f72$export$74f0035aff7ea1c0 || ($2f512219da033f72$export$74f0035aff7ea1c0 = {}));
var $2f512219da033f72$export$6875c90eb8212aba;
(function(ConfluenceLegacyRecommendedPagesSpaceBehavior) {
    ConfluenceLegacyRecommendedPagesSpaceBehavior["Hidden"] = "HIDDEN";
    ConfluenceLegacyRecommendedPagesSpaceBehavior["Shown"] = "SHOWN";
})($2f512219da033f72$export$6875c90eb8212aba || ($2f512219da033f72$export$6875c90eb8212aba = {}));
var $2f512219da033f72$export$c3e45d6c8873afa5;
(function(ConfluenceLegacyRelationSourceType) {
    ConfluenceLegacyRelationSourceType["User"] = "user";
})($2f512219da033f72$export$c3e45d6c8873afa5 || ($2f512219da033f72$export$c3e45d6c8873afa5 = {}));
var $2f512219da033f72$export$9cbd9eca53d8233e;
(function(ConfluenceLegacyRelationTargetType) {
    ConfluenceLegacyRelationTargetType["Content"] = "content";
    ConfluenceLegacyRelationTargetType["Space"] = "space";
})($2f512219da033f72$export$9cbd9eca53d8233e || ($2f512219da033f72$export$9cbd9eca53d8233e = {}));
var $2f512219da033f72$export$b7e6e1a18c840b8f;
(function(ConfluenceLegacyRelationType) {
    ConfluenceLegacyRelationType["Collaborator"] = "collaborator";
    ConfluenceLegacyRelationType["Favourite"] = "favourite";
    ConfluenceLegacyRelationType["Touched"] = "touched";
})($2f512219da033f72$export$b7e6e1a18c840b8f || ($2f512219da033f72$export$b7e6e1a18c840b8f = {}));
var $2f512219da033f72$export$367b84a88c23075f;
(function(ConfluenceLegacyRelevantUserFilter) {
    ConfluenceLegacyRelevantUserFilter["Collaborators"] = "collaborators";
})($2f512219da033f72$export$367b84a88c23075f || ($2f512219da033f72$export$367b84a88c23075f = {}));
var $2f512219da033f72$export$8b22f13531a8344e;
(function(ConfluenceLegacyRelevantUsersSortOrder) {
    ConfluenceLegacyRelevantUsersSortOrder["Asc"] = "asc";
    ConfluenceLegacyRelevantUsersSortOrder["Desc"] = "desc";
})($2f512219da033f72$export$8b22f13531a8344e || ($2f512219da033f72$export$8b22f13531a8344e = {}));
var $2f512219da033f72$export$376441298d996eee;
(function(ConfluenceLegacyResponseType) {
    ConfluenceLegacyResponseType["BulletListAdf"] = "BULLET_LIST_ADF";
    ConfluenceLegacyResponseType["BulletListMarkdown"] = "BULLET_LIST_MARKDOWN";
    ConfluenceLegacyResponseType["ParagraphPlaintext"] = "PARAGRAPH_PLAINTEXT";
})($2f512219da033f72$export$376441298d996eee || ($2f512219da033f72$export$376441298d996eee = {}));
var $2f512219da033f72$export$7f316768f979019e;
(function(ConfluenceLegacyReverseTrialCohort) {
    ConfluenceLegacyReverseTrialCohort["Control"] = "CONTROL";
    ConfluenceLegacyReverseTrialCohort["Enrolled"] = "ENROLLED";
    ConfluenceLegacyReverseTrialCohort["NotEnrolled"] = "NOT_ENROLLED";
    ConfluenceLegacyReverseTrialCohort["Unassigned"] = "UNASSIGNED";
    ConfluenceLegacyReverseTrialCohort["Unknown"] = "UNKNOWN";
    ConfluenceLegacyReverseTrialCohort["Variant"] = "VARIANT";
})($2f512219da033f72$export$7f316768f979019e || ($2f512219da033f72$export$7f316768f979019e = {}));
var $2f512219da033f72$export$3bf4e8049523f596;
(function(ConfluenceLegacyRevertToLegacyEditorResult) {
    ConfluenceLegacyRevertToLegacyEditorResult["NotReverted"] = "NOT_REVERTED";
    ConfluenceLegacyRevertToLegacyEditorResult["Reverted"] = "REVERTED";
})($2f512219da033f72$export$3bf4e8049523f596 || ($2f512219da033f72$export$3bf4e8049523f596 = {}));
var $2f512219da033f72$export$ef682e8bdb6dbe2e;
(function(ConfluenceLegacyRoleAssignmentPrincipalType) {
    ConfluenceLegacyRoleAssignmentPrincipalType["AccessClass"] = "ACCESS_CLASS";
    ConfluenceLegacyRoleAssignmentPrincipalType["Group"] = "GROUP";
    ConfluenceLegacyRoleAssignmentPrincipalType["Team"] = "TEAM";
    ConfluenceLegacyRoleAssignmentPrincipalType["User"] = "USER";
})($2f512219da033f72$export$ef682e8bdb6dbe2e || ($2f512219da033f72$export$ef682e8bdb6dbe2e = {}));
var $2f512219da033f72$export$e1172c4cec191be2;
(function(ConfluenceLegacySearchesByTermColumns) {
    ConfluenceLegacySearchesByTermColumns["PageViewedPercentage"] = "pageViewedPercentage";
    ConfluenceLegacySearchesByTermColumns["SearchClickCount"] = "searchClickCount";
    ConfluenceLegacySearchesByTermColumns["SearchSessionCount"] = "searchSessionCount";
    ConfluenceLegacySearchesByTermColumns["SearchTerm"] = "searchTerm";
    ConfluenceLegacySearchesByTermColumns["Total"] = "total";
    ConfluenceLegacySearchesByTermColumns["UniqueUsers"] = "uniqueUsers";
})($2f512219da033f72$export$e1172c4cec191be2 || ($2f512219da033f72$export$e1172c4cec191be2 = {}));
var $2f512219da033f72$export$e7d6f21793433a06;
(function(ConfluenceLegacySearchesByTermPeriod) {
    ConfluenceLegacySearchesByTermPeriod["Day"] = "day";
    ConfluenceLegacySearchesByTermPeriod["Month"] = "month";
    ConfluenceLegacySearchesByTermPeriod["Week"] = "week";
})($2f512219da033f72$export$e7d6f21793433a06 || ($2f512219da033f72$export$e7d6f21793433a06 = {}));
var $2f512219da033f72$export$a199f440cd936cc;
(function(ConfluenceLegacyShareType) {
    ConfluenceLegacyShareType["InviteToEdit"] = "INVITE_TO_EDIT";
    ConfluenceLegacyShareType["SharePage"] = "SHARE_PAGE";
})($2f512219da033f72$export$a199f440cd936cc || ($2f512219da033f72$export$a199f440cd936cc = {}));
var $2f512219da033f72$export$5f5a76dd02b1e8f0;
(function(ConfluenceLegacySitePermissionOperationType) {
    ConfluenceLegacySitePermissionOperationType["AdministerConfluence"] = "ADMINISTER_CONFLUENCE";
    ConfluenceLegacySitePermissionOperationType["AdministerSystem"] = "ADMINISTER_SYSTEM";
    ConfluenceLegacySitePermissionOperationType["CreateProfileattachment"] = "CREATE_PROFILEATTACHMENT";
    ConfluenceLegacySitePermissionOperationType["CreateSpace"] = "CREATE_SPACE";
    ConfluenceLegacySitePermissionOperationType["ExternalCollaborator"] = "EXTERNAL_COLLABORATOR";
    ConfluenceLegacySitePermissionOperationType["LimitedUseConfluence"] = "LIMITED_USE_CONFLUENCE";
    ConfluenceLegacySitePermissionOperationType["ReadUserprofile"] = "READ_USERPROFILE";
    ConfluenceLegacySitePermissionOperationType["UpdateUserstatus"] = "UPDATE_USERSTATUS";
    ConfluenceLegacySitePermissionOperationType["UseConfluence"] = "USE_CONFLUENCE";
    ConfluenceLegacySitePermissionOperationType["UsePersonalspace"] = "USE_PERSONALSPACE";
})($2f512219da033f72$export$5f5a76dd02b1e8f0 || ($2f512219da033f72$export$5f5a76dd02b1e8f0 = {}));
var $2f512219da033f72$export$c0dc9e525f1888d7;
(function(ConfluenceLegacySitePermissionType) {
    ConfluenceLegacySitePermissionType["Anonymous"] = "ANONYMOUS";
    ConfluenceLegacySitePermissionType["App"] = "APP";
    ConfluenceLegacySitePermissionType["External"] = "EXTERNAL";
    ConfluenceLegacySitePermissionType["Internal"] = "INTERNAL";
    ConfluenceLegacySitePermissionType["Jsd"] = "JSD";
})($2f512219da033f72$export$c0dc9e525f1888d7 || ($2f512219da033f72$export$c0dc9e525f1888d7 = {}));
var $2f512219da033f72$export$cacd2625b0eb5c10;
(function(ConfluenceLegacySitePermissionTypeFilter) {
    ConfluenceLegacySitePermissionTypeFilter["All"] = "ALL";
    ConfluenceLegacySitePermissionTypeFilter["Externalcollaborator"] = "EXTERNALCOLLABORATOR";
    ConfluenceLegacySitePermissionTypeFilter["None"] = "NONE";
})($2f512219da033f72$export$cacd2625b0eb5c10 || ($2f512219da033f72$export$cacd2625b0eb5c10 = {}));
var $2f512219da033f72$export$3427a291ccf5b35f;
(function(ConfluenceLegacySpaceAssignmentType) {
    ConfluenceLegacySpaceAssignmentType["Assigned"] = "ASSIGNED";
    ConfluenceLegacySpaceAssignmentType["Unassigned"] = "UNASSIGNED";
})($2f512219da033f72$export$3427a291ccf5b35f || ($2f512219da033f72$export$3427a291ccf5b35f = {}));
var $2f512219da033f72$export$66c6ff50e2fe5ded;
(function(ConfluenceLegacySpacePermissionType) {
    ConfluenceLegacySpacePermissionType["AdministerSpace"] = "ADMINISTER_SPACE";
    ConfluenceLegacySpacePermissionType["ArchivePage"] = "ARCHIVE_PAGE";
    ConfluenceLegacySpacePermissionType["Comment"] = "COMMENT";
    ConfluenceLegacySpacePermissionType["CreateAttachment"] = "CREATE_ATTACHMENT";
    ConfluenceLegacySpacePermissionType["CreateEditPage"] = "CREATE_EDIT_PAGE";
    ConfluenceLegacySpacePermissionType["EditBlog"] = "EDIT_BLOG";
    ConfluenceLegacySpacePermissionType["ExportPage"] = "EXPORT_PAGE";
    ConfluenceLegacySpacePermissionType["ExportSpace"] = "EXPORT_SPACE";
    ConfluenceLegacySpacePermissionType["RemoveAttachment"] = "REMOVE_ATTACHMENT";
    ConfluenceLegacySpacePermissionType["RemoveBlog"] = "REMOVE_BLOG";
    ConfluenceLegacySpacePermissionType["RemoveComment"] = "REMOVE_COMMENT";
    ConfluenceLegacySpacePermissionType["RemoveMail"] = "REMOVE_MAIL";
    ConfluenceLegacySpacePermissionType["RemoveOwnContent"] = "REMOVE_OWN_CONTENT";
    ConfluenceLegacySpacePermissionType["RemovePage"] = "REMOVE_PAGE";
    ConfluenceLegacySpacePermissionType["SetPagePermissions"] = "SET_PAGE_PERMISSIONS";
    ConfluenceLegacySpacePermissionType["ViewSpace"] = "VIEW_SPACE";
})($2f512219da033f72$export$66c6ff50e2fe5ded || ($2f512219da033f72$export$66c6ff50e2fe5ded = {}));
var $2f512219da033f72$export$f324862e9abce9a4;
(function(ConfluenceLegacySpaceRoleType) {
    ConfluenceLegacySpaceRoleType["Custom"] = "CUSTOM";
    ConfluenceLegacySpaceRoleType["System"] = "SYSTEM";
})($2f512219da033f72$export$f324862e9abce9a4 || ($2f512219da033f72$export$f324862e9abce9a4 = {}));
var $2f512219da033f72$export$a816519a4452de22;
(function(ConfluenceLegacySpaceSidebarLinkType) {
    ConfluenceLegacySpaceSidebarLinkType["ExternalLink"] = "EXTERNAL_LINK";
    ConfluenceLegacySpaceSidebarLinkType["Forge"] = "FORGE";
    ConfluenceLegacySpaceSidebarLinkType["PinnedAttachment"] = "PINNED_ATTACHMENT";
    ConfluenceLegacySpaceSidebarLinkType["PinnedBlogPost"] = "PINNED_BLOG_POST";
    ConfluenceLegacySpaceSidebarLinkType["PinnedPage"] = "PINNED_PAGE";
    ConfluenceLegacySpaceSidebarLinkType["PinnedSpace"] = "PINNED_SPACE";
    ConfluenceLegacySpaceSidebarLinkType["PinnedUserInfo"] = "PINNED_USER_INFO";
    ConfluenceLegacySpaceSidebarLinkType["WebItem"] = "WEB_ITEM";
})($2f512219da033f72$export$a816519a4452de22 || ($2f512219da033f72$export$a816519a4452de22 = {}));
var $2f512219da033f72$export$4f08231b454021a7;
(function(ConfluenceLegacySpaceViewsPersistenceOption) {
    ConfluenceLegacySpaceViewsPersistenceOption["Popularity"] = "POPULARITY";
    ConfluenceLegacySpaceViewsPersistenceOption["RecentlyModified"] = "RECENTLY_MODIFIED";
    ConfluenceLegacySpaceViewsPersistenceOption["RecentlyViewed"] = "RECENTLY_VIEWED";
    ConfluenceLegacySpaceViewsPersistenceOption["TitleAz"] = "TITLE_AZ";
    ConfluenceLegacySpaceViewsPersistenceOption["Tree"] = "TREE";
})($2f512219da033f72$export$4f08231b454021a7 || ($2f512219da033f72$export$4f08231b454021a7 = {}));
var $2f512219da033f72$export$b1fc899dd9dab99c;
(function(ConfluenceLegacyStalePageStatus) {
    ConfluenceLegacyStalePageStatus["Archived"] = "ARCHIVED";
    ConfluenceLegacyStalePageStatus["Current"] = "CURRENT";
    ConfluenceLegacyStalePageStatus["Draft"] = "DRAFT";
})($2f512219da033f72$export$b1fc899dd9dab99c || ($2f512219da033f72$export$b1fc899dd9dab99c = {}));
var $2f512219da033f72$export$52d6eaeb13b767d7;
(function(ConfluenceLegacyStalePagesSortingType) {
    ConfluenceLegacyStalePagesSortingType["Asc"] = "ASC";
    ConfluenceLegacyStalePagesSortingType["Desc"] = "DESC";
})($2f512219da033f72$export$52d6eaeb13b767d7 || ($2f512219da033f72$export$52d6eaeb13b767d7 = {}));
var $2f512219da033f72$export$2ef0672a533512e5;
(function(ConfluenceLegacySummaryType) {
    ConfluenceLegacySummaryType["Blogpost"] = "BLOGPOST";
    ConfluenceLegacySummaryType["Page"] = "PAGE";
})($2f512219da033f72$export$2ef0672a533512e5 || ($2f512219da033f72$export$2ef0672a533512e5 = {}));
var $2f512219da033f72$export$ac9323de0f6ac2f9;
(function(ConfluenceLegacySystemSpaceHomepageTemplate) {
    ConfluenceLegacySystemSpaceHomepageTemplate["Eap"] = "EAP";
    ConfluenceLegacySystemSpaceHomepageTemplate["Minimal"] = "MINIMAL";
    ConfluenceLegacySystemSpaceHomepageTemplate["Visual"] = "VISUAL";
})($2f512219da033f72$export$ac9323de0f6ac2f9 || ($2f512219da033f72$export$ac9323de0f6ac2f9 = {}));
var $2f512219da033f72$export$d926f0433bfa5cfe;
(function(ConfluenceLegacyTaskStatus) {
    ConfluenceLegacyTaskStatus["Checked"] = "CHECKED";
    ConfluenceLegacyTaskStatus["Unchecked"] = "UNCHECKED";
})($2f512219da033f72$export$d926f0433bfa5cfe || ($2f512219da033f72$export$d926f0433bfa5cfe = {}));
var $2f512219da033f72$export$e59d52222a05db4a;
(function(ConfluenceLegacyTeamCalendarDayOfWeek) {
    ConfluenceLegacyTeamCalendarDayOfWeek["Friday"] = "FRIDAY";
    ConfluenceLegacyTeamCalendarDayOfWeek["Monday"] = "MONDAY";
    ConfluenceLegacyTeamCalendarDayOfWeek["Saturday"] = "SATURDAY";
    ConfluenceLegacyTeamCalendarDayOfWeek["Sunday"] = "SUNDAY";
    ConfluenceLegacyTeamCalendarDayOfWeek["Thursday"] = "THURSDAY";
    ConfluenceLegacyTeamCalendarDayOfWeek["Tuesday"] = "TUESDAY";
    ConfluenceLegacyTeamCalendarDayOfWeek["Wednesday"] = "WEDNESDAY";
})($2f512219da033f72$export$e59d52222a05db4a || ($2f512219da033f72$export$e59d52222a05db4a = {}));
var $2f512219da033f72$export$6fa4f21ea723a4cf;
(function(ConfluenceLegacyTemplateContentAppearance) {
    ConfluenceLegacyTemplateContentAppearance["Default"] = "DEFAULT";
    ConfluenceLegacyTemplateContentAppearance["FullWidth"] = "FULL_WIDTH";
})($2f512219da033f72$export$6fa4f21ea723a4cf || ($2f512219da033f72$export$6fa4f21ea723a4cf = {}));
var $2f512219da033f72$export$a883f3365032d0b5;
(function(ConfluenceMutationContentStatus) {
    ConfluenceMutationContentStatus["Current"] = "CURRENT";
    ConfluenceMutationContentStatus["Draft"] = "DRAFT";
})($2f512219da033f72$export$a883f3365032d0b5 || ($2f512219da033f72$export$a883f3365032d0b5 = {}));
var $2f512219da033f72$export$629c17cb184cb2f;
(function(ConfluenceOperationName) {
    ConfluenceOperationName["Administer"] = "ADMINISTER";
    ConfluenceOperationName["Archive"] = "ARCHIVE";
    ConfluenceOperationName["Copy"] = "COPY";
    ConfluenceOperationName["Create"] = "CREATE";
    ConfluenceOperationName["CreateSpace"] = "CREATE_SPACE";
    ConfluenceOperationName["Delete"] = "DELETE";
    ConfluenceOperationName["Export"] = "EXPORT";
    ConfluenceOperationName["Move"] = "MOVE";
    ConfluenceOperationName["Purge"] = "PURGE";
    ConfluenceOperationName["PurgeVersion"] = "PURGE_VERSION";
    ConfluenceOperationName["Read"] = "READ";
    ConfluenceOperationName["Restore"] = "RESTORE";
    ConfluenceOperationName["RestrictContent"] = "RESTRICT_CONTENT";
    ConfluenceOperationName["Update"] = "UPDATE";
    ConfluenceOperationName["Use"] = "USE";
})($2f512219da033f72$export$629c17cb184cb2f || ($2f512219da033f72$export$629c17cb184cb2f = {}));
var $2f512219da033f72$export$406af9bbda9174f7;
(function(ConfluenceOperationTarget) {
    ConfluenceOperationTarget["Application"] = "APPLICATION";
    ConfluenceOperationTarget["Attachment"] = "ATTACHMENT";
    ConfluenceOperationTarget["BlogPost"] = "BLOG_POST";
    ConfluenceOperationTarget["Comment"] = "COMMENT";
    ConfluenceOperationTarget["Page"] = "PAGE";
    ConfluenceOperationTarget["Space"] = "SPACE";
    ConfluenceOperationTarget["UserProfile"] = "USER_PROFILE";
})($2f512219da033f72$export$406af9bbda9174f7 || ($2f512219da033f72$export$406af9bbda9174f7 = {}));
var $2f512219da033f72$export$b9563c27e132ecf3;
(function(ConfluencePageStatus) {
    ConfluencePageStatus["Archived"] = "ARCHIVED";
    ConfluencePageStatus["Current"] = "CURRENT";
    ConfluencePageStatus["Deleted"] = "DELETED";
    ConfluencePageStatus["Draft"] = "DRAFT";
    ConfluencePageStatus["Historical"] = "HISTORICAL";
    ConfluencePageStatus["Trashed"] = "TRASHED";
})($2f512219da033f72$export$b9563c27e132ecf3 || ($2f512219da033f72$export$b9563c27e132ecf3 = {}));
var $2f512219da033f72$export$c5ec0cc4d455d1c8;
(function(ConfluencePageSubType) {
    ConfluencePageSubType["Live"] = "LIVE";
})($2f512219da033f72$export$c5ec0cc4d455d1c8 || ($2f512219da033f72$export$c5ec0cc4d455d1c8 = {}));
var $2f512219da033f72$export$aa5f3445d469c06b;
(function(ConfluencePrincipalType) {
    ConfluencePrincipalType["Group"] = "GROUP";
    ConfluencePrincipalType["User"] = "USER";
})($2f512219da033f72$export$aa5f3445d469c06b || ($2f512219da033f72$export$aa5f3445d469c06b = {}));
var $2f512219da033f72$export$cb561d9d6bab5f1a;
(function(ConfluenceSpaceOwnerType) {
    ConfluenceSpaceOwnerType["Group"] = "GROUP";
    ConfluenceSpaceOwnerType["User"] = "USER";
})($2f512219da033f72$export$cb561d9d6bab5f1a || ($2f512219da033f72$export$cb561d9d6bab5f1a = {}));
var $2f512219da033f72$export$d939b611ae8d039c;
(function(ConfluenceSpaceSettingEditorVersion) {
    ConfluenceSpaceSettingEditorVersion["V1"] = "V1";
    ConfluenceSpaceSettingEditorVersion["V2"] = "V2";
})($2f512219da033f72$export$d939b611ae8d039c || ($2f512219da033f72$export$d939b611ae8d039c = {}));
var $2f512219da033f72$export$2607d60870895ed3;
(function(ConfluenceSpaceStatus) {
    ConfluenceSpaceStatus["Archived"] = "ARCHIVED";
    ConfluenceSpaceStatus["Current"] = "CURRENT";
})($2f512219da033f72$export$2607d60870895ed3 || ($2f512219da033f72$export$2607d60870895ed3 = {}));
var $2f512219da033f72$export$2fabe69f8125d5a7;
(function(ConfluenceSpaceType) {
    ConfluenceSpaceType["Global"] = "GLOBAL";
    ConfluenceSpaceType["Personal"] = "PERSONAL";
})($2f512219da033f72$export$2fabe69f8125d5a7 || ($2f512219da033f72$export$2fabe69f8125d5a7 = {}));
var $2f512219da033f72$export$8d1e87378f89fa9c;
(function(ConfluenceSubscriptionContentType) {
    ConfluenceSubscriptionContentType["Blogpost"] = "BLOGPOST";
    ConfluenceSubscriptionContentType["Comment"] = "COMMENT";
    ConfluenceSubscriptionContentType["Database"] = "DATABASE";
    ConfluenceSubscriptionContentType["Embed"] = "EMBED";
    ConfluenceSubscriptionContentType["Folder"] = "FOLDER";
    ConfluenceSubscriptionContentType["Page"] = "PAGE";
    ConfluenceSubscriptionContentType["Whiteboard"] = "WHITEBOARD";
})($2f512219da033f72$export$8d1e87378f89fa9c || ($2f512219da033f72$export$8d1e87378f89fa9c = {}));
var $2f512219da033f72$export$5053ac532e22e9b7;
(function(ConfluenceUserType) {
    ConfluenceUserType["Anonymous"] = "ANONYMOUS";
    ConfluenceUserType["Known"] = "KNOWN";
})($2f512219da033f72$export$5053ac532e22e9b7 || ($2f512219da033f72$export$5053ac532e22e9b7 = {}));
var $2f512219da033f72$export$c41bae9247aa23d6;
(function(ContactAdminPageDisabledReason) {
    ContactAdminPageDisabledReason["ConfigOff"] = "CONFIG_OFF";
    ContactAdminPageDisabledReason["NoAdminEmails"] = "NO_ADMIN_EMAILS";
    ContactAdminPageDisabledReason["NoMailServer"] = "NO_MAIL_SERVER";
    ContactAdminPageDisabledReason["NoRecaptcha"] = "NO_RECAPTCHA";
})($2f512219da033f72$export$c41bae9247aa23d6 || ($2f512219da033f72$export$c41bae9247aa23d6 = {}));
var $2f512219da033f72$export$7d7a98f44861e6f7;
(function(ContainerType) {
    ContainerType["Blogpost"] = "BLOGPOST";
    ContainerType["Database"] = "DATABASE";
    ContainerType["Page"] = "PAGE";
    ContainerType["Space"] = "SPACE";
    ContainerType["Whiteboard"] = "WHITEBOARD";
})($2f512219da033f72$export$7d7a98f44861e6f7 || ($2f512219da033f72$export$7d7a98f44861e6f7 = {}));
var $2f512219da033f72$export$2a508539b9b026e5;
(function(ContentAccessInputType) {
    ContentAccessInputType["EveryoneCanEdit"] = "EVERYONE_CAN_EDIT";
    ContentAccessInputType["EveryoneCanView"] = "EVERYONE_CAN_VIEW";
    ContentAccessInputType["EveryoneNoAccess"] = "EVERYONE_NO_ACCESS";
    ContentAccessInputType["Private"] = "PRIVATE";
})($2f512219da033f72$export$2a508539b9b026e5 || ($2f512219da033f72$export$2a508539b9b026e5 = {}));
var $2f512219da033f72$export$95c15c503cf0205e;
(function(ContentAccessType) {
    ContentAccessType["EveryoneCanEdit"] = "EVERYONE_CAN_EDIT";
    ContentAccessType["EveryoneCanView"] = "EVERYONE_CAN_VIEW";
    ContentAccessType["EveryoneNoAccess"] = "EVERYONE_NO_ACCESS";
})($2f512219da033f72$export$95c15c503cf0205e || ($2f512219da033f72$export$95c15c503cf0205e = {}));
var $2f512219da033f72$export$5ddd00ae853474f4;
(function(ContentAction) {
    ContentAction["Created"] = "created";
    ContentAction["Updated"] = "updated";
    ContentAction["Viewed"] = "viewed";
})($2f512219da033f72$export$5ddd00ae853474f4 || ($2f512219da033f72$export$5ddd00ae853474f4 = {}));
var $2f512219da033f72$export$8be450ac125d65b9;
(function(ContentDataClassificationMutationContentStatus) {
    ContentDataClassificationMutationContentStatus["Current"] = "CURRENT";
    ContentDataClassificationMutationContentStatus["Draft"] = "DRAFT";
})($2f512219da033f72$export$8be450ac125d65b9 || ($2f512219da033f72$export$8be450ac125d65b9 = {}));
var $2f512219da033f72$export$78f7f4ebab34552e;
(function(ContentDataClassificationQueryContentStatus) {
    ContentDataClassificationQueryContentStatus["Archived"] = "ARCHIVED";
    ContentDataClassificationQueryContentStatus["Current"] = "CURRENT";
    ContentDataClassificationQueryContentStatus["Draft"] = "DRAFT";
})($2f512219da033f72$export$78f7f4ebab34552e || ($2f512219da033f72$export$78f7f4ebab34552e = {}));
var $2f512219da033f72$export$e0db935847b66dda;
(function(ContentDeleteActionType) {
    ContentDeleteActionType["DeleteDraft"] = "DELETE_DRAFT";
    ContentDeleteActionType["DeleteDraftIfBlank"] = "DELETE_DRAFT_IF_BLANK";
    ContentDeleteActionType["MoveToTrash"] = "MOVE_TO_TRASH";
    ContentDeleteActionType["PurgeFromTrash"] = "PURGE_FROM_TRASH";
})($2f512219da033f72$export$e0db935847b66dda || ($2f512219da033f72$export$e0db935847b66dda = {}));
var $2f512219da033f72$export$7c562381fe299c25;
(function(ContentPermissionType) {
    ContentPermissionType["Edit"] = "EDIT";
    ContentPermissionType["View"] = "VIEW";
})($2f512219da033f72$export$7c562381fe299c25 || ($2f512219da033f72$export$7c562381fe299c25 = {}));
var $2f512219da033f72$export$62c53e2e83119144;
(function(ContentPlatformBooleanOperators) {
    ContentPlatformBooleanOperators["And"] = "AND";
    ContentPlatformBooleanOperators["Or"] = "OR";
})($2f512219da033f72$export$62c53e2e83119144 || ($2f512219da033f72$export$62c53e2e83119144 = {}));
var $2f512219da033f72$export$70152384a4eb0e06;
(function(ContentPlatformFieldNames) {
    ContentPlatformFieldNames["Description"] = "DESCRIPTION";
    ContentPlatformFieldNames["Title"] = "TITLE";
})($2f512219da033f72$export$70152384a4eb0e06 || ($2f512219da033f72$export$70152384a4eb0e06 = {}));
var $2f512219da033f72$export$c05e625f37f1df6a;
(function(ContentPlatformOperators) {
    ContentPlatformOperators["All"] = "ALL";
    ContentPlatformOperators["Any"] = "ANY";
})($2f512219da033f72$export$c05e625f37f1df6a || ($2f512219da033f72$export$c05e625f37f1df6a = {}));
var $2f512219da033f72$export$e4bac19bb31c7d1;
(function(ContentPlatformSearchTypes) {
    ContentPlatformSearchTypes["Contains"] = "CONTAINS";
    ContentPlatformSearchTypes["ExactMatch"] = "EXACT_MATCH";
})($2f512219da033f72$export$e4bac19bb31c7d1 || ($2f512219da033f72$export$e4bac19bb31c7d1 = {}));
var $2f512219da033f72$export$65352d71e8010518;
(function(ContentRendererMode) {
    ContentRendererMode["Editor"] = "EDITOR";
    ContentRendererMode["Pdf"] = "PDF";
    ContentRendererMode["Renderer"] = "RENDERER";
})($2f512219da033f72$export$65352d71e8010518 || ($2f512219da033f72$export$65352d71e8010518 = {}));
var $2f512219da033f72$export$f4016897b165b6d5;
(function(ContentRepresentation) {
    ContentRepresentation["AtlasDocFormat"] = "ATLAS_DOC_FORMAT";
    ContentRepresentation["Editor"] = "EDITOR";
    ContentRepresentation["Editor2"] = "EDITOR2";
    ContentRepresentation["ExportView"] = "EXPORT_VIEW";
    ContentRepresentation["Plain"] = "PLAIN";
    ContentRepresentation["Raw"] = "RAW";
    ContentRepresentation["Storage"] = "STORAGE";
    ContentRepresentation["StyledView"] = "STYLED_VIEW";
    ContentRepresentation["View"] = "VIEW";
    ContentRepresentation["Wiki"] = "WIKI";
})($2f512219da033f72$export$f4016897b165b6d5 || ($2f512219da033f72$export$f4016897b165b6d5 = {}));
var $2f512219da033f72$export$4fd34ed002cf6bfb;
(function(ContentRole) {
    ContentRole["Default"] = "DEFAULT";
    ContentRole["Editor"] = "EDITOR";
    ContentRole["Viewer"] = "VIEWER";
})($2f512219da033f72$export$4fd34ed002cf6bfb || ($2f512219da033f72$export$4fd34ed002cf6bfb = {}));
var $2f512219da033f72$export$ae77e0661f173b68;
(function(ContentStateRestrictionLevel) {
    ContentStateRestrictionLevel["None"] = "NONE";
    ContentStateRestrictionLevel["PageOwner"] = "PAGE_OWNER";
})($2f512219da033f72$export$ae77e0661f173b68 || ($2f512219da033f72$export$ae77e0661f173b68 = {}));
var $2f512219da033f72$export$2f3f99f16bab5cdf;
(function(CustomEntityAttributeType) {
    CustomEntityAttributeType["Any"] = "any";
    CustomEntityAttributeType["Boolean"] = "boolean";
    CustomEntityAttributeType["Float"] = "float";
    CustomEntityAttributeType["Integer"] = "integer";
    CustomEntityAttributeType["String"] = "string";
})($2f512219da033f72$export$2f3f99f16bab5cdf || ($2f512219da033f72$export$2f3f99f16bab5cdf = {}));
var $2f512219da033f72$export$54f78149dae8a06c;
(function(CustomEntityIndexStatus) {
    CustomEntityIndexStatus["Active"] = "ACTIVE";
    CustomEntityIndexStatus["Creating"] = "CREATING";
    CustomEntityIndexStatus["Inactive"] = "INACTIVE";
    CustomEntityIndexStatus["Pending"] = "PENDING";
})($2f512219da033f72$export$54f78149dae8a06c || ($2f512219da033f72$export$54f78149dae8a06c = {}));
var $2f512219da033f72$export$aecc53098eb55beb;
(function(CustomEntityStatus) {
    CustomEntityStatus["Active"] = "ACTIVE";
    CustomEntityStatus["Inactive"] = "INACTIVE";
})($2f512219da033f72$export$aecc53098eb55beb || ($2f512219da033f72$export$aecc53098eb55beb = {}));
var $2f512219da033f72$export$fe1e5623f79b2657;
(function(CustomMultiselectFieldInputComparators) {
    CustomMultiselectFieldInputComparators["ContainAll"] = "CONTAIN_ALL";
    CustomMultiselectFieldInputComparators["ContainAny"] = "CONTAIN_ANY";
    CustomMultiselectFieldInputComparators["ContainNone"] = "CONTAIN_NONE";
    CustomMultiselectFieldInputComparators["IsSet"] = "IS_SET";
    CustomMultiselectFieldInputComparators["NotSet"] = "NOT_SET";
})($2f512219da033f72$export$fe1e5623f79b2657 || ($2f512219da033f72$export$fe1e5623f79b2657 = {}));
var $2f512219da033f72$export$697ee3a30c96e362;
(function(CustomNumberFieldInputComparators) {
    CustomNumberFieldInputComparators["IsSet"] = "IS_SET";
    CustomNumberFieldInputComparators["NotSet"] = "NOT_SET";
})($2f512219da033f72$export$697ee3a30c96e362 || ($2f512219da033f72$export$697ee3a30c96e362 = {}));
var $2f512219da033f72$export$1035e8ccd79c3a50;
(function(CustomSingleSelectFieldInputComparators) {
    CustomSingleSelectFieldInputComparators["ContainAny"] = "CONTAIN_ANY";
    CustomSingleSelectFieldInputComparators["ContainNone"] = "CONTAIN_NONE";
    CustomSingleSelectFieldInputComparators["IsSet"] = "IS_SET";
    CustomSingleSelectFieldInputComparators["NotSet"] = "NOT_SET";
})($2f512219da033f72$export$1035e8ccd79c3a50 || ($2f512219da033f72$export$1035e8ccd79c3a50 = {}));
var $2f512219da033f72$export$10f65c018dc4a5c1;
(function(CustomTextFieldInputComparators) {
    CustomTextFieldInputComparators["IsSet"] = "IS_SET";
    CustomTextFieldInputComparators["NotSet"] = "NOT_SET";
})($2f512219da033f72$export$10f65c018dc4a5c1 || ($2f512219da033f72$export$10f65c018dc4a5c1 = {}));
var $2f512219da033f72$export$227a3c742efa1bf3;
(function(CustomUserFieldInputComparators) {
    CustomUserFieldInputComparators["ContainAny"] = "CONTAIN_ANY";
    CustomUserFieldInputComparators["IsSet"] = "IS_SET";
    CustomUserFieldInputComparators["NotSet"] = "NOT_SET";
})($2f512219da033f72$export$227a3c742efa1bf3 || ($2f512219da033f72$export$227a3c742efa1bf3 = {}));
var $2f512219da033f72$export$17ade050935780b6;
(function(CustomerServiceAttributeTypeName) {
    CustomerServiceAttributeTypeName["Boolean"] = "BOOLEAN";
    CustomerServiceAttributeTypeName["Date"] = "DATE";
    CustomerServiceAttributeTypeName["Email"] = "EMAIL";
    CustomerServiceAttributeTypeName["Multiselect"] = "MULTISELECT";
    CustomerServiceAttributeTypeName["Number"] = "NUMBER";
    CustomerServiceAttributeTypeName["Phone"] = "PHONE";
    CustomerServiceAttributeTypeName["Select"] = "SELECT";
    CustomerServiceAttributeTypeName["Text"] = "TEXT";
    CustomerServiceAttributeTypeName["Url"] = "URL";
    CustomerServiceAttributeTypeName["User"] = "USER";
})($2f512219da033f72$export$17ade050935780b6 || ($2f512219da033f72$export$17ade050935780b6 = {}));
var $2f512219da033f72$export$98afe1d41a26dd3b;
(function(CustomerServiceContextType) {
    /** Organization/Customer Details View */ CustomerServiceContextType["Default"] = "DEFAULT";
    /** Jira Issue View */ CustomerServiceContextType["Issue"] = "ISSUE";
})($2f512219da033f72$export$98afe1d41a26dd3b || ($2f512219da033f72$export$98afe1d41a26dd3b = {}));
var $2f512219da033f72$export$65378626fab83b8;
(function(CustomerServiceCustomDetailCreateErrorCode) {
    CustomerServiceCustomDetailCreateErrorCode["ColorNotSaved"] = "COLOR_NOT_SAVED";
    CustomerServiceCustomDetailCreateErrorCode["PermissionsNotSaved"] = "PERMISSIONS_NOT_SAVED";
})($2f512219da033f72$export$65378626fab83b8 || ($2f512219da033f72$export$65378626fab83b8 = {}));
var $2f512219da033f72$export$b39410ef8fd0f614;
(function(CustomerServiceCustomDetailTypeName) {
    CustomerServiceCustomDetailTypeName["Boolean"] = "BOOLEAN";
    CustomerServiceCustomDetailTypeName["Date"] = "DATE";
    CustomerServiceCustomDetailTypeName["Email"] = "EMAIL";
    CustomerServiceCustomDetailTypeName["Multiselect"] = "MULTISELECT";
    CustomerServiceCustomDetailTypeName["Number"] = "NUMBER";
    CustomerServiceCustomDetailTypeName["Phone"] = "PHONE";
    CustomerServiceCustomDetailTypeName["Select"] = "SELECT";
    CustomerServiceCustomDetailTypeName["Text"] = "TEXT";
    CustomerServiceCustomDetailTypeName["Url"] = "URL";
    CustomerServiceCustomDetailTypeName["User"] = "USER";
})($2f512219da033f72$export$b39410ef8fd0f614 || ($2f512219da033f72$export$b39410ef8fd0f614 = {}));
var $2f512219da033f72$export$c8c77ee10baacd37;
(function(CustomerServiceCustomDetailsEntityType) {
    CustomerServiceCustomDetailsEntityType["Customer"] = "CUSTOMER";
    CustomerServiceCustomDetailsEntityType["Entitlement"] = "ENTITLEMENT";
    CustomerServiceCustomDetailsEntityType["Organization"] = "ORGANIZATION";
})($2f512219da033f72$export$c8c77ee10baacd37 || ($2f512219da033f72$export$c8c77ee10baacd37 = {}));
var $2f512219da033f72$export$beae497f7881e8b9;
(function(CustomerServiceNoteEntity) {
    CustomerServiceNoteEntity["Customer"] = "CUSTOMER";
    CustomerServiceNoteEntity["Organization"] = "ORGANIZATION";
})($2f512219da033f72$export$beae497f7881e8b9 || ($2f512219da033f72$export$beae497f7881e8b9 = {}));
var $2f512219da033f72$export$950a886e1d68d5;
(function(CustomerServicePermissionGroupType) {
    CustomerServicePermissionGroupType["Admins"] = "ADMINS";
    CustomerServicePermissionGroupType["AdminsAgents"] = "ADMINS_AGENTS";
    CustomerServicePermissionGroupType["AdminsAgentsSiteAccess"] = "ADMINS_AGENTS_SITE_ACCESS";
})($2f512219da033f72$export$950a886e1d68d5 || ($2f512219da033f72$export$950a886e1d68d5 = {}));
var $2f512219da033f72$export$94dacf0afef67abf;
(function(DataClassificationPolicyDecisionStatus) {
    DataClassificationPolicyDecisionStatus["Allowed"] = "ALLOWED";
    DataClassificationPolicyDecisionStatus["Blocked"] = "BLOCKED";
})($2f512219da033f72$export$94dacf0afef67abf || ($2f512219da033f72$export$94dacf0afef67abf = {}));
var $2f512219da033f72$export$e3d8cf42d600c426;
(function(DataResidencyResponse) {
    DataResidencyResponse["AppDoesNotSupportDr"] = "APP_DOES_NOT_SUPPORT_DR";
    DataResidencyResponse["NotApplicable"] = "NOT_APPLICABLE";
    DataResidencyResponse["StoredExternalToAtlassian"] = "STORED_EXTERNAL_TO_ATLASSIAN";
    DataResidencyResponse["StoredInAtlassianAndDrNotSupported"] = "STORED_IN_ATLASSIAN_AND_DR_NOT_SUPPORTED";
    DataResidencyResponse["StoredInAtlassianAndDrSupported"] = "STORED_IN_ATLASSIAN_AND_DR_SUPPORTED";
})($2f512219da033f72$export$e3d8cf42d600c426 || ($2f512219da033f72$export$e3d8cf42d600c426 = {}));
var $2f512219da033f72$export$852364220ec700a8;
(function(DataSecurityPolicyAction) {
    DataSecurityPolicyAction["AiAccess"] = "AI_ACCESS";
    DataSecurityPolicyAction["AppAccess"] = "APP_ACCESS";
    DataSecurityPolicyAction["PageExport"] = "PAGE_EXPORT";
    DataSecurityPolicyAction["PublicLinks"] = "PUBLIC_LINKS";
})($2f512219da033f72$export$852364220ec700a8 || ($2f512219da033f72$export$852364220ec700a8 = {}));
var $2f512219da033f72$export$ef1af5f765744ec8;
(function(DataSecurityPolicyCoverageType) {
    DataSecurityPolicyCoverageType["ClassificationLevel"] = "CLASSIFICATION_LEVEL";
    DataSecurityPolicyCoverageType["Container"] = "CONTAINER";
    DataSecurityPolicyCoverageType["None"] = "NONE";
    DataSecurityPolicyCoverageType["Workspace"] = "WORKSPACE";
})($2f512219da033f72$export$ef1af5f765744ec8 || ($2f512219da033f72$export$ef1af5f765744ec8 = {}));
var $2f512219da033f72$export$3c5b314640ce2287;
(function(DataSecurityPolicyDecidableContentStatus) {
    DataSecurityPolicyDecidableContentStatus["Archived"] = "ARCHIVED";
    DataSecurityPolicyDecidableContentStatus["Current"] = "CURRENT";
    DataSecurityPolicyDecidableContentStatus["Draft"] = "DRAFT";
})($2f512219da033f72$export$3c5b314640ce2287 || ($2f512219da033f72$export$3c5b314640ce2287 = {}));
var $2f512219da033f72$export$52da9d0dfdf48c77;
(function(DeactivatedPageOwnerUserType) {
    DeactivatedPageOwnerUserType["FormerUsers"] = "FORMER_USERS";
    DeactivatedPageOwnerUserType["NonFormerUsers"] = "NON_FORMER_USERS";
})($2f512219da033f72$export$52da9d0dfdf48c77 || ($2f512219da033f72$export$52da9d0dfdf48c77 = {}));
var $2f512219da033f72$export$a12a01ce2571070a;
(function(DeploymentState) {
    DeploymentState["Cancelled"] = "CANCELLED";
    DeploymentState["Failed"] = "FAILED";
    DeploymentState["InProgress"] = "IN_PROGRESS";
    DeploymentState["Pending"] = "PENDING";
    DeploymentState["RolledBack"] = "ROLLED_BACK";
    DeploymentState["Successful"] = "SUCCESSFUL";
    DeploymentState["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$a12a01ce2571070a || ($2f512219da033f72$export$a12a01ce2571070a = {}));
var $2f512219da033f72$export$950556173b6cbecb;
(function(Depth) {
    Depth["All"] = "ALL";
    Depth["Root"] = "ROOT";
})($2f512219da033f72$export$950556173b6cbecb || ($2f512219da033f72$export$950556173b6cbecb = {}));
var $2f512219da033f72$export$9b81d39c063708b1;
(function(DescendantsNoteApplicationOption) {
    DescendantsNoteApplicationOption["All"] = "ALL";
    DescendantsNoteApplicationOption["None"] = "NONE";
    DescendantsNoteApplicationOption["Roots"] = "ROOTS";
})($2f512219da033f72$export$9b81d39c063708b1 || ($2f512219da033f72$export$9b81d39c063708b1 = {}));
var $2f512219da033f72$export$20937a979d4c4d41;
(function(DevAiAutodevLogGroupPhase) {
    DevAiAutodevLogGroupPhase["CodeGenerating"] = "CODE_GENERATING";
    DevAiAutodevLogGroupPhase["CodeReview"] = "CODE_REVIEW";
    DevAiAutodevLogGroupPhase["CodeReGenerating"] = "CODE_RE_GENERATING";
    DevAiAutodevLogGroupPhase["PlanGenerating"] = "PLAN_GENERATING";
    DevAiAutodevLogGroupPhase["PlanReview"] = "PLAN_REVIEW";
    DevAiAutodevLogGroupPhase["PlanReGenerating"] = "PLAN_RE_GENERATING";
})($2f512219da033f72$export$20937a979d4c4d41 || ($2f512219da033f72$export$20937a979d4c4d41 = {}));
var $2f512219da033f72$export$5a2d7037a146a719;
(function(DevAiAutodevLogGroupStatus) {
    DevAiAutodevLogGroupStatus["Completed"] = "COMPLETED";
    DevAiAutodevLogGroupStatus["Failed"] = "FAILED";
    DevAiAutodevLogGroupStatus["InProgress"] = "IN_PROGRESS";
})($2f512219da033f72$export$5a2d7037a146a719 || ($2f512219da033f72$export$5a2d7037a146a719 = {}));
var $2f512219da033f72$export$c42b77140e980ae5;
(function(DevAiAutodevLogPhase) {
    DevAiAutodevLogPhase["CodeGenerating"] = "CODE_GENERATING";
    DevAiAutodevLogPhase["CodeReview"] = "CODE_REVIEW";
    DevAiAutodevLogPhase["CodeReGenerating"] = "CODE_RE_GENERATING";
    DevAiAutodevLogPhase["PlanGenerating"] = "PLAN_GENERATING";
    DevAiAutodevLogPhase["PlanReview"] = "PLAN_REVIEW";
    DevAiAutodevLogPhase["PlanReGenerating"] = "PLAN_RE_GENERATING";
})($2f512219da033f72$export$c42b77140e980ae5 || ($2f512219da033f72$export$c42b77140e980ae5 = {}));
var $2f512219da033f72$export$1cbb2b7e845365d0;
(function(DevAiAutodevLogPriority) {
    DevAiAutodevLogPriority["Lowest"] = "LOWEST";
    DevAiAutodevLogPriority["Medium"] = "MEDIUM";
})($2f512219da033f72$export$1cbb2b7e845365d0 || ($2f512219da033f72$export$1cbb2b7e845365d0 = {}));
var $2f512219da033f72$export$34a002c2ec8c2de5;
(function(DevAiAutodevLogStatus) {
    DevAiAutodevLogStatus["Completed"] = "COMPLETED";
    DevAiAutodevLogStatus["Failed"] = "FAILED";
    DevAiAutodevLogStatus["InProgress"] = "IN_PROGRESS";
})($2f512219da033f72$export$34a002c2ec8c2de5 || ($2f512219da033f72$export$34a002c2ec8c2de5 = {}));
var $2f512219da033f72$export$63bd3fb0666e773f;
(function(DevAiAutofixScanSortField) {
    DevAiAutofixScanSortField["StartDate"] = "START_DATE";
})($2f512219da033f72$export$63bd3fb0666e773f || ($2f512219da033f72$export$63bd3fb0666e773f = {}));
var $2f512219da033f72$export$f25325441f229f64;
(function(DevAiAutofixScanStatus) {
    DevAiAutofixScanStatus["Completed"] = "COMPLETED";
    DevAiAutofixScanStatus["Failed"] = "FAILED";
    DevAiAutofixScanStatus["InProgress"] = "IN_PROGRESS";
})($2f512219da033f72$export$f25325441f229f64 || ($2f512219da033f72$export$f25325441f229f64 = {}));
var $2f512219da033f72$export$d09e4c4b79589a66;
(function(DevAiAutofixTaskSortField) {
    DevAiAutofixTaskSortField["CreatedAt"] = "CREATED_AT";
    DevAiAutofixTaskSortField["Filename"] = "FILENAME";
    DevAiAutofixTaskSortField["NewCoveragePercentage"] = "NEW_COVERAGE_PERCENTAGE";
    DevAiAutofixTaskSortField["PreviousCoveragePercentage"] = "PREVIOUS_COVERAGE_PERCENTAGE";
    DevAiAutofixTaskSortField["PrimaryLanguage"] = "PRIMARY_LANGUAGE";
    DevAiAutofixTaskSortField["Status"] = "STATUS";
    DevAiAutofixTaskSortField["UpdatedAt"] = "UPDATED_AT";
})($2f512219da033f72$export$d09e4c4b79589a66 || ($2f512219da033f72$export$d09e4c4b79589a66 = {}));
var $2f512219da033f72$export$265f04bd9f283d5d;
(function(DevAiAutofixTaskStatus) {
    DevAiAutofixTaskStatus["PrDeclined"] = "PR_DECLINED";
    DevAiAutofixTaskStatus["PrMerged"] = "PR_MERGED";
    DevAiAutofixTaskStatus["PrOpened"] = "PR_OPENED";
    DevAiAutofixTaskStatus["WorkflowCancelled"] = "WORKFLOW_CANCELLED";
    DevAiAutofixTaskStatus["WorkflowCompleted"] = "WORKFLOW_COMPLETED";
    DevAiAutofixTaskStatus["WorkflowInprogress"] = "WORKFLOW_INPROGRESS";
    DevAiAutofixTaskStatus["WorkflowPending"] = "WORKFLOW_PENDING";
})($2f512219da033f72$export$265f04bd9f283d5d || ($2f512219da033f72$export$265f04bd9f283d5d = {}));
var $2f512219da033f72$export$1112f8236c3a931a;
(function(DevAiIssueScopingLabel) {
    DevAiIssueScopingLabel["Complex"] = "COMPLEX";
    DevAiIssueScopingLabel["InScope"] = "IN_SCOPE";
    DevAiIssueScopingLabel["Optimal"] = "OPTIMAL";
    DevAiIssueScopingLabel["Recoverable"] = "RECOVERABLE";
    DevAiIssueScopingLabel["Unsolvable"] = "UNSOLVABLE";
})($2f512219da033f72$export$1112f8236c3a931a || ($2f512219da033f72$export$1112f8236c3a931a = {}));
var $2f512219da033f72$export$81ed66d7c104abd5;
(function(DevAiRovoAgentTemplateFilter) {
    DevAiRovoAgentTemplateFilter["Exclude"] = "EXCLUDE";
    DevAiRovoAgentTemplateFilter["Include"] = "INCLUDE";
    DevAiRovoAgentTemplateFilter["Only"] = "ONLY";
})($2f512219da033f72$export$81ed66d7c104abd5 || ($2f512219da033f72$export$81ed66d7c104abd5 = {}));
var $2f512219da033f72$export$e81a3fe0d2b413f;
(function(DevAiScanIntervalUnit) {
    DevAiScanIntervalUnit["Days"] = "DAYS";
    DevAiScanIntervalUnit["Months"] = "MONTHS";
    DevAiScanIntervalUnit["Weeks"] = "WEEKS";
})($2f512219da033f72$export$e81a3fe0d2b413f || ($2f512219da033f72$export$e81a3fe0d2b413f = {}));
var $2f512219da033f72$export$bfbfde65991aaecf;
(function(DevAiSupportedRepoFilterOption) {
    DevAiSupportedRepoFilterOption["All"] = "ALL";
    DevAiSupportedRepoFilterOption["DisabledOnly"] = "DISABLED_ONLY";
    DevAiSupportedRepoFilterOption["EnabledOnly"] = "ENABLED_ONLY";
})($2f512219da033f72$export$bfbfde65991aaecf || ($2f512219da033f72$export$bfbfde65991aaecf = {}));
var $2f512219da033f72$export$3ecfde2cf6de114a;
(function(DevAiWorkflowRunStatus) {
    DevAiWorkflowRunStatus["Cancelled"] = "CANCELLED";
    DevAiWorkflowRunStatus["Completed"] = "COMPLETED";
    DevAiWorkflowRunStatus["Failed"] = "FAILED";
    DevAiWorkflowRunStatus["InProgress"] = "IN_PROGRESS";
    DevAiWorkflowRunStatus["Pending"] = "PENDING";
})($2f512219da033f72$export$3ecfde2cf6de114a || ($2f512219da033f72$export$3ecfde2cf6de114a = {}));
var $2f512219da033f72$export$38ae85b0603265fc;
(function(DevOpsBuildState) {
    /** The build has been cancelled or stopped. */ DevOpsBuildState["Cancelled"] = "CANCELLED";
    /** The build failed. */ DevOpsBuildState["Failed"] = "FAILED";
    /** The build is currently running. */ DevOpsBuildState["InProgress"] = "IN_PROGRESS";
    /** The build is queued, or some manual action is required. */ DevOpsBuildState["Pending"] = "PENDING";
    /** The build completed successfully. */ DevOpsBuildState["Successful"] = "SUCCESSFUL";
    /** The build is in an unknown state. */ DevOpsBuildState["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$38ae85b0603265fc || ($2f512219da033f72$export$38ae85b0603265fc = {}));
var $2f512219da033f72$export$e81f0008646134d2;
(function(DevOpsComponentTier) {
    DevOpsComponentTier["Tier_1"] = "TIER_1";
    DevOpsComponentTier["Tier_2"] = "TIER_2";
    DevOpsComponentTier["Tier_3"] = "TIER_3";
    DevOpsComponentTier["Tier_4"] = "TIER_4";
})($2f512219da033f72$export$e81f0008646134d2 || ($2f512219da033f72$export$e81f0008646134d2 = {}));
var $2f512219da033f72$export$1ecef45184e0481;
(function(DevOpsComponentType) {
    DevOpsComponentType["Application"] = "APPLICATION";
    DevOpsComponentType["Capability"] = "CAPABILITY";
    DevOpsComponentType["CloudResource"] = "CLOUD_RESOURCE";
    DevOpsComponentType["DataPipeline"] = "DATA_PIPELINE";
    DevOpsComponentType["Library"] = "LIBRARY";
    DevOpsComponentType["MachineLearningModel"] = "MACHINE_LEARNING_MODEL";
    DevOpsComponentType["Other"] = "OTHER";
    DevOpsComponentType["Service"] = "SERVICE";
    DevOpsComponentType["UiElement"] = "UI_ELEMENT";
    DevOpsComponentType["Website"] = "WEBSITE";
})($2f512219da033f72$export$1ecef45184e0481 || ($2f512219da033f72$export$1ecef45184e0481 = {}));
var $2f512219da033f72$export$8e9c2240003b2ba6;
(function(DevOpsDesignStatus) {
    DevOpsDesignStatus["None"] = "NONE";
    DevOpsDesignStatus["ReadyForDevelopment"] = "READY_FOR_DEVELOPMENT";
    DevOpsDesignStatus["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$8e9c2240003b2ba6 || ($2f512219da033f72$export$8e9c2240003b2ba6 = {}));
var $2f512219da033f72$export$279a4200dae77ac6;
(function(DevOpsDesignType) {
    DevOpsDesignType["Canvas"] = "CANVAS";
    DevOpsDesignType["File"] = "FILE";
    DevOpsDesignType["Group"] = "GROUP";
    DevOpsDesignType["Node"] = "NODE";
    DevOpsDesignType["Other"] = "OTHER";
    DevOpsDesignType["Prototype"] = "PROTOTYPE";
})($2f512219da033f72$export$279a4200dae77ac6 || ($2f512219da033f72$export$279a4200dae77ac6 = {}));
var $2f512219da033f72$export$eeb884a29ae659e4;
(function(DevOpsDocumentCategory) {
    DevOpsDocumentCategory["Archive"] = "ARCHIVE";
    DevOpsDocumentCategory["Audio"] = "AUDIO";
    DevOpsDocumentCategory["Code"] = "CODE";
    DevOpsDocumentCategory["Document"] = "DOCUMENT";
    DevOpsDocumentCategory["Folder"] = "FOLDER";
    DevOpsDocumentCategory["Form"] = "FORM";
    DevOpsDocumentCategory["Image"] = "IMAGE";
    DevOpsDocumentCategory["Other"] = "OTHER";
    DevOpsDocumentCategory["Pdf"] = "PDF";
    DevOpsDocumentCategory["Presentation"] = "PRESENTATION";
    DevOpsDocumentCategory["Shortcut"] = "SHORTCUT";
    DevOpsDocumentCategory["Spreadsheet"] = "SPREADSHEET";
    DevOpsDocumentCategory["Video"] = "VIDEO";
})($2f512219da033f72$export$eeb884a29ae659e4 || ($2f512219da033f72$export$eeb884a29ae659e4 = {}));
var $2f512219da033f72$export$d897dc8d29fd16eb;
(function(DevOpsEnvironmentCategory) {
    DevOpsEnvironmentCategory["Development"] = "DEVELOPMENT";
    DevOpsEnvironmentCategory["Production"] = "PRODUCTION";
    DevOpsEnvironmentCategory["Staging"] = "STAGING";
    DevOpsEnvironmentCategory["Testing"] = "TESTING";
    DevOpsEnvironmentCategory["Unmapped"] = "UNMAPPED";
})($2f512219da033f72$export$d897dc8d29fd16eb || ($2f512219da033f72$export$d897dc8d29fd16eb = {}));
var $2f512219da033f72$export$18fde50976ec82dd;
(function(DevOpsMetricsCycleTimePhase) {
    /** Development phase from initial code commit to deployed code. */ DevOpsMetricsCycleTimePhase["CommitToDeployment"] = "COMMIT_TO_DEPLOYMENT";
    /** Development phase from initial code commit to opened pull request. */ DevOpsMetricsCycleTimePhase["CommitToPr"] = "COMMIT_TO_PR";
})($2f512219da033f72$export$18fde50976ec82dd || ($2f512219da033f72$export$18fde50976ec82dd = {}));
var $2f512219da033f72$export$1f082d6bdd7f11d5;
(function(DevOpsMetricsResolutionUnit) {
    DevOpsMetricsResolutionUnit["Day"] = "DAY";
    DevOpsMetricsResolutionUnit["Hour"] = "HOUR";
    DevOpsMetricsResolutionUnit["Week"] = "WEEK";
})($2f512219da033f72$export$1f082d6bdd7f11d5 || ($2f512219da033f72$export$1f082d6bdd7f11d5 = {}));
var $2f512219da033f72$export$fdde013eb4eeffed;
(function(DevOpsMetricsRollupOption) {
    DevOpsMetricsRollupOption["Mean"] = "MEAN";
    DevOpsMetricsRollupOption["Percentile"] = "PERCENTILE";
})($2f512219da033f72$export$fdde013eb4eeffed || ($2f512219da033f72$export$fdde013eb4eeffed = {}));
var $2f512219da033f72$export$ab7231643ddbb509;
(function(DevOpsOperationsIncidentSeverity) {
    DevOpsOperationsIncidentSeverity["P1"] = "P1";
    DevOpsOperationsIncidentSeverity["P2"] = "P2";
    DevOpsOperationsIncidentSeverity["P3"] = "P3";
    DevOpsOperationsIncidentSeverity["P4"] = "P4";
    DevOpsOperationsIncidentSeverity["P5"] = "P5";
    DevOpsOperationsIncidentSeverity["Pending"] = "PENDING";
    DevOpsOperationsIncidentSeverity["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$ab7231643ddbb509 || ($2f512219da033f72$export$ab7231643ddbb509 = {}));
var $2f512219da033f72$export$3ef3f18ee7a943de;
(function(DevOpsOperationsIncidentStatus) {
    DevOpsOperationsIncidentStatus["Open"] = "OPEN";
    DevOpsOperationsIncidentStatus["Resolved"] = "RESOLVED";
    DevOpsOperationsIncidentStatus["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$3ef3f18ee7a943de || ($2f512219da033f72$export$3ef3f18ee7a943de = {}));
var $2f512219da033f72$export$1c5eb757d029c7d0;
(function(DevOpsPostIncidentReviewStatus) {
    DevOpsPostIncidentReviewStatus["Completed"] = "COMPLETED";
    DevOpsPostIncidentReviewStatus["InProgress"] = "IN_PROGRESS";
    DevOpsPostIncidentReviewStatus["Todo"] = "TODO";
})($2f512219da033f72$export$1c5eb757d029c7d0 || ($2f512219da033f72$export$1c5eb757d029c7d0 = {}));
var $2f512219da033f72$export$8fd61af3426661d5;
(function(DevOpsProjectStatus) {
    DevOpsProjectStatus["Cancelled"] = "CANCELLED";
    DevOpsProjectStatus["Completed"] = "COMPLETED";
    DevOpsProjectStatus["InProgress"] = "IN_PROGRESS";
    DevOpsProjectStatus["Paused"] = "PAUSED";
    DevOpsProjectStatus["Pending"] = "PENDING";
    DevOpsProjectStatus["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$8fd61af3426661d5 || ($2f512219da033f72$export$8fd61af3426661d5 = {}));
var $2f512219da033f72$export$3ba9c1ac88495bed;
(function(DevOpsProjectTargetDateType) {
    DevOpsProjectTargetDateType["Day"] = "DAY";
    DevOpsProjectTargetDateType["Month"] = "MONTH";
    DevOpsProjectTargetDateType["Quarter"] = "QUARTER";
    DevOpsProjectTargetDateType["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$3ba9c1ac88495bed || ($2f512219da033f72$export$3ba9c1ac88495bed = {}));
var $2f512219da033f72$export$2190b10e3dc81d80;
(function(DevOpsProviderNamespace) {
    DevOpsProviderNamespace["Asap"] = "ASAP";
    DevOpsProviderNamespace["Classic"] = "CLASSIC";
    DevOpsProviderNamespace["Forge"] = "FORGE";
    DevOpsProviderNamespace["Oauth"] = "OAUTH";
})($2f512219da033f72$export$2190b10e3dc81d80 || ($2f512219da033f72$export$2190b10e3dc81d80 = {}));
var $2f512219da033f72$export$e0671d592d4ff2a3;
(function(DevOpsProviderType) {
    DevOpsProviderType["Build"] = "BUILD";
    DevOpsProviderType["Deployment"] = "DEPLOYMENT";
    DevOpsProviderType["Design"] = "DESIGN";
    DevOpsProviderType["DevopsComponents"] = "DEVOPS_COMPONENTS";
    DevOpsProviderType["DevInfo"] = "DEV_INFO";
    DevOpsProviderType["Documentation"] = "DOCUMENTATION";
    DevOpsProviderType["FeatureFlag"] = "FEATURE_FLAG";
    DevOpsProviderType["Operations"] = "OPERATIONS";
    DevOpsProviderType["Project"] = "PROJECT";
    DevOpsProviderType["RemoteLinks"] = "REMOTE_LINKS";
    DevOpsProviderType["Security"] = "SECURITY";
})($2f512219da033f72$export$e0671d592d4ff2a3 || ($2f512219da033f72$export$e0671d592d4ff2a3 = {}));
var $2f512219da033f72$export$4ccf930134e74702;
(function(DevOpsPullRequestApprovalStatus) {
    DevOpsPullRequestApprovalStatus["Approved"] = "APPROVED";
    DevOpsPullRequestApprovalStatus["Needswork"] = "NEEDSWORK";
    DevOpsPullRequestApprovalStatus["Unapproved"] = "UNAPPROVED";
})($2f512219da033f72$export$4ccf930134e74702 || ($2f512219da033f72$export$4ccf930134e74702 = {}));
var $2f512219da033f72$export$4dec602c1ab1d95e;
(function(DevOpsPullRequestStatus) {
    DevOpsPullRequestStatus["Declined"] = "DECLINED";
    DevOpsPullRequestStatus["Draft"] = "DRAFT";
    DevOpsPullRequestStatus["Merged"] = "MERGED";
    DevOpsPullRequestStatus["Open"] = "OPEN";
    DevOpsPullRequestStatus["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$4dec602c1ab1d95e || ($2f512219da033f72$export$4dec602c1ab1d95e = {}));
var $2f512219da033f72$export$13a31923d75e3a27;
(function(DevOpsRelationshipCertainty) {
    /** The relationship was created by a user. */ DevOpsRelationshipCertainty["Explicit"] = "EXPLICIT";
    /** The relationship was inferred by a system. */ DevOpsRelationshipCertainty["Implicit"] = "IMPLICIT";
})($2f512219da033f72$export$13a31923d75e3a27 || ($2f512219da033f72$export$13a31923d75e3a27 = {}));
var $2f512219da033f72$export$c5657a9969e35205;
(function(DevOpsRelationshipCertaintyFilter) {
    /** Return all relationships. */ DevOpsRelationshipCertaintyFilter["All"] = "ALL";
    /** Return only relationships created by a user. */ DevOpsRelationshipCertaintyFilter["Explicit"] = "EXPLICIT";
    /** Return only relationships inferred by a system. */ DevOpsRelationshipCertaintyFilter["Implicit"] = "IMPLICIT";
})($2f512219da033f72$export$c5657a9969e35205 || ($2f512219da033f72$export$c5657a9969e35205 = {}));
var $2f512219da033f72$export$15a0db675256459b;
(function(DevOpsRepositoryHostingProviderFilter) {
    DevOpsRepositoryHostingProviderFilter["All"] = "ALL";
    DevOpsRepositoryHostingProviderFilter["BitbucketCloud"] = "BITBUCKET_CLOUD";
    DevOpsRepositoryHostingProviderFilter["ThirdParty"] = "THIRD_PARTY";
})($2f512219da033f72$export$15a0db675256459b || ($2f512219da033f72$export$15a0db675256459b = {}));
var $2f512219da033f72$export$24e732e98f25b4d9;
(function(DevOpsSecurityVulnerabilitySeverity) {
    DevOpsSecurityVulnerabilitySeverity["Critical"] = "CRITICAL";
    DevOpsSecurityVulnerabilitySeverity["High"] = "HIGH";
    DevOpsSecurityVulnerabilitySeverity["Low"] = "LOW";
    DevOpsSecurityVulnerabilitySeverity["Medium"] = "MEDIUM";
    DevOpsSecurityVulnerabilitySeverity["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$24e732e98f25b4d9 || ($2f512219da033f72$export$24e732e98f25b4d9 = {}));
var $2f512219da033f72$export$a1202d25589419a7;
(function(DevOpsSecurityVulnerabilityStatus) {
    DevOpsSecurityVulnerabilityStatus["Closed"] = "CLOSED";
    DevOpsSecurityVulnerabilityStatus["Ignored"] = "IGNORED";
    DevOpsSecurityVulnerabilityStatus["Open"] = "OPEN";
    DevOpsSecurityVulnerabilityStatus["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$a1202d25589419a7 || ($2f512219da033f72$export$a1202d25589419a7 = {}));
var $2f512219da033f72$export$82bbaba9292627e1;
(function(DevOpsServiceAndJiraProjectRelationshipType) {
    /** A relationship created for the change management feature */ DevOpsServiceAndJiraProjectRelationshipType["ChangeManagement"] = "CHANGE_MANAGEMENT";
    /** A standard relationship */ DevOpsServiceAndJiraProjectRelationshipType["Default"] = "DEFAULT";
})($2f512219da033f72$export$82bbaba9292627e1 || ($2f512219da033f72$export$82bbaba9292627e1 = {}));
var $2f512219da033f72$export$c3e0b3161314e204;
(function(DevOpsServiceAndRepositoryRelationshipSortBy) {
    DevOpsServiceAndRepositoryRelationshipSortBy["LastInferredAt"] = "LAST_INFERRED_AT";
})($2f512219da033f72$export$c3e0b3161314e204 || ($2f512219da033f72$export$c3e0b3161314e204 = {}));
var $2f512219da033f72$export$cd3c7b586cbb9da5;
(function(DevOpsServiceRelationshipType) {
    DevOpsServiceRelationshipType["Contains"] = "CONTAINS";
    DevOpsServiceRelationshipType["DependsOn"] = "DEPENDS_ON";
})($2f512219da033f72$export$cd3c7b586cbb9da5 || ($2f512219da033f72$export$cd3c7b586cbb9da5 = {}));
var $2f512219da033f72$export$b4d01a63edd297ec;
(function(DevOpsToolIntegrationType) {
    DevOpsToolIntegrationType["Any"] = "ANY";
    DevOpsToolIntegrationType["App"] = "APP";
    DevOpsToolIntegrationType["Exists"] = "EXISTS";
    DevOpsToolIntegrationType["None"] = "NONE";
    DevOpsToolIntegrationType["Product"] = "PRODUCT";
})($2f512219da033f72$export$b4d01a63edd297ec || ($2f512219da033f72$export$b4d01a63edd297ec = {}));
var $2f512219da033f72$export$1371117f8b853f61;
(function(DevOpsToolSortOrder) {
    DevOpsToolSortOrder["Asc"] = "ASC";
    DevOpsToolSortOrder["Desc"] = "DESC";
})($2f512219da033f72$export$1371117f8b853f61 || ($2f512219da033f72$export$1371117f8b853f61 = {}));
var $2f512219da033f72$export$861966f1b6eab176;
(function(DevStatusActivity) {
    DevStatusActivity["BranchOpen"] = "BRANCH_OPEN";
    DevStatusActivity["Commit"] = "COMMIT";
    DevStatusActivity["Deployment"] = "DEPLOYMENT";
    DevStatusActivity["Design"] = "DESIGN";
    DevStatusActivity["PrDeclined"] = "PR_DECLINED";
    DevStatusActivity["PrMerged"] = "PR_MERGED";
    DevStatusActivity["PrOpen"] = "PR_OPEN";
})($2f512219da033f72$export$861966f1b6eab176 || ($2f512219da033f72$export$861966f1b6eab176 = {}));
var $2f512219da033f72$export$7f74a797185e6d9a;
(function(DistributionStatus) {
    DistributionStatus["Development"] = "DEVELOPMENT";
    DistributionStatus["Public"] = "PUBLIC";
})($2f512219da033f72$export$7f74a797185e6d9a || ($2f512219da033f72$export$7f74a797185e6d9a = {}));
var $2f512219da033f72$export$897cd61e9bfdceb5;
(function(DocumentRepresentation) {
    DocumentRepresentation["AtlasDocFormat"] = "ATLAS_DOC_FORMAT";
    DocumentRepresentation["Html"] = "HTML";
    DocumentRepresentation["Storage"] = "STORAGE";
    DocumentRepresentation["View"] = "VIEW";
})($2f512219da033f72$export$897cd61e9bfdceb5 || ($2f512219da033f72$export$897cd61e9bfdceb5 = {}));
var $2f512219da033f72$export$c7d26868f7f0cc94;
(function(EcosystemAppInstallationConfigIdType) {
    EcosystemAppInstallationConfigIdType["Cloud"] = "CLOUD";
    /** Config applies to all installations belonging to a specific site (cloud ID) */ EcosystemAppInstallationConfigIdType["Installation"] = "INSTALLATION";
})($2f512219da033f72$export$c7d26868f7f0cc94 || ($2f512219da033f72$export$c7d26868f7f0cc94 = {}));
var $2f512219da033f72$export$250c76f3771f8949;
(function(EcosystemAppNetworkPermissionType) {
    EcosystemAppNetworkPermissionType["Connect"] = "CONNECT";
})($2f512219da033f72$export$250c76f3771f8949 || ($2f512219da033f72$export$250c76f3771f8949 = {}));
var $2f512219da033f72$export$f432b7347a6f0100;
(function(EcosystemAppsInstalledInContextsFilterType) {
    /**
   * Only supports one name in the values list for now, otherwise will fail
   * validation.
   */ EcosystemAppsInstalledInContextsFilterType["Name"] = "NAME";
    /**
   * Returns apps filtered by the ARIs passed in the values list, as an exact match with its id
   * or the ARI generated from its latest migration keys for harmonised apps
   */ EcosystemAppsInstalledInContextsFilterType["OnlyAppIds"] = "ONLY_APP_IDS";
})($2f512219da033f72$export$f432b7347a6f0100 || ($2f512219da033f72$export$f432b7347a6f0100 = {}));
var $2f512219da033f72$export$123dfeb539fdf7e4;
(function(EcosystemAppsInstalledInContextsSortKey) {
    EcosystemAppsInstalledInContextsSortKey["Name"] = "NAME";
    EcosystemAppsInstalledInContextsSortKey["RelatedApps"] = "RELATED_APPS";
})($2f512219da033f72$export$123dfeb539fdf7e4 || ($2f512219da033f72$export$123dfeb539fdf7e4 = {}));
var $2f512219da033f72$export$95cd1c8d0204c6ec;
(function(EcosystemGlobalInstallationOverrideKeys) {
    EcosystemGlobalInstallationOverrideKeys["AllowEgressAnalytics"] = "ALLOW_EGRESS_ANALYTICS";
    EcosystemGlobalInstallationOverrideKeys["AllowLogsAccess"] = "ALLOW_LOGS_ACCESS";
})($2f512219da033f72$export$95cd1c8d0204c6ec || ($2f512219da033f72$export$95cd1c8d0204c6ec = {}));
var $2f512219da033f72$export$386c5c1977e3445;
(function(EcosystemInstallationOverrideKeys) {
    EcosystemInstallationOverrideKeys["AllowEgressAnalytics"] = "ALLOW_EGRESS_ANALYTICS";
})($2f512219da033f72$export$386c5c1977e3445 || ($2f512219da033f72$export$386c5c1977e3445 = {}));
var $2f512219da033f72$export$68e24bad3a2118f8;
(function(EcosystemInstallationRecoveryMode) {
    EcosystemInstallationRecoveryMode["FreshInstall"] = "FRESH_INSTALL";
    EcosystemInstallationRecoveryMode["RecoverPreviousInstall"] = "RECOVER_PREVIOUS_INSTALL";
})($2f512219da033f72$export$68e24bad3a2118f8 || ($2f512219da033f72$export$68e24bad3a2118f8 = {}));
var $2f512219da033f72$export$c8914e6b1e019577;
(function(EcosystemLicenseMode) {
    EcosystemLicenseMode["Agent"] = "AGENT";
    EcosystemLicenseMode["UserAccess"] = "USER_ACCESS";
})($2f512219da033f72$export$c8914e6b1e019577 || ($2f512219da033f72$export$c8914e6b1e019577 = {}));
var $2f512219da033f72$export$a787a627cae22ccc;
(function(EcosystemRequiredProduct) {
    EcosystemRequiredProduct["Compass"] = "COMPASS";
    EcosystemRequiredProduct["Confluence"] = "CONFLUENCE";
    EcosystemRequiredProduct["Jira"] = "JIRA";
})($2f512219da033f72$export$a787a627cae22ccc || ($2f512219da033f72$export$a787a627cae22ccc = {}));
var $2f512219da033f72$export$9270b4856dd262c;
(function(EditorConversionSetting) {
    EditorConversionSetting["None"] = "NONE";
    EditorConversionSetting["Supported"] = "SUPPORTED";
})($2f512219da033f72$export$9270b4856dd262c || ($2f512219da033f72$export$9270b4856dd262c = {}));
var $2f512219da033f72$export$7dc6752a22ab011a;
(function(Environment) {
    Environment["Development"] = "DEVELOPMENT";
    Environment["Production"] = "PRODUCTION";
    Environment["Staging"] = "STAGING";
})($2f512219da033f72$export$7dc6752a22ab011a || ($2f512219da033f72$export$7dc6752a22ab011a = {}));
var $2f512219da033f72$export$38fe23235d685c0d;
(function(EstimationType) {
    EstimationType["CustomNumberField"] = "CUSTOM_NUMBER_FIELD";
    EstimationType["IssueCount"] = "ISSUE_COUNT";
    EstimationType["OriginalEstimate"] = "ORIGINAL_ESTIMATE";
    EstimationType["StoryPoints"] = "STORY_POINTS";
})($2f512219da033f72$export$38fe23235d685c0d || ($2f512219da033f72$export$38fe23235d685c0d = {}));
var $2f512219da033f72$export$f7fc910e99a97ad;
(function(ExtensionContextsFilterType) {
    /** Filters extensions by App ID and Environment ID. Format is 'appId:environmentId'. */ ExtensionContextsFilterType["AppIdEnvironmentId"] = "APP_ID_ENVIRONMENT_ID";
    ExtensionContextsFilterType["DataClassificationTag"] = "DATA_CLASSIFICATION_TAG";
    /** Filters extensions by Definition ID. */ ExtensionContextsFilterType["DefinitionId"] = "DEFINITION_ID";
    ExtensionContextsFilterType["ExtensionType"] = "EXTENSION_TYPE";
    /** Filters extensions by principal type. Supported values are: 'unlicensed', 'customer', 'anonymous'. */ ExtensionContextsFilterType["PrincipalType"] = "PRINCIPAL_TYPE";
})($2f512219da033f72$export$f7fc910e99a97ad || ($2f512219da033f72$export$f7fc910e99a97ad = {}));
var $2f512219da033f72$export$d11f0d213b47454b;
(function(ExternalApprovalStatus) {
    ExternalApprovalStatus["Approved"] = "APPROVED";
    ExternalApprovalStatus["Needswork"] = "NEEDSWORK";
    ExternalApprovalStatus["Unapproved"] = "UNAPPROVED";
})($2f512219da033f72$export$d11f0d213b47454b || ($2f512219da033f72$export$d11f0d213b47454b = {}));
var $2f512219da033f72$export$2b73fd69b8f5a9bd;
(function(ExternalAttendeeRsvpStatus) {
    ExternalAttendeeRsvpStatus["Accepted"] = "ACCEPTED";
    ExternalAttendeeRsvpStatus["Declined"] = "DECLINED";
    ExternalAttendeeRsvpStatus["NotResponded"] = "NOT_RESPONDED";
    ExternalAttendeeRsvpStatus["Other"] = "OTHER";
    ExternalAttendeeRsvpStatus["TenativelyAccepted"] = "TENATIVELY_ACCEPTED";
})($2f512219da033f72$export$2b73fd69b8f5a9bd || ($2f512219da033f72$export$2b73fd69b8f5a9bd = {}));
var $2f512219da033f72$export$a529a83fbd574a83;
(function(ExternalBuildState) {
    ExternalBuildState["Cancelled"] = "CANCELLED";
    ExternalBuildState["Failed"] = "FAILED";
    ExternalBuildState["InProgress"] = "IN_PROGRESS";
    ExternalBuildState["Pending"] = "PENDING";
    ExternalBuildState["Successful"] = "SUCCESSFUL";
    ExternalBuildState["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$a529a83fbd574a83 || ($2f512219da033f72$export$a529a83fbd574a83 = {}));
var $2f512219da033f72$export$21df421064bf3919;
(function(ExternalChangeType) {
    ExternalChangeType["Added"] = "ADDED";
    ExternalChangeType["Copied"] = "COPIED";
    ExternalChangeType["Deleted"] = "DELETED";
    ExternalChangeType["Modified"] = "MODIFIED";
    ExternalChangeType["Moved"] = "MOVED";
    ExternalChangeType["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$21df421064bf3919 || ($2f512219da033f72$export$21df421064bf3919 = {}));
var $2f512219da033f72$export$710e1d5671e33a1f;
(function(ExternalCollaboratorsSortField) {
    ExternalCollaboratorsSortField["Name"] = "NAME";
})($2f512219da033f72$export$710e1d5671e33a1f || ($2f512219da033f72$export$710e1d5671e33a1f = {}));
var $2f512219da033f72$export$76e73af93da5bdbc;
(function(ExternalCommentReactionType) {
    ExternalCommentReactionType["Like"] = "LIKE";
})($2f512219da033f72$export$76e73af93da5bdbc || ($2f512219da033f72$export$76e73af93da5bdbc = {}));
var $2f512219da033f72$export$6759ac6277d955dd;
(function(ExternalCommitFlags) {
    ExternalCommitFlags["MergeCommit"] = "MERGE_COMMIT";
})($2f512219da033f72$export$6759ac6277d955dd || ($2f512219da033f72$export$6759ac6277d955dd = {}));
var $2f512219da033f72$export$bbf4ad4fb3d17b4c;
(function(ExternalConversationType) {
    ExternalConversationType["Channel"] = "CHANNEL";
    ExternalConversationType["DirectMessage"] = "DIRECT_MESSAGE";
    ExternalConversationType["GroupDirectMessage"] = "GROUP_DIRECT_MESSAGE";
})($2f512219da033f72$export$bbf4ad4fb3d17b4c || ($2f512219da033f72$export$bbf4ad4fb3d17b4c = {}));
var $2f512219da033f72$export$2b3de6bf362bc793;
(function(ExternalDeploymentState) {
    ExternalDeploymentState["Cancelled"] = "CANCELLED";
    ExternalDeploymentState["Failed"] = "FAILED";
    ExternalDeploymentState["InProgress"] = "IN_PROGRESS";
    ExternalDeploymentState["Pending"] = "PENDING";
    ExternalDeploymentState["RolledBack"] = "ROLLED_BACK";
    ExternalDeploymentState["Successful"] = "SUCCESSFUL";
    ExternalDeploymentState["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$2b3de6bf362bc793 || ($2f512219da033f72$export$2b3de6bf362bc793 = {}));
var $2f512219da033f72$export$b3dbc3bb1f3d376e;
(function(ExternalDesignStatus) {
    ExternalDesignStatus["None"] = "NONE";
    ExternalDesignStatus["ReadyForDevelopment"] = "READY_FOR_DEVELOPMENT";
    ExternalDesignStatus["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$b3dbc3bb1f3d376e || ($2f512219da033f72$export$b3dbc3bb1f3d376e = {}));
var $2f512219da033f72$export$697e56d9e72094e7;
(function(ExternalDesignType) {
    ExternalDesignType["Canvas"] = "CANVAS";
    ExternalDesignType["File"] = "FILE";
    ExternalDesignType["Group"] = "GROUP";
    ExternalDesignType["Node"] = "NODE";
    ExternalDesignType["Other"] = "OTHER";
    ExternalDesignType["Prototype"] = "PROTOTYPE";
})($2f512219da033f72$export$697e56d9e72094e7 || ($2f512219da033f72$export$697e56d9e72094e7 = {}));
var $2f512219da033f72$export$febd917fd954ad28;
(function(ExternalDocumentCategory) {
    ExternalDocumentCategory["Archive"] = "ARCHIVE";
    ExternalDocumentCategory["Audio"] = "AUDIO";
    ExternalDocumentCategory["Blogpost"] = "BLOGPOST";
    ExternalDocumentCategory["Code"] = "CODE";
    ExternalDocumentCategory["Comment"] = "COMMENT";
    ExternalDocumentCategory["Document"] = "DOCUMENT";
    ExternalDocumentCategory["Folder"] = "FOLDER";
    ExternalDocumentCategory["Form"] = "FORM";
    ExternalDocumentCategory["Image"] = "IMAGE";
    ExternalDocumentCategory["Other"] = "OTHER";
    ExternalDocumentCategory["Page"] = "PAGE";
    ExternalDocumentCategory["Pdf"] = "PDF";
    ExternalDocumentCategory["Presentation"] = "PRESENTATION";
    ExternalDocumentCategory["Shortcut"] = "SHORTCUT";
    ExternalDocumentCategory["Space"] = "SPACE";
    ExternalDocumentCategory["Spreadsheet"] = "SPREADSHEET";
    ExternalDocumentCategory["Video"] = "VIDEO";
    ExternalDocumentCategory["WebPage"] = "WEB_PAGE";
})($2f512219da033f72$export$febd917fd954ad28 || ($2f512219da033f72$export$febd917fd954ad28 = {}));
var $2f512219da033f72$export$58380f2014542325;
(function(ExternalEnvironmentType) {
    ExternalEnvironmentType["Development"] = "DEVELOPMENT";
    ExternalEnvironmentType["Production"] = "PRODUCTION";
    ExternalEnvironmentType["Staging"] = "STAGING";
    ExternalEnvironmentType["Testing"] = "TESTING";
    ExternalEnvironmentType["Unmapped"] = "UNMAPPED";
})($2f512219da033f72$export$58380f2014542325 || ($2f512219da033f72$export$58380f2014542325 = {}));
var $2f512219da033f72$export$e8178298be24f98b;
(function(ExternalEventType) {
    ExternalEventType["Appointment"] = "APPOINTMENT";
    ExternalEventType["Birthday"] = "BIRTHDAY";
    ExternalEventType["Default"] = "DEFAULT";
    ExternalEventType["Event"] = "EVENT";
    ExternalEventType["FocusTime"] = "FOCUS_TIME";
    ExternalEventType["OutOfOffice"] = "OUT_OF_OFFICE";
    ExternalEventType["Reminder"] = "REMINDER";
    ExternalEventType["Task"] = "TASK";
    ExternalEventType["WorkingLocation"] = "WORKING_LOCATION";
})($2f512219da033f72$export$e8178298be24f98b || ($2f512219da033f72$export$e8178298be24f98b = {}));
var $2f512219da033f72$export$7fbe6f4fd7f8b720;
(function(ExternalMembershipType) {
    ExternalMembershipType["Private"] = "PRIVATE";
    ExternalMembershipType["Public"] = "PUBLIC";
    ExternalMembershipType["Shared"] = "SHARED";
})($2f512219da033f72$export$7fbe6f4fd7f8b720 || ($2f512219da033f72$export$7fbe6f4fd7f8b720 = {}));
var $2f512219da033f72$export$589c937a173b601d;
(function(ExternalPullRequestStatus) {
    ExternalPullRequestStatus["Declined"] = "DECLINED";
    ExternalPullRequestStatus["Draft"] = "DRAFT";
    ExternalPullRequestStatus["Merged"] = "MERGED";
    ExternalPullRequestStatus["Open"] = "OPEN";
    ExternalPullRequestStatus["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$589c937a173b601d || ($2f512219da033f72$export$589c937a173b601d = {}));
var $2f512219da033f72$export$6935f9834af32b63;
(function(ExternalVulnerabilitySeverityLevel) {
    ExternalVulnerabilitySeverityLevel["Critical"] = "CRITICAL";
    ExternalVulnerabilitySeverityLevel["High"] = "HIGH";
    ExternalVulnerabilitySeverityLevel["Low"] = "LOW";
    ExternalVulnerabilitySeverityLevel["Medium"] = "MEDIUM";
    ExternalVulnerabilitySeverityLevel["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$6935f9834af32b63 || ($2f512219da033f72$export$6935f9834af32b63 = {}));
var $2f512219da033f72$export$4e05add33b7916dd;
(function(ExternalVulnerabilityStatus) {
    ExternalVulnerabilityStatus["Closed"] = "CLOSED";
    ExternalVulnerabilityStatus["Ignored"] = "IGNORED";
    ExternalVulnerabilityStatus["Open"] = "OPEN";
    ExternalVulnerabilityStatus["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$4e05add33b7916dd || ($2f512219da033f72$export$4e05add33b7916dd = {}));
var $2f512219da033f72$export$fe6bc7391e35d6c7;
(function(ExternalVulnerabilityType) {
    ExternalVulnerabilityType["Dast"] = "DAST";
    ExternalVulnerabilityType["Sast"] = "SAST";
    ExternalVulnerabilityType["Sca"] = "SCA";
    ExternalVulnerabilityType["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$fe6bc7391e35d6c7 || ($2f512219da033f72$export$fe6bc7391e35d6c7 = {}));
var $2f512219da033f72$export$513d853ff5fc6ca6;
(function(ExternalWorkItemSubtype) {
    ExternalWorkItemSubtype["Approval"] = "APPROVAL";
    ExternalWorkItemSubtype["Bug"] = "BUG";
    ExternalWorkItemSubtype["DefaultTask"] = "DEFAULT_TASK";
    ExternalWorkItemSubtype["Epic"] = "EPIC";
    ExternalWorkItemSubtype["Incident"] = "INCIDENT";
    ExternalWorkItemSubtype["Issue"] = "ISSUE";
    ExternalWorkItemSubtype["Milestone"] = "MILESTONE";
    ExternalWorkItemSubtype["Other"] = "OTHER";
    ExternalWorkItemSubtype["Problem"] = "PROBLEM";
    ExternalWorkItemSubtype["Question"] = "QUESTION";
    ExternalWorkItemSubtype["Section"] = "SECTION";
    ExternalWorkItemSubtype["Story"] = "STORY";
    ExternalWorkItemSubtype["Task"] = "TASK";
    ExternalWorkItemSubtype["WorkItem"] = "WORK_ITEM";
})($2f512219da033f72$export$513d853ff5fc6ca6 || ($2f512219da033f72$export$513d853ff5fc6ca6 = {}));
var $2f512219da033f72$export$5cecd2906004a9f9;
(function(FeedEventType) {
    FeedEventType["Comment"] = "COMMENT";
    FeedEventType["Create"] = "CREATE";
    FeedEventType["Edit"] = "EDIT";
    FeedEventType["Editlive"] = "EDITLIVE";
    FeedEventType["Publishlive"] = "PUBLISHLIVE";
})($2f512219da033f72$export$5cecd2906004a9f9 || ($2f512219da033f72$export$5cecd2906004a9f9 = {}));
var $2f512219da033f72$export$27d1ac5a175e8bbf;
(function(FeedItemSourceType) {
    FeedItemSourceType["Person"] = "PERSON";
    FeedItemSourceType["Space"] = "SPACE";
})($2f512219da033f72$export$27d1ac5a175e8bbf || ($2f512219da033f72$export$27d1ac5a175e8bbf = {}));
var $2f512219da033f72$export$a13b342a3f580b52;
(function(FeedType) {
    FeedType["Direct"] = "DIRECT";
    FeedType["Following"] = "FOLLOWING";
    FeedType["Popular"] = "POPULAR";
})($2f512219da033f72$export$a13b342a3f580b52 || ($2f512219da033f72$export$a13b342a3f580b52 = {}));
var $2f512219da033f72$export$7abb09aca3d3224b;
(function(ForgeAlertsAlertActivityType) {
    ForgeAlertsAlertActivityType["AlertClosed"] = "ALERT_CLOSED";
    ForgeAlertsAlertActivityType["AlertOpen"] = "ALERT_OPEN";
    ForgeAlertsAlertActivityType["EmailSent"] = "EMAIL_SENT";
    ForgeAlertsAlertActivityType["SeverityUpdated"] = "SEVERITY_UPDATED";
})($2f512219da033f72$export$7abb09aca3d3224b || ($2f512219da033f72$export$7abb09aca3d3224b = {}));
var $2f512219da033f72$export$33c67579a8081e2a;
(function(ForgeAlertsListOrderByColumns) {
    ForgeAlertsListOrderByColumns["AlertId"] = "alertId";
    ForgeAlertsListOrderByColumns["ClosedAt"] = "closedAt";
    ForgeAlertsListOrderByColumns["CreatedAt"] = "createdAt";
    ForgeAlertsListOrderByColumns["Duration"] = "duration";
    ForgeAlertsListOrderByColumns["Severity"] = "severity";
})($2f512219da033f72$export$33c67579a8081e2a || ($2f512219da033f72$export$33c67579a8081e2a = {}));
var $2f512219da033f72$export$9d3bb71d891b531d;
(function(ForgeAlertsListOrderOptions) {
    ForgeAlertsListOrderOptions["Asc"] = "ASC";
    ForgeAlertsListOrderOptions["Desc"] = "DESC";
})($2f512219da033f72$export$9d3bb71d891b531d || ($2f512219da033f72$export$9d3bb71d891b531d = {}));
var $2f512219da033f72$export$e762242ac801905f;
(function(ForgeAlertsMetricsDataType) {
    ForgeAlertsMetricsDataType["DateTime"] = "DATE_TIME";
})($2f512219da033f72$export$e762242ac801905f || ($2f512219da033f72$export$e762242ac801905f = {}));
var $2f512219da033f72$export$84db9ee3d9e00674;
(function(ForgeAlertsMetricsResolutionUnit) {
    ForgeAlertsMetricsResolutionUnit["Day"] = "DAY";
    ForgeAlertsMetricsResolutionUnit["Hours"] = "HOURS";
    ForgeAlertsMetricsResolutionUnit["Minutes"] = "MINUTES";
})($2f512219da033f72$export$84db9ee3d9e00674 || ($2f512219da033f72$export$84db9ee3d9e00674 = {}));
var $2f512219da033f72$export$804cf64af4f1f8ef;
(function(ForgeAlertsRuleActivityAction) {
    ForgeAlertsRuleActivityAction["Created"] = "CREATED";
    ForgeAlertsRuleActivityAction["Deleted"] = "DELETED";
    ForgeAlertsRuleActivityAction["Disabled"] = "DISABLED";
    ForgeAlertsRuleActivityAction["Enabled"] = "ENABLED";
    ForgeAlertsRuleActivityAction["Updated"] = "UPDATED";
})($2f512219da033f72$export$804cf64af4f1f8ef || ($2f512219da033f72$export$804cf64af4f1f8ef = {}));
var $2f512219da033f72$export$a8eb586b92cbde1f;
(function(ForgeAlertsRuleFilterActions) {
    ForgeAlertsRuleFilterActions["Exclude"] = "EXCLUDE";
    ForgeAlertsRuleFilterActions["Include"] = "INCLUDE";
})($2f512219da033f72$export$a8eb586b92cbde1f || ($2f512219da033f72$export$a8eb586b92cbde1f = {}));
var $2f512219da033f72$export$b8a26accb92dade4;
(function(ForgeAlertsRuleFilterDimensions) {
    ForgeAlertsRuleFilterDimensions["ErrorTypes"] = "ERROR_TYPES";
    ForgeAlertsRuleFilterDimensions["Functions"] = "FUNCTIONS";
    ForgeAlertsRuleFilterDimensions["Sites"] = "SITES";
    ForgeAlertsRuleFilterDimensions["Versions"] = "VERSIONS";
})($2f512219da033f72$export$b8a26accb92dade4 || ($2f512219da033f72$export$b8a26accb92dade4 = {}));
var $2f512219da033f72$export$3cd0507df3412180;
(function(ForgeAlertsRuleMetricType) {
    ForgeAlertsRuleMetricType["InvocationCount"] = "INVOCATION_COUNT";
    ForgeAlertsRuleMetricType["InvocationErrors"] = "INVOCATION_ERRORS";
    ForgeAlertsRuleMetricType["InvocationLatency"] = "INVOCATION_LATENCY";
    ForgeAlertsRuleMetricType["InvocationSuccessRate"] = "INVOCATION_SUCCESS_RATE";
})($2f512219da033f72$export$3cd0507df3412180 || ($2f512219da033f72$export$3cd0507df3412180 = {}));
var $2f512219da033f72$export$49e1bdac0115b9c;
(function(ForgeAlertsRuleSeverity) {
    ForgeAlertsRuleSeverity["Critical"] = "CRITICAL";
    ForgeAlertsRuleSeverity["Major"] = "MAJOR";
    ForgeAlertsRuleSeverity["Minor"] = "MINOR";
})($2f512219da033f72$export$49e1bdac0115b9c || ($2f512219da033f72$export$49e1bdac0115b9c = {}));
var $2f512219da033f72$export$c665fabcc544b3e1;
(function(ForgeAlertsRuleWhenConditions) {
    ForgeAlertsRuleWhenConditions["Above"] = "ABOVE";
    ForgeAlertsRuleWhenConditions["AboveOrEqualTo"] = "ABOVE_OR_EQUAL_TO";
    ForgeAlertsRuleWhenConditions["Below"] = "BELOW";
    ForgeAlertsRuleWhenConditions["BelowOrEqualTo"] = "BELOW_OR_EQUAL_TO";
})($2f512219da033f72$export$c665fabcc544b3e1 || ($2f512219da033f72$export$c665fabcc544b3e1 = {}));
var $2f512219da033f72$export$767f8584da7588f6;
(function(ForgeAlertsStatus) {
    ForgeAlertsStatus["Closed"] = "CLOSED";
    ForgeAlertsStatus["Open"] = "OPEN";
})($2f512219da033f72$export$767f8584da7588f6 || ($2f512219da033f72$export$767f8584da7588f6 = {}));
var $2f512219da033f72$export$d43e1fd1dac905d1;
(function(ForgeAuditLogsActionType) {
    ForgeAuditLogsActionType["ContributorAdded"] = "CONTRIBUTOR_ADDED";
    ForgeAuditLogsActionType["ContributorRemoved"] = "CONTRIBUTOR_REMOVED";
    ForgeAuditLogsActionType["ContributorRoleUpdated"] = "CONTRIBUTOR_ROLE_UPDATED";
    ForgeAuditLogsActionType["OwnershipTransferred"] = "OWNERSHIP_TRANSFERRED";
})($2f512219da033f72$export$d43e1fd1dac905d1 || ($2f512219da033f72$export$d43e1fd1dac905d1 = {}));
var $2f512219da033f72$export$f0a3a970a16c79ec;
(function(ForgeMetricsApiRequestGroupByDimensions) {
    ForgeMetricsApiRequestGroupByDimensions["ContextAri"] = "CONTEXT_ARI";
    ForgeMetricsApiRequestGroupByDimensions["Status"] = "STATUS";
    ForgeMetricsApiRequestGroupByDimensions["Url"] = "URL";
})($2f512219da033f72$export$f0a3a970a16c79ec || ($2f512219da033f72$export$f0a3a970a16c79ec = {}));
var $2f512219da033f72$export$ff830a2670c6e0f4;
(function(ForgeMetricsApiRequestStatus) {
    ForgeMetricsApiRequestStatus["2Xx"] = "_2XX";
    ForgeMetricsApiRequestStatus["4Xx"] = "_4XX";
    ForgeMetricsApiRequestStatus["5Xx"] = "_5XX";
})($2f512219da033f72$export$ff830a2670c6e0f4 || ($2f512219da033f72$export$ff830a2670c6e0f4 = {}));
var $2f512219da033f72$export$67826916f2c41941;
(function(ForgeMetricsApiRequestType) {
    ForgeMetricsApiRequestType["Cache"] = "CACHE";
    ForgeMetricsApiRequestType["External"] = "EXTERNAL";
    ForgeMetricsApiRequestType["Product"] = "PRODUCT";
    ForgeMetricsApiRequestType["Sql"] = "SQL";
})($2f512219da033f72$export$67826916f2c41941 || ($2f512219da033f72$export$67826916f2c41941 = {}));
var $2f512219da033f72$export$6854d9ebadef3813;
(function(ForgeMetricsChartName) {
    ForgeMetricsChartName["ApiRequestCount_2Xx"] = "API_REQUEST_COUNT_2XX";
    ForgeMetricsChartName["ApiRequestCount_4Xx"] = "API_REQUEST_COUNT_4XX";
    ForgeMetricsChartName["ApiRequestCount_5Xx"] = "API_REQUEST_COUNT_5XX";
    ForgeMetricsChartName["ApiRequestLatency"] = "API_REQUEST_LATENCY";
    ForgeMetricsChartName["InvocationCount"] = "INVOCATION_COUNT";
    ForgeMetricsChartName["InvocationError"] = "INVOCATION_ERROR";
    ForgeMetricsChartName["InvocationLatency"] = "INVOCATION_LATENCY";
    ForgeMetricsChartName["InvocationSuccessRate"] = "INVOCATION_SUCCESS_RATE";
})($2f512219da033f72$export$6854d9ebadef3813 || ($2f512219da033f72$export$6854d9ebadef3813 = {}));
var $2f512219da033f72$export$be13db3f8d97b678;
(function(ForgeMetricsCustomGroupByDimensions) {
    ForgeMetricsCustomGroupByDimensions["CustomMetricName"] = "CUSTOM_METRIC_NAME";
})($2f512219da033f72$export$be13db3f8d97b678 || ($2f512219da033f72$export$be13db3f8d97b678 = {}));
var $2f512219da033f72$export$8220077afa4e34ce;
(function(ForgeMetricsDataType) {
    ForgeMetricsDataType["Category"] = "CATEGORY";
    ForgeMetricsDataType["DateTime"] = "DATE_TIME";
    ForgeMetricsDataType["Numeric"] = "NUMERIC";
})($2f512219da033f72$export$8220077afa4e34ce || ($2f512219da033f72$export$8220077afa4e34ce = {}));
var $2f512219da033f72$export$81745303cdddd39e;
(function(ForgeMetricsGroupByDimensions) {
    ForgeMetricsGroupByDimensions["ContextAri"] = "CONTEXT_ARI";
    ForgeMetricsGroupByDimensions["EnvironmentId"] = "ENVIRONMENT_ID";
    ForgeMetricsGroupByDimensions["ErrorType"] = "ERROR_TYPE";
    ForgeMetricsGroupByDimensions["Function"] = "FUNCTION";
    ForgeMetricsGroupByDimensions["UserTier"] = "USER_TIER";
    ForgeMetricsGroupByDimensions["Version"] = "VERSION";
})($2f512219da033f72$export$81745303cdddd39e || ($2f512219da033f72$export$81745303cdddd39e = {}));
var $2f512219da033f72$export$2afbe872edd7ae25;
(function(ForgeMetricsLabels) {
    ForgeMetricsLabels["ForgeApiRequestCount"] = "FORGE_API_REQUEST_COUNT";
    ForgeMetricsLabels["ForgeApiRequestLatency"] = "FORGE_API_REQUEST_LATENCY";
    ForgeMetricsLabels["ForgeBackendInvocationCount"] = "FORGE_BACKEND_INVOCATION_COUNT";
    ForgeMetricsLabels["ForgeBackendInvocationErrors"] = "FORGE_BACKEND_INVOCATION_ERRORS";
    ForgeMetricsLabels["ForgeBackendInvocationLatency"] = "FORGE_BACKEND_INVOCATION_LATENCY";
})($2f512219da033f72$export$2afbe872edd7ae25 || ($2f512219da033f72$export$2afbe872edd7ae25 = {}));
var $2f512219da033f72$export$bf91b1fbb61e5286;
(function(ForgeMetricsResolutionUnit) {
    ForgeMetricsResolutionUnit["Hours"] = "HOURS";
    ForgeMetricsResolutionUnit["Minutes"] = "MINUTES";
})($2f512219da033f72$export$bf91b1fbb61e5286 || ($2f512219da033f72$export$bf91b1fbb61e5286 = {}));
var $2f512219da033f72$export$923266f2817195b3;
(function(ForgeMetricsSiteFilterCategory) {
    ForgeMetricsSiteFilterCategory["All"] = "ALL";
    ForgeMetricsSiteFilterCategory["HighestInvocationCount"] = "HIGHEST_INVOCATION_COUNT";
    ForgeMetricsSiteFilterCategory["HighestNumberOfErrors"] = "HIGHEST_NUMBER_OF_ERRORS";
    ForgeMetricsSiteFilterCategory["HighestNumberOfUsers"] = "HIGHEST_NUMBER_OF_USERS";
    ForgeMetricsSiteFilterCategory["LowestSuccessRate"] = "LOWEST_SUCCESS_RATE";
})($2f512219da033f72$export$923266f2817195b3 || ($2f512219da033f72$export$923266f2817195b3 = {}));
var $2f512219da033f72$export$fc8a1cc6d4fd1a88;
(function(FormStatus) {
    FormStatus["Approved"] = "APPROVED";
    FormStatus["Rejected"] = "REJECTED";
    FormStatus["Saved"] = "SAVED";
    FormStatus["Submitted"] = "SUBMITTED";
})($2f512219da033f72$export$fc8a1cc6d4fd1a88 || ($2f512219da033f72$export$fc8a1cc6d4fd1a88 = {}));
var $2f512219da033f72$export$6dc536fb03c01261;
(function(FortifiedMetricsResolutionUnit) {
    FortifiedMetricsResolutionUnit["Hours"] = "HOURS";
    FortifiedMetricsResolutionUnit["Minutes"] = "MINUTES";
})($2f512219da033f72$export$6dc536fb03c01261 || ($2f512219da033f72$export$6dc536fb03c01261 = {}));
var $2f512219da033f72$export$c11461c8b46bd7da;
(function(FunctionTriggerType) {
    FunctionTriggerType["Frontend"] = "FRONTEND";
    FunctionTriggerType["Manual"] = "MANUAL";
    FunctionTriggerType["Product"] = "PRODUCT";
    FunctionTriggerType["Web"] = "WEB";
})($2f512219da033f72$export$c11461c8b46bd7da || ($2f512219da033f72$export$c11461c8b46bd7da = {}));
var $2f512219da033f72$export$7cf25e310e0549b9;
(function(GrantCheckProduct) {
    GrantCheckProduct["Compass"] = "COMPASS";
    GrantCheckProduct["Confluence"] = "CONFLUENCE";
    GrantCheckProduct["Jira"] = "JIRA";
    GrantCheckProduct["JiraServicedesk"] = "JIRA_SERVICEDESK";
    GrantCheckProduct["Mercury"] = "MERCURY";
    /** Don't check whether a user has been granted access to a specific site(cloudId) */ GrantCheckProduct["NoGrantChecks"] = "NO_GRANT_CHECKS";
    GrantCheckProduct["Townsquare"] = "TOWNSQUARE";
})($2f512219da033f72$export$7cf25e310e0549b9 || ($2f512219da033f72$export$7cf25e310e0549b9 = {}));
var $2f512219da033f72$export$e257ff6d0ceabf65;
(function(GraphCreateMetadataProjectAssociatedBuildJiraBuildOutputBuildStateEnum) {
    GraphCreateMetadataProjectAssociatedBuildJiraBuildOutputBuildStateEnum["Cancelled"] = "CANCELLED";
    GraphCreateMetadataProjectAssociatedBuildJiraBuildOutputBuildStateEnum["Failed"] = "FAILED";
    GraphCreateMetadataProjectAssociatedBuildJiraBuildOutputBuildStateEnum["InProgress"] = "IN_PROGRESS";
    GraphCreateMetadataProjectAssociatedBuildJiraBuildOutputBuildStateEnum["NotSet"] = "NOT_SET";
    GraphCreateMetadataProjectAssociatedBuildJiraBuildOutputBuildStateEnum["Pending"] = "PENDING";
    GraphCreateMetadataProjectAssociatedBuildJiraBuildOutputBuildStateEnum["Successful"] = "SUCCESSFUL";
    GraphCreateMetadataProjectAssociatedBuildJiraBuildOutputBuildStateEnum["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$e257ff6d0ceabf65 || ($2f512219da033f72$export$e257ff6d0ceabf65 = {}));
var $2f512219da033f72$export$d67cf8c91eee6c78;
(function(GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum) {
    GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["Cancelled"] = "CANCELLED";
    GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["Failed"] = "FAILED";
    GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["InProgress"] = "IN_PROGRESS";
    GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["NotSet"] = "NOT_SET";
    GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["Pending"] = "PENDING";
    GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["RolledBack"] = "ROLLED_BACK";
    GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["Successful"] = "SUCCESSFUL";
    GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$d67cf8c91eee6c78 || ($2f512219da033f72$export$d67cf8c91eee6c78 = {}));
var $2f512219da033f72$export$ee2e640b413dd384;
(function(GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputEnvironmentTypeEnum) {
    GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputEnvironmentTypeEnum["Development"] = "DEVELOPMENT";
    GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputEnvironmentTypeEnum["NotSet"] = "NOT_SET";
    GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputEnvironmentTypeEnum["Production"] = "PRODUCTION";
    GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputEnvironmentTypeEnum["Staging"] = "STAGING";
    GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputEnvironmentTypeEnum["Testing"] = "TESTING";
    GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputEnvironmentTypeEnum["Unmapped"] = "UNMAPPED";
})($2f512219da033f72$export$ee2e640b413dd384 || ($2f512219da033f72$export$ee2e640b413dd384 = {}));
var $2f512219da033f72$export$c50c7062a9ebe6be;
(function(GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputPullRequestStatusEnum) {
    GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputPullRequestStatusEnum["Declined"] = "DECLINED";
    GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputPullRequestStatusEnum["Merged"] = "MERGED";
    GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputPullRequestStatusEnum["NotSet"] = "NOT_SET";
    GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputPullRequestStatusEnum["Open"] = "OPEN";
    GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputPullRequestStatusEnum["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$c50c7062a9ebe6be || ($2f512219da033f72$export$c50c7062a9ebe6be = {}));
var $2f512219da033f72$export$a79d08c6a74f2aa7;
(function(GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputReviewerReviewerStatusEnum) {
    GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputReviewerReviewerStatusEnum["Approved"] = "APPROVED";
    GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputReviewerReviewerStatusEnum["Needswork"] = "NEEDSWORK";
    GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputReviewerReviewerStatusEnum["NotSet"] = "NOT_SET";
    GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputReviewerReviewerStatusEnum["Unapproved"] = "UNAPPROVED";
})($2f512219da033f72$export$a79d08c6a74f2aa7 || ($2f512219da033f72$export$a79d08c6a74f2aa7 = {}));
var $2f512219da033f72$export$6f687fc24be8932d;
(function(GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum) {
    GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum["Critical"] = "CRITICAL";
    GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum["High"] = "HIGH";
    GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum["Low"] = "LOW";
    GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum["Medium"] = "MEDIUM";
    GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$6f687fc24be8932d || ($2f512219da033f72$export$6f687fc24be8932d = {}));
var $2f512219da033f72$export$49ff7d43116f0b34;
(function(GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityStatusEnum) {
    GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityStatusEnum["Closed"] = "CLOSED";
    GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityStatusEnum["Ignored"] = "IGNORED";
    GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityStatusEnum["Open"] = "OPEN";
    GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityStatusEnum["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$49ff7d43116f0b34 || ($2f512219da033f72$export$49ff7d43116f0b34 = {}));
var $2f512219da033f72$export$e818e0de20808583;
(function(GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityTypeEnum) {
    GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityTypeEnum["Dast"] = "DAST";
    GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityTypeEnum["Sast"] = "SAST";
    GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityTypeEnum["Sca"] = "SCA";
    GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityTypeEnum["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$e818e0de20808583 || ($2f512219da033f72$export$e818e0de20808583 = {}));
var $2f512219da033f72$export$712746aa2988ba08;
(function(GraphCreateMetadataSprintAssociatedBuildJiraBuildOutputBuildStateEnum) {
    GraphCreateMetadataSprintAssociatedBuildJiraBuildOutputBuildStateEnum["Cancelled"] = "CANCELLED";
    GraphCreateMetadataSprintAssociatedBuildJiraBuildOutputBuildStateEnum["Failed"] = "FAILED";
    GraphCreateMetadataSprintAssociatedBuildJiraBuildOutputBuildStateEnum["InProgress"] = "IN_PROGRESS";
    GraphCreateMetadataSprintAssociatedBuildJiraBuildOutputBuildStateEnum["NotSet"] = "NOT_SET";
    GraphCreateMetadataSprintAssociatedBuildJiraBuildOutputBuildStateEnum["Pending"] = "PENDING";
    GraphCreateMetadataSprintAssociatedBuildJiraBuildOutputBuildStateEnum["Successful"] = "SUCCESSFUL";
    GraphCreateMetadataSprintAssociatedBuildJiraBuildOutputBuildStateEnum["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$712746aa2988ba08 || ($2f512219da033f72$export$712746aa2988ba08 = {}));
var $2f512219da033f72$export$f69c5a9b8fd498a0;
(function(GraphCreateMetadataSprintAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum) {
    GraphCreateMetadataSprintAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["Cancelled"] = "CANCELLED";
    GraphCreateMetadataSprintAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["Failed"] = "FAILED";
    GraphCreateMetadataSprintAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["InProgress"] = "IN_PROGRESS";
    GraphCreateMetadataSprintAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["NotSet"] = "NOT_SET";
    GraphCreateMetadataSprintAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["Pending"] = "PENDING";
    GraphCreateMetadataSprintAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["RolledBack"] = "ROLLED_BACK";
    GraphCreateMetadataSprintAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["Successful"] = "SUCCESSFUL";
    GraphCreateMetadataSprintAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$f69c5a9b8fd498a0 || ($2f512219da033f72$export$f69c5a9b8fd498a0 = {}));
var $2f512219da033f72$export$ae5cb07efff2d516;
(function(GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputPullRequestStatusEnum) {
    GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputPullRequestStatusEnum["Declined"] = "DECLINED";
    GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputPullRequestStatusEnum["Merged"] = "MERGED";
    GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputPullRequestStatusEnum["NotSet"] = "NOT_SET";
    GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputPullRequestStatusEnum["Open"] = "OPEN";
    GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputPullRequestStatusEnum["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$ae5cb07efff2d516 || ($2f512219da033f72$export$ae5cb07efff2d516 = {}));
var $2f512219da033f72$export$784f60349b367f9b;
(function(GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputReviewerReviewerStatusEnum) {
    GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputReviewerReviewerStatusEnum["Approved"] = "APPROVED";
    GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputReviewerReviewerStatusEnum["Needswork"] = "NEEDSWORK";
    GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputReviewerReviewerStatusEnum["NotSet"] = "NOT_SET";
    GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputReviewerReviewerStatusEnum["Unapproved"] = "UNAPPROVED";
})($2f512219da033f72$export$784f60349b367f9b || ($2f512219da033f72$export$784f60349b367f9b = {}));
var $2f512219da033f72$export$e37d41f18a90ba53;
(function(GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum) {
    GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum["Critical"] = "CRITICAL";
    GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum["High"] = "HIGH";
    GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum["Low"] = "LOW";
    GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum["Medium"] = "MEDIUM";
    GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum["NotSet"] = "NOT_SET";
    GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$e37d41f18a90ba53 || ($2f512219da033f72$export$e37d41f18a90ba53 = {}));
var $2f512219da033f72$export$f53fed6636725b64;
(function(GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityStatusEnum) {
    GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityStatusEnum["Closed"] = "CLOSED";
    GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityStatusEnum["Ignored"] = "IGNORED";
    GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityStatusEnum["NotSet"] = "NOT_SET";
    GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityStatusEnum["Open"] = "OPEN";
    GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityStatusEnum["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$f53fed6636725b64 || ($2f512219da033f72$export$f53fed6636725b64 = {}));
var $2f512219da033f72$export$aa057f51e7ce3c82;
(function(GraphCreateMetadataSprintAssociatedVulnerabilityOutputStatusCategoryEnum) {
    GraphCreateMetadataSprintAssociatedVulnerabilityOutputStatusCategoryEnum["Done"] = "DONE";
    GraphCreateMetadataSprintAssociatedVulnerabilityOutputStatusCategoryEnum["Indeterminate"] = "INDETERMINATE";
    GraphCreateMetadataSprintAssociatedVulnerabilityOutputStatusCategoryEnum["New"] = "NEW";
    GraphCreateMetadataSprintAssociatedVulnerabilityOutputStatusCategoryEnum["Undefined"] = "UNDEFINED";
})($2f512219da033f72$export$aa057f51e7ce3c82 || ($2f512219da033f72$export$aa057f51e7ce3c82 = {}));
var $2f512219da033f72$export$28a810288577486f;
(function(GraphCreateMetadataSprintContainsIssueJiraIssueInputStatusCategoryEnum) {
    GraphCreateMetadataSprintContainsIssueJiraIssueInputStatusCategoryEnum["Done"] = "DONE";
    GraphCreateMetadataSprintContainsIssueJiraIssueInputStatusCategoryEnum["Indeterminate"] = "INDETERMINATE";
    GraphCreateMetadataSprintContainsIssueJiraIssueInputStatusCategoryEnum["New"] = "NEW";
    GraphCreateMetadataSprintContainsIssueJiraIssueInputStatusCategoryEnum["Undefined"] = "UNDEFINED";
})($2f512219da033f72$export$28a810288577486f || ($2f512219da033f72$export$28a810288577486f = {}));
var $2f512219da033f72$export$f863dc0cdc1e6a3;
(function(GraphCreateMetadataSprintContainsIssueJiraIssueOutputStatusCategoryEnum) {
    GraphCreateMetadataSprintContainsIssueJiraIssueOutputStatusCategoryEnum["Done"] = "DONE";
    GraphCreateMetadataSprintContainsIssueJiraIssueOutputStatusCategoryEnum["Indeterminate"] = "INDETERMINATE";
    GraphCreateMetadataSprintContainsIssueJiraIssueOutputStatusCategoryEnum["New"] = "NEW";
    GraphCreateMetadataSprintContainsIssueJiraIssueOutputStatusCategoryEnum["Undefined"] = "UNDEFINED";
})($2f512219da033f72$export$f863dc0cdc1e6a3 || ($2f512219da033f72$export$f863dc0cdc1e6a3 = {}));
var $2f512219da033f72$export$34ac44607b1850e7;
(function(GraphQlContentStatus) {
    GraphQlContentStatus["Archived"] = "ARCHIVED";
    GraphQlContentStatus["Current"] = "CURRENT";
    GraphQlContentStatus["Deleted"] = "DELETED";
    GraphQlContentStatus["Draft"] = "DRAFT";
})($2f512219da033f72$export$34ac44607b1850e7 || ($2f512219da033f72$export$34ac44607b1850e7 = {}));
var $2f512219da033f72$export$e994123c2f429b75;
(function(GraphQlContentTemplateType) {
    GraphQlContentTemplateType["Blueprint"] = "BLUEPRINT";
    GraphQlContentTemplateType["Page"] = "PAGE";
})($2f512219da033f72$export$e994123c2f429b75 || ($2f512219da033f72$export$e994123c2f429b75 = {}));
var $2f512219da033f72$export$6af6910f297c50c4;
(function(GraphQlCoverPictureWidth) {
    GraphQlCoverPictureWidth["Fixed"] = "FIXED";
    GraphQlCoverPictureWidth["Full"] = "FULL";
})($2f512219da033f72$export$6af6910f297c50c4 || ($2f512219da033f72$export$6af6910f297c50c4 = {}));
var $2f512219da033f72$export$96f02f1db8e6595;
(function(GraphQlFrontCoverState) {
    GraphQlFrontCoverState["Hidden"] = "HIDDEN";
    GraphQlFrontCoverState["Shown"] = "SHOWN";
    GraphQlFrontCoverState["Transition"] = "TRANSITION";
    GraphQlFrontCoverState["Unset"] = "UNSET";
})($2f512219da033f72$export$96f02f1db8e6595 || ($2f512219da033f72$export$96f02f1db8e6595 = {}));
var $2f512219da033f72$export$fae963d3525fb22e;
(function(GraphQlLabelSortDirection) {
    GraphQlLabelSortDirection["Ascending"] = "ASCENDING";
    GraphQlLabelSortDirection["Descending"] = "DESCENDING";
})($2f512219da033f72$export$fae963d3525fb22e || ($2f512219da033f72$export$fae963d3525fb22e = {}));
var $2f512219da033f72$export$c6e07a9286fc08a4;
(function(GraphQlLabelSortField) {
    GraphQlLabelSortField["LabellingCreationdate"] = "LABELLING_CREATIONDATE";
    GraphQlLabelSortField["LabellingId"] = "LABELLING_ID";
})($2f512219da033f72$export$c6e07a9286fc08a4 || ($2f512219da033f72$export$c6e07a9286fc08a4 = {}));
var $2f512219da033f72$export$b019fbba578858f0;
(function(GraphQlPageStatus) {
    GraphQlPageStatus["Current"] = "CURRENT";
    GraphQlPageStatus["Draft"] = "DRAFT";
    GraphQlPageStatus["Historical"] = "HISTORICAL";
    GraphQlPageStatus["Trashed"] = "TRASHED";
})($2f512219da033f72$export$b019fbba578858f0 || ($2f512219da033f72$export$b019fbba578858f0 = {}));
var $2f512219da033f72$export$ae2ce47a7c8824be;
(function(GraphQlReactionContentType) {
    GraphQlReactionContentType["Blogpost"] = "BLOGPOST";
    GraphQlReactionContentType["Comment"] = "COMMENT";
    GraphQlReactionContentType["Page"] = "PAGE";
})($2f512219da033f72$export$ae2ce47a7c8824be || ($2f512219da033f72$export$ae2ce47a7c8824be = {}));
var $2f512219da033f72$export$fed82f495356959d;
(function(GraphQlTemplateContentAppearance) {
    GraphQlTemplateContentAppearance["Default"] = "DEFAULT";
    GraphQlTemplateContentAppearance["FullWidth"] = "FULL_WIDTH";
})($2f512219da033f72$export$fed82f495356959d || ($2f512219da033f72$export$fed82f495356959d = {}));
var $2f512219da033f72$export$506c56cd93325d6f;
(function(GraphQueryMetadataProjectAssociatedBuildInputToBuildStateEnum) {
    GraphQueryMetadataProjectAssociatedBuildInputToBuildStateEnum["Cancelled"] = "CANCELLED";
    GraphQueryMetadataProjectAssociatedBuildInputToBuildStateEnum["Failed"] = "FAILED";
    GraphQueryMetadataProjectAssociatedBuildInputToBuildStateEnum["InProgress"] = "IN_PROGRESS";
    GraphQueryMetadataProjectAssociatedBuildInputToBuildStateEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataProjectAssociatedBuildInputToBuildStateEnum["Pending"] = "PENDING";
    GraphQueryMetadataProjectAssociatedBuildInputToBuildStateEnum["Successful"] = "SUCCESSFUL";
    GraphQueryMetadataProjectAssociatedBuildInputToBuildStateEnum["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$506c56cd93325d6f || ($2f512219da033f72$export$506c56cd93325d6f = {}));
var $2f512219da033f72$export$7ea6916b52f9a466;
(function(GraphQueryMetadataProjectAssociatedDeploymentInputToDeploymentStateEnum) {
    GraphQueryMetadataProjectAssociatedDeploymentInputToDeploymentStateEnum["Cancelled"] = "CANCELLED";
    GraphQueryMetadataProjectAssociatedDeploymentInputToDeploymentStateEnum["Failed"] = "FAILED";
    GraphQueryMetadataProjectAssociatedDeploymentInputToDeploymentStateEnum["InProgress"] = "IN_PROGRESS";
    GraphQueryMetadataProjectAssociatedDeploymentInputToDeploymentStateEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataProjectAssociatedDeploymentInputToDeploymentStateEnum["Pending"] = "PENDING";
    GraphQueryMetadataProjectAssociatedDeploymentInputToDeploymentStateEnum["RolledBack"] = "ROLLED_BACK";
    GraphQueryMetadataProjectAssociatedDeploymentInputToDeploymentStateEnum["Successful"] = "SUCCESSFUL";
    GraphQueryMetadataProjectAssociatedDeploymentInputToDeploymentStateEnum["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$7ea6916b52f9a466 || ($2f512219da033f72$export$7ea6916b52f9a466 = {}));
var $2f512219da033f72$export$4a73bb7047a59c43;
(function(GraphQueryMetadataProjectAssociatedDeploymentInputToEnvironmentTypeEnum) {
    GraphQueryMetadataProjectAssociatedDeploymentInputToEnvironmentTypeEnum["Development"] = "DEVELOPMENT";
    GraphQueryMetadataProjectAssociatedDeploymentInputToEnvironmentTypeEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataProjectAssociatedDeploymentInputToEnvironmentTypeEnum["Production"] = "PRODUCTION";
    GraphQueryMetadataProjectAssociatedDeploymentInputToEnvironmentTypeEnum["Staging"] = "STAGING";
    GraphQueryMetadataProjectAssociatedDeploymentInputToEnvironmentTypeEnum["Testing"] = "TESTING";
    GraphQueryMetadataProjectAssociatedDeploymentInputToEnvironmentTypeEnum["Unmapped"] = "UNMAPPED";
})($2f512219da033f72$export$4a73bb7047a59c43 || ($2f512219da033f72$export$4a73bb7047a59c43 = {}));
var $2f512219da033f72$export$13841098b50a1391;
(function(GraphQueryMetadataProjectAssociatedPrInputToPullRequestStatusEnum) {
    GraphQueryMetadataProjectAssociatedPrInputToPullRequestStatusEnum["Declined"] = "DECLINED";
    GraphQueryMetadataProjectAssociatedPrInputToPullRequestStatusEnum["Merged"] = "MERGED";
    GraphQueryMetadataProjectAssociatedPrInputToPullRequestStatusEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataProjectAssociatedPrInputToPullRequestStatusEnum["Open"] = "OPEN";
    GraphQueryMetadataProjectAssociatedPrInputToPullRequestStatusEnum["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$13841098b50a1391 || ($2f512219da033f72$export$13841098b50a1391 = {}));
var $2f512219da033f72$export$b79540fc1cf58152;
(function(GraphQueryMetadataProjectAssociatedPrInputToReviewerReviewerStatusEnum) {
    GraphQueryMetadataProjectAssociatedPrInputToReviewerReviewerStatusEnum["Approved"] = "APPROVED";
    GraphQueryMetadataProjectAssociatedPrInputToReviewerReviewerStatusEnum["Needswork"] = "NEEDSWORK";
    GraphQueryMetadataProjectAssociatedPrInputToReviewerReviewerStatusEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataProjectAssociatedPrInputToReviewerReviewerStatusEnum["Unapproved"] = "UNAPPROVED";
})($2f512219da033f72$export$b79540fc1cf58152 || ($2f512219da033f72$export$b79540fc1cf58152 = {}));
var $2f512219da033f72$export$f73a51516debfebb;
(function(GraphQueryMetadataProjectAssociatedPrInputToReviewermatchTypeEnum) {
    GraphQueryMetadataProjectAssociatedPrInputToReviewermatchTypeEnum["All"] = "ALL";
    GraphQueryMetadataProjectAssociatedPrInputToReviewermatchTypeEnum["Any"] = "ANY";
    GraphQueryMetadataProjectAssociatedPrInputToReviewermatchTypeEnum["None"] = "NONE";
})($2f512219da033f72$export$f73a51516debfebb || ($2f512219da033f72$export$f73a51516debfebb = {}));
var $2f512219da033f72$export$ffa68ad6c069c08;
(function(GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilitySeverityEnum) {
    GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilitySeverityEnum["Critical"] = "CRITICAL";
    GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilitySeverityEnum["High"] = "HIGH";
    GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilitySeverityEnum["Low"] = "LOW";
    GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilitySeverityEnum["Medium"] = "MEDIUM";
    GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilitySeverityEnum["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$ffa68ad6c069c08 || ($2f512219da033f72$export$ffa68ad6c069c08 = {}));
var $2f512219da033f72$export$d9c8a38d7a3c7cc8;
(function(GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityStatusEnum) {
    GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityStatusEnum["Closed"] = "CLOSED";
    GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityStatusEnum["Ignored"] = "IGNORED";
    GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityStatusEnum["Open"] = "OPEN";
    GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityStatusEnum["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$d9c8a38d7a3c7cc8 || ($2f512219da033f72$export$d9c8a38d7a3c7cc8 = {}));
var $2f512219da033f72$export$5a8ffaaa2ad7aed0;
(function(GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityTypeEnum) {
    GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityTypeEnum["Dast"] = "DAST";
    GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityTypeEnum["Sast"] = "SAST";
    GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityTypeEnum["Sca"] = "SCA";
    GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityTypeEnum["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$5a8ffaaa2ad7aed0 || ($2f512219da033f72$export$5a8ffaaa2ad7aed0 = {}));
var $2f512219da033f72$export$806eaced01bf01a;
(function(GraphQueryMetadataProjectHasIssueInputRelationshipArimatchTypeEnum) {
    GraphQueryMetadataProjectHasIssueInputRelationshipArimatchTypeEnum["All"] = "ALL";
    GraphQueryMetadataProjectHasIssueInputRelationshipArimatchTypeEnum["Any"] = "ANY";
    GraphQueryMetadataProjectHasIssueInputRelationshipArimatchTypeEnum["None"] = "NONE";
})($2f512219da033f72$export$806eaced01bf01a || ($2f512219da033f72$export$806eaced01bf01a = {}));
var $2f512219da033f72$export$6ca61b0e0124327a;
(function(GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilitySeverityEnum) {
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilitySeverityEnum["Critical"] = "CRITICAL";
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilitySeverityEnum["High"] = "HIGH";
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilitySeverityEnum["Low"] = "LOW";
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilitySeverityEnum["Medium"] = "MEDIUM";
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilitySeverityEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilitySeverityEnum["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$6ca61b0e0124327a || ($2f512219da033f72$export$6ca61b0e0124327a = {}));
var $2f512219da033f72$export$f5a38573abf93209;
(function(GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityStatusEnum) {
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityStatusEnum["Closed"] = "CLOSED";
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityStatusEnum["Ignored"] = "IGNORED";
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityStatusEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityStatusEnum["Open"] = "OPEN";
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityStatusEnum["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$f5a38573abf93209 || ($2f512219da033f72$export$f5a38573abf93209 = {}));
var $2f512219da033f72$export$e78de564c39ba63a;
(function(GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityTypeEnum) {
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityTypeEnum["Dast"] = "DAST";
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityTypeEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityTypeEnum["Sast"] = "SAST";
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityTypeEnum["Sca"] = "SCA";
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityTypeEnum["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$e78de564c39ba63a || ($2f512219da033f72$export$e78de564c39ba63a = {}));
var $2f512219da033f72$export$84e173808cf3fbd;
(function(GraphQueryMetadataServiceLinkedIncidentInputToJiraServiceManagementIncidentPriorityEnum) {
    GraphQueryMetadataServiceLinkedIncidentInputToJiraServiceManagementIncidentPriorityEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataServiceLinkedIncidentInputToJiraServiceManagementIncidentPriorityEnum["P1"] = "P1";
    GraphQueryMetadataServiceLinkedIncidentInputToJiraServiceManagementIncidentPriorityEnum["P2"] = "P2";
    GraphQueryMetadataServiceLinkedIncidentInputToJiraServiceManagementIncidentPriorityEnum["P3"] = "P3";
    GraphQueryMetadataServiceLinkedIncidentInputToJiraServiceManagementIncidentPriorityEnum["P4"] = "P4";
    GraphQueryMetadataServiceLinkedIncidentInputToJiraServiceManagementIncidentPriorityEnum["P5"] = "P5";
})($2f512219da033f72$export$84e173808cf3fbd || ($2f512219da033f72$export$84e173808cf3fbd = {}));
var $2f512219da033f72$export$9b119abe5b87afc8;
(function(GraphQueryMetadataSortEnum) {
    GraphQueryMetadataSortEnum["Asc"] = "ASC";
    GraphQueryMetadataSortEnum["Desc"] = "DESC";
})($2f512219da033f72$export$9b119abe5b87afc8 || ($2f512219da033f72$export$9b119abe5b87afc8 = {}));
var $2f512219da033f72$export$c4247d75f3bd62d6;
(function(GraphQueryMetadataSprintAssociatedBuildInputToBuildStateEnum) {
    GraphQueryMetadataSprintAssociatedBuildInputToBuildStateEnum["Cancelled"] = "CANCELLED";
    GraphQueryMetadataSprintAssociatedBuildInputToBuildStateEnum["Failed"] = "FAILED";
    GraphQueryMetadataSprintAssociatedBuildInputToBuildStateEnum["InProgress"] = "IN_PROGRESS";
    GraphQueryMetadataSprintAssociatedBuildInputToBuildStateEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataSprintAssociatedBuildInputToBuildStateEnum["Pending"] = "PENDING";
    GraphQueryMetadataSprintAssociatedBuildInputToBuildStateEnum["Successful"] = "SUCCESSFUL";
    GraphQueryMetadataSprintAssociatedBuildInputToBuildStateEnum["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$c4247d75f3bd62d6 || ($2f512219da033f72$export$c4247d75f3bd62d6 = {}));
var $2f512219da033f72$export$251196d62f47dadc;
(function(GraphQueryMetadataSprintAssociatedDeploymentInputToDeploymentStateEnum) {
    GraphQueryMetadataSprintAssociatedDeploymentInputToDeploymentStateEnum["Cancelled"] = "CANCELLED";
    GraphQueryMetadataSprintAssociatedDeploymentInputToDeploymentStateEnum["Failed"] = "FAILED";
    GraphQueryMetadataSprintAssociatedDeploymentInputToDeploymentStateEnum["InProgress"] = "IN_PROGRESS";
    GraphQueryMetadataSprintAssociatedDeploymentInputToDeploymentStateEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataSprintAssociatedDeploymentInputToDeploymentStateEnum["Pending"] = "PENDING";
    GraphQueryMetadataSprintAssociatedDeploymentInputToDeploymentStateEnum["RolledBack"] = "ROLLED_BACK";
    GraphQueryMetadataSprintAssociatedDeploymentInputToDeploymentStateEnum["Successful"] = "SUCCESSFUL";
    GraphQueryMetadataSprintAssociatedDeploymentInputToDeploymentStateEnum["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$251196d62f47dadc || ($2f512219da033f72$export$251196d62f47dadc = {}));
var $2f512219da033f72$export$ecfd24ecd1c4c396;
(function(GraphQueryMetadataSprintAssociatedDeploymentInputToEnvironmentTypeEnum) {
    GraphQueryMetadataSprintAssociatedDeploymentInputToEnvironmentTypeEnum["Development"] = "DEVELOPMENT";
    GraphQueryMetadataSprintAssociatedDeploymentInputToEnvironmentTypeEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataSprintAssociatedDeploymentInputToEnvironmentTypeEnum["Production"] = "PRODUCTION";
    GraphQueryMetadataSprintAssociatedDeploymentInputToEnvironmentTypeEnum["Staging"] = "STAGING";
    GraphQueryMetadataSprintAssociatedDeploymentInputToEnvironmentTypeEnum["Testing"] = "TESTING";
    GraphQueryMetadataSprintAssociatedDeploymentInputToEnvironmentTypeEnum["Unmapped"] = "UNMAPPED";
})($2f512219da033f72$export$ecfd24ecd1c4c396 || ($2f512219da033f72$export$ecfd24ecd1c4c396 = {}));
var $2f512219da033f72$export$2b200e1b05f9a91;
(function(GraphQueryMetadataSprintAssociatedPrInputToPullRequestStatusEnum) {
    GraphQueryMetadataSprintAssociatedPrInputToPullRequestStatusEnum["Declined"] = "DECLINED";
    GraphQueryMetadataSprintAssociatedPrInputToPullRequestStatusEnum["Merged"] = "MERGED";
    GraphQueryMetadataSprintAssociatedPrInputToPullRequestStatusEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataSprintAssociatedPrInputToPullRequestStatusEnum["Open"] = "OPEN";
    GraphQueryMetadataSprintAssociatedPrInputToPullRequestStatusEnum["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$2b200e1b05f9a91 || ($2f512219da033f72$export$2b200e1b05f9a91 = {}));
var $2f512219da033f72$export$3782643d0ae02abe;
(function(GraphQueryMetadataSprintAssociatedPrInputToReviewerReviewerStatusEnum) {
    GraphQueryMetadataSprintAssociatedPrInputToReviewerReviewerStatusEnum["Approved"] = "APPROVED";
    GraphQueryMetadataSprintAssociatedPrInputToReviewerReviewerStatusEnum["Needswork"] = "NEEDSWORK";
    GraphQueryMetadataSprintAssociatedPrInputToReviewerReviewerStatusEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataSprintAssociatedPrInputToReviewerReviewerStatusEnum["Unapproved"] = "UNAPPROVED";
})($2f512219da033f72$export$3782643d0ae02abe || ($2f512219da033f72$export$3782643d0ae02abe = {}));
var $2f512219da033f72$export$522af156c9a19c25;
(function(GraphQueryMetadataSprintAssociatedPrInputToReviewermatchTypeEnum) {
    GraphQueryMetadataSprintAssociatedPrInputToReviewermatchTypeEnum["All"] = "ALL";
    GraphQueryMetadataSprintAssociatedPrInputToReviewermatchTypeEnum["Any"] = "ANY";
    GraphQueryMetadataSprintAssociatedPrInputToReviewermatchTypeEnum["None"] = "NONE";
})($2f512219da033f72$export$522af156c9a19c25 || ($2f512219da033f72$export$522af156c9a19c25 = {}));
var $2f512219da033f72$export$67557b0182f33b6;
(function(GraphQueryMetadataSprintAssociatedVulnerabilityInputRelationshipStatusCategoryEnum) {
    GraphQueryMetadataSprintAssociatedVulnerabilityInputRelationshipStatusCategoryEnum["Done"] = "DONE";
    GraphQueryMetadataSprintAssociatedVulnerabilityInputRelationshipStatusCategoryEnum["Indeterminate"] = "INDETERMINATE";
    GraphQueryMetadataSprintAssociatedVulnerabilityInputRelationshipStatusCategoryEnum["New"] = "NEW";
    GraphQueryMetadataSprintAssociatedVulnerabilityInputRelationshipStatusCategoryEnum["Undefined"] = "UNDEFINED";
})($2f512219da033f72$export$67557b0182f33b6 || ($2f512219da033f72$export$67557b0182f33b6 = {}));
var $2f512219da033f72$export$46a86c882ece79a0;
(function(GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilitySeverityEnum) {
    GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilitySeverityEnum["Critical"] = "CRITICAL";
    GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilitySeverityEnum["High"] = "HIGH";
    GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilitySeverityEnum["Low"] = "LOW";
    GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilitySeverityEnum["Medium"] = "MEDIUM";
    GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilitySeverityEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilitySeverityEnum["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$46a86c882ece79a0 || ($2f512219da033f72$export$46a86c882ece79a0 = {}));
var $2f512219da033f72$export$7fc2bf7b37a3a03c;
(function(GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilityStatusEnum) {
    GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilityStatusEnum["Closed"] = "CLOSED";
    GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilityStatusEnum["Ignored"] = "IGNORED";
    GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilityStatusEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilityStatusEnum["Open"] = "OPEN";
    GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilityStatusEnum["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$7fc2bf7b37a3a03c || ($2f512219da033f72$export$7fc2bf7b37a3a03c = {}));
var $2f512219da033f72$export$39763c846aa96176;
(function(GraphQueryMetadataSprintContainsIssueInputToStatusCategoryEnum) {
    GraphQueryMetadataSprintContainsIssueInputToStatusCategoryEnum["Done"] = "DONE";
    GraphQueryMetadataSprintContainsIssueInputToStatusCategoryEnum["Indeterminate"] = "INDETERMINATE";
    GraphQueryMetadataSprintContainsIssueInputToStatusCategoryEnum["New"] = "NEW";
    GraphQueryMetadataSprintContainsIssueInputToStatusCategoryEnum["Undefined"] = "UNDEFINED";
})($2f512219da033f72$export$39763c846aa96176 || ($2f512219da033f72$export$39763c846aa96176 = {}));
var $2f512219da033f72$export$a2b328bd2744e149;
(function(GraphStoreAtlasGoalHasUpdateNewConfidence) {
    GraphStoreAtlasGoalHasUpdateNewConfidence["Day"] = "DAY";
    GraphStoreAtlasGoalHasUpdateNewConfidence["Month"] = "MONTH";
    GraphStoreAtlasGoalHasUpdateNewConfidence["NotSet"] = "NOT_SET";
    GraphStoreAtlasGoalHasUpdateNewConfidence["Quarter"] = "QUARTER";
})($2f512219da033f72$export$a2b328bd2744e149 || ($2f512219da033f72$export$a2b328bd2744e149 = {}));
var $2f512219da033f72$export$8c3713cb1757344d;
(function(GraphStoreAtlasGoalHasUpdateNewStatus) {
    GraphStoreAtlasGoalHasUpdateNewStatus["AtRisk"] = "AT_RISK";
    GraphStoreAtlasGoalHasUpdateNewStatus["Cancelled"] = "CANCELLED";
    GraphStoreAtlasGoalHasUpdateNewStatus["Done"] = "DONE";
    GraphStoreAtlasGoalHasUpdateNewStatus["NotSet"] = "NOT_SET";
    GraphStoreAtlasGoalHasUpdateNewStatus["OffTrack"] = "OFF_TRACK";
    GraphStoreAtlasGoalHasUpdateNewStatus["OnTrack"] = "ON_TRACK";
    GraphStoreAtlasGoalHasUpdateNewStatus["Paused"] = "PAUSED";
    GraphStoreAtlasGoalHasUpdateNewStatus["Pending"] = "PENDING";
})($2f512219da033f72$export$8c3713cb1757344d || ($2f512219da033f72$export$8c3713cb1757344d = {}));
var $2f512219da033f72$export$7de0ebd50e38066f;
(function(GraphStoreAtlasGoalHasUpdateOldConfidence) {
    GraphStoreAtlasGoalHasUpdateOldConfidence["Day"] = "DAY";
    GraphStoreAtlasGoalHasUpdateOldConfidence["Month"] = "MONTH";
    GraphStoreAtlasGoalHasUpdateOldConfidence["NotSet"] = "NOT_SET";
    GraphStoreAtlasGoalHasUpdateOldConfidence["Null"] = "NULL";
    GraphStoreAtlasGoalHasUpdateOldConfidence["Quarter"] = "QUARTER";
})($2f512219da033f72$export$7de0ebd50e38066f || ($2f512219da033f72$export$7de0ebd50e38066f = {}));
var $2f512219da033f72$export$a85ea4a452eb4f1c;
(function(GraphStoreAtlasGoalHasUpdateOldStatus) {
    GraphStoreAtlasGoalHasUpdateOldStatus["AtRisk"] = "AT_RISK";
    GraphStoreAtlasGoalHasUpdateOldStatus["Cancelled"] = "CANCELLED";
    GraphStoreAtlasGoalHasUpdateOldStatus["Done"] = "DONE";
    GraphStoreAtlasGoalHasUpdateOldStatus["NotSet"] = "NOT_SET";
    GraphStoreAtlasGoalHasUpdateOldStatus["Null"] = "NULL";
    GraphStoreAtlasGoalHasUpdateOldStatus["OffTrack"] = "OFF_TRACK";
    GraphStoreAtlasGoalHasUpdateOldStatus["OnTrack"] = "ON_TRACK";
    GraphStoreAtlasGoalHasUpdateOldStatus["Paused"] = "PAUSED";
    GraphStoreAtlasGoalHasUpdateOldStatus["Pending"] = "PENDING";
})($2f512219da033f72$export$a85ea4a452eb4f1c || ($2f512219da033f72$export$a85ea4a452eb4f1c = {}));
var $2f512219da033f72$export$c4f184d5b2aae113;
(function(GraphStoreAtlasGoalHasUpdateUpdateType) {
    GraphStoreAtlasGoalHasUpdateUpdateType["NotSet"] = "NOT_SET";
    GraphStoreAtlasGoalHasUpdateUpdateType["System"] = "SYSTEM";
    GraphStoreAtlasGoalHasUpdateUpdateType["User"] = "USER";
})($2f512219da033f72$export$c4f184d5b2aae113 || ($2f512219da033f72$export$c4f184d5b2aae113 = {}));
var $2f512219da033f72$export$a90c73458d02491;
(function(GraphStoreAtlasHomeRankingCriteriaEnum) {
    /** From the prioritized list of sources pick one item (at random from each source) at a time until we reach the target / limit */ GraphStoreAtlasHomeRankingCriteriaEnum["RoundRobinRandom"] = "ROUND_ROBIN_RANDOM";
})($2f512219da033f72$export$a90c73458d02491 || ($2f512219da033f72$export$a90c73458d02491 = {}));
var $2f512219da033f72$export$d77f0b3a4f4f349f;
(function(GraphStoreAtlasProjectHasUpdateNewConfidence) {
    GraphStoreAtlasProjectHasUpdateNewConfidence["Day"] = "DAY";
    GraphStoreAtlasProjectHasUpdateNewConfidence["Month"] = "MONTH";
    GraphStoreAtlasProjectHasUpdateNewConfidence["NotSet"] = "NOT_SET";
    GraphStoreAtlasProjectHasUpdateNewConfidence["Quarter"] = "QUARTER";
})($2f512219da033f72$export$d77f0b3a4f4f349f || ($2f512219da033f72$export$d77f0b3a4f4f349f = {}));
var $2f512219da033f72$export$2bb0fe61d291a9ee;
(function(GraphStoreAtlasProjectHasUpdateNewStatus) {
    GraphStoreAtlasProjectHasUpdateNewStatus["AtRisk"] = "AT_RISK";
    GraphStoreAtlasProjectHasUpdateNewStatus["Cancelled"] = "CANCELLED";
    GraphStoreAtlasProjectHasUpdateNewStatus["Done"] = "DONE";
    GraphStoreAtlasProjectHasUpdateNewStatus["NotSet"] = "NOT_SET";
    GraphStoreAtlasProjectHasUpdateNewStatus["OffTrack"] = "OFF_TRACK";
    GraphStoreAtlasProjectHasUpdateNewStatus["OnTrack"] = "ON_TRACK";
    GraphStoreAtlasProjectHasUpdateNewStatus["Paused"] = "PAUSED";
    GraphStoreAtlasProjectHasUpdateNewStatus["Pending"] = "PENDING";
})($2f512219da033f72$export$2bb0fe61d291a9ee || ($2f512219da033f72$export$2bb0fe61d291a9ee = {}));
var $2f512219da033f72$export$1838b3c063d5dd34;
(function(GraphStoreAtlasProjectHasUpdateOldConfidence) {
    GraphStoreAtlasProjectHasUpdateOldConfidence["Day"] = "DAY";
    GraphStoreAtlasProjectHasUpdateOldConfidence["Month"] = "MONTH";
    GraphStoreAtlasProjectHasUpdateOldConfidence["NotSet"] = "NOT_SET";
    GraphStoreAtlasProjectHasUpdateOldConfidence["Null"] = "NULL";
    GraphStoreAtlasProjectHasUpdateOldConfidence["Quarter"] = "QUARTER";
})($2f512219da033f72$export$1838b3c063d5dd34 || ($2f512219da033f72$export$1838b3c063d5dd34 = {}));
var $2f512219da033f72$export$60ece9931877824c;
(function(GraphStoreAtlasProjectHasUpdateOldStatus) {
    GraphStoreAtlasProjectHasUpdateOldStatus["AtRisk"] = "AT_RISK";
    GraphStoreAtlasProjectHasUpdateOldStatus["Cancelled"] = "CANCELLED";
    GraphStoreAtlasProjectHasUpdateOldStatus["Done"] = "DONE";
    GraphStoreAtlasProjectHasUpdateOldStatus["NotSet"] = "NOT_SET";
    GraphStoreAtlasProjectHasUpdateOldStatus["Null"] = "NULL";
    GraphStoreAtlasProjectHasUpdateOldStatus["OffTrack"] = "OFF_TRACK";
    GraphStoreAtlasProjectHasUpdateOldStatus["OnTrack"] = "ON_TRACK";
    GraphStoreAtlasProjectHasUpdateOldStatus["Paused"] = "PAUSED";
    GraphStoreAtlasProjectHasUpdateOldStatus["Pending"] = "PENDING";
})($2f512219da033f72$export$60ece9931877824c || ($2f512219da033f72$export$60ece9931877824c = {}));
var $2f512219da033f72$export$25567aeabb3bde2;
(function(GraphStoreAtlasProjectHasUpdateUpdateType) {
    GraphStoreAtlasProjectHasUpdateUpdateType["NotSet"] = "NOT_SET";
    GraphStoreAtlasProjectHasUpdateUpdateType["System"] = "SYSTEM";
    GraphStoreAtlasProjectHasUpdateUpdateType["User"] = "USER";
})($2f512219da033f72$export$25567aeabb3bde2 || ($2f512219da033f72$export$25567aeabb3bde2 = {}));
var $2f512219da033f72$export$fb0f42f72b340ab0;
(function(GraphStoreCreateComponentImpactedByIncidentJiraIncidentPriorityInput) {
    GraphStoreCreateComponentImpactedByIncidentJiraIncidentPriorityInput["NotSet"] = "NOT_SET";
    GraphStoreCreateComponentImpactedByIncidentJiraIncidentPriorityInput["P1"] = "P1";
    GraphStoreCreateComponentImpactedByIncidentJiraIncidentPriorityInput["P2"] = "P2";
    GraphStoreCreateComponentImpactedByIncidentJiraIncidentPriorityInput["P3"] = "P3";
    GraphStoreCreateComponentImpactedByIncidentJiraIncidentPriorityInput["P4"] = "P4";
    GraphStoreCreateComponentImpactedByIncidentJiraIncidentPriorityInput["P5"] = "P5";
    GraphStoreCreateComponentImpactedByIncidentJiraIncidentPriorityInput["Pending"] = "PENDING";
    GraphStoreCreateComponentImpactedByIncidentJiraIncidentPriorityInput["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$fb0f42f72b340ab0 || ($2f512219da033f72$export$fb0f42f72b340ab0 = {}));
var $2f512219da033f72$export$621f4c3ec3f34f6d;
(function(GraphStoreCreateComponentImpactedByIncidentJiraIncidentStatusInput) {
    GraphStoreCreateComponentImpactedByIncidentJiraIncidentStatusInput["Done"] = "DONE";
    GraphStoreCreateComponentImpactedByIncidentJiraIncidentStatusInput["Indeterminate"] = "INDETERMINATE";
    GraphStoreCreateComponentImpactedByIncidentJiraIncidentStatusInput["New"] = "NEW";
    GraphStoreCreateComponentImpactedByIncidentJiraIncidentStatusInput["NotSet"] = "NOT_SET";
    GraphStoreCreateComponentImpactedByIncidentJiraIncidentStatusInput["Undefined"] = "UNDEFINED";
})($2f512219da033f72$export$621f4c3ec3f34f6d || ($2f512219da033f72$export$621f4c3ec3f34f6d = {}));
var $2f512219da033f72$export$2cb64a720d855b98;
(function(GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilitySeverityInput) {
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilitySeverityInput["Critical"] = "CRITICAL";
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilitySeverityInput["High"] = "HIGH";
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilitySeverityInput["Low"] = "LOW";
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilitySeverityInput["Medium"] = "MEDIUM";
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilitySeverityInput["NotSet"] = "NOT_SET";
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilitySeverityInput["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$2cb64a720d855b98 || ($2f512219da033f72$export$2cb64a720d855b98 = {}));
var $2f512219da033f72$export$996ea6ee34911f99;
(function(GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilityStatusInput) {
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilityStatusInput["Closed"] = "CLOSED";
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilityStatusInput["Ignored"] = "IGNORED";
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilityStatusInput["NotSet"] = "NOT_SET";
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilityStatusInput["Open"] = "OPEN";
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilityStatusInput["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$996ea6ee34911f99 || ($2f512219da033f72$export$996ea6ee34911f99 = {}));
var $2f512219da033f72$export$7db5c45cbd7a8d6a;
(function(GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilityTypeInput) {
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilityTypeInput["Dast"] = "DAST";
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilityTypeInput["NotSet"] = "NOT_SET";
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilityTypeInput["Sast"] = "SAST";
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilityTypeInput["Sca"] = "SCA";
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilityTypeInput["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$7db5c45cbd7a8d6a || ($2f512219da033f72$export$7db5c45cbd7a8d6a = {}));
var $2f512219da033f72$export$9887284bd91c5bd3;
(function(GraphStoreFullComponentImpactedByIncidentJiraIncidentPriorityOutput) {
    GraphStoreFullComponentImpactedByIncidentJiraIncidentPriorityOutput["NotSet"] = "NOT_SET";
    GraphStoreFullComponentImpactedByIncidentJiraIncidentPriorityOutput["P1"] = "P1";
    GraphStoreFullComponentImpactedByIncidentJiraIncidentPriorityOutput["P2"] = "P2";
    GraphStoreFullComponentImpactedByIncidentJiraIncidentPriorityOutput["P3"] = "P3";
    GraphStoreFullComponentImpactedByIncidentJiraIncidentPriorityOutput["P4"] = "P4";
    GraphStoreFullComponentImpactedByIncidentJiraIncidentPriorityOutput["P5"] = "P5";
    GraphStoreFullComponentImpactedByIncidentJiraIncidentPriorityOutput["Pending"] = "PENDING";
    GraphStoreFullComponentImpactedByIncidentJiraIncidentPriorityOutput["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$9887284bd91c5bd3 || ($2f512219da033f72$export$9887284bd91c5bd3 = {}));
var $2f512219da033f72$export$753e474d0e2d3bcb;
(function(GraphStoreFullComponentImpactedByIncidentJiraIncidentStatusOutput) {
    GraphStoreFullComponentImpactedByIncidentJiraIncidentStatusOutput["Done"] = "DONE";
    GraphStoreFullComponentImpactedByIncidentJiraIncidentStatusOutput["Indeterminate"] = "INDETERMINATE";
    GraphStoreFullComponentImpactedByIncidentJiraIncidentStatusOutput["New"] = "NEW";
    GraphStoreFullComponentImpactedByIncidentJiraIncidentStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullComponentImpactedByIncidentJiraIncidentStatusOutput["Undefined"] = "UNDEFINED";
})($2f512219da033f72$export$753e474d0e2d3bcb || ($2f512219da033f72$export$753e474d0e2d3bcb = {}));
var $2f512219da033f72$export$983eeb7eafc088a9;
(function(GraphStoreFullIssueAssociatedBuildBuildStateOutput) {
    GraphStoreFullIssueAssociatedBuildBuildStateOutput["Cancelled"] = "CANCELLED";
    GraphStoreFullIssueAssociatedBuildBuildStateOutput["Failed"] = "FAILED";
    GraphStoreFullIssueAssociatedBuildBuildStateOutput["InProgress"] = "IN_PROGRESS";
    GraphStoreFullIssueAssociatedBuildBuildStateOutput["NotSet"] = "NOT_SET";
    GraphStoreFullIssueAssociatedBuildBuildStateOutput["Pending"] = "PENDING";
    GraphStoreFullIssueAssociatedBuildBuildStateOutput["Successful"] = "SUCCESSFUL";
    GraphStoreFullIssueAssociatedBuildBuildStateOutput["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$983eeb7eafc088a9 || ($2f512219da033f72$export$983eeb7eafc088a9 = {}));
var $2f512219da033f72$export$6707759160f13c4c;
(function(GraphStoreFullIssueAssociatedDeploymentDeploymentStateOutput) {
    GraphStoreFullIssueAssociatedDeploymentDeploymentStateOutput["Cancelled"] = "CANCELLED";
    GraphStoreFullIssueAssociatedDeploymentDeploymentStateOutput["Failed"] = "FAILED";
    GraphStoreFullIssueAssociatedDeploymentDeploymentStateOutput["InProgress"] = "IN_PROGRESS";
    GraphStoreFullIssueAssociatedDeploymentDeploymentStateOutput["NotSet"] = "NOT_SET";
    GraphStoreFullIssueAssociatedDeploymentDeploymentStateOutput["Pending"] = "PENDING";
    GraphStoreFullIssueAssociatedDeploymentDeploymentStateOutput["RolledBack"] = "ROLLED_BACK";
    GraphStoreFullIssueAssociatedDeploymentDeploymentStateOutput["Successful"] = "SUCCESSFUL";
    GraphStoreFullIssueAssociatedDeploymentDeploymentStateOutput["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$6707759160f13c4c || ($2f512219da033f72$export$6707759160f13c4c = {}));
var $2f512219da033f72$export$62f69bc9834c2852;
(function(GraphStoreFullIssueAssociatedDeploymentEnvironmentTypeOutput) {
    GraphStoreFullIssueAssociatedDeploymentEnvironmentTypeOutput["Development"] = "DEVELOPMENT";
    GraphStoreFullIssueAssociatedDeploymentEnvironmentTypeOutput["NotSet"] = "NOT_SET";
    GraphStoreFullIssueAssociatedDeploymentEnvironmentTypeOutput["Production"] = "PRODUCTION";
    GraphStoreFullIssueAssociatedDeploymentEnvironmentTypeOutput["Staging"] = "STAGING";
    GraphStoreFullIssueAssociatedDeploymentEnvironmentTypeOutput["Testing"] = "TESTING";
    GraphStoreFullIssueAssociatedDeploymentEnvironmentTypeOutput["Unmapped"] = "UNMAPPED";
})($2f512219da033f72$export$62f69bc9834c2852 || ($2f512219da033f72$export$62f69bc9834c2852 = {}));
var $2f512219da033f72$export$a3ef183d8c6ea7f8;
(function(GraphStoreFullIssueAssociatedDesignDesignStatusOutput) {
    GraphStoreFullIssueAssociatedDesignDesignStatusOutput["None"] = "NONE";
    GraphStoreFullIssueAssociatedDesignDesignStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullIssueAssociatedDesignDesignStatusOutput["ReadyForDevelopment"] = "READY_FOR_DEVELOPMENT";
    GraphStoreFullIssueAssociatedDesignDesignStatusOutput["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$a3ef183d8c6ea7f8 || ($2f512219da033f72$export$a3ef183d8c6ea7f8 = {}));
var $2f512219da033f72$export$e0814c7e8e75c569;
(function(GraphStoreFullIssueAssociatedDesignDesignTypeOutput) {
    GraphStoreFullIssueAssociatedDesignDesignTypeOutput["Canvas"] = "CANVAS";
    GraphStoreFullIssueAssociatedDesignDesignTypeOutput["File"] = "FILE";
    GraphStoreFullIssueAssociatedDesignDesignTypeOutput["Group"] = "GROUP";
    GraphStoreFullIssueAssociatedDesignDesignTypeOutput["Node"] = "NODE";
    GraphStoreFullIssueAssociatedDesignDesignTypeOutput["NotSet"] = "NOT_SET";
    GraphStoreFullIssueAssociatedDesignDesignTypeOutput["Other"] = "OTHER";
    GraphStoreFullIssueAssociatedDesignDesignTypeOutput["Prototype"] = "PROTOTYPE";
})($2f512219da033f72$export$e0814c7e8e75c569 || ($2f512219da033f72$export$e0814c7e8e75c569 = {}));
var $2f512219da033f72$export$f82857e2145c8247;
(function(GraphStoreFullIssueAssociatedIssueRemoteLinkLinkApplicationTypeOutput) {
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkApplicationTypeOutput["Bamboo"] = "BAMBOO";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkApplicationTypeOutput["BbPrComment"] = "BB_PR_COMMENT";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkApplicationTypeOutput["ConfluencePage"] = "CONFLUENCE_PAGE";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkApplicationTypeOutput["Jira"] = "JIRA";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkApplicationTypeOutput["NotSet"] = "NOT_SET";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkApplicationTypeOutput["Snyk"] = "SNYK";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkApplicationTypeOutput["Trello"] = "TRELLO";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkApplicationTypeOutput["WebLink"] = "WEB_LINK";
})($2f512219da033f72$export$f82857e2145c8247 || ($2f512219da033f72$export$f82857e2145c8247 = {}));
var $2f512219da033f72$export$90175675ed9a274f;
(function(GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput) {
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["AddedToIdea"] = "ADDED_TO_IDEA";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["Blocks"] = "BLOCKS";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["Causes"] = "CAUSES";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["Clones"] = "CLONES";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["CreatedFrom"] = "CREATED_FROM";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["Duplicates"] = "DUPLICATES";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["Implements"] = "IMPLEMENTS";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["IsBlockedBy"] = "IS_BLOCKED_BY";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["IsCausedBy"] = "IS_CAUSED_BY";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["IsClonedBy"] = "IS_CLONED_BY";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["IsDuplicatedBy"] = "IS_DUPLICATED_BY";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["IsIdeaFor"] = "IS_IDEA_FOR";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["IsImplementedBy"] = "IS_IMPLEMENTED_BY";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["IsReviewedBy"] = "IS_REVIEWED_BY";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["MentionedIn"] = "MENTIONED_IN";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["MergedFrom"] = "MERGED_FROM";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["MergedInto"] = "MERGED_INTO";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["NotSet"] = "NOT_SET";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["RelatesTo"] = "RELATES_TO";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["Reviews"] = "REVIEWS";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["SplitFrom"] = "SPLIT_FROM";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["SplitTo"] = "SPLIT_TO";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["WikiPage"] = "WIKI_PAGE";
})($2f512219da033f72$export$90175675ed9a274f || ($2f512219da033f72$export$90175675ed9a274f = {}));
var $2f512219da033f72$export$947d4abb5daf138e;
(function(GraphStoreFullIssueAssociatedPrPullRequestStatusOutput) {
    GraphStoreFullIssueAssociatedPrPullRequestStatusOutput["Declined"] = "DECLINED";
    GraphStoreFullIssueAssociatedPrPullRequestStatusOutput["Merged"] = "MERGED";
    GraphStoreFullIssueAssociatedPrPullRequestStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullIssueAssociatedPrPullRequestStatusOutput["Open"] = "OPEN";
    GraphStoreFullIssueAssociatedPrPullRequestStatusOutput["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$947d4abb5daf138e || ($2f512219da033f72$export$947d4abb5daf138e = {}));
var $2f512219da033f72$export$e353d7be2a12f0f2;
(function(GraphStoreFullIssueAssociatedPrReviewerReviewerStatusOutput) {
    GraphStoreFullIssueAssociatedPrReviewerReviewerStatusOutput["Approved"] = "APPROVED";
    GraphStoreFullIssueAssociatedPrReviewerReviewerStatusOutput["Needswork"] = "NEEDSWORK";
    GraphStoreFullIssueAssociatedPrReviewerReviewerStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullIssueAssociatedPrReviewerReviewerStatusOutput["Unapproved"] = "UNAPPROVED";
})($2f512219da033f72$export$e353d7be2a12f0f2 || ($2f512219da033f72$export$e353d7be2a12f0f2 = {}));
var $2f512219da033f72$export$e336ee68867d9184;
(function(GraphStoreFullJswProjectAssociatedIncidentJiraIncidentPriorityOutput) {
    GraphStoreFullJswProjectAssociatedIncidentJiraIncidentPriorityOutput["NotSet"] = "NOT_SET";
    GraphStoreFullJswProjectAssociatedIncidentJiraIncidentPriorityOutput["P1"] = "P1";
    GraphStoreFullJswProjectAssociatedIncidentJiraIncidentPriorityOutput["P2"] = "P2";
    GraphStoreFullJswProjectAssociatedIncidentJiraIncidentPriorityOutput["P3"] = "P3";
    GraphStoreFullJswProjectAssociatedIncidentJiraIncidentPriorityOutput["P4"] = "P4";
    GraphStoreFullJswProjectAssociatedIncidentJiraIncidentPriorityOutput["P5"] = "P5";
    GraphStoreFullJswProjectAssociatedIncidentJiraIncidentPriorityOutput["Pending"] = "PENDING";
    GraphStoreFullJswProjectAssociatedIncidentJiraIncidentPriorityOutput["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$e336ee68867d9184 || ($2f512219da033f72$export$e336ee68867d9184 = {}));
var $2f512219da033f72$export$8a57dccf86b2a6de;
(function(GraphStoreFullJswProjectAssociatedIncidentJiraIncidentStatusOutput) {
    GraphStoreFullJswProjectAssociatedIncidentJiraIncidentStatusOutput["Done"] = "DONE";
    GraphStoreFullJswProjectAssociatedIncidentJiraIncidentStatusOutput["Indeterminate"] = "INDETERMINATE";
    GraphStoreFullJswProjectAssociatedIncidentJiraIncidentStatusOutput["New"] = "NEW";
    GraphStoreFullJswProjectAssociatedIncidentJiraIncidentStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullJswProjectAssociatedIncidentJiraIncidentStatusOutput["Undefined"] = "UNDEFINED";
})($2f512219da033f72$export$8a57dccf86b2a6de || ($2f512219da033f72$export$8a57dccf86b2a6de = {}));
var $2f512219da033f72$export$d781aa0d3a6bc4bd;
(function(GraphStoreFullParentDocumentHasChildDocumentCategoryOutput) {
    GraphStoreFullParentDocumentHasChildDocumentCategoryOutput["Archive"] = "ARCHIVE";
    GraphStoreFullParentDocumentHasChildDocumentCategoryOutput["Audio"] = "AUDIO";
    GraphStoreFullParentDocumentHasChildDocumentCategoryOutput["Code"] = "CODE";
    GraphStoreFullParentDocumentHasChildDocumentCategoryOutput["Document"] = "DOCUMENT";
    GraphStoreFullParentDocumentHasChildDocumentCategoryOutput["Folder"] = "FOLDER";
    GraphStoreFullParentDocumentHasChildDocumentCategoryOutput["Form"] = "FORM";
    GraphStoreFullParentDocumentHasChildDocumentCategoryOutput["Image"] = "IMAGE";
    GraphStoreFullParentDocumentHasChildDocumentCategoryOutput["NotSet"] = "NOT_SET";
    GraphStoreFullParentDocumentHasChildDocumentCategoryOutput["Other"] = "OTHER";
    GraphStoreFullParentDocumentHasChildDocumentCategoryOutput["Pdf"] = "PDF";
    GraphStoreFullParentDocumentHasChildDocumentCategoryOutput["Presentation"] = "PRESENTATION";
    GraphStoreFullParentDocumentHasChildDocumentCategoryOutput["Shortcut"] = "SHORTCUT";
    GraphStoreFullParentDocumentHasChildDocumentCategoryOutput["Spreadsheet"] = "SPREADSHEET";
    GraphStoreFullParentDocumentHasChildDocumentCategoryOutput["Video"] = "VIDEO";
})($2f512219da033f72$export$d781aa0d3a6bc4bd || ($2f512219da033f72$export$d781aa0d3a6bc4bd = {}));
var $2f512219da033f72$export$12686f8906883b4d;
(function(GraphStoreFullProjectAssociatedBuildBuildStateOutput) {
    GraphStoreFullProjectAssociatedBuildBuildStateOutput["Cancelled"] = "CANCELLED";
    GraphStoreFullProjectAssociatedBuildBuildStateOutput["Failed"] = "FAILED";
    GraphStoreFullProjectAssociatedBuildBuildStateOutput["InProgress"] = "IN_PROGRESS";
    GraphStoreFullProjectAssociatedBuildBuildStateOutput["NotSet"] = "NOT_SET";
    GraphStoreFullProjectAssociatedBuildBuildStateOutput["Pending"] = "PENDING";
    GraphStoreFullProjectAssociatedBuildBuildStateOutput["Successful"] = "SUCCESSFUL";
    GraphStoreFullProjectAssociatedBuildBuildStateOutput["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$12686f8906883b4d || ($2f512219da033f72$export$12686f8906883b4d = {}));
var $2f512219da033f72$export$1a6794f56a498d8;
(function(GraphStoreFullProjectAssociatedDeploymentDeploymentStateOutput) {
    GraphStoreFullProjectAssociatedDeploymentDeploymentStateOutput["Cancelled"] = "CANCELLED";
    GraphStoreFullProjectAssociatedDeploymentDeploymentStateOutput["Failed"] = "FAILED";
    GraphStoreFullProjectAssociatedDeploymentDeploymentStateOutput["InProgress"] = "IN_PROGRESS";
    GraphStoreFullProjectAssociatedDeploymentDeploymentStateOutput["NotSet"] = "NOT_SET";
    GraphStoreFullProjectAssociatedDeploymentDeploymentStateOutput["Pending"] = "PENDING";
    GraphStoreFullProjectAssociatedDeploymentDeploymentStateOutput["RolledBack"] = "ROLLED_BACK";
    GraphStoreFullProjectAssociatedDeploymentDeploymentStateOutput["Successful"] = "SUCCESSFUL";
    GraphStoreFullProjectAssociatedDeploymentDeploymentStateOutput["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$1a6794f56a498d8 || ($2f512219da033f72$export$1a6794f56a498d8 = {}));
var $2f512219da033f72$export$757f321f826d4b9f;
(function(GraphStoreFullProjectAssociatedDeploymentEnvironmentTypeOutput) {
    GraphStoreFullProjectAssociatedDeploymentEnvironmentTypeOutput["Development"] = "DEVELOPMENT";
    GraphStoreFullProjectAssociatedDeploymentEnvironmentTypeOutput["NotSet"] = "NOT_SET";
    GraphStoreFullProjectAssociatedDeploymentEnvironmentTypeOutput["Production"] = "PRODUCTION";
    GraphStoreFullProjectAssociatedDeploymentEnvironmentTypeOutput["Staging"] = "STAGING";
    GraphStoreFullProjectAssociatedDeploymentEnvironmentTypeOutput["Testing"] = "TESTING";
    GraphStoreFullProjectAssociatedDeploymentEnvironmentTypeOutput["Unmapped"] = "UNMAPPED";
})($2f512219da033f72$export$757f321f826d4b9f || ($2f512219da033f72$export$757f321f826d4b9f = {}));
var $2f512219da033f72$export$bed7454cabd50a99;
(function(GraphStoreFullProjectAssociatedPrPullRequestStatusOutput) {
    GraphStoreFullProjectAssociatedPrPullRequestStatusOutput["Declined"] = "DECLINED";
    GraphStoreFullProjectAssociatedPrPullRequestStatusOutput["Merged"] = "MERGED";
    GraphStoreFullProjectAssociatedPrPullRequestStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullProjectAssociatedPrPullRequestStatusOutput["Open"] = "OPEN";
    GraphStoreFullProjectAssociatedPrPullRequestStatusOutput["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$bed7454cabd50a99 || ($2f512219da033f72$export$bed7454cabd50a99 = {}));
var $2f512219da033f72$export$e0795a56969d3929;
(function(GraphStoreFullProjectAssociatedPrReviewerReviewerStatusOutput) {
    GraphStoreFullProjectAssociatedPrReviewerReviewerStatusOutput["Approved"] = "APPROVED";
    GraphStoreFullProjectAssociatedPrReviewerReviewerStatusOutput["Needswork"] = "NEEDSWORK";
    GraphStoreFullProjectAssociatedPrReviewerReviewerStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullProjectAssociatedPrReviewerReviewerStatusOutput["Unapproved"] = "UNAPPROVED";
})($2f512219da033f72$export$e0795a56969d3929 || ($2f512219da033f72$export$e0795a56969d3929 = {}));
var $2f512219da033f72$export$c56f5d7588a02f34;
(function(GraphStoreFullProjectAssociatedVulnerabilityVulnerabilitySeverityOutput) {
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilitySeverityOutput["Critical"] = "CRITICAL";
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilitySeverityOutput["High"] = "HIGH";
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilitySeverityOutput["Low"] = "LOW";
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilitySeverityOutput["Medium"] = "MEDIUM";
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilitySeverityOutput["NotSet"] = "NOT_SET";
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilitySeverityOutput["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$c56f5d7588a02f34 || ($2f512219da033f72$export$c56f5d7588a02f34 = {}));
var $2f512219da033f72$export$9406f481f6c79a5d;
(function(GraphStoreFullProjectAssociatedVulnerabilityVulnerabilityStatusOutput) {
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilityStatusOutput["Closed"] = "CLOSED";
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilityStatusOutput["Ignored"] = "IGNORED";
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilityStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilityStatusOutput["Open"] = "OPEN";
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilityStatusOutput["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$9406f481f6c79a5d || ($2f512219da033f72$export$9406f481f6c79a5d = {}));
var $2f512219da033f72$export$d307e59860de1336;
(function(GraphStoreFullProjectAssociatedVulnerabilityVulnerabilityTypeOutput) {
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilityTypeOutput["Dast"] = "DAST";
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilityTypeOutput["NotSet"] = "NOT_SET";
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilityTypeOutput["Sast"] = "SAST";
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilityTypeOutput["Sca"] = "SCA";
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilityTypeOutput["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$d307e59860de1336 || ($2f512219da033f72$export$d307e59860de1336 = {}));
var $2f512219da033f72$export$ec0309648167c01f;
(function(GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilitySeverityOutput) {
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilitySeverityOutput["Critical"] = "CRITICAL";
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilitySeverityOutput["High"] = "HIGH";
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilitySeverityOutput["Low"] = "LOW";
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilitySeverityOutput["Medium"] = "MEDIUM";
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilitySeverityOutput["NotSet"] = "NOT_SET";
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilitySeverityOutput["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$ec0309648167c01f || ($2f512219da033f72$export$ec0309648167c01f = {}));
var $2f512219da033f72$export$55ab07a5fac6a121;
(function(GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilityStatusOutput) {
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilityStatusOutput["Closed"] = "CLOSED";
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilityStatusOutput["Ignored"] = "IGNORED";
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilityStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilityStatusOutput["Open"] = "OPEN";
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilityStatusOutput["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$55ab07a5fac6a121 || ($2f512219da033f72$export$55ab07a5fac6a121 = {}));
var $2f512219da033f72$export$93214a30dc67e249;
(function(GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilityTypeOutput) {
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilityTypeOutput["Dast"] = "DAST";
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilityTypeOutput["NotSet"] = "NOT_SET";
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilityTypeOutput["Sast"] = "SAST";
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilityTypeOutput["Sca"] = "SCA";
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilityTypeOutput["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$93214a30dc67e249 || ($2f512219da033f72$export$93214a30dc67e249 = {}));
var $2f512219da033f72$export$cb34d20b583b9880;
(function(GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentPriorityOutput) {
    GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentPriorityOutput["NotSet"] = "NOT_SET";
    GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentPriorityOutput["P1"] = "P1";
    GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentPriorityOutput["P2"] = "P2";
    GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentPriorityOutput["P3"] = "P3";
    GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentPriorityOutput["P4"] = "P4";
    GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentPriorityOutput["P5"] = "P5";
})($2f512219da033f72$export$cb34d20b583b9880 || ($2f512219da033f72$export$cb34d20b583b9880 = {}));
var $2f512219da033f72$export$4f97d0efb46b21d7;
(function(GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentStatusOutput) {
    GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentStatusOutput["Done"] = "DONE";
    GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentStatusOutput["Indeterminate"] = "INDETERMINATE";
    GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentStatusOutput["New"] = "NEW";
    GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentStatusOutput["Undefined"] = "UNDEFINED";
})($2f512219da033f72$export$4f97d0efb46b21d7 || ($2f512219da033f72$export$4f97d0efb46b21d7 = {}));
var $2f512219da033f72$export$1faf908d1ac6334b;
(function(GraphStoreFullSprintAssociatedBuildBuildStateOutput) {
    GraphStoreFullSprintAssociatedBuildBuildStateOutput["Cancelled"] = "CANCELLED";
    GraphStoreFullSprintAssociatedBuildBuildStateOutput["Failed"] = "FAILED";
    GraphStoreFullSprintAssociatedBuildBuildStateOutput["InProgress"] = "IN_PROGRESS";
    GraphStoreFullSprintAssociatedBuildBuildStateOutput["NotSet"] = "NOT_SET";
    GraphStoreFullSprintAssociatedBuildBuildStateOutput["Pending"] = "PENDING";
    GraphStoreFullSprintAssociatedBuildBuildStateOutput["Successful"] = "SUCCESSFUL";
    GraphStoreFullSprintAssociatedBuildBuildStateOutput["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$1faf908d1ac6334b || ($2f512219da033f72$export$1faf908d1ac6334b = {}));
var $2f512219da033f72$export$5bab79a51fe84df7;
(function(GraphStoreFullSprintAssociatedDeploymentDeploymentStateOutput) {
    GraphStoreFullSprintAssociatedDeploymentDeploymentStateOutput["Cancelled"] = "CANCELLED";
    GraphStoreFullSprintAssociatedDeploymentDeploymentStateOutput["Failed"] = "FAILED";
    GraphStoreFullSprintAssociatedDeploymentDeploymentStateOutput["InProgress"] = "IN_PROGRESS";
    GraphStoreFullSprintAssociatedDeploymentDeploymentStateOutput["NotSet"] = "NOT_SET";
    GraphStoreFullSprintAssociatedDeploymentDeploymentStateOutput["Pending"] = "PENDING";
    GraphStoreFullSprintAssociatedDeploymentDeploymentStateOutput["RolledBack"] = "ROLLED_BACK";
    GraphStoreFullSprintAssociatedDeploymentDeploymentStateOutput["Successful"] = "SUCCESSFUL";
    GraphStoreFullSprintAssociatedDeploymentDeploymentStateOutput["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$5bab79a51fe84df7 || ($2f512219da033f72$export$5bab79a51fe84df7 = {}));
var $2f512219da033f72$export$c8f81b6916886c13;
(function(GraphStoreFullSprintAssociatedDeploymentEnvironmentTypeOutput) {
    GraphStoreFullSprintAssociatedDeploymentEnvironmentTypeOutput["Development"] = "DEVELOPMENT";
    GraphStoreFullSprintAssociatedDeploymentEnvironmentTypeOutput["NotSet"] = "NOT_SET";
    GraphStoreFullSprintAssociatedDeploymentEnvironmentTypeOutput["Production"] = "PRODUCTION";
    GraphStoreFullSprintAssociatedDeploymentEnvironmentTypeOutput["Staging"] = "STAGING";
    GraphStoreFullSprintAssociatedDeploymentEnvironmentTypeOutput["Testing"] = "TESTING";
    GraphStoreFullSprintAssociatedDeploymentEnvironmentTypeOutput["Unmapped"] = "UNMAPPED";
})($2f512219da033f72$export$c8f81b6916886c13 || ($2f512219da033f72$export$c8f81b6916886c13 = {}));
var $2f512219da033f72$export$889f8821445073a8;
(function(GraphStoreFullSprintAssociatedPrPullRequestStatusOutput) {
    GraphStoreFullSprintAssociatedPrPullRequestStatusOutput["Declined"] = "DECLINED";
    GraphStoreFullSprintAssociatedPrPullRequestStatusOutput["Merged"] = "MERGED";
    GraphStoreFullSprintAssociatedPrPullRequestStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullSprintAssociatedPrPullRequestStatusOutput["Open"] = "OPEN";
    GraphStoreFullSprintAssociatedPrPullRequestStatusOutput["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$889f8821445073a8 || ($2f512219da033f72$export$889f8821445073a8 = {}));
var $2f512219da033f72$export$25d6205b4517999;
(function(GraphStoreFullSprintAssociatedPrReviewerReviewerStatusOutput) {
    GraphStoreFullSprintAssociatedPrReviewerReviewerStatusOutput["Approved"] = "APPROVED";
    GraphStoreFullSprintAssociatedPrReviewerReviewerStatusOutput["Needswork"] = "NEEDSWORK";
    GraphStoreFullSprintAssociatedPrReviewerReviewerStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullSprintAssociatedPrReviewerReviewerStatusOutput["Unapproved"] = "UNAPPROVED";
})($2f512219da033f72$export$25d6205b4517999 || ($2f512219da033f72$export$25d6205b4517999 = {}));
var $2f512219da033f72$export$f128313c5c33553a;
(function(GraphStoreFullSprintAssociatedVulnerabilityStatusCategoryOutput) {
    GraphStoreFullSprintAssociatedVulnerabilityStatusCategoryOutput["Done"] = "DONE";
    GraphStoreFullSprintAssociatedVulnerabilityStatusCategoryOutput["Indeterminate"] = "INDETERMINATE";
    GraphStoreFullSprintAssociatedVulnerabilityStatusCategoryOutput["New"] = "NEW";
    GraphStoreFullSprintAssociatedVulnerabilityStatusCategoryOutput["Undefined"] = "UNDEFINED";
})($2f512219da033f72$export$f128313c5c33553a || ($2f512219da033f72$export$f128313c5c33553a = {}));
var $2f512219da033f72$export$987cd4ea5561fc8e;
(function(GraphStoreFullSprintAssociatedVulnerabilityVulnerabilitySeverityOutput) {
    GraphStoreFullSprintAssociatedVulnerabilityVulnerabilitySeverityOutput["Critical"] = "CRITICAL";
    GraphStoreFullSprintAssociatedVulnerabilityVulnerabilitySeverityOutput["High"] = "HIGH";
    GraphStoreFullSprintAssociatedVulnerabilityVulnerabilitySeverityOutput["Low"] = "LOW";
    GraphStoreFullSprintAssociatedVulnerabilityVulnerabilitySeverityOutput["Medium"] = "MEDIUM";
    GraphStoreFullSprintAssociatedVulnerabilityVulnerabilitySeverityOutput["NotSet"] = "NOT_SET";
    GraphStoreFullSprintAssociatedVulnerabilityVulnerabilitySeverityOutput["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$987cd4ea5561fc8e || ($2f512219da033f72$export$987cd4ea5561fc8e = {}));
var $2f512219da033f72$export$bf865dbaf78a8d95;
(function(GraphStoreFullSprintAssociatedVulnerabilityVulnerabilityStatusOutput) {
    GraphStoreFullSprintAssociatedVulnerabilityVulnerabilityStatusOutput["Closed"] = "CLOSED";
    GraphStoreFullSprintAssociatedVulnerabilityVulnerabilityStatusOutput["Ignored"] = "IGNORED";
    GraphStoreFullSprintAssociatedVulnerabilityVulnerabilityStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullSprintAssociatedVulnerabilityVulnerabilityStatusOutput["Open"] = "OPEN";
    GraphStoreFullSprintAssociatedVulnerabilityVulnerabilityStatusOutput["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$bf865dbaf78a8d95 || ($2f512219da033f72$export$bf865dbaf78a8d95 = {}));
var $2f512219da033f72$export$5296991171ff0fcb;
(function(GraphStoreFullSprintContainsIssueStatusCategoryOutput) {
    GraphStoreFullSprintContainsIssueStatusCategoryOutput["Done"] = "DONE";
    GraphStoreFullSprintContainsIssueStatusCategoryOutput["Indeterminate"] = "INDETERMINATE";
    GraphStoreFullSprintContainsIssueStatusCategoryOutput["New"] = "NEW";
    GraphStoreFullSprintContainsIssueStatusCategoryOutput["Undefined"] = "UNDEFINED";
})($2f512219da033f72$export$5296991171ff0fcb || ($2f512219da033f72$export$5296991171ff0fcb = {}));
var $2f512219da033f72$export$50919f92f150f4c2;
(function(GraphStoreFullVersionAssociatedDesignDesignStatusOutput) {
    GraphStoreFullVersionAssociatedDesignDesignStatusOutput["None"] = "NONE";
    GraphStoreFullVersionAssociatedDesignDesignStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullVersionAssociatedDesignDesignStatusOutput["ReadyForDevelopment"] = "READY_FOR_DEVELOPMENT";
    GraphStoreFullVersionAssociatedDesignDesignStatusOutput["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$50919f92f150f4c2 || ($2f512219da033f72$export$50919f92f150f4c2 = {}));
var $2f512219da033f72$export$a1b88d68d1f49808;
(function(GraphStoreFullVersionAssociatedDesignDesignTypeOutput) {
    GraphStoreFullVersionAssociatedDesignDesignTypeOutput["Canvas"] = "CANVAS";
    GraphStoreFullVersionAssociatedDesignDesignTypeOutput["File"] = "FILE";
    GraphStoreFullVersionAssociatedDesignDesignTypeOutput["Group"] = "GROUP";
    GraphStoreFullVersionAssociatedDesignDesignTypeOutput["Node"] = "NODE";
    GraphStoreFullVersionAssociatedDesignDesignTypeOutput["NotSet"] = "NOT_SET";
    GraphStoreFullVersionAssociatedDesignDesignTypeOutput["Other"] = "OTHER";
    GraphStoreFullVersionAssociatedDesignDesignTypeOutput["Prototype"] = "PROTOTYPE";
})($2f512219da033f72$export$a1b88d68d1f49808 || ($2f512219da033f72$export$a1b88d68d1f49808 = {}));
var $2f512219da033f72$export$fabcab228e2ed9c7;
(function(GraphStoreFullVulnerabilityAssociatedIssueVulnerabilitySeverityOutput) {
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilitySeverityOutput["Critical"] = "CRITICAL";
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilitySeverityOutput["High"] = "HIGH";
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilitySeverityOutput["Low"] = "LOW";
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilitySeverityOutput["Medium"] = "MEDIUM";
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilitySeverityOutput["NotSet"] = "NOT_SET";
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilitySeverityOutput["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$fabcab228e2ed9c7 || ($2f512219da033f72$export$fabcab228e2ed9c7 = {}));
var $2f512219da033f72$export$6e4f0b0ee9bb1b2b;
(function(GraphStoreFullVulnerabilityAssociatedIssueVulnerabilityStatusOutput) {
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilityStatusOutput["Closed"] = "CLOSED";
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilityStatusOutput["Ignored"] = "IGNORED";
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilityStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilityStatusOutput["Open"] = "OPEN";
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilityStatusOutput["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$6e4f0b0ee9bb1b2b || ($2f512219da033f72$export$6e4f0b0ee9bb1b2b = {}));
var $2f512219da033f72$export$4ec664baba8498fa;
(function(GraphStoreFullVulnerabilityAssociatedIssueVulnerabilityTypeOutput) {
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilityTypeOutput["Dast"] = "DAST";
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilityTypeOutput["NotSet"] = "NOT_SET";
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilityTypeOutput["Sast"] = "SAST";
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilityTypeOutput["Sca"] = "SCA";
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilityTypeOutput["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$4ec664baba8498fa || ($2f512219da033f72$export$4ec664baba8498fa = {}));
var $2f512219da033f72$export$ca58efde64d86f94;
(function(GraphStoreIssueAssociatedDeploymentDeploymentState) {
    GraphStoreIssueAssociatedDeploymentDeploymentState["Cancelled"] = "CANCELLED";
    GraphStoreIssueAssociatedDeploymentDeploymentState["Failed"] = "FAILED";
    GraphStoreIssueAssociatedDeploymentDeploymentState["InProgress"] = "IN_PROGRESS";
    GraphStoreIssueAssociatedDeploymentDeploymentState["NotSet"] = "NOT_SET";
    GraphStoreIssueAssociatedDeploymentDeploymentState["Pending"] = "PENDING";
    GraphStoreIssueAssociatedDeploymentDeploymentState["RolledBack"] = "ROLLED_BACK";
    GraphStoreIssueAssociatedDeploymentDeploymentState["Successful"] = "SUCCESSFUL";
    GraphStoreIssueAssociatedDeploymentDeploymentState["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$ca58efde64d86f94 || ($2f512219da033f72$export$ca58efde64d86f94 = {}));
var $2f512219da033f72$export$3ad8a7711584b9be;
(function(GraphStoreIssueAssociatedDeploymentEnvironmentType) {
    GraphStoreIssueAssociatedDeploymentEnvironmentType["Development"] = "DEVELOPMENT";
    GraphStoreIssueAssociatedDeploymentEnvironmentType["NotSet"] = "NOT_SET";
    GraphStoreIssueAssociatedDeploymentEnvironmentType["Production"] = "PRODUCTION";
    GraphStoreIssueAssociatedDeploymentEnvironmentType["Staging"] = "STAGING";
    GraphStoreIssueAssociatedDeploymentEnvironmentType["Testing"] = "TESTING";
    GraphStoreIssueAssociatedDeploymentEnvironmentType["Unmapped"] = "UNMAPPED";
})($2f512219da033f72$export$3ad8a7711584b9be || ($2f512219da033f72$export$3ad8a7711584b9be = {}));
var $2f512219da033f72$export$a79c5b827301ce70;
(function(GraphStoreJswProjectAssociatedIncidentJiraIncidentPriority) {
    GraphStoreJswProjectAssociatedIncidentJiraIncidentPriority["NotSet"] = "NOT_SET";
    GraphStoreJswProjectAssociatedIncidentJiraIncidentPriority["P1"] = "P1";
    GraphStoreJswProjectAssociatedIncidentJiraIncidentPriority["P2"] = "P2";
    GraphStoreJswProjectAssociatedIncidentJiraIncidentPriority["P3"] = "P3";
    GraphStoreJswProjectAssociatedIncidentJiraIncidentPriority["P4"] = "P4";
    GraphStoreJswProjectAssociatedIncidentJiraIncidentPriority["P5"] = "P5";
    GraphStoreJswProjectAssociatedIncidentJiraIncidentPriority["Pending"] = "PENDING";
    GraphStoreJswProjectAssociatedIncidentJiraIncidentPriority["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$a79c5b827301ce70 || ($2f512219da033f72$export$a79c5b827301ce70 = {}));
var $2f512219da033f72$export$bb923b67e7b3c5a3;
(function(GraphStoreJswProjectAssociatedIncidentJiraIncidentStatus) {
    GraphStoreJswProjectAssociatedIncidentJiraIncidentStatus["Done"] = "DONE";
    GraphStoreJswProjectAssociatedIncidentJiraIncidentStatus["Indeterminate"] = "INDETERMINATE";
    GraphStoreJswProjectAssociatedIncidentJiraIncidentStatus["New"] = "NEW";
    GraphStoreJswProjectAssociatedIncidentJiraIncidentStatus["NotSet"] = "NOT_SET";
    GraphStoreJswProjectAssociatedIncidentJiraIncidentStatus["Undefined"] = "UNDEFINED";
})($2f512219da033f72$export$bb923b67e7b3c5a3 || ($2f512219da033f72$export$bb923b67e7b3c5a3 = {}));
var $2f512219da033f72$export$f153746befb8db60;
(function(GraphStoreProjectAssociatedBuildBuildState) {
    GraphStoreProjectAssociatedBuildBuildState["Cancelled"] = "CANCELLED";
    GraphStoreProjectAssociatedBuildBuildState["Failed"] = "FAILED";
    GraphStoreProjectAssociatedBuildBuildState["InProgress"] = "IN_PROGRESS";
    GraphStoreProjectAssociatedBuildBuildState["NotSet"] = "NOT_SET";
    GraphStoreProjectAssociatedBuildBuildState["Pending"] = "PENDING";
    GraphStoreProjectAssociatedBuildBuildState["Successful"] = "SUCCESSFUL";
    GraphStoreProjectAssociatedBuildBuildState["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$f153746befb8db60 || ($2f512219da033f72$export$f153746befb8db60 = {}));
var $2f512219da033f72$export$3d406ab6bd989229;
(function(GraphStoreProjectAssociatedDeploymentDeploymentState) {
    GraphStoreProjectAssociatedDeploymentDeploymentState["Cancelled"] = "CANCELLED";
    GraphStoreProjectAssociatedDeploymentDeploymentState["Failed"] = "FAILED";
    GraphStoreProjectAssociatedDeploymentDeploymentState["InProgress"] = "IN_PROGRESS";
    GraphStoreProjectAssociatedDeploymentDeploymentState["NotSet"] = "NOT_SET";
    GraphStoreProjectAssociatedDeploymentDeploymentState["Pending"] = "PENDING";
    GraphStoreProjectAssociatedDeploymentDeploymentState["RolledBack"] = "ROLLED_BACK";
    GraphStoreProjectAssociatedDeploymentDeploymentState["Successful"] = "SUCCESSFUL";
    GraphStoreProjectAssociatedDeploymentDeploymentState["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$3d406ab6bd989229 || ($2f512219da033f72$export$3d406ab6bd989229 = {}));
var $2f512219da033f72$export$1e042c9b11303649;
(function(GraphStoreProjectAssociatedDeploymentEnvironmentType) {
    GraphStoreProjectAssociatedDeploymentEnvironmentType["Development"] = "DEVELOPMENT";
    GraphStoreProjectAssociatedDeploymentEnvironmentType["NotSet"] = "NOT_SET";
    GraphStoreProjectAssociatedDeploymentEnvironmentType["Production"] = "PRODUCTION";
    GraphStoreProjectAssociatedDeploymentEnvironmentType["Staging"] = "STAGING";
    GraphStoreProjectAssociatedDeploymentEnvironmentType["Testing"] = "TESTING";
    GraphStoreProjectAssociatedDeploymentEnvironmentType["Unmapped"] = "UNMAPPED";
})($2f512219da033f72$export$1e042c9b11303649 || ($2f512219da033f72$export$1e042c9b11303649 = {}));
var $2f512219da033f72$export$4d0f434df5bd5f5d;
(function(GraphStoreProjectAssociatedPrPullRequestStatus) {
    GraphStoreProjectAssociatedPrPullRequestStatus["Declined"] = "DECLINED";
    GraphStoreProjectAssociatedPrPullRequestStatus["Merged"] = "MERGED";
    GraphStoreProjectAssociatedPrPullRequestStatus["NotSet"] = "NOT_SET";
    GraphStoreProjectAssociatedPrPullRequestStatus["Open"] = "OPEN";
    GraphStoreProjectAssociatedPrPullRequestStatus["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$4d0f434df5bd5f5d || ($2f512219da033f72$export$4d0f434df5bd5f5d = {}));
var $2f512219da033f72$export$7b819b5db45ec714;
(function(GraphStoreProjectAssociatedPrReviewerReviewerStatus) {
    GraphStoreProjectAssociatedPrReviewerReviewerStatus["Approved"] = "APPROVED";
    GraphStoreProjectAssociatedPrReviewerReviewerStatus["Needswork"] = "NEEDSWORK";
    GraphStoreProjectAssociatedPrReviewerReviewerStatus["NotSet"] = "NOT_SET";
    GraphStoreProjectAssociatedPrReviewerReviewerStatus["Unapproved"] = "UNAPPROVED";
})($2f512219da033f72$export$7b819b5db45ec714 || ($2f512219da033f72$export$7b819b5db45ec714 = {}));
var $2f512219da033f72$export$8960ee08b61499ff;
(function(GraphStoreProjectAssociatedVulnerabilityVulnerabilitySeverity) {
    GraphStoreProjectAssociatedVulnerabilityVulnerabilitySeverity["Critical"] = "CRITICAL";
    GraphStoreProjectAssociatedVulnerabilityVulnerabilitySeverity["High"] = "HIGH";
    GraphStoreProjectAssociatedVulnerabilityVulnerabilitySeverity["Low"] = "LOW";
    GraphStoreProjectAssociatedVulnerabilityVulnerabilitySeverity["Medium"] = "MEDIUM";
    GraphStoreProjectAssociatedVulnerabilityVulnerabilitySeverity["NotSet"] = "NOT_SET";
    GraphStoreProjectAssociatedVulnerabilityVulnerabilitySeverity["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$8960ee08b61499ff || ($2f512219da033f72$export$8960ee08b61499ff = {}));
var $2f512219da033f72$export$4079472ae478c8b5;
(function(GraphStoreProjectAssociatedVulnerabilityVulnerabilityStatus) {
    GraphStoreProjectAssociatedVulnerabilityVulnerabilityStatus["Closed"] = "CLOSED";
    GraphStoreProjectAssociatedVulnerabilityVulnerabilityStatus["Ignored"] = "IGNORED";
    GraphStoreProjectAssociatedVulnerabilityVulnerabilityStatus["NotSet"] = "NOT_SET";
    GraphStoreProjectAssociatedVulnerabilityVulnerabilityStatus["Open"] = "OPEN";
    GraphStoreProjectAssociatedVulnerabilityVulnerabilityStatus["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$4079472ae478c8b5 || ($2f512219da033f72$export$4079472ae478c8b5 = {}));
var $2f512219da033f72$export$52c8ce54b5f1ece6;
(function(GraphStoreProjectAssociatedVulnerabilityVulnerabilityType) {
    GraphStoreProjectAssociatedVulnerabilityVulnerabilityType["Dast"] = "DAST";
    GraphStoreProjectAssociatedVulnerabilityVulnerabilityType["NotSet"] = "NOT_SET";
    GraphStoreProjectAssociatedVulnerabilityVulnerabilityType["Sast"] = "SAST";
    GraphStoreProjectAssociatedVulnerabilityVulnerabilityType["Sca"] = "SCA";
    GraphStoreProjectAssociatedVulnerabilityVulnerabilityType["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$52c8ce54b5f1ece6 || ($2f512219da033f72$export$52c8ce54b5f1ece6 = {}));
var $2f512219da033f72$export$50ace2d33df76dc8;
(function(GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentPriority) {
    GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentPriority["NotSet"] = "NOT_SET";
    GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentPriority["P1"] = "P1";
    GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentPriority["P2"] = "P2";
    GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentPriority["P3"] = "P3";
    GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentPriority["P4"] = "P4";
    GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentPriority["P5"] = "P5";
})($2f512219da033f72$export$50ace2d33df76dc8 || ($2f512219da033f72$export$50ace2d33df76dc8 = {}));
var $2f512219da033f72$export$b9597115770809a4;
(function(GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentStatus) {
    GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentStatus["Done"] = "DONE";
    GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentStatus["Indeterminate"] = "INDETERMINATE";
    GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentStatus["New"] = "NEW";
    GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentStatus["NotSet"] = "NOT_SET";
    GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentStatus["Undefined"] = "UNDEFINED";
})($2f512219da033f72$export$b9597115770809a4 || ($2f512219da033f72$export$b9597115770809a4 = {}));
var $2f512219da033f72$export$f295a95cd0626a8f;
(function(GraphStoreSprintAssociatedBuildBuildState) {
    GraphStoreSprintAssociatedBuildBuildState["Cancelled"] = "CANCELLED";
    GraphStoreSprintAssociatedBuildBuildState["Failed"] = "FAILED";
    GraphStoreSprintAssociatedBuildBuildState["InProgress"] = "IN_PROGRESS";
    GraphStoreSprintAssociatedBuildBuildState["NotSet"] = "NOT_SET";
    GraphStoreSprintAssociatedBuildBuildState["Pending"] = "PENDING";
    GraphStoreSprintAssociatedBuildBuildState["Successful"] = "SUCCESSFUL";
    GraphStoreSprintAssociatedBuildBuildState["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$f295a95cd0626a8f || ($2f512219da033f72$export$f295a95cd0626a8f = {}));
var $2f512219da033f72$export$6df900849642cd1c;
(function(GraphStoreSprintAssociatedDeploymentDeploymentState) {
    GraphStoreSprintAssociatedDeploymentDeploymentState["Cancelled"] = "CANCELLED";
    GraphStoreSprintAssociatedDeploymentDeploymentState["Failed"] = "FAILED";
    GraphStoreSprintAssociatedDeploymentDeploymentState["InProgress"] = "IN_PROGRESS";
    GraphStoreSprintAssociatedDeploymentDeploymentState["NotSet"] = "NOT_SET";
    GraphStoreSprintAssociatedDeploymentDeploymentState["Pending"] = "PENDING";
    GraphStoreSprintAssociatedDeploymentDeploymentState["RolledBack"] = "ROLLED_BACK";
    GraphStoreSprintAssociatedDeploymentDeploymentState["Successful"] = "SUCCESSFUL";
    GraphStoreSprintAssociatedDeploymentDeploymentState["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$6df900849642cd1c || ($2f512219da033f72$export$6df900849642cd1c = {}));
var $2f512219da033f72$export$9f4efa40f1a0faae;
(function(GraphStoreSprintAssociatedDeploymentEnvironmentType) {
    GraphStoreSprintAssociatedDeploymentEnvironmentType["Development"] = "DEVELOPMENT";
    GraphStoreSprintAssociatedDeploymentEnvironmentType["NotSet"] = "NOT_SET";
    GraphStoreSprintAssociatedDeploymentEnvironmentType["Production"] = "PRODUCTION";
    GraphStoreSprintAssociatedDeploymentEnvironmentType["Staging"] = "STAGING";
    GraphStoreSprintAssociatedDeploymentEnvironmentType["Testing"] = "TESTING";
    GraphStoreSprintAssociatedDeploymentEnvironmentType["Unmapped"] = "UNMAPPED";
})($2f512219da033f72$export$9f4efa40f1a0faae || ($2f512219da033f72$export$9f4efa40f1a0faae = {}));
var $2f512219da033f72$export$5ffbe3a12bdc5b6c;
(function(GraphStoreSprintAssociatedPrPullRequestStatus) {
    GraphStoreSprintAssociatedPrPullRequestStatus["Declined"] = "DECLINED";
    GraphStoreSprintAssociatedPrPullRequestStatus["Merged"] = "MERGED";
    GraphStoreSprintAssociatedPrPullRequestStatus["NotSet"] = "NOT_SET";
    GraphStoreSprintAssociatedPrPullRequestStatus["Open"] = "OPEN";
    GraphStoreSprintAssociatedPrPullRequestStatus["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$5ffbe3a12bdc5b6c || ($2f512219da033f72$export$5ffbe3a12bdc5b6c = {}));
var $2f512219da033f72$export$b397a81d3b3345af;
(function(GraphStoreSprintAssociatedPrReviewerReviewerStatus) {
    GraphStoreSprintAssociatedPrReviewerReviewerStatus["Approved"] = "APPROVED";
    GraphStoreSprintAssociatedPrReviewerReviewerStatus["Needswork"] = "NEEDSWORK";
    GraphStoreSprintAssociatedPrReviewerReviewerStatus["NotSet"] = "NOT_SET";
    GraphStoreSprintAssociatedPrReviewerReviewerStatus["Unapproved"] = "UNAPPROVED";
})($2f512219da033f72$export$b397a81d3b3345af || ($2f512219da033f72$export$b397a81d3b3345af = {}));
var $2f512219da033f72$export$9ee1edc61daf0f8a;
(function(GraphStoreSprintAssociatedVulnerabilityStatusCategory) {
    GraphStoreSprintAssociatedVulnerabilityStatusCategory["Done"] = "DONE";
    GraphStoreSprintAssociatedVulnerabilityStatusCategory["Indeterminate"] = "INDETERMINATE";
    GraphStoreSprintAssociatedVulnerabilityStatusCategory["New"] = "NEW";
    GraphStoreSprintAssociatedVulnerabilityStatusCategory["Undefined"] = "UNDEFINED";
})($2f512219da033f72$export$9ee1edc61daf0f8a || ($2f512219da033f72$export$9ee1edc61daf0f8a = {}));
var $2f512219da033f72$export$67d1797c0aa2ad19;
(function(GraphStoreSprintAssociatedVulnerabilityVulnerabilitySeverity) {
    GraphStoreSprintAssociatedVulnerabilityVulnerabilitySeverity["Critical"] = "CRITICAL";
    GraphStoreSprintAssociatedVulnerabilityVulnerabilitySeverity["High"] = "HIGH";
    GraphStoreSprintAssociatedVulnerabilityVulnerabilitySeverity["Low"] = "LOW";
    GraphStoreSprintAssociatedVulnerabilityVulnerabilitySeverity["Medium"] = "MEDIUM";
    GraphStoreSprintAssociatedVulnerabilityVulnerabilitySeverity["NotSet"] = "NOT_SET";
    GraphStoreSprintAssociatedVulnerabilityVulnerabilitySeverity["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$67d1797c0aa2ad19 || ($2f512219da033f72$export$67d1797c0aa2ad19 = {}));
var $2f512219da033f72$export$e55dd9ead99d6d9f;
(function(GraphStoreSprintAssociatedVulnerabilityVulnerabilityStatus) {
    GraphStoreSprintAssociatedVulnerabilityVulnerabilityStatus["Closed"] = "CLOSED";
    GraphStoreSprintAssociatedVulnerabilityVulnerabilityStatus["Ignored"] = "IGNORED";
    GraphStoreSprintAssociatedVulnerabilityVulnerabilityStatus["NotSet"] = "NOT_SET";
    GraphStoreSprintAssociatedVulnerabilityVulnerabilityStatus["Open"] = "OPEN";
    GraphStoreSprintAssociatedVulnerabilityVulnerabilityStatus["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$e55dd9ead99d6d9f || ($2f512219da033f72$export$e55dd9ead99d6d9f = {}));
var $2f512219da033f72$export$296e777b040fe873;
(function(GraphStoreSprintContainsIssueStatusCategory) {
    GraphStoreSprintContainsIssueStatusCategory["Done"] = "DONE";
    GraphStoreSprintContainsIssueStatusCategory["Indeterminate"] = "INDETERMINATE";
    GraphStoreSprintContainsIssueStatusCategory["New"] = "NEW";
    GraphStoreSprintContainsIssueStatusCategory["Undefined"] = "UNDEFINED";
})($2f512219da033f72$export$296e777b040fe873 || ($2f512219da033f72$export$296e777b040fe873 = {}));
var $2f512219da033f72$export$318f148359ce1fb1;
(function(GraphStoreVersionAssociatedDesignDesignStatus) {
    GraphStoreVersionAssociatedDesignDesignStatus["None"] = "NONE";
    GraphStoreVersionAssociatedDesignDesignStatus["NotSet"] = "NOT_SET";
    GraphStoreVersionAssociatedDesignDesignStatus["ReadyForDevelopment"] = "READY_FOR_DEVELOPMENT";
    GraphStoreVersionAssociatedDesignDesignStatus["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$318f148359ce1fb1 || ($2f512219da033f72$export$318f148359ce1fb1 = {}));
var $2f512219da033f72$export$c81e290110aa4fde;
(function(GraphStoreVersionAssociatedDesignDesignType) {
    GraphStoreVersionAssociatedDesignDesignType["Canvas"] = "CANVAS";
    GraphStoreVersionAssociatedDesignDesignType["File"] = "FILE";
    GraphStoreVersionAssociatedDesignDesignType["Group"] = "GROUP";
    GraphStoreVersionAssociatedDesignDesignType["Node"] = "NODE";
    GraphStoreVersionAssociatedDesignDesignType["NotSet"] = "NOT_SET";
    GraphStoreVersionAssociatedDesignDesignType["Other"] = "OTHER";
    GraphStoreVersionAssociatedDesignDesignType["Prototype"] = "PROTOTYPE";
})($2f512219da033f72$export$c81e290110aa4fde || ($2f512219da033f72$export$c81e290110aa4fde = {}));
var $2f512219da033f72$export$b5409d01f4236473;
(function(GrowthUnifiedProfileAnchorType) {
    GrowthUnifiedProfileAnchorType["Pfm"] = "PFM";
    GrowthUnifiedProfileAnchorType["Seo"] = "SEO";
})($2f512219da033f72$export$b5409d01f4236473 || ($2f512219da033f72$export$b5409d01f4236473 = {}));
var $2f512219da033f72$export$2845c0acf9e62f30;
(function(GrowthUnifiedProfileChannel) {
    GrowthUnifiedProfileChannel["PaidContent"] = "PAID_CONTENT";
    GrowthUnifiedProfileChannel["PaidDisplay"] = "PAID_DISPLAY";
    GrowthUnifiedProfileChannel["PaidReviewSites"] = "PAID_REVIEW_SITES";
    GrowthUnifiedProfileChannel["PaidSearch"] = "PAID_SEARCH";
    GrowthUnifiedProfileChannel["PaidSocial"] = "PAID_SOCIAL";
})($2f512219da033f72$export$2845c0acf9e62f30 || ($2f512219da033f72$export$2845c0acf9e62f30 = {}));
var $2f512219da033f72$export$eb044d0d19d592c7;
(function(GrowthUnifiedProfileCompanySize) {
    GrowthUnifiedProfileCompanySize["Large"] = "LARGE";
    GrowthUnifiedProfileCompanySize["Medium"] = "MEDIUM";
    GrowthUnifiedProfileCompanySize["Small"] = "SMALL";
    GrowthUnifiedProfileCompanySize["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$eb044d0d19d592c7 || ($2f512219da033f72$export$eb044d0d19d592c7 = {}));
var $2f512219da033f72$export$4582f4191dc3bb0e;
(function(GrowthUnifiedProfileCompanyType) {
    GrowthUnifiedProfileCompanyType["Private"] = "PRIVATE";
    GrowthUnifiedProfileCompanyType["Public"] = "PUBLIC";
})($2f512219da033f72$export$4582f4191dc3bb0e || ($2f512219da033f72$export$4582f4191dc3bb0e = {}));
var $2f512219da033f72$export$67925d31accc388;
(function(GrowthUnifiedProfileDomainType) {
    GrowthUnifiedProfileDomainType["Business"] = "BUSINESS";
    GrowthUnifiedProfileDomainType["Personal"] = "PERSONAL";
})($2f512219da033f72$export$67925d31accc388 || ($2f512219da033f72$export$67925d31accc388 = {}));
var $2f512219da033f72$export$28880b034aa5dc30;
(function(GrowthUnifiedProfileEnrichmentStatus) {
    GrowthUnifiedProfileEnrichmentStatus["Complete"] = "COMPLETE";
    GrowthUnifiedProfileEnrichmentStatus["Error"] = "ERROR";
    GrowthUnifiedProfileEnrichmentStatus["InProgress"] = "IN_PROGRESS";
    GrowthUnifiedProfileEnrichmentStatus["Pending"] = "PENDING";
})($2f512219da033f72$export$28880b034aa5dc30 || ($2f512219da033f72$export$28880b034aa5dc30 = {}));
var $2f512219da033f72$export$8d96e2c494b1d62c;
(function(GrowthUnifiedProfileEnterpriseAccountStatus) {
    GrowthUnifiedProfileEnterpriseAccountStatus["Bronze"] = "BRONZE";
    GrowthUnifiedProfileEnterpriseAccountStatus["Gam"] = "GAM";
    GrowthUnifiedProfileEnterpriseAccountStatus["Gold"] = "GOLD";
    GrowthUnifiedProfileEnterpriseAccountStatus["Platimun"] = "PLATIMUN";
    GrowthUnifiedProfileEnterpriseAccountStatus["Silver"] = "SILVER";
})($2f512219da033f72$export$8d96e2c494b1d62c || ($2f512219da033f72$export$8d96e2c494b1d62c = {}));
var $2f512219da033f72$export$71e2332d6e22a291;
(function(GrowthUnifiedProfileEntityType) {
    /** anonymous entity type */ GrowthUnifiedProfileEntityType["AjsAnonymousUser"] = "AJS_ANONYMOUS_USER";
    /** atlassian account entity type */ GrowthUnifiedProfileEntityType["AtlassianAccount"] = "ATLASSIAN_ACCOUNT";
    /** organization entity type */ GrowthUnifiedProfileEntityType["Org"] = "ORG";
    /** site of tenant entity type */ GrowthUnifiedProfileEntityType["Site"] = "SITE";
})($2f512219da033f72$export$71e2332d6e22a291 || ($2f512219da033f72$export$71e2332d6e22a291 = {}));
var $2f512219da033f72$export$7107196e11922cb3;
(function(GrowthUnifiedProfileEntryType) {
    GrowthUnifiedProfileEntryType["Existing"] = "EXISTING";
    GrowthUnifiedProfileEntryType["New"] = "NEW";
})($2f512219da033f72$export$7107196e11922cb3 || ($2f512219da033f72$export$7107196e11922cb3 = {}));
var $2f512219da033f72$export$c49017e7afc08542;
(function(GrowthUnifiedProfileJtbd) {
    GrowthUnifiedProfileJtbd["AdHocTaskAndIncidentManagement"] = "AD_HOC_TASK_AND_INCIDENT_MANAGEMENT";
    GrowthUnifiedProfileJtbd["Budgets"] = "BUDGETS";
    GrowthUnifiedProfileJtbd["CdWrtng"] = "CD_WRTNG";
    GrowthUnifiedProfileJtbd["CentralizedDocumentation"] = "CENTRALIZED_DOCUMENTATION";
    GrowthUnifiedProfileJtbd["ComplianceAndRiskManagement"] = "COMPLIANCE_AND_RISK_MANAGEMENT";
    GrowthUnifiedProfileJtbd["EstimateTimeAndEffort"] = "ESTIMATE_TIME_AND_EFFORT";
    GrowthUnifiedProfileJtbd["ImproveTeamProcesses"] = "IMPROVE_TEAM_PROCESSES";
    GrowthUnifiedProfileJtbd["ImproveWorkflow"] = "IMPROVE_WORKFLOW";
    GrowthUnifiedProfileJtbd["LaunchCampaigns"] = "LAUNCH_CAMPAIGNS";
    GrowthUnifiedProfileJtbd["ManageTasks"] = "MANAGE_TASKS";
    GrowthUnifiedProfileJtbd["ManagingClientAndVendorRelationships"] = "MANAGING_CLIENT_AND_VENDOR_RELATIONSHIPS";
    GrowthUnifiedProfileJtbd["MapWorkDependencies"] = "MAP_WORK_DEPENDENCIES";
    GrowthUnifiedProfileJtbd["MarketingContent"] = "MARKETING_CONTENT";
    GrowthUnifiedProfileJtbd["PlanAndManage"] = "PLAN_AND_MANAGE";
    GrowthUnifiedProfileJtbd["PrioritizeWork"] = "PRIORITIZE_WORK";
    GrowthUnifiedProfileJtbd["ProjectPlanning"] = "PROJECT_PLANNING";
    GrowthUnifiedProfileJtbd["ProjectPlanningAndCoordination"] = "PROJECT_PLANNING_AND_COORDINATION";
    GrowthUnifiedProfileJtbd["ProjectProgress"] = "PROJECT_PROGRESS";
    GrowthUnifiedProfileJtbd["RunSprints"] = "RUN_SPRINTS";
    GrowthUnifiedProfileJtbd["Stakeholders"] = "STAKEHOLDERS";
    GrowthUnifiedProfileJtbd["StrategiesAndGoals"] = "STRATEGIES_AND_GOALS";
    GrowthUnifiedProfileJtbd["SystemAndToolEvaluations"] = "SYSTEM_AND_TOOL_EVALUATIONS";
    GrowthUnifiedProfileJtbd["TrackingRprtng"] = "TRACKING_RPRTNG";
    GrowthUnifiedProfileJtbd["TrackBugs"] = "TRACK_BUGS";
    GrowthUnifiedProfileJtbd["UseKanbanBoard"] = "USE_KANBAN_BOARD";
    GrowthUnifiedProfileJtbd["WorkInScrum"] = "WORK_IN_SCRUM";
})($2f512219da033f72$export$c49017e7afc08542 || ($2f512219da033f72$export$c49017e7afc08542 = {}));
var $2f512219da033f72$export$5990898c79cc1feb;
(function(GrowthUnifiedProfileJiraFamiliarity) {
    GrowthUnifiedProfileJiraFamiliarity["Experience"] = "EXPERIENCE";
    GrowthUnifiedProfileJiraFamiliarity["Middle"] = "MIDDLE";
    GrowthUnifiedProfileJiraFamiliarity["New"] = "NEW";
})($2f512219da033f72$export$5990898c79cc1feb || ($2f512219da033f72$export$5990898c79cc1feb = {}));
var $2f512219da033f72$export$989873014e3540ce;
(function(GrowthUnifiedProfileOnboardingContextProjectLandingSelection) {
    GrowthUnifiedProfileOnboardingContextProjectLandingSelection["CreateProject"] = "CREATE_PROJECT";
    GrowthUnifiedProfileOnboardingContextProjectLandingSelection["SampleProject"] = "SAMPLE_PROJECT";
})($2f512219da033f72$export$989873014e3540ce || ($2f512219da033f72$export$989873014e3540ce = {}));
var $2f512219da033f72$export$ab8fcbc569972183;
(function(GrowthUnifiedProfileProduct) {
    GrowthUnifiedProfileProduct["Compass"] = "compass";
    GrowthUnifiedProfileProduct["Confluence"] = "confluence";
    GrowthUnifiedProfileProduct["Jira"] = "jira";
    GrowthUnifiedProfileProduct["Jpd"] = "jpd";
    GrowthUnifiedProfileProduct["Jsm"] = "jsm";
    GrowthUnifiedProfileProduct["Jwm"] = "jwm";
    GrowthUnifiedProfileProduct["Trello"] = "trello";
})($2f512219da033f72$export$ab8fcbc569972183 || ($2f512219da033f72$export$ab8fcbc569972183 = {}));
var $2f512219da033f72$export$110930cf5e2a2eff;
(function(GrowthUnifiedProfileTeamType) {
    GrowthUnifiedProfileTeamType["CustomerService"] = "CUSTOMER_SERVICE";
    GrowthUnifiedProfileTeamType["DataScience"] = "DATA_SCIENCE";
    GrowthUnifiedProfileTeamType["Design"] = "DESIGN";
    GrowthUnifiedProfileTeamType["Finance"] = "FINANCE";
    GrowthUnifiedProfileTeamType["HumanResources"] = "HUMAN_RESOURCES";
    GrowthUnifiedProfileTeamType["ItSupport"] = "IT_SUPPORT";
    GrowthUnifiedProfileTeamType["Legal"] = "LEGAL";
    GrowthUnifiedProfileTeamType["Marketing"] = "MARKETING";
    GrowthUnifiedProfileTeamType["Operations"] = "OPERATIONS";
    GrowthUnifiedProfileTeamType["Other"] = "OTHER";
    GrowthUnifiedProfileTeamType["ProductManagement"] = "PRODUCT_MANAGEMENT";
    GrowthUnifiedProfileTeamType["ProgramManagement"] = "PROGRAM_MANAGEMENT";
    GrowthUnifiedProfileTeamType["ProjectManagement"] = "PROJECT_MANAGEMENT";
    GrowthUnifiedProfileTeamType["Sales"] = "SALES";
    GrowthUnifiedProfileTeamType["SoftwareDevelopment"] = "SOFTWARE_DEVELOPMENT";
    GrowthUnifiedProfileTeamType["SoftwareEngineering"] = "SOFTWARE_ENGINEERING";
})($2f512219da033f72$export$110930cf5e2a2eff || ($2f512219da033f72$export$110930cf5e2a2eff = {}));
var $2f512219da033f72$export$7a7154b224aaa072;
(function(HelpCenterAccessControlType) {
    /** Help center is accessible to external customers */ HelpCenterAccessControlType["External"] = "EXTERNAL";
    /** Help center is accessible to specific groups */ HelpCenterAccessControlType["GroupBased"] = "GROUP_BASED";
    /** Help center is accessible to internal customers */ HelpCenterAccessControlType["Internal"] = "INTERNAL";
    /** Help center is accessible to all */ HelpCenterAccessControlType["Public"] = "PUBLIC";
})($2f512219da033f72$export$7a7154b224aaa072 || ($2f512219da033f72$export$7a7154b224aaa072 = {}));
var $2f512219da033f72$export$a4bd4d15a9a3d3f1;
(function(HelpCenterDescriptionType) {
    HelpCenterDescriptionType["PlainText"] = "PLAIN_TEXT";
    HelpCenterDescriptionType["RichText"] = "RICH_TEXT";
    HelpCenterDescriptionType["WikiMarkup"] = "WIKI_MARKUP";
})($2f512219da033f72$export$a4bd4d15a9a3d3f1 || ($2f512219da033f72$export$a4bd4d15a9a3d3f1 = {}));
var $2f512219da033f72$export$9f54202027f49420;
(function(HelpCenterMediaConfigOperationType) {
    /** indicates banner upload */ HelpCenterMediaConfigOperationType["BannerUpload"] = "BANNER_UPLOAD";
    /** indicates logo upload */ HelpCenterMediaConfigOperationType["LogoUpload"] = "LOGO_UPLOAD";
})($2f512219da033f72$export$9f54202027f49420 || ($2f512219da033f72$export$9f54202027f49420 = {}));
var $2f512219da033f72$export$bb0f427b0236e5c7;
(function(HelpCenterPageType) {
    /** indicates Custom help center page */ HelpCenterPageType["Custom"] = "CUSTOM";
})($2f512219da033f72$export$bb0f427b0236e5c7 || ($2f512219da033f72$export$bb0f427b0236e5c7 = {}));
var $2f512219da033f72$export$de6d4d4c47123061;
(function(HelpCenterPortalsSortOrder) {
    HelpCenterPortalsSortOrder["NameAscending"] = "NAME_ASCENDING";
    HelpCenterPortalsSortOrder["Popularity"] = "POPULARITY";
})($2f512219da033f72$export$de6d4d4c47123061 || ($2f512219da033f72$export$de6d4d4c47123061 = {}));
var $2f512219da033f72$export$10df61f732f39a6d;
(function(HelpCenterPortalsType) {
    /** Featured Portals */ HelpCenterPortalsType["Featured"] = "FEATURED";
    /** Hidden Portals */ HelpCenterPortalsType["Hidden"] = "HIDDEN";
    /** Visible Portals */ HelpCenterPortalsType["Visible"] = "VISIBLE";
})($2f512219da033f72$export$10df61f732f39a6d || ($2f512219da033f72$export$10df61f732f39a6d = {}));
var $2f512219da033f72$export$bf41d3d919083034;
(function(HelpCenterProjectMappingOperationType) {
    /** Indicates the mapping of projects to Help Center */ HelpCenterProjectMappingOperationType["MapProjects"] = "MAP_PROJECTS";
    /** Indicates the un-mapping of projects to a Help Center */ HelpCenterProjectMappingOperationType["UnmapProjects"] = "UNMAP_PROJECTS";
})($2f512219da033f72$export$bf41d3d919083034 || ($2f512219da033f72$export$bf41d3d919083034 = {}));
var $2f512219da033f72$export$98ecf93df3b75669;
(function(HelpCenterProjectType) {
    HelpCenterProjectType["CustomerService"] = "CUSTOMER_SERVICE";
    HelpCenterProjectType["ServiceDesk"] = "SERVICE_DESK";
})($2f512219da033f72$export$98ecf93df3b75669 || ($2f512219da033f72$export$98ecf93df3b75669 = {}));
var $2f512219da033f72$export$db18c35dcd3a9e38;
(function(HelpCenterSortOrder) {
    HelpCenterSortOrder["CreatedDateAscending"] = "CREATED_DATE_ASCENDING";
    HelpCenterSortOrder["CreatedDateDescending"] = "CREATED_DATE_DESCENDING";
})($2f512219da033f72$export$db18c35dcd3a9e38 || ($2f512219da033f72$export$db18c35dcd3a9e38 = {}));
var $2f512219da033f72$export$404b16ab15b3352c;
(function(HelpCenterType) {
    /** indicates Advanced help center */ HelpCenterType["Advanced"] = "ADVANCED";
    /** indicates Basic help center */ HelpCenterType["Basic"] = "BASIC";
    /** indicates Customer Service help center */ HelpCenterType["CustomerService"] = "CUSTOMER_SERVICE";
    /** indicates Unified help center */ HelpCenterType["Unified"] = "UNIFIED";
})($2f512219da033f72$export$404b16ab15b3352c || ($2f512219da033f72$export$404b16ab15b3352c = {}));
var $2f512219da033f72$export$25877d5a420a6e71;
(function(HelpExternalResourceLinkResourceType) {
    HelpExternalResourceLinkResourceType["Channel"] = "CHANNEL";
    HelpExternalResourceLinkResourceType["Knowledge"] = "KNOWLEDGE";
    HelpExternalResourceLinkResourceType["RequestForm"] = "REQUEST_FORM";
})($2f512219da033f72$export$25877d5a420a6e71 || ($2f512219da033f72$export$25877d5a420a6e71 = {}));
var $2f512219da033f72$export$4f955d957799126e;
(function(HelpLayoutAtomicElementKey) {
    HelpLayoutAtomicElementKey["Announcement"] = "ANNOUNCEMENT";
    HelpLayoutAtomicElementKey["Breadcrumb"] = "BREADCRUMB";
    HelpLayoutAtomicElementKey["Connect"] = "CONNECT";
    HelpLayoutAtomicElementKey["Editor"] = "EDITOR";
    HelpLayoutAtomicElementKey["Forge"] = "FORGE";
    HelpLayoutAtomicElementKey["Heading"] = "HEADING";
    HelpLayoutAtomicElementKey["Hero"] = "HERO";
    HelpLayoutAtomicElementKey["Image"] = "IMAGE";
    HelpLayoutAtomicElementKey["NoContent"] = "NO_CONTENT";
    HelpLayoutAtomicElementKey["Paragraph"] = "PARAGRAPH";
    HelpLayoutAtomicElementKey["PortalsList"] = "PORTALS_LIST";
    HelpLayoutAtomicElementKey["Search"] = "SEARCH";
    HelpLayoutAtomicElementKey["SuggestedRequestFormsList"] = "SUGGESTED_REQUEST_FORMS_LIST";
    HelpLayoutAtomicElementKey["TopicsList"] = "TOPICS_LIST";
})($2f512219da033f72$export$4f955d957799126e || ($2f512219da033f72$export$4f955d957799126e = {}));
var $2f512219da033f72$export$84634f764851e67a;
(function(HelpLayoutBackgroundImageObjectFit) {
    HelpLayoutBackgroundImageObjectFit["Contain"] = "CONTAIN";
    HelpLayoutBackgroundImageObjectFit["Cover"] = "COVER";
    HelpLayoutBackgroundImageObjectFit["Fill"] = "FILL";
})($2f512219da033f72$export$84634f764851e67a || ($2f512219da033f72$export$84634f764851e67a = {}));
var $2f512219da033f72$export$56da6c14427b099;
(function(HelpLayoutBackgroundType) {
    HelpLayoutBackgroundType["Color"] = "COLOR";
    HelpLayoutBackgroundType["Image"] = "IMAGE";
    HelpLayoutBackgroundType["Transparent"] = "TRANSPARENT";
})($2f512219da033f72$export$56da6c14427b099 || ($2f512219da033f72$export$56da6c14427b099 = {}));
var $2f512219da033f72$export$576a5650ed3956e9;
(function(HelpLayoutCompositeElementKey) {
    HelpLayoutCompositeElementKey["LinkCard"] = "LINK_CARD";
})($2f512219da033f72$export$576a5650ed3956e9 || ($2f512219da033f72$export$576a5650ed3956e9 = {}));
var $2f512219da033f72$export$d614d14eebc9034e;
(function(HelpLayoutConnectElementPages) {
    HelpLayoutConnectElementPages["Approvals"] = "APPROVALS";
    HelpLayoutConnectElementPages["CreateRequest"] = "CREATE_REQUEST";
    HelpLayoutConnectElementPages["HelpCenter"] = "HELP_CENTER";
    HelpLayoutConnectElementPages["MyRequest"] = "MY_REQUEST";
    HelpLayoutConnectElementPages["Portal"] = "PORTAL";
    HelpLayoutConnectElementPages["Profile"] = "PROFILE";
    HelpLayoutConnectElementPages["ViewRequest"] = "VIEW_REQUEST";
})($2f512219da033f72$export$d614d14eebc9034e || ($2f512219da033f72$export$d614d14eebc9034e = {}));
var $2f512219da033f72$export$13477f5de7466343;
(function(HelpLayoutConnectElementType) {
    HelpLayoutConnectElementType["DetailsPanels"] = "detailsPanels";
    HelpLayoutConnectElementType["FooterPanels"] = "footerPanels";
    HelpLayoutConnectElementType["HeaderAndSubheaderPanels"] = "headerAndSubheaderPanels";
    HelpLayoutConnectElementType["HeaderPanels"] = "headerPanels";
    HelpLayoutConnectElementType["OptionPanels"] = "optionPanels";
    HelpLayoutConnectElementType["ProfilePagePanel"] = "profilePagePanel";
    HelpLayoutConnectElementType["PropertyPanels"] = "propertyPanels";
    HelpLayoutConnectElementType["RequestCreatePanel"] = "requestCreatePanel";
    HelpLayoutConnectElementType["SubheaderPanels"] = "subheaderPanels";
})($2f512219da033f72$export$13477f5de7466343 || ($2f512219da033f72$export$13477f5de7466343 = {}));
var $2f512219da033f72$export$66fddc1b3eb3d42f;
(function(HelpLayoutElementCategory) {
    HelpLayoutElementCategory["Basic"] = "BASIC";
    HelpLayoutElementCategory["Navigation"] = "NAVIGATION";
})($2f512219da033f72$export$66fddc1b3eb3d42f || ($2f512219da033f72$export$66fddc1b3eb3d42f = {}));
var $2f512219da033f72$export$7e4f0d562642895e;
(function(HelpLayoutElementKey) {
    HelpLayoutElementKey["Announcement"] = "ANNOUNCEMENT";
    HelpLayoutElementKey["Breadcrumb"] = "BREADCRUMB";
    HelpLayoutElementKey["Connect"] = "CONNECT";
    HelpLayoutElementKey["Editor"] = "EDITOR";
    HelpLayoutElementKey["Forge"] = "FORGE";
    HelpLayoutElementKey["Heading"] = "HEADING";
    HelpLayoutElementKey["Hero"] = "HERO";
    HelpLayoutElementKey["Image"] = "IMAGE";
    HelpLayoutElementKey["LinkCard"] = "LINK_CARD";
    HelpLayoutElementKey["NoContent"] = "NO_CONTENT";
    HelpLayoutElementKey["Paragraph"] = "PARAGRAPH";
    HelpLayoutElementKey["PortalsList"] = "PORTALS_LIST";
    HelpLayoutElementKey["Search"] = "SEARCH";
    HelpLayoutElementKey["SuggestedRequestFormsList"] = "SUGGESTED_REQUEST_FORMS_LIST";
    HelpLayoutElementKey["TopicsList"] = "TOPICS_LIST";
})($2f512219da033f72$export$7e4f0d562642895e || ($2f512219da033f72$export$7e4f0d562642895e = {}));
var $2f512219da033f72$export$443851e78d175634;
(function(HelpLayoutForgeElementPages) {
    HelpLayoutForgeElementPages["Approvals"] = "approvals";
    HelpLayoutForgeElementPages["CreateRequest"] = "create_request";
    HelpLayoutForgeElementPages["HelpCenter"] = "help_center";
    HelpLayoutForgeElementPages["MyRequests"] = "my_requests";
    HelpLayoutForgeElementPages["Portal"] = "portal";
    HelpLayoutForgeElementPages["Profile"] = "profile";
    HelpLayoutForgeElementPages["ViewRequest"] = "view_request";
})($2f512219da033f72$export$443851e78d175634 || ($2f512219da033f72$export$443851e78d175634 = {}));
var $2f512219da033f72$export$fd51ac42041cdcaa;
(function(HelpLayoutForgeElementType) {
    HelpLayoutForgeElementType["Footer"] = "FOOTER";
    HelpLayoutForgeElementType["HeaderAndSubheader"] = "HEADER_AND_SUBHEADER";
})($2f512219da033f72$export$fd51ac42041cdcaa || ($2f512219da033f72$export$fd51ac42041cdcaa = {}));
var $2f512219da033f72$export$ddbaabbc700bfb0f;
(function(HelpLayoutHeadingType) {
    HelpLayoutHeadingType["H1"] = "h1";
    HelpLayoutHeadingType["H2"] = "h2";
    HelpLayoutHeadingType["H3"] = "h3";
    HelpLayoutHeadingType["H4"] = "h4";
    HelpLayoutHeadingType["H5"] = "h5";
    HelpLayoutHeadingType["H6"] = "h6";
})($2f512219da033f72$export$ddbaabbc700bfb0f || ($2f512219da033f72$export$ddbaabbc700bfb0f = {}));
var $2f512219da033f72$export$dc0242f9aced7a72;
(function(HelpLayoutHorizontalAlignment) {
    HelpLayoutHorizontalAlignment["Center"] = "CENTER";
    HelpLayoutHorizontalAlignment["Left"] = "LEFT";
    HelpLayoutHorizontalAlignment["Right"] = "RIGHT";
})($2f512219da033f72$export$dc0242f9aced7a72 || ($2f512219da033f72$export$dc0242f9aced7a72 = {}));
var $2f512219da033f72$export$da6edd2e84621f40;
(function(HelpLayoutProjectType) {
    HelpLayoutProjectType["CustomerService"] = "CUSTOMER_SERVICE";
    HelpLayoutProjectType["ServiceDesk"] = "SERVICE_DESK";
})($2f512219da033f72$export$da6edd2e84621f40 || ($2f512219da033f72$export$da6edd2e84621f40 = {}));
var $2f512219da033f72$export$c6ced3decaf9cad4;
(function(HelpLayoutType) {
    HelpLayoutType["CustomPage"] = "CUSTOM_PAGE";
    HelpLayoutType["HomePage"] = "HOME_PAGE";
})($2f512219da033f72$export$c6ced3decaf9cad4 || ($2f512219da033f72$export$c6ced3decaf9cad4 = {}));
var $2f512219da033f72$export$29b8c6e9ec83845e;
(function(HelpLayoutVerticalAlignment) {
    HelpLayoutVerticalAlignment["Bottom"] = "BOTTOM";
    HelpLayoutVerticalAlignment["Middle"] = "MIDDLE";
    HelpLayoutVerticalAlignment["Top"] = "TOP";
})($2f512219da033f72$export$29b8c6e9ec83845e || ($2f512219da033f72$export$29b8c6e9ec83845e = {}));
var $2f512219da033f72$export$91d78161733c703b;
(function(HelpObjectStoreArticleSearchStrategy) {
    HelpObjectStoreArticleSearchStrategy["ContentSearch"] = "CONTENT_SEARCH";
    /** Search Strategy used to obtain the search result */ HelpObjectStoreArticleSearchStrategy["Cql"] = "CQL";
    HelpObjectStoreArticleSearchStrategy["Proxy"] = "PROXY";
})($2f512219da033f72$export$91d78161733c703b || ($2f512219da033f72$export$91d78161733c703b = {}));
var $2f512219da033f72$export$2e254ab7a9ab0d07;
(function(HelpObjectStoreArticleSourceSystem) {
    HelpObjectStoreArticleSourceSystem["Confluence"] = "CONFLUENCE";
    HelpObjectStoreArticleSourceSystem["External"] = "EXTERNAL";
    HelpObjectStoreArticleSourceSystem["GoogleDrive"] = "GOOGLE_DRIVE";
    HelpObjectStoreArticleSourceSystem["Sharepoint"] = "SHAREPOINT";
})($2f512219da033f72$export$2e254ab7a9ab0d07 || ($2f512219da033f72$export$2e254ab7a9ab0d07 = {}));
var $2f512219da033f72$export$fca880a7c8a28341;
(function(HelpObjectStoreHelpObjectType) {
    HelpObjectStoreHelpObjectType["Article"] = "ARTICLE";
    HelpObjectStoreHelpObjectType["Channel"] = "CHANNEL";
    HelpObjectStoreHelpObjectType["Portal"] = "PORTAL";
    HelpObjectStoreHelpObjectType["RequestForm"] = "REQUEST_FORM";
})($2f512219da033f72$export$fca880a7c8a28341 || ($2f512219da033f72$export$fca880a7c8a28341 = {}));
var $2f512219da033f72$export$5a6a464de3389453;
(function(HelpObjectStoreJsmEntityType) {
    HelpObjectStoreJsmEntityType["Article"] = "ARTICLE";
    HelpObjectStoreJsmEntityType["Channel"] = "CHANNEL";
    HelpObjectStoreJsmEntityType["Portal"] = "PORTAL";
    HelpObjectStoreJsmEntityType["RequestForm"] = "REQUEST_FORM";
})($2f512219da033f72$export$5a6a464de3389453 || ($2f512219da033f72$export$5a6a464de3389453 = {}));
var $2f512219da033f72$export$58b749200060ff4d;
(function(HelpObjectStorePortalSearchStrategy) {
    /** Search Strategy used to obtain the search result */ HelpObjectStorePortalSearchStrategy["Jira"] = "JIRA";
    HelpObjectStorePortalSearchStrategy["SearchPlatform"] = "SEARCH_PLATFORM";
})($2f512219da033f72$export$58b749200060ff4d || ($2f512219da033f72$export$58b749200060ff4d = {}));
var $2f512219da033f72$export$3b47f0ab032956d3;
(function(HelpObjectStoreRequestTypeSearchStrategy) {
    HelpObjectStoreRequestTypeSearchStrategy["JiraIssueBasedSearch"] = "JIRA_ISSUE_BASED_SEARCH";
    /** Search Strategy used to obtain the search result */ HelpObjectStoreRequestTypeSearchStrategy["JiraKeywordBased"] = "JIRA_KEYWORD_BASED";
    HelpObjectStoreRequestTypeSearchStrategy["SearchPlatformKeywordBased"] = "SEARCH_PLATFORM_KEYWORD_BASED";
    HelpObjectStoreRequestTypeSearchStrategy["SearchPlatformKeywordBasedEr"] = "SEARCH_PLATFORM_KEYWORD_BASED_ER";
})($2f512219da033f72$export$3b47f0ab032956d3 || ($2f512219da033f72$export$3b47f0ab032956d3 = {}));
var $2f512219da033f72$export$714c6e1043f92681;
(function(HelpObjectStoreSearchAlgorithm) {
    HelpObjectStoreSearchAlgorithm["KeywordSearchOnIssues"] = "KEYWORD_SEARCH_ON_ISSUES";
    HelpObjectStoreSearchAlgorithm["KeywordSearchOnPortalsBm25"] = "KEYWORD_SEARCH_ON_PORTALS_BM25";
    HelpObjectStoreSearchAlgorithm["KeywordSearchOnPortalsExactMatch"] = "KEYWORD_SEARCH_ON_PORTALS_EXACT_MATCH";
    HelpObjectStoreSearchAlgorithm["KeywordSearchOnRequestTypesBm25"] = "KEYWORD_SEARCH_ON_REQUEST_TYPES_BM25";
    HelpObjectStoreSearchAlgorithm["KeywordSearchOnRequestTypesExactMatch"] = "KEYWORD_SEARCH_ON_REQUEST_TYPES_EXACT_MATCH";
})($2f512219da033f72$export$714c6e1043f92681 || ($2f512219da033f72$export$714c6e1043f92681 = {}));
var $2f512219da033f72$export$82309e1a4e81fdbf;
(function(HelpObjectStoreSearchBackend) {
    HelpObjectStoreSearchBackend["Jira"] = "JIRA";
    HelpObjectStoreSearchBackend["SearchPlatform"] = "SEARCH_PLATFORM";
})($2f512219da033f72$export$82309e1a4e81fdbf || ($2f512219da033f72$export$82309e1a4e81fdbf = {}));
var $2f512219da033f72$export$3cd8bacd120e7d23;
(function(HelpObjectStoreSearchEntityType) {
    HelpObjectStoreSearchEntityType["Article"] = "ARTICLE";
    HelpObjectStoreSearchEntityType["Channel"] = "CHANNEL";
    HelpObjectStoreSearchEntityType["Portal"] = "PORTAL";
    HelpObjectStoreSearchEntityType["RequestForm"] = "REQUEST_FORM";
})($2f512219da033f72$export$3cd8bacd120e7d23 || ($2f512219da033f72$export$3cd8bacd120e7d23 = {}));
var $2f512219da033f72$export$78a7af08ea3c76ad;
(function(HelpObjectStoreSearchableEntityType) {
    HelpObjectStoreSearchableEntityType["Article"] = "ARTICLE";
    HelpObjectStoreSearchableEntityType["RequestForm"] = "REQUEST_FORM";
})($2f512219da033f72$export$78a7af08ea3c76ad || ($2f512219da033f72$export$78a7af08ea3c76ad = {}));
var $2f512219da033f72$export$bd60e0a42047a260;
(function(HomeWidgetState) {
    HomeWidgetState["Collapsed"] = "COLLAPSED";
    HomeWidgetState["Expanded"] = "EXPANDED";
})($2f512219da033f72$export$bd60e0a42047a260 || ($2f512219da033f72$export$bd60e0a42047a260 = {}));
var $2f512219da033f72$export$b892fc271262a69b;
(function(InfluentsNotificationActorType) {
    InfluentsNotificationActorType["Animated"] = "animated";
    InfluentsNotificationActorType["Url"] = "url";
})($2f512219da033f72$export$b892fc271262a69b || ($2f512219da033f72$export$b892fc271262a69b = {}));
var $2f512219da033f72$export$add9b70bcde2a1e5;
(function(InfluentsNotificationAppearance) {
    InfluentsNotificationAppearance["Danger"] = "DANGER";
    InfluentsNotificationAppearance["Default"] = "DEFAULT";
    InfluentsNotificationAppearance["Link"] = "LINK";
    InfluentsNotificationAppearance["Primary"] = "PRIMARY";
    InfluentsNotificationAppearance["Subtle"] = "SUBTLE";
    InfluentsNotificationAppearance["Warning"] = "WARNING";
})($2f512219da033f72$export$add9b70bcde2a1e5 || ($2f512219da033f72$export$add9b70bcde2a1e5 = {}));
var $2f512219da033f72$export$3f759331ea860587;
(function(InfluentsNotificationCategory) {
    InfluentsNotificationCategory["Direct"] = "direct";
    InfluentsNotificationCategory["Watching"] = "watching";
})($2f512219da033f72$export$3f759331ea860587 || ($2f512219da033f72$export$3f759331ea860587 = {}));
var $2f512219da033f72$export$d50fb347f614347c;
(function(InfluentsNotificationReadState) {
    InfluentsNotificationReadState["Read"] = "read";
    InfluentsNotificationReadState["Unread"] = "unread";
})($2f512219da033f72$export$d50fb347f614347c || ($2f512219da033f72$export$d50fb347f614347c = {}));
var $2f512219da033f72$export$2f1aab60b03054b9;
(function(InitialPermissionOptions) {
    InitialPermissionOptions["CopyFromSpace"] = "COPY_FROM_SPACE";
    InitialPermissionOptions["Default"] = "DEFAULT";
    InitialPermissionOptions["Private"] = "PRIVATE";
})($2f512219da033f72$export$2f1aab60b03054b9 || ($2f512219da033f72$export$2f1aab60b03054b9 = {}));
var $2f512219da033f72$export$d2857b26e06bb4ab;
(function(InlineTasksQuerySortColumn) {
    InlineTasksQuerySortColumn["Assignee"] = "ASSIGNEE";
    InlineTasksQuerySortColumn["DueDate"] = "DUE_DATE";
    InlineTasksQuerySortColumn["PageTitle"] = "PAGE_TITLE";
})($2f512219da033f72$export$d2857b26e06bb4ab || ($2f512219da033f72$export$d2857b26e06bb4ab = {}));
var $2f512219da033f72$export$372a35549565e884;
(function(InlineTasksQuerySortOrder) {
    InlineTasksQuerySortOrder["Ascending"] = "ASCENDING";
    InlineTasksQuerySortOrder["Descending"] = "DESCENDING";
})($2f512219da033f72$export$372a35549565e884 || ($2f512219da033f72$export$372a35549565e884 = {}));
var $2f512219da033f72$export$32b11fa8a4db8f2e;
(function(InsightsNextBestTaskAction) {
    InsightsNextBestTaskAction["Remove"] = "REMOVE";
    InsightsNextBestTaskAction["Snooze"] = "SNOOZE";
})($2f512219da033f72$export$32b11fa8a4db8f2e || ($2f512219da033f72$export$32b11fa8a4db8f2e = {}));
var $2f512219da033f72$export$a20071bd470d2580;
(function(InsightsRecommendationVisibility) {
    InsightsRecommendationVisibility["Hidden"] = "HIDDEN";
    InsightsRecommendationVisibility["Removed"] = "REMOVED";
    InsightsRecommendationVisibility["Snoozed"] = "SNOOZED";
    InsightsRecommendationVisibility["Visible"] = "VISIBLE";
})($2f512219da033f72$export$a20071bd470d2580 || ($2f512219da033f72$export$a20071bd470d2580 = {}));
var $2f512219da033f72$export$82f384a576ac2790;
(function(InspectPermissions) {
    InspectPermissions["Comment"] = "COMMENT";
    InspectPermissions["Edit"] = "EDIT";
    InspectPermissions["View"] = "VIEW";
})($2f512219da033f72$export$82f384a576ac2790 || ($2f512219da033f72$export$82f384a576ac2790 = {}));
var $2f512219da033f72$export$338894d2bcfa1c6c;
(function(IssueDevOpsCommitChangeType) {
    IssueDevOpsCommitChangeType["Added"] = "ADDED";
    IssueDevOpsCommitChangeType["Copied"] = "COPIED";
    IssueDevOpsCommitChangeType["Deleted"] = "DELETED";
    IssueDevOpsCommitChangeType["Modified"] = "MODIFIED";
    /** Deprecated - use MODIFIED instead. */ IssueDevOpsCommitChangeType["Modify"] = "MODIFY";
    IssueDevOpsCommitChangeType["Moved"] = "MOVED";
    IssueDevOpsCommitChangeType["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$338894d2bcfa1c6c || ($2f512219da033f72$export$338894d2bcfa1c6c = {}));
var $2f512219da033f72$export$99413405dc72cb24;
(function(IssueDevOpsDeploymentEnvironmentType) {
    IssueDevOpsDeploymentEnvironmentType["Development"] = "DEVELOPMENT";
    IssueDevOpsDeploymentEnvironmentType["Production"] = "PRODUCTION";
    IssueDevOpsDeploymentEnvironmentType["Staging"] = "STAGING";
    IssueDevOpsDeploymentEnvironmentType["Testing"] = "TESTING";
    IssueDevOpsDeploymentEnvironmentType["Unmapped"] = "UNMAPPED";
})($2f512219da033f72$export$99413405dc72cb24 || ($2f512219da033f72$export$99413405dc72cb24 = {}));
var $2f512219da033f72$export$df40bbb79dc09c24;
(function(IssueDevOpsDeploymentState) {
    IssueDevOpsDeploymentState["Cancelled"] = "CANCELLED";
    IssueDevOpsDeploymentState["Failed"] = "FAILED";
    IssueDevOpsDeploymentState["InProgress"] = "IN_PROGRESS";
    IssueDevOpsDeploymentState["Pending"] = "PENDING";
    IssueDevOpsDeploymentState["RolledBack"] = "ROLLED_BACK";
    IssueDevOpsDeploymentState["Successful"] = "SUCCESSFUL";
    IssueDevOpsDeploymentState["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$df40bbb79dc09c24 || ($2f512219da033f72$export$df40bbb79dc09c24 = {}));
var $2f512219da033f72$export$93807e2ffddb6d99;
(function(IssueDevOpsPullRequestStatus) {
    IssueDevOpsPullRequestStatus["Declined"] = "DECLINED";
    IssueDevOpsPullRequestStatus["Draft"] = "DRAFT";
    IssueDevOpsPullRequestStatus["Merged"] = "MERGED";
    IssueDevOpsPullRequestStatus["Open"] = "OPEN";
    IssueDevOpsPullRequestStatus["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$93807e2ffddb6d99 || ($2f512219da033f72$export$93807e2ffddb6d99 = {}));
var $2f512219da033f72$export$b40f2294e83c8458;
(function(JiraActionType) {
    /** Can current user create a Company Managed project */ JiraActionType["CreateCompanyManagedProject"] = "CREATE_COMPANY_MANAGED_PROJECT";
    /** Can current user create any project */ JiraActionType["CreateProject"] = "CREATE_PROJECT";
    /** Can current user create a Team Managed project */ JiraActionType["CreateTeamManagedProject"] = "CREATE_TEAM_MANAGED_PROJECT";
})($2f512219da033f72$export$b40f2294e83c8458 || ($2f512219da033f72$export$b40f2294e83c8458 = {}));
var $2f512219da033f72$export$7dab5913fedb74fb;
(function(JiraAddValueFieldOperations) {
    /** Overrides single value field. */ JiraAddValueFieldOperations["Add"] = "ADD";
})($2f512219da033f72$export$7dab5913fedb74fb || ($2f512219da033f72$export$7dab5913fedb74fb = {}));
var $2f512219da033f72$export$35561b7f9e1f55e5;
(function(JiraAnnouncementBannerVisibility) {
    /** The announcement banner is shown to logged in users only. */ JiraAnnouncementBannerVisibility["Private"] = "PRIVATE";
    /** The announcement banner is shown to anyone on the internet. */ JiraAnnouncementBannerVisibility["Public"] = "PUBLIC";
})($2f512219da033f72$export$35561b7f9e1f55e5 || ($2f512219da033f72$export$35561b7f9e1f55e5 = {}));
var $2f512219da033f72$export$ce082fc9df0d76d9;
(function(JiraAppType) {
    JiraAppType["Connect"] = "CONNECT";
    JiraAppType["Forge"] = "FORGE";
})($2f512219da033f72$export$ce082fc9df0d76d9 || ($2f512219da033f72$export$ce082fc9df0d76d9 = {}));
var $2f512219da033f72$export$3041ba651e0f5411;
(function(JiraApplicationKey) {
    /** Jira Work Management application key */ JiraApplicationKey["JiraCore"] = "JIRA_CORE";
    /** Jira Product Discovery application key */ JiraApplicationKey["JiraProductDiscovery"] = "JIRA_PRODUCT_DISCOVERY";
    /** Jira Service Management application key */ JiraApplicationKey["JiraServiceDesk"] = "JIRA_SERVICE_DESK";
    /** Jira Software application key */ JiraApplicationKey["JiraSoftware"] = "JIRA_SOFTWARE";
})($2f512219da033f72$export$3041ba651e0f5411 || ($2f512219da033f72$export$3041ba651e0f5411 = {}));
var $2f512219da033f72$export$b45afd01a571a7c3;
(function(JiraApprovalDecision) {
    JiraApprovalDecision["Approved"] = "APPROVED";
    JiraApprovalDecision["Rejected"] = "REJECTED";
})($2f512219da033f72$export$b45afd01a571a7c3 || ($2f512219da033f72$export$b45afd01a571a7c3 = {}));
var $2f512219da033f72$export$ff923d46af5bc866;
(function(JiraAtlassianIntelligenceFeatureEnum) {
    JiraAtlassianIntelligenceFeatureEnum["AiMate"] = "AI_MATE";
    JiraAtlassianIntelligenceFeatureEnum["NaturalLanguageToJql"] = "NATURAL_LANGUAGE_TO_JQL";
})($2f512219da033f72$export$ff923d46af5bc866 || ($2f512219da033f72$export$ff923d46af5bc866 = {}));
var $2f512219da033f72$export$e58d203181411860;
(function(JiraAttachmentParentName) {
    JiraAttachmentParentName["Comment"] = "COMMENT";
    JiraAttachmentParentName["Customfield"] = "CUSTOMFIELD";
    JiraAttachmentParentName["Description"] = "DESCRIPTION";
    JiraAttachmentParentName["Environment"] = "ENVIRONMENT";
    JiraAttachmentParentName["Form"] = "FORM";
    JiraAttachmentParentName["Issue"] = "ISSUE";
    JiraAttachmentParentName["Worklog"] = "WORKLOG";
})($2f512219da033f72$export$e58d203181411860 || ($2f512219da033f72$export$e58d203181411860 = {}));
var $2f512219da033f72$export$4452eb40a75908b1;
(function(JiraAttachmentSortField) {
    /** sorts by the created date */ JiraAttachmentSortField["Created"] = "CREATED";
})($2f512219da033f72$export$4452eb40a75908b1 || ($2f512219da033f72$export$4452eb40a75908b1 = {}));
var $2f512219da033f72$export$add469b410e3b948;
(function(JiraAttachmentsPermissions) {
    /** Allows the user to create atachments on the correspondig Issue. */ JiraAttachmentsPermissions["CreateAttachments"] = "CREATE_ATTACHMENTS";
    /** Allows the user to delete attachments on the corresponding Issue. */ JiraAttachmentsPermissions["DeleteOwnAttachments"] = "DELETE_OWN_ATTACHMENTS";
})($2f512219da033f72$export$add469b410e3b948 || ($2f512219da033f72$export$add469b410e3b948 = {}));
var $2f512219da033f72$export$20cf66312c009d2a;
(function(JiraAutodevCodeChangeEnumType) {
    JiraAutodevCodeChangeEnumType["Add"] = "ADD";
    JiraAutodevCodeChangeEnumType["Delete"] = "DELETE";
    JiraAutodevCodeChangeEnumType["Edit"] = "EDIT";
    JiraAutodevCodeChangeEnumType["Other"] = "OTHER";
})($2f512219da033f72$export$20cf66312c009d2a || ($2f512219da033f72$export$20cf66312c009d2a = {}));
var $2f512219da033f72$export$7c2c34d9bc1709c;
(function(JiraAutodevPhase) {
    /** transitions to CODE_REVIEW upon success */ JiraAutodevPhase["CodeGenerating"] = "CODE_GENERATING";
    /** When code is generated successfully --> CODE_RE_GENERATING */ JiraAutodevPhase["CodeReview"] = "CODE_REVIEW";
    /** When user press regenerate code button --> CODE_REVIEW */ JiraAutodevPhase["CodeReGenerating"] = "CODE_RE_GENERATING";
    /** When job is created --> PLAN_REVIEW */ JiraAutodevPhase["PlanGenerating"] = "PLAN_GENERATING";
    /** When plan is generated successfully --> PLAN_RE_GENERATING || CODE_GENERATING */ JiraAutodevPhase["PlanReview"] = "PLAN_REVIEW";
    /** When user press button to regenerate plan --> PLAN_REVIEW */ JiraAutodevPhase["PlanReGenerating"] = "PLAN_RE_GENERATING";
})($2f512219da033f72$export$7c2c34d9bc1709c || ($2f512219da033f72$export$7c2c34d9bc1709c = {}));
var $2f512219da033f72$export$9d46e21e99abf4d9;
(function(JiraAutodevState) {
    /** When an autodev job is cancelled by the user. */ JiraAutodevState["Cancelled"] = "CANCELLED";
    /** This state is entered when the code is being generated */ JiraAutodevState["CodeGenerating"] = "CODE_GENERATING";
    /** This state is entered when the code generation fails */ JiraAutodevState["CodeGenerationFail"] = "CODE_GENERATION_FAIL";
    /** This state is entered when user confirm to say that “plan looks okay, now generate code”. */ JiraAutodevState["CodeGenerationReady"] = "CODE_GENERATION_READY";
    /** This state is entered when the code generation is successful */ JiraAutodevState["CodeGenerationSuccess"] = "CODE_GENERATION_SUCCESS";
    /** When an autodev job is first created, it will enter this state. */ JiraAutodevState["Created"] = "CREATED";
    /** This state will be automatically enter when backend service started work on the job id. */ JiraAutodevState["PlanGenerating"] = "PLAN_GENERATING";
    /** This state will be be entered when the plan generation fails */ JiraAutodevState["PlanGenerationFail"] = "PLAN_GENERATION_FAIL";
    /** This state will be be entered when the plan generation succeeds */ JiraAutodevState["PlanGenerationSuccess"] = "PLAN_GENERATION_SUCCESS";
    /** This state should be automatically enter when backend service pick up the CODE_GENERATION_SUCCESS state. */ JiraAutodevState["PullrequestCreating"] = "PULLREQUEST_CREATING";
    /** This state should be entered when pull request fails to be created */ JiraAutodevState["PullrequestCreationFail"] = "PULLREQUEST_CREATION_FAIL";
    /** This state should be entered when pull request creation has succeeded */ JiraAutodevState["PullrequestCreationSuccess"] = "PULLREQUEST_CREATION_SUCCESS";
    /** Fallback state for any unexpected error */ JiraAutodevState["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$9d46e21e99abf4d9 || ($2f512219da033f72$export$9d46e21e99abf4d9 = {}));
var $2f512219da033f72$export$b45cf8febb3440fe;
(function(JiraAutodevStatus) {
    /** The autodev job was cancelled */ JiraAutodevStatus["Cancelled"] = "CANCELLED";
    /** The autodev job completed successfully */ JiraAutodevStatus["Completed"] = "COMPLETED";
    /** The autodev job stopped running because of an error */ JiraAutodevStatus["Failed"] = "FAILED";
    /** The autodev job is currently running */ JiraAutodevStatus["InProgress"] = "IN_PROGRESS";
    /** The autodev job hasn't started yet */ JiraAutodevStatus["Pending"] = "PENDING";
})($2f512219da033f72$export$b45cf8febb3440fe || ($2f512219da033f72$export$b45cf8febb3440fe = {}));
var $2f512219da033f72$export$ffe042497b182587;
(function(JiraAutofixJobType) {
    /** Autofix job to remove feature flags */ JiraAutofixJobType["InternalRemoveFeatureFlag"] = "INTERNAL_REMOVE_FEATURE_FLAG";
})($2f512219da033f72$export$ffe042497b182587 || ($2f512219da033f72$export$ffe042497b182587 = {}));
var $2f512219da033f72$export$9bc56f5589387f27;
(function(JiraAutofixStatus) {
    /** Job successfully completed */ JiraAutofixStatus["Completed"] = "COMPLETED";
    /** Job failed */ JiraAutofixStatus["Failed"] = "FAILED";
    /** Job in progress */ JiraAutofixStatus["InProgress"] = "IN_PROGRESS";
    /** Job not started */ JiraAutofixStatus["Pending"] = "PENDING";
})($2f512219da033f72$export$9bc56f5589387f27 || ($2f512219da033f72$export$9bc56f5589387f27 = {}));
var $2f512219da033f72$export$2c2631a0fafec4d2;
(function(JiraBackgroundType) {
    JiraBackgroundType["Attachment"] = "ATTACHMENT";
    JiraBackgroundType["Color"] = "COLOR";
    JiraBackgroundType["Custom"] = "CUSTOM";
    JiraBackgroundType["Gradient"] = "GRADIENT";
    JiraBackgroundType["Unsplash"] = "UNSPLASH";
})($2f512219da033f72$export$2c2631a0fafec4d2 || ($2f512219da033f72$export$2c2631a0fafec4d2 = {}));
var $2f512219da033f72$export$a91e934e29660252;
(function(JiraBatchWindowPreference) {
    JiraBatchWindowPreference["DefaultBatching"] = "DEFAULT_BATCHING";
    JiraBatchWindowPreference["FifteenMinutes"] = "FIFTEEN_MINUTES";
    JiraBatchWindowPreference["FiveMinutes"] = "FIVE_MINUTES";
    JiraBatchWindowPreference["NoBatching"] = "NO_BATCHING";
    JiraBatchWindowPreference["OncePerDay"] = "ONCE_PER_DAY";
    JiraBatchWindowPreference["OneDay"] = "ONE_DAY";
    JiraBatchWindowPreference["OneHour"] = "ONE_HOUR";
    JiraBatchWindowPreference["TenMinutes"] = "TEN_MINUTES";
    JiraBatchWindowPreference["ThirtyMinutes"] = "THIRTY_MINUTES";
})($2f512219da033f72$export$a91e934e29660252 || ($2f512219da033f72$export$a91e934e29660252 = {}));
var $2f512219da033f72$export$fffb97f85a99dcd3;
(function(JiraBitbucketWorkspaceApprovalState) {
    JiraBitbucketWorkspaceApprovalState["Approved"] = "APPROVED";
    JiraBitbucketWorkspaceApprovalState["PendingApproval"] = "PENDING_APPROVAL";
})($2f512219da033f72$export$fffb97f85a99dcd3 || ($2f512219da033f72$export$fffb97f85a99dcd3 = {}));
var $2f512219da033f72$export$4dc98413456458b;
(function(JiraBoardLocationType) {
    /** Boards located in a project */ JiraBoardLocationType["Project"] = "PROJECT";
    /** Boards located under a user */ JiraBoardLocationType["User"] = "USER";
})($2f512219da033f72$export$4dc98413456458b || ($2f512219da033f72$export$4dc98413456458b = {}));
var $2f512219da033f72$export$49e19d96d2521497;
(function(JiraBoardSwimlaneStrategy) {
    JiraBoardSwimlaneStrategy["AssigneeUnassignedFirst"] = "ASSIGNEE_UNASSIGNED_FIRST";
    JiraBoardSwimlaneStrategy["AssigneeUnassignedLast"] = "ASSIGNEE_UNASSIGNED_LAST";
    JiraBoardSwimlaneStrategy["Custom"] = "CUSTOM";
    JiraBoardSwimlaneStrategy["Epic"] = "EPIC";
    JiraBoardSwimlaneStrategy["IssueChildren"] = "ISSUE_CHILDREN";
    JiraBoardSwimlaneStrategy["IssueParent"] = "ISSUE_PARENT";
    JiraBoardSwimlaneStrategy["None"] = "NONE";
    JiraBoardSwimlaneStrategy["ParentChild"] = "PARENT_CHILD";
    JiraBoardSwimlaneStrategy["Project"] = "PROJECT";
    JiraBoardSwimlaneStrategy["RequestType"] = "REQUEST_TYPE";
})($2f512219da033f72$export$49e19d96d2521497 || ($2f512219da033f72$export$49e19d96d2521497 = {}));
var $2f512219da033f72$export$97a2fe75628224ea;
(function(JiraBoardType) {
    /** The board type without sprints */ JiraBoardType["Kanban"] = "KANBAN";
    /** The board type with sprints */ JiraBoardType["Scrum"] = "SCRUM";
})($2f512219da033f72$export$97a2fe75628224ea || ($2f512219da033f72$export$97a2fe75628224ea = {}));
var $2f512219da033f72$export$8dcaa522c00e0bea;
(function(JiraBulkEditMultiSelectFieldOptions) {
    /** Represents the Bulk Edit multi select field option for which the field values provided in Bulk Edit will be added to the already set field values */ JiraBulkEditMultiSelectFieldOptions["Add"] = "ADD";
    /** Represents the Bulk Edit multi select field option for which the field values provided in Bulk Edit will be removed from the already set field values (if they exist) */ JiraBulkEditMultiSelectFieldOptions["Remove"] = "REMOVE";
    /** Represents Bulk Edit multi select field option for which the already set field values will be all removed */ JiraBulkEditMultiSelectFieldOptions["RemoveAll"] = "REMOVE_ALL";
    /** Represents the Bulk Edit multi select field option for which the field values provided in Bulk Edit will replace the already set field values */ JiraBulkEditMultiSelectFieldOptions["Replace"] = "REPLACE";
})($2f512219da033f72$export$8dcaa522c00e0bea || ($2f512219da033f72$export$8dcaa522c00e0bea = {}));
var $2f512219da033f72$export$65634ab0c72ca58;
(function(JiraBulkOperationType) {
    /** Specified bulk delete operation type */ JiraBulkOperationType["BulkDelete"] = "BULK_DELETE";
    /** Specified bulk edit operation type */ JiraBulkOperationType["BulkEdit"] = "BULK_EDIT";
    /** Specified bulk transition operation type */ JiraBulkOperationType["BulkTransition"] = "BULK_TRANSITION";
    /** Specified bulk unwatch operation type */ JiraBulkOperationType["BulkUnwatch"] = "BULK_UNWATCH";
    /** Specified bulk watch operation type */ JiraBulkOperationType["BulkWatch"] = "BULK_WATCH";
})($2f512219da033f72$export$65634ab0c72ca58 || ($2f512219da033f72$export$65634ab0c72ca58 = {}));
var $2f512219da033f72$export$598ca3e7e63eeac3;
(function(JiraCalendarMode) {
    JiraCalendarMode["Day"] = "DAY";
    JiraCalendarMode["Month"] = "MONTH";
    JiraCalendarMode["Week"] = "WEEK";
})($2f512219da033f72$export$598ca3e7e63eeac3 || ($2f512219da033f72$export$598ca3e7e63eeac3 = {}));
var $2f512219da033f72$export$80636f9ce4ef8927;
(function(JiraCalendarPermissionKey) {
    JiraCalendarPermissionKey["ManageSprintsPermission"] = "MANAGE_SPRINTS_PERMISSION";
})($2f512219da033f72$export$80636f9ce4ef8927 || ($2f512219da033f72$export$80636f9ce4ef8927 = {}));
var $2f512219da033f72$export$56103bfe65fcf045;
(function(JiraCalendarWeekStart) {
    JiraCalendarWeekStart["Monday"] = "MONDAY";
    JiraCalendarWeekStart["Saturday"] = "SATURDAY";
    JiraCalendarWeekStart["Sunday"] = "SUNDAY";
})($2f512219da033f72$export$56103bfe65fcf045 || ($2f512219da033f72$export$56103bfe65fcf045 = {}));
var $2f512219da033f72$export$ce8ee5a026b40f80;
(function(JiraCannedResponseScope) {
    JiraCannedResponseScope["Personal"] = "PERSONAL";
    JiraCannedResponseScope["Project"] = "PROJECT";
})($2f512219da033f72$export$ce8ee5a026b40f80 || ($2f512219da033f72$export$ce8ee5a026b40f80 = {}));
var $2f512219da033f72$export$c55b15b4975ca485;
(function(JiraCannedResponseSortOrder) {
    JiraCannedResponseSortOrder["Asc"] = "ASC";
    JiraCannedResponseSortOrder["Desc"] = "DESC";
})($2f512219da033f72$export$c55b15b4975ca485 || ($2f512219da033f72$export$c55b15b4975ca485 = {}));
var $2f512219da033f72$export$95ff254e6924dc6f;
(function(JiraCascadingSelectOptionType) {
    /** All options, regardless of whether they're a parent or child. */ JiraCascadingSelectOptionType["All"] = "ALL";
    /** Child option only */ JiraCascadingSelectOptionType["Child"] = "CHILD";
    /** Parent option only */ JiraCascadingSelectOptionType["Parent"] = "PARENT";
})($2f512219da033f72$export$95ff254e6924dc6f || ($2f512219da033f72$export$95ff254e6924dc6f = {}));
var $2f512219da033f72$export$f34d058fb688acaf;
(function(JiraClassificationLevelSource) {
    JiraClassificationLevelSource["Issue"] = "ISSUE";
    JiraClassificationLevelSource["Project"] = "PROJECT";
})($2f512219da033f72$export$f34d058fb688acaf || ($2f512219da033f72$export$f34d058fb688acaf = {}));
var $2f512219da033f72$export$608cba47cc506457;
(function(JiraClassificationLevelStatus) {
    JiraClassificationLevelStatus["Archived"] = "ARCHIVED";
    JiraClassificationLevelStatus["Draft"] = "DRAFT";
    JiraClassificationLevelStatus["Published"] = "PUBLISHED";
})($2f512219da033f72$export$608cba47cc506457 || ($2f512219da033f72$export$608cba47cc506457 = {}));
var $2f512219da033f72$export$a6a7c946782bf432;
(function(JiraClassificationLevelType) {
    JiraClassificationLevelType["System"] = "SYSTEM";
    JiraClassificationLevelType["User"] = "USER";
})($2f512219da033f72$export$a6a7c946782bf432 || ($2f512219da033f72$export$a6a7c946782bf432 = {}));
var $2f512219da033f72$export$aafda693b12c4a20;
(function(JiraCmdbAttributeType) {
    /** Bitbucket repository attribute. */ JiraCmdbAttributeType["BitbucketRepo"] = "BITBUCKET_REPO";
    /** Confluence attribute. */ JiraCmdbAttributeType["Confluence"] = "CONFLUENCE";
    /** Default attributes, e.g. text, boolean, integer, date. */ JiraCmdbAttributeType["Default"] = "DEFAULT";
    /** Group attribute. */ JiraCmdbAttributeType["Group"] = "GROUP";
    /** Opsgenie team attribute. */ JiraCmdbAttributeType["OpsgenieTeam"] = "OPSGENIE_TEAM";
    /** Project attribute. */ JiraCmdbAttributeType["Project"] = "PROJECT";
    /** Reference object attribute. */ JiraCmdbAttributeType["ReferencedObject"] = "REFERENCED_OBJECT";
    /** Status attribute. */ JiraCmdbAttributeType["Status"] = "STATUS";
    /** User attribute. */ JiraCmdbAttributeType["User"] = "USER";
    /** Version attribute. */ JiraCmdbAttributeType["Version"] = "VERSION";
})($2f512219da033f72$export$aafda693b12c4a20 || ($2f512219da033f72$export$aafda693b12c4a20 = {}));
var $2f512219da033f72$export$7341e48e3db8f8f0;
(function(JiraColorSchemeThemeSetting) {
    /** Theme matches the user browser settings */ JiraColorSchemeThemeSetting["Automatic"] = "AUTOMATIC";
    /** Dark mode theme */ JiraColorSchemeThemeSetting["Dark"] = "DARK";
    /** Light mode theme */ JiraColorSchemeThemeSetting["Light"] = "LIGHT";
})($2f512219da033f72$export$7341e48e3db8f8f0 || ($2f512219da033f72$export$7341e48e3db8f8f0 = {}));
var $2f512219da033f72$export$67f08e20644f2173;
(function(JiraCommentSortField) {
    /** sorts by the created date */ JiraCommentSortField["Created"] = "CREATED";
})($2f512219da033f72$export$67f08e20644f2173 || ($2f512219da033f72$export$67f08e20644f2173 = {}));
var $2f512219da033f72$export$6f50c8d504c17c7a;
(function(JiraConfigFieldType) {
    /** Allows multiple values to be selected using two select lists */ JiraConfigFieldType["CustomCascadingSelect"] = "CUSTOM_CASCADING_SELECT";
    /** Stores a date with a time component */ JiraConfigFieldType["CustomDatetime"] = "CUSTOM_DATETIME";
    /** Stores a date using a picker control */ JiraConfigFieldType["CustomDatePicker"] = "CUSTOM_DATE_PICKER";
    /** Stores and validates a numeric (floating point) input */ JiraConfigFieldType["CustomFloat"] = "CUSTOM_FLOAT";
    /** Stores a user group using a picker control */ JiraConfigFieldType["CustomGroupPicker"] = "CUSTOM_GROUP_PICKER";
    /** A read-only field that stores the previous ID of the issue from the system that it was imported from */ JiraConfigFieldType["CustomImportId"] = "CUSTOM_IMPORT_ID";
    /** Stores labels */ JiraConfigFieldType["CustomLabels"] = "CUSTOM_LABELS";
    /** Stores multiple values using checkboxes */ JiraConfigFieldType["CustomMultiCheckboxes"] = "CUSTOM_MULTI_CHECKBOXES";
    /** Stores multiple user groups using a picker control */ JiraConfigFieldType["CustomMultiGroupPicker"] = "CUSTOM_MULTI_GROUP_PICKER";
    /** Stores multiple values using a select list */ JiraConfigFieldType["CustomMultiSelect"] = "CUSTOM_MULTI_SELECT";
    /** Stores multiple users using a picker control */ JiraConfigFieldType["CustomMultiUserPicker"] = "CUSTOM_MULTI_USER_PICKER";
    /** Stores multiple versions from the versions available in a project using a picker control */ JiraConfigFieldType["CustomMultiVersion"] = "CUSTOM_MULTI_VERSION";
    /** Stores a project from a list of projects that the user is permitted to view */ JiraConfigFieldType["CustomProject"] = "CUSTOM_PROJECT";
    /** Stores a value using radio buttons */ JiraConfigFieldType["CustomRadioButtons"] = "CUSTOM_RADIO_BUTTONS";
    /** Stores a read-only text value, which can only be populated via the API */ JiraConfigFieldType["CustomReadonlyField"] = "CUSTOM_READONLY_FIELD";
    /** Stores a value from a configurable list of options */ JiraConfigFieldType["CustomSelect"] = "CUSTOM_SELECT";
    /** Stores a long text string using a multiline text area */ JiraConfigFieldType["CustomTextarea"] = "CUSTOM_TEXTAREA";
    /** Stores a text string using a single-line text box */ JiraConfigFieldType["CustomTextField"] = "CUSTOM_TEXT_FIELD";
    /** Stores a URL */ JiraConfigFieldType["CustomUrl"] = "CUSTOM_URL";
    /** Stores a user using a picker control */ JiraConfigFieldType["CustomUserPicker"] = "CUSTOM_USER_PICKER";
    /** Stores a version using a picker control */ JiraConfigFieldType["CustomVersion"] = "CUSTOM_VERSION";
    /** Servicedesk approvals field */ JiraConfigFieldType["ServicedeskApprovals"] = "SERVICEDESK_APPROVALS";
    /** Servicedesk cmdb field */ JiraConfigFieldType["ServicedeskCmdbField"] = "SERVICEDESK_CMDB_FIELD";
    /** Servicedesk customer organizations field */ JiraConfigFieldType["ServicedeskCustomerOrganizations"] = "SERVICEDESK_CUSTOMER_ORGANIZATIONS";
    /** Servicedesk request feedback field */ JiraConfigFieldType["ServicedeskRequestFeedback"] = "SERVICEDESK_REQUEST_FEEDBACK";
    /** Servicedesk feedback date field */ JiraConfigFieldType["ServicedeskRequestFeedbackDate"] = "SERVICEDESK_REQUEST_FEEDBACK_DATE";
    /** Servicedesk request language field */ JiraConfigFieldType["ServicedeskRequestLanguage"] = "SERVICEDESK_REQUEST_LANGUAGE";
    /** Servicedesk request participants field */ JiraConfigFieldType["ServicedeskRequestParticipants"] = "SERVICEDESK_REQUEST_PARTICIPANTS";
    /** Servicedesk sla field */ JiraConfigFieldType["ServicedeskSlaField"] = "SERVICEDESK_SLA_FIELD";
    /** Servicedesk vp origin field */ JiraConfigFieldType["ServicedeskVpOrigin"] = "SERVICEDESK_VP_ORIGIN";
    /** Software epic color field */ JiraConfigFieldType["SoftwareEpicColor"] = "SOFTWARE_EPIC_COLOR";
    /** Software epic issue color field */ JiraConfigFieldType["SoftwareEpicIssueColor"] = "SOFTWARE_EPIC_ISSUE_COLOR";
    /** Software epic label field */ JiraConfigFieldType["SoftwareEpicLabel"] = "SOFTWARE_EPIC_LABEL";
    /** Software epic lexo rank field */ JiraConfigFieldType["SoftwareEpicLexoRank"] = "SOFTWARE_EPIC_LEXO_RANK";
    /** Software epic link field */ JiraConfigFieldType["SoftwareEpicLink"] = "SOFTWARE_EPIC_LINK";
    /** Software epic sprint field */ JiraConfigFieldType["SoftwareEpicSprint"] = "SOFTWARE_EPIC_SPRINT";
    /** Software epic status field */ JiraConfigFieldType["SoftwareEpicStatus"] = "SOFTWARE_EPIC_STATUS";
    /** Standard affected versions issue field */ JiraConfigFieldType["StandardAffectedVersions"] = "STANDARD_AFFECTED_VERSIONS";
    /** Standard aggregate progress issue field */ JiraConfigFieldType["StandardAggregateProgress"] = "STANDARD_AGGREGATE_PROGRESS";
    /** Standard aggregate time estimate issue field */ JiraConfigFieldType["StandardAggregateTimeEstimate"] = "STANDARD_AGGREGATE_TIME_ESTIMATE";
    /** Standard aggregate time original estimate issue field */ JiraConfigFieldType["StandardAggregateTimeOriginalEstimate"] = "STANDARD_AGGREGATE_TIME_ORIGINAL_ESTIMATE";
    /** Standard aggregate time spent issue field */ JiraConfigFieldType["StandardAggregateTimeSpent"] = "STANDARD_AGGREGATE_TIME_SPENT";
    /** Standard assignee issue field */ JiraConfigFieldType["StandardAssignee"] = "STANDARD_ASSIGNEE";
    /** Standard attachment issue field */ JiraConfigFieldType["StandardAttachment"] = "STANDARD_ATTACHMENT";
    /** Standard comment issue field */ JiraConfigFieldType["StandardComment"] = "STANDARD_COMMENT";
    /** Standard components issue field */ JiraConfigFieldType["StandardComponents"] = "STANDARD_COMPONENTS";
    /** Standard created issue field */ JiraConfigFieldType["StandardCreated"] = "STANDARD_CREATED";
    /** Standard creator issue field */ JiraConfigFieldType["StandardCreator"] = "STANDARD_CREATOR";
    /** Standard description issue field */ JiraConfigFieldType["StandardDescription"] = "STANDARD_DESCRIPTION";
    /** Standard due date issue field */ JiraConfigFieldType["StandardDueDate"] = "STANDARD_DUE_DATE";
    /** Standard environment issue field */ JiraConfigFieldType["StandardEnvironment"] = "STANDARD_ENVIRONMENT";
    /** Standard fix for versions issue field */ JiraConfigFieldType["StandardFixForVersions"] = "STANDARD_FIX_FOR_VERSIONS";
    /** Standard form token issue field */ JiraConfigFieldType["StandardFormToken"] = "STANDARD_FORM_TOKEN";
    /** Standard issue key issue field */ JiraConfigFieldType["StandardIssueKey"] = "STANDARD_ISSUE_KEY";
    /** Standard issue links issue field */ JiraConfigFieldType["StandardIssueLinks"] = "STANDARD_ISSUE_LINKS";
    /** Standard issue number issue field */ JiraConfigFieldType["StandardIssueNumber"] = "STANDARD_ISSUE_NUMBER";
    /** Standard issue type issue field */ JiraConfigFieldType["StandardIssueType"] = "STANDARD_ISSUE_TYPE";
    /** Standard labels issue field */ JiraConfigFieldType["StandardLabels"] = "STANDARD_LABELS";
    /** Standard last viewed issue field */ JiraConfigFieldType["StandardLastViewed"] = "STANDARD_LAST_VIEWED";
    /** Standard parent issue field */ JiraConfigFieldType["StandardParent"] = "STANDARD_PARENT";
    /** Standard priority issue field */ JiraConfigFieldType["StandardPriority"] = "STANDARD_PRIORITY";
    /** Standard progress issue field */ JiraConfigFieldType["StandardProgress"] = "STANDARD_PROGRESS";
    /** Standard project issue field */ JiraConfigFieldType["StandardProject"] = "STANDARD_PROJECT";
    /** Standard project key issue field */ JiraConfigFieldType["StandardProjectKey"] = "STANDARD_PROJECT_KEY";
    /** Standard reporter issue field */ JiraConfigFieldType["StandardReporter"] = "STANDARD_REPORTER";
    /** Standard resolution issue field */ JiraConfigFieldType["StandardResolution"] = "STANDARD_RESOLUTION";
    /** Standard resolution date issue field */ JiraConfigFieldType["StandardResolutionDate"] = "STANDARD_RESOLUTION_DATE";
    /** Standard security issue field */ JiraConfigFieldType["StandardSecurity"] = "STANDARD_SECURITY";
    /** Standard status issue field */ JiraConfigFieldType["StandardStatus"] = "STANDARD_STATUS";
    /** Standard subtasks issue field */ JiraConfigFieldType["StandardSubtasks"] = "STANDARD_SUBTASKS";
    /** Standard summary issue field */ JiraConfigFieldType["StandardSummary"] = "STANDARD_SUMMARY";
    /** Standard thumbnail issue field */ JiraConfigFieldType["StandardThumbnail"] = "STANDARD_THUMBNAIL";
    /** Standard time tracking issue field */ JiraConfigFieldType["StandardTimetracking"] = "STANDARD_TIMETRACKING";
    /** Standard time estimate issue field */ JiraConfigFieldType["StandardTimeEstimate"] = "STANDARD_TIME_ESTIMATE";
    /** Standard original estimate issue field */ JiraConfigFieldType["StandardTimeOriginalEstimate"] = "STANDARD_TIME_ORIGINAL_ESTIMATE";
    /** Standard time spent issue field */ JiraConfigFieldType["StandardTimeSpent"] = "STANDARD_TIME_SPENT";
    /** Standard updated issue field */ JiraConfigFieldType["StandardUpdated"] = "STANDARD_UPDATED";
    /** Standard voters issue field */ JiraConfigFieldType["StandardVoters"] = "STANDARD_VOTERS";
    /** Standard votes issue field */ JiraConfigFieldType["StandardVotes"] = "STANDARD_VOTES";
    /** Standard watchers issue field */ JiraConfigFieldType["StandardWatchers"] = "STANDARD_WATCHERS";
    /** Standard watches issue field */ JiraConfigFieldType["StandardWatches"] = "STANDARD_WATCHES";
    /** Standard worklog issue field */ JiraConfigFieldType["StandardWorklog"] = "STANDARD_WORKLOG";
    /** Standard work ratio issue field */ JiraConfigFieldType["StandardWorkratio"] = "STANDARD_WORKRATIO";
    /** Used to represent a Field type that is currently not handled */ JiraConfigFieldType["Unsupported"] = "UNSUPPORTED";
})($2f512219da033f72$export$6f50c8d504c17c7a || ($2f512219da033f72$export$6f50c8d504c17c7a = {}));
var $2f512219da033f72$export$9d90b408b08d33b7;
(function(JiraConfigStateConfigurationStatus) {
    /** App is in configured state */ JiraConfigStateConfigurationStatus["Configured"] = "CONFIGURED";
    /** App is not in configured state */ JiraConfigStateConfigurationStatus["NotConfigured"] = "NOT_CONFIGURED";
    /** App is not installed */ JiraConfigStateConfigurationStatus["NotInstalled"] = "NOT_INSTALLED";
    /** Configured state not set */ JiraConfigStateConfigurationStatus["NotSet"] = "NOT_SET";
    /** App is in partially configured state */ JiraConfigStateConfigurationStatus["PartiallyConfigured"] = "PARTIALLY_CONFIGURED";
    /** Provider action is in configured state */ JiraConfigStateConfigurationStatus["ProviderActionConfigured"] = "PROVIDER_ACTION_CONFIGURED";
    /** Provider action is not in configured state */ JiraConfigStateConfigurationStatus["ProviderActionNotConfigured"] = "PROVIDER_ACTION_NOT_CONFIGURED";
})($2f512219da033f72$export$9d90b408b08d33b7 || ($2f512219da033f72$export$9d90b408b08d33b7 = {}));
var $2f512219da033f72$export$227a4b9b7e3c43f7;
(function(JiraConfigStateProviderType) {
    /** Represents a provider type of an app which providers build service */ JiraConfigStateProviderType["Builds"] = "BUILDS";
    /** Represents a provider type of an app which providers deployments service */ JiraConfigStateProviderType["Deployments"] = "DEPLOYMENTS";
    /** Represents a provider type of an app which providers designs service */ JiraConfigStateProviderType["Designs"] = "DESIGNS";
    /** Represents a provider type of an app which providers dev Info service */ JiraConfigStateProviderType["DevelopmentInfo"] = "DEVELOPMENT_INFO";
    /** Represents a provider type of an app which providers feature flag service */ JiraConfigStateProviderType["FeatureFlags"] = "FEATURE_FLAGS";
    /** Represents a provider type of an app which providers remote links service */ JiraConfigStateProviderType["RemoteLinks"] = "REMOTE_LINKS";
    /** Represents a provider type of an app which providers security service */ JiraConfigStateProviderType["Security"] = "SECURITY";
    /** Represents a provider type of an app which does not fit in above categories */ JiraConfigStateProviderType["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$227a4b9b7e3c43f7 || ($2f512219da033f72$export$227a4b9b7e3c43f7 = {}));
var $2f512219da033f72$export$2eccc11159f64a0b;
(function(JiraContactOrgAdminToEnableAtlassianIntelligenceState) {
    /** The modal is available to be shown. */ JiraContactOrgAdminToEnableAtlassianIntelligenceState["Available"] = "AVAILABLE";
    /** The modal is not available to be shown. */ JiraContactOrgAdminToEnableAtlassianIntelligenceState["Unavailable"] = "UNAVAILABLE";
})($2f512219da033f72$export$2eccc11159f64a0b || ($2f512219da033f72$export$2eccc11159f64a0b = {}));
var $2f512219da033f72$export$ab94fb316a642cad;
(function(JiraCustomIssueSearchErrorType) {
    /** A specific, internal error was generated by the custom search implementation */ JiraCustomIssueSearchErrorType["CustomImplementationError"] = "CUSTOM_IMPLEMENTATION_ERROR";
    /** The requested custom search implementation is not enabled for this request */ JiraCustomIssueSearchErrorType["CustomSearchDisabled"] = "CUSTOM_SEARCH_DISABLED";
    /** An ARI used as input to a custom search implementation was invalid */ JiraCustomIssueSearchErrorType["InvalidAri"] = "INVALID_ARI";
    /** An ARI used as input to a custom search implementation is not supported by the implementation */ JiraCustomIssueSearchErrorType["UnsupportedAri"] = "UNSUPPORTED_ARI";
})($2f512219da033f72$export$ab94fb316a642cad || ($2f512219da033f72$export$ab94fb316a642cad = {}));
var $2f512219da033f72$export$2ed4618f2653768;
(function(JiraDeploymentsFeaturePrecondition) {
    /** The deployments feature is available as the project has satisfied all precondition checks. */ JiraDeploymentsFeaturePrecondition["AllSatisfied"] = "ALL_SATISFIED";
    /** The deployments feature is available and will show the empty-state page as no CI/CD provider is sending deployment data. */ JiraDeploymentsFeaturePrecondition["DeploymentsEmptyState"] = "DEPLOYMENTS_EMPTY_STATE";
    /** The deployments feature is not available as the precondition checks have not been satisfied. */ JiraDeploymentsFeaturePrecondition["NotAvailable"] = "NOT_AVAILABLE";
})($2f512219da033f72$export$2ed4618f2653768 || ($2f512219da033f72$export$2ed4618f2653768 = {}));
var $2f512219da033f72$export$956b9378bb62ef88;
(function(JiraDevInfoConfigErrorType) {
    JiraDevInfoConfigErrorType["Incapable"] = "INCAPABLE";
    JiraDevInfoConfigErrorType["NotConfigured"] = "NOT_CONFIGURED";
    JiraDevInfoConfigErrorType["Unauthorized"] = "UNAUTHORIZED";
    JiraDevInfoConfigErrorType["UnknownConfigError"] = "UNKNOWN_CONFIG_ERROR";
})($2f512219da033f72$export$956b9378bb62ef88 || ($2f512219da033f72$export$956b9378bb62ef88 = {}));
var $2f512219da033f72$export$35269253edf4bd98;
(function(JiraDevOpsCapability) {
    JiraDevOpsCapability["Branch"] = "BRANCH";
    JiraDevOpsCapability["Build"] = "BUILD";
    JiraDevOpsCapability["Commit"] = "COMMIT";
    JiraDevOpsCapability["Deployment"] = "DEPLOYMENT";
    JiraDevOpsCapability["FeatureFlag"] = "FEATURE_FLAG";
    JiraDevOpsCapability["PullRequest"] = "PULL_REQUEST";
    JiraDevOpsCapability["Review"] = "REVIEW";
})($2f512219da033f72$export$35269253edf4bd98 || ($2f512219da033f72$export$35269253edf4bd98 = {}));
var $2f512219da033f72$export$62ac5d058da58a8;
(function(JiraDevOpsInContextConfigPromptLocation) {
    JiraDevOpsInContextConfigPromptLocation["DevelopmentPanel"] = "DEVELOPMENT_PANEL";
    JiraDevOpsInContextConfigPromptLocation["ReleasesPanel"] = "RELEASES_PANEL";
    JiraDevOpsInContextConfigPromptLocation["SecurityPanel"] = "SECURITY_PANEL";
})($2f512219da033f72$export$62ac5d058da58a8 || ($2f512219da033f72$export$62ac5d058da58a8 = {}));
var $2f512219da033f72$export$ab235556283af700;
(function(JiraDevOpsIssuePanelBannerType) {
    /** Banner that explains how to add issue keys in your commits, branches and PRs */ JiraDevOpsIssuePanelBannerType["IssueKeyOnboarding"] = "ISSUE_KEY_ONBOARDING";
})($2f512219da033f72$export$ab235556283af700 || ($2f512219da033f72$export$ab235556283af700 = {}));
var $2f512219da033f72$export$9deab4622c89c42;
(function(JiraDevOpsIssuePanelState) {
    /** Panel should show the available Dev Summary */ JiraDevOpsIssuePanelState["DevSummary"] = "DEV_SUMMARY";
    /** Panel should be hidden */ JiraDevOpsIssuePanelState["Hidden"] = "HIDDEN";
    /** Panel should show the "not connected" state to prompt user to integrate tools */ JiraDevOpsIssuePanelState["NotConnected"] = "NOT_CONNECTED";
})($2f512219da033f72$export$9deab4622c89c42 || ($2f512219da033f72$export$9deab4622c89c42 = {}));
var $2f512219da033f72$export$f72ad11cc7a7d264;
(function(JiraDevOpsUpdateAssociationsEntityType) {
    JiraDevOpsUpdateAssociationsEntityType["Vulnerability"] = "VULNERABILITY";
})($2f512219da033f72$export$f72ad11cc7a7d264 || ($2f512219da033f72$export$f72ad11cc7a7d264 = {}));
var $2f512219da033f72$export$309a4c314bc40eda;
(function(JiraEmailMimeType) {
    JiraEmailMimeType["Html"] = "HTML";
    JiraEmailMimeType["Text"] = "TEXT";
})($2f512219da033f72$export$309a4c314bc40eda || ($2f512219da033f72$export$309a4c314bc40eda = {}));
var $2f512219da033f72$export$2d42aa6ed58ded25;
(function(JiraEntityScope) {
    JiraEntityScope["Global"] = "GLOBAL";
    JiraEntityScope["Project"] = "PROJECT";
})($2f512219da033f72$export$2d42aa6ed58ded25 || ($2f512219da033f72$export$2d42aa6ed58ded25 = {}));
var $2f512219da033f72$export$5c4322ab4b397354;
(function(JiraFavouriteType) {
    JiraFavouriteType["Board"] = "BOARD";
    JiraFavouriteType["Dashboard"] = "DASHBOARD";
    JiraFavouriteType["Filter"] = "FILTER";
    JiraFavouriteType["Plan"] = "PLAN";
    JiraFavouriteType["Project"] = "PROJECT";
    JiraFavouriteType["Queue"] = "QUEUE";
})($2f512219da033f72$export$5c4322ab4b397354 || ($2f512219da033f72$export$5c4322ab4b397354 = {}));
var $2f512219da033f72$export$18f16315d2f9166d;
(function(JiraFieldOptionIdsFilterOperation) {
    /**
   * Allow the optionIds provided in the JiraFieldOptionIdsFilterInput from available options
   * with intersection of result from searchBy query string.
   */ JiraFieldOptionIdsFilterOperation["Allow"] = "ALLOW";
    /**
   * Exclude the optionIds provided in the JiraFieldOptionIdsFilterInput from available options
   * with intersection of result from searchBy query string.
   */ JiraFieldOptionIdsFilterOperation["Exclude"] = "EXCLUDE";
})($2f512219da033f72$export$18f16315d2f9166d || ($2f512219da033f72$export$18f16315d2f9166d = {}));
var $2f512219da033f72$export$8947915968eda69f;
(function(JiraForgeEnvironmentType) {
    JiraForgeEnvironmentType["Development"] = "DEVELOPMENT";
    JiraForgeEnvironmentType["Production"] = "PRODUCTION";
    JiraForgeEnvironmentType["Staging"] = "STAGING";
})($2f512219da033f72$export$8947915968eda69f || ($2f512219da033f72$export$8947915968eda69f = {}));
var $2f512219da033f72$export$a84cede14c0af3e6;
(function(JiraFormattingArea) {
    JiraFormattingArea["Cell"] = "CELL";
    JiraFormattingArea["Row"] = "ROW";
})($2f512219da033f72$export$a84cede14c0af3e6 || ($2f512219da033f72$export$a84cede14c0af3e6 = {}));
var $2f512219da033f72$export$ac68c28f8148831f;
(function(JiraFormattingColor) {
    /** @deprecated Use JiraColor instead */ JiraFormattingColor["Blue"] = "BLUE";
    /** @deprecated Use JiraColor instead */ JiraFormattingColor["Green"] = "GREEN";
    /** @deprecated Use JiraColor instead */ JiraFormattingColor["Red"] = "RED";
})($2f512219da033f72$export$ac68c28f8148831f || ($2f512219da033f72$export$ac68c28f8148831f = {}));
var $2f512219da033f72$export$efa4d82804592bca;
(function(JiraFormattingMultipleValueOperator) {
    JiraFormattingMultipleValueOperator["Contains"] = "CONTAINS";
    JiraFormattingMultipleValueOperator["DoesNotContain"] = "DOES_NOT_CONTAIN";
    JiraFormattingMultipleValueOperator["HasAnyOf"] = "HAS_ANY_OF";
})($2f512219da033f72$export$efa4d82804592bca || ($2f512219da033f72$export$efa4d82804592bca = {}));
var $2f512219da033f72$export$eca120e5a19089a1;
(function(JiraFormattingNoValueOperator) {
    JiraFormattingNoValueOperator["IsEmpty"] = "IS_EMPTY";
    JiraFormattingNoValueOperator["IsNotEmpty"] = "IS_NOT_EMPTY";
})($2f512219da033f72$export$eca120e5a19089a1 || ($2f512219da033f72$export$eca120e5a19089a1 = {}));
var $2f512219da033f72$export$545873d4d5fe4917;
(function(JiraFormattingSingleValueOperator) {
    JiraFormattingSingleValueOperator["Contains"] = "CONTAINS";
    JiraFormattingSingleValueOperator["DoesNotContain"] = "DOES_NOT_CONTAIN";
    JiraFormattingSingleValueOperator["DoesNotEqual"] = "DOES_NOT_EQUAL";
    JiraFormattingSingleValueOperator["Equals"] = "EQUALS";
    JiraFormattingSingleValueOperator["GreaterThan"] = "GREATER_THAN";
    JiraFormattingSingleValueOperator["GreaterThanOrEquals"] = "GREATER_THAN_OR_EQUALS";
    JiraFormattingSingleValueOperator["Is"] = "IS";
    JiraFormattingSingleValueOperator["IsAfter"] = "IS_AFTER";
    JiraFormattingSingleValueOperator["IsBefore"] = "IS_BEFORE";
    JiraFormattingSingleValueOperator["IsNot"] = "IS_NOT";
    JiraFormattingSingleValueOperator["IsOnOrAfter"] = "IS_ON_OR_AFTER";
    JiraFormattingSingleValueOperator["IsOnOrBefore"] = "IS_ON_OR_BEFORE";
    JiraFormattingSingleValueOperator["LessThan"] = "LESS_THAN";
    JiraFormattingSingleValueOperator["LessThanOrEquals"] = "LESS_THAN_OR_EQUALS";
})($2f512219da033f72$export$545873d4d5fe4917 || ($2f512219da033f72$export$545873d4d5fe4917 = {}));
var $2f512219da033f72$export$7a46afffd251b41d;
(function(JiraFormattingTwoValueOperator) {
    JiraFormattingTwoValueOperator["IsBetween"] = "IS_BETWEEN";
    JiraFormattingTwoValueOperator["IsNotBetween"] = "IS_NOT_BETWEEN";
})($2f512219da033f72$export$7a46afffd251b41d || ($2f512219da033f72$export$7a46afffd251b41d = {}));
var $2f512219da033f72$export$4a2c19fd597ee77f;
(function(JiraGlobalIssueCreateView) {
    /** The global issue create full modal view. */ JiraGlobalIssueCreateView["FullModal"] = "FULL_MODAL";
    /** The global issue create mini modal view. */ JiraGlobalIssueCreateView["MiniModal"] = "MINI_MODAL";
})($2f512219da033f72$export$4a2c19fd597ee77f || ($2f512219da033f72$export$4a2c19fd597ee77f = {}));
var $2f512219da033f72$export$c30f06fc4059f363;
(function(JiraGlobalPermissionType) {
    /**
   * Create and administer projects, issue types, fields, workflows, and schemes for all projects.
   * Users with this permission can perform most administration tasks, except: managing users,
   * importing data, and editing system email settings.
   */ JiraGlobalPermissionType["Administer"] = "ADMINISTER";
    /** Users with this permission can see the names of all users and groups on your site. */ JiraGlobalPermissionType["UserPicker"] = "USER_PICKER";
})($2f512219da033f72$export$c30f06fc4059f363 || ($2f512219da033f72$export$c30f06fc4059f363 = {}));
var $2f512219da033f72$export$6d47154a1de14240;
(function(JiraGoalStatus) {
    JiraGoalStatus["Archived"] = "ARCHIVED";
    JiraGoalStatus["AtRisk"] = "AT_RISK";
    JiraGoalStatus["Cancelled"] = "CANCELLED";
    JiraGoalStatus["Completed"] = "COMPLETED";
    JiraGoalStatus["Done"] = "DONE";
    JiraGoalStatus["OffTrack"] = "OFF_TRACK";
    JiraGoalStatus["OnTrack"] = "ON_TRACK";
    JiraGoalStatus["Paused"] = "PAUSED";
    JiraGoalStatus["Pending"] = "PENDING";
})($2f512219da033f72$export$6d47154a1de14240 || ($2f512219da033f72$export$6d47154a1de14240 = {}));
var $2f512219da033f72$export$60b5a68a2a59a819;
(function(JiraGrantTypeKeyEnum) {
    /**
   * The anonymous access represents the public access without logging in.
   * It takes no parameter.
   */ JiraGrantTypeKeyEnum["AnonymousAccess"] = "ANONYMOUS_ACCESS";
    /**
   * Any user who has the product access.
   * It takes no parameter.
   */ JiraGrantTypeKeyEnum["AnyLoggedinUserApplicationRole"] = "ANY_LOGGEDIN_USER_APPLICATION_ROLE";
    /**
   * A application role is used to grant a user/group access to the application group.
   * It takes application role as parameter.
   */ JiraGrantTypeKeyEnum["ApplicationRole"] = "APPLICATION_ROLE";
    /**
   * The issue assignee role.
   * It takes platform defined 'assignee' as parameter to represent the issue field value.
   */ JiraGrantTypeKeyEnum["Assignee"] = "ASSIGNEE";
    /**
   * A group is a collection of users who can be given access together.
   * It represents group in the organization's user base.
   * It takes group id as parameter.
   */ JiraGrantTypeKeyEnum["Group"] = "GROUP";
    /**
   * A multi group picker custom field.
   * It takes multi group picker custom field id as parameter.
   */ JiraGrantTypeKeyEnum["MultiGroupPicker"] = "MULTI_GROUP_PICKER";
    /**
   * A multi user picker custom field.
   * It takes multi user picker custom field id as parameter.
   */ JiraGrantTypeKeyEnum["MultiUserPicker"] = "MULTI_USER_PICKER";
    /**
   * The project lead role.
   * It takes no parameter.
   */ JiraGrantTypeKeyEnum["ProjectLead"] = "PROJECT_LEAD";
    /**
   * A role that user/group can play in a project.
   * It takes project role as parameter.
   */ JiraGrantTypeKeyEnum["ProjectRole"] = "PROJECT_ROLE";
    /**
   * The issue reporter role.
   * It takes platform defined 'reporter' as parameter to represent the issue field value.
   */ JiraGrantTypeKeyEnum["Reporter"] = "REPORTER";
    /**
   * The grant type defines what the customers can do from the portal view.
   * It takes no parameter.
   */ JiraGrantTypeKeyEnum["ServiceProjectCustomerPortalAccess"] = "SERVICE_PROJECT_CUSTOMER_PORTAL_ACCESS";
    /**
   * An individual user who can be given the access to work on one or more projects.
   * It takes user account id as parameter.
   */ JiraGrantTypeKeyEnum["User"] = "USER";
})($2f512219da033f72$export$60b5a68a2a59a819 || ($2f512219da033f72$export$60b5a68a2a59a819 = {}));
var $2f512219da033f72$export$ebb3bfffea31943a;
(function(JiraGroupsContext) {
    /** This corresponds to fields that accepts only "Group" entities as RHS value. */ JiraGroupsContext["Group"] = "GROUP";
    /** This corresponds to fields that accepts "User" entities as RHS value. */ JiraGroupsContext["User"] = "USER";
})($2f512219da033f72$export$ebb3bfffea31943a || ($2f512219da033f72$export$ebb3bfffea31943a = {}));
var $2f512219da033f72$export$42ed5df1bdc10783;
(function(JiraHomePageType) {
    /** The Dashboards home page */ JiraHomePageType["Dashboards"] = "DASHBOARDS";
    /** The login redirect page for some anonymous users */ JiraHomePageType["LoginRedirect"] = "LOGIN_REDIRECT";
    /** The Projects directory home page */ JiraHomePageType["ProjectsDirectory"] = "PROJECTS_DIRECTORY";
    /** The Your Work home page */ JiraHomePageType["YourWork"] = "YOUR_WORK";
})($2f512219da033f72$export$42ed5df1bdc10783 || ($2f512219da033f72$export$42ed5df1bdc10783 = {}));
var $2f512219da033f72$export$f1e981f4a82c46b7;
(function(JiraIncidentPriority) {
    JiraIncidentPriority["P1"] = "P1";
    JiraIncidentPriority["P2"] = "P2";
    JiraIncidentPriority["P3"] = "P3";
    JiraIncidentPriority["P4"] = "P4";
    JiraIncidentPriority["P5"] = "P5";
})($2f512219da033f72$export$f1e981f4a82c46b7 || ($2f512219da033f72$export$f1e981f4a82c46b7 = {}));
var $2f512219da033f72$export$c8c1ed3f290ea5bf;
(function(JiraInstallDeploymentsBannerPrecondition) {
    /** The deployments banner is available but no CI/CD provider is sending deployment data. */ JiraInstallDeploymentsBannerPrecondition["DeploymentsEmptyState"] = "DEPLOYMENTS_EMPTY_STATE";
    /** The deployments banner is available but the feature has not been enabled. */ JiraInstallDeploymentsBannerPrecondition["FeatureNotEnabled"] = "FEATURE_NOT_ENABLED";
    /** The deployments banner is not available as the precondition checks have not been satisfied. */ JiraInstallDeploymentsBannerPrecondition["NotAvailable"] = "NOT_AVAILABLE";
})($2f512219da033f72$export$c8c1ed3f290ea5bf || ($2f512219da033f72$export$c8c1ed3f290ea5bf = {}));
var $2f512219da033f72$export$ca26010eaa3c3804;
(function(JiraIssueDeploymentEnvironmentState) {
    /** The deployment was deployed successfully */ JiraIssueDeploymentEnvironmentState["Deployed"] = "DEPLOYED";
    /** The deployment was not deployed successfully */ JiraIssueDeploymentEnvironmentState["NotDeployed"] = "NOT_DEPLOYED";
})($2f512219da033f72$export$ca26010eaa3c3804 || ($2f512219da033f72$export$ca26010eaa3c3804 = {}));
var $2f512219da033f72$export$55363ce84d2e39d7;
(function(JiraIssueExportType) {
    /** Export to CSV with all fields. */ JiraIssueExportType["CsvAllFields"] = "CSV_ALL_FIELDS";
    /** Export to CSV with current visible fields. */ JiraIssueExportType["CsvCurrentFields"] = "CSV_CURRENT_FIELDS";
    /** Export to CSV with BOM, all fields. */ JiraIssueExportType["CsvWithBomAllFields"] = "CSV_WITH_BOM_ALL_FIELDS";
    /** Export to CSV with BOM, current fields. */ JiraIssueExportType["CsvWithBomCurrentFields"] = "CSV_WITH_BOM_CURRENT_FIELDS";
})($2f512219da033f72$export$55363ce84d2e39d7 || ($2f512219da033f72$export$55363ce84d2e39d7 = {}));
var $2f512219da033f72$export$f02f8d5666a4ac9b;
(function(JiraIssueItemLayoutItemLocationRuleType) {
    /** Date items. For example: date or time related fields. */ JiraIssueItemLayoutItemLocationRuleType["Dates"] = "DATES";
    /** Multiline text items. For example: a description field or custom multi-line test fields. */ JiraIssueItemLayoutItemLocationRuleType["MultilineText"] = "MULTILINE_TEXT";
    /** Any other item types not covered by previous item types. */ JiraIssueItemLayoutItemLocationRuleType["Other"] = "OTHER";
    /** People items. For example: user pickers, team pickers or group picker. */ JiraIssueItemLayoutItemLocationRuleType["People"] = "PEOPLE";
    /** Time tracking items. For example: estimate, original estimate or time tracking panels. */ JiraIssueItemLayoutItemLocationRuleType["Timetracking"] = "TIMETRACKING";
})($2f512219da033f72$export$f02f8d5666a4ac9b || ($2f512219da033f72$export$f02f8d5666a4ac9b = {}));
var $2f512219da033f72$export$697c16cbeca9bb08;
(function(JiraIssueItemSystemContainerType) {
    /** The container type for the issue content. */ JiraIssueItemSystemContainerType["Content"] = "CONTENT";
    /** The container type for the issue context. */ JiraIssueItemSystemContainerType["Context"] = "CONTEXT";
    /** The container type for customer context fields in JCS. */ JiraIssueItemSystemContainerType["CustomerContext"] = "CUSTOMER_CONTEXT";
    /** The container type for the issue hidden items. */ JiraIssueItemSystemContainerType["HiddenItems"] = "HIDDEN_ITEMS";
    /** The container type for the issue primary context. */ JiraIssueItemSystemContainerType["Primary"] = "PRIMARY";
    /** The container type for the request in JSM projects. */ JiraIssueItemSystemContainerType["Request"] = "REQUEST";
    /** The container type for the request portal in JSM projects. */ JiraIssueItemSystemContainerType["RequestPortal"] = "REQUEST_PORTAL";
    /** The container type for the issue secondary context. */ JiraIssueItemSystemContainerType["Secondary"] = "SECONDARY";
})($2f512219da033f72$export$697c16cbeca9bb08 || ($2f512219da033f72$export$697c16cbeca9bb08 = {}));
var $2f512219da033f72$export$be9310abc07a1404;
(function(JiraIssueLifecycleState) {
    /** An active issue is present and visible (Default state) */ JiraIssueLifecycleState["Active"] = "ACTIVE";
    /**
   * An archived issue is present but hidden. It can be retrieved
   * back to active state.
   */ JiraIssueLifecycleState["Archived"] = "ARCHIVED";
})($2f512219da033f72$export$be9310abc07a1404 || ($2f512219da033f72$export$be9310abc07a1404 = {}));
var $2f512219da033f72$export$230ec0d260fcf9aa;
(function(JiraIssueLinkDirection) {
    /** Going from the other issue to this issue. */ JiraIssueLinkDirection["Inward"] = "INWARD";
    /** Going from this issue to the other issue. */ JiraIssueLinkDirection["Outward"] = "OUTWARD";
})($2f512219da033f72$export$230ec0d260fcf9aa || ($2f512219da033f72$export$230ec0d260fcf9aa = {}));
var $2f512219da033f72$export$7130dd552fdcdc8d;
(function(JiraIssueModuleType) {
    /** A module that provides a content panel for displaying issue data. */ JiraIssueModuleType["IssueModule"] = "ISSUE_MODULE";
    /** A module that provides a legacy web panel. */ JiraIssueModuleType["WebPanel"] = "WEB_PANEL";
})($2f512219da033f72$export$7130dd552fdcdc8d || ($2f512219da033f72$export$7130dd552fdcdc8d = {}));
var $2f512219da033f72$export$339e1af59c6eefd6;
(function(JiraIssueNavigatorSearchLayout) {
    /** Detailed or aka split-view of issues */ JiraIssueNavigatorSearchLayout["Detail"] = "DETAIL";
    /** List view of issues */ JiraIssueNavigatorSearchLayout["List"] = "LIST";
})($2f512219da033f72$export$339e1af59c6eefd6 || ($2f512219da033f72$export$339e1af59c6eefd6 = {}));
var $2f512219da033f72$export$7ca831dd5735cc4c;
(function(JiraIssueSearchFieldSetSelectedState) {
    /** Both selected and non-selected field config sets. */ JiraIssueSearchFieldSetSelectedState["All"] = "ALL";
    /** Only the field config sets that have not been selected in the current view. */ JiraIssueSearchFieldSetSelectedState["NonSelected"] = "NON_SELECTED";
    /** Only the field config sets selected in the current view. */ JiraIssueSearchFieldSetSelectedState["Selected"] = "SELECTED";
})($2f512219da033f72$export$7ca831dd5735cc4c || ($2f512219da033f72$export$7ca831dd5735cc4c = {}));
var $2f512219da033f72$export$7746b96e4487895e;
(function(JiraIssueSearchOperationScope) {
    JiraIssueSearchOperationScope["NinGlobal"] = "NIN_GLOBAL";
    JiraIssueSearchOperationScope["NinGlobalSchemaRefactor"] = "NIN_GLOBAL_SCHEMA_REFACTOR";
    JiraIssueSearchOperationScope["NinGlobalShadowRequest"] = "NIN_GLOBAL_SHADOW_REQUEST";
    JiraIssueSearchOperationScope["NinProject"] = "NIN_PROJECT";
    JiraIssueSearchOperationScope["NinProjectSchemaRefactor"] = "NIN_PROJECT_SCHEMA_REFACTOR";
    JiraIssueSearchOperationScope["NinProjectShadowRequest"] = "NIN_PROJECT_SHADOW_REQUEST";
})($2f512219da033f72$export$7746b96e4487895e || ($2f512219da033f72$export$7746b96e4487895e = {}));
var $2f512219da033f72$export$2df7420a9bb23332;
(function(JiraIssueTransitionCommentType) {
    /** Comment has to be shared internally with the team */ JiraIssueTransitionCommentType["InternalNote"] = "INTERNAL_NOTE";
    /** Comment has to be shared with the customer */ JiraIssueTransitionCommentType["ReplyToCustomer"] = "REPLY_TO_CUSTOMER";
})($2f512219da033f72$export$2df7420a9bb23332 || ($2f512219da033f72$export$2df7420a9bb23332 = {}));
var $2f512219da033f72$export$dafe05b7c43936e0;
(function(JiraIssueTransitionLayoutMessageType) {
    /** An error message type is sent when there is any error while fetching the screen */ JiraIssueTransitionLayoutMessageType["Error"] = "ERROR";
    /** An info message configured on the transition modal */ JiraIssueTransitionLayoutMessageType["Info"] = "INFO";
    /** A send a success message during modal load */ JiraIssueTransitionLayoutMessageType["Success"] = "SUCCESS";
    /** A warning message that might be configured on the BE or shown based on the screen configuration/field support etc. */ JiraIssueTransitionLayoutMessageType["Warn"] = "WARN";
})($2f512219da033f72$export$dafe05b7c43936e0 || ($2f512219da033f72$export$dafe05b7c43936e0 = {}));
var $2f512219da033f72$export$8aef47d2eef7b927;
(function(JiraIssueViewActivityFeedSortOrder) {
    JiraIssueViewActivityFeedSortOrder["NewestFirst"] = "NEWEST_FIRST";
    JiraIssueViewActivityFeedSortOrder["OldestFirst"] = "OLDEST_FIRST";
})($2f512219da033f72$export$8aef47d2eef7b927 || ($2f512219da033f72$export$8aef47d2eef7b927 = {}));
var $2f512219da033f72$export$15a9db503febb7bb;
(function(JiraIssueViewActivityLayout) {
    JiraIssueViewActivityLayout["Horizontal"] = "HORIZONTAL";
    JiraIssueViewActivityLayout["Vertical"] = "VERTICAL";
})($2f512219da033f72$export$15a9db503febb7bb || ($2f512219da033f72$export$15a9db503febb7bb = {}));
var $2f512219da033f72$export$db6a595e3239346;
(function(JiraIssueViewAttachmentPanelViewMode) {
    JiraIssueViewAttachmentPanelViewMode["ListView"] = "LIST_VIEW";
    JiraIssueViewAttachmentPanelViewMode["StripView"] = "STRIP_VIEW";
})($2f512219da033f72$export$db6a595e3239346 || ($2f512219da033f72$export$db6a595e3239346 = {}));
var $2f512219da033f72$export$c5dd6014d53eac27;
(function(JiraIssueViewTimestampDisplayMode) {
    JiraIssueViewTimestampDisplayMode["Absolute"] = "ABSOLUTE";
    JiraIssueViewTimestampDisplayMode["Relative"] = "RELATIVE";
})($2f512219da033f72$export$c5dd6014d53eac27 || ($2f512219da033f72$export$c5dd6014d53eac27 = {}));
var $2f512219da033f72$export$ab2f34f07eb5e4b6;
(function(JiraIteration) {
    JiraIteration["Iteration_1"] = "ITERATION_1";
    JiraIteration["Iteration_2"] = "ITERATION_2";
    JiraIteration["IterationDynamic"] = "ITERATION_DYNAMIC";
})($2f512219da033f72$export$ab2f34f07eb5e4b6 || ($2f512219da033f72$export$ab2f34f07eb5e4b6 = {}));
var $2f512219da033f72$export$3b5b236cf36c7f9a;
(function(JiraJqlBuilderSearchMode) {
    /** JQL text based builder. */ JiraJqlBuilderSearchMode["Advanced"] = "ADVANCED";
    /** User friendly JQL Builder. */ JiraJqlBuilderSearchMode["Basic"] = "BASIC";
})($2f512219da033f72$export$3b5b236cf36c7f9a || ($2f512219da033f72$export$3b5b236cf36c7f9a = {}));
var $2f512219da033f72$export$37c9dd62a1eeff06;
(function(JiraJourneyParentIssueType) {
    /** Jira issue */ JiraJourneyParentIssueType["Request"] = "REQUEST";
})($2f512219da033f72$export$37c9dd62a1eeff06 || ($2f512219da033f72$export$37c9dd62a1eeff06 = {}));
var $2f512219da033f72$export$46a584c8e068126;
(function(JiraJourneyStatus) {
    /** The journey is archived and can not be triggered or modified */ JiraJourneyStatus["Archived"] = "ARCHIVED";
    /** The journey is disabled and can not be triggered */ JiraJourneyStatus["Disabled"] = "DISABLED";
    /** The journey is in draft status and can not be triggered */ JiraJourneyStatus["Draft"] = "DRAFT";
    /** The journey is enabled and can be triggered */ JiraJourneyStatus["Published"] = "PUBLISHED";
})($2f512219da033f72$export$46a584c8e068126 || ($2f512219da033f72$export$46a584c8e068126 = {}));
var $2f512219da033f72$export$9235a600c4562606;
(function(JiraJourneyStatusDependencyType) {
    JiraJourneyStatusDependencyType["Status"] = "STATUS";
    JiraJourneyStatusDependencyType["StatusCategory"] = "STATUS_CATEGORY";
})($2f512219da033f72$export$9235a600c4562606 || ($2f512219da033f72$export$9235a600c4562606 = {}));
var $2f512219da033f72$export$86049ccf66185dbb;
(function(JiraJourneyTriggerType) {
    /** When a parent issue is created */ JiraJourneyTriggerType["ParentIssueCreated"] = "PARENT_ISSUE_CREATED";
    /** When workday integration is triggered */ JiraJourneyTriggerType["WorkdayIntegrationTriggered"] = "WORKDAY_INTEGRATION_TRIGGERED";
})($2f512219da033f72$export$86049ccf66185dbb || ($2f512219da033f72$export$86049ccf66185dbb = {}));
var $2f512219da033f72$export$fd281481162cf736;
(function(JiraJqlAutocompleteType) {
    /** The Jira basic field JQL autocomplete type. */ JiraJqlAutocompleteType["Basic"] = "BASIC";
    /** The Jira cascadingOption field JQL autocomplete type. */ JiraJqlAutocompleteType["Cascadingoption"] = "CASCADINGOPTION";
    /** The Jira component field JQL autocomplete type. */ JiraJqlAutocompleteType["Component"] = "COMPONENT";
    /** The Jira group field JQL autocomplete type. */ JiraJqlAutocompleteType["Group"] = "GROUP";
    /** The Jira issue field JQL autocomplete type. */ JiraJqlAutocompleteType["Issue"] = "ISSUE";
    /** The Jira issue field type JQL autocomplete type. */ JiraJqlAutocompleteType["Issuetype"] = "ISSUETYPE";
    /** The Jira JWM Category field type JQL autocomplete type. */ JiraJqlAutocompleteType["JwmCategory"] = "JWM_CATEGORY";
    /** The Jira labels field type JQL autocomplete type. */ JiraJqlAutocompleteType["Labels"] = "LABELS";
    /** No autocomplete support. */ JiraJqlAutocompleteType["None"] = "NONE";
    /** The Jira option field type JQL autocomplete type. */ JiraJqlAutocompleteType["Option"] = "OPTION";
    /** The Jira Organization field JQL autocomplete type. */ JiraJqlAutocompleteType["Organization"] = "ORGANIZATION";
    /** The Jira priority field JQL autocomplete type. */ JiraJqlAutocompleteType["Priority"] = "PRIORITY";
    /** The Jira project field JQL autocomplete type. */ JiraJqlAutocompleteType["Project"] = "PROJECT";
    /** The Jira RequestType field JQL autocomplete type. */ JiraJqlAutocompleteType["Requesttype"] = "REQUESTTYPE";
    /** The Jira resolution field JQL autocomplete type. */ JiraJqlAutocompleteType["Resolution"] = "RESOLUTION";
    /** The Jira sprint field JQL autocomplete type. */ JiraJqlAutocompleteType["Sprint"] = "SPRINT";
    /** The Jira status field JQL autocomplete type. */ JiraJqlAutocompleteType["Status"] = "STATUS";
    /** The Jira status category field JQL autocomplete type. */ JiraJqlAutocompleteType["Statuscategory"] = "STATUSCATEGORY";
    /** The Jira TicketCategory field JQL autocomplete type. */ JiraJqlAutocompleteType["TicketCategory"] = "TICKET_CATEGORY";
    /** The Jira user field JQL autocomplete type. */ JiraJqlAutocompleteType["User"] = "USER";
    /** The Jira version field JQL autocomplete type. */ JiraJqlAutocompleteType["Version"] = "VERSION";
})($2f512219da033f72$export$fd281481162cf736 || ($2f512219da033f72$export$fd281481162cf736 = {}));
var $2f512219da033f72$export$4b728896d4330036;
(function(JiraJqlBuilderMode) {
    /**
   * The basic mode, allows queries to be built and executed via the JQL basic editor.
   *
   * This mode allows users to easily construct JQL queries by interacting with the UI.
   */ JiraJqlBuilderMode["Basic"] = "BASIC";
    /**
   * The JQL mode, allows queries to be built and executed via the JQL advanced editor.
   *
   * This mode allows users to manually type and construct complex JQL queries.
   */ JiraJqlBuilderMode["Jql"] = "JQL";
})($2f512219da033f72$export$4b728896d4330036 || ($2f512219da033f72$export$4b728896d4330036 = {}));
var $2f512219da033f72$export$cbea312143ae44f9;
(function(JiraJqlClauseType) {
    /** This denotes both WHERE and ORDER_BY. */ JiraJqlClauseType["Any"] = "ANY";
    /** This corresponds to fields used to sort Jira Issues. */ JiraJqlClauseType["OrderBy"] = "ORDER_BY";
    /** This corresponds to jql fields used as filter criteria of Jira issues. */ JiraJqlClauseType["Where"] = "WHERE";
})($2f512219da033f72$export$cbea312143ae44f9 || ($2f512219da033f72$export$cbea312143ae44f9 = {}));
var $2f512219da033f72$export$c4f30303e8f1794;
(function(JiraJqlFunctionStatus) {
    JiraJqlFunctionStatus["Finished"] = "FINISHED";
    JiraJqlFunctionStatus["Processing"] = "PROCESSING";
    JiraJqlFunctionStatus["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$c4f30303e8f1794 || ($2f512219da033f72$export$c4f30303e8f1794 = {}));
var $2f512219da033f72$export$d3fe59ef06ef4fb4;
(function(JiraJqlOperator) {
    /** The `CHANGED` operator is used to find issues that have a value that had changed for the specified field. */ JiraJqlOperator["Changed"] = "CHANGED";
    /** The `CHANGED` operator is used to find issues that have a value that had changed for the specified field. */ JiraJqlOperator["Contains"] = "CONTAINS";
    /** The `=` operator is used to search for issues where the value of the specified field exactly matches the specified value. */ JiraJqlOperator["Equals"] = "EQUALS";
    /** The `>` operator is used to search for issues where the value of the specified field is greater than the specified value. */ JiraJqlOperator["GreaterThan"] = "GREATER_THAN";
    /** The `>=` operator is used to search for issues where the value of the specified field is greater than or equal to the specified value. */ JiraJqlOperator["GreaterThanOrEqual"] = "GREATER_THAN_OR_EQUAL";
    /** The `IN` operator is used to search for issues where the value of the specified field is one of multiple specified values. */ JiraJqlOperator["In"] = "IN";
    /** The `IS` operator can only be used with EMPTY or NULL. That is, it is used to search for issues where the specified field has no value. */ JiraJqlOperator["Is"] = "IS";
    /** The `IS NOT` operator can only be used with EMPTY or NULL. That is, it is used to search for issues where the specified field has a value. */ JiraJqlOperator["IsNot"] = "IS_NOT";
    /** The `<` operator is used to search for issues where the value of the specified field is less than the specified value. */ JiraJqlOperator["LessThan"] = "LESS_THAN";
    /** The `<=` operator is used to search for issues where the value of the specified field is less than or equal to than the specified value. */ JiraJqlOperator["LessThanOrEqual"] = "LESS_THAN_OR_EQUAL";
    /** The `!~` operator is used to search for issues where the value of the specified field is not a "fuzzy" match for the specified value. */ JiraJqlOperator["NotContains"] = "NOT_CONTAINS";
    /** The `!=` operator is used to search for issues where the value of the specified field does not match the specified value. */ JiraJqlOperator["NotEquals"] = "NOT_EQUALS";
    /** The `NOT IN` operator is used to search for issues where the value of the specified field is not one of multiple specified values. */ JiraJqlOperator["NotIn"] = "NOT_IN";
    /** The `WAS` operator is used to find issues that currently have or previously had the specified value for the specified field. */ JiraJqlOperator["Was"] = "WAS";
    /** The `WAS IN` operator is used to find issues that currently have or previously had any of multiple specified values for the specified field. */ JiraJqlOperator["WasIn"] = "WAS_IN";
    /** The `WAS NOT` operator is used to find issues that have never had the specified value for the specified field. */ JiraJqlOperator["WasNot"] = "WAS_NOT";
    /** The `WAS NOT IN` operator is used to search for issues where the value of the specified field has never been one of multiple specified values. */ JiraJqlOperator["WasNotIn"] = "WAS_NOT_IN";
})($2f512219da033f72$export$d3fe59ef06ef4fb4 || ($2f512219da033f72$export$d3fe59ef06ef4fb4 = {}));
var $2f512219da033f72$export$b4868a7397b1d1a3;
(function(JiraJqlSyntaxError) {
    JiraJqlSyntaxError["BadFieldId"] = "BAD_FIELD_ID";
    JiraJqlSyntaxError["BadFunctionArgument"] = "BAD_FUNCTION_ARGUMENT";
    JiraJqlSyntaxError["BadOperator"] = "BAD_OPERATOR";
    JiraJqlSyntaxError["BadPropertyId"] = "BAD_PROPERTY_ID";
    JiraJqlSyntaxError["EmptyField"] = "EMPTY_FIELD";
    JiraJqlSyntaxError["EmptyFunction"] = "EMPTY_FUNCTION";
    JiraJqlSyntaxError["EmptyFunctionArgument"] = "EMPTY_FUNCTION_ARGUMENT";
    JiraJqlSyntaxError["IllegalCharacter"] = "ILLEGAL_CHARACTER";
    JiraJqlSyntaxError["IllegalEscape"] = "ILLEGAL_ESCAPE";
    JiraJqlSyntaxError["IllegalNumber"] = "ILLEGAL_NUMBER";
    JiraJqlSyntaxError["MissingFieldName"] = "MISSING_FIELD_NAME";
    JiraJqlSyntaxError["MissingLogicalOperator"] = "MISSING_LOGICAL_OPERATOR";
    JiraJqlSyntaxError["NoOperator"] = "NO_OPERATOR";
    JiraJqlSyntaxError["NoOrder"] = "NO_ORDER";
    JiraJqlSyntaxError["OperandUnsupported"] = "OPERAND_UNSUPPORTED";
    JiraJqlSyntaxError["PredicateUnsupported"] = "PREDICATE_UNSUPPORTED";
    JiraJqlSyntaxError["ReservedCharacter"] = "RESERVED_CHARACTER";
    JiraJqlSyntaxError["ReservedWord"] = "RESERVED_WORD";
    JiraJqlSyntaxError["UnexpectedText"] = "UNEXPECTED_TEXT";
    JiraJqlSyntaxError["UnfinishedString"] = "UNFINISHED_STRING";
    JiraJqlSyntaxError["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$b4868a7397b1d1a3 || ($2f512219da033f72$export$b4868a7397b1d1a3 = {}));
var $2f512219da033f72$export$586b6450ae834916;
(function(JiraJqlViewContext) {
    /** This corresponds to fields requested for Jira Product Discovery Roadmaps. */ JiraJqlViewContext["JpdRoadmaps"] = "JPD_ROADMAPS";
    /** This corresponds to fields requested for Jira Software Plans. */ JiraJqlViewContext["JswPlans"] = "JSW_PLANS";
    /** This corresponds to fields requested for Jira Work Management (JWM). */ JiraJqlViewContext["Jwm"] = "JWM";
    /** This corresponds to the shadow request client. */ JiraJqlViewContext["ShadowRequest"] = "SHADOW_REQUEST";
})($2f512219da033f72$export$586b6450ae834916 || ($2f512219da033f72$export$586b6450ae834916 = {}));
var $2f512219da033f72$export$29e67496c83af6d9;
(function(JiraLinkIssuesToIncidentIssueLinkTypeName) {
    JiraLinkIssuesToIncidentIssueLinkTypeName["PostIncidentReviews"] = "POST_INCIDENT_REVIEWS";
    JiraLinkIssuesToIncidentIssueLinkTypeName["Relates"] = "RELATES";
})($2f512219da033f72$export$29e67496c83af6d9 || ($2f512219da033f72$export$29e67496c83af6d9 = {}));
var $2f512219da033f72$export$aad956212e1cffd3;
(function(JiraLongRunningTaskStatus) {
    /** Indicates someone has been successfully cancelled */ JiraLongRunningTaskStatus["Cancelled"] = "CANCELLED";
    /** Indicates someone has requested the task to be cancelled */ JiraLongRunningTaskStatus["CancelRequested"] = "CANCEL_REQUESTED";
    /** Indicates the task has been successfully completed */ JiraLongRunningTaskStatus["Complete"] = "COMPLETE";
    /** Indicates the task has been unresponsive for some time and was marked to be dead */ JiraLongRunningTaskStatus["Dead"] = "DEAD";
    /** Indicates the task has been created and waiting in the queue */ JiraLongRunningTaskStatus["Enqueued"] = "ENQUEUED";
    /** Indicates the task has failed */ JiraLongRunningTaskStatus["Failed"] = "FAILED";
    /** Indicates the task is currently running */ JiraLongRunningTaskStatus["Running"] = "RUNNING";
})($2f512219da033f72$export$aad956212e1cffd3 || ($2f512219da033f72$export$aad956212e1cffd3 = {}));
var $2f512219da033f72$export$283b57df1581f83e;
(function(JiraMultiValueFieldOperations) {
    /** Adds value to multi value field. */ JiraMultiValueFieldOperations["Add"] = "ADD";
    /** Removes value from multi value field. */ JiraMultiValueFieldOperations["Remove"] = "REMOVE";
    /** Overrides multi value field. */ JiraMultiValueFieldOperations["Set"] = "SET";
})($2f512219da033f72$export$283b57df1581f83e || ($2f512219da033f72$export$283b57df1581f83e = {}));
var $2f512219da033f72$export$36f79c8a08b4e752;
(function(JiraNavigationItemTypeKey) {
    JiraNavigationItemTypeKey["App"] = "APP";
    JiraNavigationItemTypeKey["Approvals"] = "APPROVALS";
    /** @deprecated Replaced by APP as each app will have its own navigation item */ JiraNavigationItemTypeKey["Apps"] = "APPS";
    JiraNavigationItemTypeKey["ArchivedIssues"] = "ARCHIVED_ISSUES";
    JiraNavigationItemTypeKey["Attachments"] = "ATTACHMENTS";
    JiraNavigationItemTypeKey["Backlog"] = "BACKLOG";
    JiraNavigationItemTypeKey["Board"] = "BOARD";
    JiraNavigationItemTypeKey["Calendar"] = "CALENDAR";
    JiraNavigationItemTypeKey["Code"] = "CODE";
    JiraNavigationItemTypeKey["Components"] = "COMPONENTS";
    JiraNavigationItemTypeKey["CustomerSupport"] = "CUSTOMER_SUPPORT";
    JiraNavigationItemTypeKey["Dependencies"] = "DEPENDENCIES";
    JiraNavigationItemTypeKey["Deployments"] = "DEPLOYMENTS";
    JiraNavigationItemTypeKey["Development"] = "DEVELOPMENT";
    JiraNavigationItemTypeKey["Forms"] = "FORMS";
    /** @deprecated Get started item was an experiment which has been cleaned up */ JiraNavigationItemTypeKey["GetStarted"] = "GET_STARTED";
    JiraNavigationItemTypeKey["Goals"] = "GOALS";
    JiraNavigationItemTypeKey["Incidents"] = "INCIDENTS";
    JiraNavigationItemTypeKey["Issues"] = "ISSUES";
    JiraNavigationItemTypeKey["List"] = "LIST";
    JiraNavigationItemTypeKey["OnCall"] = "ON_CALL";
    JiraNavigationItemTypeKey["Pages"] = "PAGES";
    JiraNavigationItemTypeKey["PlanCalendar"] = "PLAN_CALENDAR";
    JiraNavigationItemTypeKey["PlanDependencies"] = "PLAN_DEPENDENCIES";
    JiraNavigationItemTypeKey["PlanProgram"] = "PLAN_PROGRAM";
    JiraNavigationItemTypeKey["PlanReleases"] = "PLAN_RELEASES";
    JiraNavigationItemTypeKey["PlanSummary"] = "PLAN_SUMMARY";
    JiraNavigationItemTypeKey["PlanTeams"] = "PLAN_TEAMS";
    JiraNavigationItemTypeKey["PlanTimeline"] = "PLAN_TIMELINE";
    JiraNavigationItemTypeKey["Program"] = "PROGRAM";
    JiraNavigationItemTypeKey["Queue"] = "QUEUE";
    JiraNavigationItemTypeKey["Releases"] = "RELEASES";
    JiraNavigationItemTypeKey["Reports"] = "REPORTS";
    JiraNavigationItemTypeKey["Requests"] = "REQUESTS";
    JiraNavigationItemTypeKey["Security"] = "SECURITY";
    JiraNavigationItemTypeKey["Shortcuts"] = "SHORTCUTS";
    JiraNavigationItemTypeKey["Summary"] = "SUMMARY";
    JiraNavigationItemTypeKey["Teams"] = "TEAMS";
    JiraNavigationItemTypeKey["Timeline"] = "TIMELINE";
})($2f512219da033f72$export$36f79c8a08b4e752 || ($2f512219da033f72$export$36f79c8a08b4e752 = {}));
var $2f512219da033f72$export$b4137b99365f6ad8;
(function(JiraNotificationCategoryType) {
    JiraNotificationCategoryType["CommentChanges"] = "COMMENT_CHANGES";
    JiraNotificationCategoryType["IssueAssigned"] = "ISSUE_ASSIGNED";
    JiraNotificationCategoryType["IssueChanges"] = "ISSUE_CHANGES";
    JiraNotificationCategoryType["IssueMentioned"] = "ISSUE_MENTIONED";
    JiraNotificationCategoryType["IssueMiscellaneous"] = "ISSUE_MISCELLANEOUS";
    JiraNotificationCategoryType["IssueWorklogChanges"] = "ISSUE_WORKLOG_CHANGES";
    JiraNotificationCategoryType["Recurring"] = "RECURRING";
})($2f512219da033f72$export$b4137b99365f6ad8 || ($2f512219da033f72$export$b4137b99365f6ad8 = {}));
var $2f512219da033f72$export$ec1ac0705bb7ee00;
(function(JiraNotificationChannelType) {
    JiraNotificationChannelType["Email"] = "EMAIL";
    JiraNotificationChannelType["InProduct"] = "IN_PRODUCT";
    JiraNotificationChannelType["MobilePush"] = "MOBILE_PUSH";
})($2f512219da033f72$export$ec1ac0705bb7ee00 || ($2f512219da033f72$export$ec1ac0705bb7ee00 = {}));
var $2f512219da033f72$export$6e621da855f29918;
(function(JiraNotificationType) {
    JiraNotificationType["CommentCreated"] = "COMMENT_CREATED";
    JiraNotificationType["CommentDeleted"] = "COMMENT_DELETED";
    JiraNotificationType["CommentEdited"] = "COMMENT_EDITED";
    JiraNotificationType["DailyDueDateNotification"] = "DAILY_DUE_DATE_NOTIFICATION";
    JiraNotificationType["IssueAssigned"] = "ISSUE_ASSIGNED";
    JiraNotificationType["IssueCreated"] = "ISSUE_CREATED";
    JiraNotificationType["IssueDeleted"] = "ISSUE_DELETED";
    JiraNotificationType["IssueMoved"] = "ISSUE_MOVED";
    JiraNotificationType["IssueUpdated"] = "ISSUE_UPDATED";
    JiraNotificationType["MentionsCombined"] = "MENTIONS_COMBINED";
    JiraNotificationType["MiscellaneousIssueEventCombined"] = "MISCELLANEOUS_ISSUE_EVENT_COMBINED";
    JiraNotificationType["WorklogCombined"] = "WORKLOG_COMBINED";
})($2f512219da033f72$export$6e621da855f29918 || ($2f512219da033f72$export$6e621da855f29918 = {}));
var $2f512219da033f72$export$cee8f27c76cb2a11;
(function(JiraOAuthAppsInstallationStatus) {
    JiraOAuthAppsInstallationStatus["Complete"] = "COMPLETE";
    JiraOAuthAppsInstallationStatus["Failed"] = "FAILED";
    /** One of the possible installation statuses: PENDING, RUNNING, COMPLETE, FAILED */ JiraOAuthAppsInstallationStatus["Pending"] = "PENDING";
    JiraOAuthAppsInstallationStatus["Running"] = "RUNNING";
})($2f512219da033f72$export$cee8f27c76cb2a11 || ($2f512219da033f72$export$cee8f27c76cb2a11 = {}));
var $2f512219da033f72$export$59148652a7cacd91;
(function(JiraOrganizationApprovalLocation) {
    /** When the approval is done during the organization installation process */ JiraOrganizationApprovalLocation["DuringInstallationFlow"] = "DURING_INSTALLATION_FLOW";
    /** When the approval is done during the provisioning the tenant */ JiraOrganizationApprovalLocation["DuringProvisioning"] = "DURING_PROVISIONING";
    /** When the approval is done via DVCS page in Jira */ JiraOrganizationApprovalLocation["OnAdminScreen"] = "ON_ADMIN_SCREEN";
    /** When the approval is done during the provisioning the tenant. This should be specific to Bitbucket only. */ JiraOrganizationApprovalLocation["RemindBitbucketApprovalBanner"] = "REMIND_BITBUCKET_APPROVAL_BANNER";
    /** When the approval is done in unknown UI */ JiraOrganizationApprovalLocation["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$59148652a7cacd91 || ($2f512219da033f72$export$59148652a7cacd91 = {}));
var $2f512219da033f72$export$22ca33290808aca8;
(function(JiraOverviewPlanMigrationChangeboardingStatus) {
    /** Indicate that the user has completed the changeboarding flow. */ JiraOverviewPlanMigrationChangeboardingStatus["Completed"] = "COMPLETED";
    /** @deprecated Not used, replaced by COMPLETED status */ JiraOverviewPlanMigrationChangeboardingStatus["Triggered"] = "TRIGGERED";
})($2f512219da033f72$export$22ca33290808aca8 || ($2f512219da033f72$export$22ca33290808aca8 = {}));
var $2f512219da033f72$export$edf2fc589cbdc;
(function(JiraPermissionMessageTypeEnum) {
    /** Represents a basic message. */ JiraPermissionMessageTypeEnum["Information"] = "INFORMATION";
    /** Represents a warning message. */ JiraPermissionMessageTypeEnum["Warning"] = "WARNING";
})($2f512219da033f72$export$edf2fc589cbdc || ($2f512219da033f72$export$edf2fc589cbdc = {}));
var $2f512219da033f72$export$a7ab8f3606c74f1;
(function(JiraPermissionTagEnum) {
    /** Represents a permission that is about to be deprecated. */ JiraPermissionTagEnum["Deprecated"] = "DEPRECATED";
    /** Represents a permission that is only available to enterprise customers. */ JiraPermissionTagEnum["Enterprise"] = "ENTERPRISE";
    /** Represents a permission that is newly added. */ JiraPermissionTagEnum["New"] = "NEW";
})($2f512219da033f72$export$a7ab8f3606c74f1 || ($2f512219da033f72$export$a7ab8f3606c74f1 = {}));
var $2f512219da033f72$export$b91894fc36442fca;
(function(JiraPermissionType) {
    /** user with this permission can browse at least one project */ JiraPermissionType["BrowseProjects"] = "BROWSE_PROJECTS";
    /** user with this permission can modify collections of issues at once */ JiraPermissionType["BulkChange"] = "BULK_CHANGE";
})($2f512219da033f72$export$b91894fc36442fca || ($2f512219da033f72$export$b91894fc36442fca = {}));
var $2f512219da033f72$export$39bfd317df87a9c;
(function(JiraPlanStatus) {
    JiraPlanStatus["Active"] = "ACTIVE";
    JiraPlanStatus["Archived"] = "ARCHIVED";
    JiraPlanStatus["Trashed"] = "TRASHED";
})($2f512219da033f72$export$39bfd317df87a9c || ($2f512219da033f72$export$39bfd317df87a9c = {}));
var $2f512219da033f72$export$c8a2a254afd848c4;
(function(JiraPlaybookIssueFilterType) {
    JiraPlaybookIssueFilterType["Groups"] = "GROUPS";
    JiraPlaybookIssueFilterType["IssueTypes"] = "ISSUE_TYPES";
    JiraPlaybookIssueFilterType["RequestTypes"] = "REQUEST_TYPES";
})($2f512219da033f72$export$c8a2a254afd848c4 || ($2f512219da033f72$export$c8a2a254afd848c4 = {}));
var $2f512219da033f72$export$93707883cedfd4c4;
(function(JiraPlaybookScopeType) {
    JiraPlaybookScopeType["Global"] = "GLOBAL";
    JiraPlaybookScopeType["Project"] = "PROJECT";
    JiraPlaybookScopeType["Team"] = "TEAM";
})($2f512219da033f72$export$93707883cedfd4c4 || ($2f512219da033f72$export$93707883cedfd4c4 = {}));
var $2f512219da033f72$export$e082dde27432ac44;
(function(JiraPlaybookStateField) {
    JiraPlaybookStateField["Disabled"] = "DISABLED";
    JiraPlaybookStateField["Enabled"] = "ENABLED";
})($2f512219da033f72$export$e082dde27432ac44 || ($2f512219da033f72$export$e082dde27432ac44 = {}));
var $2f512219da033f72$export$8baaf82dcf1e93ae;
(function(JiraPlaybookStepRunStatus) {
    JiraPlaybookStepRunStatus["Failed"] = "FAILED";
    JiraPlaybookStepRunStatus["InProgress"] = "IN_PROGRESS";
    JiraPlaybookStepRunStatus["Success"] = "SUCCESS";
})($2f512219da033f72$export$8baaf82dcf1e93ae || ($2f512219da033f72$export$8baaf82dcf1e93ae = {}));
var $2f512219da033f72$export$dc3c70c12aa6338;
(function(JiraPlaybookStepType) {
    JiraPlaybookStepType["AutomationRule"] = "AUTOMATION_RULE";
    JiraPlaybookStepType["InstructionalRule"] = "INSTRUCTIONAL_RULE";
})($2f512219da033f72$export$dc3c70c12aa6338 || ($2f512219da033f72$export$dc3c70c12aa6338 = {}));
var $2f512219da033f72$export$c11c4db88724120c;
(function(JiraPlaybooksSortBy) {
    JiraPlaybooksSortBy["Name"] = "NAME";
})($2f512219da033f72$export$c11c4db88724120c || ($2f512219da033f72$export$c11c4db88724120c = {}));
var $2f512219da033f72$export$62abc5008715ef4b;
(function(JiraProductEnum) {
    JiraProductEnum["JiraProductDiscovery"] = "JIRA_PRODUCT_DISCOVERY";
    JiraProductEnum["JiraServiceManagement"] = "JIRA_SERVICE_MANAGEMENT";
    JiraProductEnum["JiraSoftware"] = "JIRA_SOFTWARE";
    JiraProductEnum["JiraWorkManagement"] = "JIRA_WORK_MANAGEMENT";
})($2f512219da033f72$export$62abc5008715ef4b || ($2f512219da033f72$export$62abc5008715ef4b = {}));
var $2f512219da033f72$export$456e2c6faf3dd3d9;
(function(JiraProjectActionType) {
    /** Assign issues within the project. */ JiraProjectActionType["AssignIssues"] = "ASSIGN_ISSUES";
    /** Create issues within the project and fill out their fields upon creation. */ JiraProjectActionType["CreateIssues"] = "CREATE_ISSUES";
    /** Delete issues within the project. */ JiraProjectActionType["DeleteIssues"] = "DELETE_ISSUES";
    /** Edit issues within the project. */ JiraProjectActionType["EditIssues"] = "EDIT_ISSUES";
    /** Edit project configuration such as edit access, manage people and permissions, configure issue types and their fields, and enable project features. */ JiraProjectActionType["EditProjectConfig"] = "EDIT_PROJECT_CONFIG";
    /** Link issues within the project. */ JiraProjectActionType["LinkIssues"] = "LINK_ISSUES";
    /** Schedule issues within the project. */ JiraProjectActionType["ScheduleIssues"] = "SCHEDULE_ISSUES";
    /** Transition issues within the project. */ JiraProjectActionType["TransitionIssues"] = "TRANSITION_ISSUES";
    /** View issues within the project. */ JiraProjectActionType["ViewIssues"] = "VIEW_ISSUES";
    /** View some set of project configurations such as edit workflows, edit issue layout, or project details. If EditProjectConfig is true this should be too. */ JiraProjectActionType["ViewProjectConfig"] = "VIEW_PROJECT_CONFIG";
})($2f512219da033f72$export$456e2c6faf3dd3d9 || ($2f512219da033f72$export$456e2c6faf3dd3d9 = {}));
var $2f512219da033f72$export$a2f8423691ae525a;
(function(JiraProjectCleanupRecommendationAction) {
    /** This project can be archived. */ JiraProjectCleanupRecommendationAction["Archive"] = "ARCHIVE";
    /** This project can be trashed. */ JiraProjectCleanupRecommendationAction["Trash"] = "TRASH";
})($2f512219da033f72$export$a2f8423691ae525a || ($2f512219da033f72$export$a2f8423691ae525a = {}));
var $2f512219da033f72$export$9c0ded90f678acb6;
(function(JiraProjectCleanupRecommendationStaleSince) {
    JiraProjectCleanupRecommendationStaleSince["OneYear"] = "ONE_YEAR";
    JiraProjectCleanupRecommendationStaleSince["SixMonths"] = "SIX_MONTHS";
    JiraProjectCleanupRecommendationStaleSince["TwoYears"] = "TWO_YEARS";
})($2f512219da033f72$export$9c0ded90f678acb6 || ($2f512219da033f72$export$9c0ded90f678acb6 = {}));
var $2f512219da033f72$export$b2cfde8b20600ddf;
(function(JiraProjectCleanupTaskStatusType) {
    JiraProjectCleanupTaskStatusType["Complete"] = "COMPLETE";
    JiraProjectCleanupTaskStatusType["Error"] = "ERROR";
    JiraProjectCleanupTaskStatusType["InProgress"] = "IN_PROGRESS";
    JiraProjectCleanupTaskStatusType["Pending"] = "PENDING";
    JiraProjectCleanupTaskStatusType["TerminalError"] = "TERMINAL_ERROR";
})($2f512219da033f72$export$b2cfde8b20600ddf || ($2f512219da033f72$export$b2cfde8b20600ddf = {}));
var $2f512219da033f72$export$8e4f09e2e6362630;
(function(JiraProjectDateTimeFormat) {
    /** dd/MMM/yy h:mm a    E.g. 23/May/07 3:55 AM */ JiraProjectDateTimeFormat["CompleteDatetimeFormat"] = "COMPLETE_DATETIME_FORMAT";
    /** EEEE h:mm a     E.g. Wednesday 3:55 AM */ JiraProjectDateTimeFormat["DayFormat"] = "DAY_FORMAT";
    /** dd/MMM/yy   E.g. 23/May/07 */ JiraProjectDateTimeFormat["DayMonthYearFormat"] = "DAY_MONTH_YEAR_FORMAT";
    /** E.g. 2 days ago */ JiraProjectDateTimeFormat["Relative"] = "RELATIVE";
    /** h:mm a  E.g. 3:55 AM */ JiraProjectDateTimeFormat["TimeFormat"] = "TIME_FORMAT";
})($2f512219da033f72$export$8e4f09e2e6362630 || ($2f512219da033f72$export$8e4f09e2e6362630 = {}));
var $2f512219da033f72$export$341e76c920e0710f;
(function(JiraProjectListRightPanelState) {
    /** The project list sidebar is closed. */ JiraProjectListRightPanelState["Closed"] = "CLOSED";
    /** The project list sidebar is open. */ JiraProjectListRightPanelState["Open"] = "OPEN";
})($2f512219da033f72$export$341e76c920e0710f || ($2f512219da033f72$export$341e76c920e0710f = {}));
var $2f512219da033f72$export$6e766e8806e1db62;
(function(JiraProjectNotificationConfigurationState) {
    /** The user has configured notification preferences for this project */ JiraProjectNotificationConfigurationState["Configured"] = "CONFIGURED";
    /** The user has not configured notification preferences for this project. Computed defaults will be returned. */ JiraProjectNotificationConfigurationState["Default"] = "DEFAULT";
})($2f512219da033f72$export$6e766e8806e1db62 || ($2f512219da033f72$export$6e766e8806e1db62 = {}));
var $2f512219da033f72$export$ecfca2e8f1d416c9;
(function(JiraProjectPermissionCategoryEnum) {
    /** Represents one or more permissions to manage issue attacments such as create and delete. */ JiraProjectPermissionCategoryEnum["Attachments"] = "ATTACHMENTS";
    /** Represents one or more permissions to manage issue comments such as add, delete and edit. */ JiraProjectPermissionCategoryEnum["Comments"] = "COMMENTS";
    /** Represents one or more permissions applicable at issue level to manage operations such as create, delete, edit, and transition. */ JiraProjectPermissionCategoryEnum["Issues"] = "ISSUES";
    /** Represents one or more permissions representing default category if not any other existing category. */ JiraProjectPermissionCategoryEnum["Other"] = "OTHER";
    /** Represents one or more permissions applicable at project level such as project administration, view project information, and manage sprints. */ JiraProjectPermissionCategoryEnum["Projects"] = "PROJECTS";
    /** Represents one or more permissions to manage worklogs, time tracking for billing purpose in some cases. */ JiraProjectPermissionCategoryEnum["TimeTracking"] = "TIME_TRACKING";
    /** Represents one or more permissions to manage watchers and voters of an issue. */ JiraProjectPermissionCategoryEnum["VotersAndWatchers"] = "VOTERS_AND_WATCHERS";
})($2f512219da033f72$export$ecfca2e8f1d416c9 || ($2f512219da033f72$export$ecfca2e8f1d416c9 = {}));
var $2f512219da033f72$export$5b73c005b9475dcb;
(function(JiraProjectPermissionType) {
    /** Ability to comment on issues. */ JiraProjectPermissionType["AddComments"] = "ADD_COMMENTS";
    /** Ability to administer a project in Jira. */ JiraProjectPermissionType["AdministerProjects"] = "ADMINISTER_PROJECTS";
    /** Ability to archive issues within a project. */ JiraProjectPermissionType["ArchiveIssues"] = "ARCHIVE_ISSUES";
    /** Users with this permission may be assigned to issues. */ JiraProjectPermissionType["AssignableUser"] = "ASSIGNABLE_USER";
    /** Ability to assign issues to other people. */ JiraProjectPermissionType["AssignIssues"] = "ASSIGN_ISSUES";
    /** Ability to browse projects and the issues within them. */ JiraProjectPermissionType["BrowseProjects"] = "BROWSE_PROJECTS";
    /** Ability to close issues. Often useful where your developers resolve issues, and a QA department closes them. */ JiraProjectPermissionType["CloseIssues"] = "CLOSE_ISSUES";
    /** Users with this permission may create attachments. */ JiraProjectPermissionType["CreateAttachments"] = "CREATE_ATTACHMENTS";
    /** Ability to create issues. */ JiraProjectPermissionType["CreateIssues"] = "CREATE_ISSUES";
    /** Users with this permission may delete all attachments. */ JiraProjectPermissionType["DeleteAllAttachments"] = "DELETE_ALL_ATTACHMENTS";
    /** Ability to delete all comments made on issues. */ JiraProjectPermissionType["DeleteAllComments"] = "DELETE_ALL_COMMENTS";
    /** Ability to delete all worklogs made on issues. */ JiraProjectPermissionType["DeleteAllWorklogs"] = "DELETE_ALL_WORKLOGS";
    /** Ability to delete issues. */ JiraProjectPermissionType["DeleteIssues"] = "DELETE_ISSUES";
    /** Users with this permission may delete own attachments. */ JiraProjectPermissionType["DeleteOwnAttachments"] = "DELETE_OWN_ATTACHMENTS";
    /** Ability to delete own comments made on issues. */ JiraProjectPermissionType["DeleteOwnComments"] = "DELETE_OWN_COMMENTS";
    /** Ability to delete own worklogs made on issues. */ JiraProjectPermissionType["DeleteOwnWorklogs"] = "DELETE_OWN_WORKLOGS";
    /** Ability to edit all comments made on issues. */ JiraProjectPermissionType["EditAllComments"] = "EDIT_ALL_COMMENTS";
    /** Ability to edit all worklogs made on issues. */ JiraProjectPermissionType["EditAllWorklogs"] = "EDIT_ALL_WORKLOGS";
    /** Ability to edit issues. */ JiraProjectPermissionType["EditIssues"] = "EDIT_ISSUES";
    /** Ability to manage issue layout, and add, remove, and search for fields in Jira. */ JiraProjectPermissionType["EditIssueLayout"] = "EDIT_ISSUE_LAYOUT";
    /** Ability to edit own comments made on issues. */ JiraProjectPermissionType["EditOwnComments"] = "EDIT_OWN_COMMENTS";
    /** Ability to edit own worklogs made on issues. */ JiraProjectPermissionType["EditOwnWorklogs"] = "EDIT_OWN_WORKLOGS";
    /** Ability to edit a workflow. */ JiraProjectPermissionType["EditWorkflow"] = "EDIT_WORKFLOW";
    /** Ability to link issues together and create linked issues. Only useful if issue linking is turned on. */ JiraProjectPermissionType["LinkIssues"] = "LINK_ISSUES";
    /** Ability to manage the watchers of an issue. */ JiraProjectPermissionType["ManageWatchers"] = "MANAGE_WATCHERS";
    /** Ability to modify the reporter when creating or editing an issue. */ JiraProjectPermissionType["ModifyReporter"] = "MODIFY_REPORTER";
    /** Ability to move issues between projects or between workflows of the same project (if applicable). Note the user can only move issues to a project they have the create permission for. */ JiraProjectPermissionType["MoveIssues"] = "MOVE_ISSUES";
    /** Ability to resolve and reopen issues. This includes the ability to set a fix version. */ JiraProjectPermissionType["ResolveIssues"] = "RESOLVE_ISSUES";
    /** Ability to view or edit an issue's due date. */ JiraProjectPermissionType["ScheduleIssues"] = "SCHEDULE_ISSUES";
    /** Ability to set the level of security on an issue so that only people in that security level can see the issue. */ JiraProjectPermissionType["SetIssueSecurity"] = "SET_ISSUE_SECURITY";
    /** Ability to transition issues. */ JiraProjectPermissionType["TransitionIssues"] = "TRANSITION_ISSUES";
    /** Ability to unarchive issues within a project. */ JiraProjectPermissionType["UnarchiveIssues"] = "UNARCHIVE_ISSUES";
    /** Allows users in a software project to view development-related information on the issue, such as commits, reviews and build information. */ JiraProjectPermissionType["ViewDevTools"] = "VIEW_DEV_TOOLS";
    /** Users with this permission may view a read-only version of a workflow. */ JiraProjectPermissionType["ViewReadonlyWorkflow"] = "VIEW_READONLY_WORKFLOW";
    /** Ability to view the voters and watchers of an issue. */ JiraProjectPermissionType["ViewVotersAndWatchers"] = "VIEW_VOTERS_AND_WATCHERS";
    /** Ability to log work done against an issue. Only useful if Time Tracking is turned on. */ JiraProjectPermissionType["WorkOnIssues"] = "WORK_ON_ISSUES";
})($2f512219da033f72$export$5b73c005b9475dcb || ($2f512219da033f72$export$5b73c005b9475dcb = {}));
var $2f512219da033f72$export$efb7762c97861711;
(function(JiraProjectRoleActorRecommendationAction) {
    /** This project role actor can be trashed. */ JiraProjectRoleActorRecommendationAction["Trash"] = "TRASH";
})($2f512219da033f72$export$efb7762c97861711 || ($2f512219da033f72$export$efb7762c97861711 = {}));
var $2f512219da033f72$export$b44a05ea54d6beba;
(function(JiraProjectRoleActorUserStatus) {
    /** The user associated with this project role actor is deleted. */ JiraProjectRoleActorUserStatus["Deleted"] = "DELETED";
    /** The user associated with this project role actor is not active. */ JiraProjectRoleActorUserStatus["Inactive"] = "INACTIVE";
})($2f512219da033f72$export$b44a05ea54d6beba || ($2f512219da033f72$export$b44a05ea54d6beba = {}));
var $2f512219da033f72$export$15a3b3ba6d4cada1;
(function(JiraProjectShortcutType) {
    /** A shortcut which links to a repository */ JiraProjectShortcutType["Repository"] = "REPOSITORY";
    /** The basic shortcut link */ JiraProjectShortcutType["ShortcutLink"] = "SHORTCUT_LINK";
    /** When an unexpected shortcut type is encountered which is not yet supported */ JiraProjectShortcutType["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$15a3b3ba6d4cada1 || ($2f512219da033f72$export$15a3b3ba6d4cada1 = {}));
var $2f512219da033f72$export$f4b615b47854d356;
(function(JiraProjectSortField) {
    /** sorts by category */ JiraProjectSortField["Category"] = "CATEGORY";
    /** sorts by favourite value of the project */ JiraProjectSortField["Favourite"] = "FAVOURITE";
    /** sorts by project key */ JiraProjectSortField["Key"] = "KEY";
    /** sorts by the time of the last updated issue in the project */ JiraProjectSortField["LastIssueUpdatedTime"] = "LAST_ISSUE_UPDATED_TIME";
    /** sorts by lead */ JiraProjectSortField["Lead"] = "LEAD";
    /** sorts by project name */ JiraProjectSortField["Name"] = "NAME";
})($2f512219da033f72$export$f4b615b47854d356 || ($2f512219da033f72$export$f4b615b47854d356 = {}));
var $2f512219da033f72$export$f24d023940410bd2;
(function(JiraProjectStatus) {
    /** An active project. */ JiraProjectStatus["Active"] = "ACTIVE";
    /** An archived project. */ JiraProjectStatus["Archived"] = "ARCHIVED";
    /** A deleted project. */ JiraProjectStatus["Deleted"] = "DELETED";
})($2f512219da033f72$export$f24d023940410bd2 || ($2f512219da033f72$export$f24d023940410bd2 = {}));
var $2f512219da033f72$export$7108cef8ee0b9c1d;
(function(JiraProjectStyle) {
    /** A company-managed project. */ JiraProjectStyle["CompanyManagedProject"] = "COMPANY_MANAGED_PROJECT";
    /** A team-managed project. */ JiraProjectStyle["TeamManagedProject"] = "TEAM_MANAGED_PROJECT";
})($2f512219da033f72$export$7108cef8ee0b9c1d || ($2f512219da033f72$export$7108cef8ee0b9c1d = {}));
var $2f512219da033f72$export$af05362339233870;
(function(JiraProjectType) {
    /** A business project. */ JiraProjectType["Business"] = "BUSINESS";
    /** A customer service project. */ JiraProjectType["CustomerService"] = "CUSTOMER_SERVICE";
    /** A product discovery project. */ JiraProjectType["ProductDiscovery"] = "PRODUCT_DISCOVERY";
    /** A service desk project. */ JiraProjectType["ServiceDesk"] = "SERVICE_DESK";
    /** A software project. */ JiraProjectType["Software"] = "SOFTWARE";
})($2f512219da033f72$export$af05362339233870 || ($2f512219da033f72$export$af05362339233870 = {}));
var $2f512219da033f72$export$a8cdf7bc23c30cb9;
(function(JiraProjectsHelpCenterMappingStatus) {
    JiraProjectsHelpCenterMappingStatus["All"] = "ALL";
    JiraProjectsHelpCenterMappingStatus["Linked"] = "LINKED";
    JiraProjectsHelpCenterMappingStatus["Unlinked"] = "UNLINKED";
})($2f512219da033f72$export$a8cdf7bc23c30cb9 || ($2f512219da033f72$export$a8cdf7bc23c30cb9 = {}));
var $2f512219da033f72$export$e4cb38caa605881;
(function(JiraPullRequestState) {
    /** Pull Request is Declined */ JiraPullRequestState["Declined"] = "DECLINED";
    /** Pull Request is Draft */ JiraPullRequestState["Draft"] = "DRAFT";
    /** Pull Request is Merged */ JiraPullRequestState["Merged"] = "MERGED";
    /** Pull Request is Open */ JiraPullRequestState["Open"] = "OPEN";
})($2f512219da033f72$export$e4cb38caa605881 || ($2f512219da033f72$export$e4cb38caa605881 = {}));
var $2f512219da033f72$export$ba97d7c27eb56d75;
(function(JiraRankMutationEdge) {
    JiraRankMutationEdge["Bottom"] = "BOTTOM";
    JiraRankMutationEdge["Top"] = "TOP";
})($2f512219da033f72$export$ba97d7c27eb56d75 || ($2f512219da033f72$export$ba97d7c27eb56d75 = {}));
var $2f512219da033f72$export$8b4c07c95d919811;
(function(JiraRecommendationCategory) {
    /** Recommendation to delete a custom field */ JiraRecommendationCategory["CustomField"] = "CUSTOM_FIELD";
    /** Recommendation to archive issues */ JiraRecommendationCategory["IssueArchival"] = "ISSUE_ARCHIVAL";
    /** Recommendation to clean (archive or trash) the project */ JiraRecommendationCategory["ProjectCleanup"] = "PROJECT_CLEANUP";
    /** Recommendation to delete a project role actor */ JiraRecommendationCategory["ProjectRoleActor"] = "PROJECT_ROLE_ACTOR";
})($2f512219da033f72$export$8b4c07c95d919811 || ($2f512219da033f72$export$8b4c07c95d919811 = {}));
var $2f512219da033f72$export$8c291667cbff5f2e;
(function(JiraRedactionSortField) {
    /** Sort by redaction created time */ JiraRedactionSortField["Created"] = "CREATED";
    /** Sort by field name */ JiraRedactionSortField["Field"] = "FIELD";
    /** Sort by redaction reason */ JiraRedactionSortField["Reason"] = "REASON";
    /** Sort by redacted by user */ JiraRedactionSortField["RedactedBy"] = "REDACTED_BY";
    /** Sort by redaction updated time */ JiraRedactionSortField["Updated"] = "UPDATED";
})($2f512219da033f72$export$8c291667cbff5f2e || ($2f512219da033f72$export$8c291667cbff5f2e = {}));
var $2f512219da033f72$export$88911ff8dc5ac51b;
(function(JiraReleaseNotesIssueKeyConfig) {
    /** Include issue keys in the generated release notes as hyperlinks to their respective issue view */ JiraReleaseNotesIssueKeyConfig["Linked"] = "LINKED";
    /** Exclude issue keys from the generated release notes */ JiraReleaseNotesIssueKeyConfig["None"] = "NONE";
    /** Include issue keys in the generated release notes as plain text */ JiraReleaseNotesIssueKeyConfig["Unlinked"] = "UNLINKED";
})($2f512219da033f72$export$88911ff8dc5ac51b || ($2f512219da033f72$export$88911ff8dc5ac51b = {}));
var $2f512219da033f72$export$bb6f763ecaab7945;
(function(JiraReleasesEpicReleaseStatusFilter) {
    /** Only epics that have been released (to any environment) will be included in the results. */ JiraReleasesEpicReleaseStatusFilter["Released"] = "RELEASED";
    /**
   * Epics that have been released will be returned first, followed by epics that haven't
   * yet been released.
   */ JiraReleasesEpicReleaseStatusFilter["ReleasedAndUnreleased"] = "RELEASED_AND_UNRELEASED";
})($2f512219da033f72$export$bb6f763ecaab7945 || ($2f512219da033f72$export$bb6f763ecaab7945 = {}));
var $2f512219da033f72$export$fe2e4a5cf13d7781;
(function(JiraReleasesIssueReleaseStatusFilter) {
    /** Only issues that have been released (to any environment) will be included in the results. */ JiraReleasesIssueReleaseStatusFilter["Released"] = "RELEASED";
    /**
   * Issues that have been released will be returned first, followed by issues that haven't
   * yet been released.
   */ JiraReleasesIssueReleaseStatusFilter["ReleasedAndUnreleased"] = "RELEASED_AND_UNRELEASED";
    /** Only issues that have *not* been released (to any environment) will be included in the results. */ JiraReleasesIssueReleaseStatusFilter["Unreleased"] = "UNRELEASED";
})($2f512219da033f72$export$fe2e4a5cf13d7781 || ($2f512219da033f72$export$fe2e4a5cf13d7781 = {}));
var $2f512219da033f72$export$8bb30df22fb75daf;
(function(JiraReorderBoardViewColumnPosition) {
    JiraReorderBoardViewColumnPosition["After"] = "AFTER";
    JiraReorderBoardViewColumnPosition["Before"] = "BEFORE";
})($2f512219da033f72$export$8bb30df22fb75daf || ($2f512219da033f72$export$8bb30df22fb75daf = {}));
var $2f512219da033f72$export$d0483c6fd1bb3a85;
(function(JiraResourceUsageCustomFieldRecommendationAction) {
    /** This custom field can be trashed. */ JiraResourceUsageCustomFieldRecommendationAction["Trash"] = "TRASH";
})($2f512219da033f72$export$d0483c6fd1bb3a85 || ($2f512219da033f72$export$d0483c6fd1bb3a85 = {}));
var $2f512219da033f72$export$6b943f296ac5a6bd;
(function(JiraResourceUsageRecommendationStatus) {
    /** The recommendation has been archived */ JiraResourceUsageRecommendationStatus["Archived"] = "ARCHIVED";
    /** The recommendation has been executed */ JiraResourceUsageRecommendationStatus["Executed"] = "EXECUTED";
    /** The recommendation has been created, user hasn't been notified about it or acted on it */ JiraResourceUsageRecommendationStatus["New"] = "NEW";
    /** The recommendation is not relevant anymore */ JiraResourceUsageRecommendationStatus["Obsolete"] = "OBSOLETE";
    /** The recommendation has been trashed */ JiraResourceUsageRecommendationStatus["Trashed"] = "TRASHED";
})($2f512219da033f72$export$6b943f296ac5a6bd || ($2f512219da033f72$export$6b943f296ac5a6bd = {}));
var $2f512219da033f72$export$daac6ca3443a8579;
(function(JiraReviewState) {
    /** Review is in Require Approval state */ JiraReviewState["Approval"] = "APPROVAL";
    /** Review has been closed */ JiraReviewState["Closed"] = "CLOSED";
    /** Review is in Dead state */ JiraReviewState["Dead"] = "DEAD";
    /** Review is in Draft state */ JiraReviewState["Draft"] = "DRAFT";
    /** Review has been rejected */ JiraReviewState["Rejected"] = "REJECTED";
    /** Review is in Review state */ JiraReviewState["Review"] = "REVIEW";
    /** Review is in Summarize state */ JiraReviewState["Summarize"] = "SUMMARIZE";
    /** Review state is unknown */ JiraReviewState["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$daac6ca3443a8579 || ($2f512219da033f72$export$daac6ca3443a8579 = {}));
var $2f512219da033f72$export$ac4d9d3c50ca05e6;
(function(JiraScenarioType) {
    JiraScenarioType["Added"] = "ADDED";
    JiraScenarioType["Deleted"] = "DELETED";
    JiraScenarioType["Deletedfromjira"] = "DELETEDFROMJIRA";
    JiraScenarioType["Updated"] = "UPDATED";
})($2f512219da033f72$export$ac4d9d3c50ca05e6 || ($2f512219da033f72$export$ac4d9d3c50ca05e6 = {}));
var $2f512219da033f72$export$fd023c605588471d;
(function(JiraSearchableEntityType) {
    /** A searchable board item. */ JiraSearchableEntityType["Board"] = "BOARD";
    /** A searchable dashboard item. */ JiraSearchableEntityType["Dashboard"] = "DASHBOARD";
    /** A searchable filter item. */ JiraSearchableEntityType["Filter"] = "FILTER";
    /** An searchable issue item. */ JiraSearchableEntityType["Issue"] = "ISSUE";
    /** A searchable plan item. */ JiraSearchableEntityType["Plan"] = "PLAN";
    /** A searchable project item. */ JiraSearchableEntityType["Project"] = "PROJECT";
    /** A searchable queue item. */ JiraSearchableEntityType["Queue"] = "QUEUE";
})($2f512219da033f72$export$fd023c605588471d || ($2f512219da033f72$export$fd023c605588471d = {}));
var $2f512219da033f72$export$40c351d91e581267;
(function(JiraServiceManagementApprovalDecisionResponseType) {
    /** Indicates that the decision is approved by the approver. */ JiraServiceManagementApprovalDecisionResponseType["Approved"] = "approved";
    /** Indicates that the decision is declined by the approver. */ JiraServiceManagementApprovalDecisionResponseType["Declined"] = "declined";
    /** Indicates that the decision is pending by the approver. */ JiraServiceManagementApprovalDecisionResponseType["Pending"] = "pending";
})($2f512219da033f72$export$40c351d91e581267 || ($2f512219da033f72$export$40c351d91e581267 = {}));
var $2f512219da033f72$export$f2800242314330d1;
(function(JiraServiceManagementApprovalState) {
    /** Indicates that approval can not be completed due to lack of approvers. */ JiraServiceManagementApprovalState["InsufficientApprovers"] = "INSUFFICIENT_APPROVERS";
    /** Indicates that approval has sufficient user to complete. */ JiraServiceManagementApprovalState["Ok"] = "OK";
})($2f512219da033f72$export$f2800242314330d1 || ($2f512219da033f72$export$f2800242314330d1 = {}));
var $2f512219da033f72$export$9c65915394dd59bf;
(function(JiraServiceManagementCommentVisibility) {
    /** This comment will only appear in JIRA's issue view. Also called private. */ JiraServiceManagementCommentVisibility["Internal"] = "INTERNAL";
    /** This comment will appear in the portal, visible to all customers. Also called public. */ JiraServiceManagementCommentVisibility["VisibleToHelpseeker"] = "VISIBLE_TO_HELPSEEKER";
})($2f512219da033f72$export$9c65915394dd59bf || ($2f512219da033f72$export$9c65915394dd59bf = {}));
var $2f512219da033f72$export$bd4a236d84b2f605;
(function(JiraServiceManagementCreateRequestTypeFromTemplateRequestFormInputType) {
    /** This means the reference of the proforma form template will be sent as input. */ JiraServiceManagementCreateRequestTypeFromTemplateRequestFormInputType["FormTemplateReference"] = "FORM_TEMPLATE_REFERENCE";
    /** This means the reference of the jira request type template will be sent as input. */ JiraServiceManagementCreateRequestTypeFromTemplateRequestFormInputType["RequestTypeTemplateReference"] = "REQUEST_TYPE_TEMPLATE_REFERENCE";
})($2f512219da033f72$export$bd4a236d84b2f605 || ($2f512219da033f72$export$bd4a236d84b2f605 = {}));
var $2f512219da033f72$export$f35e6061c0db2138;
(function(JiraServiceManagementCreateRequestTypeFromTemplateWorkflowAction) {
    /** This mean workflow will be shared with going to created request type. */ JiraServiceManagementCreateRequestTypeFromTemplateWorkflowAction["Share"] = "SHARE";
})($2f512219da033f72$export$f35e6061c0db2138 || ($2f512219da033f72$export$f35e6061c0db2138 = {}));
var $2f512219da033f72$export$bfa88ab509b645e1;
(function(JiraServiceManagementCreateRequestTypeFromTemplateWorkflowInputType) {
    /** This mean use workflow that associated with given issue type */ JiraServiceManagementCreateRequestTypeFromTemplateWorkflowInputType["ReferenceThroughIssueType"] = "REFERENCE_THROUGH_ISSUE_TYPE";
})($2f512219da033f72$export$bfa88ab509b645e1 || ($2f512219da033f72$export$bfa88ab509b645e1 = {}));
var $2f512219da033f72$export$ddab2c249424d3a2;
(function(JiraServiceManagementMajorIncident) {
    JiraServiceManagementMajorIncident["MajorIncident"] = "MAJOR_INCIDENT";
})($2f512219da033f72$export$ddab2c249424d3a2 || ($2f512219da033f72$export$ddab2c249424d3a2 = {}));
var $2f512219da033f72$export$e93d85fe60017d05;
(function(JiraServiceManagementPractice) {
    /** Empower the IT operations teams with richer contextual information around changes from software development tools so they can make better decisions and minimize risk. */ JiraServiceManagementPractice["ChangeManagement"] = "CHANGE_MANAGEMENT";
    /** Provide customer support teams with the tools they need to escalate requests to software development teams. */ JiraServiceManagementPractice["DeveloperEscalation"] = "DEVELOPER_ESCALATION";
    /** Bring the development and IT operations teams together to rapidly respond to, resolve, and continuously learn from incidents. */ JiraServiceManagementPractice["IncidentManagement"] = "INCIDENT_MANAGEMENT";
    /** Bring people and teams together to discuss the details of an incident: why it happened, what impact it had, what actions were taken to resolve it, and how the team can prevent it from happening again. */ JiraServiceManagementPractice["PostIncidentReview"] = "POST_INCIDENT_REVIEW";
    /** Group incidents to problems, fast-track root cause analysis, and record workarounds to minimize the impact of incidents. */ JiraServiceManagementPractice["ProblemManagement"] = "PROBLEM_MANAGEMENT";
    /** Manage work across teams with one platform so the employees and customers quickly get the help they need. */ JiraServiceManagementPractice["ServiceRequest"] = "SERVICE_REQUEST";
})($2f512219da033f72$export$e93d85fe60017d05 || ($2f512219da033f72$export$e93d85fe60017d05 = {}));
var $2f512219da033f72$export$3292ab1fe1c3cdee;
(function(JiraServiceManagementRendererType) {
    JiraServiceManagementRendererType["AtlassianWikiRendererType"] = "ATLASSIAN_WIKI_RENDERER_TYPE";
    JiraServiceManagementRendererType["JiraTextRendererType"] = "JIRA_TEXT_RENDERER_TYPE";
})($2f512219da033f72$export$3292ab1fe1c3cdee || ($2f512219da033f72$export$3292ab1fe1c3cdee = {}));
var $2f512219da033f72$export$203e282493cf612c;
(function(JiraServiceManagementRequestTypeCategoryRestriction) {
    JiraServiceManagementRequestTypeCategoryRestriction["Open"] = "OPEN";
    JiraServiceManagementRequestTypeCategoryRestriction["Restricted"] = "RESTRICTED";
})($2f512219da033f72$export$203e282493cf612c || ($2f512219da033f72$export$203e282493cf612c = {}));
var $2f512219da033f72$export$bf755de3ce9cd79c;
(function(JiraServiceManagementRequestTypeCategoryStatus) {
    JiraServiceManagementRequestTypeCategoryStatus["Active"] = "ACTIVE";
    JiraServiceManagementRequestTypeCategoryStatus["Draft"] = "DRAFT";
    JiraServiceManagementRequestTypeCategoryStatus["Inactive"] = "INACTIVE";
})($2f512219da033f72$export$bf755de3ce9cd79c || ($2f512219da033f72$export$bf755de3ce9cd79c = {}));
var $2f512219da033f72$export$34d7d8d807e96acf;
(function(JiraShareableEntityGrant) {
    /** The anonymous access represents the public access without logging in. */ JiraShareableEntityGrant["AnonymousAccess"] = "ANONYMOUS_ACCESS";
    /** Any user who has the product access. */ JiraShareableEntityGrant["AnyLoggedinUserApplicationRole"] = "ANY_LOGGEDIN_USER_APPLICATION_ROLE";
    /**
   * A group is a collection of users who can be given access together.
   * It represents group in the organization's user base.
   */ JiraShareableEntityGrant["Group"] = "GROUP";
    /** A project or a role that user can play in a project. */ JiraShareableEntityGrant["Project"] = "PROJECT";
    /** A project or a role that user can play in a project. */ JiraShareableEntityGrant["ProjectRole"] = "PROJECT_ROLE";
    /**
   * Indicates that the user does not have access to the project
   * the members of which have been granted permission.
   */ JiraShareableEntityGrant["ProjectUnknown"] = "PROJECT_UNKNOWN";
    /** An individual user who can be given the access to work on one or more projects. */ JiraShareableEntityGrant["User"] = "USER";
})($2f512219da033f72$export$34d7d8d807e96acf || ($2f512219da033f72$export$34d7d8d807e96acf = {}));
var $2f512219da033f72$export$1b2fa9bebfb7075c;
(function(JiraSidebarMenuDisplayMode) {
    JiraSidebarMenuDisplayMode["MostRecentOnly"] = "MOST_RECENT_ONLY";
    JiraSidebarMenuDisplayMode["Starred"] = "STARRED";
    JiraSidebarMenuDisplayMode["StarredAndRecent"] = "STARRED_AND_RECENT";
})($2f512219da033f72$export$1b2fa9bebfb7075c || ($2f512219da033f72$export$1b2fa9bebfb7075c = {}));
var $2f512219da033f72$export$1f76696f6d16d0a3;
(function(JiraSingleValueFieldOperations) {
    /** Overrides single value field. */ JiraSingleValueFieldOperations["Set"] = "SET";
})($2f512219da033f72$export$1f76696f6d16d0a3 || ($2f512219da033f72$export$1f76696f6d16d0a3 = {}));
var $2f512219da033f72$export$8da1ba7785d00ed1;
(function(JiraSoftwareIssueSearchCustomInputContext) {
    /** Search is constrained to issues visible on backlogs */ JiraSoftwareIssueSearchCustomInputContext["Backlog"] = "BACKLOG";
    /** Search is constrained to issues visible on boards */ JiraSoftwareIssueSearchCustomInputContext["Board"] = "BOARD";
    /** No additional visibility constraints are applied to the search */ JiraSoftwareIssueSearchCustomInputContext["None"] = "NONE";
})($2f512219da033f72$export$8da1ba7785d00ed1 || ($2f512219da033f72$export$8da1ba7785d00ed1 = {}));
var $2f512219da033f72$export$4b13eb4595f55ffa;
(function(JiraSprintState) {
    /** The sprint is in progress. */ JiraSprintState["Active"] = "ACTIVE";
    /** The sprint has been completed. */ JiraSprintState["Closed"] = "CLOSED";
    /** The sprint hasn't been started yet. */ JiraSprintState["Future"] = "FUTURE";
})($2f512219da033f72$export$4b13eb4595f55ffa || ($2f512219da033f72$export$4b13eb4595f55ffa = {}));
var $2f512219da033f72$export$539cfae207f2a8d6;
(function(JiraStatusCategoryColor) {
    /** #4a6785 */ JiraStatusCategoryColor["BlueGray"] = "BLUE_GRAY";
    /** #815b3a */ JiraStatusCategoryColor["Brown"] = "BROWN";
    /** #14892c */ JiraStatusCategoryColor["Green"] = "GREEN";
    /** #707070 */ JiraStatusCategoryColor["MediumGray"] = "MEDIUM_GRAY";
    /** #d04437 */ JiraStatusCategoryColor["WarmRed"] = "WARM_RED";
    /** #f6c342 */ JiraStatusCategoryColor["Yellow"] = "YELLOW";
})($2f512219da033f72$export$539cfae207f2a8d6 || ($2f512219da033f72$export$539cfae207f2a8d6 = {}));
var $2f512219da033f72$export$f61057e011c8c809;
(function(JiraSuggestedChildIssueStatusType) {
    /** The feature has completed its work and the stream is finished */ JiraSuggestedChildIssueStatusType["Complete"] = "COMPLETE";
    /** The service is refining suggested issues based on the user's additional context prompt */ JiraSuggestedChildIssueStatusType["RefiningSuggestedIssues"] = "REFINING_SUGGESTED_ISSUES";
    /** The service is reformatting the suggested issues to the standard format for their issue type */ JiraSuggestedChildIssueStatusType["ReformattingIssues"] = "REFORMATTING_ISSUES";
    /**
   * The service is removing issues that are semantically similar to existing child issues or issues provided in
   * excludeSimilarIssues argument
   */ JiraSuggestedChildIssueStatusType["RemovingDuplicateIssues"] = "REMOVING_DUPLICATE_ISSUES";
    /** The service is retrieving context for the source issue from the DB */ JiraSuggestedChildIssueStatusType["RetrievingSourceContext"] = "RETRIEVING_SOURCE_CONTEXT";
    /** The service is generating suggestions for child issues based on the source issue context */ JiraSuggestedChildIssueStatusType["SuggestingInitialIssues"] = "SUGGESTING_INITIAL_ISSUES";
})($2f512219da033f72$export$f61057e011c8c809 || ($2f512219da033f72$export$f61057e011c8c809 = {}));
var $2f512219da033f72$export$f7abe62a0ee830d;
(function(JiraSuggestedIssueErrorType) {
    /** There are communication problems with downstream services used by the feature. */ JiraSuggestedIssueErrorType["CommunicationsError"] = "COMMUNICATIONS_ERROR";
    /** The source issue did not contain enough information to suggest any quality child issues */ JiraSuggestedIssueErrorType["NotEnoughInformation"] = "NOT_ENOUGH_INFORMATION";
    /**
   * All quality child issues have already been suggested by the issues.  Generally this indicates that all viable child
   * issues have already been added to the issue
   */ JiraSuggestedIssueErrorType["NoFurtherSuggestions"] = "NO_FURTHER_SUGGESTIONS";
    /** A general catch all for other types of errors encountered while suggesting child issues. */ JiraSuggestedIssueErrorType["Unclassified"] = "UNCLASSIFIED";
    /** The feature has deemed the content in the source issue to be unethical and will not suggest child issues. */ JiraSuggestedIssueErrorType["UnethicalContent"] = "UNETHICAL_CONTENT";
})($2f512219da033f72$export$f7abe62a0ee830d || ($2f512219da033f72$export$f7abe62a0ee830d = {}));
var $2f512219da033f72$export$6edac7c7d2e8c8c9;
(function(JiraSuggestedIssueFieldValueError) {
    /** We don't support issue which has required field yet */ JiraSuggestedIssueFieldValueError["HaveRequiredField"] = "HAVE_REQUIRED_FIELD";
    /** We don't support issue which is sub-task */ JiraSuggestedIssueFieldValueError["IsSubTask"] = "IS_SUB_TASK";
    /** The LLM responded that it does not have enough information to suggest any issues */ JiraSuggestedIssueFieldValueError["NotEnoughInformation"] = "NOT_ENOUGH_INFORMATION";
    /**
   * The LLM response that it has no further suggestions, generally this indicates that all viable child issues
   * have already been added to the issue
   */ JiraSuggestedIssueFieldValueError["NoFurtherSuggestions"] = "NO_FURTHER_SUGGESTIONS";
    /** We don't support suggestion if feature is not enabled (ie not opt-in to ai, etc) */ JiraSuggestedIssueFieldValueError["SuggestionIsNotEnabled"] = "SUGGESTION_IS_NOT_ENABLED";
    /**
   * A general catch all for other types of errors. This will not be generated by the LLM, but used for invalid LLM
   * responses
   */ JiraSuggestedIssueFieldValueError["Unclassified"] = "UNCLASSIFIED";
})($2f512219da033f72$export$6edac7c7d2e8c8c9 || ($2f512219da033f72$export$6edac7c7d2e8c8c9 = {}));
var $2f512219da033f72$export$313379dae40e4305;
(function(JiraSyntheticFieldCardOptionType) {
    JiraSyntheticFieldCardOptionType["CardCover"] = "CARD_COVER";
    JiraSyntheticFieldCardOptionType["Pages"] = "PAGES";
})($2f512219da033f72$export$313379dae40e4305 || ($2f512219da033f72$export$313379dae40e4305 = {}));
var $2f512219da033f72$export$edaa045cf8e612c1;
(function(JiraTimeFormat) {
    /** E.g. 2d 4.5h */ JiraTimeFormat["Days"] = "DAYS";
    /** E.g. 52.5h */ JiraTimeFormat["Hours"] = "HOURS";
    /** E.g. 2 days, 4 hours, 30 minutes */ JiraTimeFormat["Pretty"] = "PRETTY";
})($2f512219da033f72$export$edaa045cf8e612c1 || ($2f512219da033f72$export$edaa045cf8e612c1 = {}));
var $2f512219da033f72$export$98bcea6c013bc229;
(function(JiraTimeUnit) {
    /** When the current duration is in days. */ JiraTimeUnit["Day"] = "DAY";
    /** When the current duration is in hours. */ JiraTimeUnit["Hour"] = "HOUR";
    /** When the current duration is in minutes. */ JiraTimeUnit["Minute"] = "MINUTE";
    /** When the current duration is in weeks. */ JiraTimeUnit["Week"] = "WEEK";
})($2f512219da033f72$export$98bcea6c013bc229 || ($2f512219da033f72$export$98bcea6c013bc229 = {}));
var $2f512219da033f72$export$f68bbce1273585a7;
(function(JiraTransitionSortOption) {
    JiraTransitionSortOption["OpsBar"] = "OPS_BAR";
    JiraTransitionSortOption["OpsBarThenStatusCategory"] = "OPS_BAR_THEN_STATUS_CATEGORY";
})($2f512219da033f72$export$f68bbce1273585a7 || ($2f512219da033f72$export$f68bbce1273585a7 = {}));
var $2f512219da033f72$export$8cb0419b0b598690;
(function(JiraUiModificationsViewType) {
    JiraUiModificationsViewType["Gic"] = "GIC";
    JiraUiModificationsViewType["IssueTransition"] = "IssueTransition";
    JiraUiModificationsViewType["IssueView"] = "IssueView";
    JiraUiModificationsViewType["JsmRequestCreate"] = "JSMRequestCreate";
})($2f512219da033f72$export$8cb0419b0b598690 || ($2f512219da033f72$export$8cb0419b0b598690 = {}));
var $2f512219da033f72$export$5e761940e4c8e671;
(function(JiraVersionApproverStatus) {
    /** Indicates the task has been approved */ JiraVersionApproverStatus["Approved"] = "APPROVED";
    /** Indicates the task has been declined */ JiraVersionApproverStatus["Declined"] = "DECLINED";
    /** Indicates the task is yet to be approved or rejected */ JiraVersionApproverStatus["Pending"] = "PENDING";
})($2f512219da033f72$export$5e761940e4c8e671 || ($2f512219da033f72$export$5e761940e4c8e671 = {}));
var $2f512219da033f72$export$ec4fbd90ada48f79;
(function(JiraVersionDetailsCollapsedUi) {
    JiraVersionDetailsCollapsedUi["Description"] = "DESCRIPTION";
    JiraVersionDetailsCollapsedUi["Issues"] = "ISSUES";
    JiraVersionDetailsCollapsedUi["IssueAssociatedDesigns"] = "ISSUE_ASSOCIATED_DESIGNS";
    JiraVersionDetailsCollapsedUi["ProgressCard"] = "PROGRESS_CARD";
    JiraVersionDetailsCollapsedUi["RelatedWork"] = "RELATED_WORK";
    JiraVersionDetailsCollapsedUi["RichTextSection"] = "RICH_TEXT_SECTION";
    JiraVersionDetailsCollapsedUi["RightSidebar"] = "RIGHT_SIDEBAR";
})($2f512219da033f72$export$ec4fbd90ada48f79 || ($2f512219da033f72$export$ec4fbd90ada48f79 = {}));
var $2f512219da033f72$export$41dca0c2bc0964ff;
(function(JiraVersionIssueTableColumn) {
    /** build status column */ JiraVersionIssueTableColumn["BuildStatus"] = "BUILD_STATUS";
    /** deployment status column (either from Bamboo or other providers) */ JiraVersionIssueTableColumn["DeploymentStatus"] = "DEPLOYMENT_STATUS";
    /** development status column */ JiraVersionIssueTableColumn["DevelopmentStatus"] = "DEVELOPMENT_STATUS";
    /** feature flag status column */ JiraVersionIssueTableColumn["FeatureFlagStatus"] = "FEATURE_FLAG_STATUS";
    /** Issue assignee column */ JiraVersionIssueTableColumn["IssueAssignee"] = "ISSUE_ASSIGNEE";
    /** Priority column */ JiraVersionIssueTableColumn["IssuePriority"] = "ISSUE_PRIORITY";
    /** Issue status column */ JiraVersionIssueTableColumn["IssueStatus"] = "ISSUE_STATUS";
    /** More action meat ball menu column */ JiraVersionIssueTableColumn["MoreAction"] = "MORE_ACTION";
    /** Warnings column */ JiraVersionIssueTableColumn["Warnings"] = "WARNINGS";
})($2f512219da033f72$export$41dca0c2bc0964ff || ($2f512219da033f72$export$41dca0c2bc0964ff = {}));
var $2f512219da033f72$export$2f70e0a7311bc8e6;
(function(JiraVersionIssuesFilter) {
    JiraVersionIssuesFilter["All"] = "ALL";
    JiraVersionIssuesFilter["Done"] = "DONE";
    JiraVersionIssuesFilter["FailingBuild"] = "FAILING_BUILD";
    JiraVersionIssuesFilter["InProgress"] = "IN_PROGRESS";
    JiraVersionIssuesFilter["OpenPullRequest"] = "OPEN_PULL_REQUEST";
    JiraVersionIssuesFilter["OpenReview"] = "OPEN_REVIEW";
    JiraVersionIssuesFilter["Todo"] = "TODO";
    JiraVersionIssuesFilter["UnreviewedCode"] = "UNREVIEWED_CODE";
})($2f512219da033f72$export$2f70e0a7311bc8e6 || ($2f512219da033f72$export$2f70e0a7311bc8e6 = {}));
var $2f512219da033f72$export$70909551a8657943;
(function(JiraVersionIssuesSortField) {
    /** Sort by assignee */ JiraVersionIssuesSortField["Assignee"] = "ASSIGNEE";
    /** Sort by date issue was created */ JiraVersionIssuesSortField["Created"] = "CREATED";
    /** Sort by issue key */ JiraVersionIssuesSortField["Key"] = "KEY";
    /** Sort by priority */ JiraVersionIssuesSortField["Priority"] = "PRIORITY";
    /** Sort by status */ JiraVersionIssuesSortField["Status"] = "STATUS";
    /** Sort by type */ JiraVersionIssuesSortField["Type"] = "TYPE";
})($2f512219da033f72$export$70909551a8657943 || ($2f512219da033f72$export$70909551a8657943 = {}));
var $2f512219da033f72$export$e857541964b7b4a4;
(function(JiraVersionIssuesStatusCategories) {
    /** Issue status done category */ JiraVersionIssuesStatusCategories["Done"] = "DONE";
    /** Issue status in-progress category */ JiraVersionIssuesStatusCategories["InProgress"] = "IN_PROGRESS";
    /** Issue status todo category */ JiraVersionIssuesStatusCategories["Todo"] = "TODO";
})($2f512219da033f72$export$e857541964b7b4a4 || ($2f512219da033f72$export$e857541964b7b4a4 = {}));
var $2f512219da033f72$export$df98b03ce20f1d71;
(function(JiraVersionRelatedWorkType) {
    /** A related work item that links to the version's release notes in a Confluence page. */ JiraVersionRelatedWorkType["ConfluenceReleaseNotes"] = "CONFLUENCE_RELEASE_NOTES";
    /** The most general kind of related work item - an arbitrary link/URL. */ JiraVersionRelatedWorkType["GenericLink"] = "GENERIC_LINK";
    /**
   * A related work item that represents the "native" release notes for the version. These release notes are
   * generated dynamically, and there is at most one per version.
   */ JiraVersionRelatedWorkType["NativeReleaseNotes"] = "NATIVE_RELEASE_NOTES";
})($2f512219da033f72$export$df98b03ce20f1d71 || ($2f512219da033f72$export$df98b03ce20f1d71 = {}));
var $2f512219da033f72$export$f1ccce3810e15115;
(function(JiraVersionReleaseNotesType) {
    /** Represents a Release Note generated in Confluence */ JiraVersionReleaseNotesType["ConfluenceReleaseNote"] = "CONFLUENCE_RELEASE_NOTE";
    /** Represents the standard html/markdown Release Note Type */ JiraVersionReleaseNotesType["NativeReleaseNote"] = "NATIVE_RELEASE_NOTE";
})($2f512219da033f72$export$f1ccce3810e15115 || ($2f512219da033f72$export$f1ccce3810e15115 = {}));
var $2f512219da033f72$export$14819bc3909a411;
(function(JiraVersionSortField) {
    JiraVersionSortField["Description"] = "DESCRIPTION";
    JiraVersionSortField["Name"] = "NAME";
    JiraVersionSortField["ReleaseDate"] = "RELEASE_DATE";
    JiraVersionSortField["Sequence"] = "SEQUENCE";
    JiraVersionSortField["StartDate"] = "START_DATE";
})($2f512219da033f72$export$14819bc3909a411 || ($2f512219da033f72$export$14819bc3909a411 = {}));
var $2f512219da033f72$export$661a9c551e5e752c;
(function(JiraVersionStatus) {
    /** Indicates the version is archived, no further changes can be made to this version unless it is un-archived */ JiraVersionStatus["Archived"] = "ARCHIVED";
    /** Indicates the version is available to public */ JiraVersionStatus["Released"] = "RELEASED";
    /** Indicates the version is not launched yet */ JiraVersionStatus["Unreleased"] = "UNRELEASED";
})($2f512219da033f72$export$661a9c551e5e752c || ($2f512219da033f72$export$661a9c551e5e752c = {}));
var $2f512219da033f72$export$fc74821556ba9086;
(function(JiraVersionWarningCategories) {
    /** Category to list issues with failing build in the version */ JiraVersionWarningCategories["FailingBuild"] = "FAILING_BUILD";
    /** Category to list issues with pull request still open in the version */ JiraVersionWarningCategories["OpenPullRequest"] = "OPEN_PULL_REQUEST";
    /** Category to list issues with review(FishEye/Crucible specific entity) still open in the version */ JiraVersionWarningCategories["OpenReview"] = "OPEN_REVIEW";
    /** Category to list issues with some code linked that is not reviewed in the version */ JiraVersionWarningCategories["UnreviewedCode"] = "UNREVIEWED_CODE";
})($2f512219da033f72$export$fc74821556ba9086 || ($2f512219da033f72$export$fc74821556ba9086 = {}));
var $2f512219da033f72$export$953aa8fa6e3444b5;
(function(JiraVersionWarningConfigState) {
    JiraVersionWarningConfigState["Disabled"] = "DISABLED";
    JiraVersionWarningConfigState["Enabled"] = "ENABLED";
    JiraVersionWarningConfigState["NotApplicable"] = "NOT_APPLICABLE";
})($2f512219da033f72$export$953aa8fa6e3444b5 || ($2f512219da033f72$export$953aa8fa6e3444b5 = {}));
var $2f512219da033f72$export$d93e6e69204ae0db;
(function(JiraVisibilityControlMechanism) {
    /** A Jira admin blocked the app from accessing the data in the given context using [App Access Rules](https://support.atlassian.com/security-and-access-policies/docs/block-app-access/). */ JiraVisibilityControlMechanism["AppAccessRules"] = "AppAccessRules";
    /** The extension specified [Display Conditions](https://developer.atlassian.com/platform/forge/manifest-reference/display-conditions/) that evaluated to `false`. The app doesn't want the extension to be visible in the given context. */ JiraVisibilityControlMechanism["DisplayConditions"] = "DisplayConditions";
})($2f512219da033f72$export$d93e6e69204ae0db || ($2f512219da033f72$export$d93e6e69204ae0db = {}));
var $2f512219da033f72$export$b1636d2c563ea928;
(function(JiraVotesOperations) {
    /** Adds voter to an issue. */ JiraVotesOperations["Add"] = "ADD";
    /** Removes voter from an issue. */ JiraVotesOperations["Remove"] = "REMOVE";
})($2f512219da033f72$export$b1636d2c563ea928 || ($2f512219da033f72$export$b1636d2c563ea928 = {}));
var $2f512219da033f72$export$859195aa80d24a0e;
(function(JiraWatchesOperations) {
    /** Adds watcher to an issue. */ JiraWatchesOperations["Add"] = "ADD";
    /** Removes watcher from an issue. */ JiraWatchesOperations["Remove"] = "REMOVE";
})($2f512219da033f72$export$859195aa80d24a0e || ($2f512219da033f72$export$859195aa80d24a0e = {}));
var $2f512219da033f72$export$bba45fb1219c9de3;
(function(JiraWorkManagementBackgroundType) {
    JiraWorkManagementBackgroundType["Attachment"] = "ATTACHMENT";
    JiraWorkManagementBackgroundType["Color"] = "COLOR";
    JiraWorkManagementBackgroundType["Custom"] = "CUSTOM";
    JiraWorkManagementBackgroundType["Gradient"] = "GRADIENT";
})($2f512219da033f72$export$bba45fb1219c9de3 || ($2f512219da033f72$export$bba45fb1219c9de3 = {}));
var $2f512219da033f72$export$2eb64d234500f795;
(function(JiraWorkManagementUserLicenseSeatEdition) {
    JiraWorkManagementUserLicenseSeatEdition["Free"] = "FREE";
    JiraWorkManagementUserLicenseSeatEdition["Premium"] = "PREMIUM";
    JiraWorkManagementUserLicenseSeatEdition["Standard"] = "STANDARD";
})($2f512219da033f72$export$2eb64d234500f795 || ($2f512219da033f72$export$2eb64d234500f795 = {}));
var $2f512219da033f72$export$6ff2b5b641c7145c;
(function(JiraWorklogAdjustmentEstimateOperation) {
    /** To adjust estimate automatically whatever time spent mentioned. */ JiraWorklogAdjustmentEstimateOperation["Auto"] = "AUTO";
    /** To leave time tracking without auto adjusting based on time spent */ JiraWorklogAdjustmentEstimateOperation["Leave"] = "LEAVE";
    /** To reduce the time remaining manually. */ JiraWorklogAdjustmentEstimateOperation["Manual"] = "MANUAL";
    /** To specifiy new time remaining. */ JiraWorklogAdjustmentEstimateOperation["New"] = "NEW";
})($2f512219da033f72$export$6ff2b5b641c7145c || ($2f512219da033f72$export$6ff2b5b641c7145c = {}));
var $2f512219da033f72$export$605b54213cb587aa;
(function(JsmChatChannelExperienceId) {
    JsmChatChannelExperienceId["Helpcenter"] = "HELPCENTER";
    JsmChatChannelExperienceId["Widget"] = "WIDGET";
})($2f512219da033f72$export$605b54213cb587aa || ($2f512219da033f72$export$605b54213cb587aa = {}));
var $2f512219da033f72$export$becc47419f149198;
(function(JsmChatChannelType) {
    JsmChatChannelType["Agent"] = "AGENT";
    JsmChatChannelType["Request"] = "REQUEST";
})($2f512219da033f72$export$becc47419f149198 || ($2f512219da033f72$export$becc47419f149198 = {}));
var $2f512219da033f72$export$a89b8ac8c955a6b8;
(function(JsmChatConnectedApps) {
    JsmChatConnectedApps["Slack"] = "SLACK";
    JsmChatConnectedApps["Teams"] = "TEAMS";
})($2f512219da033f72$export$a89b8ac8c955a6b8 || ($2f512219da033f72$export$a89b8ac8c955a6b8 = {}));
var $2f512219da033f72$export$f1772920401d1869;
(function(JsmChatConversationAnalyticsEvent) {
    JsmChatConversationAnalyticsEvent["UserClearedChat"] = "USER_CLEARED_CHAT";
    JsmChatConversationAnalyticsEvent["UserMarkedAsNotResolved"] = "USER_MARKED_AS_NOT_RESOLVED";
    JsmChatConversationAnalyticsEvent["UserMarkedAsResolved"] = "USER_MARKED_AS_RESOLVED";
    JsmChatConversationAnalyticsEvent["UserSharedCsat"] = "USER_SHARED_CSAT";
    JsmChatConversationAnalyticsEvent["VaRespondedWithKnowledgeAnswer"] = "VA_RESPONDED_WITH_KNOWLEDGE_ANSWER";
    JsmChatConversationAnalyticsEvent["VaRespondedWithNonKnowledgeAnswer"] = "VA_RESPONDED_WITH_NON_KNOWLEDGE_ANSWER";
})($2f512219da033f72$export$f1772920401d1869 || ($2f512219da033f72$export$f1772920401d1869 = {}));
var $2f512219da033f72$export$42547432295df90d;
(function(JsmChatConversationChannelType) {
    JsmChatConversationChannelType["Email"] = "EMAIL";
    JsmChatConversationChannelType["HelpCenter"] = "HELP_CENTER";
    JsmChatConversationChannelType["Portal"] = "PORTAL";
    JsmChatConversationChannelType["Slack"] = "SLACK";
    JsmChatConversationChannelType["Widget"] = "WIDGET";
})($2f512219da033f72$export$42547432295df90d || ($2f512219da033f72$export$42547432295df90d = {}));
var $2f512219da033f72$export$4b852b1f25f22fba;
(function(JsmChatCreateWebConversationMessageContentType) {
    JsmChatCreateWebConversationMessageContentType["Adf"] = "ADF";
})($2f512219da033f72$export$4b852b1f25f22fba || ($2f512219da033f72$export$4b852b1f25f22fba = {}));
var $2f512219da033f72$export$bd82ae2ddf0ee1bb;
(function(JsmChatCreateWebConversationUserRole) {
    JsmChatCreateWebConversationUserRole["Acknowledgment"] = "Acknowledgment";
    JsmChatCreateWebConversationUserRole["Init"] = "Init";
    JsmChatCreateWebConversationUserRole["JsmAgent"] = "JSM_Agent";
    JsmChatCreateWebConversationUserRole["Participant"] = "Participant";
    JsmChatCreateWebConversationUserRole["Reporter"] = "Reporter";
    JsmChatCreateWebConversationUserRole["VirtualAgent"] = "VirtualAgent";
})($2f512219da033f72$export$bd82ae2ddf0ee1bb || ($2f512219da033f72$export$bd82ae2ddf0ee1bb = {}));
var $2f512219da033f72$export$f209cecbea0db715;
(function(JsmChatMessageSource) {
    JsmChatMessageSource["Email"] = "EMAIL";
})($2f512219da033f72$export$f209cecbea0db715 || ($2f512219da033f72$export$f209cecbea0db715 = {}));
var $2f512219da033f72$export$6c33ffba63a39eab;
(function(JsmChatMessageType) {
    JsmChatMessageType["Adf"] = "ADF";
})($2f512219da033f72$export$6c33ffba63a39eab || ($2f512219da033f72$export$6c33ffba63a39eab = {}));
var $2f512219da033f72$export$541d31a3a9a748d3;
(function(JsmChatWebChannelExperienceId) {
    JsmChatWebChannelExperienceId["Helpcenter"] = "HELPCENTER";
})($2f512219da033f72$export$541d31a3a9a748d3 || ($2f512219da033f72$export$541d31a3a9a748d3 = {}));
var $2f512219da033f72$export$a7843418b4abf972;
(function(JsmChatWebConversationActions) {
    JsmChatWebConversationActions["CloseConversation"] = "CLOSE_CONVERSATION";
    JsmChatWebConversationActions["DisableInput"] = "DISABLE_INPUT";
    JsmChatWebConversationActions["GreetingMessage"] = "GREETING_MESSAGE";
    JsmChatWebConversationActions["RedirectToSearch"] = "REDIRECT_TO_SEARCH";
})($2f512219da033f72$export$a7843418b4abf972 || ($2f512219da033f72$export$a7843418b4abf972 = {}));
var $2f512219da033f72$export$194b74aaba4c66bb;
(function(JsmChatWebConversationMessageContentType) {
    JsmChatWebConversationMessageContentType["Adf"] = "ADF";
})($2f512219da033f72$export$194b74aaba4c66bb || ($2f512219da033f72$export$194b74aaba4c66bb = {}));
var $2f512219da033f72$export$765d6dfd69cf5430;
(function(JsmChatWebConversationUserRole) {
    JsmChatWebConversationUserRole["JsmAgent"] = "JSM_Agent";
    JsmChatWebConversationUserRole["Participant"] = "Participant";
    JsmChatWebConversationUserRole["Reporter"] = "Reporter";
    JsmChatWebConversationUserRole["VirtualAgent"] = "VirtualAgent";
})($2f512219da033f72$export$765d6dfd69cf5430 || ($2f512219da033f72$export$765d6dfd69cf5430 = {}));
var $2f512219da033f72$export$a4817513e320362b;
(function(JsmChatWebInteractionType) {
    JsmChatWebInteractionType["Buttons"] = "BUTTONS";
    JsmChatWebInteractionType["Dropdown"] = "DROPDOWN";
    JsmChatWebInteractionType["JiraField"] = "JIRA_FIELD";
})($2f512219da033f72$export$a4817513e320362b || ($2f512219da033f72$export$a4817513e320362b = {}));
var $2f512219da033f72$export$2992769e8753e621;
(function(KnowledgeBaseArticleSearchSortByKey) {
    KnowledgeBaseArticleSearchSortByKey["LastModified"] = "LAST_MODIFIED";
    KnowledgeBaseArticleSearchSortByKey["Title"] = "TITLE";
})($2f512219da033f72$export$2992769e8753e621 || ($2f512219da033f72$export$2992769e8753e621 = {}));
var $2f512219da033f72$export$491854222fb4161a;
(function(KnowledgeBaseArticleSearchSortOrder) {
    KnowledgeBaseArticleSearchSortOrder["Asc"] = "ASC";
    KnowledgeBaseArticleSearchSortOrder["Desc"] = "DESC";
})($2f512219da033f72$export$491854222fb4161a || ($2f512219da033f72$export$491854222fb4161a = {}));
var $2f512219da033f72$export$c9816db2d5d28541;
(function(KnowledgeBaseSpacePermissionType) {
    /** Permission for anonymous users (view only) */ KnowledgeBaseSpacePermissionType["AnonymousUsers"] = "ANONYMOUS_USERS";
    /** Permission for Confluence licensed users */ KnowledgeBaseSpacePermissionType["ConfluenceLicensedUsers"] = "CONFLUENCE_LICENSED_USERS";
    /** Permission for Confluence unlicensed users */ KnowledgeBaseSpacePermissionType["ConfluenceUnlicensedUsers"] = "CONFLUENCE_UNLICENSED_USERS";
})($2f512219da033f72$export$c9816db2d5d28541 || ($2f512219da033f72$export$c9816db2d5d28541 = {}));
var $2f512219da033f72$export$39978dee0852c112;
(function(KnowledgeDiscoveryBookmarkState) {
    KnowledgeDiscoveryBookmarkState["Active"] = "ACTIVE";
    KnowledgeDiscoveryBookmarkState["Suggested"] = "SUGGESTED";
})($2f512219da033f72$export$39978dee0852c112 || ($2f512219da033f72$export$39978dee0852c112 = {}));
var $2f512219da033f72$export$237aec910e197d97;
(function(KnowledgeDiscoveryDefinitionScope) {
    KnowledgeDiscoveryDefinitionScope["Blogpost"] = "BLOGPOST";
    KnowledgeDiscoveryDefinitionScope["Organization"] = "ORGANIZATION";
    KnowledgeDiscoveryDefinitionScope["Page"] = "PAGE";
    KnowledgeDiscoveryDefinitionScope["Project"] = "PROJECT";
    KnowledgeDiscoveryDefinitionScope["Space"] = "SPACE";
})($2f512219da033f72$export$237aec910e197d97 || ($2f512219da033f72$export$237aec910e197d97 = {}));
var $2f512219da033f72$export$d2d7439a14c13cac;
(function(KnowledgeDiscoveryEntityType) {
    KnowledgeDiscoveryEntityType["ConfluenceBlogpost"] = "CONFLUENCE_BLOGPOST";
    KnowledgeDiscoveryEntityType["ConfluenceDocument"] = "CONFLUENCE_DOCUMENT";
    KnowledgeDiscoveryEntityType["ConfluencePage"] = "CONFLUENCE_PAGE";
    KnowledgeDiscoveryEntityType["ConfluenceSpace"] = "CONFLUENCE_SPACE";
    KnowledgeDiscoveryEntityType["JiraProject"] = "JIRA_PROJECT";
    KnowledgeDiscoveryEntityType["KeyPhrase"] = "KEY_PHRASE";
    KnowledgeDiscoveryEntityType["Topic"] = "TOPIC";
    KnowledgeDiscoveryEntityType["User"] = "USER";
})($2f512219da033f72$export$d2d7439a14c13cac || ($2f512219da033f72$export$d2d7439a14c13cac = {}));
var $2f512219da033f72$export$4c5402ac41e05bd0;
(function(KnowledgeDiscoveryKeyPhraseCategory) {
    KnowledgeDiscoveryKeyPhraseCategory["Acronym"] = "ACRONYM";
    KnowledgeDiscoveryKeyPhraseCategory["Auto"] = "AUTO";
    KnowledgeDiscoveryKeyPhraseCategory["Other"] = "OTHER";
    KnowledgeDiscoveryKeyPhraseCategory["Project"] = "PROJECT";
    KnowledgeDiscoveryKeyPhraseCategory["Team"] = "TEAM";
})($2f512219da033f72$export$4c5402ac41e05bd0 || ($2f512219da033f72$export$4c5402ac41e05bd0 = {}));
var $2f512219da033f72$export$5fc610914b028d97;
(function(KnowledgeDiscoveryKeyPhraseInputTextFormat) {
    KnowledgeDiscoveryKeyPhraseInputTextFormat["Adf"] = "ADF";
    KnowledgeDiscoveryKeyPhraseInputTextFormat["Plain"] = "PLAIN";
})($2f512219da033f72$export$5fc610914b028d97 || ($2f512219da033f72$export$5fc610914b028d97 = {}));
var $2f512219da033f72$export$fc0361604b6ff360;
(function(KnowledgeDiscoveryRelatedEntityActionType) {
    KnowledgeDiscoveryRelatedEntityActionType["Delete"] = "DELETE";
    KnowledgeDiscoveryRelatedEntityActionType["Persist"] = "PERSIST";
})($2f512219da033f72$export$fc0361604b6ff360 || ($2f512219da033f72$export$fc0361604b6ff360 = {}));
var $2f512219da033f72$export$be3a90b14f5b3f96;
(function(KnowledgeDiscoverySearchQueryClassification) {
    KnowledgeDiscoverySearchQueryClassification["KeywordOrAcronym"] = "KEYWORD_OR_ACRONYM";
    KnowledgeDiscoverySearchQueryClassification["NaturalLanguageQuery"] = "NATURAL_LANGUAGE_QUERY";
    KnowledgeDiscoverySearchQueryClassification["Navigational"] = "NAVIGATIONAL";
    KnowledgeDiscoverySearchQueryClassification["None"] = "NONE";
    KnowledgeDiscoverySearchQueryClassification["Person"] = "PERSON";
    KnowledgeDiscoverySearchQueryClassification["Team"] = "TEAM";
})($2f512219da033f72$export$be3a90b14f5b3f96 || ($2f512219da033f72$export$be3a90b14f5b3f96 = {}));
var $2f512219da033f72$export$2af2684e8f4b3a61;
(function(KnowledgeDiscoverySearchQueryClassificationSubtype) {
    KnowledgeDiscoverySearchQueryClassificationSubtype["Command"] = "COMMAND";
    KnowledgeDiscoverySearchQueryClassificationSubtype["Confluence"] = "CONFLUENCE";
    KnowledgeDiscoverySearchQueryClassificationSubtype["Evaluate"] = "EVALUATE";
    KnowledgeDiscoverySearchQueryClassificationSubtype["Jira"] = "JIRA";
    KnowledgeDiscoverySearchQueryClassificationSubtype["JobTitle"] = "JOB_TITLE";
    KnowledgeDiscoverySearchQueryClassificationSubtype["Llm"] = "LLM";
    KnowledgeDiscoverySearchQueryClassificationSubtype["Question"] = "QUESTION";
})($2f512219da033f72$export$2af2684e8f4b3a61 || ($2f512219da033f72$export$2af2684e8f4b3a61 = {}));
var $2f512219da033f72$export$476bafd4888ee246;
(function(KnowledgeDiscoveryTopicType) {
    KnowledgeDiscoveryTopicType["Area"] = "AREA";
    KnowledgeDiscoveryTopicType["Company"] = "COMPANY";
    KnowledgeDiscoveryTopicType["Event"] = "EVENT";
    KnowledgeDiscoveryTopicType["Process"] = "PROCESS";
    KnowledgeDiscoveryTopicType["Program"] = "PROGRAM";
    KnowledgeDiscoveryTopicType["Team"] = "TEAM";
})($2f512219da033f72$export$476bafd4888ee246 || ($2f512219da033f72$export$476bafd4888ee246 = {}));
var $2f512219da033f72$export$522f238043d058cb;
(function(LicenseOverrideState) {
    LicenseOverrideState["Active"] = "ACTIVE";
    LicenseOverrideState["Advanced"] = "ADVANCED";
    LicenseOverrideState["Inactive"] = "INACTIVE";
    LicenseOverrideState["Standard"] = "STANDARD";
    LicenseOverrideState["Trial"] = "TRIAL";
})($2f512219da033f72$export$522f238043d058cb || ($2f512219da033f72$export$522f238043d058cb = {}));
var $2f512219da033f72$export$902181cb056f3d0b;
(function(LicenseStatus) {
    LicenseStatus["Active"] = "ACTIVE";
    LicenseStatus["Suspended"] = "SUSPENDED";
    LicenseStatus["Unlicensed"] = "UNLICENSED";
})($2f512219da033f72$export$902181cb056f3d0b || ($2f512219da033f72$export$902181cb056f3d0b = {}));
var $2f512219da033f72$export$3b3519737999098f;
(function(LifecycleStage) {
    LifecycleStage["Beta"] = "BETA";
    LifecycleStage["Experimental"] = "EXPERIMENTAL";
    LifecycleStage["Production"] = "PRODUCTION";
    LifecycleStage["Staging"] = "STAGING";
})($2f512219da033f72$export$3b3519737999098f || ($2f512219da033f72$export$3b3519737999098f = {}));
var $2f512219da033f72$export$81913a6042065c49;
(function(LoomMeetingSource) {
    LoomMeetingSource["GoogleCalendar"] = "GOOGLE_CALENDAR";
    LoomMeetingSource["MicrosoftOutlook"] = "MICROSOFT_OUTLOOK";
    LoomMeetingSource["Zoom"] = "ZOOM";
})($2f512219da033f72$export$81913a6042065c49 || ($2f512219da033f72$export$81913a6042065c49 = {}));
var $2f512219da033f72$export$9d643cbb1392f8e6;
(function(LoomUserStatus) {
    LoomUserStatus["Linked"] = "LINKED";
    LoomUserStatus["LinkedEnterprise"] = "LINKED_ENTERPRISE";
    LoomUserStatus["Mastered"] = "MASTERED";
    LoomUserStatus["NotFound"] = "NOT_FOUND";
})($2f512219da033f72$export$9d643cbb1392f8e6 || ($2f512219da033f72$export$9d643cbb1392f8e6 = {}));
var $2f512219da033f72$export$f02742739c4d10;
(function(LpCertSortField) {
    LpCertSortField["ActiveDate"] = "ACTIVE_DATE";
    LpCertSortField["ExpireDate"] = "EXPIRE_DATE";
    LpCertSortField["Id"] = "ID";
    LpCertSortField["ImageUrl"] = "IMAGE_URL";
    LpCertSortField["Name"] = "NAME";
    LpCertSortField["NameAbbr"] = "NAME_ABBR";
    LpCertSortField["PublicUrl"] = "PUBLIC_URL";
    LpCertSortField["Status"] = "STATUS";
    LpCertSortField["Type"] = "TYPE";
})($2f512219da033f72$export$f02742739c4d10 || ($2f512219da033f72$export$f02742739c4d10 = {}));
var $2f512219da033f72$export$a8eb0a5903a5312c;
(function(LpCertStatus) {
    LpCertStatus["Active"] = "ACTIVE";
    LpCertStatus["Expired"] = "EXPIRED";
})($2f512219da033f72$export$a8eb0a5903a5312c || ($2f512219da033f72$export$a8eb0a5903a5312c = {}));
var $2f512219da033f72$export$9999af1e50a41e44;
(function(LpCertType) {
    LpCertType["Badge"] = "BADGE";
    LpCertType["Certification"] = "CERTIFICATION";
    LpCertType["Standing"] = "STANDING";
})($2f512219da033f72$export$9999af1e50a41e44 || ($2f512219da033f72$export$9999af1e50a41e44 = {}));
var $2f512219da033f72$export$a8f04761d618cfe2;
(function(LpCourseSortField) {
    LpCourseSortField["CompletedDate"] = "COMPLETED_DATE";
    LpCourseSortField["CourseId"] = "COURSE_ID";
    LpCourseSortField["Id"] = "ID";
    LpCourseSortField["Status"] = "STATUS";
    LpCourseSortField["Title"] = "TITLE";
    LpCourseSortField["Url"] = "URL";
})($2f512219da033f72$export$a8f04761d618cfe2 || ($2f512219da033f72$export$a8f04761d618cfe2 = {}));
var $2f512219da033f72$export$b2608a9d91a1b256;
(function(LpCourseStatus) {
    LpCourseStatus["Completed"] = "COMPLETED";
    LpCourseStatus["InProgress"] = "IN_PROGRESS";
})($2f512219da033f72$export$b2608a9d91a1b256 || ($2f512219da033f72$export$b2608a9d91a1b256 = {}));
var $2f512219da033f72$export$dcfe2c64979f9e2c;
(function(LpSortOrder) {
    LpSortOrder["Asc"] = "ASC";
    LpSortOrder["Desc"] = "DESC";
})($2f512219da033f72$export$dcfe2c64979f9e2c || ($2f512219da033f72$export$dcfe2c64979f9e2c = {}));
var $2f512219da033f72$export$f25ba44b203e3645;
(function(MarketplaceAppPaymentModel) {
    MarketplaceAppPaymentModel["Free"] = "FREE";
    MarketplaceAppPaymentModel["PaidViaAtlassian"] = "PAID_VIA_ATLASSIAN";
    MarketplaceAppPaymentModel["PaidViaPartner"] = "PAID_VIA_PARTNER";
})($2f512219da033f72$export$f25ba44b203e3645 || ($2f512219da033f72$export$f25ba44b203e3645 = {}));
var $2f512219da033f72$export$6e069b93ed3dba5f;
(function(MarketplaceAppVersionVisibility) {
    MarketplaceAppVersionVisibility["Private"] = "PRIVATE";
    MarketplaceAppVersionVisibility["Public"] = "PUBLIC";
})($2f512219da033f72$export$6e069b93ed3dba5f || ($2f512219da033f72$export$6e069b93ed3dba5f = {}));
var $2f512219da033f72$export$dafb60ab7ab08188;
(function(MarketplaceBillingCycle) {
    MarketplaceBillingCycle["Annual"] = "ANNUAL";
    MarketplaceBillingCycle["Monthly"] = "MONTHLY";
})($2f512219da033f72$export$dafb60ab7ab08188 || ($2f512219da033f72$export$dafb60ab7ab08188 = {}));
var $2f512219da033f72$export$468594da24feab1;
(function(MarketplaceCloudFortifiedStatus) {
    MarketplaceCloudFortifiedStatus["Applied"] = "APPLIED";
    MarketplaceCloudFortifiedStatus["Approved"] = "APPROVED";
    MarketplaceCloudFortifiedStatus["NotAParticipant"] = "NOT_A_PARTICIPANT";
    MarketplaceCloudFortifiedStatus["Rejected"] = "REJECTED";
})($2f512219da033f72$export$468594da24feab1 || ($2f512219da033f72$export$468594da24feab1 = {}));
var $2f512219da033f72$export$af13e4a6e0622f5e;
(function(MarketplaceConsoleAsvlLegacyVersionApprovalStatus) {
    MarketplaceConsoleAsvlLegacyVersionApprovalStatus["Approved"] = "APPROVED";
    MarketplaceConsoleAsvlLegacyVersionApprovalStatus["Archived"] = "ARCHIVED";
    MarketplaceConsoleAsvlLegacyVersionApprovalStatus["Deleted"] = "DELETED";
    MarketplaceConsoleAsvlLegacyVersionApprovalStatus["Rejected"] = "REJECTED";
    MarketplaceConsoleAsvlLegacyVersionApprovalStatus["Submitted"] = "SUBMITTED";
    MarketplaceConsoleAsvlLegacyVersionApprovalStatus["Uninitiated"] = "UNINITIATED";
})($2f512219da033f72$export$af13e4a6e0622f5e || ($2f512219da033f72$export$af13e4a6e0622f5e = {}));
var $2f512219da033f72$export$70a7872ed4e38e3a;
(function(MarketplaceConsoleAsvlLegacyVersionStatus) {
    MarketplaceConsoleAsvlLegacyVersionStatus["Private"] = "PRIVATE";
    MarketplaceConsoleAsvlLegacyVersionStatus["Public"] = "PUBLIC";
})($2f512219da033f72$export$70a7872ed4e38e3a || ($2f512219da033f72$export$70a7872ed4e38e3a = {}));
var $2f512219da033f72$export$c1efd3e80d58f939;
(function(MarketplaceConsoleAppSoftwareVersionLicenseTypeId) {
    MarketplaceConsoleAppSoftwareVersionLicenseTypeId["Asl"] = "ASL";
    MarketplaceConsoleAppSoftwareVersionLicenseTypeId["AtlassianClosedSource"] = "ATLASSIAN_CLOSED_SOURCE";
    MarketplaceConsoleAppSoftwareVersionLicenseTypeId["Bsd"] = "BSD";
    MarketplaceConsoleAppSoftwareVersionLicenseTypeId["Commercial"] = "COMMERCIAL";
    MarketplaceConsoleAppSoftwareVersionLicenseTypeId["CommercialFree"] = "COMMERCIAL_FREE";
    MarketplaceConsoleAppSoftwareVersionLicenseTypeId["Epl"] = "EPL";
    MarketplaceConsoleAppSoftwareVersionLicenseTypeId["Gpl"] = "GPL";
    MarketplaceConsoleAppSoftwareVersionLicenseTypeId["Lgpl"] = "LGPL";
})($2f512219da033f72$export$c1efd3e80d58f939 || ($2f512219da033f72$export$c1efd3e80d58f939 = {}));
var $2f512219da033f72$export$fb9cecbbd253ebc0;
(function(MarketplaceConsoleAppSoftwareVersionState) {
    MarketplaceConsoleAppSoftwareVersionState["Active"] = "ACTIVE";
    MarketplaceConsoleAppSoftwareVersionState["Approved"] = "APPROVED";
    MarketplaceConsoleAppSoftwareVersionState["Archived"] = "ARCHIVED";
    MarketplaceConsoleAppSoftwareVersionState["AutoApproved"] = "AUTO_APPROVED";
    MarketplaceConsoleAppSoftwareVersionState["Draft"] = "DRAFT";
    MarketplaceConsoleAppSoftwareVersionState["Rejected"] = "REJECTED";
    MarketplaceConsoleAppSoftwareVersionState["Submitted"] = "SUBMITTED";
})($2f512219da033f72$export$fb9cecbbd253ebc0 || ($2f512219da033f72$export$fb9cecbbd253ebc0 = {}));
var $2f512219da033f72$export$9de5cbe727291181;
(function(MarketplaceConsoleDevSpaceProgram) {
    MarketplaceConsoleDevSpaceProgram["AtlassianParter"] = "ATLASSIAN_PARTER";
    MarketplaceConsoleDevSpaceProgram["FreeLicense"] = "FREE_LICENSE";
    MarketplaceConsoleDevSpaceProgram["MarketplacePartner"] = "MARKETPLACE_PARTNER";
    MarketplaceConsoleDevSpaceProgram["SolutionPartner"] = "SOLUTION_PARTNER";
})($2f512219da033f72$export$9de5cbe727291181 || ($2f512219da033f72$export$9de5cbe727291181 = {}));
var $2f512219da033f72$export$2f6a1d40840e6e7a;
(function(MarketplaceConsoleDevSpaceTier) {
    MarketplaceConsoleDevSpaceTier["Gold"] = "GOLD";
    MarketplaceConsoleDevSpaceTier["Platinum"] = "PLATINUM";
    MarketplaceConsoleDevSpaceTier["Silver"] = "SILVER";
})($2f512219da033f72$export$2f6a1d40840e6e7a || ($2f512219da033f72$export$2f6a1d40840e6e7a = {}));
var $2f512219da033f72$export$63c7f04a210975b2;
(function(MarketplaceConsoleEditionType) {
    MarketplaceConsoleEditionType["Advanced"] = "ADVANCED";
    MarketplaceConsoleEditionType["AdvancedMultiInstance"] = "ADVANCED_MULTI_INSTANCE";
    MarketplaceConsoleEditionType["Standard"] = "STANDARD";
    MarketplaceConsoleEditionType["StandardMultiInstance"] = "STANDARD_MULTI_INSTANCE";
})($2f512219da033f72$export$63c7f04a210975b2 || ($2f512219da033f72$export$63c7f04a210975b2 = {}));
var $2f512219da033f72$export$26ce6a16987d908d;
(function(MarketplaceConsoleEditionsActivationStatus) {
    MarketplaceConsoleEditionsActivationStatus["Approved"] = "APPROVED";
    MarketplaceConsoleEditionsActivationStatus["Pending"] = "PENDING";
    MarketplaceConsoleEditionsActivationStatus["Rejected"] = "REJECTED";
})($2f512219da033f72$export$26ce6a16987d908d || ($2f512219da033f72$export$26ce6a16987d908d = {}));
var $2f512219da033f72$export$14f32a11a50ded19;
(function(MarketplaceConsoleHosting) {
    MarketplaceConsoleHosting["Cloud"] = "CLOUD";
    MarketplaceConsoleHosting["DataCenter"] = "DATA_CENTER";
    MarketplaceConsoleHosting["Server"] = "SERVER";
})($2f512219da033f72$export$14f32a11a50ded19 || ($2f512219da033f72$export$14f32a11a50ded19 = {}));
var $2f512219da033f72$export$5636d960d9fd9d0a;
(function(MarketplaceConsoleLegacyMongoPluginHiddenIn) {
    MarketplaceConsoleLegacyMongoPluginHiddenIn["HiddenInSiteAndAppMarketplace"] = "HIDDEN_IN_SITE_AND_APP_MARKETPLACE";
    MarketplaceConsoleLegacyMongoPluginHiddenIn["HiddenInSiteOnly"] = "HIDDEN_IN_SITE_ONLY";
})($2f512219da033f72$export$5636d960d9fd9d0a || ($2f512219da033f72$export$5636d960d9fd9d0a = {}));
var $2f512219da033f72$export$b16d3f44b490e152;
(function(MarketplaceConsoleLegacyMongoStatus) {
    MarketplaceConsoleLegacyMongoStatus["Notassigned"] = "NOTASSIGNED";
    MarketplaceConsoleLegacyMongoStatus["Private"] = "PRIVATE";
    MarketplaceConsoleLegacyMongoStatus["Public"] = "PUBLIC";
    MarketplaceConsoleLegacyMongoStatus["Readytolaunch"] = "READYTOLAUNCH";
    MarketplaceConsoleLegacyMongoStatus["Rejected"] = "REJECTED";
    MarketplaceConsoleLegacyMongoStatus["Submitted"] = "SUBMITTED";
})($2f512219da033f72$export$b16d3f44b490e152 || ($2f512219da033f72$export$b16d3f44b490e152 = {}));
var $2f512219da033f72$export$a3c494bbbdf25ee3;
(function(MarketplaceConsoleParentSoftwareState) {
    MarketplaceConsoleParentSoftwareState["Active"] = "ACTIVE";
    MarketplaceConsoleParentSoftwareState["Archived"] = "ARCHIVED";
    MarketplaceConsoleParentSoftwareState["Draft"] = "DRAFT";
})($2f512219da033f72$export$a3c494bbbdf25ee3 || ($2f512219da033f72$export$a3c494bbbdf25ee3 = {}));
var $2f512219da033f72$export$1393796fd66f6532;
(function(MarketplaceConsolePaymentModel) {
    MarketplaceConsolePaymentModel["Free"] = "FREE";
    MarketplaceConsolePaymentModel["PaidViaAtlassian"] = "PAID_VIA_ATLASSIAN";
    MarketplaceConsolePaymentModel["PaidViaVendor"] = "PAID_VIA_VENDOR";
})($2f512219da033f72$export$1393796fd66f6532 || ($2f512219da033f72$export$1393796fd66f6532 = {}));
var $2f512219da033f72$export$e1c43740a06d58bb;
(function(MarketplaceConsolePluginFrameworkType) {
    MarketplaceConsolePluginFrameworkType["P1"] = "P1";
    MarketplaceConsolePluginFrameworkType["P2"] = "P2";
})($2f512219da033f72$export$e1c43740a06d58bb || ($2f512219da033f72$export$e1c43740a06d58bb = {}));
var $2f512219da033f72$export$7e092f87e8d91044;
(function(MarketplaceConsolePricingCurrency) {
    MarketplaceConsolePricingCurrency["Jpy"] = "JPY";
    MarketplaceConsolePricingCurrency["Usd"] = "USD";
})($2f512219da033f72$export$7e092f87e8d91044 || ($2f512219da033f72$export$7e092f87e8d91044 = {}));
var $2f512219da033f72$export$4c5c05b960837cad;
(function(MarketplaceConsolePricingPlanStatus) {
    MarketplaceConsolePricingPlanStatus["Draft"] = "DRAFT";
    MarketplaceConsolePricingPlanStatus["Live"] = "LIVE";
    MarketplaceConsolePricingPlanStatus["Pending"] = "PENDING";
})($2f512219da033f72$export$4c5c05b960837cad || ($2f512219da033f72$export$4c5c05b960837cad = {}));
var $2f512219da033f72$export$8b7b15f5e0317b5a;
(function(MarketplaceEntityStatus) {
    MarketplaceEntityStatus["Active"] = "ACTIVE";
    MarketplaceEntityStatus["Archived"] = "ARCHIVED";
})($2f512219da033f72$export$8b7b15f5e0317b5a || ($2f512219da033f72$export$8b7b15f5e0317b5a = {}));
var $2f512219da033f72$export$1a1d4383d2498aa8;
(function(MarketplaceListingStatus) {
    MarketplaceListingStatus["Private"] = "PRIVATE";
    MarketplaceListingStatus["Public"] = "PUBLIC";
    MarketplaceListingStatus["ReadyToLaunch"] = "READY_TO_LAUNCH";
    MarketplaceListingStatus["Rejected"] = "REJECTED";
    MarketplaceListingStatus["Submitted"] = "SUBMITTED";
})($2f512219da033f72$export$1a1d4383d2498aa8 || ($2f512219da033f72$export$1a1d4383d2498aa8 = {}));
var $2f512219da033f72$export$25ad001a38719422;
(function(MarketplaceLocation) {
    MarketplaceLocation["InProduct"] = "IN_PRODUCT";
    MarketplaceLocation["Website"] = "WEBSITE";
})($2f512219da033f72$export$25ad001a38719422 || ($2f512219da033f72$export$25ad001a38719422 = {}));
var $2f512219da033f72$export$96bfc8c3eec61fd0;
(function(MarketplacePartnerSupportHolidayFrequency) {
    MarketplacePartnerSupportHolidayFrequency["Annual"] = "ANNUAL";
    MarketplacePartnerSupportHolidayFrequency["OneTime"] = "ONE_TIME";
})($2f512219da033f72$export$96bfc8c3eec61fd0 || ($2f512219da033f72$export$96bfc8c3eec61fd0 = {}));
var $2f512219da033f72$export$4f999921e3690a15;
(function(MarketplacePartnerTierType) {
    MarketplacePartnerTierType["Gold"] = "GOLD";
    MarketplacePartnerTierType["Platinum"] = "PLATINUM";
    MarketplacePartnerTierType["Silver"] = "SILVER";
})($2f512219da033f72$export$4f999921e3690a15 || ($2f512219da033f72$export$4f999921e3690a15 = {}));
var $2f512219da033f72$export$8fec59d6f9a79101;
(function(MarketplacePartnerType) {
    MarketplacePartnerType["AtlassianInternal"] = "ATLASSIAN_INTERNAL";
})($2f512219da033f72$export$8fec59d6f9a79101 || ($2f512219da033f72$export$8fec59d6f9a79101 = {}));
var $2f512219da033f72$export$72afefd58b6b80d0;
(function(MarketplacePricingPlanStatus) {
    MarketplacePricingPlanStatus["Draft"] = "DRAFT";
    MarketplacePricingPlanStatus["Live"] = "LIVE";
    MarketplacePricingPlanStatus["Pending"] = "PENDING";
})($2f512219da033f72$export$72afefd58b6b80d0 || ($2f512219da033f72$export$72afefd58b6b80d0 = {}));
var $2f512219da033f72$export$3c578ff2609d82d7;
(function(MarketplacePricingTierMode) {
    MarketplacePricingTierMode["Graduated"] = "GRADUATED";
    MarketplacePricingTierMode["Volume"] = "VOLUME";
})($2f512219da033f72$export$3c578ff2609d82d7 || ($2f512219da033f72$export$3c578ff2609d82d7 = {}));
var $2f512219da033f72$export$7edcca7ce5991948;
(function(MarketplacePricingTierPolicy) {
    MarketplacePricingTierPolicy["Block"] = "BLOCK";
    MarketplacePricingTierPolicy["PerUnit"] = "PER_UNIT";
})($2f512219da033f72$export$7edcca7ce5991948 || ($2f512219da033f72$export$7edcca7ce5991948 = {}));
var $2f512219da033f72$export$645f0980d82252ac;
(function(MarketplacePricingTierType) {
    MarketplacePricingTierType["RemoteAgentTiered"] = "REMOTE_AGENT_TIERED";
    MarketplacePricingTierType["UserTiered"] = "USER_TIERED";
})($2f512219da033f72$export$645f0980d82252ac || ($2f512219da033f72$export$645f0980d82252ac = {}));
var $2f512219da033f72$export$2cbd5d0207702c5;
(function(MarketplaceProgramStatus) {
    MarketplaceProgramStatus["Applied"] = "APPLIED";
    MarketplaceProgramStatus["Approved"] = "APPROVED";
    MarketplaceProgramStatus["NotAParticipant"] = "NOT_A_PARTICIPANT";
    MarketplaceProgramStatus["Rejected"] = "REJECTED";
})($2f512219da033f72$export$2cbd5d0207702c5 || ($2f512219da033f72$export$2cbd5d0207702c5 = {}));
var $2f512219da033f72$export$530009b3dfc0f50e;
(function(MarketplaceStoreAtlassianProductHostingType) {
    MarketplaceStoreAtlassianProductHostingType["Cloud"] = "CLOUD";
    MarketplaceStoreAtlassianProductHostingType["Datacenter"] = "DATACENTER";
    MarketplaceStoreAtlassianProductHostingType["Server"] = "SERVER";
})($2f512219da033f72$export$530009b3dfc0f50e || ($2f512219da033f72$export$530009b3dfc0f50e = {}));
var $2f512219da033f72$export$b24074035b7232d5;
(function(MarketplaceStoreBillingSystem) {
    MarketplaceStoreBillingSystem["Ccp"] = "CCP";
    MarketplaceStoreBillingSystem["Hams"] = "HAMS";
})($2f512219da033f72$export$b24074035b7232d5 || ($2f512219da033f72$export$b24074035b7232d5 = {}));
var $2f512219da033f72$export$da28f7301ad006a5;
(function(MarketplaceStoreDeveloperSpaceStatus) {
    MarketplaceStoreDeveloperSpaceStatus["Active"] = "ACTIVE";
    MarketplaceStoreDeveloperSpaceStatus["Archived"] = "ARCHIVED";
    MarketplaceStoreDeveloperSpaceStatus["Inactive"] = "INACTIVE";
})($2f512219da033f72$export$da28f7301ad006a5 || ($2f512219da033f72$export$da28f7301ad006a5 = {}));
var $2f512219da033f72$export$fe42024bf862f826;
(function(MarketplaceStoreEditionType) {
    MarketplaceStoreEditionType["Advanced"] = "ADVANCED";
    MarketplaceStoreEditionType["Standard"] = "STANDARD";
})($2f512219da033f72$export$fe42024bf862f826 || ($2f512219da033f72$export$fe42024bf862f826 = {}));
var $2f512219da033f72$export$8db4f89e95cf18dc;
(function(MarketplaceStoreEnterpriseProduct) {
    MarketplaceStoreEnterpriseProduct["Confluence"] = "CONFLUENCE";
    MarketplaceStoreEnterpriseProduct["Jira"] = "JIRA";
})($2f512219da033f72$export$8db4f89e95cf18dc || ($2f512219da033f72$export$8db4f89e95cf18dc = {}));
var $2f512219da033f72$export$b36f406ff2fbbafe;
(function(MarketplaceStoreHomePageHighlightedSectionVariation) {
    MarketplaceStoreHomePageHighlightedSectionVariation["Prominent"] = "PROMINENT";
})($2f512219da033f72$export$b36f406ff2fbbafe || ($2f512219da033f72$export$b36f406ff2fbbafe = {}));
var $2f512219da033f72$export$be602207859a9a98;
(function(MarketplaceStoreHostInstanceType) {
    MarketplaceStoreHostInstanceType["Production"] = "PRODUCTION";
    MarketplaceStoreHostInstanceType["Sandbox"] = "SANDBOX";
})($2f512219da033f72$export$be602207859a9a98 || ($2f512219da033f72$export$be602207859a9a98 = {}));
var $2f512219da033f72$export$f6c61b63a81bc74a;
(function(MarketplaceStoreInstallAppStatus) {
    MarketplaceStoreInstallAppStatus["InProgress"] = "IN_PROGRESS";
    MarketplaceStoreInstallAppStatus["Pending"] = "PENDING";
    MarketplaceStoreInstallAppStatus["ProvisioningFailure"] = "PROVISIONING_FAILURE";
    MarketplaceStoreInstallAppStatus["ProvisioningSuccessInstallPending"] = "PROVISIONING_SUCCESS_INSTALL_PENDING";
    MarketplaceStoreInstallAppStatus["Success"] = "SUCCESS";
    MarketplaceStoreInstallAppStatus["TimedOut"] = "TIMED_OUT";
})($2f512219da033f72$export$f6c61b63a81bc74a || ($2f512219da033f72$export$f6c61b63a81bc74a = {}));
var $2f512219da033f72$export$36ca2010d8fa9f9a;
(function(MarketplaceStoreInstallationTargetProduct) {
    MarketplaceStoreInstallationTargetProduct["Compass"] = "COMPASS";
    MarketplaceStoreInstallationTargetProduct["Confluence"] = "CONFLUENCE";
    MarketplaceStoreInstallationTargetProduct["Jira"] = "JIRA";
})($2f512219da033f72$export$36ca2010d8fa9f9a || ($2f512219da033f72$export$36ca2010d8fa9f9a = {}));
var $2f512219da033f72$export$ebb4384456a718fc;
(function(MarketplaceStorePartnerEnrollmentProgram) {
    MarketplaceStorePartnerEnrollmentProgram["MarketplacePartner"] = "MARKETPLACE_PARTNER";
    MarketplaceStorePartnerEnrollmentProgram["SolutionPartner"] = "SOLUTION_PARTNER";
})($2f512219da033f72$export$ebb4384456a718fc || ($2f512219da033f72$export$ebb4384456a718fc = {}));
var $2f512219da033f72$export$e29b364dec316f58;
(function(MarketplaceStorePartnerEnrollmentProgramValue) {
    MarketplaceStorePartnerEnrollmentProgramValue["Gold"] = "GOLD";
    MarketplaceStorePartnerEnrollmentProgramValue["Platinum"] = "PLATINUM";
    MarketplaceStorePartnerEnrollmentProgramValue["Silver"] = "SILVER";
})($2f512219da033f72$export$e29b364dec316f58 || ($2f512219da033f72$export$e29b364dec316f58 = {}));
var $2f512219da033f72$export$9f0778caa5aa9129;
(function(MarketplaceStorePartnerSupportAvailabilityDay) {
    MarketplaceStorePartnerSupportAvailabilityDay["Friday"] = "FRIDAY";
    MarketplaceStorePartnerSupportAvailabilityDay["Monday"] = "MONDAY";
    MarketplaceStorePartnerSupportAvailabilityDay["Saturday"] = "SATURDAY";
    MarketplaceStorePartnerSupportAvailabilityDay["Sunday"] = "SUNDAY";
    MarketplaceStorePartnerSupportAvailabilityDay["Thursday"] = "THURSDAY";
    MarketplaceStorePartnerSupportAvailabilityDay["Tuesday"] = "TUESDAY";
    MarketplaceStorePartnerSupportAvailabilityDay["Wednesday"] = "WEDNESDAY";
})($2f512219da033f72$export$9f0778caa5aa9129 || ($2f512219da033f72$export$9f0778caa5aa9129 = {}));
var $2f512219da033f72$export$81bd7d703c9c9b4c;
(function(MarketplaceStorePricingCurrency) {
    MarketplaceStorePricingCurrency["Jpy"] = "JPY";
    MarketplaceStorePricingCurrency["Usd"] = "USD";
})($2f512219da033f72$export$81bd7d703c9c9b4c || ($2f512219da033f72$export$81bd7d703c9c9b4c = {}));
var $2f512219da033f72$export$5bd05159c340bc65;
(function(MarketplaceStoreReviewsSorting) {
    MarketplaceStoreReviewsSorting["Helpful"] = "HELPFUL";
    MarketplaceStoreReviewsSorting["Recent"] = "RECENT";
})($2f512219da033f72$export$5bd05159c340bc65 || ($2f512219da033f72$export$5bd05159c340bc65 = {}));
var $2f512219da033f72$export$2dd83c49139620d1;
(function(MembershipRole) {
    /** A team member with administrative permissions */ MembershipRole["Admin"] = "ADMIN";
    /** A regular team member */ MembershipRole["Regular"] = "REGULAR";
})($2f512219da033f72$export$2dd83c49139620d1 || ($2f512219da033f72$export$2dd83c49139620d1 = {}));
var $2f512219da033f72$export$86e062496769357c;
(function(MembershipSetting) {
    /** Members may invite others to join the team */ MembershipSetting["MemberInvite"] = "MEMBER_INVITE";
    /** Anyone may join */ MembershipSetting["Open"] = "OPEN";
})($2f512219da033f72$export$86e062496769357c || ($2f512219da033f72$export$86e062496769357c = {}));
var $2f512219da033f72$export$74cd14b61afb55b0;
(function(MembershipState) {
    /** A member who was previously a full member of the team, but has been removed or has left the team */ MembershipState["Alumni"] = "ALUMNI";
    /** A full member of the team */ MembershipState["FullMember"] = "FULL_MEMBER";
    /** A member who has been invited to the team but has not yet joined */ MembershipState["Invited"] = "INVITED";
    /** A member who has requested to join the team and is pending approval */ MembershipState["RequestingToJoin"] = "REQUESTING_TO_JOIN";
})($2f512219da033f72$export$74cd14b61afb55b0 || ($2f512219da033f72$export$74cd14b61afb55b0 = {}));
var $2f512219da033f72$export$973400a550f738ec;
(function(MercuryAggregatedHeadcountSortField) {
    MercuryAggregatedHeadcountSortField["FilledPositions"] = "FILLED_POSITIONS";
    MercuryAggregatedHeadcountSortField["OpenPositions"] = "OPEN_POSITIONS";
    MercuryAggregatedHeadcountSortField["TotalHeadcount"] = "TOTAL_HEADCOUNT";
})($2f512219da033f72$export$973400a550f738ec || ($2f512219da033f72$export$973400a550f738ec = {}));
var $2f512219da033f72$export$d617424552c630d7;
(function(MercuryChangeProposalSortField) {
    MercuryChangeProposalSortField["Name"] = "NAME";
})($2f512219da033f72$export$d617424552c630d7 || ($2f512219da033f72$export$d617424552c630d7 = {}));
var $2f512219da033f72$export$bc3e48f4065d763e;
(function(MercuryEntityType) {
    MercuryEntityType["Comment"] = "COMMENT";
    MercuryEntityType["FocusArea"] = "FOCUS_AREA";
    MercuryEntityType["FocusAreaStatusUpdate"] = "FOCUS_AREA_STATUS_UPDATE";
    MercuryEntityType["Program"] = "PROGRAM";
    MercuryEntityType["ProgramStatusUpdate"] = "PROGRAM_STATUS_UPDATE";
})($2f512219da033f72$export$bc3e48f4065d763e || ($2f512219da033f72$export$bc3e48f4065d763e = {}));
var $2f512219da033f72$export$c73583e70d228a11;
(function(MercuryEventType) {
    MercuryEventType["Create"] = "CREATE";
    MercuryEventType["CreateUpdate"] = "CREATE_UPDATE";
    MercuryEventType["Delete"] = "DELETE";
    MercuryEventType["DeleteUpdate"] = "DELETE_UPDATE";
    MercuryEventType["EditUpdate"] = "EDIT_UPDATE";
    MercuryEventType["Export"] = "EXPORT";
    MercuryEventType["Import"] = "IMPORT";
    MercuryEventType["Link"] = "LINK";
    MercuryEventType["Unlink"] = "UNLINK";
    MercuryEventType["Update"] = "UPDATE";
})($2f512219da033f72$export$c73583e70d228a11 || ($2f512219da033f72$export$c73583e70d228a11 = {}));
var $2f512219da033f72$export$b8aac8b3d4a5c526;
(function(MercuryFocusAreaHealthColor) {
    MercuryFocusAreaHealthColor["Green"] = "GREEN";
    MercuryFocusAreaHealthColor["Red"] = "RED";
    MercuryFocusAreaHealthColor["Yellow"] = "YELLOW";
})($2f512219da033f72$export$b8aac8b3d4a5c526 || ($2f512219da033f72$export$b8aac8b3d4a5c526 = {}));
var $2f512219da033f72$export$aabad147dc044911;
(function(MercuryFocusAreaHierarchySortField) {
    MercuryFocusAreaHierarchySortField["HierarchyLevel"] = "HIERARCHY_LEVEL";
    MercuryFocusAreaHierarchySortField["Name"] = "NAME";
})($2f512219da033f72$export$aabad147dc044911 || ($2f512219da033f72$export$aabad147dc044911 = {}));
var $2f512219da033f72$export$a1abf0dad11e643b;
(function(MercuryFocusAreaSortField) {
    MercuryFocusAreaSortField["Budget"] = "BUDGET";
    MercuryFocusAreaSortField["FocusAreaType"] = "FOCUS_AREA_TYPE";
    MercuryFocusAreaSortField["HasParent"] = "HAS_PARENT";
    MercuryFocusAreaSortField["HierarchyLevel"] = "HIERARCHY_LEVEL";
    MercuryFocusAreaSortField["LastUpdated"] = "LAST_UPDATED";
    MercuryFocusAreaSortField["Name"] = "NAME";
    MercuryFocusAreaSortField["Spend"] = "SPEND";
    MercuryFocusAreaSortField["Status"] = "STATUS";
    MercuryFocusAreaSortField["TargetDate"] = "TARGET_DATE";
    MercuryFocusAreaSortField["Watching"] = "WATCHING";
})($2f512219da033f72$export$a1abf0dad11e643b || ($2f512219da033f72$export$a1abf0dad11e643b = {}));
var $2f512219da033f72$export$64e01af19826bbd8;
(function(MercuryFocusAreaTeamAllocationAggregationSortField) {
    MercuryFocusAreaTeamAllocationAggregationSortField["FilledPositions"] = "FILLED_POSITIONS";
    MercuryFocusAreaTeamAllocationAggregationSortField["OpenPositions"] = "OPEN_POSITIONS";
    MercuryFocusAreaTeamAllocationAggregationSortField["TeamName"] = "TEAM_NAME";
    MercuryFocusAreaTeamAllocationAggregationSortField["TotalPositions"] = "TOTAL_POSITIONS";
})($2f512219da033f72$export$64e01af19826bbd8 || ($2f512219da033f72$export$64e01af19826bbd8 = {}));
var $2f512219da033f72$export$dabf182ed7e8bf64;
(function(MercuryProjectStatusColor) {
    MercuryProjectStatusColor["Blue"] = "BLUE";
    MercuryProjectStatusColor["Gray"] = "GRAY";
    MercuryProjectStatusColor["Green"] = "GREEN";
    /** @deprecated Mercury does not require this colour */ MercuryProjectStatusColor["Red"] = "RED";
    /** @deprecated Mercury does not require this colour */ MercuryProjectStatusColor["Yellow"] = "YELLOW";
})($2f512219da033f72$export$dabf182ed7e8bf64 || ($2f512219da033f72$export$dabf182ed7e8bf64 = {}));
var $2f512219da033f72$export$320c5706f8bb04ac;
(function(MercuryProjectTargetDateType) {
    MercuryProjectTargetDateType["Day"] = "DAY";
    MercuryProjectTargetDateType["Month"] = "MONTH";
    MercuryProjectTargetDateType["Quarter"] = "QUARTER";
})($2f512219da033f72$export$320c5706f8bb04ac || ($2f512219da033f72$export$320c5706f8bb04ac = {}));
var $2f512219da033f72$export$ae3bb205c58a2aef;
(function(MercuryProviderConfigurationStatus) {
    MercuryProviderConfigurationStatus["Connected"] = "CONNECTED";
    MercuryProviderConfigurationStatus["SignUp"] = "SIGN_UP";
})($2f512219da033f72$export$ae3bb205c58a2aef || ($2f512219da033f72$export$ae3bb205c58a2aef = {}));
var $2f512219da033f72$export$3733411202b02987;
(function(MercuryProviderWorkErrorType) {
    MercuryProviderWorkErrorType["Invalid"] = "INVALID";
    MercuryProviderWorkErrorType["NotFound"] = "NOT_FOUND";
    MercuryProviderWorkErrorType["NoPermissions"] = "NO_PERMISSIONS";
})($2f512219da033f72$export$3733411202b02987 || ($2f512219da033f72$export$3733411202b02987 = {}));
var $2f512219da033f72$export$9f4b40ce69c1d6a5;
(function(MercuryProviderWorkStatusColor) {
    MercuryProviderWorkStatusColor["Blue"] = "BLUE";
    MercuryProviderWorkStatusColor["Gray"] = "GRAY";
    MercuryProviderWorkStatusColor["Green"] = "GREEN";
    MercuryProviderWorkStatusColor["Red"] = "RED";
    MercuryProviderWorkStatusColor["Yellow"] = "YELLOW";
})($2f512219da033f72$export$9f4b40ce69c1d6a5 || ($2f512219da033f72$export$9f4b40ce69c1d6a5 = {}));
var $2f512219da033f72$export$26be07f0f07696ad;
(function(MercuryProviderWorkTargetDateType) {
    MercuryProviderWorkTargetDateType["Day"] = "DAY";
    MercuryProviderWorkTargetDateType["Month"] = "MONTH";
    MercuryProviderWorkTargetDateType["Quarter"] = "QUARTER";
})($2f512219da033f72$export$26be07f0f07696ad || ($2f512219da033f72$export$26be07f0f07696ad = {}));
var $2f512219da033f72$export$34fe7352d687be72;
(function(MercuryStrategicEventSortField) {
    MercuryStrategicEventSortField["Name"] = "NAME";
    MercuryStrategicEventSortField["Status"] = "STATUS";
    MercuryStrategicEventSortField["TargetDate"] = "TARGET_DATE";
})($2f512219da033f72$export$34fe7352d687be72 || ($2f512219da033f72$export$34fe7352d687be72 = {}));
var $2f512219da033f72$export$5615eb511c3f7b44;
(function(MercuryTargetDateType) {
    MercuryTargetDateType["Day"] = "DAY";
    MercuryTargetDateType["Month"] = "MONTH";
    MercuryTargetDateType["Quarter"] = "QUARTER";
})($2f512219da033f72$export$5615eb511c3f7b44 || ($2f512219da033f72$export$5615eb511c3f7b44 = {}));
var $2f512219da033f72$export$6eb0d144e13a497b;
(function(MercuryTeamFocusAreaAllocationSortField) {
    MercuryTeamFocusAreaAllocationSortField["FilledPositions"] = "FILLED_POSITIONS";
    MercuryTeamFocusAreaAllocationSortField["OpenPositions"] = "OPEN_POSITIONS";
})($2f512219da033f72$export$6eb0d144e13a497b || ($2f512219da033f72$export$6eb0d144e13a497b = {}));
var $2f512219da033f72$export$8c8ab86a3ad574d9;
(function(MercuryTeamSortField) {
    MercuryTeamSortField["Name"] = "NAME";
})($2f512219da033f72$export$8c8ab86a3ad574d9 || ($2f512219da033f72$export$8c8ab86a3ad574d9 = {}));
var $2f512219da033f72$export$e5ba5b8b5f2756a8;
(function(MigrationEventStatus) {
    MigrationEventStatus["Cancelled"] = "CANCELLED";
    MigrationEventStatus["Cancelling"] = "CANCELLING";
    MigrationEventStatus["Failed"] = "FAILED";
    MigrationEventStatus["Incomplete"] = "INCOMPLETE";
    MigrationEventStatus["InProgress"] = "IN_PROGRESS";
    MigrationEventStatus["Paused"] = "PAUSED";
    MigrationEventStatus["Ready"] = "READY";
    MigrationEventStatus["Skipped"] = "SKIPPED";
    MigrationEventStatus["Success"] = "SUCCESS";
    MigrationEventStatus["TimedOut"] = "TIMED_OUT";
})($2f512219da033f72$export$e5ba5b8b5f2756a8 || ($2f512219da033f72$export$e5ba5b8b5f2756a8 = {}));
var $2f512219da033f72$export$6b9f180c97bd81c9;
(function(MigrationEventType) {
    MigrationEventType["Container"] = "CONTAINER";
    MigrationEventType["Migration"] = "MIGRATION";
    MigrationEventType["Transfer"] = "TRANSFER";
})($2f512219da033f72$export$6b9f180c97bd81c9 || ($2f512219da033f72$export$6b9f180c97bd81c9 = {}));
var $2f512219da033f72$export$b68aeace563254a3;
(function(MissionControlFeatureDiscoverySuggestion) {
    MissionControlFeatureDiscoverySuggestion["SpaceManager"] = "SPACE_MANAGER";
    MissionControlFeatureDiscoverySuggestion["SpaceReports"] = "SPACE_REPORTS";
    MissionControlFeatureDiscoverySuggestion["UserAccess"] = "USER_ACCESS";
})($2f512219da033f72$export$b68aeace563254a3 || ($2f512219da033f72$export$b68aeace563254a3 = {}));
var $2f512219da033f72$export$a231d806d63674da;
(function(MissionControlMetricSuggestion) {
    MissionControlMetricSuggestion["DeactivatedPageOwners"] = "DEACTIVATED_PAGE_OWNERS";
    MissionControlMetricSuggestion["InactivePages"] = "INACTIVE_PAGES";
    MissionControlMetricSuggestion["UnassignedGuests"] = "UNASSIGNED_GUESTS";
})($2f512219da033f72$export$a231d806d63674da || ($2f512219da033f72$export$a231d806d63674da = {}));
var $2f512219da033f72$export$664fabf452bdb475;
(function(MobilePlatform) {
    MobilePlatform["Android"] = "ANDROID";
    MobilePlatform["Ios"] = "IOS";
})($2f512219da033f72$export$664fabf452bdb475 || ($2f512219da033f72$export$664fabf452bdb475 = {}));
var $2f512219da033f72$export$a7e8a9c9b5c9e259;
(function(NadelHydrationTemplate) {
    NadelHydrationTemplate["NadelPlaceholder"] = "NADEL_PLACEHOLDER";
})($2f512219da033f72$export$a7e8a9c9b5c9e259 || ($2f512219da033f72$export$a7e8a9c9b5c9e259 = {}));
var $2f512219da033f72$export$e129faa8dbff76aa;
(function(NlpDisclaimer) {
    NlpDisclaimer["WhoQuestion"] = "WHO_QUESTION";
})($2f512219da033f72$export$e129faa8dbff76aa || ($2f512219da033f72$export$e129faa8dbff76aa = {}));
var $2f512219da033f72$export$c5b04a82c748b9bd;
(function(NlpErrorState) {
    NlpErrorState["AcceptableUseViolations"] = "ACCEPTABLE_USE_VIOLATIONS";
    NlpErrorState["AiDisabled"] = "AI_DISABLED";
    NlpErrorState["NoAnswer"] = "NO_ANSWER";
    NlpErrorState["NoAnswerHydration"] = "NO_ANSWER_HYDRATION";
    NlpErrorState["NoAnswerKeywords"] = "NO_ANSWER_KEYWORDS";
    NlpErrorState["NoAnswerOpenAiResponseErr"] = "NO_ANSWER_OPEN_AI_RESPONSE_ERR";
    NlpErrorState["NoAnswerRelevantContent"] = "NO_ANSWER_RELEVANT_CONTENT";
    NlpErrorState["NoAnswerSearchResults"] = "NO_ANSWER_SEARCH_RESULTS";
    NlpErrorState["NoAnswerWhoQuestion"] = "NO_ANSWER_WHO_QUESTION";
    NlpErrorState["OpenaiRateLimitUserAbuse"] = "OPENAI_RATE_LIMIT_USER_ABUSE";
    NlpErrorState["SubjectiveQuery"] = "SUBJECTIVE_QUERY";
})($2f512219da033f72$export$c5b04a82c748b9bd || ($2f512219da033f72$export$c5b04a82c748b9bd = {}));
var $2f512219da033f72$export$db433339b7e07571;
(function(NlpGetKeywordsTextFormat) {
    NlpGetKeywordsTextFormat["Adf"] = "ADF";
    NlpGetKeywordsTextFormat["PlainText"] = "PLAIN_TEXT";
})($2f512219da033f72$export$db433339b7e07571 || ($2f512219da033f72$export$db433339b7e07571 = {}));
var $2f512219da033f72$export$b1971cd5d32db392;
(function(NlpSearchResultFormat) {
    NlpSearchResultFormat["Adf"] = "ADF";
    NlpSearchResultFormat["Json"] = "JSON";
    NlpSearchResultFormat["Markdown"] = "MARKDOWN";
    NlpSearchResultFormat["PlainText"] = "PLAIN_TEXT";
})($2f512219da033f72$export$b1971cd5d32db392 || ($2f512219da033f72$export$b1971cd5d32db392 = {}));
var $2f512219da033f72$export$3f22e424998acb73;
(function(NlpSearchResultType) {
    NlpSearchResultType["Blogpost"] = "blogpost";
    NlpSearchResultType["Page"] = "page";
    NlpSearchResultType["User"] = "user";
})($2f512219da033f72$export$3f22e424998acb73 || ($2f512219da033f72$export$3f22e424998acb73 = {}));
var $2f512219da033f72$export$fb999f8a83c64817;
(function(NotificationAction) {
    NotificationAction["DontNotify"] = "DONT_NOTIFY";
    NotificationAction["Notify"] = "NOTIFY";
})($2f512219da033f72$export$fb999f8a83c64817 || ($2f512219da033f72$export$fb999f8a83c64817 = {}));
var $2f512219da033f72$export$19d8a953b6c48689;
(function(NumberUserInputType) {
    NumberUserInputType["Number"] = "NUMBER";
})($2f512219da033f72$export$19d8a953b6c48689 || ($2f512219da033f72$export$19d8a953b6c48689 = {}));
var $2f512219da033f72$export$ab5aad00225c5662;
(function(Operation) {
    Operation["Assigned"] = "ASSIGNED";
    Operation["Complete"] = "COMPLETE";
    Operation["Deleted"] = "DELETED";
    Operation["InComplete"] = "IN_COMPLETE";
    Operation["Reworded"] = "REWORDED";
    Operation["Unassigned"] = "UNASSIGNED";
})($2f512219da033f72$export$ab5aad00225c5662 || ($2f512219da033f72$export$ab5aad00225c5662 = {}));
var $2f512219da033f72$export$40393097b8209d35;
(function(OutputDeviceType) {
    OutputDeviceType["Desktop"] = "DESKTOP";
    OutputDeviceType["Email"] = "EMAIL";
    OutputDeviceType["Mobile"] = "MOBILE";
})($2f512219da033f72$export$40393097b8209d35 || ($2f512219da033f72$export$40393097b8209d35 = {}));
var $2f512219da033f72$export$d197034e0ce6cbfa;
(function(PeapProgramStatus) {
    PeapProgramStatus["Abandoned"] = "ABANDONED";
    PeapProgramStatus["Active"] = "ACTIVE";
    PeapProgramStatus["Ended"] = "ENDED";
    PeapProgramStatus["New"] = "NEW";
})($2f512219da033f72$export$d197034e0ce6cbfa || ($2f512219da033f72$export$d197034e0ce6cbfa = {}));
var $2f512219da033f72$export$5a0f0b95fb039974;
(function(PtGraphQlPageStatus) {
    PtGraphQlPageStatus["Current"] = "CURRENT";
    PtGraphQlPageStatus["Draft"] = "DRAFT";
    PtGraphQlPageStatus["Historical"] = "HISTORICAL";
    PtGraphQlPageStatus["Trashed"] = "TRASHED";
})($2f512219da033f72$export$5a0f0b95fb039974 || ($2f512219da033f72$export$5a0f0b95fb039974 = {}));
var $2f512219da033f72$export$64ac2b5f448712fd;
(function(PageActivityAction) {
    PageActivityAction["Created"] = "created";
    PageActivityAction["Published"] = "published";
    PageActivityAction["Snapshotted"] = "snapshotted";
    PageActivityAction["Started"] = "started";
    PageActivityAction["Updated"] = "updated";
})($2f512219da033f72$export$64ac2b5f448712fd || ($2f512219da033f72$export$64ac2b5f448712fd = {}));
var $2f512219da033f72$export$2aad1bd9e74391f;
(function(PageActivityActionSubject) {
    PageActivityActionSubject["Comment"] = "comment";
    PageActivityActionSubject["Page"] = "page";
})($2f512219da033f72$export$2aad1bd9e74391f || ($2f512219da033f72$export$2aad1bd9e74391f = {}));
var $2f512219da033f72$export$946707219eda5f24;
(function(PageAnalyticsCountType) {
    PageAnalyticsCountType["All"] = "ALL";
    PageAnalyticsCountType["User"] = "USER";
})($2f512219da033f72$export$946707219eda5f24 || ($2f512219da033f72$export$946707219eda5f24 = {}));
var $2f512219da033f72$export$ad3bfb30b39d7ffd;
(function(PageAnalyticsTimeseriesCountType) {
    PageAnalyticsTimeseriesCountType["All"] = "ALL";
})($2f512219da033f72$export$ad3bfb30b39d7ffd || ($2f512219da033f72$export$ad3bfb30b39d7ffd = {}));
var $2f512219da033f72$export$8d4d3d8b2da7ecab;
(function(PageCardInPageTreeHoverPreference) {
    PageCardInPageTreeHoverPreference["NoOptionSelected"] = "NO_OPTION_SELECTED";
    PageCardInPageTreeHoverPreference["NoShowPagecard"] = "NO_SHOW_PAGECARD";
    PageCardInPageTreeHoverPreference["ShowPagecard"] = "SHOW_PAGECARD";
})($2f512219da033f72$export$8d4d3d8b2da7ecab || ($2f512219da033f72$export$8d4d3d8b2da7ecab = {}));
var $2f512219da033f72$export$6790c9faedcaca69;
(function(PageCopyRestrictionValidationStatus) {
    PageCopyRestrictionValidationStatus["InvalidMultiple"] = "INVALID_MULTIPLE";
    PageCopyRestrictionValidationStatus["InvalidSingle"] = "INVALID_SINGLE";
    PageCopyRestrictionValidationStatus["Valid"] = "VALID";
})($2f512219da033f72$export$6790c9faedcaca69 || ($2f512219da033f72$export$6790c9faedcaca69 = {}));
var $2f512219da033f72$export$d00cc0fdc8655a46;
(function(PageStatusInput) {
    PageStatusInput["Current"] = "CURRENT";
    PageStatusInput["Draft"] = "DRAFT";
})($2f512219da033f72$export$d00cc0fdc8655a46 || ($2f512219da033f72$export$d00cc0fdc8655a46 = {}));
var $2f512219da033f72$export$d37048b83c249679;
(function(PageUpdateTrigger) {
    PageUpdateTrigger["CreatePage"] = "CREATE_PAGE";
    PageUpdateTrigger["DiscardChanges"] = "DISCARD_CHANGES";
    PageUpdateTrigger["EditPage"] = "EDIT_PAGE";
    PageUpdateTrigger["LinkRefactoring"] = "LINK_REFACTORING";
    PageUpdateTrigger["MigratePageCollab"] = "MIGRATE_PAGE_COLLAB";
    PageUpdateTrigger["OwnerChange"] = "OWNER_CHANGE";
    PageUpdateTrigger["PageRename"] = "PAGE_RENAME";
    PageUpdateTrigger["PersonalTasklist"] = "PERSONAL_TASKLIST";
    PageUpdateTrigger["Revert"] = "REVERT";
    PageUpdateTrigger["SpaceCreate"] = "SPACE_CREATE";
    PageUpdateTrigger["Unknown"] = "UNKNOWN";
    PageUpdateTrigger["ViewPage"] = "VIEW_PAGE";
})($2f512219da033f72$export$d37048b83c249679 || ($2f512219da033f72$export$d37048b83c249679 = {}));
var $2f512219da033f72$export$e7cf5ba3dce96e2a;
(function(PagesDisplayPersistenceOption) {
    PagesDisplayPersistenceOption["Cards"] = "CARDS";
    PagesDisplayPersistenceOption["CompactList"] = "COMPACT_LIST";
    PagesDisplayPersistenceOption["List"] = "LIST";
})($2f512219da033f72$export$e7cf5ba3dce96e2a || ($2f512219da033f72$export$e7cf5ba3dce96e2a = {}));
var $2f512219da033f72$export$75155158100edfd1;
(function(PagesSortField) {
    PagesSortField["LastModifiedDate"] = "LAST_MODIFIED_DATE";
    PagesSortField["Relevant"] = "RELEVANT";
    PagesSortField["Title"] = "TITLE";
})($2f512219da033f72$export$75155158100edfd1 || ($2f512219da033f72$export$75155158100edfd1 = {}));
var $2f512219da033f72$export$b82b223ae4482fe3;
(function(PagesSortOrder) {
    PagesSortOrder["Asc"] = "ASC";
    PagesSortOrder["Desc"] = "DESC";
})($2f512219da033f72$export$b82b223ae4482fe3 || ($2f512219da033f72$export$b82b223ae4482fe3 = {}));
var $2f512219da033f72$export$20d511023e79b2f8;
(function(PartnerBtfLicenseType) {
    PartnerBtfLicenseType["Academic"] = "ACADEMIC";
    PartnerBtfLicenseType["Commercial"] = "COMMERCIAL";
    PartnerBtfLicenseType["Evaluation"] = "EVALUATION";
    PartnerBtfLicenseType["Starter"] = "STARTER";
})($2f512219da033f72$export$20d511023e79b2f8 || ($2f512219da033f72$export$20d511023e79b2f8 = {}));
var $2f512219da033f72$export$d8bdcda0cbd9a410;
(function(PartnerCloudLicenseType) {
    PartnerCloudLicenseType["Academic"] = "ACADEMIC";
    PartnerCloudLicenseType["Commercial"] = "COMMERCIAL";
    PartnerCloudLicenseType["Community"] = "COMMUNITY";
    PartnerCloudLicenseType["Demonstration"] = "DEMONSTRATION";
    PartnerCloudLicenseType["Developer"] = "DEVELOPER";
    PartnerCloudLicenseType["Evaluation"] = "EVALUATION";
    PartnerCloudLicenseType["Free"] = "FREE";
    PartnerCloudLicenseType["OpenSource"] = "OPEN_SOURCE";
    PartnerCloudLicenseType["Starter"] = "STARTER";
})($2f512219da033f72$export$d8bdcda0cbd9a410 || ($2f512219da033f72$export$d8bdcda0cbd9a410 = {}));
var $2f512219da033f72$export$f0c4b6a2f4cddbe1;
(function(PartnerCurrency) {
    PartnerCurrency["Jpy"] = "JPY";
    PartnerCurrency["Usd"] = "USD";
})($2f512219da033f72$export$f0c4b6a2f4cddbe1 || ($2f512219da033f72$export$f0c4b6a2f4cddbe1 = {}));
var $2f512219da033f72$export$e141851b33100510;
(function(PartnerInvoiceJsonCurrency) {
    PartnerInvoiceJsonCurrency["Aud"] = "AUD";
    PartnerInvoiceJsonCurrency["Eur"] = "EUR";
    PartnerInvoiceJsonCurrency["Gbp"] = "GBP";
    PartnerInvoiceJsonCurrency["Jpy"] = "JPY";
    PartnerInvoiceJsonCurrency["Usd"] = "USD";
})($2f512219da033f72$export$e141851b33100510 || ($2f512219da033f72$export$e141851b33100510 = {}));
var $2f512219da033f72$export$1ede5f4f7cadbc19;
(function(PathType) {
    PathType["Absolute"] = "ABSOLUTE";
    PathType["Relative"] = "RELATIVE";
    PathType["RelativeNoContext"] = "RELATIVE_NO_CONTEXT";
})($2f512219da033f72$export$1ede5f4f7cadbc19 || ($2f512219da033f72$export$1ede5f4f7cadbc19 = {}));
var $2f512219da033f72$export$d9669dcdbd1161d9;
(function(PaywallStatus) {
    PaywallStatus["Active"] = "ACTIVE";
    PaywallStatus["Deactivated"] = "DEACTIVATED";
    PaywallStatus["Unset"] = "UNSET";
})($2f512219da033f72$export$d9669dcdbd1161d9 || ($2f512219da033f72$export$d9669dcdbd1161d9 = {}));
var $2f512219da033f72$export$f1a726cdbae0d72a;
(function(PermissionDisplayType) {
    PermissionDisplayType["Anonymous"] = "ANONYMOUS";
    PermissionDisplayType["Group"] = "GROUP";
    PermissionDisplayType["GuestUser"] = "GUEST_USER";
    PermissionDisplayType["LicensedUser"] = "LICENSED_USER";
})($2f512219da033f72$export$f1a726cdbae0d72a || ($2f512219da033f72$export$f1a726cdbae0d72a = {}));
var $2f512219da033f72$export$75869504556f3325;
(function(PermsReportTargetType) {
    PermsReportTargetType["Group"] = "GROUP";
    PermsReportTargetType["User"] = "USER";
})($2f512219da033f72$export$75869504556f3325 || ($2f512219da033f72$export$75869504556f3325 = {}));
var $2f512219da033f72$export$f2dc2b898b108911;
(function(PlanModeDestination) {
    PlanModeDestination["Backlog"] = "BACKLOG";
    PlanModeDestination["Board"] = "BOARD";
    PlanModeDestination["Sprint"] = "SPRINT";
})($2f512219da033f72$export$f2dc2b898b108911 || ($2f512219da033f72$export$f2dc2b898b108911 = {}));
var $2f512219da033f72$export$2dffd0b5373a4389;
(function(Platform) {
    Platform["Android"] = "ANDROID";
    Platform["Ios"] = "IOS";
    Platform["Web"] = "WEB";
})($2f512219da033f72$export$2dffd0b5373a4389 || ($2f512219da033f72$export$2dffd0b5373a4389 = {}));
var $2f512219da033f72$export$2cbcdf3f71413e2f;
(function(PolarisCommentKind) {
    PolarisCommentKind["PlayContribution"] = "PLAY_CONTRIBUTION";
    PolarisCommentKind["View"] = "VIEW";
})($2f512219da033f72$export$2cbcdf3f71413e2f || ($2f512219da033f72$export$2cbcdf3f71413e2f = {}));
var $2f512219da033f72$export$fb5683d231e089bf;
(function(PolarisFieldType) {
    PolarisFieldType["PolarisIdeaPlayField"] = "PolarisIdeaPlayField";
    PolarisFieldType["PolarisJiraField"] = "PolarisJiraField";
})($2f512219da033f72$export$fb5683d231e089bf || ($2f512219da033f72$export$fb5683d231e089bf = {}));
var $2f512219da033f72$export$6ce5461c35ff17aa;
(function(PolarisFilterEnumType) {
    PolarisFilterEnumType["BoardColumn"] = "BOARD_COLUMN";
    PolarisFilterEnumType["ViewGroup"] = "VIEW_GROUP";
})($2f512219da033f72$export$6ce5461c35ff17aa || ($2f512219da033f72$export$6ce5461c35ff17aa = {}));
var $2f512219da033f72$export$123c361c0586acd4;
(function(PolarisPlayKind) {
    PolarisPlayKind["PolarisBudgetAllocationPlay"] = "PolarisBudgetAllocationPlay";
})($2f512219da033f72$export$123c361c0586acd4 || ($2f512219da033f72$export$123c361c0586acd4 = {}));
var $2f512219da033f72$export$ec111ec92c0d7d70;
(function(PolarisRefreshError) {
    PolarisRefreshError["InternalError"] = "INTERNAL_ERROR";
    PolarisRefreshError["InvalidSnippet"] = "INVALID_SNIPPET";
    PolarisRefreshError["NeedAuth"] = "NEED_AUTH";
    PolarisRefreshError["NotFound"] = "NOT_FOUND";
})($2f512219da033f72$export$ec111ec92c0d7d70 || ($2f512219da033f72$export$ec111ec92c0d7d70 = {}));
var $2f512219da033f72$export$f3e14b5f4d20c3d5;
(function(PolarisResolvedObjectAuthType) {
    PolarisResolvedObjectAuthType["ApiKey"] = "API_KEY";
    PolarisResolvedObjectAuthType["Oauth2"] = "OAUTH2";
})($2f512219da033f72$export$f3e14b5f4d20c3d5 || ($2f512219da033f72$export$f3e14b5f4d20c3d5 = {}));
var $2f512219da033f72$export$57783d255575ae4b;
(function(PolarisSnippetPropertyKind) {
    /** 1-5 integer rating */ PolarisSnippetPropertyKind["Labels"] = "LABELS";
    PolarisSnippetPropertyKind["Number"] = "NUMBER";
    /** generic number */ PolarisSnippetPropertyKind["Rating"] = "RATING";
})($2f512219da033f72$export$57783d255575ae4b || ($2f512219da033f72$export$57783d255575ae4b = {}));
var $2f512219da033f72$export$bda785e7d71f1240;
(function(PolarisSortOrder) {
    PolarisSortOrder["Asc"] = "ASC";
    PolarisSortOrder["Desc"] = "DESC";
})($2f512219da033f72$export$bda785e7d71f1240 || ($2f512219da033f72$export$bda785e7d71f1240 = {}));
var $2f512219da033f72$export$14a23e97810cf04b;
(function(PolarisTimelineMode) {
    PolarisTimelineMode["Months"] = "MONTHS";
    PolarisTimelineMode["Quarters"] = "QUARTERS";
    PolarisTimelineMode["Years"] = "YEARS";
})($2f512219da033f72$export$14a23e97810cf04b || ($2f512219da033f72$export$14a23e97810cf04b = {}));
var $2f512219da033f72$export$2b6d541a0ba09b1f;
(function(PolarisValueOperator) {
    PolarisValueOperator["Eq"] = "EQ";
    PolarisValueOperator["Gt"] = "GT";
    PolarisValueOperator["Gte"] = "GTE";
    PolarisValueOperator["Lt"] = "LT";
    PolarisValueOperator["Lte"] = "LTE";
})($2f512219da033f72$export$2b6d541a0ba09b1f || ($2f512219da033f72$export$2b6d541a0ba09b1f = {}));
var $2f512219da033f72$export$dbd70c8a392059ec;
(function(PolarisViewFieldRollupType) {
    PolarisViewFieldRollupType["Avg"] = "AVG";
    PolarisViewFieldRollupType["Count"] = "COUNT";
    PolarisViewFieldRollupType["Empty"] = "EMPTY";
    PolarisViewFieldRollupType["Filled"] = "FILLED";
    PolarisViewFieldRollupType["Max"] = "MAX";
    PolarisViewFieldRollupType["Median"] = "MEDIAN";
    PolarisViewFieldRollupType["Min"] = "MIN";
    PolarisViewFieldRollupType["Range"] = "RANGE";
    PolarisViewFieldRollupType["Sum"] = "SUM";
})($2f512219da033f72$export$dbd70c8a392059ec || ($2f512219da033f72$export$dbd70c8a392059ec = {}));
var $2f512219da033f72$export$54183e329a6730fd;
(function(PolarisViewFilterKind) {
    PolarisViewFilterKind["ConnectionFieldIdentity"] = "CONNECTION_FIELD_IDENTITY";
    PolarisViewFilterKind["FieldIdentity"] = "FIELD_IDENTITY";
    /** a field being matched by identity */ PolarisViewFilterKind["FieldNumeric"] = "FIELD_NUMERIC";
    PolarisViewFilterKind["Interval"] = "INTERVAL";
    /** a field being matched by numeric comparison */ PolarisViewFilterKind["Text"] = "TEXT";
})($2f512219da033f72$export$54183e329a6730fd || ($2f512219da033f72$export$54183e329a6730fd = {}));
var $2f512219da033f72$export$d6c8f262b1709692;
(function(PolarisViewFilterOperator) {
    PolarisViewFilterOperator["EndAfterNow"] = "END_AFTER_NOW";
    PolarisViewFilterOperator["EndBeforeNow"] = "END_BEFORE_NOW";
    PolarisViewFilterOperator["Eq"] = "EQ";
    PolarisViewFilterOperator["Gt"] = "GT";
    PolarisViewFilterOperator["Gte"] = "GTE";
    PolarisViewFilterOperator["Lt"] = "LT";
    PolarisViewFilterOperator["Lte"] = "LTE";
    PolarisViewFilterOperator["Neq"] = "NEQ";
    PolarisViewFilterOperator["StartAfterNow"] = "START_AFTER_NOW";
    PolarisViewFilterOperator["StartBeforeNow"] = "START_BEFORE_NOW";
})($2f512219da033f72$export$d6c8f262b1709692 || ($2f512219da033f72$export$d6c8f262b1709692 = {}));
var $2f512219da033f72$export$2503fee82ee05536;
(function(PolarisViewLayoutType) {
    PolarisViewLayoutType["Compact"] = "COMPACT";
    PolarisViewLayoutType["Detailed"] = "DETAILED";
    PolarisViewLayoutType["Summary"] = "SUMMARY";
})($2f512219da033f72$export$2503fee82ee05536 || ($2f512219da033f72$export$2503fee82ee05536 = {}));
var $2f512219da033f72$export$975689d1b7b4351b;
(function(PolarisViewSetType) {
    PolarisViewSetType["Capture"] = "CAPTURE";
    PolarisViewSetType["Custom"] = "CUSTOM";
    PolarisViewSetType["Deliver"] = "DELIVER";
    PolarisViewSetType["Prioritize"] = "PRIORITIZE";
    /** for views that are used to manage the display of single ideas (e.g., Idea views) */ PolarisViewSetType["Section"] = "SECTION";
    PolarisViewSetType["Single"] = "SINGLE";
    PolarisViewSetType["System"] = "SYSTEM";
})($2f512219da033f72$export$975689d1b7b4351b || ($2f512219da033f72$export$975689d1b7b4351b = {}));
var $2f512219da033f72$export$6d557cf9ccdcf3b3;
(function(PolarisViewSortMode) {
    PolarisViewSortMode["FieldsSort"] = "FIELDS_SORT";
    PolarisViewSortMode["ProjectRank"] = "PROJECT_RANK";
    PolarisViewSortMode["ViewRank"] = "VIEW_RANK";
})($2f512219da033f72$export$6d557cf9ccdcf3b3 || ($2f512219da033f72$export$6d557cf9ccdcf3b3 = {}));
var $2f512219da033f72$export$9dec0b77614b677b;
(function(PolarisVisualizationType) {
    PolarisVisualizationType["Board"] = "BOARD";
    PolarisVisualizationType["Collection"] = "COLLECTION";
    PolarisVisualizationType["Matrix"] = "MATRIX";
    PolarisVisualizationType["Section"] = "SECTION";
    PolarisVisualizationType["Table"] = "TABLE";
    PolarisVisualizationType["Timeline"] = "TIMELINE";
    PolarisVisualizationType["Twoxtwo"] = "TWOXTWO";
})($2f512219da033f72$export$9dec0b77614b677b || ($2f512219da033f72$export$9dec0b77614b677b = {}));
var $2f512219da033f72$export$c68cf5b85bcf89b0;
(function(PrincipalFilterType) {
    PrincipalFilterType["Group"] = "GROUP";
    PrincipalFilterType["Guest"] = "GUEST";
    PrincipalFilterType["Team"] = "TEAM";
    PrincipalFilterType["User"] = "USER";
})($2f512219da033f72$export$c68cf5b85bcf89b0 || ($2f512219da033f72$export$c68cf5b85bcf89b0 = {}));
var $2f512219da033f72$export$39adac38571da5a2;
(function(PrincipalType) {
    PrincipalType["Anonymous"] = "ANONYMOUS";
    PrincipalType["Customer"] = "CUSTOMER";
    PrincipalType["Unlicensed"] = "UNLICENSED";
})($2f512219da033f72$export$39adac38571da5a2 || ($2f512219da033f72$export$39adac38571da5a2 = {}));
var $2f512219da033f72$export$264ad599d7cef668;
(function(Product) {
    Product["Confluence"] = "CONFLUENCE";
})($2f512219da033f72$export$264ad599d7cef668 || ($2f512219da033f72$export$264ad599d7cef668 = {}));
var $2f512219da033f72$export$71a6257cca19a8a8;
(function(PublicLinkAdminAction) {
    PublicLinkAdminAction["Block"] = "BLOCK";
    PublicLinkAdminAction["Off"] = "OFF";
    PublicLinkAdminAction["On"] = "ON";
    PublicLinkAdminAction["Unblock"] = "UNBLOCK";
})($2f512219da033f72$export$71a6257cca19a8a8 || ($2f512219da033f72$export$71a6257cca19a8a8 = {}));
var $2f512219da033f72$export$d978fb4cfc723d14;
(function(PublicLinkDefaultSpaceStatus) {
    PublicLinkDefaultSpaceStatus["Off"] = "OFF";
    PublicLinkDefaultSpaceStatus["On"] = "ON";
})($2f512219da033f72$export$d978fb4cfc723d14 || ($2f512219da033f72$export$d978fb4cfc723d14 = {}));
var $2f512219da033f72$export$cb24eb3958583602;
(function(PublicLinkPageStatus) {
    PublicLinkPageStatus["BlockedByClassificationLevel"] = "BLOCKED_BY_CLASSIFICATION_LEVEL";
    PublicLinkPageStatus["BlockedByContainerPolicy"] = "BLOCKED_BY_CONTAINER_POLICY";
    PublicLinkPageStatus["BlockedByOrg"] = "BLOCKED_BY_ORG";
    PublicLinkPageStatus["BlockedByProduct"] = "BLOCKED_BY_PRODUCT";
    PublicLinkPageStatus["BlockedBySpace"] = "BLOCKED_BY_SPACE";
    PublicLinkPageStatus["Off"] = "OFF";
    PublicLinkPageStatus["On"] = "ON";
    PublicLinkPageStatus["SiteBlocked"] = "SITE_BLOCKED";
    PublicLinkPageStatus["SiteDisabled"] = "SITE_DISABLED";
    PublicLinkPageStatus["SpaceBlocked"] = "SPACE_BLOCKED";
    PublicLinkPageStatus["SpaceDisabled"] = "SPACE_DISABLED";
})($2f512219da033f72$export$cb24eb3958583602 || ($2f512219da033f72$export$cb24eb3958583602 = {}));
var $2f512219da033f72$export$fcb2676e4c5b8efd;
(function(PublicLinkPermissionsObjectType) {
    PublicLinkPermissionsObjectType["Content"] = "CONTENT";
})($2f512219da033f72$export$fcb2676e4c5b8efd || ($2f512219da033f72$export$fcb2676e4c5b8efd = {}));
var $2f512219da033f72$export$1d899d09218cc934;
(function(PublicLinkPermissionsType) {
    PublicLinkPermissionsType["Edit"] = "EDIT";
})($2f512219da033f72$export$1d899d09218cc934 || ($2f512219da033f72$export$1d899d09218cc934 = {}));
var $2f512219da033f72$export$b1788c464c408aed;
(function(PublicLinkSiteStatus) {
    PublicLinkSiteStatus["BlockedByOrg"] = "BLOCKED_BY_ORG";
    PublicLinkSiteStatus["Off"] = "OFF";
    PublicLinkSiteStatus["On"] = "ON";
})($2f512219da033f72$export$b1788c464c408aed || ($2f512219da033f72$export$b1788c464c408aed = {}));
var $2f512219da033f72$export$d044f97b106be0ee;
(function(PublicLinkSpaceStatus) {
    PublicLinkSpaceStatus["BlockedByContainerPolicy"] = "BLOCKED_BY_CONTAINER_POLICY";
    PublicLinkSpaceStatus["BlockedByOrg"] = "BLOCKED_BY_ORG";
    PublicLinkSpaceStatus["BlockedByProduct"] = "BLOCKED_BY_PRODUCT";
    PublicLinkSpaceStatus["Off"] = "OFF";
    PublicLinkSpaceStatus["On"] = "ON";
})($2f512219da033f72$export$d044f97b106be0ee || ($2f512219da033f72$export$d044f97b106be0ee = {}));
var $2f512219da033f72$export$cb38a0280f90ee03;
(function(PublicLinkSpacesByCriteriaOrder) {
    PublicLinkSpacesByCriteriaOrder["ActiveLinks"] = "ACTIVE_LINKS";
    PublicLinkSpacesByCriteriaOrder["Name"] = "NAME";
    PublicLinkSpacesByCriteriaOrder["Status"] = "STATUS";
})($2f512219da033f72$export$cb38a0280f90ee03 || ($2f512219da033f72$export$cb38a0280f90ee03 = {}));
var $2f512219da033f72$export$90d7a60018d7cff3;
(function(PublicLinkStatus) {
    PublicLinkStatus["BlockedByClassificationLevel"] = "BLOCKED_BY_CLASSIFICATION_LEVEL";
    PublicLinkStatus["BlockedByContainerPolicy"] = "BLOCKED_BY_CONTAINER_POLICY";
    PublicLinkStatus["BlockedByOrg"] = "BLOCKED_BY_ORG";
    PublicLinkStatus["BlockedByProduct"] = "BLOCKED_BY_PRODUCT";
    PublicLinkStatus["BlockedBySpace"] = "BLOCKED_BY_SPACE";
    PublicLinkStatus["Off"] = "OFF";
    PublicLinkStatus["On"] = "ON";
    PublicLinkStatus["SiteBlocked"] = "SITE_BLOCKED";
    PublicLinkStatus["SiteDisabled"] = "SITE_DISABLED";
    PublicLinkStatus["SpaceBlocked"] = "SPACE_BLOCKED";
    PublicLinkStatus["SpaceDisabled"] = "SPACE_DISABLED";
})($2f512219da033f72$export$90d7a60018d7cff3 || ($2f512219da033f72$export$90d7a60018d7cff3 = {}));
var $2f512219da033f72$export$c5e160c0f2685c5e;
(function(PublicLinksByCriteriaOrder) {
    PublicLinksByCriteriaOrder["DateEnabled"] = "DATE_ENABLED";
    PublicLinksByCriteriaOrder["Status"] = "STATUS";
    PublicLinksByCriteriaOrder["Title"] = "TITLE";
})($2f512219da033f72$export$c5e160c0f2685c5e || ($2f512219da033f72$export$c5e160c0f2685c5e = {}));
var $2f512219da033f72$export$637f1b6475b561ba;
(function(PushNotificationGroupInputType) {
    PushNotificationGroupInputType["None"] = "NONE";
    PushNotificationGroupInputType["Quiet"] = "QUIET";
    PushNotificationGroupInputType["Standard"] = "STANDARD";
})($2f512219da033f72$export$637f1b6475b561ba || ($2f512219da033f72$export$637f1b6475b561ba = {}));
var $2f512219da033f72$export$4b76a95472d63873;
(function(PushNotificationSettingGroup) {
    PushNotificationSettingGroup["Custom"] = "CUSTOM";
    PushNotificationSettingGroup["None"] = "NONE";
    PushNotificationSettingGroup["Quiet"] = "QUIET";
    PushNotificationSettingGroup["Standard"] = "STANDARD";
})($2f512219da033f72$export$4b76a95472d63873 || ($2f512219da033f72$export$4b76a95472d63873 = {}));
var $2f512219da033f72$export$7c8e26efb80b90e8;
(function(QueryType) {
    QueryType["All"] = "ALL";
    QueryType["Delete"] = "DELETE";
    QueryType["Insert"] = "INSERT";
    QueryType["Other"] = "OTHER";
    QueryType["Select"] = "SELECT";
    QueryType["Update"] = "UPDATE";
})($2f512219da033f72$export$7c8e26efb80b90e8 || ($2f512219da033f72$export$7c8e26efb80b90e8 = {}));
var $2f512219da033f72$export$4530733bd84e25cd;
(function(RadarEntityType) {
    RadarEntityType["FocusArea"] = "focusArea";
    RadarEntityType["Position"] = "position";
    RadarEntityType["Worker"] = "worker";
})($2f512219da033f72$export$4530733bd84e25cd || ($2f512219da033f72$export$4530733bd84e25cd = {}));
var $2f512219da033f72$export$4f1abe2398c6f2ab;
(function(RadarFieldType) {
    RadarFieldType["Ari"] = "ARI";
    RadarFieldType["Boolean"] = "BOOLEAN";
    RadarFieldType["Datetime"] = "DATETIME";
    RadarFieldType["Number"] = "NUMBER";
    RadarFieldType["Status"] = "STATUS";
    RadarFieldType["String"] = "STRING";
    RadarFieldType["Url"] = "URL";
})($2f512219da033f72$export$4f1abe2398c6f2ab || ($2f512219da033f72$export$4f1abe2398c6f2ab = {}));
var $2f512219da033f72$export$fbe5b0d3c66930b4;
(function(RadarFilterInputType) {
    RadarFilterInputType["Checkbox"] = "CHECKBOX";
    RadarFilterInputType["Radio"] = "RADIO";
    RadarFilterInputType["Range"] = "RANGE";
    RadarFilterInputType["Textfield"] = "TEXTFIELD";
})($2f512219da033f72$export$fbe5b0d3c66930b4 || ($2f512219da033f72$export$fbe5b0d3c66930b4 = {}));
var $2f512219da033f72$export$7f542bfe2df819df;
(function(RadarFilterOperators) {
    RadarFilterOperators["Equals"] = "EQUALS";
    RadarFilterOperators["GreaterThan"] = "GREATER_THAN";
    RadarFilterOperators["GreaterThanOrEqual"] = "GREATER_THAN_OR_EQUAL";
    RadarFilterOperators["LessThan"] = "LESS_THAN";
    RadarFilterOperators["LessThanOrEqual"] = "LESS_THAN_OR_EQUAL";
    RadarFilterOperators["Like"] = "LIKE";
    RadarFilterOperators["NotEquals"] = "NOT_EQUALS";
    RadarFilterOperators["NotLike"] = "NOT_LIKE";
})($2f512219da033f72$export$7f542bfe2df819df || ($2f512219da033f72$export$7f542bfe2df819df = {}));
var $2f512219da033f72$export$b58fcc4561c5cc84;
(function(RadarFilterPlurality) {
    RadarFilterPlurality["And"] = "AND";
    /** Tenure in (3, 4, 5) */ RadarFilterPlurality["None"] = "NONE";
    /** Tenure > 3 and Tenure < 5 */ RadarFilterPlurality["Or"] = "OR";
})($2f512219da033f72$export$b58fcc4561c5cc84 || ($2f512219da033f72$export$b58fcc4561c5cc84 = {}));
var $2f512219da033f72$export$8ddc11e15a2108db;
(function(RadarFunctionId) {
    RadarFunctionId["Haschild"] = "HASCHILD";
    RadarFunctionId["Under"] = "UNDER";
})($2f512219da033f72$export$8ddc11e15a2108db || ($2f512219da033f72$export$8ddc11e15a2108db = {}));
var $2f512219da033f72$export$78f05d708f553e51;
(function(RadarNumericAppearance) {
    RadarNumericAppearance["Duration"] = "DURATION";
    RadarNumericAppearance["Number"] = "NUMBER";
})($2f512219da033f72$export$78f05d708f553e51 || ($2f512219da033f72$export$78f05d708f553e51 = {}));
var $2f512219da033f72$export$6114e3b5d70fb3f4;
(function(RadarStatusAppearance) {
    RadarStatusAppearance["Default"] = "default";
    RadarStatusAppearance["Inprogress"] = "inprogress";
    RadarStatusAppearance["Moved"] = "moved";
    RadarStatusAppearance["New"] = "new";
    RadarStatusAppearance["Removed"] = "removed";
    RadarStatusAppearance["Success"] = "success";
})($2f512219da033f72$export$6114e3b5d70fb3f4 || ($2f512219da033f72$export$6114e3b5d70fb3f4 = {}));
var $2f512219da033f72$export$e0affd64059d9f82;
(function(RateLimitingCurrency) {
    RateLimitingCurrency["CannedResponseMutationCurrency"] = "CANNED_RESPONSE_MUTATION_CURRENCY";
    RateLimitingCurrency["CannedResponseQueryCurrency"] = "CANNED_RESPONSE_QUERY_CURRENCY";
    RateLimitingCurrency["CompassSynchronizeLinkAssociationsCurrency"] = "COMPASS_SYNCHRONIZE_LINK_ASSOCIATIONS_CURRENCY";
    RateLimitingCurrency["DevopsContainerRelationshipsReadCurrency"] = "DEVOPS_CONTAINER_RELATIONSHIPS_READ_CURRENCY";
    RateLimitingCurrency["DevopsContainerRelationshipsWriteCurrency"] = "DEVOPS_CONTAINER_RELATIONSHIPS_WRITE_CURRENCY";
    RateLimitingCurrency["DevopsServiceReadCurrency"] = "DEVOPS_SERVICE_READ_CURRENCY";
    RateLimitingCurrency["DevopsServiceWriteCurrency"] = "DEVOPS_SERVICE_WRITE_CURRENCY";
    RateLimitingCurrency["ExportMetricsCurrency"] = "EXPORT_METRICS_CURRENCY";
    RateLimitingCurrency["ForgeAlertsCurrency"] = "FORGE_ALERTS_CURRENCY";
    RateLimitingCurrency["ForgeAppContributorCurrency"] = "FORGE_APP_CONTRIBUTOR_CURRENCY";
    RateLimitingCurrency["ForgeAuditLogsCurrency"] = "FORGE_AUDIT_LOGS_CURRENCY";
    RateLimitingCurrency["ForgeMetricsCurrency"] = "FORGE_METRICS_CURRENCY";
    RateLimitingCurrency["HelpCenterCurrency"] = "HELP_CENTER_CURRENCY";
    RateLimitingCurrency["HelpLayoutCurrency"] = "HELP_LAYOUT_CURRENCY";
    RateLimitingCurrency["HelpObjectStoreCurrency"] = "HELP_OBJECT_STORE_CURRENCY";
    RateLimitingCurrency["KnowledgeBaseCurrency"] = "KNOWLEDGE_BASE_CURRENCY";
    RateLimitingCurrency["PolarisBetaUserCurrency"] = "POLARIS_BETA_USER_CURRENCY";
    RateLimitingCurrency["PolarisCollabTokenQueryCurrency"] = "POLARIS_COLLAB_TOKEN_QUERY_CURRENCY";
    RateLimitingCurrency["PolarisCommentCurrency"] = "POLARIS_COMMENT_CURRENCY";
    RateLimitingCurrency["PolarisCurrency"] = "POLARIS_CURRENCY";
    RateLimitingCurrency["PolarisFieldCurrency"] = "POLARIS_FIELD_CURRENCY";
    RateLimitingCurrency["PolarisIdeaCurrency"] = "POLARIS_IDEA_CURRENCY";
    RateLimitingCurrency["PolarisIdeaTemplatesQueryCurrency"] = "POLARIS_IDEA_TEMPLATES_QUERY_CURRENCY";
    RateLimitingCurrency["PolarisIdeaTemplateCurrency"] = "POLARIS_IDEA_TEMPLATE_CURRENCY";
    RateLimitingCurrency["PolarisInsightsQueryCurrency"] = "POLARIS_INSIGHTS_QUERY_CURRENCY";
    RateLimitingCurrency["PolarisInsightsWithErrorsQueryCurrency"] = "POLARIS_INSIGHTS_WITH_ERRORS_QUERY_CURRENCY";
    RateLimitingCurrency["PolarisInsightCurrency"] = "POLARIS_INSIGHT_CURRENCY";
    RateLimitingCurrency["PolarisInsightQueryCurrency"] = "POLARIS_INSIGHT_QUERY_CURRENCY";
    RateLimitingCurrency["PolarisLabelsQueryCurrency"] = "POLARIS_LABELS_QUERY_CURRENCY";
    RateLimitingCurrency["PolarisOnboardingCurrency"] = "POLARIS_ONBOARDING_CURRENCY";
    RateLimitingCurrency["PolarisPlayCurrency"] = "POLARIS_PLAY_CURRENCY";
    RateLimitingCurrency["PolarisProjectConfigCurrency"] = "POLARIS_PROJECT_CONFIG_CURRENCY";
    RateLimitingCurrency["PolarisProjectQueryCurrency"] = "POLARIS_PROJECT_QUERY_CURRENCY";
    RateLimitingCurrency["PolarisRankingCurrency"] = "POLARIS_RANKING_CURRENCY";
    RateLimitingCurrency["PolarisReactionCurrency"] = "POLARIS_REACTION_CURRENCY";
    RateLimitingCurrency["PolarisSnippetCurrency"] = "POLARIS_SNIPPET_CURRENCY";
    RateLimitingCurrency["PolarisSnippetPropertiesConfigQueryCurrency"] = "POLARIS_SNIPPET_PROPERTIES_CONFIG_QUERY_CURRENCY";
    RateLimitingCurrency["PolarisUnfurlCurrency"] = "POLARIS_UNFURL_CURRENCY";
    RateLimitingCurrency["PolarisViewsetCurrency"] = "POLARIS_VIEWSET_CURRENCY";
    /** Depraecated currency */ RateLimitingCurrency["PolarisViewArrangementInfoQueryCurrency"] = "POLARIS_VIEW_ARRANGEMENT_INFO_QUERY_CURRENCY";
    RateLimitingCurrency["PolarisViewCurrency"] = "POLARIS_VIEW_CURRENCY";
    RateLimitingCurrency["PolarisViewQueryCurrency"] = "POLARIS_VIEW_QUERY_CURRENCY";
    RateLimitingCurrency["PolarisWriteCurrency"] = "POLARIS_WRITE_CURRENCY";
    RateLimitingCurrency["TeamsCurrency"] = "TEAMS_CURRENCY";
    RateLimitingCurrency["TeamMembersCurrency"] = "TEAM_MEMBERS_CURRENCY";
    RateLimitingCurrency["TeamMembersV2Currency"] = "TEAM_MEMBERS_V2_CURRENCY";
    RateLimitingCurrency["TeamRoleGrantsMutatePrincipalsCurrency"] = "TEAM_ROLE_GRANTS_MUTATE_PRINCIPALS_CURRENCY";
    RateLimitingCurrency["TeamRoleGrantsQueryPrincipalsCurrency"] = "TEAM_ROLE_GRANTS_QUERY_PRINCIPALS_CURRENCY";
    RateLimitingCurrency["TeamSearchCurrency"] = "TEAM_SEARCH_CURRENCY";
    /** This isn't used anywhere but we're keeping it around so pipelines don't break */ RateLimitingCurrency["TeamSearchV2Currency"] = "TEAM_SEARCH_V2_CURRENCY";
    RateLimitingCurrency["TeamV2Currency"] = "TEAM_V2_CURRENCY";
    RateLimitingCurrency["TestingService"] = "TESTING_SERVICE";
    RateLimitingCurrency["TrelloCurrency"] = "TRELLO_CURRENCY";
    RateLimitingCurrency["TrelloMutationCurrency"] = "TRELLO_MUTATION_CURRENCY";
})($2f512219da033f72$export$e0affd64059d9f82 || ($2f512219da033f72$export$e0affd64059d9f82 = {}));
var $2f512219da033f72$export$21a155e8c732fb3e;
(function(RecentFilter) {
    RecentFilter["All"] = "ALL";
    RecentFilter["Created"] = "CREATED";
    RecentFilter["WorkedOn"] = "WORKED_ON";
})($2f512219da033f72$export$21a155e8c732fb3e || ($2f512219da033f72$export$21a155e8c732fb3e = {}));
var $2f512219da033f72$export$783a6e80ad143bfa;
(function(ReclassificationFilterScope) {
    ReclassificationFilterScope["Content"] = "CONTENT";
    ReclassificationFilterScope["Space"] = "SPACE";
    ReclassificationFilterScope["Workspace"] = "WORKSPACE";
})($2f512219da033f72$export$783a6e80ad143bfa || ($2f512219da033f72$export$783a6e80ad143bfa = {}));
var $2f512219da033f72$export$5e3c7f13be5cbe17;
(function(RecommendedPagesSpaceBehavior) {
    RecommendedPagesSpaceBehavior["Hidden"] = "HIDDEN";
    RecommendedPagesSpaceBehavior["Shown"] = "SHOWN";
})($2f512219da033f72$export$5e3c7f13be5cbe17 || ($2f512219da033f72$export$5e3c7f13be5cbe17 = {}));
var $2f512219da033f72$export$43e683e1574d54;
(function(RelationSourceType) {
    RelationSourceType["User"] = "user";
})($2f512219da033f72$export$43e683e1574d54 || ($2f512219da033f72$export$43e683e1574d54 = {}));
var $2f512219da033f72$export$298b6537334b9281;
(function(RelationTargetType) {
    RelationTargetType["Content"] = "content";
    RelationTargetType["Space"] = "space";
})($2f512219da033f72$export$298b6537334b9281 || ($2f512219da033f72$export$298b6537334b9281 = {}));
var $2f512219da033f72$export$ebeccdce1e2968d0;
(function(RelationType) {
    RelationType["Collaborator"] = "collaborator";
    RelationType["Favourite"] = "favourite";
    RelationType["Touched"] = "touched";
})($2f512219da033f72$export$ebeccdce1e2968d0 || ($2f512219da033f72$export$ebeccdce1e2968d0 = {}));
var $2f512219da033f72$export$6995cc8c41c95909;
(function(RelevantUserFilter) {
    RelevantUserFilter["Collaborators"] = "collaborators";
})($2f512219da033f72$export$6995cc8c41c95909 || ($2f512219da033f72$export$6995cc8c41c95909 = {}));
var $2f512219da033f72$export$368a63a80b83af71;
(function(RelevantUsersSortOrder) {
    RelevantUsersSortOrder["Asc"] = "asc";
    RelevantUsersSortOrder["Desc"] = "desc";
})($2f512219da033f72$export$368a63a80b83af71 || ($2f512219da033f72$export$368a63a80b83af71 = {}));
var $2f512219da033f72$export$8e7b7bb509dc942b;
(function(ResourceAccessType) {
    ResourceAccessType["Edit"] = "EDIT";
    ResourceAccessType["View"] = "VIEW";
})($2f512219da033f72$export$8e7b7bb509dc942b || ($2f512219da033f72$export$8e7b7bb509dc942b = {}));
var $2f512219da033f72$export$c6f9da6f70cfc2eb;
(function(ResourceType) {
    ResourceType["Database"] = "DATABASE";
    ResourceType["Folder"] = "FOLDER";
    ResourceType["Page"] = "PAGE";
    ResourceType["Space"] = "SPACE";
    ResourceType["Whiteboard"] = "WHITEBOARD";
})($2f512219da033f72$export$c6f9da6f70cfc2eb || ($2f512219da033f72$export$c6f9da6f70cfc2eb = {}));
var $2f512219da033f72$export$7390b1e457b4cb6f;
(function(ResponseType) {
    ResponseType["BulletListAdf"] = "BULLET_LIST_ADF";
    ResponseType["BulletListMarkdown"] = "BULLET_LIST_MARKDOWN";
    ResponseType["ParagraphPlaintext"] = "PARAGRAPH_PLAINTEXT";
})($2f512219da033f72$export$7390b1e457b4cb6f || ($2f512219da033f72$export$7390b1e457b4cb6f = {}));
var $2f512219da033f72$export$8798225e6f84b893;
(function(ReverseTrialCohort) {
    ReverseTrialCohort["Control"] = "CONTROL";
    ReverseTrialCohort["Enrolled"] = "ENROLLED";
    ReverseTrialCohort["NotEnrolled"] = "NOT_ENROLLED";
    ReverseTrialCohort["Unassigned"] = "UNASSIGNED";
    ReverseTrialCohort["Unknown"] = "UNKNOWN";
    ReverseTrialCohort["Variant"] = "VARIANT";
})($2f512219da033f72$export$8798225e6f84b893 || ($2f512219da033f72$export$8798225e6f84b893 = {}));
var $2f512219da033f72$export$c7008c50eda1b0f5;
(function(RevertToLegacyEditorResult) {
    RevertToLegacyEditorResult["NotReverted"] = "NOT_REVERTED";
    RevertToLegacyEditorResult["Reverted"] = "REVERTED";
})($2f512219da033f72$export$c7008c50eda1b0f5 || ($2f512219da033f72$export$c7008c50eda1b0f5 = {}));
var $2f512219da033f72$export$4df1ed283b73df16;
(function(RoadmapChildIssuePlanningMode) {
    /** Use Date based planning */ RoadmapChildIssuePlanningMode["Date"] = "DATE";
    /** Disabled child issue planning */ RoadmapChildIssuePlanningMode["Disabled"] = "DISABLED";
    /** Use Sprint based planning */ RoadmapChildIssuePlanningMode["Sprint"] = "SPRINT";
})($2f512219da033f72$export$4df1ed283b73df16 || ($2f512219da033f72$export$4df1ed283b73df16 = {}));
var $2f512219da033f72$export$1c9f5b28aa44f22d;
(function(RoadmapEpicView) {
    /** All epics regardless of status */ RoadmapEpicView["All"] = "ALL";
    /** Epics with status complete */ RoadmapEpicView["Completed"] = "COMPLETED";
    /** Epics with status incomplete */ RoadmapEpicView["Incomplete"] = "INCOMPLETE";
})($2f512219da033f72$export$1c9f5b28aa44f22d || ($2f512219da033f72$export$1c9f5b28aa44f22d = {}));
var $2f512219da033f72$export$7f14fc5a386166cb;
(function(RoadmapLevelOneView) {
    /** Show level one items completed within last 1 month */ RoadmapLevelOneView["Complete1M"] = "COMPLETE1M";
    /** Show level one items completed within last 3 months */ RoadmapLevelOneView["Complete3M"] = "COMPLETE3M";
    /** Show level one items completed within last 6 months */ RoadmapLevelOneView["Complete6M"] = "COMPLETE6M";
    /** Show level one items completed within last 9 months */ RoadmapLevelOneView["Complete9M"] = "COMPLETE9M";
    /** Show level one items completed within last 12 months */ RoadmapLevelOneView["Complete12M"] = "COMPLETE12M";
    /** Do not show completed level one items */ RoadmapLevelOneView["Incomplete"] = "INCOMPLETE";
})($2f512219da033f72$export$7f14fc5a386166cb || ($2f512219da033f72$export$7f14fc5a386166cb = {}));
var $2f512219da033f72$export$6df418813509b448;
(function(RoadmapPaletteColor) {
    RoadmapPaletteColor["Blue"] = "BLUE";
    RoadmapPaletteColor["DarkBlue"] = "DARK_BLUE";
    RoadmapPaletteColor["DarkGreen"] = "DARK_GREEN";
    RoadmapPaletteColor["DarkGrey"] = "DARK_GREY";
    RoadmapPaletteColor["DarkOrange"] = "DARK_ORANGE";
    RoadmapPaletteColor["DarkPurple"] = "DARK_PURPLE";
    RoadmapPaletteColor["DarkTeal"] = "DARK_TEAL";
    RoadmapPaletteColor["DarkYellow"] = "DARK_YELLOW";
    RoadmapPaletteColor["Green"] = "GREEN";
    RoadmapPaletteColor["Grey"] = "GREY";
    RoadmapPaletteColor["Orange"] = "ORANGE";
    RoadmapPaletteColor["Purple"] = "PURPLE";
    RoadmapPaletteColor["Teal"] = "TEAL";
    RoadmapPaletteColor["Yellow"] = "YELLOW";
})($2f512219da033f72$export$6df418813509b448 || ($2f512219da033f72$export$6df418813509b448 = {}));
var $2f512219da033f72$export$718224d6d55ce2e9;
(function(RoadmapRankPosition) {
    /** Rank the item after the provided id */ RoadmapRankPosition["After"] = "AFTER";
    /** Rank the item before the provided id */ RoadmapRankPosition["Before"] = "BEFORE";
})($2f512219da033f72$export$718224d6d55ce2e9 || ($2f512219da033f72$export$718224d6d55ce2e9 = {}));
var $2f512219da033f72$export$8fd1e37e60920853;
(function(RoadmapSprintState) {
    /** A current sprint */ RoadmapSprintState["Active"] = "ACTIVE";
    /** A sprint that was completed in the past */ RoadmapSprintState["Closed"] = "CLOSED";
    /** A sprint that is planned for the future */ RoadmapSprintState["Future"] = "FUTURE";
})($2f512219da033f72$export$8fd1e37e60920853 || ($2f512219da033f72$export$8fd1e37e60920853 = {}));
var $2f512219da033f72$export$d1eb62afe3c5898c;
(function(RoadmapTimelineMode) {
    /** Months */ RoadmapTimelineMode["Months"] = "MONTHS";
    /** Quarters */ RoadmapTimelineMode["Quarters"] = "QUARTERS";
    /** Weeks */ RoadmapTimelineMode["Weeks"] = "WEEKS";
})($2f512219da033f72$export$d1eb62afe3c5898c || ($2f512219da033f72$export$d1eb62afe3c5898c = {}));
var $2f512219da033f72$export$e12a64c0aae94c50;
(function(RoadmapVersionStatus) {
    /** version has been archived */ RoadmapVersionStatus["Archived"] = "ARCHIVED";
    /** version has been released */ RoadmapVersionStatus["Released"] = "RELEASED";
    /** version has not been released */ RoadmapVersionStatus["Unreleased"] = "UNRELEASED";
})($2f512219da033f72$export$e12a64c0aae94c50 || ($2f512219da033f72$export$e12a64c0aae94c50 = {}));
var $2f512219da033f72$export$4e2d5448f3fd8728;
(function(RoleAssignmentPrincipalType) {
    RoleAssignmentPrincipalType["AccessClass"] = "ACCESS_CLASS";
    RoleAssignmentPrincipalType["Group"] = "GROUP";
    RoleAssignmentPrincipalType["Team"] = "TEAM";
    RoleAssignmentPrincipalType["User"] = "USER";
})($2f512219da033f72$export$4e2d5448f3fd8728 || ($2f512219da033f72$export$4e2d5448f3fd8728 = {}));
var $2f512219da033f72$export$74a8f61d42003686;
(function(SandboxEventResult) {
    SandboxEventResult["Failed"] = "failed";
    SandboxEventResult["Incomplete"] = "incomplete";
    SandboxEventResult["Successful"] = "successful";
    SandboxEventResult["Unknown"] = "unknown";
})($2f512219da033f72$export$74a8f61d42003686 || ($2f512219da033f72$export$74a8f61d42003686 = {}));
var $2f512219da033f72$export$fc03b8f4df65e1a2;
(function(SandboxEventSource) {
    SandboxEventSource["Admin"] = "admin";
    SandboxEventSource["System"] = "system";
    SandboxEventSource["User"] = "user";
})($2f512219da033f72$export$fc03b8f4df65e1a2 || ($2f512219da033f72$export$fc03b8f4df65e1a2 = {}));
var $2f512219da033f72$export$c4acd5ebccb10941;
(function(SandboxEventStatus) {
    SandboxEventStatus["AwaitingReplay"] = "awaiting_replay";
    SandboxEventStatus["Cancelled"] = "cancelled";
    SandboxEventStatus["Completed"] = "completed";
    SandboxEventStatus["Started"] = "started";
})($2f512219da033f72$export$c4acd5ebccb10941 || ($2f512219da033f72$export$c4acd5ebccb10941 = {}));
var $2f512219da033f72$export$e370ebae241bc22f;
(function(SandboxEventType) {
    SandboxEventType["Create"] = "create";
    SandboxEventType["DataClone"] = "data_clone";
    SandboxEventType["DataCloneSelective"] = "data_clone_selective";
    SandboxEventType["HardDelete"] = "hard_delete";
    SandboxEventType["Reset"] = "reset";
    SandboxEventType["Reshard"] = "reshard";
    SandboxEventType["Rollback"] = "rollback";
    SandboxEventType["SoftDelete"] = "soft_delete";
})($2f512219da033f72$export$e370ebae241bc22f || ($2f512219da033f72$export$e370ebae241bc22f = {}));
var $2f512219da033f72$export$775b6bb06e53a214;
(function(Scope) {
    /** outbound-auth */ Scope["AdminContainer"] = "ADMIN_CONTAINER";
    Scope["ApiAccess"] = "API_ACCESS";
    /**
   * jira - granular scopes.
   * Each Jira Mutation and Query should have one or more of these in an `@scope` tag and one of the non-granular scopes above
   */ Scope["ApplicationRoleRead"] = "APPLICATION_ROLE_READ";
    Scope["AsyncTaskDelete"] = "ASYNC_TASK_DELETE";
    Scope["AttachmentDelete"] = "ATTACHMENT_DELETE";
    Scope["AttachmentRead"] = "ATTACHMENT_READ";
    Scope["AttachmentWrite"] = "ATTACHMENT_WRITE";
    Scope["AuditLogRead"] = "AUDIT_LOG_READ";
    Scope["AuthConfluenceUser"] = "AUTH_CONFLUENCE_USER";
    Scope["AvatarDelete"] = "AVATAR_DELETE";
    Scope["AvatarRead"] = "AVATAR_READ";
    Scope["AvatarWrite"] = "AVATAR_WRITE";
    /** papi */ Scope["CatalogRead"] = "CATALOG_READ";
    Scope["CommentDelete"] = "COMMENT_DELETE";
    Scope["CommentPropertyDelete"] = "COMMENT_PROPERTY_DELETE";
    Scope["CommentPropertyRead"] = "COMMENT_PROPERTY_READ";
    Scope["CommentPropertyWrite"] = "COMMENT_PROPERTY_WRITE";
    Scope["CommentRead"] = "COMMENT_READ";
    Scope["CommentWrite"] = "COMMENT_WRITE";
    /** compass */ Scope["CompassAtlassianExternal"] = "COMPASS_ATLASSIAN_EXTERNAL";
    /** confluence */ Scope["ConfluenceAtlassianExternal"] = "CONFLUENCE_ATLASSIAN_EXTERNAL";
    Scope["CustomFieldContextualConfigurationRead"] = "CUSTOM_FIELD_CONTEXTUAL_CONFIGURATION_READ";
    Scope["CustomFieldContextualConfigurationWrite"] = "CUSTOM_FIELD_CONTEXTUAL_CONFIGURATION_WRITE";
    Scope["DashboardDelete"] = "DASHBOARD_DELETE";
    Scope["DashboardPropertyDelete"] = "DASHBOARD_PROPERTY_DELETE";
    Scope["DashboardPropertyRead"] = "DASHBOARD_PROPERTY_READ";
    Scope["DashboardPropertyWrite"] = "DASHBOARD_PROPERTY_WRITE";
    Scope["DashboardRead"] = "DASHBOARD_READ";
    Scope["DashboardWrite"] = "DASHBOARD_WRITE";
    Scope["DeleteConfluenceAttachment"] = "DELETE_CONFLUENCE_ATTACHMENT";
    Scope["DeleteConfluenceBlogpost"] = "DELETE_CONFLUENCE_BLOGPOST";
    Scope["DeleteConfluenceComment"] = "DELETE_CONFLUENCE_COMMENT";
    Scope["DeleteConfluenceCustomContent"] = "DELETE_CONFLUENCE_CUSTOM_CONTENT";
    Scope["DeleteConfluencePage"] = "DELETE_CONFLUENCE_PAGE";
    Scope["DeleteConfluenceSpace"] = "DELETE_CONFLUENCE_SPACE";
    Scope["DeleteJswBoardScopeAdmin"] = "DELETE_JSW_BOARD_SCOPE_ADMIN";
    Scope["DeleteJswSprint"] = "DELETE_JSW_SPRINT";
    Scope["DeleteOrganization"] = "DELETE_ORGANIZATION";
    Scope["DeleteOrganizationProperty"] = "DELETE_ORGANIZATION_PROPERTY";
    Scope["DeleteOrganizationUser"] = "DELETE_ORGANIZATION_USER";
    Scope["DeleteRequesttypeProperty"] = "DELETE_REQUESTTYPE_PROPERTY";
    Scope["DeleteRequestFeedback"] = "DELETE_REQUEST_FEEDBACK";
    Scope["DeleteRequestNotification"] = "DELETE_REQUEST_NOTIFICATION";
    Scope["DeleteRequestParticipant"] = "DELETE_REQUEST_PARTICIPANT";
    Scope["DeleteServicedeskCustomer"] = "DELETE_SERVICEDESK_CUSTOMER";
    Scope["DeleteServicedeskOrganization"] = "DELETE_SERVICEDESK_ORGANIZATION";
    Scope["DeleteServicedeskProperty"] = "DELETE_SERVICEDESK_PROPERTY";
    Scope["FieldConfigurationDelete"] = "FIELD_CONFIGURATION_DELETE";
    Scope["FieldConfigurationRead"] = "FIELD_CONFIGURATION_READ";
    Scope["FieldConfigurationSchemeDelete"] = "FIELD_CONFIGURATION_SCHEME_DELETE";
    Scope["FieldConfigurationSchemeRead"] = "FIELD_CONFIGURATION_SCHEME_READ";
    Scope["FieldConfigurationSchemeWrite"] = "FIELD_CONFIGURATION_SCHEME_WRITE";
    Scope["FieldConfigurationWrite"] = "FIELD_CONFIGURATION_WRITE";
    Scope["FieldDefaultValueRead"] = "FIELD_DEFAULT_VALUE_READ";
    Scope["FieldDefaultValueWrite"] = "FIELD_DEFAULT_VALUE_WRITE";
    Scope["FieldDelete"] = "FIELD_DELETE";
    Scope["FieldOptionsRead"] = "FIELD_OPTIONS_READ";
    Scope["FieldOptionDelete"] = "FIELD_OPTION_DELETE";
    Scope["FieldOptionRead"] = "FIELD_OPTION_READ";
    Scope["FieldOptionWrite"] = "FIELD_OPTION_WRITE";
    Scope["FieldRead"] = "FIELD_READ";
    Scope["FieldWrite"] = "FIELD_WRITE";
    Scope["FilterColumnDelete"] = "FILTER_COLUMN_DELETE";
    Scope["FilterColumnRead"] = "FILTER_COLUMN_READ";
    Scope["FilterColumnWrite"] = "FILTER_COLUMN_WRITE";
    Scope["FilterDefaultShareScopeRead"] = "FILTER_DEFAULT_SHARE_SCOPE_READ";
    Scope["FilterDefaultShareScopeWrite"] = "FILTER_DEFAULT_SHARE_SCOPE_WRITE";
    Scope["FilterDelete"] = "FILTER_DELETE";
    Scope["FilterRead"] = "FILTER_READ";
    Scope["FilterWrite"] = "FILTER_WRITE";
    Scope["GroupDelete"] = "GROUP_DELETE";
    Scope["GroupRead"] = "GROUP_READ";
    Scope["GroupWrite"] = "GROUP_WRITE";
    Scope["IdentityAtlassianExternal"] = "IDENTITY_ATLASSIAN_EXTERNAL";
    Scope["InstanceConfigurationRead"] = "INSTANCE_CONFIGURATION_READ";
    Scope["InstanceConfigurationWrite"] = "INSTANCE_CONFIGURATION_WRITE";
    Scope["IssueAdjustmentsDelete"] = "ISSUE_ADJUSTMENTS_DELETE";
    Scope["IssueAdjustmentsRead"] = "ISSUE_ADJUSTMENTS_READ";
    Scope["IssueAdjustmentsWrite"] = "ISSUE_ADJUSTMENTS_WRITE";
    Scope["IssueChangelogRead"] = "ISSUE_CHANGELOG_READ";
    Scope["IssueDelete"] = "ISSUE_DELETE";
    Scope["IssueDetailsRead"] = "ISSUE_DETAILS_READ";
    Scope["IssueEventRead"] = "ISSUE_EVENT_READ";
    Scope["IssueFieldValuesRead"] = "ISSUE_FIELD_VALUES_READ";
    Scope["IssueLinkDelete"] = "ISSUE_LINK_DELETE";
    Scope["IssueLinkRead"] = "ISSUE_LINK_READ";
    Scope["IssueLinkTypeDelete"] = "ISSUE_LINK_TYPE_DELETE";
    Scope["IssueLinkTypeRead"] = "ISSUE_LINK_TYPE_READ";
    Scope["IssueLinkTypeWrite"] = "ISSUE_LINK_TYPE_WRITE";
    Scope["IssueLinkWrite"] = "ISSUE_LINK_WRITE";
    Scope["IssueMetaRead"] = "ISSUE_META_READ";
    Scope["IssuePropertyDelete"] = "ISSUE_PROPERTY_DELETE";
    Scope["IssuePropertyRead"] = "ISSUE_PROPERTY_READ";
    Scope["IssuePropertyWrite"] = "ISSUE_PROPERTY_WRITE";
    Scope["IssueRead"] = "ISSUE_READ";
    Scope["IssueRemoteLinkDelete"] = "ISSUE_REMOTE_LINK_DELETE";
    Scope["IssueRemoteLinkRead"] = "ISSUE_REMOTE_LINK_READ";
    Scope["IssueRemoteLinkWrite"] = "ISSUE_REMOTE_LINK_WRITE";
    Scope["IssueSecurityLevelRead"] = "ISSUE_SECURITY_LEVEL_READ";
    Scope["IssueSecuritySchemeRead"] = "ISSUE_SECURITY_SCHEME_READ";
    Scope["IssueStatusRead"] = "ISSUE_STATUS_READ";
    Scope["IssueTimeTrackingRead"] = "ISSUE_TIME_TRACKING_READ";
    Scope["IssueTimeTrackingWrite"] = "ISSUE_TIME_TRACKING_WRITE";
    Scope["IssueTransitionRead"] = "ISSUE_TRANSITION_READ";
    Scope["IssueTypeDelete"] = "ISSUE_TYPE_DELETE";
    Scope["IssueTypeHierarchyRead"] = "ISSUE_TYPE_HIERARCHY_READ";
    Scope["IssueTypePropertyDelete"] = "ISSUE_TYPE_PROPERTY_DELETE";
    Scope["IssueTypePropertyRead"] = "ISSUE_TYPE_PROPERTY_READ";
    Scope["IssueTypePropertyWrite"] = "ISSUE_TYPE_PROPERTY_WRITE";
    Scope["IssueTypeRead"] = "ISSUE_TYPE_READ";
    Scope["IssueTypeSchemeDelete"] = "ISSUE_TYPE_SCHEME_DELETE";
    Scope["IssueTypeSchemeRead"] = "ISSUE_TYPE_SCHEME_READ";
    Scope["IssueTypeSchemeWrite"] = "ISSUE_TYPE_SCHEME_WRITE";
    Scope["IssueTypeScreenSchemeDelete"] = "ISSUE_TYPE_SCREEN_SCHEME_DELETE";
    Scope["IssueTypeScreenSchemeRead"] = "ISSUE_TYPE_SCREEN_SCHEME_READ";
    Scope["IssueTypeScreenSchemeWrite"] = "ISSUE_TYPE_SCREEN_SCHEME_WRITE";
    Scope["IssueTypeWrite"] = "ISSUE_TYPE_WRITE";
    Scope["IssueVotesRead"] = "ISSUE_VOTES_READ";
    Scope["IssueVoteRead"] = "ISSUE_VOTE_READ";
    Scope["IssueVoteWrite"] = "ISSUE_VOTE_WRITE";
    Scope["IssueWatcherRead"] = "ISSUE_WATCHER_READ";
    Scope["IssueWatcherWrite"] = "ISSUE_WATCHER_WRITE";
    Scope["IssueWorklogDelete"] = "ISSUE_WORKLOG_DELETE";
    Scope["IssueWorklogPropertyDelete"] = "ISSUE_WORKLOG_PROPERTY_DELETE";
    Scope["IssueWorklogPropertyRead"] = "ISSUE_WORKLOG_PROPERTY_READ";
    Scope["IssueWorklogPropertyWrite"] = "ISSUE_WORKLOG_PROPERTY_WRITE";
    Scope["IssueWorklogRead"] = "ISSUE_WORKLOG_READ";
    Scope["IssueWorklogWrite"] = "ISSUE_WORKLOG_WRITE";
    Scope["IssueWrite"] = "ISSUE_WRITE";
    Scope["JiraAtlassianExternal"] = "JIRA_ATLASSIAN_EXTERNAL";
    Scope["JiraExpressionsRead"] = "JIRA_EXPRESSIONS_READ";
    Scope["JqlRead"] = "JQL_READ";
    Scope["JqlValidate"] = "JQL_VALIDATE";
    Scope["LabelRead"] = "LABEL_READ";
    Scope["LicenseRead"] = "LICENSE_READ";
    /** ecosystem */ Scope["ManageApp"] = "MANAGE_APP";
    Scope["ManageDirectory"] = "MANAGE_DIRECTORY";
    Scope["ManageJiraConfiguration"] = "MANAGE_JIRA_CONFIGURATION";
    Scope["ManageJiraDataProvider"] = "MANAGE_JIRA_DATA_PROVIDER";
    Scope["ManageJiraProject"] = "MANAGE_JIRA_PROJECT";
    Scope["ManageJiraWebhook"] = "MANAGE_JIRA_WEBHOOK";
    /** identity */ Scope["ManageOrg"] = "MANAGE_ORG";
    Scope["ManageOrgPublicApis"] = "MANAGE_ORG_PUBLIC_APIS";
    Scope["ManageServicedeskCustomer"] = "MANAGE_SERVICEDESK_CUSTOMER";
    /** platform */ Scope["MigrateConfluence"] = "MIGRATE_CONFLUENCE";
    Scope["NotificationSchemeRead"] = "NOTIFICATION_SCHEME_READ";
    Scope["NotificationSend"] = "NOTIFICATION_SEND";
    Scope["PermissionDelete"] = "PERMISSION_DELETE";
    Scope["PermissionRead"] = "PERMISSION_READ";
    Scope["PermissionSchemeDelete"] = "PERMISSION_SCHEME_DELETE";
    Scope["PermissionSchemeRead"] = "PERMISSION_SCHEME_READ";
    Scope["PermissionSchemeWrite"] = "PERMISSION_SCHEME_WRITE";
    Scope["PermissionWrite"] = "PERMISSION_WRITE";
    Scope["PriorityRead"] = "PRIORITY_READ";
    Scope["ProjectAvatarDelete"] = "PROJECT_AVATAR_DELETE";
    Scope["ProjectAvatarRead"] = "PROJECT_AVATAR_READ";
    Scope["ProjectAvatarWrite"] = "PROJECT_AVATAR_WRITE";
    Scope["ProjectCategoryDelete"] = "PROJECT_CATEGORY_DELETE";
    Scope["ProjectCategoryRead"] = "PROJECT_CATEGORY_READ";
    Scope["ProjectCategoryWrite"] = "PROJECT_CATEGORY_WRITE";
    Scope["ProjectComponentDelete"] = "PROJECT_COMPONENT_DELETE";
    Scope["ProjectComponentRead"] = "PROJECT_COMPONENT_READ";
    Scope["ProjectComponentWrite"] = "PROJECT_COMPONENT_WRITE";
    Scope["ProjectDelete"] = "PROJECT_DELETE";
    Scope["ProjectEmailRead"] = "PROJECT_EMAIL_READ";
    Scope["ProjectEmailWrite"] = "PROJECT_EMAIL_WRITE";
    Scope["ProjectFeatureRead"] = "PROJECT_FEATURE_READ";
    Scope["ProjectFeatureWrite"] = "PROJECT_FEATURE_WRITE";
    Scope["ProjectPropertyDelete"] = "PROJECT_PROPERTY_DELETE";
    Scope["ProjectPropertyRead"] = "PROJECT_PROPERTY_READ";
    Scope["ProjectPropertyWrite"] = "PROJECT_PROPERTY_WRITE";
    Scope["ProjectRead"] = "PROJECT_READ";
    Scope["ProjectRoleDelete"] = "PROJECT_ROLE_DELETE";
    Scope["ProjectRoleRead"] = "PROJECT_ROLE_READ";
    Scope["ProjectRoleWrite"] = "PROJECT_ROLE_WRITE";
    Scope["ProjectTypeRead"] = "PROJECT_TYPE_READ";
    Scope["ProjectVersionDelete"] = "PROJECT_VERSION_DELETE";
    Scope["ProjectVersionRead"] = "PROJECT_VERSION_READ";
    Scope["ProjectVersionWrite"] = "PROJECT_VERSION_WRITE";
    Scope["ProjectWrite"] = "PROJECT_WRITE";
    /** bitbucket_repository_access_token */ Scope["PullRequest"] = "PULL_REQUEST";
    Scope["PullRequestWrite"] = "PULL_REQUEST_WRITE";
    Scope["ReadAccount"] = "READ_ACCOUNT";
    Scope["ReadCompassAttentionItem"] = "READ_COMPASS_ATTENTION_ITEM";
    Scope["ReadCompassComponent"] = "READ_COMPASS_COMPONENT";
    Scope["ReadCompassEvent"] = "READ_COMPASS_EVENT";
    Scope["ReadCompassMetric"] = "READ_COMPASS_METRIC";
    Scope["ReadCompassScorecard"] = "READ_COMPASS_SCORECARD";
    Scope["ReadConfluenceAttachment"] = "READ_CONFLUENCE_ATTACHMENT";
    Scope["ReadConfluenceAuditLog"] = "READ_CONFLUENCE_AUDIT_LOG";
    Scope["ReadConfluenceBlogpost"] = "READ_CONFLUENCE_BLOGPOST";
    Scope["ReadConfluenceComment"] = "READ_CONFLUENCE_COMMENT";
    Scope["ReadConfluenceConfiguration"] = "READ_CONFLUENCE_CONFIGURATION";
    Scope["ReadConfluenceContentAnalytics"] = "READ_CONFLUENCE_CONTENT_ANALYTICS";
    Scope["ReadConfluenceContentMetadata"] = "READ_CONFLUENCE_CONTENT_METADATA";
    Scope["ReadConfluenceContentPermission"] = "READ_CONFLUENCE_CONTENT_PERMISSION";
    Scope["ReadConfluenceContentProperty"] = "READ_CONFLUENCE_CONTENT_PROPERTY";
    Scope["ReadConfluenceContentRestriction"] = "READ_CONFLUENCE_CONTENT_RESTRICTION";
    Scope["ReadConfluenceCustomContent"] = "READ_CONFLUENCE_CUSTOM_CONTENT";
    Scope["ReadConfluenceGroup"] = "READ_CONFLUENCE_GROUP";
    Scope["ReadConfluenceInlineTask"] = "READ_CONFLUENCE_INLINE_TASK";
    Scope["ReadConfluenceLabel"] = "READ_CONFLUENCE_LABEL";
    Scope["ReadConfluencePage"] = "READ_CONFLUENCE_PAGE";
    Scope["ReadConfluenceRelation"] = "READ_CONFLUENCE_RELATION";
    Scope["ReadConfluenceSpace"] = "READ_CONFLUENCE_SPACE";
    Scope["ReadConfluenceSpacePermission"] = "READ_CONFLUENCE_SPACE_PERMISSION";
    Scope["ReadConfluenceSpaceProperty"] = "READ_CONFLUENCE_SPACE_PROPERTY";
    Scope["ReadConfluenceSpaceSetting"] = "READ_CONFLUENCE_SPACE_SETTING";
    Scope["ReadConfluenceTemplate"] = "READ_CONFLUENCE_TEMPLATE";
    Scope["ReadConfluenceUser"] = "READ_CONFLUENCE_USER";
    Scope["ReadConfluenceUserProperty"] = "READ_CONFLUENCE_USER_PROPERTY";
    Scope["ReadConfluenceWatcher"] = "READ_CONFLUENCE_WATCHER";
    Scope["ReadContainer"] = "READ_CONTAINER";
    /**
   * jira-servicedesk - granular
   * Each JSM Mutation and Query should have one or more of these in an `@scope` tag and one of the non-granular scopes above.
   * You can mix them with Jira scopes if needed.
   */ Scope["ReadCustomer"] = "READ_CUSTOMER";
    Scope["ReadDesign"] = "READ_DESIGN";
    /**
   * jira - non granular
   * Please add a granular scope as well.
   */ Scope["ReadJiraUser"] = "READ_JIRA_USER";
    Scope["ReadJiraWork"] = "READ_JIRA_WORK";
    /**
   * jsw scopes
   * Note - JSW does not have non granular scopes so it does not need two scope tags like JSM/Jira
   */ Scope["ReadJswBoardScope"] = "READ_JSW_BOARD_SCOPE";
    Scope["ReadJswBoardScopeAdmin"] = "READ_JSW_BOARD_SCOPE_ADMIN";
    Scope["ReadJswBuild"] = "READ_JSW_BUILD";
    Scope["ReadJswDeployment"] = "READ_JSW_DEPLOYMENT";
    Scope["ReadJswEpic"] = "READ_JSW_EPIC";
    Scope["ReadJswFeatureFlag"] = "READ_JSW_FEATURE_FLAG";
    Scope["ReadJswIssue"] = "READ_JSW_ISSUE";
    Scope["ReadJswRemoteLink"] = "READ_JSW_REMOTE_LINK";
    Scope["ReadJswSourceCode"] = "READ_JSW_SOURCE_CODE";
    Scope["ReadJswSprint"] = "READ_JSW_SPRINT";
    Scope["ReadKnowledgebase"] = "READ_KNOWLEDGEBASE";
    Scope["ReadMe"] = "READ_ME";
    /** notification-log */ Scope["ReadNotifications"] = "READ_NOTIFICATIONS";
    Scope["ReadOrganization"] = "READ_ORGANIZATION";
    Scope["ReadOrganizationProperty"] = "READ_ORGANIZATION_PROPERTY";
    Scope["ReadOrganizationUser"] = "READ_ORGANIZATION_USER";
    Scope["ReadQueue"] = "READ_QUEUE";
    Scope["ReadRequest"] = "READ_REQUEST";
    Scope["ReadRequesttype"] = "READ_REQUESTTYPE";
    Scope["ReadRequesttypeProperty"] = "READ_REQUESTTYPE_PROPERTY";
    Scope["ReadRequestAction"] = "READ_REQUEST_ACTION";
    Scope["ReadRequestApproval"] = "READ_REQUEST_APPROVAL";
    Scope["ReadRequestAttachment"] = "READ_REQUEST_ATTACHMENT";
    Scope["ReadRequestComment"] = "READ_REQUEST_COMMENT";
    Scope["ReadRequestFeedback"] = "READ_REQUEST_FEEDBACK";
    Scope["ReadRequestNotification"] = "READ_REQUEST_NOTIFICATION";
    Scope["ReadRequestParticipant"] = "READ_REQUEST_PARTICIPANT";
    Scope["ReadRequestSla"] = "READ_REQUEST_SLA";
    Scope["ReadRequestStatus"] = "READ_REQUEST_STATUS";
    Scope["ReadServicedesk"] = "READ_SERVICEDESK";
    Scope["ReadServicedeskCustomer"] = "READ_SERVICEDESK_CUSTOMER";
    Scope["ReadServicedeskOrganization"] = "READ_SERVICEDESK_ORGANIZATION";
    Scope["ReadServicedeskProperty"] = "READ_SERVICEDESK_PROPERTY";
    /**
   * jira-servicedesk - non-granular
   * Please add a granular scope as well.
   */ Scope["ReadServicedeskRequest"] = "READ_SERVICEDESK_REQUEST";
    /** teams */ Scope["ReadTeam"] = "READ_TEAM";
    Scope["ReadTeamMembers"] = "READ_TEAM_MEMBERS";
    Scope["ReadTownsquareComment"] = "READ_TOWNSQUARE_COMMENT";
    Scope["ReadTownsquareGoal"] = "READ_TOWNSQUARE_GOAL";
    /** townsquare (Atlas) */ Scope["ReadTownsquareProject"] = "READ_TOWNSQUARE_PROJECT";
    Scope["ReadTownsquareWorkspace"] = "READ_TOWNSQUARE_WORKSPACE";
    Scope["ResolutionRead"] = "RESOLUTION_READ";
    Scope["ScreenableFieldDelete"] = "SCREENABLE_FIELD_DELETE";
    Scope["ScreenableFieldRead"] = "SCREENABLE_FIELD_READ";
    Scope["ScreenableFieldWrite"] = "SCREENABLE_FIELD_WRITE";
    Scope["ScreenDelete"] = "SCREEN_DELETE";
    Scope["ScreenFieldRead"] = "SCREEN_FIELD_READ";
    Scope["ScreenRead"] = "SCREEN_READ";
    Scope["ScreenSchemeDelete"] = "SCREEN_SCHEME_DELETE";
    Scope["ScreenSchemeRead"] = "SCREEN_SCHEME_READ";
    Scope["ScreenSchemeWrite"] = "SCREEN_SCHEME_WRITE";
    Scope["ScreenTabDelete"] = "SCREEN_TAB_DELETE";
    Scope["ScreenTabRead"] = "SCREEN_TAB_READ";
    Scope["ScreenTabWrite"] = "SCREEN_TAB_WRITE";
    Scope["ScreenWrite"] = "SCREEN_WRITE";
    Scope["StatusRead"] = "STATUS_READ";
    Scope["StorageApp"] = "STORAGE_APP";
    /** trello */ Scope["TrelloAtlassianExternal"] = "TRELLO_ATLASSIAN_EXTERNAL";
    Scope["UserColumnsRead"] = "USER_COLUMNS_READ";
    Scope["UserConfigurationDelete"] = "USER_CONFIGURATION_DELETE";
    Scope["UserConfigurationRead"] = "USER_CONFIGURATION_READ";
    Scope["UserConfigurationWrite"] = "USER_CONFIGURATION_WRITE";
    Scope["UserPropertyDelete"] = "USER_PROPERTY_DELETE";
    Scope["UserPropertyRead"] = "USER_PROPERTY_READ";
    Scope["UserPropertyWrite"] = "USER_PROPERTY_WRITE";
    Scope["UserRead"] = "USER_READ";
    Scope["ViewUserprofile"] = "VIEW_USERPROFILE";
    Scope["WebhookDelete"] = "WEBHOOK_DELETE";
    Scope["WebhookRead"] = "WEBHOOK_READ";
    Scope["WebhookWrite"] = "WEBHOOK_WRITE";
    Scope["WorkflowDelete"] = "WORKFLOW_DELETE";
    Scope["WorkflowPropertyDelete"] = "WORKFLOW_PROPERTY_DELETE";
    Scope["WorkflowPropertyRead"] = "WORKFLOW_PROPERTY_READ";
    Scope["WorkflowPropertyWrite"] = "WORKFLOW_PROPERTY_WRITE";
    Scope["WorkflowRead"] = "WORKFLOW_READ";
    Scope["WorkflowSchemeDelete"] = "WORKFLOW_SCHEME_DELETE";
    Scope["WorkflowSchemeRead"] = "WORKFLOW_SCHEME_READ";
    Scope["WorkflowSchemeWrite"] = "WORKFLOW_SCHEME_WRITE";
    Scope["WorkflowWrite"] = "WORKFLOW_WRITE";
    Scope["WriteCompassComponent"] = "WRITE_COMPASS_COMPONENT";
    Scope["WriteCompassEvent"] = "WRITE_COMPASS_EVENT";
    Scope["WriteCompassMetric"] = "WRITE_COMPASS_METRIC";
    Scope["WriteCompassScorecard"] = "WRITE_COMPASS_SCORECARD";
    Scope["WriteConfluenceAttachment"] = "WRITE_CONFLUENCE_ATTACHMENT";
    Scope["WriteConfluenceAuditLog"] = "WRITE_CONFLUENCE_AUDIT_LOG";
    Scope["WriteConfluenceBlogpost"] = "WRITE_CONFLUENCE_BLOGPOST";
    Scope["WriteConfluenceComment"] = "WRITE_CONFLUENCE_COMMENT";
    Scope["WriteConfluenceConfiguration"] = "WRITE_CONFLUENCE_CONFIGURATION";
    Scope["WriteConfluenceContentProperty"] = "WRITE_CONFLUENCE_CONTENT_PROPERTY";
    Scope["WriteConfluenceContentRestriction"] = "WRITE_CONFLUENCE_CONTENT_RESTRICTION";
    Scope["WriteConfluenceCustomContent"] = "WRITE_CONFLUENCE_CUSTOM_CONTENT";
    Scope["WriteConfluenceGroup"] = "WRITE_CONFLUENCE_GROUP";
    Scope["WriteConfluenceInlineTask"] = "WRITE_CONFLUENCE_INLINE_TASK";
    Scope["WriteConfluenceLabel"] = "WRITE_CONFLUENCE_LABEL";
    Scope["WriteConfluencePage"] = "WRITE_CONFLUENCE_PAGE";
    Scope["WriteConfluenceRelation"] = "WRITE_CONFLUENCE_RELATION";
    Scope["WriteConfluenceSpace"] = "WRITE_CONFLUENCE_SPACE";
    Scope["WriteConfluenceSpacePermission"] = "WRITE_CONFLUENCE_SPACE_PERMISSION";
    Scope["WriteConfluenceSpaceProperty"] = "WRITE_CONFLUENCE_SPACE_PROPERTY";
    Scope["WriteConfluenceSpaceSetting"] = "WRITE_CONFLUENCE_SPACE_SETTING";
    Scope["WriteConfluenceTemplate"] = "WRITE_CONFLUENCE_TEMPLATE";
    Scope["WriteConfluenceUserProperty"] = "WRITE_CONFLUENCE_USER_PROPERTY";
    Scope["WriteConfluenceWatcher"] = "WRITE_CONFLUENCE_WATCHER";
    Scope["WriteContainer"] = "WRITE_CONTAINER";
    Scope["WriteCustomer"] = "WRITE_CUSTOMER";
    Scope["WriteDesign"] = "WRITE_DESIGN";
    Scope["WriteJiraWork"] = "WRITE_JIRA_WORK";
    Scope["WriteJswBoardScope"] = "WRITE_JSW_BOARD_SCOPE";
    Scope["WriteJswBoardScopeAdmin"] = "WRITE_JSW_BOARD_SCOPE_ADMIN";
    Scope["WriteJswBuild"] = "WRITE_JSW_BUILD";
    Scope["WriteJswDeployment"] = "WRITE_JSW_DEPLOYMENT";
    Scope["WriteJswEpic"] = "WRITE_JSW_EPIC";
    Scope["WriteJswFeatureFlag"] = "WRITE_JSW_FEATURE_FLAG";
    Scope["WriteJswIssue"] = "WRITE_JSW_ISSUE";
    Scope["WriteJswRemoteLink"] = "WRITE_JSW_REMOTE_LINK";
    Scope["WriteJswSourceCode"] = "WRITE_JSW_SOURCE_CODE";
    Scope["WriteJswSprint"] = "WRITE_JSW_SPRINT";
    Scope["WriteNotifications"] = "WRITE_NOTIFICATIONS";
    Scope["WriteOrganization"] = "WRITE_ORGANIZATION";
    Scope["WriteOrganizationProperty"] = "WRITE_ORGANIZATION_PROPERTY";
    Scope["WriteOrganizationUser"] = "WRITE_ORGANIZATION_USER";
    Scope["WriteRequest"] = "WRITE_REQUEST";
    Scope["WriteRequesttype"] = "WRITE_REQUESTTYPE";
    Scope["WriteRequesttypeProperty"] = "WRITE_REQUESTTYPE_PROPERTY";
    Scope["WriteRequestApproval"] = "WRITE_REQUEST_APPROVAL";
    Scope["WriteRequestAttachment"] = "WRITE_REQUEST_ATTACHMENT";
    Scope["WriteRequestComment"] = "WRITE_REQUEST_COMMENT";
    Scope["WriteRequestFeedback"] = "WRITE_REQUEST_FEEDBACK";
    Scope["WriteRequestNotification"] = "WRITE_REQUEST_NOTIFICATION";
    Scope["WriteRequestParticipant"] = "WRITE_REQUEST_PARTICIPANT";
    Scope["WriteRequestStatus"] = "WRITE_REQUEST_STATUS";
    Scope["WriteServicedesk"] = "WRITE_SERVICEDESK";
    Scope["WriteServicedeskCustomer"] = "WRITE_SERVICEDESK_CUSTOMER";
    Scope["WriteServicedeskOrganization"] = "WRITE_SERVICEDESK_ORGANIZATION";
    Scope["WriteServicedeskProperty"] = "WRITE_SERVICEDESK_PROPERTY";
    Scope["WriteServicedeskRequest"] = "WRITE_SERVICEDESK_REQUEST";
    Scope["WriteTownsquareGoal"] = "WRITE_TOWNSQUARE_GOAL";
    Scope["WriteTownsquareProject"] = "WRITE_TOWNSQUARE_PROJECT";
    Scope["WriteTownsquareRelationship"] = "WRITE_TOWNSQUARE_RELATIONSHIP";
})($2f512219da033f72$export$775b6bb06e53a214 || ($2f512219da033f72$export$775b6bb06e53a214 = {}));
var $2f512219da033f72$export$58320bdd6b26937a;
(function(SearchBoardProductType) {
    SearchBoardProductType["Business"] = "BUSINESS";
    SearchBoardProductType["Software"] = "SOFTWARE";
})($2f512219da033f72$export$58320bdd6b26937a || ($2f512219da033f72$export$58320bdd6b26937a = {}));
var $2f512219da033f72$export$75fb70288e44d634;
(function(SearchConfluenceDocumentStatus) {
    SearchConfluenceDocumentStatus["Archived"] = "ARCHIVED";
    SearchConfluenceDocumentStatus["Current"] = "CURRENT";
    SearchConfluenceDocumentStatus["Draft"] = "DRAFT";
})($2f512219da033f72$export$75fb70288e44d634 || ($2f512219da033f72$export$75fb70288e44d634 = {}));
var $2f512219da033f72$export$641731d7c91b88de;
(function(SearchConfluenceRangeField) {
    SearchConfluenceRangeField["Created"] = "CREATED";
    SearchConfluenceRangeField["Lastmodified"] = "LASTMODIFIED";
})($2f512219da033f72$export$641731d7c91b88de || ($2f512219da033f72$export$641731d7c91b88de = {}));
var $2f512219da033f72$export$3646d7b76c420c42;
(function(SearchContainerStatus) {
    SearchContainerStatus["Archived"] = "ARCHIVED";
    SearchContainerStatus["Current"] = "CURRENT";
})($2f512219da033f72$export$3646d7b76c420c42 || ($2f512219da033f72$export$3646d7b76c420c42 = {}));
var $2f512219da033f72$export$981cf94add4585a6;
(function(SearchIssueStatusCategory) {
    SearchIssueStatusCategory["Done"] = "DONE";
    SearchIssueStatusCategory["Open"] = "OPEN";
})($2f512219da033f72$export$981cf94add4585a6 || ($2f512219da033f72$export$981cf94add4585a6 = {}));
var $2f512219da033f72$export$395d337d64b9f57f;
(function(SearchProjectType) {
    SearchProjectType["Business"] = "business";
    SearchProjectType["ProductDiscovery"] = "product_discovery";
    SearchProjectType["ServiceDesk"] = "service_desk";
    SearchProjectType["Software"] = "software";
})($2f512219da033f72$export$395d337d64b9f57f || ($2f512219da033f72$export$395d337d64b9f57f = {}));
var $2f512219da033f72$export$95cacd63dfd98bee;
(function(SearchResultType) {
    SearchResultType["Attachment"] = "attachment";
    SearchResultType["Blogpost"] = "blogpost";
    SearchResultType["Board"] = "board";
    SearchResultType["Comment"] = "comment";
    SearchResultType["Component"] = "component";
    SearchResultType["Dashboard"] = "dashboard";
    SearchResultType["Database"] = "database";
    SearchResultType["Document"] = "document";
    SearchResultType["Embed"] = "embed";
    SearchResultType["Filter"] = "filter";
    SearchResultType["FocusArea"] = "focus_area";
    SearchResultType["FocusAreaStatusUpdate"] = "focus_area_status_update";
    SearchResultType["Folder"] = "folder";
    SearchResultType["Goal"] = "goal";
    SearchResultType["GoalUpdate"] = "goal_update";
    SearchResultType["Issue"] = "issue";
    SearchResultType["Learning"] = "learning";
    SearchResultType["Message"] = "message";
    SearchResultType["Page"] = "page";
    SearchResultType["Plan"] = "plan";
    SearchResultType["Presentation"] = "presentation";
    SearchResultType["Project"] = "project";
    SearchResultType["ProjectUpdate"] = "project_update";
    SearchResultType["Question"] = "question";
    SearchResultType["Repository"] = "repository";
    SearchResultType["Space"] = "space";
    SearchResultType["Spreadsheet"] = "spreadsheet";
    SearchResultType["Tag"] = "tag";
    SearchResultType["Unrecognised"] = "unrecognised";
    SearchResultType["Whiteboard"] = "whiteboard";
})($2f512219da033f72$export$95cacd63dfd98bee || ($2f512219da033f72$export$95cacd63dfd98bee = {}));
var $2f512219da033f72$export$3cf9b6ba26bc95c6;
(function(SearchSortOrder) {
    SearchSortOrder["Asc"] = "ASC";
    SearchSortOrder["Desc"] = "DESC";
})($2f512219da033f72$export$3cf9b6ba26bc95c6 || ($2f512219da033f72$export$3cf9b6ba26bc95c6 = {}));
var $2f512219da033f72$export$1eed0ec46c1a7935;
(function(SearchThirdPartyRangeField) {
    SearchThirdPartyRangeField["Created"] = "CREATED";
    SearchThirdPartyRangeField["Lastmodified"] = "LASTMODIFIED";
})($2f512219da033f72$export$1eed0ec46c1a7935 || ($2f512219da033f72$export$1eed0ec46c1a7935 = {}));
var $2f512219da033f72$export$a400840d3d1ded52;
(function(SearchesByTermColumns) {
    SearchesByTermColumns["PageViewedPercentage"] = "pageViewedPercentage";
    SearchesByTermColumns["SearchClickCount"] = "searchClickCount";
    SearchesByTermColumns["SearchSessionCount"] = "searchSessionCount";
    SearchesByTermColumns["SearchTerm"] = "searchTerm";
    SearchesByTermColumns["Total"] = "total";
    SearchesByTermColumns["UniqueUsers"] = "uniqueUsers";
})($2f512219da033f72$export$a400840d3d1ded52 || ($2f512219da033f72$export$a400840d3d1ded52 = {}));
var $2f512219da033f72$export$ec619dd4a07731dc;
(function(SearchesByTermPeriod) {
    SearchesByTermPeriod["Day"] = "day";
    SearchesByTermPeriod["Month"] = "month";
    SearchesByTermPeriod["Week"] = "week";
})($2f512219da033f72$export$ec619dd4a07731dc || ($2f512219da033f72$export$ec619dd4a07731dc = {}));
var $2f512219da033f72$export$2fb3cc604293ed17;
(function(ShareType) {
    ShareType["InviteToEdit"] = "INVITE_TO_EDIT";
    ShareType["SharePage"] = "SHARE_PAGE";
})($2f512219da033f72$export$2fb3cc604293ed17 || ($2f512219da033f72$export$2fb3cc604293ed17 = {}));
var $2f512219da033f72$export$34f9eb005ab98ff7;
(function(ShepherdActionType) {
    ShepherdActionType["Activate"] = "ACTIVATE";
    ShepherdActionType["Archive"] = "ARCHIVE";
    ShepherdActionType["Crawl"] = "CRAWL";
    ShepherdActionType["Create"] = "CREATE";
    ShepherdActionType["Deactivate"] = "DEACTIVATE";
    ShepherdActionType["Delete"] = "DELETE";
    ShepherdActionType["Download"] = "DOWNLOAD";
    ShepherdActionType["Export"] = "EXPORT";
    ShepherdActionType["Grant"] = "GRANT";
    ShepherdActionType["Install"] = "INSTALL";
    ShepherdActionType["Login"] = "LOGIN";
    ShepherdActionType["LoginAs"] = "LOGIN_AS";
    ShepherdActionType["Publish"] = "PUBLISH";
    ShepherdActionType["Read"] = "READ";
    ShepherdActionType["Revoke"] = "REVOKE";
    ShepherdActionType["Search"] = "SEARCH";
    ShepherdActionType["Uninstall"] = "UNINSTALL";
    ShepherdActionType["Update"] = "UPDATE";
})($2f512219da033f72$export$34f9eb005ab98ff7 || ($2f512219da033f72$export$34f9eb005ab98ff7 = {}));
var $2f512219da033f72$export$54f03cbb2a3e778f;
(function(ShepherdActorOrgStatus) {
    ShepherdActorOrgStatus["Active"] = "ACTIVE";
    ShepherdActorOrgStatus["Deactivated"] = "DEACTIVATED";
    ShepherdActorOrgStatus["Suspended"] = "SUSPENDED";
})($2f512219da033f72$export$54f03cbb2a3e778f || ($2f512219da033f72$export$54f03cbb2a3e778f = {}));
var $2f512219da033f72$export$467ce4c000663710;
(function(ShepherdAlertAction) {
    ShepherdAlertAction["AddLabel"] = "ADD_LABEL";
    ShepherdAlertAction["Redact"] = "REDACT";
    ShepherdAlertAction["Restrict"] = "RESTRICT";
    ShepherdAlertAction["UpdateDataClassification"] = "UPDATE_DATA_CLASSIFICATION";
})($2f512219da033f72$export$467ce4c000663710 || ($2f512219da033f72$export$467ce4c000663710 = {}));
var $2f512219da033f72$export$ec1710c62a266610;
(function(ShepherdAlertDetectionCategory) {
    ShepherdAlertDetectionCategory["Data"] = "DATA";
    ShepherdAlertDetectionCategory["Threat"] = "THREAT";
})($2f512219da033f72$export$ec1710c62a266610 || ($2f512219da033f72$export$ec1710c62a266610 = {}));
var $2f512219da033f72$export$13fabac16873dc0;
(function(ShepherdAlertSnippetRedactionStatus) {
    ShepherdAlertSnippetRedactionStatus["Redacted"] = "REDACTED";
    ShepherdAlertSnippetRedactionStatus["RedactionFailed"] = "REDACTION_FAILED";
    ShepherdAlertSnippetRedactionStatus["RedactionPending"] = "REDACTION_PENDING";
    ShepherdAlertSnippetRedactionStatus["Unredacted"] = "UNREDACTED";
})($2f512219da033f72$export$13fabac16873dc0 || ($2f512219da033f72$export$13fabac16873dc0 = {}));
var $2f512219da033f72$export$48343fd5997afd49;
(function(ShepherdAlertStatus) {
    ShepherdAlertStatus["InProgress"] = "IN_PROGRESS";
    ShepherdAlertStatus["Triaged"] = "TRIAGED";
    ShepherdAlertStatus["TriagedExpectedActivity"] = "TRIAGED_EXPECTED_ACTIVITY";
    ShepherdAlertStatus["TriagedTruePositive"] = "TRIAGED_TRUE_POSITIVE";
    ShepherdAlertStatus["Untriaged"] = "UNTRIAGED";
})($2f512219da033f72$export$48343fd5997afd49 || ($2f512219da033f72$export$48343fd5997afd49 = {}));
var $2f512219da033f72$export$78b33ffe8847c025;
(function(ShepherdAlertTemplateType) {
    ShepherdAlertTemplateType["AddedConfluenceGlobalPermission"] = "ADDED_CONFLUENCE_GLOBAL_PERMISSION";
    ShepherdAlertTemplateType["AddedConfluenceSpacePermission"] = "ADDED_CONFLUENCE_SPACE_PERMISSION";
    ShepherdAlertTemplateType["AddedDomain"] = "ADDED_DOMAIN";
    ShepherdAlertTemplateType["AddedJiraGlobalPermission"] = "ADDED_JIRA_GLOBAL_PERMISSION";
    ShepherdAlertTemplateType["AddedOrgadmin"] = "ADDED_ORGADMIN";
    ShepherdAlertTemplateType["BitbucketRepositoryPrivacy"] = "BITBUCKET_REPOSITORY_PRIVACY";
    ShepherdAlertTemplateType["BitbucketWorkspacePrivacy"] = "BITBUCKET_WORKSPACE_PRIVACY";
    ShepherdAlertTemplateType["ClassificationLevelArchived"] = "CLASSIFICATION_LEVEL_ARCHIVED";
    ShepherdAlertTemplateType["ClassificationLevelPublished"] = "CLASSIFICATION_LEVEL_PUBLISHED";
    ShepherdAlertTemplateType["CompromisedMobileDevice"] = "COMPROMISED_MOBILE_DEVICE";
    ShepherdAlertTemplateType["ConfluenceCustomDetection"] = "CONFLUENCE_CUSTOM_DETECTION";
    ShepherdAlertTemplateType["ConfluenceDataDiscovery"] = "CONFLUENCE_DATA_DISCOVERY";
    ShepherdAlertTemplateType["ConfluenceDataDiscoveryAtlassianToken"] = "CONFLUENCE_DATA_DISCOVERY_ATLASSIAN_TOKEN";
    ShepherdAlertTemplateType["ConfluenceDataDiscoveryAuTfn"] = "CONFLUENCE_DATA_DISCOVERY_AU_TFN";
    ShepherdAlertTemplateType["ConfluenceDataDiscoveryAwsKeys"] = "CONFLUENCE_DATA_DISCOVERY_AWS_KEYS";
    ShepherdAlertTemplateType["ConfluenceDataDiscoveryCreditCard"] = "CONFLUENCE_DATA_DISCOVERY_CREDIT_CARD";
    ShepherdAlertTemplateType["ConfluenceDataDiscoveryCrypto"] = "CONFLUENCE_DATA_DISCOVERY_CRYPTO";
    ShepherdAlertTemplateType["ConfluenceDataDiscoveryIban"] = "CONFLUENCE_DATA_DISCOVERY_IBAN";
    ShepherdAlertTemplateType["ConfluenceDataDiscoveryJwtKey"] = "CONFLUENCE_DATA_DISCOVERY_JWT_KEY";
    ShepherdAlertTemplateType["ConfluenceDataDiscoveryPassword"] = "CONFLUENCE_DATA_DISCOVERY_PASSWORD";
    ShepherdAlertTemplateType["ConfluenceDataDiscoveryPrivateKey"] = "CONFLUENCE_DATA_DISCOVERY_PRIVATE_KEY";
    ShepherdAlertTemplateType["ConfluenceDataDiscoveryUsSsn"] = "CONFLUENCE_DATA_DISCOVERY_US_SSN";
    ShepherdAlertTemplateType["ConfluencePageCrawling"] = "CONFLUENCE_PAGE_CRAWLING";
    ShepherdAlertTemplateType["ConfluencePageExports"] = "CONFLUENCE_PAGE_EXPORTS";
    ShepherdAlertTemplateType["ConfluenceSiteBackupDownloaded"] = "CONFLUENCE_SITE_BACKUP_DOWNLOADED";
    ShepherdAlertTemplateType["ConfluenceSpaceExports"] = "CONFLUENCE_SPACE_EXPORTS";
    ShepherdAlertTemplateType["ConfluenceSuspiciousSearch"] = "CONFLUENCE_SUSPICIOUS_SEARCH";
    ShepherdAlertTemplateType["CreatedAuthPolicy"] = "CREATED_AUTH_POLICY";
    ShepherdAlertTemplateType["CreatedMobileAppPolicy"] = "CREATED_MOBILE_APP_POLICY";
    ShepherdAlertTemplateType["CreatedPolicy"] = "CREATED_POLICY";
    ShepherdAlertTemplateType["CreatedSamlConfig"] = "CREATED_SAML_CONFIG";
    ShepherdAlertTemplateType["CreatedTunnel"] = "CREATED_TUNNEL";
    ShepherdAlertTemplateType["CreatedUserProvisioning"] = "CREATED_USER_PROVISIONING";
    ShepherdAlertTemplateType["DataSecurityPolicyActivated"] = "DATA_SECURITY_POLICY_ACTIVATED";
    ShepherdAlertTemplateType["DataSecurityPolicyDeactivated"] = "DATA_SECURITY_POLICY_DEACTIVATED";
    ShepherdAlertTemplateType["DataSecurityPolicyDeleted"] = "DATA_SECURITY_POLICY_DELETED";
    ShepherdAlertTemplateType["DataSecurityPolicyUpdated"] = "DATA_SECURITY_POLICY_UPDATED";
    ShepherdAlertTemplateType["Default"] = "DEFAULT";
    ShepherdAlertTemplateType["DeletedAuthPolicy"] = "DELETED_AUTH_POLICY";
    ShepherdAlertTemplateType["DeletedDomain"] = "DELETED_DOMAIN";
    ShepherdAlertTemplateType["DeletedMobileAppPolicy"] = "DELETED_MOBILE_APP_POLICY";
    ShepherdAlertTemplateType["DeletedPolicy"] = "DELETED_POLICY";
    ShepherdAlertTemplateType["DeletedTunnel"] = "DELETED_TUNNEL";
    ShepherdAlertTemplateType["EcosystemAuditLogInstallationCreated"] = "ECOSYSTEM_AUDIT_LOG_INSTALLATION_CREATED";
    ShepherdAlertTemplateType["EcosystemAuditLogInstallationDeleted"] = "ECOSYSTEM_AUDIT_LOG_INSTALLATION_DELETED";
    ShepherdAlertTemplateType["EcosystemAuditLogUserGrantCreated"] = "ECOSYSTEM_AUDIT_LOG_USER_GRANT_CREATED";
    ShepherdAlertTemplateType["EducationalAlert"] = "EDUCATIONAL_ALERT";
    ShepherdAlertTemplateType["EnableScimSync"] = "ENABLE_SCIM_SYNC";
    ShepherdAlertTemplateType["ExportedOrgeventscsv"] = "EXPORTED_ORGEVENTSCSV";
    ShepherdAlertTemplateType["GrantAssignedJiraPermissionScheme"] = "GRANT_ASSIGNED_JIRA_PERMISSION_SCHEME";
    ShepherdAlertTemplateType["IdentityPasswordResetCompletedUser"] = "IDENTITY_PASSWORD_RESET_COMPLETED_USER";
    ShepherdAlertTemplateType["ImpossibleTravel"] = "IMPOSSIBLE_TRAVEL";
    ShepherdAlertTemplateType["InitiatedGsyncConnection"] = "INITIATED_GSYNC_CONNECTION";
    ShepherdAlertTemplateType["JiraCustomDetection"] = "JIRA_CUSTOM_DETECTION";
    ShepherdAlertTemplateType["JiraDataDiscoveryAtlassianToken"] = "JIRA_DATA_DISCOVERY_ATLASSIAN_TOKEN";
    ShepherdAlertTemplateType["JiraDataDiscoveryAuTfn"] = "JIRA_DATA_DISCOVERY_AU_TFN";
    ShepherdAlertTemplateType["JiraDataDiscoveryAwsKeys"] = "JIRA_DATA_DISCOVERY_AWS_KEYS";
    ShepherdAlertTemplateType["JiraDataDiscoveryCreditCard"] = "JIRA_DATA_DISCOVERY_CREDIT_CARD";
    ShepherdAlertTemplateType["JiraDataDiscoveryCrypto"] = "JIRA_DATA_DISCOVERY_CRYPTO";
    ShepherdAlertTemplateType["JiraDataDiscoveryIban"] = "JIRA_DATA_DISCOVERY_IBAN";
    ShepherdAlertTemplateType["JiraDataDiscoveryJwtKey"] = "JIRA_DATA_DISCOVERY_JWT_KEY";
    ShepherdAlertTemplateType["JiraDataDiscoveryPassword"] = "JIRA_DATA_DISCOVERY_PASSWORD";
    ShepherdAlertTemplateType["JiraDataDiscoveryPrivateKey"] = "JIRA_DATA_DISCOVERY_PRIVATE_KEY";
    ShepherdAlertTemplateType["JiraDataDiscoveryUsSsn"] = "JIRA_DATA_DISCOVERY_US_SSN";
    ShepherdAlertTemplateType["JiraIssueCrawling"] = "JIRA_ISSUE_CRAWLING";
    ShepherdAlertTemplateType["LoginFromMaliciousIpAddress"] = "LOGIN_FROM_MALICIOUS_IP_ADDRESS";
    ShepherdAlertTemplateType["LoginFromTorExitNode"] = "LOGIN_FROM_TOR_EXIT_NODE";
    ShepherdAlertTemplateType["MobileScreenLock"] = "MOBILE_SCREEN_LOCK";
    ShepherdAlertTemplateType["OrgLoggedInAsUser"] = "ORG_LOGGED_IN_AS_USER";
    ShepherdAlertTemplateType["ProjectClassificationLevelDecreased"] = "PROJECT_CLASSIFICATION_LEVEL_DECREASED";
    ShepherdAlertTemplateType["ProjectClassificationLevelIncreased"] = "PROJECT_CLASSIFICATION_LEVEL_INCREASED";
    ShepherdAlertTemplateType["RotateScimDirectoryToken"] = "ROTATE_SCIM_DIRECTORY_TOKEN";
    ShepherdAlertTemplateType["SpaceClassificationLevelDecreased"] = "SPACE_CLASSIFICATION_LEVEL_DECREASED";
    ShepherdAlertTemplateType["SpaceClassificationLevelIncreased"] = "SPACE_CLASSIFICATION_LEVEL_INCREASED";
    ShepherdAlertTemplateType["TestAlert"] = "TEST_ALERT";
    ShepherdAlertTemplateType["TokenCreated"] = "TOKEN_CREATED";
    ShepherdAlertTemplateType["TokenRevoked"] = "TOKEN_REVOKED";
    ShepherdAlertTemplateType["UpdatedAuthPolicy"] = "UPDATED_AUTH_POLICY";
    ShepherdAlertTemplateType["UpdatedMobileAppPolicy"] = "UPDATED_MOBILE_APP_POLICY";
    ShepherdAlertTemplateType["UpdatedPolicy"] = "UPDATED_POLICY";
    ShepherdAlertTemplateType["UpdatedSamlConfig"] = "UPDATED_SAML_CONFIG";
    ShepherdAlertTemplateType["UserAddedToBeacon"] = "USER_ADDED_TO_BEACON";
    ShepherdAlertTemplateType["UserGrantedRole"] = "USER_GRANTED_ROLE";
    ShepherdAlertTemplateType["UserRemovedFromBeacon"] = "USER_REMOVED_FROM_BEACON";
    ShepherdAlertTemplateType["UserRevokedRole"] = "USER_REVOKED_ROLE";
    ShepherdAlertTemplateType["UserTokenCreated"] = "USER_TOKEN_CREATED";
    ShepherdAlertTemplateType["UserTokenRevoked"] = "USER_TOKEN_REVOKED";
    ShepherdAlertTemplateType["VerifiedDomainVerification"] = "VERIFIED_DOMAIN_VERIFICATION";
})($2f512219da033f72$export$78b33ffe8847c025 || ($2f512219da033f72$export$78b33ffe8847c025 = {}));
var $2f512219da033f72$export$9dd0637f1b429aee;
(function(ShepherdAtlassianProduct) {
    ShepherdAtlassianProduct["AdminHub"] = "ADMIN_HUB";
    ShepherdAtlassianProduct["Bitbucket"] = "BITBUCKET";
    ShepherdAtlassianProduct["Confluence"] = "CONFLUENCE";
    ShepherdAtlassianProduct["ConfluenceDc"] = "CONFLUENCE_DC";
    ShepherdAtlassianProduct["GuardDetect"] = "GUARD_DETECT";
    ShepherdAtlassianProduct["JiraDc"] = "JIRA_DC";
    ShepherdAtlassianProduct["JiraSoftware"] = "JIRA_SOFTWARE";
    ShepherdAtlassianProduct["Marketplace"] = "MARKETPLACE";
})($2f512219da033f72$export$9dd0637f1b429aee || ($2f512219da033f72$export$9dd0637f1b429aee = {}));
var $2f512219da033f72$export$4ee416f20f5a941a;
(function(ShepherdClassificationLevelColor) {
    ShepherdClassificationLevelColor["Blue"] = "BLUE";
    ShepherdClassificationLevelColor["BlueBold"] = "BLUE_BOLD";
    ShepherdClassificationLevelColor["Green"] = "GREEN";
    ShepherdClassificationLevelColor["Grey"] = "GREY";
    ShepherdClassificationLevelColor["Lime"] = "LIME";
    ShepherdClassificationLevelColor["Navy"] = "NAVY";
    ShepherdClassificationLevelColor["None"] = "NONE";
    ShepherdClassificationLevelColor["Orange"] = "ORANGE";
    ShepherdClassificationLevelColor["Purple"] = "PURPLE";
    ShepherdClassificationLevelColor["Red"] = "RED";
    ShepherdClassificationLevelColor["RedBold"] = "RED_BOLD";
    ShepherdClassificationLevelColor["Teal"] = "TEAL";
    ShepherdClassificationLevelColor["Yellow"] = "YELLOW";
})($2f512219da033f72$export$4ee416f20f5a941a || ($2f512219da033f72$export$4ee416f20f5a941a = {}));
var $2f512219da033f72$export$dddaf5557f82edf7;
(function(ShepherdClassificationStatus) {
    ShepherdClassificationStatus["Archived"] = "ARCHIVED";
    ShepherdClassificationStatus["Draft"] = "DRAFT";
    ShepherdClassificationStatus["Published"] = "PUBLISHED";
})($2f512219da033f72$export$dddaf5557f82edf7 || ($2f512219da033f72$export$dddaf5557f82edf7 = {}));
var $2f512219da033f72$export$f961d21a5cd3eed7;
(function(ShepherdCustomScanningMatchType) {
    ShepherdCustomScanningMatchType["Regex"] = "REGEX";
    ShepherdCustomScanningMatchType["String"] = "STRING";
    ShepherdCustomScanningMatchType["Word"] = "WORD";
})($2f512219da033f72$export$f961d21a5cd3eed7 || ($2f512219da033f72$export$f961d21a5cd3eed7 = {}));
var $2f512219da033f72$export$db4af14fade5e4e5;
(function(ShepherdDetectionScanningFrequency) {
    ShepherdDetectionScanningFrequency["RealTime"] = "REAL_TIME";
    ShepherdDetectionScanningFrequency["Scheduled"] = "SCHEDULED";
})($2f512219da033f72$export$db4af14fade5e4e5 || ($2f512219da033f72$export$db4af14fade5e4e5 = {}));
var $2f512219da033f72$export$2f9e73ea31c391f3;
(function(ShepherdLoginDeviceType) {
    ShepherdLoginDeviceType["Computer"] = "COMPUTER";
    ShepherdLoginDeviceType["Console"] = "CONSOLE";
    ShepherdLoginDeviceType["Embedded"] = "EMBEDDED";
    ShepherdLoginDeviceType["Mobile"] = "MOBILE";
    ShepherdLoginDeviceType["SmartTv"] = "SMART_TV";
    ShepherdLoginDeviceType["Tablet"] = "TABLET";
    ShepherdLoginDeviceType["Wearable"] = "WEARABLE";
})($2f512219da033f72$export$2f9e73ea31c391f3 || ($2f512219da033f72$export$2f9e73ea31c391f3 = {}));
var $2f512219da033f72$export$c8dd2e548b70194f;
(function(ShepherdMutationErrorType) {
    ShepherdMutationErrorType["BadRequest"] = "BAD_REQUEST";
    ShepherdMutationErrorType["InternalServerError"] = "INTERNAL_SERVER_ERROR";
    ShepherdMutationErrorType["NoProductAccess"] = "NO_PRODUCT_ACCESS";
    ShepherdMutationErrorType["Unauthorized"] = "UNAUTHORIZED";
})($2f512219da033f72$export$c8dd2e548b70194f || ($2f512219da033f72$export$c8dd2e548b70194f = {}));
var $2f512219da033f72$export$60854452710d481b;
(function(ShepherdQueryErrorType) {
    ShepherdQueryErrorType["BadRequest"] = "BAD_REQUEST";
    ShepherdQueryErrorType["InternalServerError"] = "INTERNAL_SERVER_ERROR";
    ShepherdQueryErrorType["NoProductAccess"] = "NO_PRODUCT_ACCESS";
    ShepherdQueryErrorType["Unauthorized"] = "UNAUTHORIZED";
})($2f512219da033f72$export$60854452710d481b || ($2f512219da033f72$export$60854452710d481b = {}));
var $2f512219da033f72$export$359aa80f049e8938;
(function(ShepherdRateThresholdValue) {
    ShepherdRateThresholdValue["High"] = "HIGH";
    ShepherdRateThresholdValue["Low"] = "LOW";
    ShepherdRateThresholdValue["Medium"] = "MEDIUM";
})($2f512219da033f72$export$359aa80f049e8938 || ($2f512219da033f72$export$359aa80f049e8938 = {}));
var $2f512219da033f72$export$a6dfb45e275970d5;
(function(ShepherdRedactedContentStatus) {
    ShepherdRedactedContentStatus["Redacted"] = "REDACTED";
    ShepherdRedactedContentStatus["RedactionFailed"] = "REDACTION_FAILED";
    ShepherdRedactedContentStatus["RedactionPending"] = "REDACTION_PENDING";
})($2f512219da033f72$export$a6dfb45e275970d5 || ($2f512219da033f72$export$a6dfb45e275970d5 = {}));
var $2f512219da033f72$export$d34a98598cc91c63;
(function(ShepherdRedactionStatus) {
    ShepherdRedactionStatus["Failed"] = "FAILED";
    ShepherdRedactionStatus["PartiallyRedacted"] = "PARTIALLY_REDACTED";
    ShepherdRedactionStatus["Pending"] = "PENDING";
    ShepherdRedactionStatus["Redacted"] = "REDACTED";
})($2f512219da033f72$export$d34a98598cc91c63 || ($2f512219da033f72$export$d34a98598cc91c63 = {}));
var $2f512219da033f72$export$8bcebd025de2c46b;
(function(ShepherdRemediationActionType) {
    ShepherdRemediationActionType["AnonAccessDspRemediation"] = "ANON_ACCESS_DSP_REMEDIATION";
    ShepherdRemediationActionType["ApplyClassificationRemediation"] = "APPLY_CLASSIFICATION_REMEDIATION";
    ShepherdRemediationActionType["AppsAccessDspRemediation"] = "APPS_ACCESS_DSP_REMEDIATION";
    ShepherdRemediationActionType["ArchiveRestoreClassificationRemediation"] = "ARCHIVE_RESTORE_CLASSIFICATION_REMEDIATION";
    ShepherdRemediationActionType["BlockchainExplorerRemediation"] = "BLOCKCHAIN_EXPLORER_REMEDIATION";
    ShepherdRemediationActionType["BlockIpAllowlistRemediation"] = "BLOCK_IP_ALLOWLIST_REMEDIATION";
    ShepherdRemediationActionType["CheckAutomationsRemediation"] = "CHECK_AUTOMATIONS_REMEDIATION";
    ShepherdRemediationActionType["ClassificationLevelChangeRemediation"] = "CLASSIFICATION_LEVEL_CHANGE_REMEDIATION";
    ShepherdRemediationActionType["CompromisedDeviceRemediation"] = "COMPROMISED_DEVICE_REMEDIATION";
    ShepherdRemediationActionType["ConfluenceAnonAccessRemediation"] = "CONFLUENCE_ANON_ACCESS_REMEDIATION";
    ShepherdRemediationActionType["DeleteDataRemediation"] = "DELETE_DATA_REMEDIATION";
    ShepherdRemediationActionType["DeleteFilesRemediation"] = "DELETE_FILES_REMEDIATION";
    ShepherdRemediationActionType["EditCustomDetectionRemediation"] = "EDIT_CUSTOM_DETECTION_REMEDIATION";
    ShepherdRemediationActionType["ExcludePageRemediation"] = "EXCLUDE_PAGE_REMEDIATION";
    ShepherdRemediationActionType["ExcludeUserRemediation"] = "EXCLUDE_USER_REMEDIATION";
    ShepherdRemediationActionType["ExportsDspRemediation"] = "EXPORTS_DSP_REMEDIATION";
    ShepherdRemediationActionType["ExportDspRemediation"] = "EXPORT_DSP_REMEDIATION";
    ShepherdRemediationActionType["ExportSpacePermissionsRemediation"] = "EXPORT_SPACE_PERMISSIONS_REMEDIATION";
    ShepherdRemediationActionType["JiraGlobalPermissionsRemediation"] = "JIRA_GLOBAL_PERMISSIONS_REMEDIATION";
    ShepherdRemediationActionType["KeyOwnerRemediation"] = "KEY_OWNER_REMEDIATION";
    ShepherdRemediationActionType["LimitJiraPermissionsRemediation"] = "LIMIT_JIRA_PERMISSIONS_REMEDIATION";
    ShepherdRemediationActionType["ManageAppsRemediation"] = "MANAGE_APPS_REMEDIATION";
    ShepherdRemediationActionType["ManageDomainRemediation"] = "MANAGE_DOMAIN_REMEDIATION";
    ShepherdRemediationActionType["ManageDspRemediation"] = "MANAGE_DSP_REMEDIATION";
    ShepherdRemediationActionType["PublicAccessDspRemediation"] = "PUBLIC_ACCESS_DSP_REMEDIATION";
    ShepherdRemediationActionType["ResetAccountPasswordRemediation"] = "RESET_ACCOUNT_PASSWORD_REMEDIATION";
    ShepherdRemediationActionType["RestoreAccessRemediation"] = "RESTORE_ACCESS_REMEDIATION";
    ShepherdRemediationActionType["RestrictPageAutomationRemediation"] = "RESTRICT_PAGE_AUTOMATION_REMEDIATION";
    ShepherdRemediationActionType["ReviewAccessRemediation"] = "REVIEW_ACCESS_REMEDIATION";
    ShepherdRemediationActionType["ReviewApiKeysRemediation"] = "REVIEW_API_KEYS_REMEDIATION";
    ShepherdRemediationActionType["ReviewApiTokensRemediation"] = "REVIEW_API_TOKENS_REMEDIATION";
    ShepherdRemediationActionType["ReviewAuditLogRemediation"] = "REVIEW_AUDIT_LOG_REMEDIATION";
    ShepherdRemediationActionType["ReviewAuthPolicyRemediation"] = "REVIEW_AUTH_POLICY_REMEDIATION";
    ShepherdRemediationActionType["ReviewGsyncRemediation"] = "REVIEW_GSYNC_REMEDIATION";
    ShepherdRemediationActionType["ReviewIpAllowlistRemediation"] = "REVIEW_IP_ALLOWLIST_REMEDIATION";
    ShepherdRemediationActionType["ReviewIssueRemediation"] = "REVIEW_ISSUE_REMEDIATION";
    ShepherdRemediationActionType["ReviewMobileAppPolicyRemediation"] = "REVIEW_MOBILE_APP_POLICY_REMEDIATION";
    ShepherdRemediationActionType["ReviewOtherAuthPoliciesRemediation"] = "REVIEW_OTHER_AUTH_POLICIES_REMEDIATION";
    ShepherdRemediationActionType["ReviewOtherIpAllowlistRemediation"] = "REVIEW_OTHER_IP_ALLOWLIST_REMEDIATION";
    ShepherdRemediationActionType["ReviewPageRemediation"] = "REVIEW_PAGE_REMEDIATION";
    ShepherdRemediationActionType["ReviewSamlRemediation"] = "REVIEW_SAML_REMEDIATION";
    ShepherdRemediationActionType["ReviewScimRemediation"] = "REVIEW_SCIM_REMEDIATION";
    ShepherdRemediationActionType["ReviewTunnelsConfigurationRemediation"] = "REVIEW_TUNNELS_CONFIGURATION_REMEDIATION";
    ShepherdRemediationActionType["ReviewTunnelsRemediation"] = "REVIEW_TUNNELS_REMEDIATION";
    ShepherdRemediationActionType["RevokeAccessRemediation"] = "REVOKE_ACCESS_REMEDIATION";
    ShepherdRemediationActionType["RevokeApiKeyRemediation"] = "REVOKE_API_KEY_REMEDIATION";
    ShepherdRemediationActionType["RevokeApiTokensRemediation"] = "REVOKE_API_TOKENS_REMEDIATION";
    ShepherdRemediationActionType["RevokeUserApiTokenRemediation"] = "REVOKE_USER_API_TOKEN_REMEDIATION";
    ShepherdRemediationActionType["SpacePermissionsRemediation"] = "SPACE_PERMISSIONS_REMEDIATION";
    ShepherdRemediationActionType["SuspendActorRemediation"] = "SUSPEND_ACTOR_REMEDIATION";
    ShepherdRemediationActionType["SuspendSubjectRemediation"] = "SUSPEND_SUBJECT_REMEDIATION";
    ShepherdRemediationActionType["TurnOffJiraPermissionsRemediation"] = "TURN_OFF_JIRA_PERMISSIONS_REMEDIATION";
    ShepherdRemediationActionType["TwoStepPolicyRemediation"] = "TWO_STEP_POLICY_REMEDIATION";
    ShepherdRemediationActionType["UseAuthPolicyRemediation"] = "USE_AUTH_POLICY_REMEDIATION";
    ShepherdRemediationActionType["ViewSpacePermissionsRemediation"] = "VIEW_SPACE_PERMISSIONS_REMEDIATION";
})($2f512219da033f72$export$8bcebd025de2c46b || ($2f512219da033f72$export$8bcebd025de2c46b = {}));
var $2f512219da033f72$export$e0c4be2f8b0999ce;
(function(ShepherdSearchOrigin) {
    ShepherdSearchOrigin["AdvancedSearch"] = "ADVANCED_SEARCH";
    ShepherdSearchOrigin["Ai"] = "AI";
    ShepherdSearchOrigin["QuickSearch"] = "QUICK_SEARCH";
})($2f512219da033f72$export$e0c4be2f8b0999ce || ($2f512219da033f72$export$e0c4be2f8b0999ce = {}));
var $2f512219da033f72$export$8f5af6e8802c488;
(function(ShepherdSubscriptionStatus) {
    ShepherdSubscriptionStatus["Active"] = "ACTIVE";
    ShepherdSubscriptionStatus["Error"] = "ERROR";
    ShepherdSubscriptionStatus["Inactive"] = "INACTIVE";
})($2f512219da033f72$export$8f5af6e8802c488 || ($2f512219da033f72$export$8f5af6e8802c488 = {}));
var $2f512219da033f72$export$80ad4b94a728f2e2;
(function(ShepherdVortexModeStatus) {
    ShepherdVortexModeStatus["Disabled"] = "DISABLED";
    ShepherdVortexModeStatus["Enabled"] = "ENABLED";
})($2f512219da033f72$export$80ad4b94a728f2e2 || ($2f512219da033f72$export$80ad4b94a728f2e2 = {}));
var $2f512219da033f72$export$cfc31900765a3ba4;
(function(ShepherdWebhookDestinationType) {
    ShepherdWebhookDestinationType["Default"] = "DEFAULT";
    ShepherdWebhookDestinationType["MicrosoftTeams"] = "MICROSOFT_TEAMS";
})($2f512219da033f72$export$cfc31900765a3ba4 || ($2f512219da033f72$export$cfc31900765a3ba4 = {}));
var $2f512219da033f72$export$2e013066679d73f8;
(function(ShepherdWebhookType) {
    ShepherdWebhookType["Custom"] = "CUSTOM";
    ShepherdWebhookType["MicrosoftTeams"] = "MICROSOFT_TEAMS";
    ShepherdWebhookType["Slack"] = "SLACK";
})($2f512219da033f72$export$2e013066679d73f8 || ($2f512219da033f72$export$2e013066679d73f8 = {}));
var $2f512219da033f72$export$7cafeba671f9185e;
(function(SitePermissionOperationType) {
    SitePermissionOperationType["AdministerConfluence"] = "ADMINISTER_CONFLUENCE";
    SitePermissionOperationType["AdministerSystem"] = "ADMINISTER_SYSTEM";
    SitePermissionOperationType["CreateProfileattachment"] = "CREATE_PROFILEATTACHMENT";
    SitePermissionOperationType["CreateSpace"] = "CREATE_SPACE";
    SitePermissionOperationType["ExternalCollaborator"] = "EXTERNAL_COLLABORATOR";
    SitePermissionOperationType["LimitedUseConfluence"] = "LIMITED_USE_CONFLUENCE";
    SitePermissionOperationType["ReadUserprofile"] = "READ_USERPROFILE";
    SitePermissionOperationType["UpdateUserstatus"] = "UPDATE_USERSTATUS";
    SitePermissionOperationType["UseConfluence"] = "USE_CONFLUENCE";
    SitePermissionOperationType["UsePersonalspace"] = "USE_PERSONALSPACE";
})($2f512219da033f72$export$7cafeba671f9185e || ($2f512219da033f72$export$7cafeba671f9185e = {}));
var $2f512219da033f72$export$8995abb8169b2cb8;
(function(SitePermissionType) {
    SitePermissionType["Anonymous"] = "ANONYMOUS";
    SitePermissionType["App"] = "APP";
    SitePermissionType["External"] = "EXTERNAL";
    SitePermissionType["Internal"] = "INTERNAL";
    SitePermissionType["Jsd"] = "JSD";
})($2f512219da033f72$export$8995abb8169b2cb8 || ($2f512219da033f72$export$8995abb8169b2cb8 = {}));
var $2f512219da033f72$export$3347a7c058a0368a;
(function(SitePermissionTypeFilter) {
    SitePermissionTypeFilter["All"] = "ALL";
    SitePermissionTypeFilter["Externalcollaborator"] = "EXTERNALCOLLABORATOR";
    SitePermissionTypeFilter["None"] = "NONE";
})($2f512219da033f72$export$3347a7c058a0368a || ($2f512219da033f72$export$3347a7c058a0368a = {}));
var $2f512219da033f72$export$c32ed3061693e3f1;
(function(SoftwareCardsDestinationEnum) {
    SoftwareCardsDestinationEnum["Backlog"] = "BACKLOG";
    SoftwareCardsDestinationEnum["ExistingSprint"] = "EXISTING_SPRINT";
    SoftwareCardsDestinationEnum["NewSprint"] = "NEW_SPRINT";
})($2f512219da033f72$export$c32ed3061693e3f1 || ($2f512219da033f72$export$c32ed3061693e3f1 = {}));
var $2f512219da033f72$export$79e2d9500680dd96;
(function(SortDirection) {
    /** Sort in ascending order */ SortDirection["Asc"] = "ASC";
    /** Sort in descending order */ SortDirection["Desc"] = "DESC";
})($2f512219da033f72$export$79e2d9500680dd96 || ($2f512219da033f72$export$79e2d9500680dd96 = {}));
var $2f512219da033f72$export$7ae723045d45777a;
(function(SortOrder) {
    SortOrder["Asc"] = "ASC";
    SortOrder["Desc"] = "DESC";
})($2f512219da033f72$export$7ae723045d45777a || ($2f512219da033f72$export$7ae723045d45777a = {}));
var $2f512219da033f72$export$367d99c17294fafd;
(function(SpaceAssignmentType) {
    SpaceAssignmentType["Assigned"] = "ASSIGNED";
    SpaceAssignmentType["Unassigned"] = "UNASSIGNED";
})($2f512219da033f72$export$367d99c17294fafd || ($2f512219da033f72$export$367d99c17294fafd = {}));
var $2f512219da033f72$export$d05015624caa2581;
(function(SpaceManagerFilterType) {
    SpaceManagerFilterType["Personal"] = "PERSONAL";
    SpaceManagerFilterType["TeamAndProject"] = "TEAM_AND_PROJECT";
})($2f512219da033f72$export$d05015624caa2581 || ($2f512219da033f72$export$d05015624caa2581 = {}));
var $2f512219da033f72$export$ba3a70c26a1448f3;
(function(SpaceManagerOrderColumn) {
    SpaceManagerOrderColumn["Key"] = "KEY";
    SpaceManagerOrderColumn["Title"] = "TITLE";
})($2f512219da033f72$export$ba3a70c26a1448f3 || ($2f512219da033f72$export$ba3a70c26a1448f3 = {}));
var $2f512219da033f72$export$fe86c1192e6c9ab8;
(function(SpaceManagerOrderDirection) {
    SpaceManagerOrderDirection["Asc"] = "ASC";
    SpaceManagerOrderDirection["Desc"] = "DESC";
})($2f512219da033f72$export$fe86c1192e6c9ab8 || ($2f512219da033f72$export$fe86c1192e6c9ab8 = {}));
var $2f512219da033f72$export$97d396a3ea186d0d;
(function(SpaceManagerOwnerType) {
    SpaceManagerOwnerType["Group"] = "GROUP";
    SpaceManagerOwnerType["User"] = "USER";
})($2f512219da033f72$export$97d396a3ea186d0d || ($2f512219da033f72$export$97d396a3ea186d0d = {}));
var $2f512219da033f72$export$a99f5dae9c149910;
(function(SpacePermissionType) {
    SpacePermissionType["AdministerSpace"] = "ADMINISTER_SPACE";
    SpacePermissionType["ArchivePage"] = "ARCHIVE_PAGE";
    SpacePermissionType["ArchiveSpace"] = "ARCHIVE_SPACE";
    SpacePermissionType["Comment"] = "COMMENT";
    SpacePermissionType["CreateAttachment"] = "CREATE_ATTACHMENT";
    SpacePermissionType["CreateBlog"] = "CREATE_BLOG";
    SpacePermissionType["CreateEditPage"] = "CREATE_EDIT_PAGE";
    SpacePermissionType["DeleteSpace"] = "DELETE_SPACE";
    SpacePermissionType["EditBlog"] = "EDIT_BLOG";
    SpacePermissionType["EditNativeContent"] = "EDIT_NATIVE_CONTENT";
    SpacePermissionType["ExportContent"] = "EXPORT_CONTENT";
    SpacePermissionType["ExportPage"] = "EXPORT_PAGE";
    SpacePermissionType["ExportSpace"] = "EXPORT_SPACE";
    SpacePermissionType["ManageGuestUsers"] = "MANAGE_GUEST_USERS";
    SpacePermissionType["ManageNonlicensedUsers"] = "MANAGE_NONLICENSED_USERS";
    SpacePermissionType["ManagePublicLinks"] = "MANAGE_PUBLIC_LINKS";
    SpacePermissionType["ManageUsers"] = "MANAGE_USERS";
    SpacePermissionType["RemoveAttachment"] = "REMOVE_ATTACHMENT";
    SpacePermissionType["RemoveBlog"] = "REMOVE_BLOG";
    SpacePermissionType["RemoveComment"] = "REMOVE_COMMENT";
    SpacePermissionType["RemoveMail"] = "REMOVE_MAIL";
    SpacePermissionType["RemoveOwnContent"] = "REMOVE_OWN_CONTENT";
    SpacePermissionType["RemovePage"] = "REMOVE_PAGE";
    SpacePermissionType["SetPagePermissions"] = "SET_PAGE_PERMISSIONS";
    SpacePermissionType["ViewSpace"] = "VIEW_SPACE";
})($2f512219da033f72$export$a99f5dae9c149910 || ($2f512219da033f72$export$a99f5dae9c149910 = {}));
var $2f512219da033f72$export$69bdd9d16ab8ed0f;
(function(SpaceRoleType) {
    SpaceRoleType["Custom"] = "CUSTOM";
    SpaceRoleType["System"] = "SYSTEM";
})($2f512219da033f72$export$69bdd9d16ab8ed0f || ($2f512219da033f72$export$69bdd9d16ab8ed0f = {}));
var $2f512219da033f72$export$3da4364c8f760e48;
(function(SpaceSidebarLinkType) {
    SpaceSidebarLinkType["ExternalLink"] = "EXTERNAL_LINK";
    SpaceSidebarLinkType["Forge"] = "FORGE";
    SpaceSidebarLinkType["PinnedAttachment"] = "PINNED_ATTACHMENT";
    SpaceSidebarLinkType["PinnedBlogPost"] = "PINNED_BLOG_POST";
    SpaceSidebarLinkType["PinnedPage"] = "PINNED_PAGE";
    SpaceSidebarLinkType["PinnedSpace"] = "PINNED_SPACE";
    SpaceSidebarLinkType["PinnedUserInfo"] = "PINNED_USER_INFO";
    SpaceSidebarLinkType["WebItem"] = "WEB_ITEM";
})($2f512219da033f72$export$3da4364c8f760e48 || ($2f512219da033f72$export$3da4364c8f760e48 = {}));
var $2f512219da033f72$export$220891debf9ebf41;
(function(SpaceViewsPersistenceOption) {
    SpaceViewsPersistenceOption["Popularity"] = "POPULARITY";
    SpaceViewsPersistenceOption["RecentlyModified"] = "RECENTLY_MODIFIED";
    SpaceViewsPersistenceOption["RecentlyViewed"] = "RECENTLY_VIEWED";
    SpaceViewsPersistenceOption["TitleAz"] = "TITLE_AZ";
    SpaceViewsPersistenceOption["Tree"] = "TREE";
})($2f512219da033f72$export$220891debf9ebf41 || ($2f512219da033f72$export$220891debf9ebf41 = {}));
var $2f512219da033f72$export$88ef8388f421e95e;
(function(SprintReportsEstimationStatisticType) {
    SprintReportsEstimationStatisticType["IssueCount"] = "ISSUE_COUNT";
    SprintReportsEstimationStatisticType["OriginalEstimate"] = "ORIGINAL_ESTIMATE";
    SprintReportsEstimationStatisticType["StoryPoints"] = "STORY_POINTS";
})($2f512219da033f72$export$88ef8388f421e95e || ($2f512219da033f72$export$88ef8388f421e95e = {}));
var $2f512219da033f72$export$f37cb7e02dc42251;
(function(SprintState) {
    SprintState["Active"] = "ACTIVE";
    SprintState["Closed"] = "CLOSED";
    SprintState["Future"] = "FUTURE";
})($2f512219da033f72$export$f37cb7e02dc42251 || ($2f512219da033f72$export$f37cb7e02dc42251 = {}));
var $2f512219da033f72$export$31329540a7e739d;
(function(StalePageStatus) {
    StalePageStatus["Archived"] = "ARCHIVED";
    StalePageStatus["Current"] = "CURRENT";
    StalePageStatus["Draft"] = "DRAFT";
})($2f512219da033f72$export$31329540a7e739d || ($2f512219da033f72$export$31329540a7e739d = {}));
var $2f512219da033f72$export$f88d3459570565da;
(function(StalePagesSortingType) {
    StalePagesSortingType["Asc"] = "ASC";
    StalePagesSortingType["Desc"] = "DESC";
})($2f512219da033f72$export$f88d3459570565da || ($2f512219da033f72$export$f88d3459570565da = {}));
var $2f512219da033f72$export$83c5444b50377c42;
(function(StringUserInputType) {
    StringUserInputType["Dropdown"] = "DROPDOWN";
    StringUserInputType["Paragraph"] = "PARAGRAPH";
    StringUserInputType["Text"] = "TEXT";
})($2f512219da033f72$export$83c5444b50377c42 || ($2f512219da033f72$export$83c5444b50377c42 = {}));
var $2f512219da033f72$export$5bf35143f8d5729a;
(function(SummaryType) {
    SummaryType["Blogpost"] = "BLOGPOST";
    SummaryType["Page"] = "PAGE";
})($2f512219da033f72$export$5bf35143f8d5729a || ($2f512219da033f72$export$5bf35143f8d5729a = {}));
var $2f512219da033f72$export$db58b0fec288f2d5;
(function(SupportRequestFieldDataType) {
    SupportRequestFieldDataType["Boolean"] = "BOOLEAN";
    SupportRequestFieldDataType["Date"] = "DATE";
    SupportRequestFieldDataType["Number"] = "NUMBER";
    SupportRequestFieldDataType["String"] = "STRING";
})($2f512219da033f72$export$db58b0fec288f2d5 || ($2f512219da033f72$export$db58b0fec288f2d5 = {}));
var $2f512219da033f72$export$5d395d1469cf6904;
(function(SupportRequestNamedContactOperation) {
    SupportRequestNamedContactOperation["Add"] = "ADD";
    SupportRequestNamedContactOperation["Remove"] = "REMOVE";
})($2f512219da033f72$export$5d395d1469cf6904 || ($2f512219da033f72$export$5d395d1469cf6904 = {}));
var $2f512219da033f72$export$15d04aa1faaca584;
(function(SupportRequestQueryOwnership) {
    SupportRequestQueryOwnership["Participant"] = "PARTICIPANT";
    SupportRequestQueryOwnership["Reporter"] = "REPORTER";
})($2f512219da033f72$export$15d04aa1faaca584 || ($2f512219da033f72$export$15d04aa1faaca584 = {}));
var $2f512219da033f72$export$cf9ba11854f7cb39;
(function(SupportRequestQueryStatusCategory) {
    SupportRequestQueryStatusCategory["Done"] = "DONE";
    SupportRequestQueryStatusCategory["Open"] = "OPEN";
})($2f512219da033f72$export$cf9ba11854f7cb39 || ($2f512219da033f72$export$cf9ba11854f7cb39 = {}));
var $2f512219da033f72$export$21de27a5998af787;
(function(SupportRequestStatusCategory) {
    SupportRequestStatusCategory["Done"] = "DONE";
    SupportRequestStatusCategory["InProgress"] = "IN_PROGRESS";
    SupportRequestStatusCategory["Open"] = "OPEN";
})($2f512219da033f72$export$21de27a5998af787 || ($2f512219da033f72$export$21de27a5998af787 = {}));
var $2f512219da033f72$export$4e3e0500b62d4705;
(function(SupportRequestUserType) {
    SupportRequestUserType["Customer"] = "CUSTOMER";
    SupportRequestUserType["Partner"] = "PARTNER";
})($2f512219da033f72$export$4e3e0500b62d4705 || ($2f512219da033f72$export$4e3e0500b62d4705 = {}));
var $2f512219da033f72$export$39b890c79449a0;
(function(SwimlaneStrategy) {
    SwimlaneStrategy["Assignee"] = "ASSIGNEE";
    SwimlaneStrategy["Issuechildren"] = "ISSUECHILDREN";
    SwimlaneStrategy["Issueparent"] = "ISSUEPARENT";
    SwimlaneStrategy["None"] = "NONE";
})($2f512219da033f72$export$39b890c79449a0 || ($2f512219da033f72$export$39b890c79449a0 = {}));
var $2f512219da033f72$export$7347d1c116cc1a56;
(function(SystemSpaceHomepageTemplate) {
    SystemSpaceHomepageTemplate["Eap"] = "EAP";
    SystemSpaceHomepageTemplate["Minimal"] = "MINIMAL";
    SystemSpaceHomepageTemplate["Visual"] = "VISUAL";
})($2f512219da033f72$export$7347d1c116cc1a56 || ($2f512219da033f72$export$7347d1c116cc1a56 = {}));
var $2f512219da033f72$export$61db76a97f26b7e1;
(function(TaskStatus) {
    TaskStatus["Checked"] = "CHECKED";
    TaskStatus["Unchecked"] = "UNCHECKED";
})($2f512219da033f72$export$61db76a97f26b7e1 || ($2f512219da033f72$export$61db76a97f26b7e1 = {}));
var $2f512219da033f72$export$af95a0e1ec1d37aa;
(function(TeamCalendarDayOfWeek) {
    TeamCalendarDayOfWeek["Friday"] = "FRIDAY";
    TeamCalendarDayOfWeek["Monday"] = "MONDAY";
    TeamCalendarDayOfWeek["Saturday"] = "SATURDAY";
    TeamCalendarDayOfWeek["Sunday"] = "SUNDAY";
    TeamCalendarDayOfWeek["Thursday"] = "THURSDAY";
    TeamCalendarDayOfWeek["Tuesday"] = "TUESDAY";
    TeamCalendarDayOfWeek["Wednesday"] = "WEDNESDAY";
})($2f512219da033f72$export$af95a0e1ec1d37aa || ($2f512219da033f72$export$af95a0e1ec1d37aa = {}));
var $2f512219da033f72$export$6a422ea3acdf9d9b;
(function(TeamMembershipRole) {
    /** A team member with administrative permissions */ TeamMembershipRole["Admin"] = "ADMIN";
    /** A regular team member */ TeamMembershipRole["Regular"] = "REGULAR";
})($2f512219da033f72$export$6a422ea3acdf9d9b || ($2f512219da033f72$export$6a422ea3acdf9d9b = {}));
var $2f512219da033f72$export$93b1c6cf9d16dce6;
(function(TeamMembershipSettings) {
    /** Membership is externally defined (not yet supported) */ TeamMembershipSettings["External"] = "EXTERNAL";
    /** Members may invite others to join the team */ TeamMembershipSettings["MemberInvite"] = "MEMBER_INVITE";
    /** Anyone may join */ TeamMembershipSettings["Open"] = "OPEN";
})($2f512219da033f72$export$93b1c6cf9d16dce6 || ($2f512219da033f72$export$93b1c6cf9d16dce6 = {}));
var $2f512219da033f72$export$f627e98535fb8637;
(function(TeamMembershipState) {
    /** A member who was previously a full member of the team, but has been removed or has left the team */ TeamMembershipState["Alumni"] = "ALUMNI";
    /** A full member of the team */ TeamMembershipState["FullMember"] = "FULL_MEMBER";
    /** A member who has requested to join the team and is pending approval */ TeamMembershipState["RequestingToJoin"] = "REQUESTING_TO_JOIN";
})($2f512219da033f72$export$f627e98535fb8637 || ($2f512219da033f72$export$f627e98535fb8637 = {}));
var $2f512219da033f72$export$76b040ede9e99a0e;
(function(TeamRole) {
    TeamRole["TeamsAdmin"] = "TEAMS_ADMIN";
    TeamRole["TeamsObserver"] = "TEAMS_OBSERVER";
    TeamRole["TeamsUser"] = "TEAMS_USER";
})($2f512219da033f72$export$76b040ede9e99a0e || ($2f512219da033f72$export$76b040ede9e99a0e = {}));
var $2f512219da033f72$export$3d32048696128045;
(function(TeamSearchField) {
    /** Search by team description */ TeamSearchField["Description"] = "DESCRIPTION";
    /** Search by team name */ TeamSearchField["Name"] = "NAME";
})($2f512219da033f72$export$3d32048696128045 || ($2f512219da033f72$export$3d32048696128045 = {}));
var $2f512219da033f72$export$c701f1c8ac34f3b8;
(function(TeamSortField) {
    /** Team name field */ TeamSortField["DisplayName"] = "DISPLAY_NAME";
    /** Identifier Team field */ TeamSortField["Id"] = "ID";
    /** Team state field */ TeamSortField["State"] = "STATE";
})($2f512219da033f72$export$c701f1c8ac34f3b8 || ($2f512219da033f72$export$c701f1c8ac34f3b8 = {}));
var $2f512219da033f72$export$cecdee868554f386;
(function(TeamSortOrder) {
    /** Ascendant order */ TeamSortOrder["Asc"] = "ASC";
    /** Descendent order */ TeamSortOrder["Desc"] = "DESC";
})($2f512219da033f72$export$cecdee868554f386 || ($2f512219da033f72$export$cecdee868554f386 = {}));
var $2f512219da033f72$export$c5c56131401e0716;
(function(TeamState) {
    /** The team is currently active */ TeamState["Active"] = "ACTIVE";
    /** The team has been disbanded and is currently inactive */ TeamState["Disbanded"] = "DISBANDED";
    /** All members of the team have been deleted */ TeamState["Purged"] = "PURGED";
})($2f512219da033f72$export$c5c56131401e0716 || ($2f512219da033f72$export$c5c56131401e0716 = {}));
var $2f512219da033f72$export$15fa8968cce33b6;
(function(TeamStateV2) {
    /** The team is currently active */ TeamStateV2["Active"] = "ACTIVE";
    /** All members of the team have been deleted */ TeamStateV2["Purged"] = "PURGED";
})($2f512219da033f72$export$15fa8968cce33b6 || ($2f512219da033f72$export$15fa8968cce33b6 = {}));
var $2f512219da033f72$export$be996b3d78d87257;
(function(ToolchainAssociateEntitiesErrorCode) {
    /** The entity identified by the given URL was rejected */ ToolchainAssociateEntitiesErrorCode["EntityRejected"] = "ENTITY_REJECTED";
    /** The given URL is invalid */ ToolchainAssociateEntitiesErrorCode["EntityUrlInvalid"] = "ENTITY_URL_INVALID";
    /** You do not have permission to fetch the Entity */ ToolchainAssociateEntitiesErrorCode["ProviderEntityFetchForbidden"] = "PROVIDER_ENTITY_FETCH_FORBIDDEN";
    /** The entity identified by the given URL does not exist */ ToolchainAssociateEntitiesErrorCode["ProviderEntityNotFound"] = "PROVIDER_ENTITY_NOT_FOUND";
    /** An unexpected provider error occurred */ ToolchainAssociateEntitiesErrorCode["ProviderError"] = "PROVIDER_ERROR";
    /** The given URL is not supported by the provider */ ToolchainAssociateEntitiesErrorCode["ProviderInputInvalid"] = "PROVIDER_INPUT_INVALID";
})($2f512219da033f72$export$be996b3d78d87257 || ($2f512219da033f72$export$be996b3d78d87257 = {}));
var $2f512219da033f72$export$96ad634185a48695;
(function(ToolchainCheckAuthErrorCode) {
    /** An unexpected provider error occurred or authentication type is not implemented */ ToolchainCheckAuthErrorCode["ProviderError"] = "PROVIDER_ERROR";
})($2f512219da033f72$export$96ad634185a48695 || ($2f512219da033f72$export$96ad634185a48695 = {}));
var $2f512219da033f72$export$a4a2abf60b9ee414;
(function(ToolchainContainerConnectionErrorCode) {
    ToolchainContainerConnectionErrorCode["ProviderActionForbidden"] = "PROVIDER_ACTION_FORBIDDEN";
})($2f512219da033f72$export$a4a2abf60b9ee414 || ($2f512219da033f72$export$a4a2abf60b9ee414 = {}));
var $2f512219da033f72$export$a675cf96020918d;
(function(ToolchainCreateContainerErrorCode) {
    /** The container already exists */ ToolchainCreateContainerErrorCode["ProviderContainerAlreadyExists"] = "PROVIDER_CONTAINER_ALREADY_EXISTS";
    /** You do not have permission to create the container */ ToolchainCreateContainerErrorCode["ProviderContainerCreateForbidden"] = "PROVIDER_CONTAINER_CREATE_FORBIDDEN";
    /** An unexpected provider error occurred */ ToolchainCreateContainerErrorCode["ProviderError"] = "PROVIDER_ERROR";
    /** The input provided is invalid */ ToolchainCreateContainerErrorCode["ProviderInputInvalid"] = "PROVIDER_INPUT_INVALID";
    /** The given workspace doesn't exist */ ToolchainCreateContainerErrorCode["ProviderWorkspaceNotFound"] = "PROVIDER_WORKSPACE_NOT_FOUND";
})($2f512219da033f72$export$a675cf96020918d || ($2f512219da033f72$export$a675cf96020918d = {}));
var $2f512219da033f72$export$911f961eae9c7bb3;
(function(ToolchainDisassociateEntitiesErrorCode) {
    /** The association is unknown */ ToolchainDisassociateEntitiesErrorCode["UnknownAssociation"] = "UNKNOWN_ASSOCIATION";
})($2f512219da033f72$export$911f961eae9c7bb3 || ($2f512219da033f72$export$911f961eae9c7bb3 = {}));
var $2f512219da033f72$export$a76864a49f160fd1;
(function(ToolchainProviderType) {
    ToolchainProviderType["Build"] = "BUILD";
    ToolchainProviderType["Deployment"] = "DEPLOYMENT";
    ToolchainProviderType["Design"] = "DESIGN";
    ToolchainProviderType["DevopsComponents"] = "DEVOPS_COMPONENTS";
    ToolchainProviderType["DevInfo"] = "DEV_INFO";
    ToolchainProviderType["Documentation"] = "DOCUMENTATION";
    ToolchainProviderType["FeatureFlag"] = "FEATURE_FLAG";
    ToolchainProviderType["Operations"] = "OPERATIONS";
    ToolchainProviderType["RemoteLinks"] = "REMOTE_LINKS";
    ToolchainProviderType["Security"] = "SECURITY";
})($2f512219da033f72$export$a76864a49f160fd1 || ($2f512219da033f72$export$a76864a49f160fd1 = {}));
var $2f512219da033f72$export$74b7a9159262d2e;
(function(ToolchainWorkspaceConnectionErrorCode) {
    ToolchainWorkspaceConnectionErrorCode["ProviderActionError"] = "PROVIDER_ACTION_ERROR";
    ToolchainWorkspaceConnectionErrorCode["ProviderNotSupported"] = "PROVIDER_NOT_SUPPORTED";
})($2f512219da033f72$export$74b7a9159262d2e || ($2f512219da033f72$export$74b7a9159262d2e = {}));
var $2f512219da033f72$export$811997fc1181bd2c;
(function(TownsquareAccessControlCapability) {
    TownsquareAccessControlCapability["Access"] = "ACCESS";
    TownsquareAccessControlCapability["Administer"] = "ADMINISTER";
    TownsquareAccessControlCapability["Create"] = "CREATE";
})($2f512219da033f72$export$811997fc1181bd2c || ($2f512219da033f72$export$811997fc1181bd2c = {}));
var $2f512219da033f72$export$bbee594fef8c3882;
(function(TownsquareCapabilityContainer) {
    TownsquareCapabilityContainer["GoalsApp"] = "GOALS_APP";
    TownsquareCapabilityContainer["ProjectsApp"] = "PROJECTS_APP";
})($2f512219da033f72$export$bbee594fef8c3882 || ($2f512219da033f72$export$bbee594fef8c3882 = {}));
var $2f512219da033f72$export$efa69ae2d35f8c5f;
(function(TownsquareGoalIconAppearance) {
    TownsquareGoalIconAppearance["AtRisk"] = "AT_RISK";
    TownsquareGoalIconAppearance["Default"] = "DEFAULT";
    TownsquareGoalIconAppearance["OffTrack"] = "OFF_TRACK";
    TownsquareGoalIconAppearance["OnTrack"] = "ON_TRACK";
})($2f512219da033f72$export$efa69ae2d35f8c5f || ($2f512219da033f72$export$efa69ae2d35f8c5f = {}));
var $2f512219da033f72$export$e60f165a9252fbc4;
(function(TownsquareGoalIconKey) {
    TownsquareGoalIconKey["Goal"] = "GOAL";
    TownsquareGoalIconKey["KeyResult"] = "KEY_RESULT";
    TownsquareGoalIconKey["Objective"] = "OBJECTIVE";
})($2f512219da033f72$export$e60f165a9252fbc4 || ($2f512219da033f72$export$e60f165a9252fbc4 = {}));
var $2f512219da033f72$export$e2d891f9dd055fc4;
(function(TownsquareGoalSortEnum) {
    TownsquareGoalSortEnum["CreationDateAsc"] = "CREATION_DATE_ASC";
    TownsquareGoalSortEnum["CreationDateDesc"] = "CREATION_DATE_DESC";
    TownsquareGoalSortEnum["HierarchyAsc"] = "HIERARCHY_ASC";
    TownsquareGoalSortEnum["HierarchyDesc"] = "HIERARCHY_DESC";
    TownsquareGoalSortEnum["HierarchyLevelAsc"] = "HIERARCHY_LEVEL_ASC";
    TownsquareGoalSortEnum["HierarchyLevelDesc"] = "HIERARCHY_LEVEL_DESC";
    TownsquareGoalSortEnum["IdAsc"] = "ID_ASC";
    TownsquareGoalSortEnum["IdDesc"] = "ID_DESC";
    TownsquareGoalSortEnum["LatestUpdateDateAsc"] = "LATEST_UPDATE_DATE_ASC";
    TownsquareGoalSortEnum["LatestUpdateDateDesc"] = "LATEST_UPDATE_DATE_DESC";
    TownsquareGoalSortEnum["NameAsc"] = "NAME_ASC";
    TownsquareGoalSortEnum["NameDesc"] = "NAME_DESC";
    TownsquareGoalSortEnum["ProjectCountAsc"] = "PROJECT_COUNT_ASC";
    TownsquareGoalSortEnum["ProjectCountDesc"] = "PROJECT_COUNT_DESC";
    TownsquareGoalSortEnum["ScoreAsc"] = "SCORE_ASC";
    TownsquareGoalSortEnum["ScoreDesc"] = "SCORE_DESC";
    TownsquareGoalSortEnum["TargetDateAsc"] = "TARGET_DATE_ASC";
    TownsquareGoalSortEnum["TargetDateDesc"] = "TARGET_DATE_DESC";
    TownsquareGoalSortEnum["WatchingAsc"] = "WATCHING_ASC";
    TownsquareGoalSortEnum["WatchingDesc"] = "WATCHING_DESC";
})($2f512219da033f72$export$e2d891f9dd055fc4 || ($2f512219da033f72$export$e2d891f9dd055fc4 = {}));
var $2f512219da033f72$export$114cd33b2bd21562;
(function(TownsquareGoalStateValue) {
    TownsquareGoalStateValue["Archived"] = "archived";
    TownsquareGoalStateValue["AtRisk"] = "at_risk";
    TownsquareGoalStateValue["Cancelled"] = "cancelled";
    TownsquareGoalStateValue["Done"] = "done";
    TownsquareGoalStateValue["OffTrack"] = "off_track";
    TownsquareGoalStateValue["OnTrack"] = "on_track";
    TownsquareGoalStateValue["Paused"] = "paused";
    TownsquareGoalStateValue["Pending"] = "pending";
})($2f512219da033f72$export$114cd33b2bd21562 || ($2f512219da033f72$export$114cd33b2bd21562 = {}));
var $2f512219da033f72$export$d857eec43cac6124;
(function(TownsquareGoalTypeState) {
    TownsquareGoalTypeState["Disabled"] = "DISABLED";
    TownsquareGoalTypeState["Enabled"] = "ENABLED";
})($2f512219da033f72$export$d857eec43cac6124 || ($2f512219da033f72$export$d857eec43cac6124 = {}));
var $2f512219da033f72$export$5e899d10362593f0;
(function(TownsquareProjectPhase) {
    TownsquareProjectPhase["Done"] = "done";
    TownsquareProjectPhase["InProgress"] = "in_progress";
    TownsquareProjectPhase["Paused"] = "paused";
    TownsquareProjectPhase["Pending"] = "pending";
})($2f512219da033f72$export$5e899d10362593f0 || ($2f512219da033f72$export$5e899d10362593f0 = {}));
var $2f512219da033f72$export$8aa4fdb7ade2bdbb;
(function(TownsquareProjectSortEnum) {
    TownsquareProjectSortEnum["CreationDateAsc"] = "CREATION_DATE_ASC";
    TownsquareProjectSortEnum["CreationDateDesc"] = "CREATION_DATE_DESC";
    TownsquareProjectSortEnum["IdAsc"] = "ID_ASC";
    TownsquareProjectSortEnum["IdDesc"] = "ID_DESC";
    TownsquareProjectSortEnum["LatestUpdateDateAsc"] = "LATEST_UPDATE_DATE_ASC";
    TownsquareProjectSortEnum["LatestUpdateDateDesc"] = "LATEST_UPDATE_DATE_DESC";
    TownsquareProjectSortEnum["NameAsc"] = "NAME_ASC";
    TownsquareProjectSortEnum["NameDesc"] = "NAME_DESC";
    TownsquareProjectSortEnum["StartDateAsc"] = "START_DATE_ASC";
    TownsquareProjectSortEnum["StartDateDesc"] = "START_DATE_DESC";
    TownsquareProjectSortEnum["StatusAsc"] = "STATUS_ASC";
    TownsquareProjectSortEnum["StatusDesc"] = "STATUS_DESC";
    TownsquareProjectSortEnum["TargetDateAsc"] = "TARGET_DATE_ASC";
    TownsquareProjectSortEnum["TargetDateDesc"] = "TARGET_DATE_DESC";
    TownsquareProjectSortEnum["WatchingAsc"] = "WATCHING_ASC";
    TownsquareProjectSortEnum["WatchingDesc"] = "WATCHING_DESC";
})($2f512219da033f72$export$8aa4fdb7ade2bdbb || ($2f512219da033f72$export$8aa4fdb7ade2bdbb = {}));
var $2f512219da033f72$export$ee344fc0997809d6;
(function(TownsquareProjectStateValue) {
    TownsquareProjectStateValue["Archived"] = "archived";
    TownsquareProjectStateValue["AtRisk"] = "at_risk";
    TownsquareProjectStateValue["Cancelled"] = "cancelled";
    TownsquareProjectStateValue["Done"] = "done";
    TownsquareProjectStateValue["OffTrack"] = "off_track";
    TownsquareProjectStateValue["OnTrack"] = "on_track";
    TownsquareProjectStateValue["Paused"] = "paused";
    TownsquareProjectStateValue["Pending"] = "pending";
})($2f512219da033f72$export$ee344fc0997809d6 || ($2f512219da033f72$export$ee344fc0997809d6 = {}));
var $2f512219da033f72$export$ee9a227c8c9479e7;
(function(TownsquareRiskSortEnum) {
    TownsquareRiskSortEnum["CreationDateAsc"] = "CREATION_DATE_ASC";
    TownsquareRiskSortEnum["CreationDateDesc"] = "CREATION_DATE_DESC";
    TownsquareRiskSortEnum["IdAsc"] = "ID_ASC";
    TownsquareRiskSortEnum["IdDesc"] = "ID_DESC";
    TownsquareRiskSortEnum["SummaryAsc"] = "SUMMARY_ASC";
    TownsquareRiskSortEnum["SummaryDesc"] = "SUMMARY_DESC";
})($2f512219da033f72$export$ee9a227c8c9479e7 || ($2f512219da033f72$export$ee9a227c8c9479e7 = {}));
var $2f512219da033f72$export$84f5d3c1f2497f3c;
(function(TownsquareTargetDateType) {
    TownsquareTargetDateType["Day"] = "DAY";
    TownsquareTargetDateType["Month"] = "MONTH";
    TownsquareTargetDateType["Quarter"] = "QUARTER";
})($2f512219da033f72$export$84f5d3c1f2497f3c || ($2f512219da033f72$export$84f5d3c1f2497f3c = {}));
var $2f512219da033f72$export$3a6dd57a186dd7a5;
(function(TownsquareUnshardedAccessControlCapability) {
    TownsquareUnshardedAccessControlCapability["Access"] = "ACCESS";
    TownsquareUnshardedAccessControlCapability["Administer"] = "ADMINISTER";
    TownsquareUnshardedAccessControlCapability["Create"] = "CREATE";
})($2f512219da033f72$export$3a6dd57a186dd7a5 || ($2f512219da033f72$export$3a6dd57a186dd7a5 = {}));
var $2f512219da033f72$export$ab1cd2c28595d1dd;
(function(TownsquareUnshardedCapabilityContainer) {
    TownsquareUnshardedCapabilityContainer["GoalsApp"] = "GOALS_APP";
    TownsquareUnshardedCapabilityContainer["ProjectsApp"] = "PROJECTS_APP";
})($2f512219da033f72$export$ab1cd2c28595d1dd || ($2f512219da033f72$export$ab1cd2c28595d1dd = {}));
var $2f512219da033f72$export$1b2597546d404c3b;
(function(TownsquareUpdateType) {
    TownsquareUpdateType["System"] = "SYSTEM";
    TownsquareUpdateType["User"] = "USER";
})($2f512219da033f72$export$1b2597546d404c3b || ($2f512219da033f72$export$1b2597546d404c3b = {}));
var $2f512219da033f72$export$532fae07bf79d169;
(function(TrelloBoardMembershipType) {
    /**
   * Privileged membership type. Can edit board settings,
   * and add/remove board members.
   */ TrelloBoardMembershipType["Admin"] = "ADMIN";
    /** Standard membership type.  Can view as well as edit board content. */ TrelloBoardMembershipType["Normal"] = "NORMAL";
    /**
   * This membership type is either view-only, or view + comment and react
   * depending on board settings.
   */ TrelloBoardMembershipType["Observer"] = "OBSERVER";
})($2f512219da033f72$export$532fae07bf79d169 || ($2f512219da033f72$export$532fae07bf79d169 = {}));
var $2f512219da033f72$export$4f70e3932d3e34fb;
(function(TrelloCardActionType) {
    TrelloCardActionType["AddAttachment"] = "ADD_ATTACHMENT";
    TrelloCardActionType["AddChecklist"] = "ADD_CHECKLIST";
    TrelloCardActionType["AddMember"] = "ADD_MEMBER";
    TrelloCardActionType["Comment"] = "COMMENT";
    TrelloCardActionType["MoveCard"] = "MOVE_CARD";
    TrelloCardActionType["RemoveMember"] = "REMOVE_MEMBER";
})($2f512219da033f72$export$4f70e3932d3e34fb || ($2f512219da033f72$export$4f70e3932d3e34fb = {}));
var $2f512219da033f72$export$e19d69c6b75aa26f;
(function(TrelloCardCoverBrightness) {
    TrelloCardCoverBrightness["Dark"] = "DARK";
    TrelloCardCoverBrightness["Light"] = "LIGHT";
})($2f512219da033f72$export$e19d69c6b75aa26f || ($2f512219da033f72$export$e19d69c6b75aa26f = {}));
var $2f512219da033f72$export$b1a4da8c2172956c;
(function(TrelloCardCoverColor) {
    TrelloCardCoverColor["Black"] = "BLACK";
    TrelloCardCoverColor["Blue"] = "BLUE";
    TrelloCardCoverColor["Green"] = "GREEN";
    TrelloCardCoverColor["Lime"] = "LIME";
    TrelloCardCoverColor["Orange"] = "ORANGE";
    TrelloCardCoverColor["Pink"] = "PINK";
    TrelloCardCoverColor["Purple"] = "PURPLE";
    TrelloCardCoverColor["Red"] = "RED";
    TrelloCardCoverColor["Sky"] = "SKY";
    TrelloCardCoverColor["Yellow"] = "YELLOW";
})($2f512219da033f72$export$b1a4da8c2172956c || ($2f512219da033f72$export$b1a4da8c2172956c = {}));
var $2f512219da033f72$export$17aa2e5fc86f2e30;
(function(TrelloCardCoverSize) {
    TrelloCardCoverSize["Full"] = "FULL";
    TrelloCardCoverSize["Normal"] = "NORMAL";
})($2f512219da033f72$export$17aa2e5fc86f2e30 || ($2f512219da033f72$export$17aa2e5fc86f2e30 = {}));
var $2f512219da033f72$export$a209f50d5cb5f744;
(function(TrelloCardExternalSource) {
    TrelloCardExternalSource["Email"] = "EMAIL";
    TrelloCardExternalSource["Msteams"] = "MSTEAMS";
    TrelloCardExternalSource["Siri"] = "SIRI";
    TrelloCardExternalSource["Slack"] = "SLACK";
})($2f512219da033f72$export$a209f50d5cb5f744 || ($2f512219da033f72$export$a209f50d5cb5f744 = {}));
var $2f512219da033f72$export$3246e4d5604c366a;
(function(TrelloCardRole) {
    TrelloCardRole["Board"] = "BOARD";
    TrelloCardRole["Link"] = "LINK";
    TrelloCardRole["Mirror"] = "MIRROR";
    TrelloCardRole["Separator"] = "SEPARATOR";
})($2f512219da033f72$export$3246e4d5604c366a || ($2f512219da033f72$export$3246e4d5604c366a = {}));
var $2f512219da033f72$export$5ab76e32d3549701;
(function(TrelloCheckItemState) {
    TrelloCheckItemState["Complete"] = "COMPLETE";
    TrelloCheckItemState["Incomplete"] = "INCOMPLETE";
})($2f512219da033f72$export$5ab76e32d3549701 || ($2f512219da033f72$export$5ab76e32d3549701 = {}));
var $2f512219da033f72$export$11203b215eaa6771;
(function(TrelloDataSourceHandler) {
    TrelloDataSourceHandler["LinkingPlatform"] = "LINKING_PLATFORM";
})($2f512219da033f72$export$11203b215eaa6771 || ($2f512219da033f72$export$11203b215eaa6771 = {}));
var $2f512219da033f72$export$67a5bcd9d9130fae;
(function(TrelloListType) {
    TrelloListType["Datasource"] = "DATASOURCE";
})($2f512219da033f72$export$67a5bcd9d9130fae || ($2f512219da033f72$export$67a5bcd9d9130fae = {}));
var $2f512219da033f72$export$706bd1827c19ca1c;
(function(TrelloPlannerCalendarColor) {
    TrelloPlannerCalendarColor["BlueSubtler"] = "BLUE_SUBTLER";
    TrelloPlannerCalendarColor["BlueSubtlest"] = "BLUE_SUBTLEST";
    TrelloPlannerCalendarColor["GraySubtler"] = "GRAY_SUBTLER";
    TrelloPlannerCalendarColor["GreenSubtler"] = "GREEN_SUBTLER";
    TrelloPlannerCalendarColor["GreenSubtlest"] = "GREEN_SUBTLEST";
    TrelloPlannerCalendarColor["LimeSubtler"] = "LIME_SUBTLER";
    TrelloPlannerCalendarColor["LimeSubtlest"] = "LIME_SUBTLEST";
    TrelloPlannerCalendarColor["MagentaSubtler"] = "MAGENTA_SUBTLER";
    TrelloPlannerCalendarColor["MagentaSubtlest"] = "MAGENTA_SUBTLEST";
    TrelloPlannerCalendarColor["OrangeSubtler"] = "ORANGE_SUBTLER";
    TrelloPlannerCalendarColor["OrangeSubtlest"] = "ORANGE_SUBTLEST";
    TrelloPlannerCalendarColor["PurpleSubtlest"] = "PURPLE_SUBTLEST";
    TrelloPlannerCalendarColor["RedSubtler"] = "RED_SUBTLER";
    TrelloPlannerCalendarColor["RedSubtlest"] = "RED_SUBTLEST";
    TrelloPlannerCalendarColor["YellowBolder"] = "YELLOW_BOLDER";
    TrelloPlannerCalendarColor["YellowSubtler"] = "YELLOW_SUBTLER";
    TrelloPlannerCalendarColor["YellowSubtlest"] = "YELLOW_SUBTLEST";
})($2f512219da033f72$export$706bd1827c19ca1c || ($2f512219da033f72$export$706bd1827c19ca1c = {}));
var $2f512219da033f72$export$c3504f8e65382e15;
(function(TrelloPlannerCalendarEventStatus) {
    TrelloPlannerCalendarEventStatus["Accepted"] = "ACCEPTED";
    TrelloPlannerCalendarEventStatus["Cancelled"] = "CANCELLED";
    TrelloPlannerCalendarEventStatus["Declined"] = "DECLINED";
    TrelloPlannerCalendarEventStatus["NeedsAction"] = "NEEDS_ACTION";
    TrelloPlannerCalendarEventStatus["Tentative"] = "TENTATIVE";
})($2f512219da033f72$export$c3504f8e65382e15 || ($2f512219da033f72$export$c3504f8e65382e15 = {}));
var $2f512219da033f72$export$74219c97285d9f20;
(function(TrelloPlannerCalendarEventType) {
    TrelloPlannerCalendarEventType["Default"] = "DEFAULT";
    TrelloPlannerCalendarEventType["OutOfOffice"] = "OUT_OF_OFFICE";
    TrelloPlannerCalendarEventType["PlannerEvent"] = "PLANNER_EVENT";
})($2f512219da033f72$export$74219c97285d9f20 || ($2f512219da033f72$export$74219c97285d9f20 = {}));
var $2f512219da033f72$export$2cd4a1711c245f6b;
(function(TrelloPlannerCalendarEventVisibility) {
    TrelloPlannerCalendarEventVisibility["Default"] = "DEFAULT";
    TrelloPlannerCalendarEventVisibility["Private"] = "PRIVATE";
    TrelloPlannerCalendarEventVisibility["Public"] = "PUBLIC";
})($2f512219da033f72$export$2cd4a1711c245f6b || ($2f512219da033f72$export$2cd4a1711c245f6b = {}));
var $2f512219da033f72$export$d6da0c6d5fb213f0;
(function(TrelloPowerUpDataAccess) {
    TrelloPowerUpDataAccess["Private"] = "PRIVATE";
    TrelloPowerUpDataAccess["Shared"] = "SHARED";
})($2f512219da033f72$export$d6da0c6d5fb213f0 || ($2f512219da033f72$export$d6da0c6d5fb213f0 = {}));
var $2f512219da033f72$export$bc6cfd4fe0c319ad;
(function(TrelloPowerUpDataScope) {
    TrelloPowerUpDataScope["Board"] = "BOARD";
    TrelloPowerUpDataScope["Card"] = "CARD";
    TrelloPowerUpDataScope["Member"] = "MEMBER";
    TrelloPowerUpDataScope["Organization"] = "ORGANIZATION";
})($2f512219da033f72$export$bc6cfd4fe0c319ad || ($2f512219da033f72$export$bc6cfd4fe0c319ad = {}));
var $2f512219da033f72$export$1ee95821123803e6;
(function(TrelloSupportedPlannerProviders) {
    TrelloSupportedPlannerProviders["Google"] = "GOOGLE";
})($2f512219da033f72$export$1ee95821123803e6 || ($2f512219da033f72$export$1ee95821123803e6 = {}));
var $2f512219da033f72$export$d563dba18e915a44;
(function(TrelloWorkspaceMembershipType) {
    /**
   * Privileged membership type. Can edit workspace settings,
   * add and remove members
   */ TrelloWorkspaceMembershipType["Admin"] = "ADMIN";
    /** Standard membership type */ TrelloWorkspaceMembershipType["Normal"] = "NORMAL";
})($2f512219da033f72$export$d563dba18e915a44 || ($2f512219da033f72$export$d563dba18e915a44 = {}));
var $2f512219da033f72$export$c8c804aa42adf4e6;
(function(TrelloWorkspaceTier) {
    /** Includes all non-free workspaces (i.e. Standard, Premium, Enterprise) */ TrelloWorkspaceTier["Paid"] = "PAID";
})($2f512219da033f72$export$c8c804aa42adf4e6 || ($2f512219da033f72$export$c8c804aa42adf4e6 = {}));
var $2f512219da033f72$export$604f18feffef43e2;
(function(UnifiedLearningCertificationSortField) {
    UnifiedLearningCertificationSortField["ActiveDate"] = "ACTIVE_DATE";
    UnifiedLearningCertificationSortField["ExpireDate"] = "EXPIRE_DATE";
    UnifiedLearningCertificationSortField["Id"] = "ID";
    UnifiedLearningCertificationSortField["ImageUrl"] = "IMAGE_URL";
    UnifiedLearningCertificationSortField["Name"] = "NAME";
    UnifiedLearningCertificationSortField["NameAbbr"] = "NAME_ABBR";
    UnifiedLearningCertificationSortField["PublicUrl"] = "PUBLIC_URL";
    UnifiedLearningCertificationSortField["Status"] = "STATUS";
    UnifiedLearningCertificationSortField["Type"] = "TYPE";
})($2f512219da033f72$export$604f18feffef43e2 || ($2f512219da033f72$export$604f18feffef43e2 = {}));
var $2f512219da033f72$export$8187f16b9dfb840;
(function(UnifiedLearningCertificationStatus) {
    UnifiedLearningCertificationStatus["Active"] = "ACTIVE";
    UnifiedLearningCertificationStatus["Expired"] = "EXPIRED";
})($2f512219da033f72$export$8187f16b9dfb840 || ($2f512219da033f72$export$8187f16b9dfb840 = {}));
var $2f512219da033f72$export$fbcd2ce7d8443c1d;
(function(UnifiedLearningCertificationType) {
    UnifiedLearningCertificationType["Badge"] = "BADGE";
    UnifiedLearningCertificationType["Certification"] = "CERTIFICATION";
    UnifiedLearningCertificationType["Standing"] = "STANDING";
})($2f512219da033f72$export$fbcd2ce7d8443c1d || ($2f512219da033f72$export$fbcd2ce7d8443c1d = {}));
var $2f512219da033f72$export$618cd13030cd7650;
(function(UnifiedSortDirection) {
    UnifiedSortDirection["Asc"] = "ASC";
    UnifiedSortDirection["Desc"] = "DESC";
})($2f512219da033f72$export$618cd13030cd7650 || ($2f512219da033f72$export$618cd13030cd7650 = {}));
var $2f512219da033f72$export$8808d536a6b2ef88;
(function(UserInstallationRuleValue) {
    UserInstallationRuleValue["Allow"] = "allow";
    UserInstallationRuleValue["Deny"] = "deny";
})($2f512219da033f72$export$8808d536a6b2ef88 || ($2f512219da033f72$export$8808d536a6b2ef88 = {}));
var $2f512219da033f72$export$da7c68101b740a53;
(function(VendorType) {
    VendorType["Internal"] = "INTERNAL";
    VendorType["ThirdParty"] = "THIRD_PARTY";
})($2f512219da033f72$export$da7c68101b740a53 || ($2f512219da033f72$export$da7c68101b740a53 = {}));
var $2f512219da033f72$export$4789b44fbe86836;
(function(VirtualAgentConversationActionType) {
    VirtualAgentConversationActionType["AiAnswered"] = "AI_ANSWERED";
    VirtualAgentConversationActionType["Matched"] = "MATCHED";
    VirtualAgentConversationActionType["Unhandled"] = "UNHANDLED";
})($2f512219da033f72$export$4789b44fbe86836 || ($2f512219da033f72$export$4789b44fbe86836 = {}));
var $2f512219da033f72$export$b35e6de70199ab95;
(function(VirtualAgentConversationChannel) {
    VirtualAgentConversationChannel["HelpCenter"] = "HELP_CENTER";
    VirtualAgentConversationChannel["JsmPortal"] = "JSM_PORTAL";
    VirtualAgentConversationChannel["JsmWidget"] = "JSM_WIDGET";
    VirtualAgentConversationChannel["MsTeams"] = "MS_TEAMS";
    VirtualAgentConversationChannel["Slack"] = "SLACK";
})($2f512219da033f72$export$b35e6de70199ab95 || ($2f512219da033f72$export$b35e6de70199ab95 = {}));
var $2f512219da033f72$export$e372c28ac4fddc25;
(function(VirtualAgentConversationCsatOptionType) {
    VirtualAgentConversationCsatOptionType["CsatOption_1"] = "CSAT_OPTION_1";
    VirtualAgentConversationCsatOptionType["CsatOption_2"] = "CSAT_OPTION_2";
    VirtualAgentConversationCsatOptionType["CsatOption_3"] = "CSAT_OPTION_3";
    VirtualAgentConversationCsatOptionType["CsatOption_4"] = "CSAT_OPTION_4";
    VirtualAgentConversationCsatOptionType["CsatOption_5"] = "CSAT_OPTION_5";
})($2f512219da033f72$export$e372c28ac4fddc25 || ($2f512219da033f72$export$e372c28ac4fddc25 = {}));
var $2f512219da033f72$export$620fe609179029be;
(function(VirtualAgentConversationState) {
    VirtualAgentConversationState["Closed"] = "CLOSED";
    VirtualAgentConversationState["Escalated"] = "ESCALATED";
    VirtualAgentConversationState["Open"] = "OPEN";
    VirtualAgentConversationState["Resolved"] = "RESOLVED";
})($2f512219da033f72$export$620fe609179029be || ($2f512219da033f72$export$620fe609179029be = {}));
var $2f512219da033f72$export$6b1507802d006c10;
(function(VirtualAgentIntentStatus) {
    /** Surfaced to help-seekers in conversation channels, as well as visible to virtual agent admins in test mode */ VirtualAgentIntentStatus["Live"] = "LIVE";
    /** Not visible to help-seekers, but visible to virtual agent admins using test mode */ VirtualAgentIntentStatus["TestOnly"] = "TEST_ONLY";
})($2f512219da033f72$export$6b1507802d006c10 || ($2f512219da033f72$export$6b1507802d006c10 = {}));
var $2f512219da033f72$export$68d524b762f21460;
(function(VirtualAgentIntentTemplateType) {
    VirtualAgentIntentTemplateType["Discovered"] = "DISCOVERED";
    VirtualAgentIntentTemplateType["Shared"] = "SHARED";
    VirtualAgentIntentTemplateType["Standard"] = "STANDARD";
})($2f512219da033f72$export$68d524b762f21460 || ($2f512219da033f72$export$68d524b762f21460 = {}));
var $2f512219da033f72$export$f794720beec52585;
(function(WorkSuggestionsAction) {
    WorkSuggestionsAction["Remove"] = "REMOVE";
    WorkSuggestionsAction["Snooze"] = "SNOOZE";
})($2f512219da033f72$export$f794720beec52585 || ($2f512219da033f72$export$f794720beec52585 = {}));
var $2f512219da033f72$export$fcfd01bc876454f4;
(function(WorkSuggestionsApprovalStatus) {
    WorkSuggestionsApprovalStatus["Approved"] = "APPROVED";
    WorkSuggestionsApprovalStatus["Needswork"] = "NEEDSWORK";
    WorkSuggestionsApprovalStatus["Unapproved"] = "UNAPPROVED";
    WorkSuggestionsApprovalStatus["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$fcfd01bc876454f4 || ($2f512219da033f72$export$fcfd01bc876454f4 = {}));
var $2f512219da033f72$export$4dffae97a15618f;
(function(WorkSuggestionsAutoDevJobState) {
    WorkSuggestionsAutoDevJobState["Cancelled"] = "CANCELLED";
    WorkSuggestionsAutoDevJobState["CodeGenerating"] = "CODE_GENERATING";
    WorkSuggestionsAutoDevJobState["CodeGenerationFail"] = "CODE_GENERATION_FAIL";
    WorkSuggestionsAutoDevJobState["CodeGenerationReady"] = "CODE_GENERATION_READY";
    WorkSuggestionsAutoDevJobState["CodeGenerationSuccess"] = "CODE_GENERATION_SUCCESS";
    WorkSuggestionsAutoDevJobState["Created"] = "CREATED";
    WorkSuggestionsAutoDevJobState["PlanGenerating"] = "PLAN_GENERATING";
    WorkSuggestionsAutoDevJobState["PlanGenerationFail"] = "PLAN_GENERATION_FAIL";
    WorkSuggestionsAutoDevJobState["PlanGenerationSuccess"] = "PLAN_GENERATION_SUCCESS";
    WorkSuggestionsAutoDevJobState["PullrequestCreating"] = "PULLREQUEST_CREATING";
    WorkSuggestionsAutoDevJobState["PullrequestCreationFail"] = "PULLREQUEST_CREATION_FAIL";
    WorkSuggestionsAutoDevJobState["PullrequestCreationSuccess"] = "PULLREQUEST_CREATION_SUCCESS";
    WorkSuggestionsAutoDevJobState["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$4dffae97a15618f || ($2f512219da033f72$export$4dffae97a15618f = {}));
var $2f512219da033f72$export$4f315a2279163c82;
(function(WorkSuggestionsEnvironmentType) {
    WorkSuggestionsEnvironmentType["Development"] = "DEVELOPMENT";
    WorkSuggestionsEnvironmentType["Production"] = "PRODUCTION";
    WorkSuggestionsEnvironmentType["Staging"] = "STAGING";
    WorkSuggestionsEnvironmentType["Testing"] = "TESTING";
    WorkSuggestionsEnvironmentType["Unmapped"] = "UNMAPPED";
})($2f512219da033f72$export$4f315a2279163c82 || ($2f512219da033f72$export$4f315a2279163c82 = {}));
var $2f512219da033f72$export$bf7ed014c948227;
(function(WorkSuggestionsTargetAudience) {
    /** The target audience for individual suggestions */ WorkSuggestionsTargetAudience["Me"] = "ME";
    /** The target audience for team suggestions */ WorkSuggestionsTargetAudience["Team"] = "TEAM";
})($2f512219da033f72$export$bf7ed014c948227 || ($2f512219da033f72$export$bf7ed014c948227 = {}));
var $2f512219da033f72$export$6d0f92f77f50b1c2;
(function(WorkSuggestionsUserPersona) {
    WorkSuggestionsUserPersona["Developer"] = "DEVELOPER";
})($2f512219da033f72$export$6d0f92f77f50b1c2 || ($2f512219da033f72$export$6d0f92f77f50b1c2 = {}));
var $2f512219da033f72$export$88e2a9ce86b144d3;
(function(WorkSuggestionsVulnerabilityStatus) {
    WorkSuggestionsVulnerabilityStatus["Closed"] = "CLOSED";
    WorkSuggestionsVulnerabilityStatus["Ignored"] = "IGNORED";
    WorkSuggestionsVulnerabilityStatus["Open"] = "OPEN";
    WorkSuggestionsVulnerabilityStatus["Unknown"] = "UNKNOWN";
})($2f512219da033f72$export$88e2a9ce86b144d3 || ($2f512219da033f72$export$88e2a9ce86b144d3 = {}));
var $2f512219da033f72$export$32baded4868555f5;
(function(SourceBillingType) {
    SourceBillingType["Ccp"] = "CCP";
    SourceBillingType["Hams"] = "HAMS";
})($2f512219da033f72$export$32baded4868555f5 || ($2f512219da033f72$export$32baded4868555f5 = {}));
const $2f512219da033f72$export$acef6c05b528e93e = (0, $e9EE7.default)($2f512219da033f72$var$t || ($2f512219da033f72$var$t = $2f512219da033f72$var$_`
    fragment PricingPlanMicroCta on ContentPlatformCallToActionMicrocopy {
        ctaMicrocopyTitle
        ctaButtonText
        ctaUrl
    }
`));
const $2f512219da033f72$export$c160f0132c467dbe = (0, $e9EE7.default)($2f512219da033f72$var$t1 || ($2f512219da033f72$var$t1 = $2f512219da033f72$var$_`
    fragment PricingPlanHighlightedFeatureItem on ContentPlatformHighlightedFeature {
        highlightedFeatureDetails
        highlightedFeatureTitleExternal
        callOut
    }
`));
const $2f512219da033f72$export$d8a96e3a8dd9a1c4 = (0, $e9EE7.default)($2f512219da033f72$var$t2 || ($2f512219da033f72$var$t2 = $2f512219da033f72$var$_`
    fragment PricingPlanComparePlansItem on ContentPlatformPlan {
        planTitleExternal
        planOneLiner
        microCta {
            ...PricingPlanMicroCta
        }
        highlightedFeaturesTitle
        highlightedFeaturesContainer {
            ...PricingPlanHighlightedFeatureItem
        }
    }
    ${0}
    ${0}
`), $2f512219da033f72$export$acef6c05b528e93e, $2f512219da033f72$export$c160f0132c467dbe);
const $2f512219da033f72$export$73a75992d9a8b2fd = (0, $e9EE7.default)($2f512219da033f72$var$t3 || ($2f512219da033f72$var$t3 = $2f512219da033f72$var$_`
    fragment RelevantPlan on ContentPlatformPlan {
        planTitleExternal
    }
`));
const $2f512219da033f72$export$ad9278a0611ccbeb = (0, $e9EE7.default)($2f512219da033f72$var$t4 || ($2f512219da033f72$var$t4 = $2f512219da033f72$var$_`
    fragment FeatureAdditionalInformation on ContentPlatformFeatureAdditionalInformation {
        featureAdditionalInformation
        relevantPlan {
            ...RelevantPlan
        }
    }
    ${0}
`), $2f512219da033f72$export$73a75992d9a8b2fd);
const $2f512219da033f72$export$92e41a0c37bf677e = (0, $e9EE7.default)($2f512219da033f72$var$t5 || ($2f512219da033f72$var$t5 = $2f512219da033f72$var$_`
    fragment PricingPlanCompareFeaturesItem on ContentPlatformFeatureGroup {
        featureGroupTitleExternal
        features {
            callOut
            featureNameExternal
            description
            relevantPlan {
                ...RelevantPlan
            }
            relevantUrl
            featureAdditionalInformation {
                ...FeatureAdditionalInformation
            }
        }
    }
    ${0}
    ${0}
`), $2f512219da033f72$export$73a75992d9a8b2fd, $2f512219da033f72$export$ad9278a0611ccbeb);
const $2f512219da033f72$export$a200070db67e1a48 = (0, $e9EE7.default)($2f512219da033f72$var$t6 || ($2f512219da033f72$var$t6 = $2f512219da033f72$var$_`
    fragment PricingPlanAdditionalFeaturesItem on ContentPlatformPlanDetails {
        planAdditionalDetailsTitleExternal
        planAdditionalDetails
    }
`));
const $2f512219da033f72$export$77f18de579486f68 = (0, $e9EE7.default)($2f512219da033f72$var$t7 || ($2f512219da033f72$var$t7 = $2f512219da033f72$var$_`
    fragment PricingPlanCallToActionItem on ContentPlatformCallToAction {
        title
        valueProposition
        text
        url
        asset {
            title
            description
            url
        }
    }
`));
const $2f512219da033f72$export$5fe08308938c82ec = (0, $e9EE7.default)($2f512219da033f72$var$t8 || ($2f512219da033f72$var$t8 = $2f512219da033f72$var$_`
    fragment PricingPlanCallToActionMicrocopyItem on ContentPlatformCallToActionMicrocopy {
        ctaMicrocopyTitle
        ctaButtonText
        ctaUrl
    }
`));
const $2f512219da033f72$export$3da5c8542a3ecf99 = (0, $e9EE7.default)($2f512219da033f72$var$t9 || ($2f512219da033f72$var$t9 = $2f512219da033f72$var$_`
    fragment PricingPlan on ContentPlatformPricing {
        pricingTitleInternal
        pricingTitleExternal
        pageDescription
        headline
        comparePlans {
            ...PricingPlanComparePlansItem
        }
        compareFeaturesTitle
        compareFeatures {
            ...PricingPlanCompareFeaturesItem
        }
        getMoreDetailsTitle
        additionalDetails {
            ...PricingPlanAdditionalFeaturesItem
        }
        relatedProduct {
            productName
            productNameId
        }
        callToActionContainer {
            ...PricingPlanCallToActionItem
            ...PricingPlanCallToActionMicrocopyItem
        }
        datacenterPlans {
            ...PricingPlanComparePlansItem
        }
    }
    ${0}
    ${0}
    ${0}
    ${0}
    ${0}
`), $2f512219da033f72$export$d8a96e3a8dd9a1c4, $2f512219da033f72$export$92e41a0c37bf677e, $2f512219da033f72$export$a200070db67e1a48, $2f512219da033f72$export$77f18de579486f68, $2f512219da033f72$export$5fe08308938c82ec);
const $2f512219da033f72$export$4f56901ef99d22d2 = (0, $e9EE7.default)($2f512219da033f72$var$t10 || ($2f512219da033f72$var$t10 = $2f512219da033f72$var$_`
    fragment PricingsResponse on ContentPlatformPricingSearchConnection {
        edges {
            node {
                ...PricingPlan
            }
        }
    }
    ${0}
`), $2f512219da033f72$export$3da5c8542a3ecf99);
const $2f512219da033f72$export$5d6aae0a726eb71f = (0, $e9EE7.default)($2f512219da033f72$var$t11 || ($2f512219da033f72$var$t11 = $2f512219da033f72$var$_`
    query Pricings($search: ContentPlatformSearchAPIv2Query!) {
        pricings(search: $search) {
            ...PricingsResponse
        }
    }
    ${0}
`), $2f512219da033f72$export$4f56901ef99d22d2);

});





parcelRegister("3mtQK", function(module, exports) {
$parcel$export(module.exports, "ExpandableContent", function () { return (parcelRequire("kTjA8")).ExpandableContent; });
parcelRequire("6xKFA");

});
parcelRegister("6xKFA", function(module, exports) {
$parcel$export(module.exports, "ExpandableContent", function () { return (parcelRequire("kTjA8")).ExpandableContent; });
parcelRequire("kTjA8");

});
parcelRegister("kTjA8", function(module, exports) {

$parcel$export(module.exports, "ExpandableContent", function () { return $af9cf3b265c57261$export$9ffd278d9b1d2f4b; });
/* expandable-content.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $g9kzu = parcelRequire("g9kzu");

var $3Bf61 = parcelRequire("3Bf61");

var $5ohHq = parcelRequire("5ohHq");
const $af9cf3b265c57261$var$buttonCss = null;
const $af9cf3b265c57261$var$labelContentsCss = null;
const $af9cf3b265c57261$var$buttonContentCss = null; /**
                                * @deprecated - Please use @/libraries/design/components/expand instead
                                */ 
const $af9cf3b265c57261$export$9ffd278d9b1d2f4b = (props)=>{
    const [expanded, setExpanded] = (0, $iSvIT.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)(); // contentRef controls the content element height upon expansion change
    const contentRef = (0, $iSvIT.useRef)(null);
    (0, $iSvIT.useEffect)(()=>{
        if (!contentRef.current) return;
        if (expanded) contentRef.current.style.maxHeight = `${contentRef.current.scrollHeight}px`;
        else contentRef.current.style.maxHeight = "0";
    }, [
        expanded
    ]);
    const handleButtonClick = ()=>{
        if (props.eventDataName) {
            const data = {
                name: props.eventDataName,
                direction: expanded ? "close" : "open"
            };
            createAnalyticsEvent({
                eventName: "expandableContentClicked",
                eventType: "ui",
                eventComponent: "button",
                event: "clicked",
                actionSubject: "expandableContent",
                action: "clicked",
                attributes: data,
                data: data
            }).fire();
        }
        setExpanded((prev)=>!prev);
    };
    const labelContents = /*#__PURE__*/ (0, $loA2J.jsxs)("span", {
        className: (0, $esG4f.default)([
            "_1wybdlk8 _1e0c1txw _zulp1y44"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                className: (0, $esG4f.default)([
                    "_1e0c1o8l _4t3i1tcg _1bsb1tcg _t9ec1pp8 _v564f4ca"
                ]),
                style: {
                    "--_1drzqs5": (0, $43MIc.default)(expanded ? "rotate(90deg)" : "rotate(0deg)")
                },
                children: props.children && /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3Bf61))), {
                    label: "",
                    size: "medium"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                style: props.labelCss,
                className: (0, $esG4f.default)([
                    "_85i5yh40 _1bsb1osq"
                ]),
                children: expanded && props.expandedLabelText ? props.expandedLabelText : props.label
            })
        ]
    });
    const expandedStyles = null;
    const collapsedStyles = null;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        children: [
            props.children ? /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                "aria-expanded": expanded,
                onClick: handleButtonClick,
                className: (0, $esG4f.default)([
                    "_kkk218uv _mizuoelr _ra3x1wug _128mt94y",
                    "_ect41bgz _1wyboxwj _vwz44jg8 _syazr2ho _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3"
                ]),
                style: {
                    cursor: "pointer",
                    "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                },
                children: labelContents
            }) : /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                className: (0, $esG4f.default)([
                    "_ect41bgz _1wyboxwj _vwz44jg8 _syazr2ho _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3"
                ]),
                style: {
                    "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                },
                children: labelContents
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                ref: contentRef,
                "aria-hidden": !expanded,
                role: expanded ? "region" : undefined,
                className: (0, $esG4f.default)([
                    "_1e0ctcjq _1reo15vq _18m915vq _v56413gs _bozg1f4h"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        expanded && "_1e0c1ule",
                        !expanded && "_1e0cglyw"
                    ]),
                    children: props.children
                })
            })
        ]
    });
};

});



parcelRegister("gPkR0", function(module, exports) {
$parcel$export(module.exports, "PriceCard", function () { return (parcelRequire("7eBVv")).PriceCard; });
$parcel$export(module.exports, "CtaButton", function () { return (parcelRequire("9h2sd")).CtaButton; });
parcelRequire("7eBVv");
parcelRequire("9h2sd");

});
parcelRegister("7eBVv", function(module, exports) {

$parcel$export(module.exports, "PriceCard", function () { return $128c155f8118ab76$export$24997073811e6afa; });
/* price-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");

var $8xSOc = parcelRequire("8xSOc");
parcelRequire("1Z9Q6");
var $bI2Os = parcelRequire("bI2Os");
var $Jt4dG = parcelRequire("Jt4dG");
var $iLqzb = parcelRequire("iLqzb");
var $l0Nem = parcelRequire("l0Nem");
var $awrki = parcelRequire("awrki");
var $lW6Hw = parcelRequire("lW6Hw");

var $7mfju = parcelRequire("7mfju");

var $1VMYN = parcelRequire("1VMYN");

var $l9lQF = parcelRequire("l9lQF");

var $5ohHq = parcelRequire("5ohHq");

var $2lcYG = parcelRequire("2lcYG");

var $lrAJa = parcelRequire("lrAJa");

var $3rxdK = parcelRequire("3rxdK");

var $1u7RU = parcelRequire("1u7RU");
const $128c155f8118ab76$var$planFeatureMessageContainerStyles = null;
const $128c155f8118ab76$var$planFeatureMessagesStyles = null; // @ts-ignore
const $128c155f8118ab76$var$stickyCtaContainerStyles = null; /**
                                        * @deprecated - Please use @/libraries/design/components/pricing-card instead
                                        */ 
const $128c155f8118ab76$export$24997073811e6afa = (props)=>{
    var _props_planFeatureMessages;
    const { enableRecommendation: enableRecommendation = true } = props;
    const { defaultUnitCount: defaultUnitCount, shouldAddBuyNow: shouldAddBuyNow, recommendationElement: recommendationElement } = (0, $l9lQF.usePriceFinderContext)();
    const { renderDirectBuyBtn: renderDirectBuyBtn, renderDirectBuyMatchSpace: renderDirectBuyMatchSpace } = (0, $lrAJa.useDirectBuyExperiment)(props.billingCycle, props.offeringSku, shouldAddBuyNow);
    let highlightedFeaturesTitle = /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
        id: "Pricing.PriceCard.featureMessageTitleFree",
        defaultMessage: "Includes:"
    });
    if (props.adjacentLowerTierPlanName) highlightedFeaturesTitle = /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
        id: "Pricing.PriceCard.featureMessageTitle",
        defaultMessage: "Everything from {featureMessagePlanName}, plus:",
        values: {
            featureMessagePlanName: props.adjacentLowerTierPlanName
        }
    });
    const planTitleId = `planTitle_${props.priceCalcIdx}`;
    const defaultRecommendationElement = /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
        id: "Pricing.PriceCard.recommended",
        defaultMessage: "Recommended"
    }); /* eslint-disable jsx-a11y/no-redundant-roles */ 
    /* added role="list" to ul for safari https://developer.mozilla.org/en-US/docs/Web/CSS/list-style#accessibility  */ return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $bI2Os.PriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, (0, $bI2Os.getPriceCardProps)(props)), {
        outlined: props.highlighted,
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $Jt4dG.PriceCardSection), {
                children: [
                    enableRecommendation && /*#__PURE__*/ (0, $loA2J.jsx)((0, $iLqzb.Banner), {
                        shown: props.highlighted,
                        children: recommendationElement ? recommendationElement : defaultRecommendationElement
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)((0, $l0Nem.ContentStack), {
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $awrki.ContentText), {
                                        id: planTitleId,
                                        variant: "lg",
                                        as: "h2",
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)($128c155f8118ab76$var$PriceCardTitle, {
                                            planName: props.planName,
                                            planTitleComponent: props.planTitleComponent
                                        })
                                    }),
                                    props.description && /*#__PURE__*/ (0, $loA2J.jsx)((0, $awrki.ContentText), {
                                        variant: "md",
                                        id: `pricing-plan-description-${props.planName}`,
                                        children: props.description
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                className: (0, $esG4f.default)([
                                    "_1pfh1wug _1e0c1txw _2lx21bp4 _4cvr1h6o _zulp1tcg"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        className: (0, $esG4f.default)([
                                            "_4t3i88uy"
                                        ]),
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3rxdK.Price), (0, $7Knp0._)({}, props))
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        className: (0, $esG4f.default)([
                                            props.billingCycle === "ANNUAL" && !(props.offeringSku === (0, $7mfju.CloudOfferingsWithSkus).rovo && props.billingCycle === "ANNUAL" && props.unitCount > 1000) && "_1pfh1tcg"
                                        ]),
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1u7RU.StickyCTAContextProvider), {
                                            isSticky: false,
                                            children: props.ctaButton
                                        })
                                    }),
                                    renderDirectBuyBtn && /*#__PURE__*/ (0, $loA2J.jsx)((0, $2lcYG.BuyNowButtonExperiment), {
                                        defaultUnitCount: defaultUnitCount,
                                        unitCount: props.unitCount,
                                        pricingPlanId: props.pricingPlanId,
                                        edition: props.edition,
                                        dataProductKey: props.dataProductKey,
                                        planName: props.planName
                                    }),
                                    renderDirectBuyMatchSpace && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        className: (0, $esG4f.default)([
                                            "_4t3i1tcg"
                                        ])
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            !!((_props_planFeatureMessages = props.planFeatureMessages) === null || _props_planFeatureMessages === void 0 ? void 0 : _props_planFeatureMessages.length) && /*#__PURE__*/ (0, $loA2J.jsx)((0, $Jt4dG.PriceCardSection), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $lW6Hw.ExpanderStack), {
                    heading: highlightedFeaturesTitle,
                    lozenge: props.dataProductKey === "loom" && props.planName === "Business + AI" && /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                        className: (0, $esG4f.default)([
                            "_1pfhmyb0 _x10q1wr3"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8xSOc.default), {
                            style: {
                                color: (0, $5ohHq.wacToken)("color.neutral.light0")
                            },
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                id: "Pricing.PriceCard.LoomAiLozenge",
                                defaultMessage: "Powered by Loom AI",
                                description: "Loom AI should not be translated"
                            })
                        })
                    }),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("ul", {
                        role: "list",
                        className: (0, $esG4f.default)([
                            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1pfhidpf _2mzuglyw"
                        ]),
                        children: props.planFeatureMessages.map((planFeatureMessage, idx)=>{
                            return /*#__PURE__*/ (0, $loA2J.jsx)("li", {
                                className: (0, $esG4f.default)([
                                    "_1pfh7vkz _1d6jidpf"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1VMYN.PlanFeature), (0, $6iHNw._)((0, $7Knp0._)({}, planFeatureMessage), {
                                    padded: false
                                }))
                            }, idx);
                        })
                    })
                })
            })
        ]
    }));
};
const $128c155f8118ab76$var$PriceCardTitle = (props)=>{
    const { planName: planName, planTitleComponent: PlanTitle } = props;
    return PlanTitle ? /*#__PURE__*/ (0, $loA2J.jsx)(PlanTitle, {
        planName: planName
    }) : /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        id: `pricing-plan-title-${planName}`,
        children: planName
    });
};

});
parcelRegister("1Z9Q6", function(module, exports) {
$parcel$export(module.exports, "Banner", function () { return (parcelRequire("iLqzb")).Banner; });
$parcel$export(module.exports, "ContentStack", function () { return (parcelRequire("l0Nem")).ContentStack; });
$parcel$export(module.exports, "ContentText", function () { return (parcelRequire("awrki")).ContentText; });
$parcel$export(module.exports, "ExpanderStack", function () { return (parcelRequire("lW6Hw")).ExpanderStack; });
$parcel$export(module.exports, "getPriceCardProps", function () { return (parcelRequire("bI2Os")).getPriceCardProps; });
$parcel$export(module.exports, "PriceCard", function () { return (parcelRequire("bI2Os")).PriceCard; });
$parcel$export(module.exports, "PriceCardSection", function () { return (parcelRequire("Jt4dG")).PriceCardSection; });
$parcel$export(module.exports, "PriceCardsStack", function () { return (parcelRequire("aYj4m")).PriceCardsStack; });

$parcel$export(module.exports, "Button", function () { return (parcelRequire("91nJf")).Adg4Button; });
parcelRequire("6xKFA");
var $kTjA8 = parcelRequire("kTjA8");

var $91nJf = parcelRequire("91nJf");
parcelRequire("iLqzb");
parcelRequire("2GiiF");
parcelRequire("l0Nem");
parcelRequire("awrki");
parcelRequire("lW6Hw");
parcelRequire("bI2Os");
parcelRequire("Jt4dG");
parcelRequire("aYj4m");

});
parcelRegister("iLqzb", function(module, exports) {

$parcel$export(module.exports, "Banner", function () { return $6b79493c7647c029$export$3b4e64e77073e307; });
/* banner.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $5ohHq = parcelRequire("5ohHq");
const $6b79493c7647c029$export$3b4e64e77073e307 = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_4t3i1tcg _1e0c1txw _1bah1h6o _4cvr1h6o _1bsb1osq",
            props.shown && "_11q71hlo _2rko1kw7"
        ]),
        style: {
            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
        },
        children: props.shown && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_syazcd5j _1wyb1crf _ect48q0o _k48pni7l _1p1dangw _vwz4f6fq _1dyzt94y _slp31hna _y3gn1h6o"
            ]),
            style: {
                "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
            },
            children: props.children
        })
    });
};
const $6b79493c7647c029$var$bannerCss = null;
const $6b79493c7647c029$var$bannerContent = null;

});

parcelRegister("2GiiF", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_SECTIONS_COUNT", function () { return $91492fe3765dcde3$export$366b07c70d10dc4d; });
const $91492fe3765dcde3$export$366b07c70d10dc4d = 2;

});

parcelRegister("l0Nem", function(module, exports) {

$parcel$export(module.exports, "ContentStack", function () { return $6325f9d4c7506509$export$346989ded957d179; });
/* content-stack.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
const $6325f9d4c7506509$export$346989ded957d179 = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o _zulp1tcg _4t3i1osq _ca0q1tcg _u5f31tcg _n3td1tcg _19bv1tcg"
        ]),
        children: props.children
    });
};
const $6325f9d4c7506509$var$contentStackCss = null;

});

parcelRegister("awrki", function(module, exports) {

$parcel$export(module.exports, "ContentText", function () { return $47e869f6aca57622$export$646b80a994b34028; });
/* content-text.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
const $47e869f6aca57622$export$646b80a994b34028 = (props)=>{
    const { as: Component = "span", variant: variant = "md" } = props;
    return /*#__PURE__*/ (0, $loA2J.jsx)(Component, (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        className: (0, $esG4f.default)([
            "_ect48q0o _syazqlpt _y3gn1h6o _1e0c1ule _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            variant === "xl" && "_1wyb1ylp _vwz4ckbl _k48p1fw0",
            variant === "lg" && "_1wyb1tcg _vwz41ul9 _k48p1fw0",
            variant === "md" && "_1wybdlk8 _vwz4gktf"
        ]),
        children: props.children
    }));
};
const $47e869f6aca57622$var$xlCss = null;
const $47e869f6aca57622$var$lgCss = null;
const $47e869f6aca57622$var$mdCss = null;
const $47e869f6aca57622$var$contentTextCss = null;

});

parcelRegister("lW6Hw", function(module, exports) {

$parcel$export(module.exports, "ExpanderStack", function () { return $0b6f1411e744bd66$export$b2da8816cb6c8b9e; });
/* expander-stack.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
const $0b6f1411e744bd66$var$expanderStackCss = null;
const $0b6f1411e744bd66$var$expanderStackHeadingCss = null;
const $0b6f1411e744bd66$export$b2da8816cb6c8b9e = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _zulp7vkz _ca0q1tcg _u5f31tcg _n3td1tcg _19bv1tcg _1bsb1osq"
        ]),
        children: [
            props.lozenge,
            props.heading && /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                className: (0, $esG4f.default)([
                    "_1wyb7vkz _vwz41tcg _k48pni7l _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                ]),
                children: props.heading
            }),
            props.children
        ]
    });
};

});

parcelRegister("bI2Os", function(module, exports) {

$parcel$export(module.exports, "PriceCard", function () { return $fbc6b36dc429b6f1$export$24997073811e6afa; });
$parcel$export(module.exports, "getPriceCardProps", function () { return $fbc6b36dc429b6f1$export$3a1eade60b680c85; });
/* price-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");

var $iSvIT = parcelRequire("iSvIT");

var $aYj4m = parcelRequire("aYj4m");
const $fbc6b36dc429b6f1$export$24997073811e6afa = (props)=>{
    const { isInsideCardStack: isInsideCardStack } = (0, $aYj4m.useIsInsideCardStack)();
    const validChildren = [];
    (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Children.forEach(props.children, (child)=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).isValidElement(child)) validChildren.push(child);
    });
    const children = validChildren.map((child, index)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).cloneElement(child, {
            key: index,
            first: index === 0,
            last: index === (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Children.count(validChildren) - 1,
            firstCard: props.first,
            lastCard: props.last,
            outlined: props.outlined
        });
    });
    if (isInsideCardStack) return children;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1s4p1osq"
        ]),
        children: children
    });
};
const $fbc6b36dc429b6f1$var$priceCardCss = null;
const $fbc6b36dc429b6f1$export$3a1eade60b680c85 = ({ first: first, last: last, outlined: outlined })=>({
        first: first,
        last: last,
        outlined: outlined
    });

});
parcelRegister("aYj4m", function(module, exports) {

$parcel$export(module.exports, "PriceCardsStack", function () { return $e0f73ec69ca5a98b$export$4379d187fb91b2c6; });
$parcel$export(module.exports, "useIsInsideCardStack", function () { return $e0f73ec69ca5a98b$export$41df4605c6d99494; });
/* price-cards-stack.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $iSvIT = parcelRequire("iSvIT");

var $2GiiF = parcelRequire("2GiiF");
const $e0f73ec69ca5a98b$export$4379d187fb91b2c6 = (props)=>{
    const { sections: sectionsCount = (0, $2GiiF.DEFAULT_SECTIONS_COUNT) } = props;
    const cardsCount = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Children.count(props.children);
    const children = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Children.map(props.children, (child, index)=>{
        const childElement = child;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).cloneElement(childElement, {
            first: index === 0,
            last: index === cardsCount - 1
        });
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)($e0f73ec69ca5a98b$var$PriceCardStackContext.Provider, {
        value: {
            isInsideCardStack: true
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_1e0c11p5 _wij21bp4 _1bsb1ns9 _glte1ns9 _1mjb1txw _na0i1bp4 _1s4p1osq",
                "_2z051xin _yv0e1iwh"
            ]),
            style: {
                "--_1u0qyx2": (0, $43MIc.default)(sectionsCount),
                "--_uofz2v": (0, $43MIc.default)(cardsCount)
            },
            children: children
        })
    });
};
const $e0f73ec69ca5a98b$var$priceCardsStackCss = null;
const $e0f73ec69ca5a98b$var$PriceCardStackContext = /*#__PURE__*/ (0, $iSvIT.createContext)({
    isInsideCardStack: false
});
const $e0f73ec69ca5a98b$export$41df4605c6d99494 = ()=>{
    return (0, $iSvIT.useContext)($e0f73ec69ca5a98b$var$PriceCardStackContext);
};

});


parcelRegister("Jt4dG", function(module, exports) {

$parcel$export(module.exports, "PriceCardSection", function () { return $99b0a6650305ae7f$export$bead6418a4510dba; });
/* price-card-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $5ohHq = parcelRequire("5ohHq");

var $aYj4m = parcelRequire("aYj4m");
const $99b0a6650305ae7f$export$bead6418a4510dba = (props)=>{
    const { first: first, last: last, firstCard: firstCard, lastCard: lastCard, outlined: outlined, children: children } = props, divProps = (0, $akGnX._)(props, [
        "first",
        "last",
        "firstCard",
        "lastCard",
        "outlined",
        "children"
    ]);
    const { isInsideCardStack: isInsideCardStack } = (0, $aYj4m.useIsInsideCardStack)();
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", (0, $6iHNw._)((0, $7Knp0._)({}, divProps), {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _1bah1yb4 _4cvr1h6o _glte1osq _11q7cd5j",
            "_mqm2u1j4 _191wu1j4 _16qsglyw",
            !isInsideCardStack && first && "_1s1ggktf _5fbcgktf",
            !isInsideCardStack && "_t51zu1j4",
            !isInsideCardStack && last && "_179ru1j4 _1yxngktf _1eingktf",
            !isInsideCardStack && outlined && "_191wn4na _t51zn4na",
            !isInsideCardStack && outlined && first && "_mqm2n4na",
            !isInsideCardStack && outlined && last && "_179rn4na _1yxngktf _1eingktf",
            isInsideCardStack && "_1tk6u1j4",
            isInsideCardStack && first && "_1e0kgktf _tg79gktf",
            isInsideCardStack && last && "_179ru1j4 _1egl1tcg _6q09idpf",
            isInsideCardStack && lastCard && "_p5clu1j4",
            isInsideCardStack && firstCard && first && "_1orwgktf",
            isInsideCardStack && lastCard && first && "_yo7bgktf",
            isInsideCardStack && lastCard && last && "_1f8wgktf",
            isInsideCardStack && firstCard && last && "_3ynegktf",
            isInsideCardStack && outlined && first && "_mqm2n4na",
            isInsideCardStack && outlined && "_xvbnn4na _1tk6n4na _1w6en4na _p5cln4na",
            isInsideCardStack && outlined && last && "_179rn4na"
        ]),
        style: {
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
            "--_r91gx3": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light400")),
            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
        },
        children: children
    }));
};
const $99b0a6650305ae7f$var$priceCardSectionCss = null;

});


parcelRegister("1VMYN", function(module, exports) {

$parcel$export(module.exports, "PlanFeature", function () { return $ffe34b1f9fe88321$export$eba92f5ed965ecf9; });
/* price-card-plan-feature.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $8xSOc = parcelRequire("8xSOc");
parcelRequire("3mtQK");
var $kTjA8 = parcelRequire("kTjA8");
const $ffe34b1f9fe88321$var$planFeatureMessageContainerCss = null;
const $ffe34b1f9fe88321$var$contentContainerCss = null;
const $ffe34b1f9fe88321$var$lozengeContainerCss = null;
const $ffe34b1f9fe88321$var$featureContentContainerCss = null;
const $ffe34b1f9fe88321$export$eba92f5ed965ecf9 = ({ featureMessage: featureMessage, lozengeText: lozengeText, padded: padded = true })=>{
    const featureMessageHasContent = !(typeof featureMessage === "string");
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _szfsglyw _stfgglyw _d32voelr _4rtxtlke _1sg88q0o _1o7poxwj _1q9t1nn1 _11lv1y44 _ficf1e5h _4pkpu7gi",
            padded && "_1q517vkz _bozg19bv"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_syaz1mpp _1bsb1osq"
            ]),
            children: featureMessageHasContent ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $kTjA8.ExpandableContent), {
                eventDataName: featureMessage.text,
                label: /*#__PURE__*/ (0, $loA2J.jsxs)("span", {
                    children: [
                        featureMessage.text,
                        lozengeText && /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                            className: (0, $esG4f.default)([
                                "_ahbq1y44"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8xSOc.default), {
                                children: lozengeText
                            })
                        })
                    ]
                }),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1wyboxwj _syazqlpt _43dsrbzz _59381r31 _yha28stv _1nmznqa1 _oxk4oelr _rfqo1r31 _1bgkglyw _1t0pnqa1"
                    ]),
                    children: featureMessage.content("100%")
                })
            }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $kTjA8.ExpandableContent), {
                eventDataName: featureMessage,
                label: /*#__PURE__*/ (0, $loA2J.jsxs)("span", {
                    children: [
                        featureMessage,
                        lozengeText && /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                            className: (0, $esG4f.default)([
                                "_ahbq1y44"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8xSOc.default), {
                                children: lozengeText
                            })
                        })
                    ]
                })
            })
        })
    });
};

});

parcelRegister("l9lQF", function(module, exports) {

$parcel$export(module.exports, "usePriceFinderContext", function () { return $fec3daa7d52b31e9$export$179afbf02f71f9f; });
$parcel$export(module.exports, "PriceFinderContextProvider", function () { return $fec3daa7d52b31e9$export$520d8e05995e73b; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
const $fec3daa7d52b31e9$var$PriceFinderContext = /*#__PURE__*/ (0, $iSvIT.createContext)(undefined);
const $fec3daa7d52b31e9$export$179afbf02f71f9f = ()=>{
    const context = (0, $iSvIT.useContext)($fec3daa7d52b31e9$var$PriceFinderContext);
    if (!context) throw new Error("usePriceFinderContext must be used within a PriceFinderContextProvider");
    return context;
};
const $fec3daa7d52b31e9$export$520d8e05995e73b = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)($fec3daa7d52b31e9$var$PriceFinderContext.Provider, {
        value: props,
        children: props.children
    });
};

});

parcelRegister("3rxdK", function(module, exports) {

$parcel$export(module.exports, "Price", function () { return $77e507b352dff6bb$export$3f58fdce283c1f4c; });
/* price.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable complexity */ /* Will be refactored once we have redesign goes live */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");
parcelRequire("1Z9Q6");
var $awrki = parcelRequire("awrki");

var $7mfju = parcelRequire("7mfju");

var $3FBn4 = parcelRequire("3FBn4");

var $l9lQF = parcelRequire("l9lQF");

var $g0OBC = parcelRequire("g0OBC");

var $6d3jZ = parcelRequire("6d3jZ");

var $2Hi3h = parcelRequire("2Hi3h");
const $77e507b352dff6bb$var$fontCharlieDisplay = '"Charlie Display", "Charlie Text", -apple-system, BlinkMacSystemFont, "Segoe UI",Roboto, "Noto Sans", Ubuntu, "Droid Sans", "Helvetica Neue", sans-serif !important';
const $77e507b352dff6bb$var$priceSpanStyles = null;
const $77e507b352dff6bb$export$3f58fdce283c1f4c = (props)=>{
    var _messages_cardOverSignupLimit;
    const { billingCycle: billingCycle, overSignupLimit: overSignupLimit, planName: planName, currencyISOCode: currencyISOCode, unitCount: unitCount, productKey: productKey, priceCalcIdx: priceCalcIdx, contactURL: contactURL, offeringSku: offeringSku, shouldAddDiscount: shouldAddDiscount } = props;
    const [{ priceCalcs: priceCalcs, messages: messages }, actions] = (0, $g0OBC.usePriceFinderStore)();
    const { enterpriseMinimumCount: enterpriseMinimumCount = (0, $7mfju.DefaultPlanLimits).UNIT_MIN_ENTERPRISE } = (0, $l9lQF.usePriceFinderContext)();
    const priceCalc = priceCalcs[priceCalcIdx];
    if (!priceCalc) throw new Error(`Price calculation was not found for index ${priceCalcIdx}`);
    let planMessage = billingCycle === "MONTHLY" ? /*#__PURE__*/ (0, $loA2J.jsx)($77e507b352dff6bb$var$MonthlyPrice, {
        formattedPrice: priceCalc.formattedAvgPerUnitPrice,
        formattedAvgPerUnitPriceWithDiscount: priceCalc.formattedAvgPerUnitPriceWithDiscount,
        planName: planName,
        shouldAddDiscount: shouldAddDiscount
    }) : /*#__PURE__*/ (0, $loA2J.jsx)($77e507b352dff6bb$export$8e077f62bcf5008c, {
        formattedPrice: priceCalc.formattedTotalPrice,
        formattedTotalPriceWithDiscount: priceCalc.formattedTotalPriceWithDiscount,
        planName: planName,
        priceCalc: priceCalc,
        priceDisplaySize: currencyISOCode === "JPY" ? "small" : "normal",
        shouldAddDiscount: shouldAddDiscount
    });
    var _messages_cardOverSignupLimit_defaultMessage;
    if (overSignupLimit && productKey === (0, $7mfju.SpecialProductKeys).BITBUCKET) planMessage = /*#__PURE__*/ (0, $loA2J.jsxs)((0, $awrki.ContentText), {
        variant: "md",
        "data-testid": "bitbucket-signup-limit",
        children: [
            "For teams of more than 35,000,",
            " ",
            /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                href: contactURL,
                children: "contact our sales team."
            })
        ]
    });
    else if (overSignupLimit) planMessage = /*#__PURE__*/ (0, $loA2J.jsx)((0, $awrki.ContentText), {
        variant: "md",
        "data-testid": "signup-limit",
        children: (_messages_cardOverSignupLimit_defaultMessage = messages === null || messages === void 0 ? void 0 : (_messages_cardOverSignupLimit = messages.cardOverSignupLimit) === null || _messages_cardOverSignupLimit === void 0 ? void 0 : _messages_cardOverSignupLimit.defaultMessage) !== null && _messages_cardOverSignupLimit_defaultMessage !== void 0 ? _messages_cardOverSignupLimit_defaultMessage : ""
    });
    if (offeringSku === (0, $7mfju.CloudOfferingsWithSkus).rovo && unitCount > 1000) planMessage = /*#__PURE__*/ (0, $loA2J.jsx)((0, $awrki.ContentText), {
        variant: "md",
        "data-testid": "rovo-annual-message",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "Pricing.card.body.rovo.annual.message",
            defaultMessage: "Start your free 30-day trial or contact your Atlassian sales representative for more information."
        })
    });
    switch(planName){
        case (0, $7mfju.SpecialPlanNames).STARTER:
        case (0, $7mfju.SpecialPlanNames).FREE:
            planMessage = /*#__PURE__*/ (0, $loA2J.jsx)($77e507b352dff6bb$var$FreePrice, {
                formattedPrice: priceCalc.formattedTotalPrice,
                planName: planName
            });
            break;
        case (0, $7mfju.SpecialPlanNames).ENTERPRISE:
            if (messages.cardEnterpriseBodyOverride) planMessage = messages.cardEnterpriseBodyOverride;
            else if (billingCycle === "MONTHLY") planMessage = /*#__PURE__*/ (0, $loA2J.jsxs)((0, $awrki.ContentText), {
                variant: "md",
                "data-testid": "enterprise-monthly",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $6d3jZ.BilledAnnuallyButton), {
                        onClick: ()=>actions.updateBillingCycle("ANNUAL")
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                        id: "PricingTeam24.card.body.enterprise.monthly",
                        defaultMessage: "Switch to Annual billing above to view Enterprise pricing."
                    })
                ]
            });
            else if (currencyISOCode === "JPY") planMessage = /*#__PURE__*/ (0, $loA2J.jsx)((0, $awrki.ContentText), {
                variant: "md",
                "data-testid": "enterprise-jpy",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "Pricing.card.body.enterprise.jpy",
                    defaultMessage: "For pricing details see FAQ below or talk to our sales team"
                })
            });
            else if (overSignupLimit) planMessage = /*#__PURE__*/ (0, $loA2J.jsx)((0, $awrki.ContentText), {
                variant: "md",
                "data-testid": "enterprise-signup-limit",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "Pricing.card.body.enterprise.overSignupLimit",
                    defaultMessage: "Talk to our sales team about pricing for Cloud Enterprise"
                })
            });
            else if (unitCount < enterpriseMinimumCount) planMessage = /*#__PURE__*/ (0, $loA2J.jsx)((0, $awrki.ContentText), {
                variant: "md",
                "data-testid": "enterprise-min-limit",
                children: messages.cardEnterpriseMinimumCount && /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: messages.cardEnterpriseMinimumCount.id,
                    defaultMessage: messages.cardEnterpriseMinimumCount.defaultMessage,
                    values: (0, $6iHNw._)((0, $7Knp0._)({}, (0, $3FBn4.DEFAULT_VALUES)), {
                        enterpriseMinimumCount: enterpriseMinimumCount
                    })
                })
            });
            break;
    }
    return planMessage;
};
const $77e507b352dff6bb$var$FREE_PRICE_TEST_ID = "free-price";
const $77e507b352dff6bb$var$FreePrice = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $awrki.ContentText), {
        variant: "xl",
        "data-cy": `plan-card-price-${props.planName.toLowerCase()}`,
        "data-testid": $77e507b352dff6bb$var$FREE_PRICE_TEST_ID,
        children: props.formattedPrice
    });
};
const $77e507b352dff6bb$var$MONTHLY_PRICE_TEST_ID = "monthly-price";
const $77e507b352dff6bb$var$MonthlyPrice = (props)=>{
    const [{ messages: messages }] = (0, $g0OBC.usePriceFinderStore)();
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            props.shouldAddDiscount ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $awrki.ContentText), {
                variant: "xl",
                "data-cy": `plan-card-price-${props.planName.toLowerCase()}`,
                "data-testid": $77e507b352dff6bb$var$MONTHLY_PRICE_TEST_ID,
                children: props.formattedAvgPerUnitPriceWithDiscount
            }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $awrki.ContentText), {
                variant: "xl",
                "data-cy": `plan-card-price-${props.planName.toLowerCase()}`,
                "data-testid": $77e507b352dff6bb$var$MONTHLY_PRICE_TEST_ID,
                children: props.formattedPrice
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $awrki.ContentText), {
                variant: "md",
                children: (messages === null || messages === void 0 ? void 0 : messages.cardMonthlyPerUnitCount) && /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: messages.cardMonthlyPerUnitCount.id,
                    defaultMessage: messages.cardMonthlyPerUnitCount.defaultMessage
                })
            })
        ]
    });
};
const $77e507b352dff6bb$var$ANNUAL_PRICE_TEST_ID = "annual-price";
const $77e507b352dff6bb$export$1db406331b1cb6e4 = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            props.shouldAddDiscount ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $awrki.ContentText), {
                variant: "xl",
                style: {
                    fontSize: props.priceDisplaySize === "small" ? "35px" : undefined
                },
                "data-testid": $77e507b352dff6bb$var$ANNUAL_PRICE_TEST_ID,
                "data-cy": `plan-card-price-${props.planName.toLowerCase()}`,
                children: props.formattedTotalPriceWithDiscount
            }) : /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                className: (0, $esG4f.default)([
                    "_1wybckbl _k48pbfng _ect41lim _kqswh2mm"
                ]),
                children: props.formattedPrice
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                "data-testid": $77e507b352dff6bb$var$ANNUAL_PRICE_TEST_ID,
                className: (0, $esG4f.default)([
                    "_1pfh1h22"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "Pricing.PriceCard.Annual.Description",
                    defaultMessage: "per year"
                })
            }),
            props.formattedUnitTierNode
        ]
    });
};
const $77e507b352dff6bb$export$8e077f62bcf5008c = (props)=>{
    const [{ unitCount: unitCount }] = (0, $g0OBC.usePriceFinderStore)();
    const { annualUserTierDisplayThreshold: annualUserTierDisplayThreshold } = (0, $l9lQF.usePriceFinderContext)();
    const shouldDisplayPriceTier = annualUserTierDisplayThreshold === undefined || unitCount >= annualUserTierDisplayThreshold;
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            props.shouldAddDiscount ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $awrki.ContentText), {
                "data-testid": $77e507b352dff6bb$var$ANNUAL_PRICE_TEST_ID,
                variant: "xl",
                style: {
                    fontSize: props.priceDisplaySize === "small" ? "35px" : undefined
                },
                "data-cy": `plan-card-price-${props.planName.toLowerCase()}`,
                children: props.formattedTotalPriceWithDiscount
            }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $awrki.ContentText), {
                "data-testid": $77e507b352dff6bb$var$ANNUAL_PRICE_TEST_ID,
                variant: "xl",
                style: {
                    fontSize: props.priceDisplaySize === "small" ? "35px" : undefined
                },
                "data-cy": `plan-card-price-${props.planName.toLowerCase()}`,
                children: props.formattedPrice
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $awrki.ContentText), {
                "data-testid": $77e507b352dff6bb$var$ANNUAL_PRICE_TEST_ID,
                variant: "md",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                        id: "Pricing.PriceCard.Annual.Description",
                        defaultMessage: "per year"
                    }),
                    shouldDisplayPriceTier && /*#__PURE__*/ (0, $loA2J.jsx)((0, $2Hi3h.UserTier), {
                        priceCalc: props.priceCalc
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("g0OBC", function(module, exports) {

$parcel$export(module.exports, "PriceFinderContainer", function () { return $481d9239b5911e02$export$d217816b05791954; });
$parcel$export(module.exports, "usePriceFinderStore", function () { return $481d9239b5911e02$export$f4b6caeda40bfc57; });

var $7Knp0 = parcelRequire("7Knp0");

var $9Zc2v = parcelRequire("9Zc2v");
var $4ejMU = parcelRequire("4ejMU");
var $ij7wO = parcelRequire("ij7wO");

var $9998h = parcelRequire("9998h");
const $481d9239b5911e02$export$d4c72bab9d6cc13a = {
    unitCount: 0,
    billingCycle: "MONTHLY",
    priceCalcs: [],
    currencyISOCode: "USD",
    messages: {
        // These messages always be overridden by the consumer on init
        unitCountInputText: {},
        unitCountInputTooltip: {},
        cardOverSignupLimit: {},
        cardEnterpriseMinimumCount: {},
        cardUnitCountTierRange: {},
        cardMonthlyPerUnitCount: {},
        cardFreeDescription: {}
    }
};
const $481d9239b5911e02$export$d217816b05791954 = (0, $9Zc2v.createContainer)();
const $481d9239b5911e02$var$store = (0, $ij7wO.createStore)({
    containedBy: $481d9239b5911e02$export$d217816b05791954,
    name: "price-finder",
    initialState: $481d9239b5911e02$export$d4c72bab9d6cc13a,
    actions: $9998h,
    handlers: {
        onInit: ()=>({ setState: setState }, state)=>{
                setState((0, $7Knp0._)({}, state));
            }
    }
});
const $481d9239b5911e02$export$f4b6caeda40bfc57 = (0, $4ejMU.createHook)($481d9239b5911e02$var$store);

});
parcelRegister("9Zc2v", function(module, exports) {

$parcel$export(module.exports, "createContainer", function () { return $74532652182e60f6$export$26ae5ca175b4ec5a; });

var $iSvIT = parcelRequire("iSvIT");

var $4J1z5 = parcelRequire("4J1z5");

var $cOw7m = parcelRequire("cOw7m");

var $b5nxz = parcelRequire("b5nxz");
var $lpR5b = parcelRequire("lpR5b");

var $jeDlX = parcelRequire("jeDlX");
const $74532652182e60f6$var$_excluded = [
    "children"
], $74532652182e60f6$var$_excluded2 = [
    "scope",
    "isGlobal"
];
function $74532652182e60f6$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $74532652182e60f6$var$noop = ()=>()=>{};
function $74532652182e60f6$export$26ae5ca175b4ec5a(StoreOrOptions, _temp) {
    if (StoreOrOptions === void 0) StoreOrOptions = {};
    let { onInit: _onInit = $74532652182e60f6$var$noop, onUpdate: onUpdate = $74532652182e60f6$var$noop, onCleanup: onCleanup = $74532652182e60f6$var$noop, displayName: displayName = "" } = _temp === void 0 ? {} : _temp;
    if ("key" in StoreOrOptions) {
        const Store = StoreOrOptions;
        const dn = displayName || `Container(${Store.key.split("__")[0]})`;
        return $74532652182e60f6$var$createFunctionContainer({
            displayName: dn,
            // compat fields
            override: {
                Store: Store,
                handlers: Object.assign({}, _onInit !== $74532652182e60f6$var$noop && {
                    onInit: ()=>_onInit()
                }, onCleanup !== $74532652182e60f6$var$noop && {
                    onDestroy: ()=>onCleanup()
                }, onUpdate !== $74532652182e60f6$var$noop && {
                    onContainerUpdate: ()=>onUpdate()
                })
            }
        });
    }
    return $74532652182e60f6$var$createFunctionContainer(StoreOrOptions);
}
function $74532652182e60f6$var$useRegistry(scope, isGlobal, _ref) {
    let { globalRegistry: globalRegistry } = _ref;
    return (0, $iSvIT.useMemo)(()=>{
        const isLocal = !scope && !isGlobal;
        return isLocal ? new (0, $lpR5b.StoreRegistry)("__local__") : globalRegistry;
    }, [
        scope,
        isGlobal,
        globalRegistry
    ]);
}
function $74532652182e60f6$var$useContainedStore(scope, registry, propsRef, check, override) {
    // Store contained scopes in a map, but throwing it away on scope change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const containedStores = (0, $iSvIT.useMemo)(()=>new Map(), [
        scope
    ]);
    const getContainedStore = (0, $iSvIT.useCallback)((Store)=>{
        let containedStore = containedStores.get(Store); // first time it gets called we add store to contained map bound
        // so we can provide props to actions (only triggered by children)
        if (!containedStore) {
            const isExisting = registry.hasStore(Store, scope);
            const config = {
                props: ()=>propsRef.current.sub,
                contained: check
            };
            const { storeState: storeState } = registry.getStore(Store, scope, config);
            const actions = (0, $b5nxz.bindActions)(Store.actions, storeState, config);
            const handlers = (0, $b5nxz.bindActions)(Object.assign({}, Store.handlers, override == null ? void 0 : override.handlers), storeState, config, actions);
            containedStore = {
                storeState: storeState,
                actions: actions,
                handlers: handlers,
                unsubscribe: storeState.subscribe(()=>handlers.onUpdate == null ? void 0 : handlers.onUpdate())
            };
            containedStores.set(Store, containedStore); // Signal store is contained and ready now, so by the time
            // consumers subscribe we already have updated the store (if needed).
            // Also if override maintain legacy behaviour, triggered on every mount
            if (!isExisting || override) handlers.onInit == null || handlers.onInit();
        }
        return containedStore;
    }, [
        containedStores,
        scope,
        registry,
        propsRef,
        check,
        override
    ]);
    return [
        containedStores,
        getContainedStore
    ];
}
function $74532652182e60f6$var$useApi(check, getContainedStore, _ref2) {
    let { globalRegistry: globalRegistry, retrieveStore: retrieveStore } = _ref2;
    const retrieveRef = (0, $iSvIT.useRef)();
    retrieveRef.current = (Store)=>check(Store) ? getContainedStore(Store) : retrieveStore(Store); // This api is "frozen", as changing it will trigger re-render across all consumers
    // so we link retrieveStore dynamically and manually call notify() on scope change
    return (0, $iSvIT.useMemo)(()=>({
            globalRegistry: globalRegistry,
            retrieveStore: (s)=>retrieveRef.current(s)
        }), [
        globalRegistry
    ]);
}
function $74532652182e60f6$var$createFunctionContainer(_temp2) {
    let { displayName: displayName, override: override } = _temp2 === void 0 ? {} : _temp2;
    const check = (store)=>override ? store === override.Store : store.containedBy === FunctionContainer;
    function FunctionContainer(props) {
        const { children: children } = props, restProps = $74532652182e60f6$var$_objectWithoutPropertiesLoose(props, $74532652182e60f6$var$_excluded);
        const { scope: scope, isGlobal: isGlobal } = restProps, subProps = $74532652182e60f6$var$_objectWithoutPropertiesLoose(restProps, $74532652182e60f6$var$_excluded2);
        const ctx = (0, $iSvIT.useContext)((0, $cOw7m.Context));
        const registry = $74532652182e60f6$var$useRegistry(scope, isGlobal, ctx); // Store props in a ref to avoid re-binding actions when they change and re-rendering all
        // consumers unnecessarily. The update is handled by an effect on the component instead
        const propsRef = (0, $iSvIT.useRef)({
            prev: null,
            next: restProps,
            sub: subProps
        });
        propsRef.current = {
            prev: propsRef.current.next,
            next: restProps,
            sub: subProps // TODO remove on next major
        };
        const [containedStores, getContainedStore] = $74532652182e60f6$var$useContainedStore(scope, registry, propsRef, check, override); // Use a stable object as is passed as value to context Provider
        const api = $74532652182e60f6$var$useApi(check, getContainedStore, ctx); // This listens for custom props change, and so we trigger container update actions
        // before the re-render gets to consumers (hence why side effect on render).
        // We do not use React hooks because num of restProps might change and react will throws
        if (!(0, $jeDlX.default)(propsRef.current.next, propsRef.current.prev)) containedStores.forEach((_ref3)=>{
            let { handlers: handlers } = _ref3;
            handlers.onContainerUpdate == null || handlers.onContainerUpdate(propsRef.current.next, propsRef.current.prev);
        });
         // We support renderding "bootstrap" containers without children with override API
        // so in this case we call getCS to initialize the store globally asap
        if (override && !containedStores.size && (scope || isGlobal)) getContainedStore(override.Store);
         // This listens for scope change or component unmount, to notify all consumers
        // so all work is done on cleanup
        (0, $iSvIT.useEffect)(()=>{
            return ()=>{
                containedStores.forEach((_ref4, Store)=>{
                    let { storeState: storeState, handlers: handlers, unsubscribe: unsubscribe } = _ref4;
                    // Detatch container from subscription
                    unsubscribe(); // Trigger a forced update on all subscribers as we opted out from context
                    // Some might have already re-rendered naturally, but we "force update" all anyway.
                    // This is sub-optimal as if there are other containers with the same
                    // old scope id we will re-render those too, but still better than context
                    storeState.notify(); // Given unsubscription is handled by useSyncExternalStore, we have no control on when
                    // React decides to do it. So we schedule on next tick to run last
                    Promise.resolve().then(()=>{
                        var _registry$getStore;
                        if (!storeState.listeners().size && // ensure registry has not already created a new store with same scope
                        storeState === ((_registry$getStore = registry.getStore(Store, scope, null)) == null ? void 0 : _registry$getStore.storeState)) {
                            handlers.onDestroy == null || handlers.onDestroy(); // We only delete scoped stores, as global shall persist and local are auto-deleted
                            if (scope) registry.deleteStore(Store, scope);
                        }
                    });
                }); // no need to reset containedStores as the map is already bound to scope
            };
        }, [
            registry,
            scope,
            containedStores
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $cOw7m.Context).Provider, {
            value: api
        }, children);
    }
    FunctionContainer.displayName = displayName || `Container`;
    FunctionContainer.propTypes = {
        children: (0, (/*@__PURE__*/$parcel$interopDefault($4J1z5))).node,
        scope: (0, (/*@__PURE__*/$parcel$interopDefault($4J1z5))).string,
        isGlobal: (0, (/*@__PURE__*/$parcel$interopDefault($4J1z5))).bool
    };
    return FunctionContainer;
}

});

parcelRegister("9998h", function(module, exports) {

$parcel$export(module.exports, "updateUnitCount", function () { return $915f730404a47a0a$export$753383981d56a121; });
$parcel$export(module.exports, "updateBillingCycle", function () { return $915f730404a47a0a$export$ea0e718cff6511cb; });
$parcel$export(module.exports, "updatePriceCalcs", function () { return $915f730404a47a0a$export$55173bfd96ab1f01; });
$parcel$export(module.exports, "updateCurrencyISOCode", function () { return $915f730404a47a0a$export$c376e0e2eb868782; });
const $915f730404a47a0a$export$753383981d56a121 = (unitCount)=>({ setState: setState })=>{
        setState({
            unitCount: unitCount
        });
    };
const $915f730404a47a0a$export$ea0e718cff6511cb = (billingCycle)=>({ setState: setState })=>{
        setState({
            billingCycle: billingCycle
        });
    };
const $915f730404a47a0a$export$55173bfd96ab1f01 = (priceCalcs)=>({ setState: setState })=>{
        setState({
            priceCalcs: priceCalcs
        });
    };
const $915f730404a47a0a$export$c376e0e2eb868782 = (currencyISOCode)=>({ setState: setState })=>{
        setState({
            currencyISOCode: currencyISOCode
        });
    };

});


parcelRegister("6d3jZ", function(module, exports) {

$parcel$export(module.exports, "BilledAnnuallyButton", function () { return $89b157f92501b840$export$ae3c75f0e47b71cc; });
/* billed-annually-button.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");
const $89b157f92501b840$export$ae3c75f0e47b71cc = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("button", {
        type: "button",
        onClick: props.onClick,
        tabIndex: 0,
        "data-event-component": "linkButton",
        "data-event": "clicked",
        className: (0, $esG4f.default)([
            "_bfhk1j28 _19itidpf _80omtlke _syazoelr _ect41kw7 _1wyb1kw7 _vwz4idpf _19pkidpf _2hwxyh40 _otyridpf _18u0yh40 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _4bfu1r31 _1hms8stv _ajmmnqa1 _o5721q9c _30l3u7gi"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "Pricing.card.body.enterprise.billedAnnually",
            defaultMessage: "Billed annually."
        })
    });
};

});

parcelRegister("2Hi3h", function(module, exports) {

$parcel$export(module.exports, "UserTier", function () { return $3a5375e26259cbe1$export$cd4f9ca719669f8d; });
/* user-tier.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $3JY7P = parcelRequire("3JY7P");

var $3FBn4 = parcelRequire("3FBn4");

var $g0OBC = parcelRequire("g0OBC");
const $3a5375e26259cbe1$var$userTierContainerStyles = null;
const $3a5375e26259cbe1$var$userTierMessageStyles = null;
const $3a5375e26259cbe1$var$toolTipContainerStyles = null;
const $3a5375e26259cbe1$export$cd4f9ca719669f8d = ({ priceCalc: priceCalc })=>{
    const { formattedBreakdown: formattedBreakdown } = priceCalc;
    const [{ messages: messages }] = (0, $g0OBC.usePriceFinderStore)();
    const fmtBreakdownTier = formattedBreakdown[formattedBreakdown.length - 1];
    if (!fmtBreakdownTier) throw new Error("No breakdown provided for user tier.");
    const { formattedUnitLimitLower: formattedUnitLimitLower, formattedUnitLimitUpper: formattedUnitLimitUpper, formattedUnitsInTier: formattedUnitsInTier, formattedUnitsAvailableInTier: formattedUnitsAvailableInTier } = fmtBreakdownTier;
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    const tooltipAriaLabel = formatMessage({
        id: "Pricing.PriceCard.UserTier.MoreInformationAboutTier",
        defaultMessage: "More information about tier"
    });
    const filledSeatsMessage = formatMessage({
        id: "Pricing.PriceCard.UserTier.Details",
        defaultMessage: "Filled seats"
    });
    const availableSeatsMessage = formatMessage({
        id: "Pricing.PriceCard.UserTier.AvailableSeats",
        defaultMessage: "Available seats"
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _zulp1y44"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1wybdlk8"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $6iHNw._)((0, $7Knp0._)({}, messages.cardUnitCountTierRange), {
                        values: (0, $6iHNw._)((0, $7Knp0._)({}, (0, $3FBn4.DEFAULT_VALUES)), {
                            lowerLimit: formattedUnitLimitLower,
                            upperLimit: formattedUnitLimitUpper
                        })
                    }))
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $3JY7P.Tooltip), {
                ariaLabel: tooltipAriaLabel,
                buttonSize: "small",
                content: `Tier:
                    ${formattedUnitLimitLower} -${" "}${formattedUnitLimitUpper}

                    ${filledSeatsMessage}:
                    ${formattedUnitsInTier}

                    ${availableSeatsMessage}:
                    ${formattedUnitsAvailableInTier}`
            })
        ]
    });
};

});


parcelRegister("1u7RU", function(module, exports) {

$parcel$export(module.exports, "useStickyCtaContext", function () { return $30068087a545b2f1$export$d07c74b192781870; });
$parcel$export(module.exports, "StickyCTAContextProvider", function () { return $30068087a545b2f1$export$6177378b3c0dfa99; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
const $30068087a545b2f1$var$StickyCtaContext = /*#__PURE__*/ (0, $iSvIT.createContext)(undefined);
const $30068087a545b2f1$export$d07c74b192781870 = ()=>{
    const context = (0, $iSvIT.useContext)($30068087a545b2f1$var$StickyCtaContext);
    if (!context) return {
        isSticky: false
    };
    return context;
};
const $30068087a545b2f1$export$6177378b3c0dfa99 = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)($30068087a545b2f1$var$StickyCtaContext.Provider, {
        value: props,
        children: props.children
    });
};

});


parcelRegister("9h2sd", function(module, exports) {

$parcel$export(module.exports, "CtaButton", function () { return $c4ae49f53d21ca2b$export$87cbfb14b50d331c; });
/* cta-button.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $g9kzu = parcelRequire("g9kzu");
parcelRequire("1Z9Q6");
var $91nJf = parcelRequire("91nJf");

var $f0Hih = parcelRequire("f0Hih");

var $hg1tq = parcelRequire("hg1tq");

var $1u7RU = parcelRequire("1u7RU");
const $c4ae49f53d21ca2b$var$ctaButtonStyles = null;
const $c4ae49f53d21ca2b$export$87cbfb14b50d331c = (_param)=>{
    var { edition: edition, dataProductKey: dataProductKey, text: text, type: type, url: url, dataEventPropsLabel: dataEventPropsLabel, containerId: containerId, isDisabled: isDisabled } = _param, props = (0, $akGnX._)(_param, [
        "edition",
        "dataProductKey",
        "text",
        "type",
        "url",
        "dataEventPropsLabel",
        "containerId",
        "isDisabled"
    ]);
    const stickyHeaderCtaEventHandlers = $c4ae49f53d21ca2b$export$dd3256f57101d933({
        edition: edition,
        containerId: containerId,
        productKey: dataProductKey
    });
    const envSpecificURL = (0, $hg1tq.getEnvironment)(true) === "staging" ? url.replace(/https:\/\/(www.)?atlassian.com/, "https://wac.stg.internal.atlassian.com") : url;
    const handleClick = ()=>{
        var _props_onClick;
        stickyHeaderCtaEventHandlers.onClick(); // @ts-ignore
        (_props_onClick = props.onClick) === null || _props_onClick === void 0 ? void 0 : _props_onClick.call(props);
    };
    const handleKeyDown = (e)=>{
        var _props_onKeyDown;
        stickyHeaderCtaEventHandlers.onKeyDown(e); // @ts-ignore
        (_props_onKeyDown = props.onKeyDown) === null || _props_onKeyDown === void 0 ? void 0 : _props_onKeyDown.call(props, e);
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $f0Hih.default), {
        intentType: "button",
        containerId: containerId,
        productKey: dataProductKey,
        edition: edition,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), (0, $6iHNw._)((0, $7Knp0._)({
            isDisabled: isDisabled,
            variant: type,
            color: "black",
            href: envSpecificURL,
            dataEventProps: {
                "data-product-key": dataProductKey,
                "data-event-component": "linkButton",
                "data-event-container": "priceBlock",
                "data-event": "clicked",
                "data-label": `${dataEventPropsLabel}`,
                "data-label-english": `${dataEventPropsLabel}`
            }
        }, props), {
            onClick: handleClick,
            onKeyDown: handleKeyDown,
            className: (0, $esG4f.default)([
                "_11c88q0o _1wyb7vkz _k48p1nn1 _vwz4gktf _4t3i1wug _4bfu1r31 _1hmsglyw _ajmmnqa1 _1bsb1ns9 _o5724jg8 _1q51ftgi _85i5ftgi"
            ]),
            children: text
        }))
    });
};
function $c4ae49f53d21ca2b$export$dd3256f57101d933(props) {
    const { edition: edition, productKey: productKey, containerId: containerId } = props;
    const { isSticky: isSticky } = (0, $1u7RU.useStickyCtaContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const payload = {
        eventType: "ui",
        action: "clicked",
        actionSubject: "linkButton",
        containerId: containerId,
        actionSubjectId: "pricingPlanCta",
        attributes: {
            productKey: productKey,
            edition: edition,
            isSticky: isSticky
        }
    };
    const onClick = ()=>{
        createAnalyticsEvent(payload).fire();
    };
    const onKeyDown = (e)=>{
        if (e.code !== "Tab" && e.code !== "Enter" && e.code !== "Space") createAnalyticsEvent(payload).fire();
    };
    return {
        onClick: onClick,
        onKeyDown: onKeyDown
    };
}

});


parcelRegister("7OWgU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $99cc735217ed1c2b$export$2e2bcd8739ae039; });
/* price-finder.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $c1VRy = parcelRequire("c1VRy");

var $l9lQF = parcelRequire("l9lQF");

var $8rqVU = parcelRequire("8rqVU");

var $9Cnr8 = parcelRequire("9Cnr8");

var $7mfju = parcelRequire("7mfju");

var $8M4vy = parcelRequire("8M4vy");

var $b2lKf = parcelRequire("b2lKf");

var $g0OBC = parcelRequire("g0OBC");

var $c3Aax = parcelRequire("c3Aax");

var $XAEGR = parcelRequire("XAEGR");
const $99cc735217ed1c2b$export$2b19a4f5a8b03e05 = ({ hamsProductKey: hamsProductKey = "", signupURL: signupURL = (0, $7mfju.SIGNUP_CTA_URL), ccpPricingData: ccpPricingData, hamsPricingData: hamsPricingData, countryCode: countryCode = (0, $7mfju.DEFAULT_COUNTRY_ISO_CODE), localeISOCode: localeISOCode = "en-US", messages: messages })=>{
    const { productPlans: productPlans, defaultUnitCount: defaultUnitCount, enterpriseMinimumCount: enterpriseMinimumCount = (0, $7mfju.DefaultPlanLimits).UNIT_MIN_ENTERPRISE, contactURL: contactURL = (0, $7mfju.CONTACT_CTA_URL) } = (0, $l9lQF.usePriceFinderContext)();
    const currencyISOCode = (0, $9Cnr8.COUNTRY_CODE_TO_CURRENCY)[countryCode] || (0, $7mfju.DEFAULT_CURRENCY_ISO_CODE);
    const initialFetchPriceCalcs = (0, $c3Aax.usePriceFinderRequests)(hamsProductKey, productPlans, enterpriseMinimumCount, defaultUnitCount, "MONTHLY");
    const initialPriceCalcs = (0, $c3Aax.usePricing)(ccpPricingData, hamsPricingData, initialFetchPriceCalcs, currencyISOCode, localeISOCode);
    const initialState = {
        unitCount: defaultUnitCount,
        billingCycle: "MONTHLY",
        priceCalcs: initialPriceCalcs,
        currencyISOCode: currencyISOCode,
        messages: messages
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $g0OBC.PriceFinderContainer), (0, $6iHNw._)((0, $7Knp0._)({}, initialState), {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_1bsb1osq"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $b2lKf.PriceFinderInputsRedesign), {}),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $8M4vy.PriceCardsContainer), {
                    productKey: hamsProductKey,
                    signupURL: signupURL,
                    contactURL: contactURL,
                    hamsProductKey: hamsProductKey,
                    hamsPricingData: hamsPricingData,
                    ccpPricingData: ccpPricingData,
                    localeISOCode: localeISOCode
                })
            ]
        })
    }));
};
const $99cc735217ed1c2b$var$PriceFinderWithFetch = ({ envSource: envSource, hamsProductKey: hamsProductKey = "", messages: messages, contentfulEnvironment: contentfulEnvironment })=>{
    const { dataProductKey: dataProductKey, productPlans: productPlans } = (0, $l9lQF.usePriceFinderContext)();
    const offeringSkus = productPlans.map((plan)=>{
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return plan.offeringSku;
    }).filter(Boolean);
    const { prices: prices, status: status, fetchData: fetchData } = (0, $8rqVU.useCCPPriceFinderData)(offeringSkus, envSource["PRODUCT_CATALOG_DELIVERY_KEY"], envSource["PRODUCT_CATALOG_SPACE"], contentfulEnvironment);
    (0, $iSvIT.useEffect)(()=>{
        fetchData();
    }, []);
    const { prices: hamsPrices, status: hamsStatus } = (0, $8rqVU.useHAMSPriceData)(hamsProductKey, envSource["PRODUCT_CATALOG_DELIVERY_KEY"], envSource["PRODUCT_CATALOG_SPACE"], contentfulEnvironment);
    const { countryCode: countryCode, status: locationStatus } = (0, $9Cnr8.useGeoLocation)(envSource["PRODUCT_CATALOG_LOCATION_BASE_URL"]);
    let forceCountryCode = countryCode;
    if (dataProductKey === "bitbucket") forceCountryCode = (0, $7mfju.DEFAULT_COUNTRY_ISO_CODE);
    if (locationStatus == "complete" && status == "complete" && hamsStatus == "complete" && prices && hamsPrices && forceCountryCode) return /*#__PURE__*/ (0, $loA2J.jsx)($99cc735217ed1c2b$export$2b19a4f5a8b03e05, {
        ccpPricingData: prices,
        hamsPricingData: hamsPrices,
        hamsProductKey: hamsProductKey,
        messages: messages,
        countryCode: forceCountryCode
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _1bah1h6o _4t3i5o3v _4cvr1h6o"
        ]),
        children: (0, $c1VRy.LoadingSpinner)
    });
};
const $99cc735217ed1c2b$var$PriceFinderSection = ({ hamsProductKey: hamsProductKey, serverSideCCPPricing: serverSideCCPPricing, serverSideHAMSPricing: serverSideHAMSPricing, countryCode: countryCode, messages: messages, contentfulEnvironment: contentfulEnvironment })=>{
    if (serverSideCCPPricing && serverSideHAMSPricing && countryCode) return /*#__PURE__*/ (0, $loA2J.jsx)($99cc735217ed1c2b$export$2b19a4f5a8b03e05, {
        ccpPricingData: serverSideCCPPricing,
        hamsPricingData: serverSideHAMSPricing,
        hamsProductKey: hamsProductKey,
        countryCode: countryCode,
        messages: messages
    });
     // server-side request failed
    if (typeof window !== "undefined") // client side render
    return /*#__PURE__*/ (0, $loA2J.jsx)($99cc735217ed1c2b$var$PriceFinderWithFetch, {
        hamsProductKey: hamsProductKey,
        messages: messages,
        envSource: window,
        contentfulEnvironment: contentfulEnvironment
    });
     // server side render
    return /*#__PURE__*/ (0, $loA2J.jsx)($99cc735217ed1c2b$var$PriceFinderWithFetch, {
        hamsProductKey: hamsProductKey,
        envSource: $XAEGR.env,
        messages: messages,
        contentfulEnvironment: contentfulEnvironment
    });
};
var $99cc735217ed1c2b$export$2e2bcd8739ae039 = $99cc735217ed1c2b$var$PriceFinderSection;

});
parcelRegister("8M4vy", function(module, exports) {

$parcel$export(module.exports, "PriceCardsContainer", function () { return $c4ed3e600bb18096$export$631362d6f0b0bcb9; });
/* card-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");
parcelRequire("1Z9Q6");
var $aYj4m = parcelRequire("aYj4m");

var $dT5kE = parcelRequire("dT5kE");

var $3FBn4 = parcelRequire("3FBn4");

var $hrScA = parcelRequire("hrScA");

var $fvAxO = parcelRequire("fvAxO");

var $7mfju = parcelRequire("7mfju");

var $l9lQF = parcelRequire("l9lQF");

var $g0OBC = parcelRequire("g0OBC");

var $c3Aax = parcelRequire("c3Aax");

var $lrAJa = parcelRequire("lrAJa");

var $2a2fv = parcelRequire("2a2fv");
parcelRequire("gPkR0");
var $9h2sd = parcelRequire("9h2sd");
var $7eBVv = parcelRequire("7eBVv");
const $c4ed3e600bb18096$export$6d3386d43155b5be = {
    display: "flex",
    flexDirection: "column",
    flexGrow: "1",
    justifyContent: "center",
    lineHeight: "24px"
};
const $c4ed3e600bb18096$export$631362d6f0b0bcb9 = ({ productKey: productKey, signupURL: signupURL, contactURL: contactURL, hamsProductKey: hamsProductKey, hamsPricingData: hamsPricingData, ccpPricingData: ccpPricingData, localeISOCode: localeISOCode })=>{
    var _productPlans__planFeatureMessages, _productPlans_;
    const intl = (0, $f6qj2.default)();
    let forcedUsdPricing = undefined;
    const { dataProductKey: dataProductKey, productPlans: productPlans, enterpriseMinimumCount: enterpriseMinimumCount = (0, $7mfju.DefaultPlanLimits).UNIT_MIN_ENTERPRISE } = (0, $l9lQF.usePriceFinderContext)();
    const [{ unitCount: unitCount, billingCycle: billingCycle, currencyISOCode: currencyISOCode }, actions] = (0, $g0OBC.usePriceFinderStore)();
    const recommendedPlanName = $c4ed3e600bb18096$export$623a082ce2e33ce1(unitCount, productPlans);
    const fetchPriceCalcs = (0, $c3Aax.usePriceFinderRequests)(hamsProductKey, productPlans, enterpriseMinimumCount, unitCount, billingCycle);
    if (dataProductKey === "trello") forcedUsdPricing = "USD";
    const finalPriceCalcs = (0, $c3Aax.usePricing)(ccpPricingData, hamsPricingData, fetchPriceCalcs, forcedUsdPricing || currencyISOCode, localeISOCode);
    (0, $iSvIT.useEffect)(()=>{
        actions.updatePriceCalcs(finalPriceCalcs); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        unitCount,
        billingCycle,
        currencyISOCode
    ]);
    const localizedSignupURL = (0, $3FBn4.useLocalizedHref)(signupURL);
    const localizedContactURL = (0, $3FBn4.useLocalizedHref)(contactURL);
    const ctaButtonText = intl.formatMessage({
        id: "Pricing.PriceCard.StartFreeTrial",
        defaultMessage: (0, $7mfju.CtaBtnText).START_FREE_TRIAL
    });
    const getProductPlanProps = (params)=>({
            idx: params.idx,
            productPlan: params.productPlan,
            dataProductKey: dataProductKey,
            recommendedPlanName: recommendedPlanName,
            unitCount: unitCount,
            ctaButtonText: ctaButtonText,
            localizedSignupURL: localizedSignupURL,
            localizedContactURL: localizedContactURL,
            billingCycle: billingCycle,
            currencyISOCode: currencyISOCode,
            productKey: productKey,
            ccpPricingData: ccpPricingData
        });
    const hasFeatures = (_productPlans_ = productPlans[0]) === null || _productPlans_ === void 0 ? void 0 : (_productPlans__planFeatureMessages = _productPlans_.planFeatureMessages) === null || _productPlans__planFeatureMessages === void 0 ? void 0 : _productPlans__planFeatureMessages.length;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _1bah1h6o _1bsb1osq"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $aYj4m.PriceCardsStack), {
            sections: hasFeatures ? 2 : 1,
            children: productPlans.map((productPlan, idx)=>/*#__PURE__*/ (0, $loA2J.jsx)($c4ed3e600bb18096$var$ProductPlanPriceCard, (0, $7Knp0._)({}, getProductPlanProps({
                    idx: idx,
                    productPlan: productPlan
                })), productPlan.planName))
        })
    });
};
const $c4ed3e600bb18096$var$ProductPlanPriceCard = (props)=>{
    var _offeringSku_toLowerCase_match, _productPlan_signupURLInfo, _productPlans_;
    const intl = (0, $f6qj2.default)();
    const contactSalesText = intl.formatMessage({
        id: "Pricing.PriceCard.ContactSales",
        defaultMessage: (0, $7mfju.CtaBtnText).CONTACT_SALES
    });
    const { productPlan: productPlan, idx: idx, dataProductKey: dataProductKey, recommendedPlanName: recommendedPlanName, unitCount: unitCount, ctaButtonText: ctaButtonText, localizedSignupURL: localizedSignupURL, localizedContactURL: localizedContactURL, billingCycle: billingCycle, currencyISOCode: currencyISOCode, productKey: productKey, ccpPricingData: ccpPricingData } = props;
    const { productPlans: productPlans, shouldAddDiscount: shouldAddDiscount, shouldAddBuyNow: shouldAddBuyNow, ctaUrlSource: ctaUrlSource } = (0, $l9lQF.usePriceFinderContext)();
    const getComparePlanCta = (0, $dT5kE.useGetComparePlanCta)();
    const { signupURLSuffix: signupURLSuffix, planFeatureMessages: planFeatureMessages, description: description, signupLimit: signupLimit, offeringSku: offeringSku } = productPlan;
    const { planTitleComponent: planTitleComponent } = productPlan;
    let { planName: planName } = productPlan;
    let edition = offeringSku === null || offeringSku === void 0 ? void 0 : (_offeringSku_toLowerCase_match = offeringSku.toLowerCase().match(/free|standard|premium|enterprise/)) === null || _offeringSku_toLowerCase_match === void 0 ? void 0 : _offeringSku_toLowerCase_match[0];
    const isHighlighted = planName === recommendedPlanName || productPlans.length === 1;
    let dataEventPropsLabel = `${planName}-start-trial`;
    let ctaBtnText = ctaButtonText;
    let ctaBtnUrl = "";
    let rovoStartTrialUrl = "";
    var _productPlan_signupURLInfo_urlPath;
    const localizedUrlPath = (0, $3FBn4.useLocalizedHref)((_productPlan_signupURLInfo_urlPath = (_productPlan_signupURLInfo = productPlan.signupURLInfo) === null || _productPlan_signupURLInfo === void 0 ? void 0 : _productPlan_signupURLInfo.urlPath) !== null && _productPlan_signupURLInfo_urlPath !== void 0 ? _productPlan_signupURLInfo_urlPath : "");
    if (productPlan.signupURLInfo) {
        const { shouldLocalize: shouldLocalize, urlDomain: urlDomain, urlPath: urlPath } = productPlan.signupURLInfo;
        if (shouldLocalize) {
            ctaBtnUrl = `${urlDomain}${localizedUrlPath}`;
            rovoStartTrialUrl = `${urlDomain}${localizedUrlPath}`;
        } else {
            ctaBtnUrl = `${urlDomain}${urlPath}`;
            rovoStartTrialUrl = `${urlDomain}${urlPath}`;
        }
    } else ctaBtnUrl = localizedSignupURL + (signupURLSuffix || "");
    const overSignupLimit = unitCount > (signupLimit || (0, $7mfju.DefaultPlanLimits).UNIT_LIMIT);
    if (offeringSku === (0, $7mfju.CloudOfferingsWithSkus).rovo || dataProductKey === "rovo") {
        planName = "Rovo";
        if (unitCount > 1000) {
            ctaBtnUrl = localizedContactURL;
            ctaBtnText = contactSalesText;
        }
    }
    const { renderDirectBuyBtn: renderDirectBuyBtn } = (0, $lrAJa.useDirectBuyExperiment)(billingCycle, offeringSku, shouldAddBuyNow);
    const { pricingPlanId: pricingPlanId } = (0, $2a2fv.usePricingPlan)(!renderDirectBuyBtn, offeringSku !== null && offeringSku !== void 0 ? offeringSku : "", currencyISOCode, edition !== null && edition !== void 0 ? edition : "", billingCycle, ccpPricingData);
    const jpdPremiumUrl = `https://www.atlassian.com/software/jira/product-discovery/premium`;
    if (offeringSku === "jira-product-discovery-premium-sku" && !(0, $hrScA.checkFeatureFlagGate)((0, $fvAxO.featureFlags).jiraProductDiscoveryPremiumWacUpdates)) {
        ctaBtnUrl = jpdPremiumUrl;
        ctaBtnText = (0, $7mfju.CtaBtnText).JOIN_WAITLIST;
    }
    if (dataProductKey === "trello") ctaBtnUrl = (0, $7mfju.TRELLO_CTA_URL);
    switch(planName){
        case (0, $7mfju.SpecialPlanNames).STARTER:
        case (0, $7mfju.SpecialPlanNames).FREE:
            edition = (0, $7mfju.Edition).FREE;
            dataEventPropsLabel = `${planName}-get-it-now`;
            ctaBtnText = intl.formatMessage({
                id: "Pricing.PriceCard.GetItNow",
                defaultMessage: (0, $7mfju.CtaBtnText).GET_IT_NOW
            });
            break;
        case (0, $7mfju.SpecialPlanNames).ENTERPRISE:
            edition = (0, $7mfju.Edition).ENTERPRISE;
            dataEventPropsLabel = `${planName}-contact-sales`;
            ctaBtnText = contactSalesText;
            ctaBtnUrl = productPlan.signupURLInfo ? ctaBtnUrl : localizedContactURL;
            break;
    }
    const shouldDisableCta = overSignupLimit && planName !== (0, $7mfju.SpecialPlanNames).FREE && planName !== (0, $7mfju.SpecialPlanNames).ENTERPRISE;
    const planTitleId = `planTitle_${idx}`;
    const planDescriptionId = `planDesc_${idx}`;
    const ctaId = `planCta_${idx}`;
    const ctaAriaLabelledBy = `${planTitleId} ${planDescriptionId} ${ctaId}`;
    const contentfulCta = getComparePlanCta({
        comparePlanIdx: idx
    });
    let ctaButtonUrl = ctaBtnUrl;
    if ((contentfulCta === null || contentfulCta === void 0 ? void 0 : contentfulCta.ctaUrl) && ctaUrlSource !== "productPlans") ctaButtonUrl = contentfulCta.ctaUrl;
    var _contentfulCta_ctaButtonText;
    let ctaButton = /*#__PURE__*/ (0, $loA2J.jsx)((0, $9h2sd.CtaButton), {
        id: ctaId,
        edition: edition,
        dataProductKey: dataProductKey,
        type: isHighlighted ? "primary" : "secondary",
        text: (_contentfulCta_ctaButtonText = contentfulCta === null || contentfulCta === void 0 ? void 0 : contentfulCta.ctaButtonText) !== null && _contentfulCta_ctaButtonText !== void 0 ? _contentfulCta_ctaButtonText : ctaBtnText,
        dataEventPropsLabel: dataEventPropsLabel,
        url: ctaButtonUrl,
        isDisabled: shouldDisableCta,
        containerId: (0, $7mfju.PRICE_FINDER_CONTAINER),
        "aria-labelledby": ctaAriaLabelledBy
    });
    if (offeringSku === (0, $7mfju.CloudOfferingsWithSkus).rovo && unitCount > 1000) ctaButton = /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        "data-testid": "rovo-double-cta",
        className: (0, $esG4f.default)([
            "_1e0c1txw _zulp14y2"
        ]),
        children: [
            ctaButton,
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $9h2sd.CtaButton), {
                id: ctaId,
                edition: edition,
                dataProductKey: dataProductKey,
                type: "secondary",
                text: ctaButtonText,
                dataEventPropsLabel: dataEventPropsLabel,
                url: rovoStartTrialUrl,
                isDisabled: overSignupLimit,
                target: "_self",
                "aria-labelledby": ctaAriaLabelledBy,
                containerId: (0, $7mfju.PRICE_FINDER_CONTAINER)
            })
        ]
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $7eBVv.PriceCard), {
        planName: planName,
        planTitleComponent: planTitleComponent,
        description: description,
        highlighted: isHighlighted,
        ctaButton: ctaButton,
        planFeatureMessages: planFeatureMessages,
        adjacentLowerTierPlanName: (_productPlans_ = productPlans[idx - 1]) === null || _productPlans_ === void 0 ? void 0 : _productPlans_.planName,
        first: idx === 0,
        last: idx === productPlans.length - 1,
        billingCycle: billingCycle,
        overSignupLimit: overSignupLimit,
        currencyISOCode: currencyISOCode,
        unitCount: unitCount,
        productKey: productKey,
        priceCalcIdx: idx,
        contactURL: localizedContactURL,
        offeringSku: offeringSku,
        enableRecommendation: productPlans.length > 1,
        shouldAddDiscount: shouldAddDiscount,
        pricingPlanId: pricingPlanId,
        edition: edition,
        dataProductKey: dataProductKey
    }, idx);
};
const $c4ed3e600bb18096$var$getRecommendedPlanIdx = (unitCount, minUnitCounts)=>{
    const len = minUnitCounts.length - 1;
    return len - minUnitCounts.reverse().findIndex((minUnitCount)=>unitCount > minUnitCount);
};
const $c4ed3e600bb18096$export$623a082ce2e33ce1 = (unitCount, productPlans)=>{
    var _productPlans_recommendedPlanIdx;
    const recommendedPlanIdx = $c4ed3e600bb18096$var$getRecommendedPlanIdx(unitCount, productPlans.map((productPlan)=>productPlan.recommendationLimit));
    var _productPlans_recommendedPlanIdx_planName;
    return (_productPlans_recommendedPlanIdx_planName = (_productPlans_recommendedPlanIdx = productPlans[recommendedPlanIdx]) === null || _productPlans_recommendedPlanIdx === void 0 ? void 0 : _productPlans_recommendedPlanIdx.planName) !== null && _productPlans_recommendedPlanIdx_planName !== void 0 ? _productPlans_recommendedPlanIdx_planName : "";
};

});
parcelRegister("2a2fv", function(module, exports) {

$parcel$export(module.exports, "usePricingPlan", function () { return $108a8c55e3c2e759$export$c0ff57beb09fa9bf; });
const $108a8c55e3c2e759$export$c0ff57beb09fa9bf = (skip, offeringSku, currencyISOCode, edition, billingCycle, ccpPricingData)=>{
    var _ccpPricingData_offeringSku_toLowerCase_defaultPricingPlans, _ccpPricingData_offeringSku_toLowerCase;
    if (skip) return {
        pricingPlanId: ""
    };
    const defaultPricingPlan = (_ccpPricingData_offeringSku_toLowerCase = ccpPricingData[offeringSku.toLowerCase()]) === null || _ccpPricingData_offeringSku_toLowerCase === void 0 ? void 0 : (_ccpPricingData_offeringSku_toLowerCase_defaultPricingPlans = _ccpPricingData_offeringSku_toLowerCase.defaultPricingPlans) === null || _ccpPricingData_offeringSku_toLowerCase_defaultPricingPlans === void 0 ? void 0 : _ccpPricingData_offeringSku_toLowerCase_defaultPricingPlans.filter((item)=>item.currency.toLowerCase() == currencyISOCode.toLowerCase() && item.offeringName.toLowerCase() == edition.toLowerCase() && item.primaryCycle_name.toLowerCase() == billingCycle.toLowerCase() && item.status.toLowerCase() == "active");
    const lastPricingPlan = defaultPricingPlan === null || defaultPricingPlan === void 0 ? void 0 : defaultPricingPlan[defaultPricingPlan.length - 1];
    return {
        pricingPlanId: (lastPricingPlan === null || lastPricingPlan === void 0 ? void 0 : lastPricingPlan.id) || ""
    };
};

});


parcelRegister("b2lKf", function(module, exports) {

$parcel$export(module.exports, "PriceFinderInputsRedesign", function () { return $01f28888d7d5f299$export$f72c1ba1733c641a; });
/* price-finder-inputs-redesign.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");

var $g9kzu = parcelRequire("g9kzu");

var $8xSOc = parcelRequire("8xSOc");

var $l9lQF = parcelRequire("l9lQF");

var $5ohHq = parcelRequire("5ohHq");

var $7mfju = parcelRequire("7mfju");

var $11puL = parcelRequire("11puL");

var $g0OBC = parcelRequire("g0OBC");
const $01f28888d7d5f299$var$labelStyles = null;
const $01f28888d7d5f299$var$legendStyles = null;
const $01f28888d7d5f299$var$inputTermStyle = null;
const $01f28888d7d5f299$var$radioLabelStyles = null;
const $01f28888d7d5f299$var$radioStyles = null;
const $01f28888d7d5f299$var$discountLozengeStyles = null;
const $01f28888d7d5f299$var$billMeStyles = null;
const $01f28888d7d5f299$export$f72c1ba1733c641a = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const [{ unitCount: unitCount, billingCycle: billingCycle, messages: messages }, actions] = (0, $g0OBC.usePriceFinderStore)();
    const { isMonthlyBillingOnly: isMonthlyBillingOnly, isAnnualBillingOnly: isAnnualBillingOnly, dataProductKey: dataProductKey } = (0, $l9lQF.usePriceFinderContext)();
    (0, $iSvIT.useEffect)(()=>{
        if (isAnnualBillingOnly) actions.updateBillingCycle("ANNUAL");
    }, []);
    const { isVariation: isDirectBuyExperimentVariation } = (0, $11puL.useDirectBuyCohort)(dataProductKey);
    const [visualUnitCount, setVisualUnitCount] = (0, $iSvIT.useState)(unitCount);
    (0, $iSvIT.useEffect)(()=>{
        if (visualUnitCount !== "" && visualUnitCount > 0 && !Number.isNaN(visualUnitCount)) actions.updateUnitCount(visualUnitCount);
    }, [
        visualUnitCount,
        actions
    ]);
    const handleUnitCountChange = (e)=>{
        const stringValue = e.target.value;
        if (stringValue === "") return setVisualUnitCount(""); // validate max number of digits
        // default is 5
        // TODO: make this configurable
        if (stringValue.length > 6) return;
        const numberValue = parseInt(stringValue, 10);
        if (numberValue < 1) return;
        setVisualUnitCount(numberValue);
    };
    const handleUnitCountBlurChange = ()=>{
        if (visualUnitCount === "") setVisualUnitCount(unitCount);
        const data = {
            unitCount: unitCount,
            productKey: dataProductKey
        };
        createAnalyticsEvent({
            eventType: "ui",
            eventName: `${(0, $7mfju.TRACKING_EVENT_NAMES).unitTierBox}_blurred`,
            eventComponent: "input",
            event: "blurred",
            actionSubject: (0, $7mfju.TRACKING_EVENT_NAMES).unitTierBox,
            action: "blurred",
            attributes: data,
            data: data
        }).fire();
    };
    const handleRadioChange = (e)=>{
        const data = {
            billingCycle: e.target.id,
            productKey: dataProductKey
        };
        createAnalyticsEvent({
            eventType: "ui",
            eventName: (0, $7mfju.TRACKING_EVENT_NAMES).billingCycleChanged,
            eventComponent: "radioButton",
            event: "clicked",
            actionSubject: (0, $7mfju.TRACKING_EVENT_NAMES).billingCycleChanged,
            action: "clicked",
            attributes: data
        }).fire();
        actions.updateBillingCycle(e.target.id);
    };
    var _messages_unitCountInputDirectBuy;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12fogza"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_p12f1kdj _19pk1wug _2hwx1wug _otyr1wug _18u01wug _b8yq1osq _3wvkidpf _1fbnidpf _1uby1wug _1t0ridpf"
            ]),
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_p12f1kdj _6rth1tcg _181n1txw _b8yq1osq _e8gh1h6o _19wgys9h"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0c1txw _4cvr1h6o _181n1ule"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("label", {
                                htmlFor: "unit-count",
                                className: (0, $esG4f.default)([
                                    "_ect4bzd7 _1wyb1j6v _1dyznl7k _k48pni7l _o5721q9c",
                                    "_12l2ftgi _syaz1hlo"
                                ]),
                                style: {
                                    "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text")),
                                    "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                                },
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, isDirectBuyExperimentVariation ? (_messages_unitCountInputDirectBuy = messages.unitCountInputDirectBuy) !== null && _messages_unitCountInputDirectBuy !== void 0 ? _messages_unitCountInputDirectBuy : messages.unitCountInputTextRedesign : messages.unitCountInputTextRedesign))
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_ca0q7vkz _u5f3idpf _n3td7vkz _19bvidpf _1bah1h6o _4cvr1h6o _1bsb1ns9 _15flidpf _1d2widpf _1svyidpf _seovidpf _1akoidpf _c7s7idpf _4puvidpf _1r3vidpf _181n116y _1t19kb7n _p7vbkb7n _1rhgf1ug"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)("input", {
                                    id: "unit-count",
                                    type: "number",
                                    value: visualUnitCount,
                                    onChange: handleUnitCountChange,
                                    onBlur: handleUnitCountBlurChange,
                                    "data-event-component": "inputNumber",
                                    "data-event-container": "priceBlock",
                                    "data-event": "clicked",
                                    className: (0, $esG4f.default)([
                                        "_syazalr3 _k48p1nn1 _1wyb1j6v _vwz41tcg _12l214y2 _ca0qftgi _u5f3i2wt _n3tdftgi _19bvi2wt _1bsb8ved _2rko1y44 _bfhk1hxd _19itglyw _13di444r _jh1sglyw _ji0mglyw"
                                    ])
                                })
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("label", {
                                htmlFor: "unit-term",
                                className: (0, $esG4f.default)([
                                    "_syaz1mpp _ect4bzd7 _1wyb1j6v _1dyznl7k _k48p1nn1 _16jlkb7n _1o9zkb7n _i0dlf1ug"
                                ]),
                                style: {
                                    "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                                },
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, messages.unitCountInputTerm))
                            })
                        ]
                    }),
                    !isMonthlyBillingOnly && !isAnnualBillingOnly && /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("fieldset", {
                            "data-testid": "billing-inputs",
                            className: (0, $esG4f.default)([
                                "_1e0c1txw _4cvr1h6o _1n261g80 _zulp7vkz _19itglyw"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)("legend", {
                                    className: (0, $esG4f.default)([
                                        "_ect4bzd7 _1wyb1j6v _1dyznl7k _k48pni7l _o5721q9c",
                                        "_1aax1e5h"
                                    ]),
                                    style: {
                                        "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                                    },
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                        id: "Pricing.priceFinderInputs.billMeText",
                                        defaultMessage: "Bill me:"
                                    })
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsxs)("span", {
                                    className: (0, $esG4f.default)([
                                        "_4t3i1osq _1e0c1txw _zulp7vkz _wnej1g80"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $loA2J.jsxs)("label", {
                                            htmlFor: "MONTHLY",
                                            className: (0, $esG4f.default)([
                                                "_80omtlke _zulpftgi _1e0c1txw _4cvr1h6o"
                                            ]),
                                            children: [
                                                /*#__PURE__*/ (0, $loA2J.jsx)("input", {
                                                    type: "radio",
                                                    id: "MONTHLY",
                                                    "data-testid": "billing-radio-monthly",
                                                    name: "billing",
                                                    checked: billingCycle === "MONTHLY",
                                                    onChange: handleRadioChange,
                                                    className: (0, $esG4f.default)([
                                                        "_bfhki0pe _19it1pkj _2rko1ssb _80omtlke _1e0c1txw _1bsb1tcg _4t3i1tcg _19pkidpf _2hwxidpf _otyridpf _18u0idpf _kqswh2mm _4cvr1h6o _1bah1h6o _1o9zidpf _12ji1r31 _1qu2glyw _12y31o36 _t9ec1s1q _v564lstf _s7n4jp4b _r06hglyw _858ub0wy _1di64m1f _irr34m1f _z0ai1cbz _1qdg1cbz _18postnw _1hfki0pe _14mj1ssb _aetrb3bt _1peqidpf _qc5o16qv _h0k6rbzz _9e6urbzz _1q44oelr _dhyqkb7n _1jb3u67f _xqvjrbzz _ga64yh40 _sfejglyw _128ydlk8 _1199dlk8 _12gnrbzz _kl6cu67f _1htqn7od _1e7g1m1a"
                                                    ])
                                                }),
                                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                                    id: "Pricing.priceFinderInputs.monthly",
                                                    defaultMessage: "Monthly"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsxs)("span", {
                                            className: (0, $esG4f.default)([
                                                "_1e0c1txw _1n261q9c"
                                            ]),
                                            children: [
                                                /*#__PURE__*/ (0, $loA2J.jsxs)("label", {
                                                    htmlFor: "ANNUAL",
                                                    className: (0, $esG4f.default)([
                                                        "_80omtlke _zulpftgi _1e0c1txw _4cvr1h6o"
                                                    ]),
                                                    children: [
                                                        /*#__PURE__*/ (0, $loA2J.jsx)("input", {
                                                            type: "radio",
                                                            id: "ANNUAL",
                                                            "data-testid": "billing-radio-annual",
                                                            name: "billing",
                                                            checked: billingCycle === "ANNUAL",
                                                            onChange: handleRadioChange,
                                                            className: (0, $esG4f.default)([
                                                                "_bfhki0pe _19it1pkj _2rko1ssb _80omtlke _1e0c1txw _1bsb1tcg _4t3i1tcg _19pkidpf _2hwxidpf _otyridpf _18u0idpf _kqswh2mm _4cvr1h6o _1bah1h6o _1o9zidpf _12ji1r31 _1qu2glyw _12y31o36 _t9ec1s1q _v564lstf _s7n4jp4b _r06hglyw _858ub0wy _1di64m1f _irr34m1f _z0ai1cbz _1qdg1cbz _18postnw _1hfki0pe _14mj1ssb _aetrb3bt _1peqidpf _qc5o16qv _h0k6rbzz _9e6urbzz _1q44oelr _dhyqkb7n _1jb3u67f _xqvjrbzz _ga64yh40 _sfejglyw _128ydlk8 _1199dlk8 _12gnrbzz _kl6cu67f _1htqn7od _1e7g1m1a"
                                                            ])
                                                        }),
                                                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                                            id: "Pricing.priceFinderInputs.anually",
                                                            defaultMessage: "Annually"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                                    className: (0, $esG4f.default)([
                                                        "_1bsb1ns9 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _bozg1y44 _1p1dangw _1rkb1wdt _1rfm1osq _q5ugidpf _7tldidpf _14adidpf _4uroidpf _11cg1y44 _xsmrusic"
                                                    ]),
                                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8xSOc.default), {
                                                        appearance: "inprogress",
                                                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                                            id: "Pricing.priceFinderInputs.saveUpTo",
                                                            defaultMessage: "SAVE UP TO 17%"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};

});


parcelRegister("ceE90", function(module, exports) {

$parcel$export(module.exports, "PricingFaq", function () { return $71aff18d297bba2a$export$3c5f68183e9d00f8; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $enAt6 = parcelRequire("enAt6");

var $9XedM = parcelRequire("9XedM");
const $71aff18d297bba2a$export$3c5f68183e9d00f8 = ({ header: header, planDetails: planDetails })=>{
    const intl = (0, $f6qj2.default)();
    if (!planDetails) return null;
    const fallbackHeader = intl.formatMessage({
        id: "pricing.faq.header",
        defaultMessage: "Get more info"
    });
    const faqAccordionsFeatures = planDetails.map((item)=>{
        var _item_planAdditionalDetailsTitleExternal, _item_planAdditionalDetails;
        return {
            header: (_item_planAdditionalDetailsTitleExternal = item.planAdditionalDetailsTitleExternal) !== null && _item_planAdditionalDetailsTitleExternal !== void 0 ? _item_planAdditionalDetailsTitleExternal : "",
            content: (0, $9XedM.parseHtmlString)((_item_planAdditionalDetails = item.planAdditionalDetails) !== null && _item_planAdditionalDetails !== void 0 ? _item_planAdditionalDetails : undefined)
        };
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $enAt6.default), {
        header: header !== null && header !== void 0 ? header : fallbackHeader,
        features: faqAccordionsFeatures
    });
};
$71aff18d297bba2a$export$3c5f68183e9d00f8.displayName = "PricingFaq";

});
parcelRegister("enAt6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $36fc7653f9c9dfa7$export$2e2bcd8739ae039; });
/* index.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable @atlaskit/design-system/no-physical-properties */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
const $36fc7653f9c9dfa7$var$rowCss = null;
const $36fc7653f9c9dfa7$var$containerCss = null;
const $36fc7653f9c9dfa7$var$headerCss = null;
const $36fc7653f9c9dfa7$var$featureContainerCss = null;
const $36fc7653f9c9dfa7$var$fadeInAnimation = null;
const $36fc7653f9c9dfa7$var$featureContentCss = null;
const $36fc7653f9c9dfa7$var$showContentCss = null;
const $36fc7653f9c9dfa7$var$featureHeaderCss = null;
const $36fc7653f9c9dfa7$var$toggleIconCss = null; /**
                             * @deprecated - Please use @/libraries/design/components/accordion instead
                             */ 
const $36fc7653f9c9dfa7$var$FaqAccordions = ({ header: header, features: features })=>{
    const [expanded, setExpanded] = (0, $iSvIT.useState)({});
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        id: "faq",
        className: (0, $esG4f.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f1fra _1bsb1osq _j4or1wqb"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_19pkidpf _2hwx1wug _otyridpf _18u01wug _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _n3tdvbgk _1bsbf2ck _8fz61c5i _1hwcidpf _1s4p1osq _q5bceo28 _jjfo1osq"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                    className: (0, $esG4f.default)([
                        "_n7zld48f _syazqlpt _1wyb1ylp _k48p1fw0 _vwz4ckbl _1dyzidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0q1tcg _u5f37vkz _n3td1tcg _19bv7vkz _y3gn1h6o _so7d14no _19q1or1b _1v4mzwfg _1bl410mc"
                    ]),
                    children: header
                }),
                features.map((feature)=>/*#__PURE__*/ {
                    var _expanded_feature_header;
                    return (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_n7zld48f _ca0qidpf _u5f37vkz _n3tdidpf _19bv7vkz _xlob1h6o _cy6oglyw _szfsglyw _stfgidpf _d32vrbzz _4rtxtlke _dpd31txw _1jmq1tcg _1gflidpf _yhjmidpf _1gqnidpf _11lvidpf _14hp1osq _1d421ul9 _k6cg1ul9"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsxs)("button", {
                                "aria-expanded": (_expanded_feature_header = expanded[feature.header]) !== null && _expanded_feature_header !== void 0 ? _expanded_feature_header : false,
                                onClick: ()=>setExpanded((0, $6iHNw._)((0, $7Knp0._)({}, expanded), {
                                        [feature.header]: !expanded[feature.header]
                                    })),
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                                        className: (0, $esG4f.default)([
                                            "_syaz1bqd _16jlkb7n _1o9zkb7n _i0dlf1ug _1wyb1tcg _k48pbfng _1dyznl7k _vwz410nf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0q1tcg _u5f3idpf _n3td1tcg _19bvidpf _y3gn1e5h _1xrxrbzz _so7dqslr _gwdjgktf"
                                        ]),
                                        children: feature.header
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        className: (0, $esG4f.default)([
                                            "_bfhkrbzz _2rko1ssb _4t3i1tcg _v56488n5 _1bsb1tcg _wtqc14w8 _pmf41sub _ts4v19bv _49x519bv _1mf219bv _12h0b3bt _s971b3bt _229db3bt _1st5stnw _vuffstnw _kd02stnw _189bidpf _1owaidpf _1ypnidpf _umq4idpf _1d08idpf _3rqzidpf _3uxpidpf _pl8lidpf _2x6gidpf _1lzuidpf _e2u3idpf _1u95idpf _tmcvu67f _1696u67f _15g2u67f _aze81wug _8u7c1wug _19dq1wug _144j14y2 _iui614y2 _6v8s14y2 _1faz1wug _1ew01wug _3r7i1wug _1oz314y2 _18xc14y2 _u63c14y2 _1xlyyh40 _kotoyh40 _6zj4yh40 _6zj41wug _ornayh40 _19dq14y2 _6v8s1wug _3r7i14y2 _u63c1wug",
                                            expanded[feature.header] ? "minus" : "plus"
                                        ])
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_y44v1dy6 _1e0cglyw _2hwxvbgk _n3td1tcg _43dsrbzz _59381r31 _yha28stv _1nmznqa1 _oxk4oelr _rfqo1r31 _1bgkglyw _1t0pnqa1 _clfdidpf _11pqidpf _q0a51tcg _c3k8idpf",
                                    expanded[feature.header] && "_1e0c1ule"
                                ]),
                                children: feature.content
                            })
                        ]
                    }, feature.header);
                })
            ]
        })
    });
};
var $36fc7653f9c9dfa7$export$2e2bcd8739ae039 = $36fc7653f9c9dfa7$var$FaqAccordions;

});

parcelRegister("9XedM", function(module, exports) {

$parcel$export(module.exports, "parseHtmlString", function () { return $17d91c8bf7021d14$export$85d98c827c7edf42; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
const $17d91c8bf7021d14$var$sharedRichtextValues = {
    p: (chunks, key)=>/*#__PURE__*/ (0, $loA2J.jsx)("p", {
            children: chunks
        }, key),
    strong: (chunks, key)=>/*#__PURE__*/ (0, $loA2J.jsx)("strong", {
            children: chunks
        }, key),
    ul: (chunks, key)=>/*#__PURE__*/ (0, $loA2J.jsx)("ul", {
            children: chunks
        }, key),
    li: (chunks, key)=>/*#__PURE__*/ (0, $loA2J.jsx)("li", {
            children: chunks
        }, key),
    a: (chunks, key, href)=>/*#__PURE__*/ (0, $loA2J.jsx)("a", {
            href: href,
            children: chunks
        }, key),
    br: (_chunks, key)=>/*#__PURE__*/ (0, $loA2J.jsx)("br", {}, key)
};
const $17d91c8bf7021d14$var$convertToReact = (node, key)=>{
    if (node.nodeType === Node.TEXT_NODE) return node.textContent;
    if (node.nodeType === Node.ELEMENT_NODE) {
        const element = node;
        const tagName = element.tagName.toLowerCase();
        const children = Array.from(element.childNodes).map((child, index)=>$17d91c8bf7021d14$var$convertToReact(child, `${key}-${index}`));
        const renderFunction = $17d91c8bf7021d14$var$sharedRichtextValues[tagName];
        if (renderFunction) return renderFunction(children, key, element.getAttribute("href") || undefined);
        else return /*#__PURE__*/ (0, $iSvIT.createElement)(tagName, {
            key: key
        }, children);
    }
    return null;
};
const $17d91c8bf7021d14$export$85d98c827c7edf42 = (htmlString)=>{
    if (!htmlString) return null;
    if (typeof document === "undefined") return null;
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlString;
    return $17d91c8bf7021d14$var$convertToReact(tempDiv, "root");
};

});


parcelRegister("f8O3L", function(module, exports) {

$parcel$export(module.exports, "QuotationsAdornment", function () { return $db705668a5325ca0$export$41c85da8b12966cf; });
/* quotations.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $bhreu = parcelRequire("bhreu");
const $db705668a5325ca0$export$41c85da8b12966cf = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1bsb1osq _kqswh2mm"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                className: (0, $esG4f.default)([
                    "_kqswstnw _152t3sup _1e021c6i _1mjbglyw"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)($db705668a5325ca0$var$LeftQuotation, {})
            }),
            props.children,
            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                className: (0, $esG4f.default)([
                    "_kqswstnw _152tidpf _rjxpu4aj _1mjbglyw"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)($db705668a5325ca0$var$RightQuotation, {})
            })
        ]
    });
};
const $db705668a5325ca0$var$LeftQuotation = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/02m24o230o077mu3rxv7gm30nj77wqii.svg",
            alt: "Quotation left"
        }
    });
const $db705668a5325ca0$var$RightQuotation = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/50x33lwtmm1hnd8x717wk316dthyw741.svg",
            alt: "Quotation right"
        }
    });

});

parcelRegister("j1oGG", function(module, exports) {
$parcel$export(module.exports, "PricingPageLayout", function () { return (parcelRequire("2rhwG")).PricingPageLayout; });
$parcel$export(module.exports, "PageHeading", function () { return (parcelRequire("3iTNH")).PageHeading; });
parcelRequire("2rhwG");
parcelRequire("3iTNH");

});
parcelRegister("2rhwG", function(module, exports) {

$parcel$export(module.exports, "PricingPageLayout", function () { return $c88d651e0553cc06$export$179602f42864b2b8; });
/* pricing-page-layout.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $kex29 = parcelRequire("kex29");

var $6YSqr = parcelRequire("6YSqr");
const $c88d651e0553cc06$export$179602f42864b2b8 = ({ nav: nav, banner: banner, hero: hero, bgColor: bgColor, hasGlobalFooter: hasGlobalFooter = true, showFallback: showFallback = false, children: children })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            nav && nav,
            !showFallback && banner,
            !showFallback && hero,
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                style: {
                    background: bgColor
                },
                className: (0, $esG4f.default)([
                    "_1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o _1q51vbgk _85i5vbgk _xc2ickbl _1u2qzwfg"
                ]),
                children: [
                    showFallback && /*#__PURE__*/ (0, $loA2J.jsx)((0, $6YSqr.PricingPageFallback), {}),
                    !showFallback && children && /*#__PURE__*/ (0, $loA2J.jsx)("main", {
                        id: "content",
                        className: (0, $esG4f.default)([
                            "_1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o _zulpvbgk _p12ftfvk _1bsbaq80 _vqct1h22 _1wfq1ul9 _15vt1ul9 _v7361wqb _chtu1wqb _8164ckbl _63vr1vh9 _1tbz1ul9 _68811ul9"
                        ]),
                        children: children
                    })
                ]
            }),
            hasGlobalFooter && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1pfhvbgk _476dckbl"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $kex29.GlobalFooter), {})
            })
        ]
    });
};
const $c88d651e0553cc06$var$footerCss = null;
const $c88d651e0553cc06$var$pricingPageLayoutOuterCss = null;
const $c88d651e0553cc06$var$pricingPageLayoutInnerCss = null;

});
parcelRegister("6YSqr", function(module, exports) {

$parcel$export(module.exports, "PricingPageFallback", function () { return $59dac0fc8356e419$export$54fc8f6b9874893e; });
/* pricing-page-fallback.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");
const $59dac0fc8356e419$export$54fc8f6b9874893e = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_4t3idtre _1e0c1txw _4cvr1h6o"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "PageFallback.message",
            defaultMessage: "An unexpected error occurred. Please try again later."
        })
    });
};

});


parcelRegister("3iTNH", function(module, exports) {

$parcel$export(module.exports, "PageHeading", function () { return $2153c1754c11de02$export$9716a88f5535df7c; });
/* page-heading.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $bhreu = parcelRequire("bhreu");
const $2153c1754c11de02$export$9716a88f5535df7c = (props)=>{
    const { as: Component = "h1", children: children } = props, rest = (0, $akGnX._)(props, [
        "as",
        "children"
    ]);
    const headingStyles = null;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _zulpftgi"
        ]),
        children: [
            typeof children === "string" ? /*#__PURE__*/ (0, $loA2J.jsx)("h1", (0, $6iHNw._)((0, $7Knp0._)({}, rest), {
                dangerouslySetInnerHTML: {
                    __html: children
                },
                className: (0, $esG4f.default)([
                    "_k48p1fw0 _vwz48vuz _y3gn1h6o _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1s18ckbl _1cqs1ady _1qjn1ylp _syazqlpt"
                ])
            })) : /*#__PURE__*/ (0, $loA2J.jsx)("h1", (0, $6iHNw._)((0, $7Knp0._)({}, rest), {
                className: (0, $esG4f.default)([
                    "_k48p1fw0 _vwz48vuz _y3gn1h6o _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1s18ckbl _1cqs1ady _1qjn1ylp _syazqlpt"
                ]),
                children: children
            })),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/ox5132cg4k77h80v02063670d5th386i.svg",
                    alt: ""
                }
            })
        ]
    });
};

});



//# sourceMappingURL=confluence-pricing-page.d383167e.js.map
